import { RawDraftContentState } from 'draft-js';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSONObject: { input: { [key: string]: any }; output: { [key: string]: any }; }
};

/** "Agency" resource's node */
export type Agency = {
  __typename?: 'Agency';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** "ArchiveAgency.agency"'s inverse relation */
  archiveAgencies: Array<ArchiveAgency>;
  /** "ArchiveAgency.agency"'s inverse relation count */
  archiveAgencyCount: Scalars['Int']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** "Photo.agency"'s inverse relation count */
  photoCount: Scalars['Int']['output'];
  /** "Photo.agency"'s inverse relation */
  photos: Array<Photo>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** "Agency" resource's node */
export type AgencyArchiveAgenciesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArchiveAgencyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArchiveAgencyWhereInput>;
};


/** "Agency" resource's node */
export type AgencyArchiveAgencyCountArgs = {
  where?: InputMaybe<ArchiveAgencyWhereInput>;
};


/** "Agency" resource's node */
export type AgencyPhotoCountArgs = {
  where?: InputMaybe<PhotoWhereInput>;
};


/** "Agency" resource's node */
export type AgencyPhotosArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoWhereInput>;
};

export type AgencyCreateInput = {
  /** Actions for the "Agency.archiveAgencies" relation: "ArchiveAgency.agency"'s inverse relation */
  archiveAgencies?: InputMaybe<AgencyNestedArchiveAgenciesCreateInput>;
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** Actions for the "Agency.photos" relation: "Photo.agency"'s inverse relation */
  photos?: InputMaybe<AgencyNestedPhotosCreateInput>;
};

export type AgencyNestedArchiveAgenciesCreateInput = {
  /** Connect existing "ArchiveAgency" nodes to the new "Agency" node, through the "Agency.archiveAgencies" relation. */
  connect?: InputMaybe<Array<ArchiveAgencyWhereUniqueInput>>;
  /** Create new "ArchiveAgency" nodes and connect them to the new "Agency" node, through the "Agency.archiveAgencies" relation. */
  create?: InputMaybe<Array<ArchiveAgencyWithForcedAgencyCreateInput>>;
};

export type AgencyNestedArchiveAgenciesUpdateInput = {
  /** Connect existing "ArchiveAgency" nodes to the existing "Agency" node, through the "Agency.archiveAgencies" relation. */
  connect?: InputMaybe<Array<ArchiveAgencyWhereUniqueInput>>;
  /** Create new "ArchiveAgency" nodes and connect them to the existing "Agency" node, through the "Agency.archiveAgencies" relation. */
  create?: InputMaybe<Array<ArchiveAgencyWithForcedAgencyCreateInput>>;
  /** Delete existing "ArchiveAgency" nodes from the "Agency.archiveAgencies" relation. */
  delete?: InputMaybe<Array<ArchiveAgencyWithForcedAgencyWhereUniqueInput>>;
  /** Update existing "ArchiveAgency" nodes and connect them to the existing "Agency" node, through the "Agency.archiveAgencies" relation. */
  update?: InputMaybe<Array<AgencyNestedUpdateArchiveAgenciesUpdateInput>>;
  /** Upsert existing "ArchiveAgency" nodes and connect them to the existing "Agency" node, through the "Agency.archiveAgencies" relation. */
  upsert?: InputMaybe<Array<AgencyNestedUpsertArchiveAgenciesUpdateInput>>;
};

export type AgencyNestedPhotosCreateInput = {
  /** Connect existing "Photo" nodes to the new "Agency" node, through the "Agency.photos" relation. */
  connect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Create new "Photo" nodes and connect them to the new "Agency" node, through the "Agency.photos" relation. */
  create?: InputMaybe<Array<PhotoWithForcedAgencyCreateInput>>;
};

export type AgencyNestedPhotosUpdateInput = {
  /** Connect existing "Photo" nodes to the existing "Agency" node, through the "Agency.photos" relation. */
  connect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Create new "Photo" nodes and connect them to the existing "Agency" node, through the "Agency.photos" relation. */
  create?: InputMaybe<Array<PhotoWithForcedAgencyCreateInput>>;
  /** Delete existing "Photo" nodes from the "Agency.photos" relation. */
  delete?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Disconnect existing "Photo" nodes of the "Agency.photos" relation. */
  disconnect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Update existing "Photo" nodes and connect them to the existing "Agency" node, through the "Agency.photos" relation. */
  update?: InputMaybe<Array<AgencyNestedUpdatePhotosUpdateInput>>;
  /** Upsert existing "Photo" nodes and connect them to the existing "Agency" node, through the "Agency.photos" relation. */
  upsert?: InputMaybe<Array<AgencyNestedUpsertPhotosUpdateInput>>;
};

export type AgencyNestedUpdateArchiveAgenciesUpdateInput = {
  data: ArchiveAgencyWithForcedAgencyUpdateInput;
  where: ArchiveAgencyWithOptionalAgencyWhereUniqueInput;
};

export type AgencyNestedUpdatePhotosUpdateInput = {
  data: PhotoWithForcedAgencyUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type AgencyNestedUpsertArchiveAgenciesUpdateInput = {
  create: ArchiveAgencyWithForcedAgencyCreateInput;
  update: ArchiveAgencyWithForcedAgencyUpdateInput;
  where: ArchiveAgencyWithOptionalAgencyWhereUniqueInput;
};

export type AgencyNestedUpsertPhotosUpdateInput = {
  create: PhotoWithForcedAgencyCreateInput;
  update: PhotoWithForcedAgencyUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum AgencyOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AgencyUpdateInput = {
  /** Actions for the "Agency.archiveAgencies" relation: "ArchiveAgency.agency"'s inverse relation */
  archiveAgencies?: InputMaybe<AgencyNestedArchiveAgenciesUpdateInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Agency.photos" relation: "Photo.agency"'s inverse relation */
  photos?: InputMaybe<AgencyNestedPhotosUpdateInput>;
};

/** Filters the "Agency" nodes by specifying some conditions */
export type AgencyWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<AgencyWhereInput>>;
  archiveAgencies_some?: InputMaybe<ArchiveAgencyWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_gt?: InputMaybe<Scalars['String']['input']>;
  label_gte?: InputMaybe<Scalars['String']['input']>;
  label_in?: InputMaybe<Array<Scalars['String']['input']>>;
  label_lt?: InputMaybe<Scalars['String']['input']>;
  label_lte?: InputMaybe<Scalars['String']['input']>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<AgencyWhereInput>;
  OR?: InputMaybe<Array<AgencyWhereInput>>;
  photos_some?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Agency" node with one of these unique values:
 * - _id
 * - name
 * - label
 */
export type AgencyWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** "Archive" resource's node */
export type Archive = {
  __typename?: 'Archive';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** get the access rights of the archive */
  accesses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** get the agencies of the archive */
  agencies?: Maybe<Array<Maybe<InformationAgency>>>;
  /** "ArchiveAgency.archive"'s inverse relation */
  archiveAgencies: Array<ArchiveAgency>;
  /** "ArchiveAgency.archive"'s inverse relation count */
  archiveAgencyCount: Scalars['Int']['output'];
  /** The internal ID */
  archiveId?: Maybe<Scalars['Int']['output']>;
  /** "ArchivePurgeSetting.archive"'s inverse relation */
  archivePurgeSetting?: Maybe<ArchivePurgeSetting>;
  /** "Category.archive"'s inverse relation */
  categories: Array<Category>;
  /** "Category.archive"'s inverse relation count */
  categoryCount: Scalars['Int']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** "DeliverySubject.archive"'s inverse relation count */
  deliverySubjectCount: Scalars['Int']['output'];
  /** "DeliverySubject.archive"'s inverse relation */
  deliverySubjects: Array<DeliverySubject>;
  /** "GcImportSetting.archive"'s inverse relation */
  gcImportSetting?: Maybe<GcImportSetting>;
  hasCategories?: Maybe<Scalars['Boolean']['output']>;
  hasCategory?: Maybe<Scalars['Boolean']['output']>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** "ImportQueue.archive"'s inverse relation count */
  importQueueCount: Scalars['Int']['output'];
  /** "ImportQueue.archive"'s inverse relation */
  importQueues: Array<ImportQueue>;
  /** get the title of the archive */
  key?: Maybe<ArchiveKeyType>;
  /** The archive label */
  label?: Maybe<Scalars['String']['output']>;
  /** "MetadataAccessRights.archive"'s inverse relation */
  metadataAccessRightsList: Array<MetadataAccessRights>;
  /** "MetadataAccessRights.archive"'s inverse relation count */
  metadataAccessRightsListCount: Scalars['Int']['output'];
  /** "MetadataAssetState.archive"'s inverse relation */
  metadataAssetStateList: Array<MetadataAssetState>;
  /** "MetadataAssetState.archive"'s inverse relation count */
  metadataAssetStateListCount: Scalars['Int']['output'];
  /** "MetadataBackupName.archive"'s inverse relation */
  metadataBackupNameList: Array<MetadataBackupName>;
  /** "MetadataBackupName.archive"'s inverse relation count */
  metadataBackupNameListCount: Scalars['Int']['output'];
  /** "MetadataBrand.archive"'s inverse relation */
  metadataBrandList: Array<MetadataBrand>;
  /** "MetadataBrand.archive"'s inverse relation count */
  metadataBrandListCount: Scalars['Int']['output'];
  /** "MetadataBrandPrisma.archive"'s inverse relation */
  metadataBrandPrismaList: Array<MetadataBrandPrisma>;
  /** "MetadataBrandPrisma.archive"'s inverse relation count */
  metadataBrandPrismaListCount: Scalars['Int']['output'];
  /** "MetadataBrandShortName.archive"'s inverse relation */
  metadataBrandShortNameList: Array<MetadataBrandShortName>;
  /** "MetadataBrandShortName.archive"'s inverse relation count */
  metadataBrandShortNameListCount: Scalars['Int']['output'];
  /** "MetadataByLine.archive"'s inverse relation */
  metadataByLineList: Array<MetadataByLine>;
  /** "MetadataByLine.archive"'s inverse relation count */
  metadataByLineListCount: Scalars['Int']['output'];
  /** "MetadataCaptionAbstract.archive"'s inverse relation */
  metadataCaptionAbstractList: Array<MetadataCaptionAbstract>;
  /** "MetadataCaptionAbstract.archive"'s inverse relation count */
  metadataCaptionAbstractListCount: Scalars['Int']['output'];
  /** "MetadataCaption.archive"'s inverse relation */
  metadataCaptionList: Array<MetadataCaption>;
  /** "MetadataCaption.archive"'s inverse relation count */
  metadataCaptionListCount: Scalars['Int']['output'];
  /** "MetadataCategory.archive"'s inverse relation */
  metadataCategoryList: Array<MetadataCategory>;
  /** "MetadataCategory.archive"'s inverse relation count */
  metadataCategoryListCount: Scalars['Int']['output'];
  /** "MetadataCategoryPrisma.archive"'s inverse relation */
  metadataCategoryPrismaList: Array<MetadataCategoryPrisma>;
  /** "MetadataCategoryPrisma.archive"'s inverse relation count */
  metadataCategoryPrismaListCount: Scalars['Int']['output'];
  /** "MetadataCompany.archive"'s inverse relation */
  metadataCompanyList: Array<MetadataCompany>;
  /** "MetadataCompany.archive"'s inverse relation count */
  metadataCompanyListCount: Scalars['Int']['output'];
  /** "MetadataCompanyShortName.archive"'s inverse relation */
  metadataCompanyShortNameList: Array<MetadataCompanyShortName>;
  /** "MetadataCompanyShortName.archive"'s inverse relation count */
  metadataCompanyShortNameListCount: Scalars['Int']['output'];
  /** "MetadataCopyrightNotice.archive"'s inverse relation */
  metadataCopyrightNoticeList: Array<MetadataCopyrightNotice>;
  /** "MetadataCopyrightNotice.archive"'s inverse relation count */
  metadataCopyrightNoticeListCount: Scalars['Int']['output'];
  /** "MetadataCreator.archive"'s inverse relation */
  metadataCreatorList: Array<MetadataCreator>;
  /** "MetadataCreator.archive"'s inverse relation count */
  metadataCreatorListCount: Scalars['Int']['output'];
  /** "MetadataCredit.archive"'s inverse relation */
  metadataCreditList: Array<MetadataCredit>;
  /** "MetadataCredit.archive"'s inverse relation count */
  metadataCreditListCount: Scalars['Int']['output'];
  /** "MetadataCustomField14.archive"'s inverse relation */
  metadataCustomField14List: Array<MetadataCustomField14>;
  /** "MetadataCustomField14.archive"'s inverse relation count */
  metadataCustomField14ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField15.archive"'s inverse relation */
  metadataCustomField15List: Array<MetadataCustomField15>;
  /** "MetadataCustomField15.archive"'s inverse relation count */
  metadataCustomField15ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField16.archive"'s inverse relation */
  metadataCustomField16List: Array<MetadataCustomField16>;
  /** "MetadataCustomField16.archive"'s inverse relation count */
  metadataCustomField16ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField17.archive"'s inverse relation */
  metadataCustomField17List: Array<MetadataCustomField17>;
  /** "MetadataCustomField17.archive"'s inverse relation count */
  metadataCustomField17ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField1.archive"'s inverse relation */
  metadataCustomField1List: Array<MetadataCustomField1>;
  /** "MetadataCustomField1.archive"'s inverse relation count */
  metadataCustomField1ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField20.archive"'s inverse relation */
  metadataCustomField20List: Array<MetadataCustomField20>;
  /** "MetadataCustomField20.archive"'s inverse relation count */
  metadataCustomField20ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField3.archive"'s inverse relation */
  metadataCustomField3List: Array<MetadataCustomField3>;
  /** "MetadataCustomField3.archive"'s inverse relation count */
  metadataCustomField3ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField4.archive"'s inverse relation */
  metadataCustomField4List: Array<MetadataCustomField4>;
  /** "MetadataCustomField4.archive"'s inverse relation count */
  metadataCustomField4ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField5.archive"'s inverse relation */
  metadataCustomField5List: Array<MetadataCustomField5>;
  /** "MetadataCustomField5.archive"'s inverse relation count */
  metadataCustomField5ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField6.archive"'s inverse relation */
  metadataCustomField6List: Array<MetadataCustomField6>;
  /** "MetadataCustomField6.archive"'s inverse relation count */
  metadataCustomField6ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField7.archive"'s inverse relation */
  metadataCustomField7List: Array<MetadataCustomField7>;
  /** "MetadataCustomField7.archive"'s inverse relation count */
  metadataCustomField7ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField9.archive"'s inverse relation */
  metadataCustomField9List: Array<MetadataCustomField9>;
  /** "MetadataCustomField9.archive"'s inverse relation count */
  metadataCustomField9ListCount: Scalars['Int']['output'];
  /** "MetadataDateCreated.archive"'s inverse relation */
  metadataDateCreatedList: Array<MetadataDateCreated>;
  /** "MetadataDateCreated.archive"'s inverse relation count */
  metadataDateCreatedListCount: Scalars['Int']['output'];
  /** "MetadataDateTimeOriginal.archive"'s inverse relation */
  metadataDateTimeOriginalList: Array<MetadataDateTimeOriginal>;
  /** "MetadataDateTimeOriginal.archive"'s inverse relation count */
  metadataDateTimeOriginalListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryAccount.archive"'s inverse relation */
  metadataDeliveryAccountList: Array<MetadataDeliveryAccount>;
  /** "MetadataDeliveryAccount.archive"'s inverse relation count */
  metadataDeliveryAccountListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryCompany.archive"'s inverse relation */
  metadataDeliveryCompanyList: Array<MetadataDeliveryCompany>;
  /** "MetadataDeliveryCompany.archive"'s inverse relation count */
  metadataDeliveryCompanyListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryCopyright.archive"'s inverse relation */
  metadataDeliveryCopyrightList: Array<MetadataDeliveryCopyright>;
  /** "MetadataDeliveryCopyright.archive"'s inverse relation count */
  metadataDeliveryCopyrightListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDateFolder.archive"'s inverse relation */
  metadataDeliveryDateFolderList: Array<MetadataDeliveryDateFolder>;
  /** "MetadataDeliveryDateFolder.archive"'s inverse relation count */
  metadataDeliveryDateFolderListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDateTime.archive"'s inverse relation */
  metadataDeliveryDateTimeList: Array<MetadataDeliveryDateTime>;
  /** "MetadataDeliveryDateTime.archive"'s inverse relation count */
  metadataDeliveryDateTimeListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDcCreator.archive"'s inverse relation */
  metadataDeliveryDcCreatorList: Array<MetadataDeliveryDcCreator>;
  /** "MetadataDeliveryDcCreator.archive"'s inverse relation count */
  metadataDeliveryDcCreatorListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDcRights.archive"'s inverse relation */
  metadataDeliveryDcRightsList: Array<MetadataDeliveryDcRights>;
  /** "MetadataDeliveryDcRights.archive"'s inverse relation count */
  metadataDeliveryDcRightsListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryFolder.archive"'s inverse relation */
  metadataDeliveryFolderList: Array<MetadataDeliveryFolder>;
  /** "MetadataDeliveryFolder.archive"'s inverse relation count */
  metadataDeliveryFolderListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryKind.archive"'s inverse relation */
  metadataDeliveryKindList: Array<MetadataDeliveryKind>;
  /** "MetadataDeliveryKind.archive"'s inverse relation count */
  metadataDeliveryKindListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryPath.archive"'s inverse relation */
  metadataDeliveryPathList: Array<MetadataDeliveryPath>;
  /** "MetadataDeliveryPath.archive"'s inverse relation count */
  metadataDeliveryPathListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryPhotoshopCredit.archive"'s inverse relation */
  metadataDeliveryPhotoshopCreditList: Array<MetadataDeliveryPhotoshopCredit>;
  /** "MetadataDeliveryPhotoshopCredit.archive"'s inverse relation count */
  metadataDeliveryPhotoshopCreditListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryPhotoshopSource.archive"'s inverse relation */
  metadataDeliveryPhotoshopSourceList: Array<MetadataDeliveryPhotoshopSource>;
  /** "MetadataDeliveryPhotoshopSource.archive"'s inverse relation count */
  metadataDeliveryPhotoshopSourceListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryService.archive"'s inverse relation */
  metadataDeliveryServiceList: Array<MetadataDeliveryService>;
  /** "MetadataDeliveryService.archive"'s inverse relation count */
  metadataDeliveryServiceListCount: Scalars['Int']['output'];
  /** "MetadataDeliverySubject.archive"'s inverse relation */
  metadataDeliverySubjectList: Array<MetadataDeliverySubject>;
  /** "MetadataDeliverySubject.archive"'s inverse relation count */
  metadataDeliverySubjectListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryUnderSubject.archive"'s inverse relation */
  metadataDeliveryUnderSubjectList: Array<MetadataDeliveryUnderSubject>;
  /** "MetadataDeliveryUnderSubject.archive"'s inverse relation count */
  metadataDeliveryUnderSubjectListCount: Scalars['Int']['output'];
  /** "MetadataDepartment.archive"'s inverse relation */
  metadataDepartmentList: Array<MetadataDepartment>;
  /** "MetadataDepartment.archive"'s inverse relation count */
  metadataDepartmentListCount: Scalars['Int']['output'];
  /** "MetadataDescription.archive"'s inverse relation */
  metadataDescriptionList: Array<MetadataDescription>;
  /** "MetadataDescription.archive"'s inverse relation count */
  metadataDescriptionListCount: Scalars['Int']['output'];
  /** "MetadataEdition.archive"'s inverse relation */
  metadataEditionList: Array<MetadataEdition>;
  /** "MetadataEdition.archive"'s inverse relation count */
  metadataEditionListCount: Scalars['Int']['output'];
  /** "MetadataEditStatus.archive"'s inverse relation */
  metadataEditStatusList: Array<MetadataEditStatus>;
  /** "MetadataEditStatus.archive"'s inverse relation count */
  metadataEditStatusListCount: Scalars['Int']['output'];
  /** "MetadataFileStatus.archive"'s inverse relation */
  metadataFileStatusList: Array<MetadataFileStatus>;
  /** "MetadataFileStatus.archive"'s inverse relation count */
  metadataFileStatusListCount: Scalars['Int']['output'];
  /** "MetadataFormat.archive"'s inverse relation */
  metadataFormatList: Array<MetadataFormat>;
  /** "MetadataFormat.archive"'s inverse relation count */
  metadataFormatListCount: Scalars['Int']['output'];
  /** "MetadataHeader.archive"'s inverse relation */
  metadataHeaderList: Array<MetadataHeader>;
  /** "MetadataHeader.archive"'s inverse relation count */
  metadataHeaderListCount: Scalars['Int']['output'];
  /** "MetadataHeaderPrisma.archive"'s inverse relation */
  metadataHeaderPrismaList: Array<MetadataHeaderPrisma>;
  /** "MetadataHeaderPrisma.archive"'s inverse relation count */
  metadataHeaderPrismaListCount: Scalars['Int']['output'];
  /** "MetadataHeadline.archive"'s inverse relation */
  metadataHeadlineList: Array<MetadataHeadline>;
  /** "MetadataHeadline.archive"'s inverse relation count */
  metadataHeadlineListCount: Scalars['Int']['output'];
  /** "MetadataIdAssignment.archive"'s inverse relation */
  metadataIdAssignmentList: Array<MetadataIdAssignment>;
  /** "MetadataIdAssignment.archive"'s inverse relation count */
  metadataIdAssignmentListCount: Scalars['Int']['output'];
  /** "MetadataIdPhotoPrisma.archive"'s inverse relation */
  metadataIdPhotoPrismaList: Array<MetadataIdPhotoPrisma>;
  /** "MetadataIdPhotoPrisma.archive"'s inverse relation count */
  metadataIdPhotoPrismaListCount: Scalars['Int']['output'];
  /** "MetadataIdSubject.archive"'s inverse relation */
  metadataIdSubjectList: Array<MetadataIdSubject>;
  /** "MetadataIdSubject.archive"'s inverse relation count */
  metadataIdSubjectListCount: Scalars['Int']['output'];
  /** "MetadataImageNotes.archive"'s inverse relation */
  metadataImageNotesList: Array<MetadataImageNotes>;
  /** "MetadataImageNotes.archive"'s inverse relation count */
  metadataImageNotesListCount: Scalars['Int']['output'];
  /** "MetadataInstructions.archive"'s inverse relation */
  metadataInstructionsList: Array<MetadataInstructions>;
  /** "MetadataInstructions.archive"'s inverse relation count */
  metadataInstructionsListCount: Scalars['Int']['output'];
  /** "MetadataIssue.archive"'s inverse relation */
  metadataIssueList: Array<MetadataIssue>;
  /** "MetadataIssue.archive"'s inverse relation count */
  metadataIssueListCount: Scalars['Int']['output'];
  /** "MetadataKeywords.archive"'s inverse relation */
  metadataKeywordsList: Array<MetadataKeywords>;
  /** "MetadataKeywords.archive"'s inverse relation count */
  metadataKeywordsListCount: Scalars['Int']['output'];
  /** "MetadataObjectName.archive"'s inverse relation */
  metadataObjectNameList: Array<MetadataObjectName>;
  /** "MetadataObjectName.archive"'s inverse relation count */
  metadataObjectNameListCount: Scalars['Int']['output'];
  /** "MetadataOriginalName.archive"'s inverse relation */
  metadataOriginalNameList: Array<MetadataOriginalName>;
  /** "MetadataOriginalName.archive"'s inverse relation count */
  metadataOriginalNameListCount: Scalars['Int']['output'];
  /** "MetadataPriceLevel.archive"'s inverse relation */
  metadataPriceLevelList: Array<MetadataPriceLevel>;
  /** "MetadataPriceLevel.archive"'s inverse relation count */
  metadataPriceLevelListCount: Scalars['Int']['output'];
  /** "MetadataProcessHistory.archive"'s inverse relation */
  metadataProcessHistoryList: Array<MetadataProcessHistory>;
  /** "MetadataProcessHistory.archive"'s inverse relation count */
  metadataProcessHistoryListCount: Scalars['Int']['output'];
  /** "MetadataProcessStatus.archive"'s inverse relation */
  metadataProcessStatusList: Array<MetadataProcessStatus>;
  /** "MetadataProcessStatus.archive"'s inverse relation count */
  metadataProcessStatusListCount: Scalars['Int']['output'];
  /** "MetadataProduct.archive"'s inverse relation */
  metadataProductList: Array<MetadataProduct>;
  /** "MetadataProduct.archive"'s inverse relation count */
  metadataProductListCount: Scalars['Int']['output'];
  /** "MetadataProducts.archive"'s inverse relation */
  metadataProductsList: Array<MetadataProducts>;
  /** "MetadataProducts.archive"'s inverse relation count */
  metadataProductsListCount: Scalars['Int']['output'];
  /** "MetadataPublishingSubject.archive"'s inverse relation */
  metadataPublishingSubjectList: Array<MetadataPublishingSubject>;
  /** "MetadataPublishingSubject.archive"'s inverse relation count */
  metadataPublishingSubjectListCount: Scalars['Int']['output'];
  /** "MetadataResolutionKind.archive"'s inverse relation */
  metadataResolutionKindList: Array<MetadataResolutionKind>;
  /** "MetadataResolutionKind.archive"'s inverse relation count */
  metadataResolutionKindListCount: Scalars['Int']['output'];
  /** "MetadataRights.archive"'s inverse relation */
  metadataRightsList: Array<MetadataRights>;
  /** "MetadataRights.archive"'s inverse relation count */
  metadataRightsListCount: Scalars['Int']['output'];
  /** "MetadataSource.archive"'s inverse relation */
  metadataSourceList: Array<MetadataSource>;
  /** "MetadataSource.archive"'s inverse relation count */
  metadataSourceListCount: Scalars['Int']['output'];
  /** "MetadataSpecialInstructions.archive"'s inverse relation */
  metadataSpecialInstructionsList: Array<MetadataSpecialInstructions>;
  /** "MetadataSpecialInstructions.archive"'s inverse relation count */
  metadataSpecialInstructionsListCount: Scalars['Int']['output'];
  /** "MetadataSubjectCode.archive"'s inverse relation */
  metadataSubjectCodeList: Array<MetadataSubjectCode>;
  /** "MetadataSubjectCode.archive"'s inverse relation count */
  metadataSubjectCodeListCount: Scalars['Int']['output'];
  /** "MetadataSubject.archive"'s inverse relation */
  metadataSubjectList: Array<MetadataSubject>;
  /** "MetadataSubject.archive"'s inverse relation count */
  metadataSubjectListCount: Scalars['Int']['output'];
  /** "MetadataSubjectPrisma.archive"'s inverse relation */
  metadataSubjectPrismaList: Array<MetadataSubjectPrisma>;
  /** "MetadataSubjectPrisma.archive"'s inverse relation count */
  metadataSubjectPrismaListCount: Scalars['Int']['output'];
  /** "MetadataTitle.archive"'s inverse relation */
  metadataTitleList: Array<MetadataTitle>;
  /** "MetadataTitle.archive"'s inverse relation count */
  metadataTitleListCount: Scalars['Int']['output'];
  /** "MetadataTransferredByFullName.archive"'s inverse relation */
  metadataTransferredByFullNameList: Array<MetadataTransferredByFullName>;
  /** "MetadataTransferredByFullName.archive"'s inverse relation count */
  metadataTransferredByFullNameListCount: Scalars['Int']['output'];
  /** "MetadataTransferredBy.archive"'s inverse relation */
  metadataTransferredByList: Array<MetadataTransferredBy>;
  /** "MetadataTransferredBy.archive"'s inverse relation count */
  metadataTransferredByListCount: Scalars['Int']['output'];
  /** "MetadataType.archive"'s inverse relation */
  metadataTypeList: Array<MetadataType>;
  /** "MetadataType.archive"'s inverse relation count */
  metadataTypeListCount: Scalars['Int']['output'];
  /** "MetadataUndersubject.archive"'s inverse relation */
  metadataUndersubjectList: Array<MetadataUndersubject>;
  /** "MetadataUndersubject.archive"'s inverse relation count */
  metadataUndersubjectListCount: Scalars['Int']['output'];
  /** "MetadataUnderUnderSubject.archive"'s inverse relation */
  metadataUnderUnderSubjectList: Array<MetadataUnderUnderSubject>;
  /** "MetadataUnderUnderSubject.archive"'s inverse relation count */
  metadataUnderUnderSubjectListCount: Scalars['Int']['output'];
  /** "MetadataUploadedByFullName.archive"'s inverse relation */
  metadataUploadedByFullNameList: Array<MetadataUploadedByFullName>;
  /** "MetadataUploadedByFullName.archive"'s inverse relation count */
  metadataUploadedByFullNameListCount: Scalars['Int']['output'];
  /** "MetadataUploadedBy.archive"'s inverse relation */
  metadataUploadedByList: Array<MetadataUploadedBy>;
  /** "MetadataUploadedBy.archive"'s inverse relation count */
  metadataUploadedByListCount: Scalars['Int']['output'];
  /** "MetadataUploadTime.archive"'s inverse relation */
  metadataUploadTimeList: Array<MetadataUploadTime>;
  /** "MetadataUploadTime.archive"'s inverse relation count */
  metadataUploadTimeListCount: Scalars['Int']['output'];
  /** "MetadataUrgency.archive"'s inverse relation */
  metadataUrgencyList: Array<MetadataUrgency>;
  /** "MetadataUrgency.archive"'s inverse relation count */
  metadataUrgencyListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined195.archive"'s inverse relation */
  metadataUserDefined195List: Array<MetadataUserDefined195>;
  /** "MetadataUserDefined195.archive"'s inverse relation count */
  metadataUserDefined195ListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined237.archive"'s inverse relation */
  metadataUserDefined237List: Array<MetadataUserDefined237>;
  /** "MetadataUserDefined237.archive"'s inverse relation count */
  metadataUserDefined237ListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined238.archive"'s inverse relation */
  metadataUserDefined238List: Array<MetadataUserDefined238>;
  /** "MetadataUserDefined238.archive"'s inverse relation count */
  metadataUserDefined238ListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined239.archive"'s inverse relation */
  metadataUserDefined239List: Array<MetadataUserDefined239>;
  /** "MetadataUserDefined239.archive"'s inverse relation count */
  metadataUserDefined239ListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined242.archive"'s inverse relation */
  metadataUserDefined242List: Array<MetadataUserDefined242>;
  /** "MetadataUserDefined242.archive"'s inverse relation count */
  metadataUserDefined242ListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined62.archive"'s inverse relation */
  metadataUserDefined62List: Array<MetadataUserDefined62>;
  /** "MetadataUserDefined62.archive"'s inverse relation count */
  metadataUserDefined62ListCount: Scalars['Int']['output'];
  /** "MetadataWorkflowKind.archive"'s inverse relation */
  metadataWorkflowKindList: Array<MetadataWorkflowKind>;
  /** "MetadataWorkflowKind.archive"'s inverse relation count */
  metadataWorkflowKindListCount: Scalars['Int']['output'];
  /** "MetadataXmpHistory.archive"'s inverse relation */
  metadataXmpHistoryList: Array<MetadataXmpHistory>;
  /** "MetadataXmpHistory.archive"'s inverse relation count */
  metadataXmpHistoryListCount: Scalars['Int']['output'];
  /** The archive name */
  name?: Maybe<ArchiveKeyType>;
  /** "Photo.archive"'s inverse relation count */
  photoCount: Scalars['Int']['output'];
  /** "PhotoMetadata.archive"'s inverse relation count */
  photoMetadataCount: Scalars['Int']['output'];
  /** "PhotoMetadata.archive"'s inverse relation */
  photoMetadatas: Array<PhotoMetadata>;
  /** "Photo.archive"'s inverse relation */
  photos: Array<Photo>;
  /** get the title of the archive */
  title?: Maybe<Scalars['String']['output']>;
  /** The archive type */
  type?: Maybe<ArchiveType>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** "Archive" resource's node */
export type ArchiveArchiveAgenciesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArchiveAgencyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArchiveAgencyWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveArchiveAgencyCountArgs = {
  where?: InputMaybe<ArchiveAgencyWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveCategoryCountArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveDeliverySubjectCountArgs = {
  where?: InputMaybe<DeliverySubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveDeliverySubjectsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<DeliverySubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeliverySubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveImportQueueCountArgs = {
  where?: InputMaybe<ImportQueueWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveImportQueuesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ImportQueueOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImportQueueWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataAccessRightsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataAccessRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataAccessRightsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataAccessRightsListCountArgs = {
  where?: InputMaybe<MetadataAccessRightsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataAssetStateListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataAssetStateOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataAssetStateWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataAssetStateListCountArgs = {
  where?: InputMaybe<MetadataAssetStateWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataBackupNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBackupNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBackupNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataBackupNameListCountArgs = {
  where?: InputMaybe<MetadataBackupNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataBrandListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataBrandListCountArgs = {
  where?: InputMaybe<MetadataBrandWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataBrandPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandPrismaWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataBrandPrismaListCountArgs = {
  where?: InputMaybe<MetadataBrandPrismaWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataBrandShortNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandShortNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandShortNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataBrandShortNameListCountArgs = {
  where?: InputMaybe<MetadataBrandShortNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataByLineListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataByLineOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataByLineWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataByLineListCountArgs = {
  where?: InputMaybe<MetadataByLineWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCaptionAbstractListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCaptionAbstractOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCaptionAbstractWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCaptionAbstractListCountArgs = {
  where?: InputMaybe<MetadataCaptionAbstractWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCaptionListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCaptionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCaptionWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCaptionListCountArgs = {
  where?: InputMaybe<MetadataCaptionWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCategoryListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCategoryWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCategoryListCountArgs = {
  where?: InputMaybe<MetadataCategoryWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCategoryPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCategoryPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCategoryPrismaWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCategoryPrismaListCountArgs = {
  where?: InputMaybe<MetadataCategoryPrismaWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCompanyListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCompanyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCompanyWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCompanyListCountArgs = {
  where?: InputMaybe<MetadataCompanyWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCompanyShortNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCompanyShortNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCompanyShortNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCompanyShortNameListCountArgs = {
  where?: InputMaybe<MetadataCompanyShortNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCopyrightNoticeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCopyrightNoticeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCopyrightNoticeListCountArgs = {
  where?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCreatorListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCreatorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCreatorWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCreatorListCountArgs = {
  where?: InputMaybe<MetadataCreatorWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCreditListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCreditOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCreditWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCreditListCountArgs = {
  where?: InputMaybe<MetadataCreditWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField14ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField14OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField14WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField14ListCountArgs = {
  where?: InputMaybe<MetadataCustomField14WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField15ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField15OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField15WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField15ListCountArgs = {
  where?: InputMaybe<MetadataCustomField15WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField16ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField16OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField16WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField16ListCountArgs = {
  where?: InputMaybe<MetadataCustomField16WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField17ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField17OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField17WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField17ListCountArgs = {
  where?: InputMaybe<MetadataCustomField17WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField1ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField1OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField1WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField1ListCountArgs = {
  where?: InputMaybe<MetadataCustomField1WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField20ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField20OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField20WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField20ListCountArgs = {
  where?: InputMaybe<MetadataCustomField20WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField3ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField3OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField3WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField3ListCountArgs = {
  where?: InputMaybe<MetadataCustomField3WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField4ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField4OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField4WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField4ListCountArgs = {
  where?: InputMaybe<MetadataCustomField4WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField5ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField5OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField5WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField5ListCountArgs = {
  where?: InputMaybe<MetadataCustomField5WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField6ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField6OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField6WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField6ListCountArgs = {
  where?: InputMaybe<MetadataCustomField6WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField7ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField7OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField7WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField7ListCountArgs = {
  where?: InputMaybe<MetadataCustomField7WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField9ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField9OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField9WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataCustomField9ListCountArgs = {
  where?: InputMaybe<MetadataCustomField9WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDateCreatedListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDateCreatedOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDateCreatedWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDateCreatedListCountArgs = {
  where?: InputMaybe<MetadataDateCreatedWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDateTimeOriginalListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDateTimeOriginalOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDateTimeOriginalListCountArgs = {
  where?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryAccountListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryAccountOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryAccountWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryAccountListCountArgs = {
  where?: InputMaybe<MetadataDeliveryAccountWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryCompanyListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryCompanyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryCompanyListCountArgs = {
  where?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryCopyrightListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryCopyrightOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryCopyrightListCountArgs = {
  where?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryDateFolderListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDateFolderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryDateFolderListCountArgs = {
  where?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryDateTimeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDateTimeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryDateTimeListCountArgs = {
  where?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryDcCreatorListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDcCreatorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryDcCreatorListCountArgs = {
  where?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryDcRightsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDcRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryDcRightsListCountArgs = {
  where?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryFolderListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryFolderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryFolderWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryFolderListCountArgs = {
  where?: InputMaybe<MetadataDeliveryFolderWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryKindListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryKindWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryKindListCountArgs = {
  where?: InputMaybe<MetadataDeliveryKindWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryPathListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPathOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPathWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryPathListCountArgs = {
  where?: InputMaybe<MetadataDeliveryPathWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryPhotoshopCreditListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryPhotoshopCreditListCountArgs = {
  where?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryPhotoshopSourceListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryPhotoshopSourceListCountArgs = {
  where?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryServiceListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryServiceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryServiceWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryServiceListCountArgs = {
  where?: InputMaybe<MetadataDeliveryServiceWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliverySubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliverySubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliverySubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliverySubjectListCountArgs = {
  where?: InputMaybe<MetadataDeliverySubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryUnderSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryUnderSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDeliveryUnderSubjectListCountArgs = {
  where?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDepartmentListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDepartmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDepartmentWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDepartmentListCountArgs = {
  where?: InputMaybe<MetadataDepartmentWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDescriptionListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDescriptionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDescriptionWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataDescriptionListCountArgs = {
  where?: InputMaybe<MetadataDescriptionWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataEditionListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataEditionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataEditionWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataEditionListCountArgs = {
  where?: InputMaybe<MetadataEditionWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataEditStatusListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataEditStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataEditStatusWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataEditStatusListCountArgs = {
  where?: InputMaybe<MetadataEditStatusWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataFileStatusListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataFileStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataFileStatusWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataFileStatusListCountArgs = {
  where?: InputMaybe<MetadataFileStatusWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataFormatListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataFormatOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataFormatWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataFormatListCountArgs = {
  where?: InputMaybe<MetadataFormatWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataHeaderListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeaderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeaderWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataHeaderListCountArgs = {
  where?: InputMaybe<MetadataHeaderWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataHeaderPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeaderPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeaderPrismaWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataHeaderPrismaListCountArgs = {
  where?: InputMaybe<MetadataHeaderPrismaWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataHeadlineListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeadlineOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeadlineWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataHeadlineListCountArgs = {
  where?: InputMaybe<MetadataHeadlineWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataIdAssignmentListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdAssignmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdAssignmentWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataIdAssignmentListCountArgs = {
  where?: InputMaybe<MetadataIdAssignmentWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataIdPhotoPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdPhotoPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataIdPhotoPrismaListCountArgs = {
  where?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataIdSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdSubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataIdSubjectListCountArgs = {
  where?: InputMaybe<MetadataIdSubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataImageNotesListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataImageNotesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataImageNotesWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataImageNotesListCountArgs = {
  where?: InputMaybe<MetadataImageNotesWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataInstructionsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataInstructionsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataInstructionsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataInstructionsListCountArgs = {
  where?: InputMaybe<MetadataInstructionsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataIssueListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIssueOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIssueWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataIssueListCountArgs = {
  where?: InputMaybe<MetadataIssueWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataKeywordsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataKeywordsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataKeywordsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataKeywordsListCountArgs = {
  where?: InputMaybe<MetadataKeywordsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataObjectNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataObjectNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataObjectNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataObjectNameListCountArgs = {
  where?: InputMaybe<MetadataObjectNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataOriginalNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataOriginalNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataOriginalNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataOriginalNameListCountArgs = {
  where?: InputMaybe<MetadataOriginalNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataPriceLevelListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataPriceLevelOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataPriceLevelWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataPriceLevelListCountArgs = {
  where?: InputMaybe<MetadataPriceLevelWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataProcessHistoryListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProcessHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProcessHistoryWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataProcessHistoryListCountArgs = {
  where?: InputMaybe<MetadataProcessHistoryWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataProcessStatusListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProcessStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProcessStatusWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataProcessStatusListCountArgs = {
  where?: InputMaybe<MetadataProcessStatusWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataProductListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProductOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProductWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataProductListCountArgs = {
  where?: InputMaybe<MetadataProductWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataProductsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProductsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProductsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataProductsListCountArgs = {
  where?: InputMaybe<MetadataProductsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataPublishingSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataPublishingSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataPublishingSubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataPublishingSubjectListCountArgs = {
  where?: InputMaybe<MetadataPublishingSubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataResolutionKindListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataResolutionKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataResolutionKindWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataResolutionKindListCountArgs = {
  where?: InputMaybe<MetadataResolutionKindWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataRightsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataRightsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataRightsListCountArgs = {
  where?: InputMaybe<MetadataRightsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataSourceListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSourceWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataSourceListCountArgs = {
  where?: InputMaybe<MetadataSourceWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataSpecialInstructionsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSpecialInstructionsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataSpecialInstructionsListCountArgs = {
  where?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataSubjectCodeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectCodeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectCodeWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataSubjectCodeListCountArgs = {
  where?: InputMaybe<MetadataSubjectCodeWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataSubjectListCountArgs = {
  where?: InputMaybe<MetadataSubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataSubjectPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectPrismaWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataSubjectPrismaListCountArgs = {
  where?: InputMaybe<MetadataSubjectPrismaWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataTitleListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTitleOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTitleWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataTitleListCountArgs = {
  where?: InputMaybe<MetadataTitleWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataTransferredByFullNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTransferredByFullNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataTransferredByFullNameListCountArgs = {
  where?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataTransferredByListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTransferredByOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTransferredByWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataTransferredByListCountArgs = {
  where?: InputMaybe<MetadataTransferredByWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataTypeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTypeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTypeWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataTypeListCountArgs = {
  where?: InputMaybe<MetadataTypeWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUndersubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUndersubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUndersubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUndersubjectListCountArgs = {
  where?: InputMaybe<MetadataUndersubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUnderUnderSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUnderUnderSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUnderUnderSubjectListCountArgs = {
  where?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUploadedByFullNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadedByFullNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUploadedByFullNameListCountArgs = {
  where?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUploadedByListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadedByOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadedByWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUploadedByListCountArgs = {
  where?: InputMaybe<MetadataUploadedByWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUploadTimeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadTimeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadTimeWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUploadTimeListCountArgs = {
  where?: InputMaybe<MetadataUploadTimeWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUrgencyListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUrgencyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUrgencyWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUrgencyListCountArgs = {
  where?: InputMaybe<MetadataUrgencyWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined195ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined195OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined195WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined195ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined195WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined237ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined237OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined237WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined237ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined237WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined238ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined238OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined238WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined238ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined238WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined239ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined239OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined239WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined239ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined239WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined242ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined242OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined242WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined242ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined242WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined62ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined62OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined62WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataUserDefined62ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined62WhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataWorkflowKindListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataWorkflowKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataWorkflowKindWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataWorkflowKindListCountArgs = {
  where?: InputMaybe<MetadataWorkflowKindWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataXmpHistoryListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataXmpHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataXmpHistoryWhereInput>;
};


/** "Archive" resource's node */
export type ArchiveMetadataXmpHistoryListCountArgs = {
  where?: InputMaybe<MetadataXmpHistoryWhereInput>;
};


/** "Archive" resource's node */
export type ArchivePhotoCountArgs = {
  where?: InputMaybe<PhotoWhereInput>;
};


/** "Archive" resource's node */
export type ArchivePhotoMetadataCountArgs = {
  where?: InputMaybe<PhotoMetadataWhereInput>;
};


/** "Archive" resource's node */
export type ArchivePhotoMetadatasArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoMetadataOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoMetadataWhereInput>;
};


/** "Archive" resource's node */
export type ArchivePhotosArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoWhereInput>;
};

/** "ArchiveAgency" resource's node */
export type ArchiveAgency = {
  __typename?: 'ArchiveAgency';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  agency: Agency;
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type ArchiveAgencyCreateInput = {
  /** Actions for the "ArchiveAgency.agency" relation */
  agency: ArchiveAgencyNestedAgencyCreateInput;
  /** Actions for the "ArchiveAgency.archive" relation */
  archive: ArchiveAgencyNestedArchiveCreateInput;
};

export type ArchiveAgencyNestedAgencyCreateInput = {
  /** Connect an existing "Agency" node to the new "ArchiveAgency" node, through the "ArchiveAgency.agency" relation. */
  connect?: InputMaybe<AgencyWhereUniqueInput>;
  /** Create a new "Agency" node and connect it to the new "ArchiveAgency" node, through the "ArchiveAgency.agency" relation. */
  create?: InputMaybe<AgencyCreateInput>;
  /** Update an existing "Agency" node and connect it to the new "ArchiveAgency" node, through the "ArchiveAgency.agency" relation. */
  update?: InputMaybe<ArchiveAgencyNestedUpdateAgencyCreateInput>;
  /** Create or update a "Agency" node and connect it to the new "ArchiveAgency" node, through the "ArchiveAgency.agency" relation. */
  upsert?: InputMaybe<ArchiveAgencyNestedUpsertAgencyCreateInput>;
};

export type ArchiveAgencyNestedAgencyUpdateInput = {
  /** Connect an existing "Agency" node to the existing "ArchiveAgency" node, through the "ArchiveAgency.agency" relation. */
  connect?: InputMaybe<AgencyWhereUniqueInput>;
  /** Create a new "Agency" node and connect it to the existing "ArchiveAgency" node, through the "ArchiveAgency.agency" relation. */
  create?: InputMaybe<AgencyCreateInput>;
  /** Update an existing "Agency" node and connect it to the existing "ArchiveAgency" node, through the "ArchiveAgency.agency" relation. */
  update?: InputMaybe<ArchiveAgencyNestedUpdateAgencyUpdateInput>;
  /** Create or update a "Agency" node and connect it to the existing "ArchiveAgency" node, through the "ArchiveAgency.agency" relation. */
  upsert?: InputMaybe<ArchiveAgencyNestedUpsertAgencyUpdateInput>;
};

export type ArchiveAgencyNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "ArchiveAgency" node, through the "ArchiveAgency.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "ArchiveAgency" node, through the "ArchiveAgency.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "ArchiveAgency" node, through the "ArchiveAgency.archive" relation. */
  update?: InputMaybe<ArchiveAgencyNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "ArchiveAgency" node, through the "ArchiveAgency.archive" relation. */
  upsert?: InputMaybe<ArchiveAgencyNestedUpsertArchiveCreateInput>;
};

export type ArchiveAgencyNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "ArchiveAgency" node, through the "ArchiveAgency.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "ArchiveAgency" node, through the "ArchiveAgency.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "ArchiveAgency" node, through the "ArchiveAgency.archive" relation. */
  update?: InputMaybe<ArchiveAgencyNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "ArchiveAgency" node, through the "ArchiveAgency.archive" relation. */
  upsert?: InputMaybe<ArchiveAgencyNestedUpsertArchiveUpdateInput>;
};

export type ArchiveAgencyNestedUpdateAgencyCreateInput = {
  data: AgencyUpdateInput;
  where: AgencyWhereUniqueInput;
};

export type ArchiveAgencyNestedUpdateAgencyUpdateInput = {
  data: AgencyUpdateInput;
  where: AgencyWhereUniqueInput;
};

export type ArchiveAgencyNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ArchiveAgencyNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ArchiveAgencyNestedUpsertAgencyCreateInput = {
  create: AgencyCreateInput;
  update: AgencyUpdateInput;
  where: AgencyWhereUniqueInput;
};

export type ArchiveAgencyNestedUpsertAgencyUpdateInput = {
  create: AgencyCreateInput;
  update: AgencyUpdateInput;
  where: AgencyWhereUniqueInput;
};

export type ArchiveAgencyNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ArchiveAgencyNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export enum ArchiveAgencyOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ArchiveAgencyUpdateInput = {
  /** Actions for the "ArchiveAgency.agency" relation */
  agency?: InputMaybe<ArchiveAgencyNestedAgencyUpdateInput>;
  /** Actions for the "ArchiveAgency.archive" relation */
  archive?: InputMaybe<ArchiveAgencyNestedArchiveUpdateInput>;
};

/** Filters the "ArchiveAgency" nodes by specifying some conditions */
export type ArchiveAgencyWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  agency?: InputMaybe<AgencyWhereInput>;
  AND?: InputMaybe<Array<ArchiveAgencyWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  NOT?: InputMaybe<ArchiveAgencyWhereInput>;
  OR?: InputMaybe<Array<ArchiveAgencyWhereInput>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "ArchiveAgency" node with one of these unique combinations of values:
 * - _id
 * - agency, archive
 */
export type ArchiveAgencyWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  agency?: InputMaybe<AgencyWhereUniqueInput>;
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
};

export type ArchiveAgencyWithForcedAgencyCreateInput = {
  /** Actions for the "ArchiveAgency.archive" relation */
  archive: ArchiveAgencyNestedArchiveCreateInput;
};

export type ArchiveAgencyWithForcedAgencyUpdateInput = {
  /** Actions for the "ArchiveAgency.archive" relation */
  archive?: InputMaybe<ArchiveAgencyNestedArchiveUpdateInput>;
};

/** Given a forced "agency", identifies exactly one "ArchiveAgency" node. */
export type ArchiveAgencyWithForcedAgencyWhereUniqueInput = {
  archive: ArchiveWhereUniqueInput;
};

export type ArchiveAgencyWithForcedArchiveCreateInput = {
  /** Actions for the "ArchiveAgency.agency" relation */
  agency: ArchiveAgencyNestedAgencyCreateInput;
};

export type ArchiveAgencyWithForcedArchiveUpdateInput = {
  /** Actions for the "ArchiveAgency.agency" relation */
  agency?: InputMaybe<ArchiveAgencyNestedAgencyUpdateInput>;
};

/** Given a forced "archive", identifies exactly one "ArchiveAgency" node. */
export type ArchiveAgencyWithForcedArchiveWhereUniqueInput = {
  agency: AgencyWhereUniqueInput;
};

/**
 * Given a known "agency", identifies exactly one "ArchiveAgency" node with one of these unique combinations of values:
 * - _id
 * - agency (optional), archive
 */
export type ArchiveAgencyWithOptionalAgencyWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  agency?: InputMaybe<AgencyWhereUniqueInput>;
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
};

/**
 * Given a known "archive", identifies exactly one "ArchiveAgency" node with one of these unique combinations of values:
 * - _id
 * - agency, archive (optional)
 */
export type ArchiveAgencyWithOptionalArchiveWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  agency?: InputMaybe<AgencyWhereUniqueInput>;
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
};

export type ArchiveCreateInput = {
  /** Actions for the "Archive.archiveAgencies" relation: "ArchiveAgency.archive"'s inverse relation */
  archiveAgencies?: InputMaybe<ArchiveNestedArchiveAgenciesCreateInput>;
  /** The internal ID */
  archiveId?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "Archive.archivePurgeSetting" relation: "ArchivePurgeSetting.archive"'s inverse relation */
  archivePurgeSetting?: InputMaybe<ArchiveNestedArchivePurgeSettingCreateInput>;
  /** Actions for the "Archive.categories" relation: "Category.archive"'s inverse relation */
  categories?: InputMaybe<ArchiveNestedCategoriesCreateInput>;
  /** Actions for the "Archive.deliverySubjects" relation: "DeliverySubject.archive"'s inverse relation */
  deliverySubjects?: InputMaybe<ArchiveNestedDeliverySubjectsCreateInput>;
  /** Actions for the "Archive.gcImportSetting" relation: "GcImportSetting.archive"'s inverse relation */
  gcImportSetting?: InputMaybe<ArchiveNestedGcImportSettingCreateInput>;
  hasCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "Archive.importQueues" relation: "ImportQueue.archive"'s inverse relation */
  importQueues?: InputMaybe<ArchiveNestedImportQueuesCreateInput>;
  /** The archive label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Archive.metadataAccessRightsList" relation: "MetadataAccessRights.archive"'s inverse relation */
  metadataAccessRightsList?: InputMaybe<ArchiveNestedMetadataAccessRightsListCreateInput>;
  /** Actions for the "Archive.metadataAssetStateList" relation: "MetadataAssetState.archive"'s inverse relation */
  metadataAssetStateList?: InputMaybe<ArchiveNestedMetadataAssetStateListCreateInput>;
  /** Actions for the "Archive.metadataBackupNameList" relation: "MetadataBackupName.archive"'s inverse relation */
  metadataBackupNameList?: InputMaybe<ArchiveNestedMetadataBackupNameListCreateInput>;
  /** Actions for the "Archive.metadataBrandList" relation: "MetadataBrand.archive"'s inverse relation */
  metadataBrandList?: InputMaybe<ArchiveNestedMetadataBrandListCreateInput>;
  /** Actions for the "Archive.metadataBrandPrismaList" relation: "MetadataBrandPrisma.archive"'s inverse relation */
  metadataBrandPrismaList?: InputMaybe<ArchiveNestedMetadataBrandPrismaListCreateInput>;
  /** Actions for the "Archive.metadataBrandShortNameList" relation: "MetadataBrandShortName.archive"'s inverse relation */
  metadataBrandShortNameList?: InputMaybe<ArchiveNestedMetadataBrandShortNameListCreateInput>;
  /** Actions for the "Archive.metadataByLineList" relation: "MetadataByLine.archive"'s inverse relation */
  metadataByLineList?: InputMaybe<ArchiveNestedMetadataByLineListCreateInput>;
  /** Actions for the "Archive.metadataCaptionAbstractList" relation: "MetadataCaptionAbstract.archive"'s inverse relation */
  metadataCaptionAbstractList?: InputMaybe<ArchiveNestedMetadataCaptionAbstractListCreateInput>;
  /** Actions for the "Archive.metadataCaptionList" relation: "MetadataCaption.archive"'s inverse relation */
  metadataCaptionList?: InputMaybe<ArchiveNestedMetadataCaptionListCreateInput>;
  /** Actions for the "Archive.metadataCategoryList" relation: "MetadataCategory.archive"'s inverse relation */
  metadataCategoryList?: InputMaybe<ArchiveNestedMetadataCategoryListCreateInput>;
  /** Actions for the "Archive.metadataCategoryPrismaList" relation: "MetadataCategoryPrisma.archive"'s inverse relation */
  metadataCategoryPrismaList?: InputMaybe<ArchiveNestedMetadataCategoryPrismaListCreateInput>;
  /** Actions for the "Archive.metadataCompanyList" relation: "MetadataCompany.archive"'s inverse relation */
  metadataCompanyList?: InputMaybe<ArchiveNestedMetadataCompanyListCreateInput>;
  /** Actions for the "Archive.metadataCompanyShortNameList" relation: "MetadataCompanyShortName.archive"'s inverse relation */
  metadataCompanyShortNameList?: InputMaybe<ArchiveNestedMetadataCompanyShortNameListCreateInput>;
  /** Actions for the "Archive.metadataCopyrightNoticeList" relation: "MetadataCopyrightNotice.archive"'s inverse relation */
  metadataCopyrightNoticeList?: InputMaybe<ArchiveNestedMetadataCopyrightNoticeListCreateInput>;
  /** Actions for the "Archive.metadataCreatorList" relation: "MetadataCreator.archive"'s inverse relation */
  metadataCreatorList?: InputMaybe<ArchiveNestedMetadataCreatorListCreateInput>;
  /** Actions for the "Archive.metadataCreditList" relation: "MetadataCredit.archive"'s inverse relation */
  metadataCreditList?: InputMaybe<ArchiveNestedMetadataCreditListCreateInput>;
  /** Actions for the "Archive.metadataCustomField14List" relation: "MetadataCustomField14.archive"'s inverse relation */
  metadataCustomField14List?: InputMaybe<ArchiveNestedMetadataCustomField14ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField15List" relation: "MetadataCustomField15.archive"'s inverse relation */
  metadataCustomField15List?: InputMaybe<ArchiveNestedMetadataCustomField15ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField16List" relation: "MetadataCustomField16.archive"'s inverse relation */
  metadataCustomField16List?: InputMaybe<ArchiveNestedMetadataCustomField16ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField17List" relation: "MetadataCustomField17.archive"'s inverse relation */
  metadataCustomField17List?: InputMaybe<ArchiveNestedMetadataCustomField17ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField1List" relation: "MetadataCustomField1.archive"'s inverse relation */
  metadataCustomField1List?: InputMaybe<ArchiveNestedMetadataCustomField1ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField20List" relation: "MetadataCustomField20.archive"'s inverse relation */
  metadataCustomField20List?: InputMaybe<ArchiveNestedMetadataCustomField20ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField3List" relation: "MetadataCustomField3.archive"'s inverse relation */
  metadataCustomField3List?: InputMaybe<ArchiveNestedMetadataCustomField3ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField4List" relation: "MetadataCustomField4.archive"'s inverse relation */
  metadataCustomField4List?: InputMaybe<ArchiveNestedMetadataCustomField4ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField5List" relation: "MetadataCustomField5.archive"'s inverse relation */
  metadataCustomField5List?: InputMaybe<ArchiveNestedMetadataCustomField5ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField6List" relation: "MetadataCustomField6.archive"'s inverse relation */
  metadataCustomField6List?: InputMaybe<ArchiveNestedMetadataCustomField6ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField7List" relation: "MetadataCustomField7.archive"'s inverse relation */
  metadataCustomField7List?: InputMaybe<ArchiveNestedMetadataCustomField7ListCreateInput>;
  /** Actions for the "Archive.metadataCustomField9List" relation: "MetadataCustomField9.archive"'s inverse relation */
  metadataCustomField9List?: InputMaybe<ArchiveNestedMetadataCustomField9ListCreateInput>;
  /** Actions for the "Archive.metadataDateCreatedList" relation: "MetadataDateCreated.archive"'s inverse relation */
  metadataDateCreatedList?: InputMaybe<ArchiveNestedMetadataDateCreatedListCreateInput>;
  /** Actions for the "Archive.metadataDateTimeOriginalList" relation: "MetadataDateTimeOriginal.archive"'s inverse relation */
  metadataDateTimeOriginalList?: InputMaybe<ArchiveNestedMetadataDateTimeOriginalListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryAccountList" relation: "MetadataDeliveryAccount.archive"'s inverse relation */
  metadataDeliveryAccountList?: InputMaybe<ArchiveNestedMetadataDeliveryAccountListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryCompanyList" relation: "MetadataDeliveryCompany.archive"'s inverse relation */
  metadataDeliveryCompanyList?: InputMaybe<ArchiveNestedMetadataDeliveryCompanyListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryCopyrightList" relation: "MetadataDeliveryCopyright.archive"'s inverse relation */
  metadataDeliveryCopyrightList?: InputMaybe<ArchiveNestedMetadataDeliveryCopyrightListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryDateFolderList" relation: "MetadataDeliveryDateFolder.archive"'s inverse relation */
  metadataDeliveryDateFolderList?: InputMaybe<ArchiveNestedMetadataDeliveryDateFolderListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryDateTimeList" relation: "MetadataDeliveryDateTime.archive"'s inverse relation */
  metadataDeliveryDateTimeList?: InputMaybe<ArchiveNestedMetadataDeliveryDateTimeListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryDcCreatorList" relation: "MetadataDeliveryDcCreator.archive"'s inverse relation */
  metadataDeliveryDcCreatorList?: InputMaybe<ArchiveNestedMetadataDeliveryDcCreatorListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryDcRightsList" relation: "MetadataDeliveryDcRights.archive"'s inverse relation */
  metadataDeliveryDcRightsList?: InputMaybe<ArchiveNestedMetadataDeliveryDcRightsListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryFolderList" relation: "MetadataDeliveryFolder.archive"'s inverse relation */
  metadataDeliveryFolderList?: InputMaybe<ArchiveNestedMetadataDeliveryFolderListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryKindList" relation: "MetadataDeliveryKind.archive"'s inverse relation */
  metadataDeliveryKindList?: InputMaybe<ArchiveNestedMetadataDeliveryKindListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryPathList" relation: "MetadataDeliveryPath.archive"'s inverse relation */
  metadataDeliveryPathList?: InputMaybe<ArchiveNestedMetadataDeliveryPathListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryPhotoshopCreditList" relation: "MetadataDeliveryPhotoshopCredit.archive"'s inverse relation */
  metadataDeliveryPhotoshopCreditList?: InputMaybe<ArchiveNestedMetadataDeliveryPhotoshopCreditListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryPhotoshopSourceList" relation: "MetadataDeliveryPhotoshopSource.archive"'s inverse relation */
  metadataDeliveryPhotoshopSourceList?: InputMaybe<ArchiveNestedMetadataDeliveryPhotoshopSourceListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryServiceList" relation: "MetadataDeliveryService.archive"'s inverse relation */
  metadataDeliveryServiceList?: InputMaybe<ArchiveNestedMetadataDeliveryServiceListCreateInput>;
  /** Actions for the "Archive.metadataDeliverySubjectList" relation: "MetadataDeliverySubject.archive"'s inverse relation */
  metadataDeliverySubjectList?: InputMaybe<ArchiveNestedMetadataDeliverySubjectListCreateInput>;
  /** Actions for the "Archive.metadataDeliveryUnderSubjectList" relation: "MetadataDeliveryUnderSubject.archive"'s inverse relation */
  metadataDeliveryUnderSubjectList?: InputMaybe<ArchiveNestedMetadataDeliveryUnderSubjectListCreateInput>;
  /** Actions for the "Archive.metadataDepartmentList" relation: "MetadataDepartment.archive"'s inverse relation */
  metadataDepartmentList?: InputMaybe<ArchiveNestedMetadataDepartmentListCreateInput>;
  /** Actions for the "Archive.metadataDescriptionList" relation: "MetadataDescription.archive"'s inverse relation */
  metadataDescriptionList?: InputMaybe<ArchiveNestedMetadataDescriptionListCreateInput>;
  /** Actions for the "Archive.metadataEditionList" relation: "MetadataEdition.archive"'s inverse relation */
  metadataEditionList?: InputMaybe<ArchiveNestedMetadataEditionListCreateInput>;
  /** Actions for the "Archive.metadataEditStatusList" relation: "MetadataEditStatus.archive"'s inverse relation */
  metadataEditStatusList?: InputMaybe<ArchiveNestedMetadataEditStatusListCreateInput>;
  /** Actions for the "Archive.metadataFileStatusList" relation: "MetadataFileStatus.archive"'s inverse relation */
  metadataFileStatusList?: InputMaybe<ArchiveNestedMetadataFileStatusListCreateInput>;
  /** Actions for the "Archive.metadataFormatList" relation: "MetadataFormat.archive"'s inverse relation */
  metadataFormatList?: InputMaybe<ArchiveNestedMetadataFormatListCreateInput>;
  /** Actions for the "Archive.metadataHeaderList" relation: "MetadataHeader.archive"'s inverse relation */
  metadataHeaderList?: InputMaybe<ArchiveNestedMetadataHeaderListCreateInput>;
  /** Actions for the "Archive.metadataHeaderPrismaList" relation: "MetadataHeaderPrisma.archive"'s inverse relation */
  metadataHeaderPrismaList?: InputMaybe<ArchiveNestedMetadataHeaderPrismaListCreateInput>;
  /** Actions for the "Archive.metadataHeadlineList" relation: "MetadataHeadline.archive"'s inverse relation */
  metadataHeadlineList?: InputMaybe<ArchiveNestedMetadataHeadlineListCreateInput>;
  /** Actions for the "Archive.metadataIdAssignmentList" relation: "MetadataIdAssignment.archive"'s inverse relation */
  metadataIdAssignmentList?: InputMaybe<ArchiveNestedMetadataIdAssignmentListCreateInput>;
  /** Actions for the "Archive.metadataIdPhotoPrismaList" relation: "MetadataIdPhotoPrisma.archive"'s inverse relation */
  metadataIdPhotoPrismaList?: InputMaybe<ArchiveNestedMetadataIdPhotoPrismaListCreateInput>;
  /** Actions for the "Archive.metadataIdSubjectList" relation: "MetadataIdSubject.archive"'s inverse relation */
  metadataIdSubjectList?: InputMaybe<ArchiveNestedMetadataIdSubjectListCreateInput>;
  /** Actions for the "Archive.metadataImageNotesList" relation: "MetadataImageNotes.archive"'s inverse relation */
  metadataImageNotesList?: InputMaybe<ArchiveNestedMetadataImageNotesListCreateInput>;
  /** Actions for the "Archive.metadataInstructionsList" relation: "MetadataInstructions.archive"'s inverse relation */
  metadataInstructionsList?: InputMaybe<ArchiveNestedMetadataInstructionsListCreateInput>;
  /** Actions for the "Archive.metadataIssueList" relation: "MetadataIssue.archive"'s inverse relation */
  metadataIssueList?: InputMaybe<ArchiveNestedMetadataIssueListCreateInput>;
  /** Actions for the "Archive.metadataKeywordsList" relation: "MetadataKeywords.archive"'s inverse relation */
  metadataKeywordsList?: InputMaybe<ArchiveNestedMetadataKeywordsListCreateInput>;
  /** Actions for the "Archive.metadataObjectNameList" relation: "MetadataObjectName.archive"'s inverse relation */
  metadataObjectNameList?: InputMaybe<ArchiveNestedMetadataObjectNameListCreateInput>;
  /** Actions for the "Archive.metadataOriginalNameList" relation: "MetadataOriginalName.archive"'s inverse relation */
  metadataOriginalNameList?: InputMaybe<ArchiveNestedMetadataOriginalNameListCreateInput>;
  /** Actions for the "Archive.metadataPriceLevelList" relation: "MetadataPriceLevel.archive"'s inverse relation */
  metadataPriceLevelList?: InputMaybe<ArchiveNestedMetadataPriceLevelListCreateInput>;
  /** Actions for the "Archive.metadataProcessHistoryList" relation: "MetadataProcessHistory.archive"'s inverse relation */
  metadataProcessHistoryList?: InputMaybe<ArchiveNestedMetadataProcessHistoryListCreateInput>;
  /** Actions for the "Archive.metadataProcessStatusList" relation: "MetadataProcessStatus.archive"'s inverse relation */
  metadataProcessStatusList?: InputMaybe<ArchiveNestedMetadataProcessStatusListCreateInput>;
  /** Actions for the "Archive.metadataProductList" relation: "MetadataProduct.archive"'s inverse relation */
  metadataProductList?: InputMaybe<ArchiveNestedMetadataProductListCreateInput>;
  /** Actions for the "Archive.metadataProductsList" relation: "MetadataProducts.archive"'s inverse relation */
  metadataProductsList?: InputMaybe<ArchiveNestedMetadataProductsListCreateInput>;
  /** Actions for the "Archive.metadataPublishingSubjectList" relation: "MetadataPublishingSubject.archive"'s inverse relation */
  metadataPublishingSubjectList?: InputMaybe<ArchiveNestedMetadataPublishingSubjectListCreateInput>;
  /** Actions for the "Archive.metadataResolutionKindList" relation: "MetadataResolutionKind.archive"'s inverse relation */
  metadataResolutionKindList?: InputMaybe<ArchiveNestedMetadataResolutionKindListCreateInput>;
  /** Actions for the "Archive.metadataRightsList" relation: "MetadataRights.archive"'s inverse relation */
  metadataRightsList?: InputMaybe<ArchiveNestedMetadataRightsListCreateInput>;
  /** Actions for the "Archive.metadataSourceList" relation: "MetadataSource.archive"'s inverse relation */
  metadataSourceList?: InputMaybe<ArchiveNestedMetadataSourceListCreateInput>;
  /** Actions for the "Archive.metadataSpecialInstructionsList" relation: "MetadataSpecialInstructions.archive"'s inverse relation */
  metadataSpecialInstructionsList?: InputMaybe<ArchiveNestedMetadataSpecialInstructionsListCreateInput>;
  /** Actions for the "Archive.metadataSubjectCodeList" relation: "MetadataSubjectCode.archive"'s inverse relation */
  metadataSubjectCodeList?: InputMaybe<ArchiveNestedMetadataSubjectCodeListCreateInput>;
  /** Actions for the "Archive.metadataSubjectList" relation: "MetadataSubject.archive"'s inverse relation */
  metadataSubjectList?: InputMaybe<ArchiveNestedMetadataSubjectListCreateInput>;
  /** Actions for the "Archive.metadataSubjectPrismaList" relation: "MetadataSubjectPrisma.archive"'s inverse relation */
  metadataSubjectPrismaList?: InputMaybe<ArchiveNestedMetadataSubjectPrismaListCreateInput>;
  /** Actions for the "Archive.metadataTitleList" relation: "MetadataTitle.archive"'s inverse relation */
  metadataTitleList?: InputMaybe<ArchiveNestedMetadataTitleListCreateInput>;
  /** Actions for the "Archive.metadataTransferredByFullNameList" relation: "MetadataTransferredByFullName.archive"'s inverse relation */
  metadataTransferredByFullNameList?: InputMaybe<ArchiveNestedMetadataTransferredByFullNameListCreateInput>;
  /** Actions for the "Archive.metadataTransferredByList" relation: "MetadataTransferredBy.archive"'s inverse relation */
  metadataTransferredByList?: InputMaybe<ArchiveNestedMetadataTransferredByListCreateInput>;
  /** Actions for the "Archive.metadataTypeList" relation: "MetadataType.archive"'s inverse relation */
  metadataTypeList?: InputMaybe<ArchiveNestedMetadataTypeListCreateInput>;
  /** Actions for the "Archive.metadataUndersubjectList" relation: "MetadataUndersubject.archive"'s inverse relation */
  metadataUndersubjectList?: InputMaybe<ArchiveNestedMetadataUndersubjectListCreateInput>;
  /** Actions for the "Archive.metadataUnderUnderSubjectList" relation: "MetadataUnderUnderSubject.archive"'s inverse relation */
  metadataUnderUnderSubjectList?: InputMaybe<ArchiveNestedMetadataUnderUnderSubjectListCreateInput>;
  /** Actions for the "Archive.metadataUploadedByFullNameList" relation: "MetadataUploadedByFullName.archive"'s inverse relation */
  metadataUploadedByFullNameList?: InputMaybe<ArchiveNestedMetadataUploadedByFullNameListCreateInput>;
  /** Actions for the "Archive.metadataUploadedByList" relation: "MetadataUploadedBy.archive"'s inverse relation */
  metadataUploadedByList?: InputMaybe<ArchiveNestedMetadataUploadedByListCreateInput>;
  /** Actions for the "Archive.metadataUploadTimeList" relation: "MetadataUploadTime.archive"'s inverse relation */
  metadataUploadTimeList?: InputMaybe<ArchiveNestedMetadataUploadTimeListCreateInput>;
  /** Actions for the "Archive.metadataUrgencyList" relation: "MetadataUrgency.archive"'s inverse relation */
  metadataUrgencyList?: InputMaybe<ArchiveNestedMetadataUrgencyListCreateInput>;
  /** Actions for the "Archive.metadataUserDefined195List" relation: "MetadataUserDefined195.archive"'s inverse relation */
  metadataUserDefined195List?: InputMaybe<ArchiveNestedMetadataUserDefined195ListCreateInput>;
  /** Actions for the "Archive.metadataUserDefined237List" relation: "MetadataUserDefined237.archive"'s inverse relation */
  metadataUserDefined237List?: InputMaybe<ArchiveNestedMetadataUserDefined237ListCreateInput>;
  /** Actions for the "Archive.metadataUserDefined238List" relation: "MetadataUserDefined238.archive"'s inverse relation */
  metadataUserDefined238List?: InputMaybe<ArchiveNestedMetadataUserDefined238ListCreateInput>;
  /** Actions for the "Archive.metadataUserDefined239List" relation: "MetadataUserDefined239.archive"'s inverse relation */
  metadataUserDefined239List?: InputMaybe<ArchiveNestedMetadataUserDefined239ListCreateInput>;
  /** Actions for the "Archive.metadataUserDefined242List" relation: "MetadataUserDefined242.archive"'s inverse relation */
  metadataUserDefined242List?: InputMaybe<ArchiveNestedMetadataUserDefined242ListCreateInput>;
  /** Actions for the "Archive.metadataUserDefined62List" relation: "MetadataUserDefined62.archive"'s inverse relation */
  metadataUserDefined62List?: InputMaybe<ArchiveNestedMetadataUserDefined62ListCreateInput>;
  /** Actions for the "Archive.metadataWorkflowKindList" relation: "MetadataWorkflowKind.archive"'s inverse relation */
  metadataWorkflowKindList?: InputMaybe<ArchiveNestedMetadataWorkflowKindListCreateInput>;
  /** Actions for the "Archive.metadataXmpHistoryList" relation: "MetadataXmpHistory.archive"'s inverse relation */
  metadataXmpHistoryList?: InputMaybe<ArchiveNestedMetadataXmpHistoryListCreateInput>;
  /** The archive name */
  name?: InputMaybe<ArchiveKeyType>;
  /** Actions for the "Archive.photoMetadatas" relation: "PhotoMetadata.archive"'s inverse relation */
  photoMetadatas?: InputMaybe<ArchiveNestedPhotoMetadatasCreateInput>;
  /** Actions for the "Archive.photos" relation: "Photo.archive"'s inverse relation */
  photos?: InputMaybe<ArchiveNestedPhotosCreateInput>;
  /** The archive type */
  type?: InputMaybe<ArchiveType>;
};

export enum ArchiveKeyType {
  CAM_ARCHIVES = 'CAM_ARCHIVES',
  CAM_LIVRAISON = 'CAM_LIVRAISON',
  CAM_SUJETS = 'CAM_SUJETS',
  CBG_SUJETS = 'CBG_SUJETS',
  CLE_SUJETS = 'CLE_SUJETS',
  CTM_ARCHIVES = 'CTM_ARCHIVES',
  CTM_SUJETS = 'CTM_SUJETS',
  CTM_WEB = 'CTM_WEB',
  FATV_SUJETS = 'FATV_SUJETS',
  FDI_ARCHIVE = 'FDI_ARCHIVE',
  FDI_SUJETS = 'FDI_SUJETS',
  GEO_ARCHIVES = 'GEO_ARCHIVES',
  HBZ_ARCHIVE = 'HBZ_ARCHIVE',
  HBZ_LIVRAISON = 'HBZ_LIVRAISON',
  HBZ_SUJETS = 'HBZ_SUJETS',
  IA_PRISMA_ARCHIVES = 'IA_PRISMA_ARCHIVES',
  ICI_ARCHIVE = 'ICI_ARCHIVE',
  ICI_SUJETS = 'ICI_SUJETS',
  IDE_SUJETS = 'IDE_SUJETS',
  JDD_SUJETS = 'JDD_SUJETS',
  JDM_SUJETS = 'JDM_SUJETS',
  JDN_SUJETS = 'JDN_SUJETS',
  MAD_SUJETS = 'MAD_SUJETS',
  NEON_SUJETS = 'NEON_SUJETS',
  NGE_SUJETS = 'NGE_SUJETS',
  PECO_SUJETS = 'PECO_SUJETS',
  PECO_WEB = 'PECO_WEB',
  PFEM_SUJETS = 'PFEM_SUJETS',
  PGEO_SUJETS = 'PGEO_SUJETS',
  PTVS_ARCHIVES_TV = 'PTVS_ARCHIVES_TV',
  PTVS_LIVRAISON = 'PTVS_LIVRAISON',
  PTVS_SUJETS = 'PTVS_SUJETS',
  TEST_UNIT = 'TEST_UNIT',
  TGL_SUJETS = 'TGL_SUJETS',
  TRV_PHOTOS = 'TRV_PHOTOS',
  TRV_WEB_GRAPHIX = 'TRV_WEB_GRAPHIX',
  TVS_SUJETS = 'TVS_SUJETS',
  VOI_ARCHIVES = 'VOI_ARCHIVES',
  VOI_BASE_PEOPLE = 'VOI_BASE_PEOPLE',
  VOI_BEAUTE = 'VOI_BEAUTE',
  VOI_SCOOP = 'VOI_SCOOP',
  VOICI_LIVRAISON = 'VOICI_LIVRAISON',
  VOICI_SUJETS = 'VOICI_SUJETS'
}

export type ArchiveNestedArchiveAgenciesCreateInput = {
  /** Connect existing "ArchiveAgency" nodes to the new "Archive" node, through the "Archive.archiveAgencies" relation. */
  connect?: InputMaybe<Array<ArchiveAgencyWhereUniqueInput>>;
  /** Create new "ArchiveAgency" nodes and connect them to the new "Archive" node, through the "Archive.archiveAgencies" relation. */
  create?: InputMaybe<Array<ArchiveAgencyWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedArchiveAgenciesUpdateInput = {
  /** Connect existing "ArchiveAgency" nodes to the existing "Archive" node, through the "Archive.archiveAgencies" relation. */
  connect?: InputMaybe<Array<ArchiveAgencyWhereUniqueInput>>;
  /** Create new "ArchiveAgency" nodes and connect them to the existing "Archive" node, through the "Archive.archiveAgencies" relation. */
  create?: InputMaybe<Array<ArchiveAgencyWithForcedArchiveCreateInput>>;
  /** Delete existing "ArchiveAgency" nodes from the "Archive.archiveAgencies" relation. */
  delete?: InputMaybe<Array<ArchiveAgencyWithForcedArchiveWhereUniqueInput>>;
  /** Update existing "ArchiveAgency" nodes and connect them to the existing "Archive" node, through the "Archive.archiveAgencies" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateArchiveAgenciesUpdateInput>>;
  /** Upsert existing "ArchiveAgency" nodes and connect them to the existing "Archive" node, through the "Archive.archiveAgencies" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertArchiveAgenciesUpdateInput>>;
};

export type ArchiveNestedArchivePurgeSettingCreateInput = {
  /** Connect an existing "ArchivePurgeSetting" node to the new "Archive" node, through the "Archive.archivePurgeSetting" relation. */
  connect?: InputMaybe<ArchivePurgeSettingWhereUniqueInput>;
  /** Create a new "ArchivePurgeSetting" node and connect it to the new "Archive" node, through the "Archive.archivePurgeSetting" relation. */
  create?: InputMaybe<ArchivePurgeSettingWithForcedArchiveCreateInput>;
};

export type ArchiveNestedArchivePurgeSettingUpdateInput = {
  /** Connect an existing "ArchivePurgeSetting" node to the existing "Archive" node, through the "Archive.archivePurgeSetting" relation. */
  connect?: InputMaybe<ArchivePurgeSettingWhereUniqueInput>;
  /** Create a new "ArchivePurgeSetting" node and connect it to the existing "Archive" node, through the "Archive.archivePurgeSetting" relation. */
  create?: InputMaybe<ArchivePurgeSettingWithForcedArchiveCreateInput>;
  /** Delete an existing "ArchivePurgeSetting" node from the "Archive.archivePurgeSetting" relation. */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "ArchivePurgeSetting" node and connect it to the existing "Archive" node, through the "Archive.archivePurgeSetting" relation. */
  update?: InputMaybe<ArchiveNestedUpdateArchivePurgeSettingUpdateInput>;
  /** Upsert an existing "ArchivePurgeSetting" node and connect it to the existing "Archive" node, through the "Archive.archivePurgeSetting" relation. */
  upsert?: InputMaybe<ArchiveNestedUpsertArchivePurgeSettingUpdateInput>;
};

export type ArchiveNestedCategoriesCreateInput = {
  /** Connect existing "Category" nodes to the new "Archive" node, through the "Archive.categories" relation. */
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Create new "Category" nodes and connect them to the new "Archive" node, through the "Archive.categories" relation. */
  create?: InputMaybe<Array<CategoryWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedCategoriesUpdateInput = {
  /** Connect existing "Category" nodes to the existing "Archive" node, through the "Archive.categories" relation. */
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Create new "Category" nodes and connect them to the existing "Archive" node, through the "Archive.categories" relation. */
  create?: InputMaybe<Array<CategoryWithForcedArchiveCreateInput>>;
  /** Delete existing "Category" nodes from the "Archive.categories" relation. */
  delete?: InputMaybe<Array<CategoryWithForcedArchiveWhereUniqueInput>>;
  /** Update existing "Category" nodes and connect them to the existing "Archive" node, through the "Archive.categories" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateCategoriesUpdateInput>>;
  /** Upsert existing "Category" nodes and connect them to the existing "Archive" node, through the "Archive.categories" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertCategoriesUpdateInput>>;
};

export type ArchiveNestedDeliverySubjectsCreateInput = {
  /** Connect existing "DeliverySubject" nodes to the new "Archive" node, through the "Archive.deliverySubjects" relation. */
  connect?: InputMaybe<Array<DeliverySubjectWhereUniqueInput>>;
  /** Create new "DeliverySubject" nodes and connect them to the new "Archive" node, through the "Archive.deliverySubjects" relation. */
  create?: InputMaybe<Array<DeliverySubjectWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedDeliverySubjectsUpdateInput = {
  /** Connect existing "DeliverySubject" nodes to the existing "Archive" node, through the "Archive.deliverySubjects" relation. */
  connect?: InputMaybe<Array<DeliverySubjectWhereUniqueInput>>;
  /** Create new "DeliverySubject" nodes and connect them to the existing "Archive" node, through the "Archive.deliverySubjects" relation. */
  create?: InputMaybe<Array<DeliverySubjectWithForcedArchiveCreateInput>>;
  /** Delete existing "DeliverySubject" nodes from the "Archive.deliverySubjects" relation. */
  delete?: InputMaybe<Array<DeliverySubjectWithForcedArchiveWhereUniqueInput>>;
  /** Update existing "DeliverySubject" nodes and connect them to the existing "Archive" node, through the "Archive.deliverySubjects" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateDeliverySubjectsUpdateInput>>;
  /** Upsert existing "DeliverySubject" nodes and connect them to the existing "Archive" node, through the "Archive.deliverySubjects" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertDeliverySubjectsUpdateInput>>;
};

export type ArchiveNestedGcImportSettingCreateInput = {
  /** Connect an existing "GcImportSetting" node to the new "Archive" node, through the "Archive.gcImportSetting" relation. */
  connect?: InputMaybe<GcImportSettingWhereUniqueInput>;
  /** Create a new "GcImportSetting" node and connect it to the new "Archive" node, through the "Archive.gcImportSetting" relation. */
  create?: InputMaybe<GcImportSettingWithForcedArchiveCreateInput>;
};

export type ArchiveNestedGcImportSettingUpdateInput = {
  /** Connect an existing "GcImportSetting" node to the existing "Archive" node, through the "Archive.gcImportSetting" relation. */
  connect?: InputMaybe<GcImportSettingWhereUniqueInput>;
  /** Create a new "GcImportSetting" node and connect it to the existing "Archive" node, through the "Archive.gcImportSetting" relation. */
  create?: InputMaybe<GcImportSettingWithForcedArchiveCreateInput>;
  /** Delete an existing "GcImportSetting" node from the "Archive.gcImportSetting" relation. */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "GcImportSetting" node and connect it to the existing "Archive" node, through the "Archive.gcImportSetting" relation. */
  update?: InputMaybe<ArchiveNestedUpdateGcImportSettingUpdateInput>;
  /** Upsert an existing "GcImportSetting" node and connect it to the existing "Archive" node, through the "Archive.gcImportSetting" relation. */
  upsert?: InputMaybe<ArchiveNestedUpsertGcImportSettingUpdateInput>;
};

export type ArchiveNestedImportQueuesCreateInput = {
  /** Connect existing "ImportQueue" nodes to the new "Archive" node, through the "Archive.importQueues" relation. */
  connect?: InputMaybe<Array<ImportQueueWhereUniqueInput>>;
  /** Create new "ImportQueue" nodes and connect them to the new "Archive" node, through the "Archive.importQueues" relation. */
  create?: InputMaybe<Array<ImportQueueWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedImportQueuesUpdateInput = {
  /** Connect existing "ImportQueue" nodes to the existing "Archive" node, through the "Archive.importQueues" relation. */
  connect?: InputMaybe<Array<ImportQueueWhereUniqueInput>>;
  /** Create new "ImportQueue" nodes and connect them to the existing "Archive" node, through the "Archive.importQueues" relation. */
  create?: InputMaybe<Array<ImportQueueWithForcedArchiveCreateInput>>;
  /** Delete existing "ImportQueue" nodes from the "Archive.importQueues" relation. */
  delete?: InputMaybe<Array<ImportQueueWhereUniqueInput>>;
  /** Disconnect existing "ImportQueue" nodes of the "Archive.importQueues" relation. */
  disconnect?: InputMaybe<Array<ImportQueueWhereUniqueInput>>;
  /** Update existing "ImportQueue" nodes and connect them to the existing "Archive" node, through the "Archive.importQueues" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateImportQueuesUpdateInput>>;
  /** Upsert existing "ImportQueue" nodes and connect them to the existing "Archive" node, through the "Archive.importQueues" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertImportQueuesUpdateInput>>;
};

export type ArchiveNestedMetadataAccessRightsListCreateInput = {
  /** Connect existing "MetadataAccessRights" nodes to the new "Archive" node, through the "Archive.metadataAccessRightsList" relation. */
  connect?: InputMaybe<Array<MetadataAccessRightsWhereUniqueInput>>;
  /** Create new "MetadataAccessRights" nodes and connect them to the new "Archive" node, through the "Archive.metadataAccessRightsList" relation. */
  create?: InputMaybe<Array<MetadataAccessRightsWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataAccessRightsListUpdateInput = {
  /** Connect existing "MetadataAccessRights" nodes to the existing "Archive" node, through the "Archive.metadataAccessRightsList" relation. */
  connect?: InputMaybe<Array<MetadataAccessRightsWhereUniqueInput>>;
  /** Create new "MetadataAccessRights" nodes and connect them to the existing "Archive" node, through the "Archive.metadataAccessRightsList" relation. */
  create?: InputMaybe<Array<MetadataAccessRightsWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataAccessRights" nodes from the "Archive.metadataAccessRightsList" relation. */
  delete?: InputMaybe<Array<MetadataAccessRightsWhereUniqueInput>>;
  /** Update existing "MetadataAccessRights" nodes and connect them to the existing "Archive" node, through the "Archive.metadataAccessRightsList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataAccessRightsListUpdateInput>>;
  /** Upsert existing "MetadataAccessRights" nodes and connect them to the existing "Archive" node, through the "Archive.metadataAccessRightsList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataAccessRightsListUpdateInput>>;
};

export type ArchiveNestedMetadataAssetStateListCreateInput = {
  /** Connect existing "MetadataAssetState" nodes to the new "Archive" node, through the "Archive.metadataAssetStateList" relation. */
  connect?: InputMaybe<Array<MetadataAssetStateWhereUniqueInput>>;
  /** Create new "MetadataAssetState" nodes and connect them to the new "Archive" node, through the "Archive.metadataAssetStateList" relation. */
  create?: InputMaybe<Array<MetadataAssetStateWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataAssetStateListUpdateInput = {
  /** Connect existing "MetadataAssetState" nodes to the existing "Archive" node, through the "Archive.metadataAssetStateList" relation. */
  connect?: InputMaybe<Array<MetadataAssetStateWhereUniqueInput>>;
  /** Create new "MetadataAssetState" nodes and connect them to the existing "Archive" node, through the "Archive.metadataAssetStateList" relation. */
  create?: InputMaybe<Array<MetadataAssetStateWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataAssetState" nodes from the "Archive.metadataAssetStateList" relation. */
  delete?: InputMaybe<Array<MetadataAssetStateWhereUniqueInput>>;
  /** Update existing "MetadataAssetState" nodes and connect them to the existing "Archive" node, through the "Archive.metadataAssetStateList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataAssetStateListUpdateInput>>;
  /** Upsert existing "MetadataAssetState" nodes and connect them to the existing "Archive" node, through the "Archive.metadataAssetStateList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataAssetStateListUpdateInput>>;
};

export type ArchiveNestedMetadataBackupNameListCreateInput = {
  /** Connect existing "MetadataBackupName" nodes to the new "Archive" node, through the "Archive.metadataBackupNameList" relation. */
  connect?: InputMaybe<Array<MetadataBackupNameWhereUniqueInput>>;
  /** Create new "MetadataBackupName" nodes and connect them to the new "Archive" node, through the "Archive.metadataBackupNameList" relation. */
  create?: InputMaybe<Array<MetadataBackupNameWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataBackupNameListUpdateInput = {
  /** Connect existing "MetadataBackupName" nodes to the existing "Archive" node, through the "Archive.metadataBackupNameList" relation. */
  connect?: InputMaybe<Array<MetadataBackupNameWhereUniqueInput>>;
  /** Create new "MetadataBackupName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBackupNameList" relation. */
  create?: InputMaybe<Array<MetadataBackupNameWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataBackupName" nodes from the "Archive.metadataBackupNameList" relation. */
  delete?: InputMaybe<Array<MetadataBackupNameWhereUniqueInput>>;
  /** Update existing "MetadataBackupName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBackupNameList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataBackupNameListUpdateInput>>;
  /** Upsert existing "MetadataBackupName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBackupNameList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataBackupNameListUpdateInput>>;
};

export type ArchiveNestedMetadataBrandListCreateInput = {
  /** Connect existing "MetadataBrand" nodes to the new "Archive" node, through the "Archive.metadataBrandList" relation. */
  connect?: InputMaybe<Array<MetadataBrandWhereUniqueInput>>;
  /** Create new "MetadataBrand" nodes and connect them to the new "Archive" node, through the "Archive.metadataBrandList" relation. */
  create?: InputMaybe<Array<MetadataBrandWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataBrandListUpdateInput = {
  /** Connect existing "MetadataBrand" nodes to the existing "Archive" node, through the "Archive.metadataBrandList" relation. */
  connect?: InputMaybe<Array<MetadataBrandWhereUniqueInput>>;
  /** Create new "MetadataBrand" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBrandList" relation. */
  create?: InputMaybe<Array<MetadataBrandWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataBrand" nodes from the "Archive.metadataBrandList" relation. */
  delete?: InputMaybe<Array<MetadataBrandWhereUniqueInput>>;
  /** Update existing "MetadataBrand" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBrandList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataBrandListUpdateInput>>;
  /** Upsert existing "MetadataBrand" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBrandList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataBrandListUpdateInput>>;
};

export type ArchiveNestedMetadataBrandPrismaListCreateInput = {
  /** Connect existing "MetadataBrandPrisma" nodes to the new "Archive" node, through the "Archive.metadataBrandPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataBrandPrismaWhereUniqueInput>>;
  /** Create new "MetadataBrandPrisma" nodes and connect them to the new "Archive" node, through the "Archive.metadataBrandPrismaList" relation. */
  create?: InputMaybe<Array<MetadataBrandPrismaWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataBrandPrismaListUpdateInput = {
  /** Connect existing "MetadataBrandPrisma" nodes to the existing "Archive" node, through the "Archive.metadataBrandPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataBrandPrismaWhereUniqueInput>>;
  /** Create new "MetadataBrandPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBrandPrismaList" relation. */
  create?: InputMaybe<Array<MetadataBrandPrismaWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataBrandPrisma" nodes from the "Archive.metadataBrandPrismaList" relation. */
  delete?: InputMaybe<Array<MetadataBrandPrismaWhereUniqueInput>>;
  /** Update existing "MetadataBrandPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBrandPrismaList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataBrandPrismaListUpdateInput>>;
  /** Upsert existing "MetadataBrandPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBrandPrismaList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataBrandPrismaListUpdateInput>>;
};

export type ArchiveNestedMetadataBrandShortNameListCreateInput = {
  /** Connect existing "MetadataBrandShortName" nodes to the new "Archive" node, through the "Archive.metadataBrandShortNameList" relation. */
  connect?: InputMaybe<Array<MetadataBrandShortNameWhereUniqueInput>>;
  /** Create new "MetadataBrandShortName" nodes and connect them to the new "Archive" node, through the "Archive.metadataBrandShortNameList" relation. */
  create?: InputMaybe<Array<MetadataBrandShortNameWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataBrandShortNameListUpdateInput = {
  /** Connect existing "MetadataBrandShortName" nodes to the existing "Archive" node, through the "Archive.metadataBrandShortNameList" relation. */
  connect?: InputMaybe<Array<MetadataBrandShortNameWhereUniqueInput>>;
  /** Create new "MetadataBrandShortName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBrandShortNameList" relation. */
  create?: InputMaybe<Array<MetadataBrandShortNameWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataBrandShortName" nodes from the "Archive.metadataBrandShortNameList" relation. */
  delete?: InputMaybe<Array<MetadataBrandShortNameWhereUniqueInput>>;
  /** Update existing "MetadataBrandShortName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBrandShortNameList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataBrandShortNameListUpdateInput>>;
  /** Upsert existing "MetadataBrandShortName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataBrandShortNameList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataBrandShortNameListUpdateInput>>;
};

export type ArchiveNestedMetadataByLineListCreateInput = {
  /** Connect existing "MetadataByLine" nodes to the new "Archive" node, through the "Archive.metadataByLineList" relation. */
  connect?: InputMaybe<Array<MetadataByLineWhereUniqueInput>>;
  /** Create new "MetadataByLine" nodes and connect them to the new "Archive" node, through the "Archive.metadataByLineList" relation. */
  create?: InputMaybe<Array<MetadataByLineWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataByLineListUpdateInput = {
  /** Connect existing "MetadataByLine" nodes to the existing "Archive" node, through the "Archive.metadataByLineList" relation. */
  connect?: InputMaybe<Array<MetadataByLineWhereUniqueInput>>;
  /** Create new "MetadataByLine" nodes and connect them to the existing "Archive" node, through the "Archive.metadataByLineList" relation. */
  create?: InputMaybe<Array<MetadataByLineWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataByLine" nodes from the "Archive.metadataByLineList" relation. */
  delete?: InputMaybe<Array<MetadataByLineWhereUniqueInput>>;
  /** Update existing "MetadataByLine" nodes and connect them to the existing "Archive" node, through the "Archive.metadataByLineList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataByLineListUpdateInput>>;
  /** Upsert existing "MetadataByLine" nodes and connect them to the existing "Archive" node, through the "Archive.metadataByLineList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataByLineListUpdateInput>>;
};

export type ArchiveNestedMetadataCaptionAbstractListCreateInput = {
  /** Connect existing "MetadataCaptionAbstract" nodes to the new "Archive" node, through the "Archive.metadataCaptionAbstractList" relation. */
  connect?: InputMaybe<Array<MetadataCaptionAbstractWhereUniqueInput>>;
  /** Create new "MetadataCaptionAbstract" nodes and connect them to the new "Archive" node, through the "Archive.metadataCaptionAbstractList" relation. */
  create?: InputMaybe<Array<MetadataCaptionAbstractWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCaptionAbstractListUpdateInput = {
  /** Connect existing "MetadataCaptionAbstract" nodes to the existing "Archive" node, through the "Archive.metadataCaptionAbstractList" relation. */
  connect?: InputMaybe<Array<MetadataCaptionAbstractWhereUniqueInput>>;
  /** Create new "MetadataCaptionAbstract" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCaptionAbstractList" relation. */
  create?: InputMaybe<Array<MetadataCaptionAbstractWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCaptionAbstract" nodes from the "Archive.metadataCaptionAbstractList" relation. */
  delete?: InputMaybe<Array<MetadataCaptionAbstractWhereUniqueInput>>;
  /** Update existing "MetadataCaptionAbstract" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCaptionAbstractList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCaptionAbstractListUpdateInput>>;
  /** Upsert existing "MetadataCaptionAbstract" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCaptionAbstractList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCaptionAbstractListUpdateInput>>;
};

export type ArchiveNestedMetadataCaptionListCreateInput = {
  /** Connect existing "MetadataCaption" nodes to the new "Archive" node, through the "Archive.metadataCaptionList" relation. */
  connect?: InputMaybe<Array<MetadataCaptionWhereUniqueInput>>;
  /** Create new "MetadataCaption" nodes and connect them to the new "Archive" node, through the "Archive.metadataCaptionList" relation. */
  create?: InputMaybe<Array<MetadataCaptionWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCaptionListUpdateInput = {
  /** Connect existing "MetadataCaption" nodes to the existing "Archive" node, through the "Archive.metadataCaptionList" relation. */
  connect?: InputMaybe<Array<MetadataCaptionWhereUniqueInput>>;
  /** Create new "MetadataCaption" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCaptionList" relation. */
  create?: InputMaybe<Array<MetadataCaptionWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCaption" nodes from the "Archive.metadataCaptionList" relation. */
  delete?: InputMaybe<Array<MetadataCaptionWhereUniqueInput>>;
  /** Update existing "MetadataCaption" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCaptionList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCaptionListUpdateInput>>;
  /** Upsert existing "MetadataCaption" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCaptionList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCaptionListUpdateInput>>;
};

export type ArchiveNestedMetadataCategoryListCreateInput = {
  /** Connect existing "MetadataCategory" nodes to the new "Archive" node, through the "Archive.metadataCategoryList" relation. */
  connect?: InputMaybe<Array<MetadataCategoryWhereUniqueInput>>;
  /** Create new "MetadataCategory" nodes and connect them to the new "Archive" node, through the "Archive.metadataCategoryList" relation. */
  create?: InputMaybe<Array<MetadataCategoryWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCategoryListUpdateInput = {
  /** Connect existing "MetadataCategory" nodes to the existing "Archive" node, through the "Archive.metadataCategoryList" relation. */
  connect?: InputMaybe<Array<MetadataCategoryWhereUniqueInput>>;
  /** Create new "MetadataCategory" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCategoryList" relation. */
  create?: InputMaybe<Array<MetadataCategoryWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCategory" nodes from the "Archive.metadataCategoryList" relation. */
  delete?: InputMaybe<Array<MetadataCategoryWhereUniqueInput>>;
  /** Update existing "MetadataCategory" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCategoryList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCategoryListUpdateInput>>;
  /** Upsert existing "MetadataCategory" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCategoryList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCategoryListUpdateInput>>;
};

export type ArchiveNestedMetadataCategoryPrismaListCreateInput = {
  /** Connect existing "MetadataCategoryPrisma" nodes to the new "Archive" node, through the "Archive.metadataCategoryPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataCategoryPrismaWhereUniqueInput>>;
  /** Create new "MetadataCategoryPrisma" nodes and connect them to the new "Archive" node, through the "Archive.metadataCategoryPrismaList" relation. */
  create?: InputMaybe<Array<MetadataCategoryPrismaWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCategoryPrismaListUpdateInput = {
  /** Connect existing "MetadataCategoryPrisma" nodes to the existing "Archive" node, through the "Archive.metadataCategoryPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataCategoryPrismaWhereUniqueInput>>;
  /** Create new "MetadataCategoryPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCategoryPrismaList" relation. */
  create?: InputMaybe<Array<MetadataCategoryPrismaWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCategoryPrisma" nodes from the "Archive.metadataCategoryPrismaList" relation. */
  delete?: InputMaybe<Array<MetadataCategoryPrismaWhereUniqueInput>>;
  /** Update existing "MetadataCategoryPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCategoryPrismaList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCategoryPrismaListUpdateInput>>;
  /** Upsert existing "MetadataCategoryPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCategoryPrismaList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCategoryPrismaListUpdateInput>>;
};

export type ArchiveNestedMetadataCompanyListCreateInput = {
  /** Connect existing "MetadataCompany" nodes to the new "Archive" node, through the "Archive.metadataCompanyList" relation. */
  connect?: InputMaybe<Array<MetadataCompanyWhereUniqueInput>>;
  /** Create new "MetadataCompany" nodes and connect them to the new "Archive" node, through the "Archive.metadataCompanyList" relation. */
  create?: InputMaybe<Array<MetadataCompanyWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCompanyListUpdateInput = {
  /** Connect existing "MetadataCompany" nodes to the existing "Archive" node, through the "Archive.metadataCompanyList" relation. */
  connect?: InputMaybe<Array<MetadataCompanyWhereUniqueInput>>;
  /** Create new "MetadataCompany" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCompanyList" relation. */
  create?: InputMaybe<Array<MetadataCompanyWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCompany" nodes from the "Archive.metadataCompanyList" relation. */
  delete?: InputMaybe<Array<MetadataCompanyWhereUniqueInput>>;
  /** Update existing "MetadataCompany" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCompanyList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCompanyListUpdateInput>>;
  /** Upsert existing "MetadataCompany" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCompanyList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCompanyListUpdateInput>>;
};

export type ArchiveNestedMetadataCompanyShortNameListCreateInput = {
  /** Connect existing "MetadataCompanyShortName" nodes to the new "Archive" node, through the "Archive.metadataCompanyShortNameList" relation. */
  connect?: InputMaybe<Array<MetadataCompanyShortNameWhereUniqueInput>>;
  /** Create new "MetadataCompanyShortName" nodes and connect them to the new "Archive" node, through the "Archive.metadataCompanyShortNameList" relation. */
  create?: InputMaybe<Array<MetadataCompanyShortNameWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCompanyShortNameListUpdateInput = {
  /** Connect existing "MetadataCompanyShortName" nodes to the existing "Archive" node, through the "Archive.metadataCompanyShortNameList" relation. */
  connect?: InputMaybe<Array<MetadataCompanyShortNameWhereUniqueInput>>;
  /** Create new "MetadataCompanyShortName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCompanyShortNameList" relation. */
  create?: InputMaybe<Array<MetadataCompanyShortNameWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCompanyShortName" nodes from the "Archive.metadataCompanyShortNameList" relation. */
  delete?: InputMaybe<Array<MetadataCompanyShortNameWhereUniqueInput>>;
  /** Update existing "MetadataCompanyShortName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCompanyShortNameList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCompanyShortNameListUpdateInput>>;
  /** Upsert existing "MetadataCompanyShortName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCompanyShortNameList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCompanyShortNameListUpdateInput>>;
};

export type ArchiveNestedMetadataCopyrightNoticeListCreateInput = {
  /** Connect existing "MetadataCopyrightNotice" nodes to the new "Archive" node, through the "Archive.metadataCopyrightNoticeList" relation. */
  connect?: InputMaybe<Array<MetadataCopyrightNoticeWhereUniqueInput>>;
  /** Create new "MetadataCopyrightNotice" nodes and connect them to the new "Archive" node, through the "Archive.metadataCopyrightNoticeList" relation. */
  create?: InputMaybe<Array<MetadataCopyrightNoticeWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCopyrightNoticeListUpdateInput = {
  /** Connect existing "MetadataCopyrightNotice" nodes to the existing "Archive" node, through the "Archive.metadataCopyrightNoticeList" relation. */
  connect?: InputMaybe<Array<MetadataCopyrightNoticeWhereUniqueInput>>;
  /** Create new "MetadataCopyrightNotice" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCopyrightNoticeList" relation. */
  create?: InputMaybe<Array<MetadataCopyrightNoticeWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCopyrightNotice" nodes from the "Archive.metadataCopyrightNoticeList" relation. */
  delete?: InputMaybe<Array<MetadataCopyrightNoticeWhereUniqueInput>>;
  /** Update existing "MetadataCopyrightNotice" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCopyrightNoticeList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCopyrightNoticeListUpdateInput>>;
  /** Upsert existing "MetadataCopyrightNotice" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCopyrightNoticeList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCopyrightNoticeListUpdateInput>>;
};

export type ArchiveNestedMetadataCreatorListCreateInput = {
  /** Connect existing "MetadataCreator" nodes to the new "Archive" node, through the "Archive.metadataCreatorList" relation. */
  connect?: InputMaybe<Array<MetadataCreatorWhereUniqueInput>>;
  /** Create new "MetadataCreator" nodes and connect them to the new "Archive" node, through the "Archive.metadataCreatorList" relation. */
  create?: InputMaybe<Array<MetadataCreatorWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCreatorListUpdateInput = {
  /** Connect existing "MetadataCreator" nodes to the existing "Archive" node, through the "Archive.metadataCreatorList" relation. */
  connect?: InputMaybe<Array<MetadataCreatorWhereUniqueInput>>;
  /** Create new "MetadataCreator" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCreatorList" relation. */
  create?: InputMaybe<Array<MetadataCreatorWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCreator" nodes from the "Archive.metadataCreatorList" relation. */
  delete?: InputMaybe<Array<MetadataCreatorWhereUniqueInput>>;
  /** Update existing "MetadataCreator" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCreatorList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCreatorListUpdateInput>>;
  /** Upsert existing "MetadataCreator" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCreatorList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCreatorListUpdateInput>>;
};

export type ArchiveNestedMetadataCreditListCreateInput = {
  /** Connect existing "MetadataCredit" nodes to the new "Archive" node, through the "Archive.metadataCreditList" relation. */
  connect?: InputMaybe<Array<MetadataCreditWhereUniqueInput>>;
  /** Create new "MetadataCredit" nodes and connect them to the new "Archive" node, through the "Archive.metadataCreditList" relation. */
  create?: InputMaybe<Array<MetadataCreditWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCreditListUpdateInput = {
  /** Connect existing "MetadataCredit" nodes to the existing "Archive" node, through the "Archive.metadataCreditList" relation. */
  connect?: InputMaybe<Array<MetadataCreditWhereUniqueInput>>;
  /** Create new "MetadataCredit" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCreditList" relation. */
  create?: InputMaybe<Array<MetadataCreditWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCredit" nodes from the "Archive.metadataCreditList" relation. */
  delete?: InputMaybe<Array<MetadataCreditWhereUniqueInput>>;
  /** Update existing "MetadataCredit" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCreditList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCreditListUpdateInput>>;
  /** Upsert existing "MetadataCredit" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCreditList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCreditListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField14ListCreateInput = {
  /** Connect existing "MetadataCustomField14" nodes to the new "Archive" node, through the "Archive.metadataCustomField14List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField14WhereUniqueInput>>;
  /** Create new "MetadataCustomField14" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField14List" relation. */
  create?: InputMaybe<Array<MetadataCustomField14WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField14ListUpdateInput = {
  /** Connect existing "MetadataCustomField14" nodes to the existing "Archive" node, through the "Archive.metadataCustomField14List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField14WhereUniqueInput>>;
  /** Create new "MetadataCustomField14" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField14List" relation. */
  create?: InputMaybe<Array<MetadataCustomField14WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField14" nodes from the "Archive.metadataCustomField14List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField14WhereUniqueInput>>;
  /** Update existing "MetadataCustomField14" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField14List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField14ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField14" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField14List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField14ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField15ListCreateInput = {
  /** Connect existing "MetadataCustomField15" nodes to the new "Archive" node, through the "Archive.metadataCustomField15List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField15WhereUniqueInput>>;
  /** Create new "MetadataCustomField15" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField15List" relation. */
  create?: InputMaybe<Array<MetadataCustomField15WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField15ListUpdateInput = {
  /** Connect existing "MetadataCustomField15" nodes to the existing "Archive" node, through the "Archive.metadataCustomField15List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField15WhereUniqueInput>>;
  /** Create new "MetadataCustomField15" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField15List" relation. */
  create?: InputMaybe<Array<MetadataCustomField15WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField15" nodes from the "Archive.metadataCustomField15List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField15WhereUniqueInput>>;
  /** Update existing "MetadataCustomField15" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField15List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField15ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField15" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField15List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField15ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField16ListCreateInput = {
  /** Connect existing "MetadataCustomField16" nodes to the new "Archive" node, through the "Archive.metadataCustomField16List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField16WhereUniqueInput>>;
  /** Create new "MetadataCustomField16" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField16List" relation. */
  create?: InputMaybe<Array<MetadataCustomField16WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField16ListUpdateInput = {
  /** Connect existing "MetadataCustomField16" nodes to the existing "Archive" node, through the "Archive.metadataCustomField16List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField16WhereUniqueInput>>;
  /** Create new "MetadataCustomField16" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField16List" relation. */
  create?: InputMaybe<Array<MetadataCustomField16WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField16" nodes from the "Archive.metadataCustomField16List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField16WhereUniqueInput>>;
  /** Update existing "MetadataCustomField16" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField16List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField16ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField16" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField16List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField16ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField17ListCreateInput = {
  /** Connect existing "MetadataCustomField17" nodes to the new "Archive" node, through the "Archive.metadataCustomField17List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField17WhereUniqueInput>>;
  /** Create new "MetadataCustomField17" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField17List" relation. */
  create?: InputMaybe<Array<MetadataCustomField17WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField17ListUpdateInput = {
  /** Connect existing "MetadataCustomField17" nodes to the existing "Archive" node, through the "Archive.metadataCustomField17List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField17WhereUniqueInput>>;
  /** Create new "MetadataCustomField17" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField17List" relation. */
  create?: InputMaybe<Array<MetadataCustomField17WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField17" nodes from the "Archive.metadataCustomField17List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField17WhereUniqueInput>>;
  /** Update existing "MetadataCustomField17" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField17List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField17ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField17" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField17List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField17ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField1ListCreateInput = {
  /** Connect existing "MetadataCustomField1" nodes to the new "Archive" node, through the "Archive.metadataCustomField1List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField1WhereUniqueInput>>;
  /** Create new "MetadataCustomField1" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField1List" relation. */
  create?: InputMaybe<Array<MetadataCustomField1WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField1ListUpdateInput = {
  /** Connect existing "MetadataCustomField1" nodes to the existing "Archive" node, through the "Archive.metadataCustomField1List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField1WhereUniqueInput>>;
  /** Create new "MetadataCustomField1" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField1List" relation. */
  create?: InputMaybe<Array<MetadataCustomField1WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField1" nodes from the "Archive.metadataCustomField1List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField1WhereUniqueInput>>;
  /** Update existing "MetadataCustomField1" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField1List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField1ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField1" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField1List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField1ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField20ListCreateInput = {
  /** Connect existing "MetadataCustomField20" nodes to the new "Archive" node, through the "Archive.metadataCustomField20List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField20WhereUniqueInput>>;
  /** Create new "MetadataCustomField20" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField20List" relation. */
  create?: InputMaybe<Array<MetadataCustomField20WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField20ListUpdateInput = {
  /** Connect existing "MetadataCustomField20" nodes to the existing "Archive" node, through the "Archive.metadataCustomField20List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField20WhereUniqueInput>>;
  /** Create new "MetadataCustomField20" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField20List" relation. */
  create?: InputMaybe<Array<MetadataCustomField20WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField20" nodes from the "Archive.metadataCustomField20List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField20WhereUniqueInput>>;
  /** Update existing "MetadataCustomField20" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField20List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField20ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField20" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField20List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField20ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField3ListCreateInput = {
  /** Connect existing "MetadataCustomField3" nodes to the new "Archive" node, through the "Archive.metadataCustomField3List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField3WhereUniqueInput>>;
  /** Create new "MetadataCustomField3" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField3List" relation. */
  create?: InputMaybe<Array<MetadataCustomField3WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField3ListUpdateInput = {
  /** Connect existing "MetadataCustomField3" nodes to the existing "Archive" node, through the "Archive.metadataCustomField3List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField3WhereUniqueInput>>;
  /** Create new "MetadataCustomField3" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField3List" relation. */
  create?: InputMaybe<Array<MetadataCustomField3WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField3" nodes from the "Archive.metadataCustomField3List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField3WhereUniqueInput>>;
  /** Update existing "MetadataCustomField3" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField3List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField3ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField3" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField3List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField3ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField4ListCreateInput = {
  /** Connect existing "MetadataCustomField4" nodes to the new "Archive" node, through the "Archive.metadataCustomField4List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField4WhereUniqueInput>>;
  /** Create new "MetadataCustomField4" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField4List" relation. */
  create?: InputMaybe<Array<MetadataCustomField4WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField4ListUpdateInput = {
  /** Connect existing "MetadataCustomField4" nodes to the existing "Archive" node, through the "Archive.metadataCustomField4List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField4WhereUniqueInput>>;
  /** Create new "MetadataCustomField4" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField4List" relation. */
  create?: InputMaybe<Array<MetadataCustomField4WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField4" nodes from the "Archive.metadataCustomField4List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField4WhereUniqueInput>>;
  /** Update existing "MetadataCustomField4" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField4List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField4ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField4" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField4List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField4ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField5ListCreateInput = {
  /** Connect existing "MetadataCustomField5" nodes to the new "Archive" node, through the "Archive.metadataCustomField5List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField5WhereUniqueInput>>;
  /** Create new "MetadataCustomField5" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField5List" relation. */
  create?: InputMaybe<Array<MetadataCustomField5WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField5ListUpdateInput = {
  /** Connect existing "MetadataCustomField5" nodes to the existing "Archive" node, through the "Archive.metadataCustomField5List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField5WhereUniqueInput>>;
  /** Create new "MetadataCustomField5" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField5List" relation. */
  create?: InputMaybe<Array<MetadataCustomField5WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField5" nodes from the "Archive.metadataCustomField5List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField5WhereUniqueInput>>;
  /** Update existing "MetadataCustomField5" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField5List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField5ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField5" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField5List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField5ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField6ListCreateInput = {
  /** Connect existing "MetadataCustomField6" nodes to the new "Archive" node, through the "Archive.metadataCustomField6List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField6WhereUniqueInput>>;
  /** Create new "MetadataCustomField6" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField6List" relation. */
  create?: InputMaybe<Array<MetadataCustomField6WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField6ListUpdateInput = {
  /** Connect existing "MetadataCustomField6" nodes to the existing "Archive" node, through the "Archive.metadataCustomField6List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField6WhereUniqueInput>>;
  /** Create new "MetadataCustomField6" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField6List" relation. */
  create?: InputMaybe<Array<MetadataCustomField6WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField6" nodes from the "Archive.metadataCustomField6List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField6WhereUniqueInput>>;
  /** Update existing "MetadataCustomField6" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField6List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField6ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField6" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField6List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField6ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField7ListCreateInput = {
  /** Connect existing "MetadataCustomField7" nodes to the new "Archive" node, through the "Archive.metadataCustomField7List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField7WhereUniqueInput>>;
  /** Create new "MetadataCustomField7" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField7List" relation. */
  create?: InputMaybe<Array<MetadataCustomField7WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField7ListUpdateInput = {
  /** Connect existing "MetadataCustomField7" nodes to the existing "Archive" node, through the "Archive.metadataCustomField7List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField7WhereUniqueInput>>;
  /** Create new "MetadataCustomField7" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField7List" relation. */
  create?: InputMaybe<Array<MetadataCustomField7WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField7" nodes from the "Archive.metadataCustomField7List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField7WhereUniqueInput>>;
  /** Update existing "MetadataCustomField7" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField7List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField7ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField7" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField7List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField7ListUpdateInput>>;
};

export type ArchiveNestedMetadataCustomField9ListCreateInput = {
  /** Connect existing "MetadataCustomField9" nodes to the new "Archive" node, through the "Archive.metadataCustomField9List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField9WhereUniqueInput>>;
  /** Create new "MetadataCustomField9" nodes and connect them to the new "Archive" node, through the "Archive.metadataCustomField9List" relation. */
  create?: InputMaybe<Array<MetadataCustomField9WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataCustomField9ListUpdateInput = {
  /** Connect existing "MetadataCustomField9" nodes to the existing "Archive" node, through the "Archive.metadataCustomField9List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField9WhereUniqueInput>>;
  /** Create new "MetadataCustomField9" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField9List" relation. */
  create?: InputMaybe<Array<MetadataCustomField9WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataCustomField9" nodes from the "Archive.metadataCustomField9List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField9WhereUniqueInput>>;
  /** Update existing "MetadataCustomField9" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField9List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataCustomField9ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField9" nodes and connect them to the existing "Archive" node, through the "Archive.metadataCustomField9List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataCustomField9ListUpdateInput>>;
};

export type ArchiveNestedMetadataDateCreatedListCreateInput = {
  /** Connect existing "MetadataDateCreated" nodes to the new "Archive" node, through the "Archive.metadataDateCreatedList" relation. */
  connect?: InputMaybe<Array<MetadataDateCreatedWhereUniqueInput>>;
  /** Create new "MetadataDateCreated" nodes and connect them to the new "Archive" node, through the "Archive.metadataDateCreatedList" relation. */
  create?: InputMaybe<Array<MetadataDateCreatedWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDateCreatedListUpdateInput = {
  /** Connect existing "MetadataDateCreated" nodes to the existing "Archive" node, through the "Archive.metadataDateCreatedList" relation. */
  connect?: InputMaybe<Array<MetadataDateCreatedWhereUniqueInput>>;
  /** Create new "MetadataDateCreated" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDateCreatedList" relation. */
  create?: InputMaybe<Array<MetadataDateCreatedWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDateCreated" nodes from the "Archive.metadataDateCreatedList" relation. */
  delete?: InputMaybe<Array<MetadataDateCreatedWhereUniqueInput>>;
  /** Update existing "MetadataDateCreated" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDateCreatedList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDateCreatedListUpdateInput>>;
  /** Upsert existing "MetadataDateCreated" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDateCreatedList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDateCreatedListUpdateInput>>;
};

export type ArchiveNestedMetadataDateTimeOriginalListCreateInput = {
  /** Connect existing "MetadataDateTimeOriginal" nodes to the new "Archive" node, through the "Archive.metadataDateTimeOriginalList" relation. */
  connect?: InputMaybe<Array<MetadataDateTimeOriginalWhereUniqueInput>>;
  /** Create new "MetadataDateTimeOriginal" nodes and connect them to the new "Archive" node, through the "Archive.metadataDateTimeOriginalList" relation. */
  create?: InputMaybe<Array<MetadataDateTimeOriginalWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDateTimeOriginalListUpdateInput = {
  /** Connect existing "MetadataDateTimeOriginal" nodes to the existing "Archive" node, through the "Archive.metadataDateTimeOriginalList" relation. */
  connect?: InputMaybe<Array<MetadataDateTimeOriginalWhereUniqueInput>>;
  /** Create new "MetadataDateTimeOriginal" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDateTimeOriginalList" relation. */
  create?: InputMaybe<Array<MetadataDateTimeOriginalWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDateTimeOriginal" nodes from the "Archive.metadataDateTimeOriginalList" relation. */
  delete?: InputMaybe<Array<MetadataDateTimeOriginalWhereUniqueInput>>;
  /** Update existing "MetadataDateTimeOriginal" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDateTimeOriginalList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDateTimeOriginalListUpdateInput>>;
  /** Upsert existing "MetadataDateTimeOriginal" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDateTimeOriginalList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDateTimeOriginalListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryAccountListCreateInput = {
  /** Connect existing "MetadataDeliveryAccount" nodes to the new "Archive" node, through the "Archive.metadataDeliveryAccountList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryAccountWhereUniqueInput>>;
  /** Create new "MetadataDeliveryAccount" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryAccountList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryAccountWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryAccountListUpdateInput = {
  /** Connect existing "MetadataDeliveryAccount" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryAccountList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryAccountWhereUniqueInput>>;
  /** Create new "MetadataDeliveryAccount" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryAccountList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryAccountWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryAccount" nodes from the "Archive.metadataDeliveryAccountList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryAccountWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryAccount" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryAccountList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryAccountListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryAccount" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryAccountList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryAccountListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryCompanyListCreateInput = {
  /** Connect existing "MetadataDeliveryCompany" nodes to the new "Archive" node, through the "Archive.metadataDeliveryCompanyList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCompanyWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCompany" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryCompanyList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCompanyWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryCompanyListUpdateInput = {
  /** Connect existing "MetadataDeliveryCompany" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryCompanyList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCompanyWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCompany" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryCompanyList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCompanyWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryCompany" nodes from the "Archive.metadataDeliveryCompanyList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryCompanyWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryCompany" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryCompanyList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryCompanyListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryCompany" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryCompanyList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryCompanyListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryCopyrightListCreateInput = {
  /** Connect existing "MetadataDeliveryCopyright" nodes to the new "Archive" node, through the "Archive.metadataDeliveryCopyrightList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCopyrightWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCopyright" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryCopyrightList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCopyrightWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryCopyrightListUpdateInput = {
  /** Connect existing "MetadataDeliveryCopyright" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryCopyrightList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCopyrightWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCopyright" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryCopyrightList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCopyrightWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryCopyright" nodes from the "Archive.metadataDeliveryCopyrightList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryCopyrightWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryCopyright" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryCopyrightList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryCopyrightListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryCopyright" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryCopyrightList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryCopyrightListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryDateFolderListCreateInput = {
  /** Connect existing "MetadataDeliveryDateFolder" nodes to the new "Archive" node, through the "Archive.metadataDeliveryDateFolderList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateFolder" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryDateFolderList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateFolderWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryDateFolderListUpdateInput = {
  /** Connect existing "MetadataDeliveryDateFolder" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryDateFolderList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateFolder" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDateFolderList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateFolderWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryDateFolder" nodes from the "Archive.metadataDeliveryDateFolderList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDateFolderWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDateFolder" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDateFolderList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryDateFolderListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDateFolder" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDateFolderList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryDateFolderListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryDateTimeListCreateInput = {
  /** Connect existing "MetadataDeliveryDateTime" nodes to the new "Archive" node, through the "Archive.metadataDeliveryDateTimeList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateTimeWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateTime" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryDateTimeList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateTimeWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryDateTimeListUpdateInput = {
  /** Connect existing "MetadataDeliveryDateTime" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryDateTimeList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateTimeWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateTime" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDateTimeList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateTimeWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryDateTime" nodes from the "Archive.metadataDeliveryDateTimeList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDateTimeWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDateTime" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDateTimeList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryDateTimeListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDateTime" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDateTimeList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryDateTimeListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryDcCreatorListCreateInput = {
  /** Connect existing "MetadataDeliveryDcCreator" nodes to the new "Archive" node, through the "Archive.metadataDeliveryDcCreatorList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcCreator" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryDcCreatorList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcCreatorWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryDcCreatorListUpdateInput = {
  /** Connect existing "MetadataDeliveryDcCreator" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryDcCreatorList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcCreator" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDcCreatorList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcCreatorWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryDcCreator" nodes from the "Archive.metadataDeliveryDcCreatorList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDcCreator" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDcCreatorList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryDcCreatorListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDcCreator" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDcCreatorList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryDcCreatorListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryDcRightsListCreateInput = {
  /** Connect existing "MetadataDeliveryDcRights" nodes to the new "Archive" node, through the "Archive.metadataDeliveryDcRightsList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcRightsWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcRights" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryDcRightsList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcRightsWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryDcRightsListUpdateInput = {
  /** Connect existing "MetadataDeliveryDcRights" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryDcRightsList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcRightsWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcRights" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDcRightsList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcRightsWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryDcRights" nodes from the "Archive.metadataDeliveryDcRightsList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDcRightsWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDcRights" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDcRightsList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryDcRightsListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDcRights" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryDcRightsList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryDcRightsListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryFolderListCreateInput = {
  /** Connect existing "MetadataDeliveryFolder" nodes to the new "Archive" node, through the "Archive.metadataDeliveryFolderList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryFolder" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryFolderList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryFolderWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryFolderListUpdateInput = {
  /** Connect existing "MetadataDeliveryFolder" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryFolderList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryFolder" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryFolderList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryFolderWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryFolder" nodes from the "Archive.metadataDeliveryFolderList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryFolderWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryFolder" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryFolderList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryFolderListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryFolder" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryFolderList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryFolderListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryKindListCreateInput = {
  /** Connect existing "MetadataDeliveryKind" nodes to the new "Archive" node, through the "Archive.metadataDeliveryKindList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryKindWhereUniqueInput>>;
  /** Create new "MetadataDeliveryKind" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryKindList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryKindWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryKindListUpdateInput = {
  /** Connect existing "MetadataDeliveryKind" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryKindList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryKindWhereUniqueInput>>;
  /** Create new "MetadataDeliveryKind" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryKindList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryKindWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryKind" nodes from the "Archive.metadataDeliveryKindList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryKindWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryKind" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryKindList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryKindListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryKind" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryKindList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryKindListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryPathListCreateInput = {
  /** Connect existing "MetadataDeliveryPath" nodes to the new "Archive" node, through the "Archive.metadataDeliveryPathList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPathWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPath" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryPathList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPathWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryPathListUpdateInput = {
  /** Connect existing "MetadataDeliveryPath" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryPathList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPathWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPath" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryPathList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPathWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryPath" nodes from the "Archive.metadataDeliveryPathList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryPathWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryPath" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryPathList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryPathListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryPath" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryPathList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryPathListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryPhotoshopCreditListCreateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopCredit" nodes to the new "Archive" node, through the "Archive.metadataDeliveryPhotoshopCreditList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopCredit" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryPhotoshopCreditList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryPhotoshopCreditListUpdateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopCredit" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryPhotoshopCreditList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopCredit" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryPhotoshopCreditList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryPhotoshopCredit" nodes from the "Archive.metadataDeliveryPhotoshopCreditList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryPhotoshopCredit" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryPhotoshopCreditList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryPhotoshopCreditListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryPhotoshopCredit" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryPhotoshopCreditList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryPhotoshopCreditListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryPhotoshopSourceListCreateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopSource" nodes to the new "Archive" node, through the "Archive.metadataDeliveryPhotoshopSourceList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopSource" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryPhotoshopSourceList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryPhotoshopSourceListUpdateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopSource" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryPhotoshopSourceList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopSource" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryPhotoshopSourceList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryPhotoshopSource" nodes from the "Archive.metadataDeliveryPhotoshopSourceList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryPhotoshopSource" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryPhotoshopSourceList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryPhotoshopSourceListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryPhotoshopSource" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryPhotoshopSourceList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryPhotoshopSourceListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryServiceListCreateInput = {
  /** Connect existing "MetadataDeliveryService" nodes to the new "Archive" node, through the "Archive.metadataDeliveryServiceList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryServiceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryService" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryServiceList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryServiceWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryServiceListUpdateInput = {
  /** Connect existing "MetadataDeliveryService" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryServiceList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryServiceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryService" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryServiceList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryServiceWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryService" nodes from the "Archive.metadataDeliveryServiceList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryServiceWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryService" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryServiceList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryServiceListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryService" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryServiceList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryServiceListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliverySubjectListCreateInput = {
  /** Connect existing "MetadataDeliverySubject" nodes to the new "Archive" node, through the "Archive.metadataDeliverySubjectList" relation. */
  connect?: InputMaybe<Array<MetadataDeliverySubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliverySubject" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliverySubjectList" relation. */
  create?: InputMaybe<Array<MetadataDeliverySubjectWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliverySubjectListUpdateInput = {
  /** Connect existing "MetadataDeliverySubject" nodes to the existing "Archive" node, through the "Archive.metadataDeliverySubjectList" relation. */
  connect?: InputMaybe<Array<MetadataDeliverySubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliverySubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliverySubjectList" relation. */
  create?: InputMaybe<Array<MetadataDeliverySubjectWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliverySubject" nodes from the "Archive.metadataDeliverySubjectList" relation. */
  delete?: InputMaybe<Array<MetadataDeliverySubjectWhereUniqueInput>>;
  /** Update existing "MetadataDeliverySubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliverySubjectList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliverySubjectListUpdateInput>>;
  /** Upsert existing "MetadataDeliverySubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliverySubjectList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliverySubjectListUpdateInput>>;
};

export type ArchiveNestedMetadataDeliveryUnderSubjectListCreateInput = {
  /** Connect existing "MetadataDeliveryUnderSubject" nodes to the new "Archive" node, through the "Archive.metadataDeliveryUnderSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliveryUnderSubject" nodes and connect them to the new "Archive" node, through the "Archive.metadataDeliveryUnderSubjectList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryUnderSubjectWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDeliveryUnderSubjectListUpdateInput = {
  /** Connect existing "MetadataDeliveryUnderSubject" nodes to the existing "Archive" node, through the "Archive.metadataDeliveryUnderSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliveryUnderSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryUnderSubjectList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryUnderSubjectWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDeliveryUnderSubject" nodes from the "Archive.metadataDeliveryUnderSubjectList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryUnderSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryUnderSubjectList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDeliveryUnderSubjectListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryUnderSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDeliveryUnderSubjectList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDeliveryUnderSubjectListUpdateInput>>;
};

export type ArchiveNestedMetadataDepartmentListCreateInput = {
  /** Connect existing "MetadataDepartment" nodes to the new "Archive" node, through the "Archive.metadataDepartmentList" relation. */
  connect?: InputMaybe<Array<MetadataDepartmentWhereUniqueInput>>;
  /** Create new "MetadataDepartment" nodes and connect them to the new "Archive" node, through the "Archive.metadataDepartmentList" relation. */
  create?: InputMaybe<Array<MetadataDepartmentWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDepartmentListUpdateInput = {
  /** Connect existing "MetadataDepartment" nodes to the existing "Archive" node, through the "Archive.metadataDepartmentList" relation. */
  connect?: InputMaybe<Array<MetadataDepartmentWhereUniqueInput>>;
  /** Create new "MetadataDepartment" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDepartmentList" relation. */
  create?: InputMaybe<Array<MetadataDepartmentWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDepartment" nodes from the "Archive.metadataDepartmentList" relation. */
  delete?: InputMaybe<Array<MetadataDepartmentWhereUniqueInput>>;
  /** Update existing "MetadataDepartment" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDepartmentList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDepartmentListUpdateInput>>;
  /** Upsert existing "MetadataDepartment" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDepartmentList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDepartmentListUpdateInput>>;
};

export type ArchiveNestedMetadataDescriptionListCreateInput = {
  /** Connect existing "MetadataDescription" nodes to the new "Archive" node, through the "Archive.metadataDescriptionList" relation. */
  connect?: InputMaybe<Array<MetadataDescriptionWhereUniqueInput>>;
  /** Create new "MetadataDescription" nodes and connect them to the new "Archive" node, through the "Archive.metadataDescriptionList" relation. */
  create?: InputMaybe<Array<MetadataDescriptionWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataDescriptionListUpdateInput = {
  /** Connect existing "MetadataDescription" nodes to the existing "Archive" node, through the "Archive.metadataDescriptionList" relation. */
  connect?: InputMaybe<Array<MetadataDescriptionWhereUniqueInput>>;
  /** Create new "MetadataDescription" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDescriptionList" relation. */
  create?: InputMaybe<Array<MetadataDescriptionWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataDescription" nodes from the "Archive.metadataDescriptionList" relation. */
  delete?: InputMaybe<Array<MetadataDescriptionWhereUniqueInput>>;
  /** Update existing "MetadataDescription" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDescriptionList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataDescriptionListUpdateInput>>;
  /** Upsert existing "MetadataDescription" nodes and connect them to the existing "Archive" node, through the "Archive.metadataDescriptionList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataDescriptionListUpdateInput>>;
};

export type ArchiveNestedMetadataEditionListCreateInput = {
  /** Connect existing "MetadataEdition" nodes to the new "Archive" node, through the "Archive.metadataEditionList" relation. */
  connect?: InputMaybe<Array<MetadataEditionWhereUniqueInput>>;
  /** Create new "MetadataEdition" nodes and connect them to the new "Archive" node, through the "Archive.metadataEditionList" relation. */
  create?: InputMaybe<Array<MetadataEditionWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataEditionListUpdateInput = {
  /** Connect existing "MetadataEdition" nodes to the existing "Archive" node, through the "Archive.metadataEditionList" relation. */
  connect?: InputMaybe<Array<MetadataEditionWhereUniqueInput>>;
  /** Create new "MetadataEdition" nodes and connect them to the existing "Archive" node, through the "Archive.metadataEditionList" relation. */
  create?: InputMaybe<Array<MetadataEditionWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataEdition" nodes from the "Archive.metadataEditionList" relation. */
  delete?: InputMaybe<Array<MetadataEditionWhereUniqueInput>>;
  /** Update existing "MetadataEdition" nodes and connect them to the existing "Archive" node, through the "Archive.metadataEditionList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataEditionListUpdateInput>>;
  /** Upsert existing "MetadataEdition" nodes and connect them to the existing "Archive" node, through the "Archive.metadataEditionList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataEditionListUpdateInput>>;
};

export type ArchiveNestedMetadataEditStatusListCreateInput = {
  /** Connect existing "MetadataEditStatus" nodes to the new "Archive" node, through the "Archive.metadataEditStatusList" relation. */
  connect?: InputMaybe<Array<MetadataEditStatusWhereUniqueInput>>;
  /** Create new "MetadataEditStatus" nodes and connect them to the new "Archive" node, through the "Archive.metadataEditStatusList" relation. */
  create?: InputMaybe<Array<MetadataEditStatusWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataEditStatusListUpdateInput = {
  /** Connect existing "MetadataEditStatus" nodes to the existing "Archive" node, through the "Archive.metadataEditStatusList" relation. */
  connect?: InputMaybe<Array<MetadataEditStatusWhereUniqueInput>>;
  /** Create new "MetadataEditStatus" nodes and connect them to the existing "Archive" node, through the "Archive.metadataEditStatusList" relation. */
  create?: InputMaybe<Array<MetadataEditStatusWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataEditStatus" nodes from the "Archive.metadataEditStatusList" relation. */
  delete?: InputMaybe<Array<MetadataEditStatusWhereUniqueInput>>;
  /** Update existing "MetadataEditStatus" nodes and connect them to the existing "Archive" node, through the "Archive.metadataEditStatusList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataEditStatusListUpdateInput>>;
  /** Upsert existing "MetadataEditStatus" nodes and connect them to the existing "Archive" node, through the "Archive.metadataEditStatusList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataEditStatusListUpdateInput>>;
};

export type ArchiveNestedMetadataFileStatusListCreateInput = {
  /** Connect existing "MetadataFileStatus" nodes to the new "Archive" node, through the "Archive.metadataFileStatusList" relation. */
  connect?: InputMaybe<Array<MetadataFileStatusWhereUniqueInput>>;
  /** Create new "MetadataFileStatus" nodes and connect them to the new "Archive" node, through the "Archive.metadataFileStatusList" relation. */
  create?: InputMaybe<Array<MetadataFileStatusWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataFileStatusListUpdateInput = {
  /** Connect existing "MetadataFileStatus" nodes to the existing "Archive" node, through the "Archive.metadataFileStatusList" relation. */
  connect?: InputMaybe<Array<MetadataFileStatusWhereUniqueInput>>;
  /** Create new "MetadataFileStatus" nodes and connect them to the existing "Archive" node, through the "Archive.metadataFileStatusList" relation. */
  create?: InputMaybe<Array<MetadataFileStatusWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataFileStatus" nodes from the "Archive.metadataFileStatusList" relation. */
  delete?: InputMaybe<Array<MetadataFileStatusWhereUniqueInput>>;
  /** Update existing "MetadataFileStatus" nodes and connect them to the existing "Archive" node, through the "Archive.metadataFileStatusList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataFileStatusListUpdateInput>>;
  /** Upsert existing "MetadataFileStatus" nodes and connect them to the existing "Archive" node, through the "Archive.metadataFileStatusList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataFileStatusListUpdateInput>>;
};

export type ArchiveNestedMetadataFormatListCreateInput = {
  /** Connect existing "MetadataFormat" nodes to the new "Archive" node, through the "Archive.metadataFormatList" relation. */
  connect?: InputMaybe<Array<MetadataFormatWhereUniqueInput>>;
  /** Create new "MetadataFormat" nodes and connect them to the new "Archive" node, through the "Archive.metadataFormatList" relation. */
  create?: InputMaybe<Array<MetadataFormatWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataFormatListUpdateInput = {
  /** Connect existing "MetadataFormat" nodes to the existing "Archive" node, through the "Archive.metadataFormatList" relation. */
  connect?: InputMaybe<Array<MetadataFormatWhereUniqueInput>>;
  /** Create new "MetadataFormat" nodes and connect them to the existing "Archive" node, through the "Archive.metadataFormatList" relation. */
  create?: InputMaybe<Array<MetadataFormatWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataFormat" nodes from the "Archive.metadataFormatList" relation. */
  delete?: InputMaybe<Array<MetadataFormatWhereUniqueInput>>;
  /** Update existing "MetadataFormat" nodes and connect them to the existing "Archive" node, through the "Archive.metadataFormatList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataFormatListUpdateInput>>;
  /** Upsert existing "MetadataFormat" nodes and connect them to the existing "Archive" node, through the "Archive.metadataFormatList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataFormatListUpdateInput>>;
};

export type ArchiveNestedMetadataHeaderListCreateInput = {
  /** Connect existing "MetadataHeader" nodes to the new "Archive" node, through the "Archive.metadataHeaderList" relation. */
  connect?: InputMaybe<Array<MetadataHeaderWhereUniqueInput>>;
  /** Create new "MetadataHeader" nodes and connect them to the new "Archive" node, through the "Archive.metadataHeaderList" relation. */
  create?: InputMaybe<Array<MetadataHeaderWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataHeaderListUpdateInput = {
  /** Connect existing "MetadataHeader" nodes to the existing "Archive" node, through the "Archive.metadataHeaderList" relation. */
  connect?: InputMaybe<Array<MetadataHeaderWhereUniqueInput>>;
  /** Create new "MetadataHeader" nodes and connect them to the existing "Archive" node, through the "Archive.metadataHeaderList" relation. */
  create?: InputMaybe<Array<MetadataHeaderWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataHeader" nodes from the "Archive.metadataHeaderList" relation. */
  delete?: InputMaybe<Array<MetadataHeaderWhereUniqueInput>>;
  /** Update existing "MetadataHeader" nodes and connect them to the existing "Archive" node, through the "Archive.metadataHeaderList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataHeaderListUpdateInput>>;
  /** Upsert existing "MetadataHeader" nodes and connect them to the existing "Archive" node, through the "Archive.metadataHeaderList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataHeaderListUpdateInput>>;
};

export type ArchiveNestedMetadataHeaderPrismaListCreateInput = {
  /** Connect existing "MetadataHeaderPrisma" nodes to the new "Archive" node, through the "Archive.metadataHeaderPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataHeaderPrismaWhereUniqueInput>>;
  /** Create new "MetadataHeaderPrisma" nodes and connect them to the new "Archive" node, through the "Archive.metadataHeaderPrismaList" relation. */
  create?: InputMaybe<Array<MetadataHeaderPrismaWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataHeaderPrismaListUpdateInput = {
  /** Connect existing "MetadataHeaderPrisma" nodes to the existing "Archive" node, through the "Archive.metadataHeaderPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataHeaderPrismaWhereUniqueInput>>;
  /** Create new "MetadataHeaderPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataHeaderPrismaList" relation. */
  create?: InputMaybe<Array<MetadataHeaderPrismaWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataHeaderPrisma" nodes from the "Archive.metadataHeaderPrismaList" relation. */
  delete?: InputMaybe<Array<MetadataHeaderPrismaWhereUniqueInput>>;
  /** Update existing "MetadataHeaderPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataHeaderPrismaList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataHeaderPrismaListUpdateInput>>;
  /** Upsert existing "MetadataHeaderPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataHeaderPrismaList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataHeaderPrismaListUpdateInput>>;
};

export type ArchiveNestedMetadataHeadlineListCreateInput = {
  /** Connect existing "MetadataHeadline" nodes to the new "Archive" node, through the "Archive.metadataHeadlineList" relation. */
  connect?: InputMaybe<Array<MetadataHeadlineWhereUniqueInput>>;
  /** Create new "MetadataHeadline" nodes and connect them to the new "Archive" node, through the "Archive.metadataHeadlineList" relation. */
  create?: InputMaybe<Array<MetadataHeadlineWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataHeadlineListUpdateInput = {
  /** Connect existing "MetadataHeadline" nodes to the existing "Archive" node, through the "Archive.metadataHeadlineList" relation. */
  connect?: InputMaybe<Array<MetadataHeadlineWhereUniqueInput>>;
  /** Create new "MetadataHeadline" nodes and connect them to the existing "Archive" node, through the "Archive.metadataHeadlineList" relation. */
  create?: InputMaybe<Array<MetadataHeadlineWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataHeadline" nodes from the "Archive.metadataHeadlineList" relation. */
  delete?: InputMaybe<Array<MetadataHeadlineWhereUniqueInput>>;
  /** Update existing "MetadataHeadline" nodes and connect them to the existing "Archive" node, through the "Archive.metadataHeadlineList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataHeadlineListUpdateInput>>;
  /** Upsert existing "MetadataHeadline" nodes and connect them to the existing "Archive" node, through the "Archive.metadataHeadlineList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataHeadlineListUpdateInput>>;
};

export type ArchiveNestedMetadataIdAssignmentListCreateInput = {
  /** Connect existing "MetadataIdAssignment" nodes to the new "Archive" node, through the "Archive.metadataIdAssignmentList" relation. */
  connect?: InputMaybe<Array<MetadataIdAssignmentWhereUniqueInput>>;
  /** Create new "MetadataIdAssignment" nodes and connect them to the new "Archive" node, through the "Archive.metadataIdAssignmentList" relation. */
  create?: InputMaybe<Array<MetadataIdAssignmentWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataIdAssignmentListUpdateInput = {
  /** Connect existing "MetadataIdAssignment" nodes to the existing "Archive" node, through the "Archive.metadataIdAssignmentList" relation. */
  connect?: InputMaybe<Array<MetadataIdAssignmentWhereUniqueInput>>;
  /** Create new "MetadataIdAssignment" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIdAssignmentList" relation. */
  create?: InputMaybe<Array<MetadataIdAssignmentWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataIdAssignment" nodes from the "Archive.metadataIdAssignmentList" relation. */
  delete?: InputMaybe<Array<MetadataIdAssignmentWhereUniqueInput>>;
  /** Update existing "MetadataIdAssignment" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIdAssignmentList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataIdAssignmentListUpdateInput>>;
  /** Upsert existing "MetadataIdAssignment" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIdAssignmentList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataIdAssignmentListUpdateInput>>;
};

export type ArchiveNestedMetadataIdPhotoPrismaListCreateInput = {
  /** Connect existing "MetadataIdPhotoPrisma" nodes to the new "Archive" node, through the "Archive.metadataIdPhotoPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataIdPhotoPrismaWhereUniqueInput>>;
  /** Create new "MetadataIdPhotoPrisma" nodes and connect them to the new "Archive" node, through the "Archive.metadataIdPhotoPrismaList" relation. */
  create?: InputMaybe<Array<MetadataIdPhotoPrismaWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataIdPhotoPrismaListUpdateInput = {
  /** Connect existing "MetadataIdPhotoPrisma" nodes to the existing "Archive" node, through the "Archive.metadataIdPhotoPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataIdPhotoPrismaWhereUniqueInput>>;
  /** Create new "MetadataIdPhotoPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIdPhotoPrismaList" relation. */
  create?: InputMaybe<Array<MetadataIdPhotoPrismaWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataIdPhotoPrisma" nodes from the "Archive.metadataIdPhotoPrismaList" relation. */
  delete?: InputMaybe<Array<MetadataIdPhotoPrismaWhereUniqueInput>>;
  /** Update existing "MetadataIdPhotoPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIdPhotoPrismaList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataIdPhotoPrismaListUpdateInput>>;
  /** Upsert existing "MetadataIdPhotoPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIdPhotoPrismaList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataIdPhotoPrismaListUpdateInput>>;
};

export type ArchiveNestedMetadataIdSubjectListCreateInput = {
  /** Connect existing "MetadataIdSubject" nodes to the new "Archive" node, through the "Archive.metadataIdSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataIdSubjectWhereUniqueInput>>;
  /** Create new "MetadataIdSubject" nodes and connect them to the new "Archive" node, through the "Archive.metadataIdSubjectList" relation. */
  create?: InputMaybe<Array<MetadataIdSubjectWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataIdSubjectListUpdateInput = {
  /** Connect existing "MetadataIdSubject" nodes to the existing "Archive" node, through the "Archive.metadataIdSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataIdSubjectWhereUniqueInput>>;
  /** Create new "MetadataIdSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIdSubjectList" relation. */
  create?: InputMaybe<Array<MetadataIdSubjectWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataIdSubject" nodes from the "Archive.metadataIdSubjectList" relation. */
  delete?: InputMaybe<Array<MetadataIdSubjectWhereUniqueInput>>;
  /** Update existing "MetadataIdSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIdSubjectList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataIdSubjectListUpdateInput>>;
  /** Upsert existing "MetadataIdSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIdSubjectList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataIdSubjectListUpdateInput>>;
};

export type ArchiveNestedMetadataImageNotesListCreateInput = {
  /** Connect existing "MetadataImageNotes" nodes to the new "Archive" node, through the "Archive.metadataImageNotesList" relation. */
  connect?: InputMaybe<Array<MetadataImageNotesWhereUniqueInput>>;
  /** Create new "MetadataImageNotes" nodes and connect them to the new "Archive" node, through the "Archive.metadataImageNotesList" relation. */
  create?: InputMaybe<Array<MetadataImageNotesWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataImageNotesListUpdateInput = {
  /** Connect existing "MetadataImageNotes" nodes to the existing "Archive" node, through the "Archive.metadataImageNotesList" relation. */
  connect?: InputMaybe<Array<MetadataImageNotesWhereUniqueInput>>;
  /** Create new "MetadataImageNotes" nodes and connect them to the existing "Archive" node, through the "Archive.metadataImageNotesList" relation. */
  create?: InputMaybe<Array<MetadataImageNotesWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataImageNotes" nodes from the "Archive.metadataImageNotesList" relation. */
  delete?: InputMaybe<Array<MetadataImageNotesWhereUniqueInput>>;
  /** Update existing "MetadataImageNotes" nodes and connect them to the existing "Archive" node, through the "Archive.metadataImageNotesList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataImageNotesListUpdateInput>>;
  /** Upsert existing "MetadataImageNotes" nodes and connect them to the existing "Archive" node, through the "Archive.metadataImageNotesList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataImageNotesListUpdateInput>>;
};

export type ArchiveNestedMetadataInstructionsListCreateInput = {
  /** Connect existing "MetadataInstructions" nodes to the new "Archive" node, through the "Archive.metadataInstructionsList" relation. */
  connect?: InputMaybe<Array<MetadataInstructionsWhereUniqueInput>>;
  /** Create new "MetadataInstructions" nodes and connect them to the new "Archive" node, through the "Archive.metadataInstructionsList" relation. */
  create?: InputMaybe<Array<MetadataInstructionsWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataInstructionsListUpdateInput = {
  /** Connect existing "MetadataInstructions" nodes to the existing "Archive" node, through the "Archive.metadataInstructionsList" relation. */
  connect?: InputMaybe<Array<MetadataInstructionsWhereUniqueInput>>;
  /** Create new "MetadataInstructions" nodes and connect them to the existing "Archive" node, through the "Archive.metadataInstructionsList" relation. */
  create?: InputMaybe<Array<MetadataInstructionsWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataInstructions" nodes from the "Archive.metadataInstructionsList" relation. */
  delete?: InputMaybe<Array<MetadataInstructionsWhereUniqueInput>>;
  /** Update existing "MetadataInstructions" nodes and connect them to the existing "Archive" node, through the "Archive.metadataInstructionsList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataInstructionsListUpdateInput>>;
  /** Upsert existing "MetadataInstructions" nodes and connect them to the existing "Archive" node, through the "Archive.metadataInstructionsList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataInstructionsListUpdateInput>>;
};

export type ArchiveNestedMetadataIssueListCreateInput = {
  /** Connect existing "MetadataIssue" nodes to the new "Archive" node, through the "Archive.metadataIssueList" relation. */
  connect?: InputMaybe<Array<MetadataIssueWhereUniqueInput>>;
  /** Create new "MetadataIssue" nodes and connect them to the new "Archive" node, through the "Archive.metadataIssueList" relation. */
  create?: InputMaybe<Array<MetadataIssueWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataIssueListUpdateInput = {
  /** Connect existing "MetadataIssue" nodes to the existing "Archive" node, through the "Archive.metadataIssueList" relation. */
  connect?: InputMaybe<Array<MetadataIssueWhereUniqueInput>>;
  /** Create new "MetadataIssue" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIssueList" relation. */
  create?: InputMaybe<Array<MetadataIssueWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataIssue" nodes from the "Archive.metadataIssueList" relation. */
  delete?: InputMaybe<Array<MetadataIssueWhereUniqueInput>>;
  /** Update existing "MetadataIssue" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIssueList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataIssueListUpdateInput>>;
  /** Upsert existing "MetadataIssue" nodes and connect them to the existing "Archive" node, through the "Archive.metadataIssueList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataIssueListUpdateInput>>;
};

export type ArchiveNestedMetadataKeywordsListCreateInput = {
  /** Connect existing "MetadataKeywords" nodes to the new "Archive" node, through the "Archive.metadataKeywordsList" relation. */
  connect?: InputMaybe<Array<MetadataKeywordsWhereUniqueInput>>;
  /** Create new "MetadataKeywords" nodes and connect them to the new "Archive" node, through the "Archive.metadataKeywordsList" relation. */
  create?: InputMaybe<Array<MetadataKeywordsWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataKeywordsListUpdateInput = {
  /** Connect existing "MetadataKeywords" nodes to the existing "Archive" node, through the "Archive.metadataKeywordsList" relation. */
  connect?: InputMaybe<Array<MetadataKeywordsWhereUniqueInput>>;
  /** Create new "MetadataKeywords" nodes and connect them to the existing "Archive" node, through the "Archive.metadataKeywordsList" relation. */
  create?: InputMaybe<Array<MetadataKeywordsWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataKeywords" nodes from the "Archive.metadataKeywordsList" relation. */
  delete?: InputMaybe<Array<MetadataKeywordsWhereUniqueInput>>;
  /** Update existing "MetadataKeywords" nodes and connect them to the existing "Archive" node, through the "Archive.metadataKeywordsList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataKeywordsListUpdateInput>>;
  /** Upsert existing "MetadataKeywords" nodes and connect them to the existing "Archive" node, through the "Archive.metadataKeywordsList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataKeywordsListUpdateInput>>;
};

export type ArchiveNestedMetadataObjectNameListCreateInput = {
  /** Connect existing "MetadataObjectName" nodes to the new "Archive" node, through the "Archive.metadataObjectNameList" relation. */
  connect?: InputMaybe<Array<MetadataObjectNameWhereUniqueInput>>;
  /** Create new "MetadataObjectName" nodes and connect them to the new "Archive" node, through the "Archive.metadataObjectNameList" relation. */
  create?: InputMaybe<Array<MetadataObjectNameWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataObjectNameListUpdateInput = {
  /** Connect existing "MetadataObjectName" nodes to the existing "Archive" node, through the "Archive.metadataObjectNameList" relation. */
  connect?: InputMaybe<Array<MetadataObjectNameWhereUniqueInput>>;
  /** Create new "MetadataObjectName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataObjectNameList" relation. */
  create?: InputMaybe<Array<MetadataObjectNameWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataObjectName" nodes from the "Archive.metadataObjectNameList" relation. */
  delete?: InputMaybe<Array<MetadataObjectNameWhereUniqueInput>>;
  /** Update existing "MetadataObjectName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataObjectNameList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataObjectNameListUpdateInput>>;
  /** Upsert existing "MetadataObjectName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataObjectNameList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataObjectNameListUpdateInput>>;
};

export type ArchiveNestedMetadataOriginalNameListCreateInput = {
  /** Connect existing "MetadataOriginalName" nodes to the new "Archive" node, through the "Archive.metadataOriginalNameList" relation. */
  connect?: InputMaybe<Array<MetadataOriginalNameWhereUniqueInput>>;
  /** Create new "MetadataOriginalName" nodes and connect them to the new "Archive" node, through the "Archive.metadataOriginalNameList" relation. */
  create?: InputMaybe<Array<MetadataOriginalNameWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataOriginalNameListUpdateInput = {
  /** Connect existing "MetadataOriginalName" nodes to the existing "Archive" node, through the "Archive.metadataOriginalNameList" relation. */
  connect?: InputMaybe<Array<MetadataOriginalNameWhereUniqueInput>>;
  /** Create new "MetadataOriginalName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataOriginalNameList" relation. */
  create?: InputMaybe<Array<MetadataOriginalNameWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataOriginalName" nodes from the "Archive.metadataOriginalNameList" relation. */
  delete?: InputMaybe<Array<MetadataOriginalNameWhereUniqueInput>>;
  /** Update existing "MetadataOriginalName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataOriginalNameList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataOriginalNameListUpdateInput>>;
  /** Upsert existing "MetadataOriginalName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataOriginalNameList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataOriginalNameListUpdateInput>>;
};

export type ArchiveNestedMetadataPriceLevelListCreateInput = {
  /** Connect existing "MetadataPriceLevel" nodes to the new "Archive" node, through the "Archive.metadataPriceLevelList" relation. */
  connect?: InputMaybe<Array<MetadataPriceLevelWhereUniqueInput>>;
  /** Create new "MetadataPriceLevel" nodes and connect them to the new "Archive" node, through the "Archive.metadataPriceLevelList" relation. */
  create?: InputMaybe<Array<MetadataPriceLevelWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataPriceLevelListUpdateInput = {
  /** Connect existing "MetadataPriceLevel" nodes to the existing "Archive" node, through the "Archive.metadataPriceLevelList" relation. */
  connect?: InputMaybe<Array<MetadataPriceLevelWhereUniqueInput>>;
  /** Create new "MetadataPriceLevel" nodes and connect them to the existing "Archive" node, through the "Archive.metadataPriceLevelList" relation. */
  create?: InputMaybe<Array<MetadataPriceLevelWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataPriceLevel" nodes from the "Archive.metadataPriceLevelList" relation. */
  delete?: InputMaybe<Array<MetadataPriceLevelWhereUniqueInput>>;
  /** Update existing "MetadataPriceLevel" nodes and connect them to the existing "Archive" node, through the "Archive.metadataPriceLevelList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataPriceLevelListUpdateInput>>;
  /** Upsert existing "MetadataPriceLevel" nodes and connect them to the existing "Archive" node, through the "Archive.metadataPriceLevelList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataPriceLevelListUpdateInput>>;
};

export type ArchiveNestedMetadataProcessHistoryListCreateInput = {
  /** Connect existing "MetadataProcessHistory" nodes to the new "Archive" node, through the "Archive.metadataProcessHistoryList" relation. */
  connect?: InputMaybe<Array<MetadataProcessHistoryWhereUniqueInput>>;
  /** Create new "MetadataProcessHistory" nodes and connect them to the new "Archive" node, through the "Archive.metadataProcessHistoryList" relation. */
  create?: InputMaybe<Array<MetadataProcessHistoryWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataProcessHistoryListUpdateInput = {
  /** Connect existing "MetadataProcessHistory" nodes to the existing "Archive" node, through the "Archive.metadataProcessHistoryList" relation. */
  connect?: InputMaybe<Array<MetadataProcessHistoryWhereUniqueInput>>;
  /** Create new "MetadataProcessHistory" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProcessHistoryList" relation. */
  create?: InputMaybe<Array<MetadataProcessHistoryWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataProcessHistory" nodes from the "Archive.metadataProcessHistoryList" relation. */
  delete?: InputMaybe<Array<MetadataProcessHistoryWhereUniqueInput>>;
  /** Update existing "MetadataProcessHistory" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProcessHistoryList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataProcessHistoryListUpdateInput>>;
  /** Upsert existing "MetadataProcessHistory" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProcessHistoryList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataProcessHistoryListUpdateInput>>;
};

export type ArchiveNestedMetadataProcessStatusListCreateInput = {
  /** Connect existing "MetadataProcessStatus" nodes to the new "Archive" node, through the "Archive.metadataProcessStatusList" relation. */
  connect?: InputMaybe<Array<MetadataProcessStatusWhereUniqueInput>>;
  /** Create new "MetadataProcessStatus" nodes and connect them to the new "Archive" node, through the "Archive.metadataProcessStatusList" relation. */
  create?: InputMaybe<Array<MetadataProcessStatusWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataProcessStatusListUpdateInput = {
  /** Connect existing "MetadataProcessStatus" nodes to the existing "Archive" node, through the "Archive.metadataProcessStatusList" relation. */
  connect?: InputMaybe<Array<MetadataProcessStatusWhereUniqueInput>>;
  /** Create new "MetadataProcessStatus" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProcessStatusList" relation. */
  create?: InputMaybe<Array<MetadataProcessStatusWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataProcessStatus" nodes from the "Archive.metadataProcessStatusList" relation. */
  delete?: InputMaybe<Array<MetadataProcessStatusWhereUniqueInput>>;
  /** Update existing "MetadataProcessStatus" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProcessStatusList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataProcessStatusListUpdateInput>>;
  /** Upsert existing "MetadataProcessStatus" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProcessStatusList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataProcessStatusListUpdateInput>>;
};

export type ArchiveNestedMetadataProductListCreateInput = {
  /** Connect existing "MetadataProduct" nodes to the new "Archive" node, through the "Archive.metadataProductList" relation. */
  connect?: InputMaybe<Array<MetadataProductWhereUniqueInput>>;
  /** Create new "MetadataProduct" nodes and connect them to the new "Archive" node, through the "Archive.metadataProductList" relation. */
  create?: InputMaybe<Array<MetadataProductWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataProductListUpdateInput = {
  /** Connect existing "MetadataProduct" nodes to the existing "Archive" node, through the "Archive.metadataProductList" relation. */
  connect?: InputMaybe<Array<MetadataProductWhereUniqueInput>>;
  /** Create new "MetadataProduct" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProductList" relation. */
  create?: InputMaybe<Array<MetadataProductWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataProduct" nodes from the "Archive.metadataProductList" relation. */
  delete?: InputMaybe<Array<MetadataProductWhereUniqueInput>>;
  /** Update existing "MetadataProduct" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProductList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataProductListUpdateInput>>;
  /** Upsert existing "MetadataProduct" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProductList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataProductListUpdateInput>>;
};

export type ArchiveNestedMetadataProductsListCreateInput = {
  /** Connect existing "MetadataProducts" nodes to the new "Archive" node, through the "Archive.metadataProductsList" relation. */
  connect?: InputMaybe<Array<MetadataProductsWhereUniqueInput>>;
  /** Create new "MetadataProducts" nodes and connect them to the new "Archive" node, through the "Archive.metadataProductsList" relation. */
  create?: InputMaybe<Array<MetadataProductsWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataProductsListUpdateInput = {
  /** Connect existing "MetadataProducts" nodes to the existing "Archive" node, through the "Archive.metadataProductsList" relation. */
  connect?: InputMaybe<Array<MetadataProductsWhereUniqueInput>>;
  /** Create new "MetadataProducts" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProductsList" relation. */
  create?: InputMaybe<Array<MetadataProductsWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataProducts" nodes from the "Archive.metadataProductsList" relation. */
  delete?: InputMaybe<Array<MetadataProductsWhereUniqueInput>>;
  /** Update existing "MetadataProducts" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProductsList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataProductsListUpdateInput>>;
  /** Upsert existing "MetadataProducts" nodes and connect them to the existing "Archive" node, through the "Archive.metadataProductsList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataProductsListUpdateInput>>;
};

export type ArchiveNestedMetadataPublishingSubjectListCreateInput = {
  /** Connect existing "MetadataPublishingSubject" nodes to the new "Archive" node, through the "Archive.metadataPublishingSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataPublishingSubjectWhereUniqueInput>>;
  /** Create new "MetadataPublishingSubject" nodes and connect them to the new "Archive" node, through the "Archive.metadataPublishingSubjectList" relation. */
  create?: InputMaybe<Array<MetadataPublishingSubjectWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataPublishingSubjectListUpdateInput = {
  /** Connect existing "MetadataPublishingSubject" nodes to the existing "Archive" node, through the "Archive.metadataPublishingSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataPublishingSubjectWhereUniqueInput>>;
  /** Create new "MetadataPublishingSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataPublishingSubjectList" relation. */
  create?: InputMaybe<Array<MetadataPublishingSubjectWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataPublishingSubject" nodes from the "Archive.metadataPublishingSubjectList" relation. */
  delete?: InputMaybe<Array<MetadataPublishingSubjectWhereUniqueInput>>;
  /** Update existing "MetadataPublishingSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataPublishingSubjectList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataPublishingSubjectListUpdateInput>>;
  /** Upsert existing "MetadataPublishingSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataPublishingSubjectList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataPublishingSubjectListUpdateInput>>;
};

export type ArchiveNestedMetadataResolutionKindListCreateInput = {
  /** Connect existing "MetadataResolutionKind" nodes to the new "Archive" node, through the "Archive.metadataResolutionKindList" relation. */
  connect?: InputMaybe<Array<MetadataResolutionKindWhereUniqueInput>>;
  /** Create new "MetadataResolutionKind" nodes and connect them to the new "Archive" node, through the "Archive.metadataResolutionKindList" relation. */
  create?: InputMaybe<Array<MetadataResolutionKindWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataResolutionKindListUpdateInput = {
  /** Connect existing "MetadataResolutionKind" nodes to the existing "Archive" node, through the "Archive.metadataResolutionKindList" relation. */
  connect?: InputMaybe<Array<MetadataResolutionKindWhereUniqueInput>>;
  /** Create new "MetadataResolutionKind" nodes and connect them to the existing "Archive" node, through the "Archive.metadataResolutionKindList" relation. */
  create?: InputMaybe<Array<MetadataResolutionKindWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataResolutionKind" nodes from the "Archive.metadataResolutionKindList" relation. */
  delete?: InputMaybe<Array<MetadataResolutionKindWhereUniqueInput>>;
  /** Update existing "MetadataResolutionKind" nodes and connect them to the existing "Archive" node, through the "Archive.metadataResolutionKindList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataResolutionKindListUpdateInput>>;
  /** Upsert existing "MetadataResolutionKind" nodes and connect them to the existing "Archive" node, through the "Archive.metadataResolutionKindList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataResolutionKindListUpdateInput>>;
};

export type ArchiveNestedMetadataRightsListCreateInput = {
  /** Connect existing "MetadataRights" nodes to the new "Archive" node, through the "Archive.metadataRightsList" relation. */
  connect?: InputMaybe<Array<MetadataRightsWhereUniqueInput>>;
  /** Create new "MetadataRights" nodes and connect them to the new "Archive" node, through the "Archive.metadataRightsList" relation. */
  create?: InputMaybe<Array<MetadataRightsWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataRightsListUpdateInput = {
  /** Connect existing "MetadataRights" nodes to the existing "Archive" node, through the "Archive.metadataRightsList" relation. */
  connect?: InputMaybe<Array<MetadataRightsWhereUniqueInput>>;
  /** Create new "MetadataRights" nodes and connect them to the existing "Archive" node, through the "Archive.metadataRightsList" relation. */
  create?: InputMaybe<Array<MetadataRightsWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataRights" nodes from the "Archive.metadataRightsList" relation. */
  delete?: InputMaybe<Array<MetadataRightsWhereUniqueInput>>;
  /** Update existing "MetadataRights" nodes and connect them to the existing "Archive" node, through the "Archive.metadataRightsList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataRightsListUpdateInput>>;
  /** Upsert existing "MetadataRights" nodes and connect them to the existing "Archive" node, through the "Archive.metadataRightsList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataRightsListUpdateInput>>;
};

export type ArchiveNestedMetadataSourceListCreateInput = {
  /** Connect existing "MetadataSource" nodes to the new "Archive" node, through the "Archive.metadataSourceList" relation. */
  connect?: InputMaybe<Array<MetadataSourceWhereUniqueInput>>;
  /** Create new "MetadataSource" nodes and connect them to the new "Archive" node, through the "Archive.metadataSourceList" relation. */
  create?: InputMaybe<Array<MetadataSourceWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataSourceListUpdateInput = {
  /** Connect existing "MetadataSource" nodes to the existing "Archive" node, through the "Archive.metadataSourceList" relation. */
  connect?: InputMaybe<Array<MetadataSourceWhereUniqueInput>>;
  /** Create new "MetadataSource" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSourceList" relation. */
  create?: InputMaybe<Array<MetadataSourceWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataSource" nodes from the "Archive.metadataSourceList" relation. */
  delete?: InputMaybe<Array<MetadataSourceWhereUniqueInput>>;
  /** Update existing "MetadataSource" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSourceList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataSourceListUpdateInput>>;
  /** Upsert existing "MetadataSource" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSourceList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataSourceListUpdateInput>>;
};

export type ArchiveNestedMetadataSpecialInstructionsListCreateInput = {
  /** Connect existing "MetadataSpecialInstructions" nodes to the new "Archive" node, through the "Archive.metadataSpecialInstructionsList" relation. */
  connect?: InputMaybe<Array<MetadataSpecialInstructionsWhereUniqueInput>>;
  /** Create new "MetadataSpecialInstructions" nodes and connect them to the new "Archive" node, through the "Archive.metadataSpecialInstructionsList" relation. */
  create?: InputMaybe<Array<MetadataSpecialInstructionsWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataSpecialInstructionsListUpdateInput = {
  /** Connect existing "MetadataSpecialInstructions" nodes to the existing "Archive" node, through the "Archive.metadataSpecialInstructionsList" relation. */
  connect?: InputMaybe<Array<MetadataSpecialInstructionsWhereUniqueInput>>;
  /** Create new "MetadataSpecialInstructions" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSpecialInstructionsList" relation. */
  create?: InputMaybe<Array<MetadataSpecialInstructionsWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataSpecialInstructions" nodes from the "Archive.metadataSpecialInstructionsList" relation. */
  delete?: InputMaybe<Array<MetadataSpecialInstructionsWhereUniqueInput>>;
  /** Update existing "MetadataSpecialInstructions" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSpecialInstructionsList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataSpecialInstructionsListUpdateInput>>;
  /** Upsert existing "MetadataSpecialInstructions" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSpecialInstructionsList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataSpecialInstructionsListUpdateInput>>;
};

export type ArchiveNestedMetadataSubjectCodeListCreateInput = {
  /** Connect existing "MetadataSubjectCode" nodes to the new "Archive" node, through the "Archive.metadataSubjectCodeList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectCodeWhereUniqueInput>>;
  /** Create new "MetadataSubjectCode" nodes and connect them to the new "Archive" node, through the "Archive.metadataSubjectCodeList" relation. */
  create?: InputMaybe<Array<MetadataSubjectCodeWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataSubjectCodeListUpdateInput = {
  /** Connect existing "MetadataSubjectCode" nodes to the existing "Archive" node, through the "Archive.metadataSubjectCodeList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectCodeWhereUniqueInput>>;
  /** Create new "MetadataSubjectCode" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSubjectCodeList" relation. */
  create?: InputMaybe<Array<MetadataSubjectCodeWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataSubjectCode" nodes from the "Archive.metadataSubjectCodeList" relation. */
  delete?: InputMaybe<Array<MetadataSubjectCodeWhereUniqueInput>>;
  /** Update existing "MetadataSubjectCode" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSubjectCodeList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataSubjectCodeListUpdateInput>>;
  /** Upsert existing "MetadataSubjectCode" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSubjectCodeList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataSubjectCodeListUpdateInput>>;
};

export type ArchiveNestedMetadataSubjectListCreateInput = {
  /** Connect existing "MetadataSubject" nodes to the new "Archive" node, through the "Archive.metadataSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectWhereUniqueInput>>;
  /** Create new "MetadataSubject" nodes and connect them to the new "Archive" node, through the "Archive.metadataSubjectList" relation. */
  create?: InputMaybe<Array<MetadataSubjectWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataSubjectListUpdateInput = {
  /** Connect existing "MetadataSubject" nodes to the existing "Archive" node, through the "Archive.metadataSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectWhereUniqueInput>>;
  /** Create new "MetadataSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSubjectList" relation. */
  create?: InputMaybe<Array<MetadataSubjectWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataSubject" nodes from the "Archive.metadataSubjectList" relation. */
  delete?: InputMaybe<Array<MetadataSubjectWhereUniqueInput>>;
  /** Update existing "MetadataSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSubjectList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataSubjectListUpdateInput>>;
  /** Upsert existing "MetadataSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSubjectList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataSubjectListUpdateInput>>;
};

export type ArchiveNestedMetadataSubjectPrismaListCreateInput = {
  /** Connect existing "MetadataSubjectPrisma" nodes to the new "Archive" node, through the "Archive.metadataSubjectPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectPrismaWhereUniqueInput>>;
  /** Create new "MetadataSubjectPrisma" nodes and connect them to the new "Archive" node, through the "Archive.metadataSubjectPrismaList" relation. */
  create?: InputMaybe<Array<MetadataSubjectPrismaWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataSubjectPrismaListUpdateInput = {
  /** Connect existing "MetadataSubjectPrisma" nodes to the existing "Archive" node, through the "Archive.metadataSubjectPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectPrismaWhereUniqueInput>>;
  /** Create new "MetadataSubjectPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSubjectPrismaList" relation. */
  create?: InputMaybe<Array<MetadataSubjectPrismaWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataSubjectPrisma" nodes from the "Archive.metadataSubjectPrismaList" relation. */
  delete?: InputMaybe<Array<MetadataSubjectPrismaWhereUniqueInput>>;
  /** Update existing "MetadataSubjectPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSubjectPrismaList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataSubjectPrismaListUpdateInput>>;
  /** Upsert existing "MetadataSubjectPrisma" nodes and connect them to the existing "Archive" node, through the "Archive.metadataSubjectPrismaList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataSubjectPrismaListUpdateInput>>;
};

export type ArchiveNestedMetadataTitleListCreateInput = {
  /** Connect existing "MetadataTitle" nodes to the new "Archive" node, through the "Archive.metadataTitleList" relation. */
  connect?: InputMaybe<Array<MetadataTitleWhereUniqueInput>>;
  /** Create new "MetadataTitle" nodes and connect them to the new "Archive" node, through the "Archive.metadataTitleList" relation. */
  create?: InputMaybe<Array<MetadataTitleWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataTitleListUpdateInput = {
  /** Connect existing "MetadataTitle" nodes to the existing "Archive" node, through the "Archive.metadataTitleList" relation. */
  connect?: InputMaybe<Array<MetadataTitleWhereUniqueInput>>;
  /** Create new "MetadataTitle" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTitleList" relation. */
  create?: InputMaybe<Array<MetadataTitleWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataTitle" nodes from the "Archive.metadataTitleList" relation. */
  delete?: InputMaybe<Array<MetadataTitleWhereUniqueInput>>;
  /** Update existing "MetadataTitle" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTitleList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataTitleListUpdateInput>>;
  /** Upsert existing "MetadataTitle" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTitleList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataTitleListUpdateInput>>;
};

export type ArchiveNestedMetadataTransferredByFullNameListCreateInput = {
  /** Connect existing "MetadataTransferredByFullName" nodes to the new "Archive" node, through the "Archive.metadataTransferredByFullNameList" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByFullNameWhereUniqueInput>>;
  /** Create new "MetadataTransferredByFullName" nodes and connect them to the new "Archive" node, through the "Archive.metadataTransferredByFullNameList" relation. */
  create?: InputMaybe<Array<MetadataTransferredByFullNameWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataTransferredByFullNameListUpdateInput = {
  /** Connect existing "MetadataTransferredByFullName" nodes to the existing "Archive" node, through the "Archive.metadataTransferredByFullNameList" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByFullNameWhereUniqueInput>>;
  /** Create new "MetadataTransferredByFullName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTransferredByFullNameList" relation. */
  create?: InputMaybe<Array<MetadataTransferredByFullNameWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataTransferredByFullName" nodes from the "Archive.metadataTransferredByFullNameList" relation. */
  delete?: InputMaybe<Array<MetadataTransferredByFullNameWhereUniqueInput>>;
  /** Update existing "MetadataTransferredByFullName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTransferredByFullNameList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataTransferredByFullNameListUpdateInput>>;
  /** Upsert existing "MetadataTransferredByFullName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTransferredByFullNameList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataTransferredByFullNameListUpdateInput>>;
};

export type ArchiveNestedMetadataTransferredByListCreateInput = {
  /** Connect existing "MetadataTransferredBy" nodes to the new "Archive" node, through the "Archive.metadataTransferredByList" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByWhereUniqueInput>>;
  /** Create new "MetadataTransferredBy" nodes and connect them to the new "Archive" node, through the "Archive.metadataTransferredByList" relation. */
  create?: InputMaybe<Array<MetadataTransferredByWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataTransferredByListUpdateInput = {
  /** Connect existing "MetadataTransferredBy" nodes to the existing "Archive" node, through the "Archive.metadataTransferredByList" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByWhereUniqueInput>>;
  /** Create new "MetadataTransferredBy" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTransferredByList" relation. */
  create?: InputMaybe<Array<MetadataTransferredByWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataTransferredBy" nodes from the "Archive.metadataTransferredByList" relation. */
  delete?: InputMaybe<Array<MetadataTransferredByWhereUniqueInput>>;
  /** Update existing "MetadataTransferredBy" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTransferredByList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataTransferredByListUpdateInput>>;
  /** Upsert existing "MetadataTransferredBy" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTransferredByList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataTransferredByListUpdateInput>>;
};

export type ArchiveNestedMetadataTypeListCreateInput = {
  /** Connect existing "MetadataType" nodes to the new "Archive" node, through the "Archive.metadataTypeList" relation. */
  connect?: InputMaybe<Array<MetadataTypeWhereUniqueInput>>;
  /** Create new "MetadataType" nodes and connect them to the new "Archive" node, through the "Archive.metadataTypeList" relation. */
  create?: InputMaybe<Array<MetadataTypeWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataTypeListUpdateInput = {
  /** Connect existing "MetadataType" nodes to the existing "Archive" node, through the "Archive.metadataTypeList" relation. */
  connect?: InputMaybe<Array<MetadataTypeWhereUniqueInput>>;
  /** Create new "MetadataType" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTypeList" relation. */
  create?: InputMaybe<Array<MetadataTypeWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataType" nodes from the "Archive.metadataTypeList" relation. */
  delete?: InputMaybe<Array<MetadataTypeWhereUniqueInput>>;
  /** Update existing "MetadataType" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTypeList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataTypeListUpdateInput>>;
  /** Upsert existing "MetadataType" nodes and connect them to the existing "Archive" node, through the "Archive.metadataTypeList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataTypeListUpdateInput>>;
};

export type ArchiveNestedMetadataUndersubjectListCreateInput = {
  /** Connect existing "MetadataUndersubject" nodes to the new "Archive" node, through the "Archive.metadataUndersubjectList" relation. */
  connect?: InputMaybe<Array<MetadataUndersubjectWhereUniqueInput>>;
  /** Create new "MetadataUndersubject" nodes and connect them to the new "Archive" node, through the "Archive.metadataUndersubjectList" relation. */
  create?: InputMaybe<Array<MetadataUndersubjectWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUndersubjectListUpdateInput = {
  /** Connect existing "MetadataUndersubject" nodes to the existing "Archive" node, through the "Archive.metadataUndersubjectList" relation. */
  connect?: InputMaybe<Array<MetadataUndersubjectWhereUniqueInput>>;
  /** Create new "MetadataUndersubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUndersubjectList" relation. */
  create?: InputMaybe<Array<MetadataUndersubjectWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUndersubject" nodes from the "Archive.metadataUndersubjectList" relation. */
  delete?: InputMaybe<Array<MetadataUndersubjectWhereUniqueInput>>;
  /** Update existing "MetadataUndersubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUndersubjectList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUndersubjectListUpdateInput>>;
  /** Upsert existing "MetadataUndersubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUndersubjectList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUndersubjectListUpdateInput>>;
};

export type ArchiveNestedMetadataUnderUnderSubjectListCreateInput = {
  /** Connect existing "MetadataUnderUnderSubject" nodes to the new "Archive" node, through the "Archive.metadataUnderUnderSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataUnderUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataUnderUnderSubject" nodes and connect them to the new "Archive" node, through the "Archive.metadataUnderUnderSubjectList" relation. */
  create?: InputMaybe<Array<MetadataUnderUnderSubjectWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUnderUnderSubjectListUpdateInput = {
  /** Connect existing "MetadataUnderUnderSubject" nodes to the existing "Archive" node, through the "Archive.metadataUnderUnderSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataUnderUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataUnderUnderSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUnderUnderSubjectList" relation. */
  create?: InputMaybe<Array<MetadataUnderUnderSubjectWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUnderUnderSubject" nodes from the "Archive.metadataUnderUnderSubjectList" relation. */
  delete?: InputMaybe<Array<MetadataUnderUnderSubjectWhereUniqueInput>>;
  /** Update existing "MetadataUnderUnderSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUnderUnderSubjectList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUnderUnderSubjectListUpdateInput>>;
  /** Upsert existing "MetadataUnderUnderSubject" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUnderUnderSubjectList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUnderUnderSubjectListUpdateInput>>;
};

export type ArchiveNestedMetadataUploadedByFullNameListCreateInput = {
  /** Connect existing "MetadataUploadedByFullName" nodes to the new "Archive" node, through the "Archive.metadataUploadedByFullNameList" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByFullNameWhereUniqueInput>>;
  /** Create new "MetadataUploadedByFullName" nodes and connect them to the new "Archive" node, through the "Archive.metadataUploadedByFullNameList" relation. */
  create?: InputMaybe<Array<MetadataUploadedByFullNameWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUploadedByFullNameListUpdateInput = {
  /** Connect existing "MetadataUploadedByFullName" nodes to the existing "Archive" node, through the "Archive.metadataUploadedByFullNameList" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByFullNameWhereUniqueInput>>;
  /** Create new "MetadataUploadedByFullName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUploadedByFullNameList" relation. */
  create?: InputMaybe<Array<MetadataUploadedByFullNameWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUploadedByFullName" nodes from the "Archive.metadataUploadedByFullNameList" relation. */
  delete?: InputMaybe<Array<MetadataUploadedByFullNameWhereUniqueInput>>;
  /** Update existing "MetadataUploadedByFullName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUploadedByFullNameList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUploadedByFullNameListUpdateInput>>;
  /** Upsert existing "MetadataUploadedByFullName" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUploadedByFullNameList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUploadedByFullNameListUpdateInput>>;
};

export type ArchiveNestedMetadataUploadedByListCreateInput = {
  /** Connect existing "MetadataUploadedBy" nodes to the new "Archive" node, through the "Archive.metadataUploadedByList" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByWhereUniqueInput>>;
  /** Create new "MetadataUploadedBy" nodes and connect them to the new "Archive" node, through the "Archive.metadataUploadedByList" relation. */
  create?: InputMaybe<Array<MetadataUploadedByWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUploadedByListUpdateInput = {
  /** Connect existing "MetadataUploadedBy" nodes to the existing "Archive" node, through the "Archive.metadataUploadedByList" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByWhereUniqueInput>>;
  /** Create new "MetadataUploadedBy" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUploadedByList" relation. */
  create?: InputMaybe<Array<MetadataUploadedByWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUploadedBy" nodes from the "Archive.metadataUploadedByList" relation. */
  delete?: InputMaybe<Array<MetadataUploadedByWhereUniqueInput>>;
  /** Update existing "MetadataUploadedBy" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUploadedByList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUploadedByListUpdateInput>>;
  /** Upsert existing "MetadataUploadedBy" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUploadedByList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUploadedByListUpdateInput>>;
};

export type ArchiveNestedMetadataUploadTimeListCreateInput = {
  /** Connect existing "MetadataUploadTime" nodes to the new "Archive" node, through the "Archive.metadataUploadTimeList" relation. */
  connect?: InputMaybe<Array<MetadataUploadTimeWhereUniqueInput>>;
  /** Create new "MetadataUploadTime" nodes and connect them to the new "Archive" node, through the "Archive.metadataUploadTimeList" relation. */
  create?: InputMaybe<Array<MetadataUploadTimeWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUploadTimeListUpdateInput = {
  /** Connect existing "MetadataUploadTime" nodes to the existing "Archive" node, through the "Archive.metadataUploadTimeList" relation. */
  connect?: InputMaybe<Array<MetadataUploadTimeWhereUniqueInput>>;
  /** Create new "MetadataUploadTime" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUploadTimeList" relation. */
  create?: InputMaybe<Array<MetadataUploadTimeWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUploadTime" nodes from the "Archive.metadataUploadTimeList" relation. */
  delete?: InputMaybe<Array<MetadataUploadTimeWhereUniqueInput>>;
  /** Update existing "MetadataUploadTime" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUploadTimeList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUploadTimeListUpdateInput>>;
  /** Upsert existing "MetadataUploadTime" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUploadTimeList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUploadTimeListUpdateInput>>;
};

export type ArchiveNestedMetadataUrgencyListCreateInput = {
  /** Connect existing "MetadataUrgency" nodes to the new "Archive" node, through the "Archive.metadataUrgencyList" relation. */
  connect?: InputMaybe<Array<MetadataUrgencyWhereUniqueInput>>;
  /** Create new "MetadataUrgency" nodes and connect them to the new "Archive" node, through the "Archive.metadataUrgencyList" relation. */
  create?: InputMaybe<Array<MetadataUrgencyWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUrgencyListUpdateInput = {
  /** Connect existing "MetadataUrgency" nodes to the existing "Archive" node, through the "Archive.metadataUrgencyList" relation. */
  connect?: InputMaybe<Array<MetadataUrgencyWhereUniqueInput>>;
  /** Create new "MetadataUrgency" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUrgencyList" relation. */
  create?: InputMaybe<Array<MetadataUrgencyWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUrgency" nodes from the "Archive.metadataUrgencyList" relation. */
  delete?: InputMaybe<Array<MetadataUrgencyWhereUniqueInput>>;
  /** Update existing "MetadataUrgency" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUrgencyList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUrgencyListUpdateInput>>;
  /** Upsert existing "MetadataUrgency" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUrgencyList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUrgencyListUpdateInput>>;
};

export type ArchiveNestedMetadataUserDefined195ListCreateInput = {
  /** Connect existing "MetadataUserDefined195" nodes to the new "Archive" node, through the "Archive.metadataUserDefined195List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined195WhereUniqueInput>>;
  /** Create new "MetadataUserDefined195" nodes and connect them to the new "Archive" node, through the "Archive.metadataUserDefined195List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined195WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUserDefined195ListUpdateInput = {
  /** Connect existing "MetadataUserDefined195" nodes to the existing "Archive" node, through the "Archive.metadataUserDefined195List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined195WhereUniqueInput>>;
  /** Create new "MetadataUserDefined195" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined195List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined195WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUserDefined195" nodes from the "Archive.metadataUserDefined195List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined195WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined195" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined195List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUserDefined195ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined195" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined195List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUserDefined195ListUpdateInput>>;
};

export type ArchiveNestedMetadataUserDefined237ListCreateInput = {
  /** Connect existing "MetadataUserDefined237" nodes to the new "Archive" node, through the "Archive.metadataUserDefined237List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined237WhereUniqueInput>>;
  /** Create new "MetadataUserDefined237" nodes and connect them to the new "Archive" node, through the "Archive.metadataUserDefined237List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined237WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUserDefined237ListUpdateInput = {
  /** Connect existing "MetadataUserDefined237" nodes to the existing "Archive" node, through the "Archive.metadataUserDefined237List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined237WhereUniqueInput>>;
  /** Create new "MetadataUserDefined237" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined237List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined237WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUserDefined237" nodes from the "Archive.metadataUserDefined237List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined237WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined237" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined237List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUserDefined237ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined237" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined237List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUserDefined237ListUpdateInput>>;
};

export type ArchiveNestedMetadataUserDefined238ListCreateInput = {
  /** Connect existing "MetadataUserDefined238" nodes to the new "Archive" node, through the "Archive.metadataUserDefined238List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined238WhereUniqueInput>>;
  /** Create new "MetadataUserDefined238" nodes and connect them to the new "Archive" node, through the "Archive.metadataUserDefined238List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined238WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUserDefined238ListUpdateInput = {
  /** Connect existing "MetadataUserDefined238" nodes to the existing "Archive" node, through the "Archive.metadataUserDefined238List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined238WhereUniqueInput>>;
  /** Create new "MetadataUserDefined238" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined238List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined238WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUserDefined238" nodes from the "Archive.metadataUserDefined238List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined238WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined238" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined238List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUserDefined238ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined238" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined238List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUserDefined238ListUpdateInput>>;
};

export type ArchiveNestedMetadataUserDefined239ListCreateInput = {
  /** Connect existing "MetadataUserDefined239" nodes to the new "Archive" node, through the "Archive.metadataUserDefined239List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined239WhereUniqueInput>>;
  /** Create new "MetadataUserDefined239" nodes and connect them to the new "Archive" node, through the "Archive.metadataUserDefined239List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined239WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUserDefined239ListUpdateInput = {
  /** Connect existing "MetadataUserDefined239" nodes to the existing "Archive" node, through the "Archive.metadataUserDefined239List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined239WhereUniqueInput>>;
  /** Create new "MetadataUserDefined239" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined239List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined239WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUserDefined239" nodes from the "Archive.metadataUserDefined239List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined239WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined239" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined239List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUserDefined239ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined239" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined239List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUserDefined239ListUpdateInput>>;
};

export type ArchiveNestedMetadataUserDefined242ListCreateInput = {
  /** Connect existing "MetadataUserDefined242" nodes to the new "Archive" node, through the "Archive.metadataUserDefined242List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined242WhereUniqueInput>>;
  /** Create new "MetadataUserDefined242" nodes and connect them to the new "Archive" node, through the "Archive.metadataUserDefined242List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined242WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUserDefined242ListUpdateInput = {
  /** Connect existing "MetadataUserDefined242" nodes to the existing "Archive" node, through the "Archive.metadataUserDefined242List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined242WhereUniqueInput>>;
  /** Create new "MetadataUserDefined242" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined242List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined242WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUserDefined242" nodes from the "Archive.metadataUserDefined242List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined242WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined242" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined242List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUserDefined242ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined242" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined242List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUserDefined242ListUpdateInput>>;
};

export type ArchiveNestedMetadataUserDefined62ListCreateInput = {
  /** Connect existing "MetadataUserDefined62" nodes to the new "Archive" node, through the "Archive.metadataUserDefined62List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined62WhereUniqueInput>>;
  /** Create new "MetadataUserDefined62" nodes and connect them to the new "Archive" node, through the "Archive.metadataUserDefined62List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined62WithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataUserDefined62ListUpdateInput = {
  /** Connect existing "MetadataUserDefined62" nodes to the existing "Archive" node, through the "Archive.metadataUserDefined62List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined62WhereUniqueInput>>;
  /** Create new "MetadataUserDefined62" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined62List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined62WithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataUserDefined62" nodes from the "Archive.metadataUserDefined62List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined62WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined62" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined62List" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataUserDefined62ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined62" nodes and connect them to the existing "Archive" node, through the "Archive.metadataUserDefined62List" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataUserDefined62ListUpdateInput>>;
};

export type ArchiveNestedMetadataWorkflowKindListCreateInput = {
  /** Connect existing "MetadataWorkflowKind" nodes to the new "Archive" node, through the "Archive.metadataWorkflowKindList" relation. */
  connect?: InputMaybe<Array<MetadataWorkflowKindWhereUniqueInput>>;
  /** Create new "MetadataWorkflowKind" nodes and connect them to the new "Archive" node, through the "Archive.metadataWorkflowKindList" relation. */
  create?: InputMaybe<Array<MetadataWorkflowKindWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataWorkflowKindListUpdateInput = {
  /** Connect existing "MetadataWorkflowKind" nodes to the existing "Archive" node, through the "Archive.metadataWorkflowKindList" relation. */
  connect?: InputMaybe<Array<MetadataWorkflowKindWhereUniqueInput>>;
  /** Create new "MetadataWorkflowKind" nodes and connect them to the existing "Archive" node, through the "Archive.metadataWorkflowKindList" relation. */
  create?: InputMaybe<Array<MetadataWorkflowKindWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataWorkflowKind" nodes from the "Archive.metadataWorkflowKindList" relation. */
  delete?: InputMaybe<Array<MetadataWorkflowKindWhereUniqueInput>>;
  /** Update existing "MetadataWorkflowKind" nodes and connect them to the existing "Archive" node, through the "Archive.metadataWorkflowKindList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataWorkflowKindListUpdateInput>>;
  /** Upsert existing "MetadataWorkflowKind" nodes and connect them to the existing "Archive" node, through the "Archive.metadataWorkflowKindList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataWorkflowKindListUpdateInput>>;
};

export type ArchiveNestedMetadataXmpHistoryListCreateInput = {
  /** Connect existing "MetadataXmpHistory" nodes to the new "Archive" node, through the "Archive.metadataXmpHistoryList" relation. */
  connect?: InputMaybe<Array<MetadataXmpHistoryWhereUniqueInput>>;
  /** Create new "MetadataXmpHistory" nodes and connect them to the new "Archive" node, through the "Archive.metadataXmpHistoryList" relation. */
  create?: InputMaybe<Array<MetadataXmpHistoryWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedMetadataXmpHistoryListUpdateInput = {
  /** Connect existing "MetadataXmpHistory" nodes to the existing "Archive" node, through the "Archive.metadataXmpHistoryList" relation. */
  connect?: InputMaybe<Array<MetadataXmpHistoryWhereUniqueInput>>;
  /** Create new "MetadataXmpHistory" nodes and connect them to the existing "Archive" node, through the "Archive.metadataXmpHistoryList" relation. */
  create?: InputMaybe<Array<MetadataXmpHistoryWithForcedArchiveCreateInput>>;
  /** Delete existing "MetadataXmpHistory" nodes from the "Archive.metadataXmpHistoryList" relation. */
  delete?: InputMaybe<Array<MetadataXmpHistoryWhereUniqueInput>>;
  /** Update existing "MetadataXmpHistory" nodes and connect them to the existing "Archive" node, through the "Archive.metadataXmpHistoryList" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdateMetadataXmpHistoryListUpdateInput>>;
  /** Upsert existing "MetadataXmpHistory" nodes and connect them to the existing "Archive" node, through the "Archive.metadataXmpHistoryList" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertMetadataXmpHistoryListUpdateInput>>;
};

export type ArchiveNestedPhotoMetadatasCreateInput = {
  /** Connect existing "PhotoMetadata" nodes to the new "Archive" node, through the "Archive.photoMetadatas" relation. */
  connect?: InputMaybe<Array<PhotoMetadataWhereUniqueInput>>;
  /** Create new "PhotoMetadata" nodes and connect them to the new "Archive" node, through the "Archive.photoMetadatas" relation. */
  create?: InputMaybe<Array<PhotoMetadataWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedPhotoMetadatasUpdateInput = {
  /** Connect existing "PhotoMetadata" nodes to the existing "Archive" node, through the "Archive.photoMetadatas" relation. */
  connect?: InputMaybe<Array<PhotoMetadataWhereUniqueInput>>;
  /** Create new "PhotoMetadata" nodes and connect them to the existing "Archive" node, through the "Archive.photoMetadatas" relation. */
  create?: InputMaybe<Array<PhotoMetadataWithForcedArchiveCreateInput>>;
  /** Delete existing "PhotoMetadata" nodes from the "Archive.photoMetadatas" relation. */
  delete?: InputMaybe<Array<PhotoMetadataWhereUniqueInput>>;
  /** Update existing "PhotoMetadata" nodes and connect them to the existing "Archive" node, through the "Archive.photoMetadatas" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdatePhotoMetadatasUpdateInput>>;
  /** Upsert existing "PhotoMetadata" nodes and connect them to the existing "Archive" node, through the "Archive.photoMetadatas" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertPhotoMetadatasUpdateInput>>;
};

export type ArchiveNestedPhotosCreateInput = {
  /** Connect existing "Photo" nodes to the new "Archive" node, through the "Archive.photos" relation. */
  connect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Create new "Photo" nodes and connect them to the new "Archive" node, through the "Archive.photos" relation. */
  create?: InputMaybe<Array<PhotoWithForcedArchiveCreateInput>>;
};

export type ArchiveNestedPhotosUpdateInput = {
  /** Connect existing "Photo" nodes to the existing "Archive" node, through the "Archive.photos" relation. */
  connect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Create new "Photo" nodes and connect them to the existing "Archive" node, through the "Archive.photos" relation. */
  create?: InputMaybe<Array<PhotoWithForcedArchiveCreateInput>>;
  /** Delete existing "Photo" nodes from the "Archive.photos" relation. */
  delete?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Update existing "Photo" nodes and connect them to the existing "Archive" node, through the "Archive.photos" relation. */
  update?: InputMaybe<Array<ArchiveNestedUpdatePhotosUpdateInput>>;
  /** Upsert existing "Photo" nodes and connect them to the existing "Archive" node, through the "Archive.photos" relation. */
  upsert?: InputMaybe<Array<ArchiveNestedUpsertPhotosUpdateInput>>;
};

export type ArchiveNestedUpdateArchiveAgenciesUpdateInput = {
  data: ArchiveAgencyWithForcedArchiveUpdateInput;
  where: ArchiveAgencyWithOptionalArchiveWhereUniqueInput;
};

export type ArchiveNestedUpdateArchivePurgeSettingUpdateInput = {
  data: ArchivePurgeSettingWithForcedArchiveUpdateInput;
  where: ArchivePurgeSettingWithOptionalArchiveWhereUniqueInput;
};

export type ArchiveNestedUpdateCategoriesUpdateInput = {
  data: CategoryWithForcedArchiveUpdateInput;
  where: CategoryWithOptionalArchiveWhereUniqueInput;
};

export type ArchiveNestedUpdateDeliverySubjectsUpdateInput = {
  data: DeliverySubjectWithForcedArchiveUpdateInput;
  where: DeliverySubjectWithOptionalArchiveWhereUniqueInput;
};

export type ArchiveNestedUpdateGcImportSettingUpdateInput = {
  data: GcImportSettingWithForcedArchiveUpdateInput;
  where: GcImportSettingWithOptionalArchiveWhereUniqueInput;
};

export type ArchiveNestedUpdateImportQueuesUpdateInput = {
  data: ImportQueueWithForcedArchiveUpdateInput;
  where: ImportQueueWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataAccessRightsListUpdateInput = {
  data: MetadataAccessRightsWithForcedArchiveUpdateInput;
  where: MetadataAccessRightsWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataAssetStateListUpdateInput = {
  data: MetadataAssetStateWithForcedArchiveUpdateInput;
  where: MetadataAssetStateWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataBackupNameListUpdateInput = {
  data: MetadataBackupNameWithForcedArchiveUpdateInput;
  where: MetadataBackupNameWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataBrandListUpdateInput = {
  data: MetadataBrandWithForcedArchiveUpdateInput;
  where: MetadataBrandWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataBrandPrismaListUpdateInput = {
  data: MetadataBrandPrismaWithForcedArchiveUpdateInput;
  where: MetadataBrandPrismaWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataBrandShortNameListUpdateInput = {
  data: MetadataBrandShortNameWithForcedArchiveUpdateInput;
  where: MetadataBrandShortNameWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataByLineListUpdateInput = {
  data: MetadataByLineWithForcedArchiveUpdateInput;
  where: MetadataByLineWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCaptionAbstractListUpdateInput = {
  data: MetadataCaptionAbstractWithForcedArchiveUpdateInput;
  where: MetadataCaptionAbstractWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCaptionListUpdateInput = {
  data: MetadataCaptionWithForcedArchiveUpdateInput;
  where: MetadataCaptionWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCategoryListUpdateInput = {
  data: MetadataCategoryWithForcedArchiveUpdateInput;
  where: MetadataCategoryWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCategoryPrismaListUpdateInput = {
  data: MetadataCategoryPrismaWithForcedArchiveUpdateInput;
  where: MetadataCategoryPrismaWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCompanyListUpdateInput = {
  data: MetadataCompanyWithForcedArchiveUpdateInput;
  where: MetadataCompanyWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCompanyShortNameListUpdateInput = {
  data: MetadataCompanyShortNameWithForcedArchiveUpdateInput;
  where: MetadataCompanyShortNameWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCopyrightNoticeListUpdateInput = {
  data: MetadataCopyrightNoticeWithForcedArchiveUpdateInput;
  where: MetadataCopyrightNoticeWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCreatorListUpdateInput = {
  data: MetadataCreatorWithForcedArchiveUpdateInput;
  where: MetadataCreatorWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCreditListUpdateInput = {
  data: MetadataCreditWithForcedArchiveUpdateInput;
  where: MetadataCreditWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField14ListUpdateInput = {
  data: MetadataCustomField14WithForcedArchiveUpdateInput;
  where: MetadataCustomField14WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField15ListUpdateInput = {
  data: MetadataCustomField15WithForcedArchiveUpdateInput;
  where: MetadataCustomField15WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField16ListUpdateInput = {
  data: MetadataCustomField16WithForcedArchiveUpdateInput;
  where: MetadataCustomField16WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField17ListUpdateInput = {
  data: MetadataCustomField17WithForcedArchiveUpdateInput;
  where: MetadataCustomField17WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField1ListUpdateInput = {
  data: MetadataCustomField1WithForcedArchiveUpdateInput;
  where: MetadataCustomField1WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField20ListUpdateInput = {
  data: MetadataCustomField20WithForcedArchiveUpdateInput;
  where: MetadataCustomField20WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField3ListUpdateInput = {
  data: MetadataCustomField3WithForcedArchiveUpdateInput;
  where: MetadataCustomField3WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField4ListUpdateInput = {
  data: MetadataCustomField4WithForcedArchiveUpdateInput;
  where: MetadataCustomField4WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField5ListUpdateInput = {
  data: MetadataCustomField5WithForcedArchiveUpdateInput;
  where: MetadataCustomField5WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField6ListUpdateInput = {
  data: MetadataCustomField6WithForcedArchiveUpdateInput;
  where: MetadataCustomField6WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField7ListUpdateInput = {
  data: MetadataCustomField7WithForcedArchiveUpdateInput;
  where: MetadataCustomField7WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataCustomField9ListUpdateInput = {
  data: MetadataCustomField9WithForcedArchiveUpdateInput;
  where: MetadataCustomField9WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDateCreatedListUpdateInput = {
  data: MetadataDateCreatedWithForcedArchiveUpdateInput;
  where: MetadataDateCreatedWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDateTimeOriginalListUpdateInput = {
  data: MetadataDateTimeOriginalWithForcedArchiveUpdateInput;
  where: MetadataDateTimeOriginalWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryAccountListUpdateInput = {
  data: MetadataDeliveryAccountWithForcedArchiveUpdateInput;
  where: MetadataDeliveryAccountWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryCompanyListUpdateInput = {
  data: MetadataDeliveryCompanyWithForcedArchiveUpdateInput;
  where: MetadataDeliveryCompanyWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryCopyrightListUpdateInput = {
  data: MetadataDeliveryCopyrightWithForcedArchiveUpdateInput;
  where: MetadataDeliveryCopyrightWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryDateFolderListUpdateInput = {
  data: MetadataDeliveryDateFolderWithForcedArchiveUpdateInput;
  where: MetadataDeliveryDateFolderWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryDateTimeListUpdateInput = {
  data: MetadataDeliveryDateTimeWithForcedArchiveUpdateInput;
  where: MetadataDeliveryDateTimeWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryDcCreatorListUpdateInput = {
  data: MetadataDeliveryDcCreatorWithForcedArchiveUpdateInput;
  where: MetadataDeliveryDcCreatorWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryDcRightsListUpdateInput = {
  data: MetadataDeliveryDcRightsWithForcedArchiveUpdateInput;
  where: MetadataDeliveryDcRightsWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryFolderListUpdateInput = {
  data: MetadataDeliveryFolderWithForcedArchiveUpdateInput;
  where: MetadataDeliveryFolderWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryKindListUpdateInput = {
  data: MetadataDeliveryKindWithForcedArchiveUpdateInput;
  where: MetadataDeliveryKindWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryPathListUpdateInput = {
  data: MetadataDeliveryPathWithForcedArchiveUpdateInput;
  where: MetadataDeliveryPathWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryPhotoshopCreditListUpdateInput = {
  data: MetadataDeliveryPhotoshopCreditWithForcedArchiveUpdateInput;
  where: MetadataDeliveryPhotoshopCreditWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryPhotoshopSourceListUpdateInput = {
  data: MetadataDeliveryPhotoshopSourceWithForcedArchiveUpdateInput;
  where: MetadataDeliveryPhotoshopSourceWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryServiceListUpdateInput = {
  data: MetadataDeliveryServiceWithForcedArchiveUpdateInput;
  where: MetadataDeliveryServiceWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliverySubjectListUpdateInput = {
  data: MetadataDeliverySubjectWithForcedArchiveUpdateInput;
  where: MetadataDeliverySubjectWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDeliveryUnderSubjectListUpdateInput = {
  data: MetadataDeliveryUnderSubjectWithForcedArchiveUpdateInput;
  where: MetadataDeliveryUnderSubjectWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDepartmentListUpdateInput = {
  data: MetadataDepartmentWithForcedArchiveUpdateInput;
  where: MetadataDepartmentWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataDescriptionListUpdateInput = {
  data: MetadataDescriptionWithForcedArchiveUpdateInput;
  where: MetadataDescriptionWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataEditionListUpdateInput = {
  data: MetadataEditionWithForcedArchiveUpdateInput;
  where: MetadataEditionWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataEditStatusListUpdateInput = {
  data: MetadataEditStatusWithForcedArchiveUpdateInput;
  where: MetadataEditStatusWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataFileStatusListUpdateInput = {
  data: MetadataFileStatusWithForcedArchiveUpdateInput;
  where: MetadataFileStatusWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataFormatListUpdateInput = {
  data: MetadataFormatWithForcedArchiveUpdateInput;
  where: MetadataFormatWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataHeaderListUpdateInput = {
  data: MetadataHeaderWithForcedArchiveUpdateInput;
  where: MetadataHeaderWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataHeaderPrismaListUpdateInput = {
  data: MetadataHeaderPrismaWithForcedArchiveUpdateInput;
  where: MetadataHeaderPrismaWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataHeadlineListUpdateInput = {
  data: MetadataHeadlineWithForcedArchiveUpdateInput;
  where: MetadataHeadlineWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataIdAssignmentListUpdateInput = {
  data: MetadataIdAssignmentWithForcedArchiveUpdateInput;
  where: MetadataIdAssignmentWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataIdPhotoPrismaListUpdateInput = {
  data: MetadataIdPhotoPrismaWithForcedArchiveUpdateInput;
  where: MetadataIdPhotoPrismaWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataIdSubjectListUpdateInput = {
  data: MetadataIdSubjectWithForcedArchiveUpdateInput;
  where: MetadataIdSubjectWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataImageNotesListUpdateInput = {
  data: MetadataImageNotesWithForcedArchiveUpdateInput;
  where: MetadataImageNotesWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataInstructionsListUpdateInput = {
  data: MetadataInstructionsWithForcedArchiveUpdateInput;
  where: MetadataInstructionsWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataIssueListUpdateInput = {
  data: MetadataIssueWithForcedArchiveUpdateInput;
  where: MetadataIssueWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataKeywordsListUpdateInput = {
  data: MetadataKeywordsWithForcedArchiveUpdateInput;
  where: MetadataKeywordsWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataObjectNameListUpdateInput = {
  data: MetadataObjectNameWithForcedArchiveUpdateInput;
  where: MetadataObjectNameWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataOriginalNameListUpdateInput = {
  data: MetadataOriginalNameWithForcedArchiveUpdateInput;
  where: MetadataOriginalNameWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataPriceLevelListUpdateInput = {
  data: MetadataPriceLevelWithForcedArchiveUpdateInput;
  where: MetadataPriceLevelWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataProcessHistoryListUpdateInput = {
  data: MetadataProcessHistoryWithForcedArchiveUpdateInput;
  where: MetadataProcessHistoryWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataProcessStatusListUpdateInput = {
  data: MetadataProcessStatusWithForcedArchiveUpdateInput;
  where: MetadataProcessStatusWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataProductListUpdateInput = {
  data: MetadataProductWithForcedArchiveUpdateInput;
  where: MetadataProductWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataProductsListUpdateInput = {
  data: MetadataProductsWithForcedArchiveUpdateInput;
  where: MetadataProductsWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataPublishingSubjectListUpdateInput = {
  data: MetadataPublishingSubjectWithForcedArchiveUpdateInput;
  where: MetadataPublishingSubjectWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataResolutionKindListUpdateInput = {
  data: MetadataResolutionKindWithForcedArchiveUpdateInput;
  where: MetadataResolutionKindWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataRightsListUpdateInput = {
  data: MetadataRightsWithForcedArchiveUpdateInput;
  where: MetadataRightsWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataSourceListUpdateInput = {
  data: MetadataSourceWithForcedArchiveUpdateInput;
  where: MetadataSourceWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataSpecialInstructionsListUpdateInput = {
  data: MetadataSpecialInstructionsWithForcedArchiveUpdateInput;
  where: MetadataSpecialInstructionsWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataSubjectCodeListUpdateInput = {
  data: MetadataSubjectCodeWithForcedArchiveUpdateInput;
  where: MetadataSubjectCodeWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataSubjectListUpdateInput = {
  data: MetadataSubjectWithForcedArchiveUpdateInput;
  where: MetadataSubjectWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataSubjectPrismaListUpdateInput = {
  data: MetadataSubjectPrismaWithForcedArchiveUpdateInput;
  where: MetadataSubjectPrismaWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataTitleListUpdateInput = {
  data: MetadataTitleWithForcedArchiveUpdateInput;
  where: MetadataTitleWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataTransferredByFullNameListUpdateInput = {
  data: MetadataTransferredByFullNameWithForcedArchiveUpdateInput;
  where: MetadataTransferredByFullNameWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataTransferredByListUpdateInput = {
  data: MetadataTransferredByWithForcedArchiveUpdateInput;
  where: MetadataTransferredByWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataTypeListUpdateInput = {
  data: MetadataTypeWithForcedArchiveUpdateInput;
  where: MetadataTypeWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUndersubjectListUpdateInput = {
  data: MetadataUndersubjectWithForcedArchiveUpdateInput;
  where: MetadataUndersubjectWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUnderUnderSubjectListUpdateInput = {
  data: MetadataUnderUnderSubjectWithForcedArchiveUpdateInput;
  where: MetadataUnderUnderSubjectWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUploadedByFullNameListUpdateInput = {
  data: MetadataUploadedByFullNameWithForcedArchiveUpdateInput;
  where: MetadataUploadedByFullNameWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUploadedByListUpdateInput = {
  data: MetadataUploadedByWithForcedArchiveUpdateInput;
  where: MetadataUploadedByWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUploadTimeListUpdateInput = {
  data: MetadataUploadTimeWithForcedArchiveUpdateInput;
  where: MetadataUploadTimeWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUrgencyListUpdateInput = {
  data: MetadataUrgencyWithForcedArchiveUpdateInput;
  where: MetadataUrgencyWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUserDefined195ListUpdateInput = {
  data: MetadataUserDefined195WithForcedArchiveUpdateInput;
  where: MetadataUserDefined195WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUserDefined237ListUpdateInput = {
  data: MetadataUserDefined237WithForcedArchiveUpdateInput;
  where: MetadataUserDefined237WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUserDefined238ListUpdateInput = {
  data: MetadataUserDefined238WithForcedArchiveUpdateInput;
  where: MetadataUserDefined238WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUserDefined239ListUpdateInput = {
  data: MetadataUserDefined239WithForcedArchiveUpdateInput;
  where: MetadataUserDefined239WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUserDefined242ListUpdateInput = {
  data: MetadataUserDefined242WithForcedArchiveUpdateInput;
  where: MetadataUserDefined242WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataUserDefined62ListUpdateInput = {
  data: MetadataUserDefined62WithForcedArchiveUpdateInput;
  where: MetadataUserDefined62WhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataWorkflowKindListUpdateInput = {
  data: MetadataWorkflowKindWithForcedArchiveUpdateInput;
  where: MetadataWorkflowKindWhereUniqueInput;
};

export type ArchiveNestedUpdateMetadataXmpHistoryListUpdateInput = {
  data: MetadataXmpHistoryWithForcedArchiveUpdateInput;
  where: MetadataXmpHistoryWhereUniqueInput;
};

export type ArchiveNestedUpdatePhotoMetadatasUpdateInput = {
  data: PhotoMetadataWithForcedArchiveUpdateInput;
  where: PhotoMetadataWhereUniqueInput;
};

export type ArchiveNestedUpdatePhotosUpdateInput = {
  data: PhotoWithForcedArchiveUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type ArchiveNestedUpsertArchiveAgenciesUpdateInput = {
  create: ArchiveAgencyWithForcedArchiveCreateInput;
  update: ArchiveAgencyWithForcedArchiveUpdateInput;
  where: ArchiveAgencyWithOptionalArchiveWhereUniqueInput;
};

export type ArchiveNestedUpsertArchivePurgeSettingUpdateInput = {
  create: ArchivePurgeSettingWithForcedArchiveCreateInput;
  update: ArchivePurgeSettingWithForcedArchiveUpdateInput;
  where: ArchivePurgeSettingWithOptionalArchiveWhereUniqueInput;
};

export type ArchiveNestedUpsertCategoriesUpdateInput = {
  create: CategoryWithForcedArchiveCreateInput;
  update: CategoryWithForcedArchiveUpdateInput;
  where: CategoryWithOptionalArchiveWhereUniqueInput;
};

export type ArchiveNestedUpsertDeliverySubjectsUpdateInput = {
  create: DeliverySubjectWithForcedArchiveCreateInput;
  update: DeliverySubjectWithForcedArchiveUpdateInput;
  where: DeliverySubjectWithOptionalArchiveWhereUniqueInput;
};

export type ArchiveNestedUpsertGcImportSettingUpdateInput = {
  create: GcImportSettingWithForcedArchiveCreateInput;
  update: GcImportSettingWithForcedArchiveUpdateInput;
  where: GcImportSettingWithOptionalArchiveWhereUniqueInput;
};

export type ArchiveNestedUpsertImportQueuesUpdateInput = {
  create: ImportQueueWithForcedArchiveCreateInput;
  update: ImportQueueWithForcedArchiveUpdateInput;
  where: ImportQueueWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataAccessRightsListUpdateInput = {
  create: MetadataAccessRightsWithForcedArchiveCreateInput;
  update: MetadataAccessRightsWithForcedArchiveUpdateInput;
  where: MetadataAccessRightsWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataAssetStateListUpdateInput = {
  create: MetadataAssetStateWithForcedArchiveCreateInput;
  update: MetadataAssetStateWithForcedArchiveUpdateInput;
  where: MetadataAssetStateWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataBackupNameListUpdateInput = {
  create: MetadataBackupNameWithForcedArchiveCreateInput;
  update: MetadataBackupNameWithForcedArchiveUpdateInput;
  where: MetadataBackupNameWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataBrandListUpdateInput = {
  create: MetadataBrandWithForcedArchiveCreateInput;
  update: MetadataBrandWithForcedArchiveUpdateInput;
  where: MetadataBrandWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataBrandPrismaListUpdateInput = {
  create: MetadataBrandPrismaWithForcedArchiveCreateInput;
  update: MetadataBrandPrismaWithForcedArchiveUpdateInput;
  where: MetadataBrandPrismaWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataBrandShortNameListUpdateInput = {
  create: MetadataBrandShortNameWithForcedArchiveCreateInput;
  update: MetadataBrandShortNameWithForcedArchiveUpdateInput;
  where: MetadataBrandShortNameWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataByLineListUpdateInput = {
  create: MetadataByLineWithForcedArchiveCreateInput;
  update: MetadataByLineWithForcedArchiveUpdateInput;
  where: MetadataByLineWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCaptionAbstractListUpdateInput = {
  create: MetadataCaptionAbstractWithForcedArchiveCreateInput;
  update: MetadataCaptionAbstractWithForcedArchiveUpdateInput;
  where: MetadataCaptionAbstractWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCaptionListUpdateInput = {
  create: MetadataCaptionWithForcedArchiveCreateInput;
  update: MetadataCaptionWithForcedArchiveUpdateInput;
  where: MetadataCaptionWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCategoryListUpdateInput = {
  create: MetadataCategoryWithForcedArchiveCreateInput;
  update: MetadataCategoryWithForcedArchiveUpdateInput;
  where: MetadataCategoryWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCategoryPrismaListUpdateInput = {
  create: MetadataCategoryPrismaWithForcedArchiveCreateInput;
  update: MetadataCategoryPrismaWithForcedArchiveUpdateInput;
  where: MetadataCategoryPrismaWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCompanyListUpdateInput = {
  create: MetadataCompanyWithForcedArchiveCreateInput;
  update: MetadataCompanyWithForcedArchiveUpdateInput;
  where: MetadataCompanyWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCompanyShortNameListUpdateInput = {
  create: MetadataCompanyShortNameWithForcedArchiveCreateInput;
  update: MetadataCompanyShortNameWithForcedArchiveUpdateInput;
  where: MetadataCompanyShortNameWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCopyrightNoticeListUpdateInput = {
  create: MetadataCopyrightNoticeWithForcedArchiveCreateInput;
  update: MetadataCopyrightNoticeWithForcedArchiveUpdateInput;
  where: MetadataCopyrightNoticeWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCreatorListUpdateInput = {
  create: MetadataCreatorWithForcedArchiveCreateInput;
  update: MetadataCreatorWithForcedArchiveUpdateInput;
  where: MetadataCreatorWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCreditListUpdateInput = {
  create: MetadataCreditWithForcedArchiveCreateInput;
  update: MetadataCreditWithForcedArchiveUpdateInput;
  where: MetadataCreditWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField14ListUpdateInput = {
  create: MetadataCustomField14WithForcedArchiveCreateInput;
  update: MetadataCustomField14WithForcedArchiveUpdateInput;
  where: MetadataCustomField14WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField15ListUpdateInput = {
  create: MetadataCustomField15WithForcedArchiveCreateInput;
  update: MetadataCustomField15WithForcedArchiveUpdateInput;
  where: MetadataCustomField15WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField16ListUpdateInput = {
  create: MetadataCustomField16WithForcedArchiveCreateInput;
  update: MetadataCustomField16WithForcedArchiveUpdateInput;
  where: MetadataCustomField16WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField17ListUpdateInput = {
  create: MetadataCustomField17WithForcedArchiveCreateInput;
  update: MetadataCustomField17WithForcedArchiveUpdateInput;
  where: MetadataCustomField17WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField1ListUpdateInput = {
  create: MetadataCustomField1WithForcedArchiveCreateInput;
  update: MetadataCustomField1WithForcedArchiveUpdateInput;
  where: MetadataCustomField1WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField20ListUpdateInput = {
  create: MetadataCustomField20WithForcedArchiveCreateInput;
  update: MetadataCustomField20WithForcedArchiveUpdateInput;
  where: MetadataCustomField20WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField3ListUpdateInput = {
  create: MetadataCustomField3WithForcedArchiveCreateInput;
  update: MetadataCustomField3WithForcedArchiveUpdateInput;
  where: MetadataCustomField3WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField4ListUpdateInput = {
  create: MetadataCustomField4WithForcedArchiveCreateInput;
  update: MetadataCustomField4WithForcedArchiveUpdateInput;
  where: MetadataCustomField4WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField5ListUpdateInput = {
  create: MetadataCustomField5WithForcedArchiveCreateInput;
  update: MetadataCustomField5WithForcedArchiveUpdateInput;
  where: MetadataCustomField5WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField6ListUpdateInput = {
  create: MetadataCustomField6WithForcedArchiveCreateInput;
  update: MetadataCustomField6WithForcedArchiveUpdateInput;
  where: MetadataCustomField6WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField7ListUpdateInput = {
  create: MetadataCustomField7WithForcedArchiveCreateInput;
  update: MetadataCustomField7WithForcedArchiveUpdateInput;
  where: MetadataCustomField7WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataCustomField9ListUpdateInput = {
  create: MetadataCustomField9WithForcedArchiveCreateInput;
  update: MetadataCustomField9WithForcedArchiveUpdateInput;
  where: MetadataCustomField9WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDateCreatedListUpdateInput = {
  create: MetadataDateCreatedWithForcedArchiveCreateInput;
  update: MetadataDateCreatedWithForcedArchiveUpdateInput;
  where: MetadataDateCreatedWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDateTimeOriginalListUpdateInput = {
  create: MetadataDateTimeOriginalWithForcedArchiveCreateInput;
  update: MetadataDateTimeOriginalWithForcedArchiveUpdateInput;
  where: MetadataDateTimeOriginalWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryAccountListUpdateInput = {
  create: MetadataDeliveryAccountWithForcedArchiveCreateInput;
  update: MetadataDeliveryAccountWithForcedArchiveUpdateInput;
  where: MetadataDeliveryAccountWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryCompanyListUpdateInput = {
  create: MetadataDeliveryCompanyWithForcedArchiveCreateInput;
  update: MetadataDeliveryCompanyWithForcedArchiveUpdateInput;
  where: MetadataDeliveryCompanyWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryCopyrightListUpdateInput = {
  create: MetadataDeliveryCopyrightWithForcedArchiveCreateInput;
  update: MetadataDeliveryCopyrightWithForcedArchiveUpdateInput;
  where: MetadataDeliveryCopyrightWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryDateFolderListUpdateInput = {
  create: MetadataDeliveryDateFolderWithForcedArchiveCreateInput;
  update: MetadataDeliveryDateFolderWithForcedArchiveUpdateInput;
  where: MetadataDeliveryDateFolderWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryDateTimeListUpdateInput = {
  create: MetadataDeliveryDateTimeWithForcedArchiveCreateInput;
  update: MetadataDeliveryDateTimeWithForcedArchiveUpdateInput;
  where: MetadataDeliveryDateTimeWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryDcCreatorListUpdateInput = {
  create: MetadataDeliveryDcCreatorWithForcedArchiveCreateInput;
  update: MetadataDeliveryDcCreatorWithForcedArchiveUpdateInput;
  where: MetadataDeliveryDcCreatorWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryDcRightsListUpdateInput = {
  create: MetadataDeliveryDcRightsWithForcedArchiveCreateInput;
  update: MetadataDeliveryDcRightsWithForcedArchiveUpdateInput;
  where: MetadataDeliveryDcRightsWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryFolderListUpdateInput = {
  create: MetadataDeliveryFolderWithForcedArchiveCreateInput;
  update: MetadataDeliveryFolderWithForcedArchiveUpdateInput;
  where: MetadataDeliveryFolderWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryKindListUpdateInput = {
  create: MetadataDeliveryKindWithForcedArchiveCreateInput;
  update: MetadataDeliveryKindWithForcedArchiveUpdateInput;
  where: MetadataDeliveryKindWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryPathListUpdateInput = {
  create: MetadataDeliveryPathWithForcedArchiveCreateInput;
  update: MetadataDeliveryPathWithForcedArchiveUpdateInput;
  where: MetadataDeliveryPathWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryPhotoshopCreditListUpdateInput = {
  create: MetadataDeliveryPhotoshopCreditWithForcedArchiveCreateInput;
  update: MetadataDeliveryPhotoshopCreditWithForcedArchiveUpdateInput;
  where: MetadataDeliveryPhotoshopCreditWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryPhotoshopSourceListUpdateInput = {
  create: MetadataDeliveryPhotoshopSourceWithForcedArchiveCreateInput;
  update: MetadataDeliveryPhotoshopSourceWithForcedArchiveUpdateInput;
  where: MetadataDeliveryPhotoshopSourceWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryServiceListUpdateInput = {
  create: MetadataDeliveryServiceWithForcedArchiveCreateInput;
  update: MetadataDeliveryServiceWithForcedArchiveUpdateInput;
  where: MetadataDeliveryServiceWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliverySubjectListUpdateInput = {
  create: MetadataDeliverySubjectWithForcedArchiveCreateInput;
  update: MetadataDeliverySubjectWithForcedArchiveUpdateInput;
  where: MetadataDeliverySubjectWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDeliveryUnderSubjectListUpdateInput = {
  create: MetadataDeliveryUnderSubjectWithForcedArchiveCreateInput;
  update: MetadataDeliveryUnderSubjectWithForcedArchiveUpdateInput;
  where: MetadataDeliveryUnderSubjectWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDepartmentListUpdateInput = {
  create: MetadataDepartmentWithForcedArchiveCreateInput;
  update: MetadataDepartmentWithForcedArchiveUpdateInput;
  where: MetadataDepartmentWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataDescriptionListUpdateInput = {
  create: MetadataDescriptionWithForcedArchiveCreateInput;
  update: MetadataDescriptionWithForcedArchiveUpdateInput;
  where: MetadataDescriptionWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataEditionListUpdateInput = {
  create: MetadataEditionWithForcedArchiveCreateInput;
  update: MetadataEditionWithForcedArchiveUpdateInput;
  where: MetadataEditionWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataEditStatusListUpdateInput = {
  create: MetadataEditStatusWithForcedArchiveCreateInput;
  update: MetadataEditStatusWithForcedArchiveUpdateInput;
  where: MetadataEditStatusWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataFileStatusListUpdateInput = {
  create: MetadataFileStatusWithForcedArchiveCreateInput;
  update: MetadataFileStatusWithForcedArchiveUpdateInput;
  where: MetadataFileStatusWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataFormatListUpdateInput = {
  create: MetadataFormatWithForcedArchiveCreateInput;
  update: MetadataFormatWithForcedArchiveUpdateInput;
  where: MetadataFormatWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataHeaderListUpdateInput = {
  create: MetadataHeaderWithForcedArchiveCreateInput;
  update: MetadataHeaderWithForcedArchiveUpdateInput;
  where: MetadataHeaderWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataHeaderPrismaListUpdateInput = {
  create: MetadataHeaderPrismaWithForcedArchiveCreateInput;
  update: MetadataHeaderPrismaWithForcedArchiveUpdateInput;
  where: MetadataHeaderPrismaWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataHeadlineListUpdateInput = {
  create: MetadataHeadlineWithForcedArchiveCreateInput;
  update: MetadataHeadlineWithForcedArchiveUpdateInput;
  where: MetadataHeadlineWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataIdAssignmentListUpdateInput = {
  create: MetadataIdAssignmentWithForcedArchiveCreateInput;
  update: MetadataIdAssignmentWithForcedArchiveUpdateInput;
  where: MetadataIdAssignmentWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataIdPhotoPrismaListUpdateInput = {
  create: MetadataIdPhotoPrismaWithForcedArchiveCreateInput;
  update: MetadataIdPhotoPrismaWithForcedArchiveUpdateInput;
  where: MetadataIdPhotoPrismaWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataIdSubjectListUpdateInput = {
  create: MetadataIdSubjectWithForcedArchiveCreateInput;
  update: MetadataIdSubjectWithForcedArchiveUpdateInput;
  where: MetadataIdSubjectWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataImageNotesListUpdateInput = {
  create: MetadataImageNotesWithForcedArchiveCreateInput;
  update: MetadataImageNotesWithForcedArchiveUpdateInput;
  where: MetadataImageNotesWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataInstructionsListUpdateInput = {
  create: MetadataInstructionsWithForcedArchiveCreateInput;
  update: MetadataInstructionsWithForcedArchiveUpdateInput;
  where: MetadataInstructionsWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataIssueListUpdateInput = {
  create: MetadataIssueWithForcedArchiveCreateInput;
  update: MetadataIssueWithForcedArchiveUpdateInput;
  where: MetadataIssueWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataKeywordsListUpdateInput = {
  create: MetadataKeywordsWithForcedArchiveCreateInput;
  update: MetadataKeywordsWithForcedArchiveUpdateInput;
  where: MetadataKeywordsWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataObjectNameListUpdateInput = {
  create: MetadataObjectNameWithForcedArchiveCreateInput;
  update: MetadataObjectNameWithForcedArchiveUpdateInput;
  where: MetadataObjectNameWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataOriginalNameListUpdateInput = {
  create: MetadataOriginalNameWithForcedArchiveCreateInput;
  update: MetadataOriginalNameWithForcedArchiveUpdateInput;
  where: MetadataOriginalNameWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataPriceLevelListUpdateInput = {
  create: MetadataPriceLevelWithForcedArchiveCreateInput;
  update: MetadataPriceLevelWithForcedArchiveUpdateInput;
  where: MetadataPriceLevelWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataProcessHistoryListUpdateInput = {
  create: MetadataProcessHistoryWithForcedArchiveCreateInput;
  update: MetadataProcessHistoryWithForcedArchiveUpdateInput;
  where: MetadataProcessHistoryWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataProcessStatusListUpdateInput = {
  create: MetadataProcessStatusWithForcedArchiveCreateInput;
  update: MetadataProcessStatusWithForcedArchiveUpdateInput;
  where: MetadataProcessStatusWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataProductListUpdateInput = {
  create: MetadataProductWithForcedArchiveCreateInput;
  update: MetadataProductWithForcedArchiveUpdateInput;
  where: MetadataProductWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataProductsListUpdateInput = {
  create: MetadataProductsWithForcedArchiveCreateInput;
  update: MetadataProductsWithForcedArchiveUpdateInput;
  where: MetadataProductsWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataPublishingSubjectListUpdateInput = {
  create: MetadataPublishingSubjectWithForcedArchiveCreateInput;
  update: MetadataPublishingSubjectWithForcedArchiveUpdateInput;
  where: MetadataPublishingSubjectWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataResolutionKindListUpdateInput = {
  create: MetadataResolutionKindWithForcedArchiveCreateInput;
  update: MetadataResolutionKindWithForcedArchiveUpdateInput;
  where: MetadataResolutionKindWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataRightsListUpdateInput = {
  create: MetadataRightsWithForcedArchiveCreateInput;
  update: MetadataRightsWithForcedArchiveUpdateInput;
  where: MetadataRightsWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataSourceListUpdateInput = {
  create: MetadataSourceWithForcedArchiveCreateInput;
  update: MetadataSourceWithForcedArchiveUpdateInput;
  where: MetadataSourceWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataSpecialInstructionsListUpdateInput = {
  create: MetadataSpecialInstructionsWithForcedArchiveCreateInput;
  update: MetadataSpecialInstructionsWithForcedArchiveUpdateInput;
  where: MetadataSpecialInstructionsWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataSubjectCodeListUpdateInput = {
  create: MetadataSubjectCodeWithForcedArchiveCreateInput;
  update: MetadataSubjectCodeWithForcedArchiveUpdateInput;
  where: MetadataSubjectCodeWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataSubjectListUpdateInput = {
  create: MetadataSubjectWithForcedArchiveCreateInput;
  update: MetadataSubjectWithForcedArchiveUpdateInput;
  where: MetadataSubjectWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataSubjectPrismaListUpdateInput = {
  create: MetadataSubjectPrismaWithForcedArchiveCreateInput;
  update: MetadataSubjectPrismaWithForcedArchiveUpdateInput;
  where: MetadataSubjectPrismaWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataTitleListUpdateInput = {
  create: MetadataTitleWithForcedArchiveCreateInput;
  update: MetadataTitleWithForcedArchiveUpdateInput;
  where: MetadataTitleWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataTransferredByFullNameListUpdateInput = {
  create: MetadataTransferredByFullNameWithForcedArchiveCreateInput;
  update: MetadataTransferredByFullNameWithForcedArchiveUpdateInput;
  where: MetadataTransferredByFullNameWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataTransferredByListUpdateInput = {
  create: MetadataTransferredByWithForcedArchiveCreateInput;
  update: MetadataTransferredByWithForcedArchiveUpdateInput;
  where: MetadataTransferredByWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataTypeListUpdateInput = {
  create: MetadataTypeWithForcedArchiveCreateInput;
  update: MetadataTypeWithForcedArchiveUpdateInput;
  where: MetadataTypeWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUndersubjectListUpdateInput = {
  create: MetadataUndersubjectWithForcedArchiveCreateInput;
  update: MetadataUndersubjectWithForcedArchiveUpdateInput;
  where: MetadataUndersubjectWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUnderUnderSubjectListUpdateInput = {
  create: MetadataUnderUnderSubjectWithForcedArchiveCreateInput;
  update: MetadataUnderUnderSubjectWithForcedArchiveUpdateInput;
  where: MetadataUnderUnderSubjectWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUploadedByFullNameListUpdateInput = {
  create: MetadataUploadedByFullNameWithForcedArchiveCreateInput;
  update: MetadataUploadedByFullNameWithForcedArchiveUpdateInput;
  where: MetadataUploadedByFullNameWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUploadedByListUpdateInput = {
  create: MetadataUploadedByWithForcedArchiveCreateInput;
  update: MetadataUploadedByWithForcedArchiveUpdateInput;
  where: MetadataUploadedByWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUploadTimeListUpdateInput = {
  create: MetadataUploadTimeWithForcedArchiveCreateInput;
  update: MetadataUploadTimeWithForcedArchiveUpdateInput;
  where: MetadataUploadTimeWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUrgencyListUpdateInput = {
  create: MetadataUrgencyWithForcedArchiveCreateInput;
  update: MetadataUrgencyWithForcedArchiveUpdateInput;
  where: MetadataUrgencyWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUserDefined195ListUpdateInput = {
  create: MetadataUserDefined195WithForcedArchiveCreateInput;
  update: MetadataUserDefined195WithForcedArchiveUpdateInput;
  where: MetadataUserDefined195WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUserDefined237ListUpdateInput = {
  create: MetadataUserDefined237WithForcedArchiveCreateInput;
  update: MetadataUserDefined237WithForcedArchiveUpdateInput;
  where: MetadataUserDefined237WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUserDefined238ListUpdateInput = {
  create: MetadataUserDefined238WithForcedArchiveCreateInput;
  update: MetadataUserDefined238WithForcedArchiveUpdateInput;
  where: MetadataUserDefined238WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUserDefined239ListUpdateInput = {
  create: MetadataUserDefined239WithForcedArchiveCreateInput;
  update: MetadataUserDefined239WithForcedArchiveUpdateInput;
  where: MetadataUserDefined239WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUserDefined242ListUpdateInput = {
  create: MetadataUserDefined242WithForcedArchiveCreateInput;
  update: MetadataUserDefined242WithForcedArchiveUpdateInput;
  where: MetadataUserDefined242WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataUserDefined62ListUpdateInput = {
  create: MetadataUserDefined62WithForcedArchiveCreateInput;
  update: MetadataUserDefined62WithForcedArchiveUpdateInput;
  where: MetadataUserDefined62WhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataWorkflowKindListUpdateInput = {
  create: MetadataWorkflowKindWithForcedArchiveCreateInput;
  update: MetadataWorkflowKindWithForcedArchiveUpdateInput;
  where: MetadataWorkflowKindWhereUniqueInput;
};

export type ArchiveNestedUpsertMetadataXmpHistoryListUpdateInput = {
  create: MetadataXmpHistoryWithForcedArchiveCreateInput;
  update: MetadataXmpHistoryWithForcedArchiveUpdateInput;
  where: MetadataXmpHistoryWhereUniqueInput;
};

export type ArchiveNestedUpsertPhotoMetadatasUpdateInput = {
  create: PhotoMetadataWithForcedArchiveCreateInput;
  update: PhotoMetadataWithForcedArchiveUpdateInput;
  where: PhotoMetadataWhereUniqueInput;
};

export type ArchiveNestedUpsertPhotosUpdateInput = {
  create: PhotoWithForcedArchiveCreateInput;
  update: PhotoWithForcedArchiveUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum ArchiveOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  archiveId_ASC = 'archiveId_ASC',
  archiveId_DESC = 'archiveId_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  hasCategories_ASC = 'hasCategories_ASC',
  hasCategories_DESC = 'hasCategories_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** "ArchivePurgeSetting" resource's node */
export type ArchivePurgeSetting = {
  __typename?: 'ArchivePurgeSetting';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID */
  id: Scalars['Int']['output'];
  /** Retention period in days before a photo becomes eligible for purge */
  period?: Maybe<Scalars['Int']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type ArchivePurgeSettingCreateInput = {
  /** Actions for the "ArchivePurgeSetting.archive" relation */
  archive: ArchivePurgeSettingNestedArchiveCreateInput;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retention period in days before a photo becomes eligible for purge */
  period?: InputMaybe<Scalars['Int']['input']>;
};

export type ArchivePurgeSettingNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "ArchivePurgeSetting" node, through the "ArchivePurgeSetting.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "ArchivePurgeSetting" node, through the "ArchivePurgeSetting.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "ArchivePurgeSetting" node, through the "ArchivePurgeSetting.archive" relation. */
  update?: InputMaybe<ArchivePurgeSettingNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "ArchivePurgeSetting" node, through the "ArchivePurgeSetting.archive" relation. */
  upsert?: InputMaybe<ArchivePurgeSettingNestedUpsertArchiveCreateInput>;
};

export type ArchivePurgeSettingNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "ArchivePurgeSetting" node, through the "ArchivePurgeSetting.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "ArchivePurgeSetting" node, through the "ArchivePurgeSetting.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "ArchivePurgeSetting" node, through the "ArchivePurgeSetting.archive" relation. */
  update?: InputMaybe<ArchivePurgeSettingNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "ArchivePurgeSetting" node, through the "ArchivePurgeSetting.archive" relation. */
  upsert?: InputMaybe<ArchivePurgeSettingNestedUpsertArchiveUpdateInput>;
};

export type ArchivePurgeSettingNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ArchivePurgeSettingNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ArchivePurgeSettingNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ArchivePurgeSettingNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export enum ArchivePurgeSettingOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  enabled_ASC = 'enabled_ASC',
  enabled_DESC = 'enabled_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  period_ASC = 'period_ASC',
  period_DESC = 'period_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ArchivePurgeSettingUpdateInput = {
  /** Actions for the "ArchivePurgeSetting.archive" relation */
  archive?: InputMaybe<ArchivePurgeSettingNestedArchiveUpdateInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retention period in days before a photo becomes eligible for purge */
  period?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "ArchivePurgeSetting" nodes by specifying some conditions */
export type ArchivePurgeSettingWhereInput = {
  AND?: InputMaybe<Array<ArchivePurgeSettingWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  enabled_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  NOT?: InputMaybe<ArchivePurgeSettingWhereInput>;
  OR?: InputMaybe<Array<ArchivePurgeSettingWhereInput>>;
  period?: InputMaybe<Scalars['Int']['input']>;
  period_gt?: InputMaybe<Scalars['Int']['input']>;
  period_gte?: InputMaybe<Scalars['Int']['input']>;
  period_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  period_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  period_lt?: InputMaybe<Scalars['Int']['input']>;
  period_lte?: InputMaybe<Scalars['Int']['input']>;
  period_not?: InputMaybe<Scalars['Int']['input']>;
  period_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "ArchivePurgeSetting" node with one of these unique values:
 * - id
 * - archive
 */
export type ArchivePurgeSettingWhereUniqueInput = {
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type ArchivePurgeSettingWithForcedArchiveCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retention period in days before a photo becomes eligible for purge */
  period?: InputMaybe<Scalars['Int']['input']>;
};

export type ArchivePurgeSettingWithForcedArchiveUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Retention period in days before a photo becomes eligible for purge */
  period?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a known "archive", identifies exactly one "ArchivePurgeSetting" node with one of these unique values:
 * - id
 * - archive (optional)
 */
export type ArchivePurgeSettingWithOptionalArchiveWhereUniqueInput = {
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum ArchiveType {
  ARCHIVE = 'ARCHIVE',
  DELIVERY = 'DELIVERY',
  NEWS = 'NEWS',
  SUJET = 'SUJET'
}

export type ArchiveUpdateInput = {
  /** Actions for the "Archive.archiveAgencies" relation: "ArchiveAgency.archive"'s inverse relation */
  archiveAgencies?: InputMaybe<ArchiveNestedArchiveAgenciesUpdateInput>;
  /** Actions for the "Archive.archivePurgeSetting" relation: "ArchivePurgeSetting.archive"'s inverse relation */
  archivePurgeSetting?: InputMaybe<ArchiveNestedArchivePurgeSettingUpdateInput>;
  /** Actions for the "Archive.categories" relation: "Category.archive"'s inverse relation */
  categories?: InputMaybe<ArchiveNestedCategoriesUpdateInput>;
  /** Actions for the "Archive.deliverySubjects" relation: "DeliverySubject.archive"'s inverse relation */
  deliverySubjects?: InputMaybe<ArchiveNestedDeliverySubjectsUpdateInput>;
  /** Actions for the "Archive.gcImportSetting" relation: "GcImportSetting.archive"'s inverse relation */
  gcImportSetting?: InputMaybe<ArchiveNestedGcImportSettingUpdateInput>;
  hasCategories?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Archive.importQueues" relation: "ImportQueue.archive"'s inverse relation */
  importQueues?: InputMaybe<ArchiveNestedImportQueuesUpdateInput>;
  /** The archive label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Archive.metadataAccessRightsList" relation: "MetadataAccessRights.archive"'s inverse relation */
  metadataAccessRightsList?: InputMaybe<ArchiveNestedMetadataAccessRightsListUpdateInput>;
  /** Actions for the "Archive.metadataAssetStateList" relation: "MetadataAssetState.archive"'s inverse relation */
  metadataAssetStateList?: InputMaybe<ArchiveNestedMetadataAssetStateListUpdateInput>;
  /** Actions for the "Archive.metadataBackupNameList" relation: "MetadataBackupName.archive"'s inverse relation */
  metadataBackupNameList?: InputMaybe<ArchiveNestedMetadataBackupNameListUpdateInput>;
  /** Actions for the "Archive.metadataBrandList" relation: "MetadataBrand.archive"'s inverse relation */
  metadataBrandList?: InputMaybe<ArchiveNestedMetadataBrandListUpdateInput>;
  /** Actions for the "Archive.metadataBrandPrismaList" relation: "MetadataBrandPrisma.archive"'s inverse relation */
  metadataBrandPrismaList?: InputMaybe<ArchiveNestedMetadataBrandPrismaListUpdateInput>;
  /** Actions for the "Archive.metadataBrandShortNameList" relation: "MetadataBrandShortName.archive"'s inverse relation */
  metadataBrandShortNameList?: InputMaybe<ArchiveNestedMetadataBrandShortNameListUpdateInput>;
  /** Actions for the "Archive.metadataByLineList" relation: "MetadataByLine.archive"'s inverse relation */
  metadataByLineList?: InputMaybe<ArchiveNestedMetadataByLineListUpdateInput>;
  /** Actions for the "Archive.metadataCaptionAbstractList" relation: "MetadataCaptionAbstract.archive"'s inverse relation */
  metadataCaptionAbstractList?: InputMaybe<ArchiveNestedMetadataCaptionAbstractListUpdateInput>;
  /** Actions for the "Archive.metadataCaptionList" relation: "MetadataCaption.archive"'s inverse relation */
  metadataCaptionList?: InputMaybe<ArchiveNestedMetadataCaptionListUpdateInput>;
  /** Actions for the "Archive.metadataCategoryList" relation: "MetadataCategory.archive"'s inverse relation */
  metadataCategoryList?: InputMaybe<ArchiveNestedMetadataCategoryListUpdateInput>;
  /** Actions for the "Archive.metadataCategoryPrismaList" relation: "MetadataCategoryPrisma.archive"'s inverse relation */
  metadataCategoryPrismaList?: InputMaybe<ArchiveNestedMetadataCategoryPrismaListUpdateInput>;
  /** Actions for the "Archive.metadataCompanyList" relation: "MetadataCompany.archive"'s inverse relation */
  metadataCompanyList?: InputMaybe<ArchiveNestedMetadataCompanyListUpdateInput>;
  /** Actions for the "Archive.metadataCompanyShortNameList" relation: "MetadataCompanyShortName.archive"'s inverse relation */
  metadataCompanyShortNameList?: InputMaybe<ArchiveNestedMetadataCompanyShortNameListUpdateInput>;
  /** Actions for the "Archive.metadataCopyrightNoticeList" relation: "MetadataCopyrightNotice.archive"'s inverse relation */
  metadataCopyrightNoticeList?: InputMaybe<ArchiveNestedMetadataCopyrightNoticeListUpdateInput>;
  /** Actions for the "Archive.metadataCreatorList" relation: "MetadataCreator.archive"'s inverse relation */
  metadataCreatorList?: InputMaybe<ArchiveNestedMetadataCreatorListUpdateInput>;
  /** Actions for the "Archive.metadataCreditList" relation: "MetadataCredit.archive"'s inverse relation */
  metadataCreditList?: InputMaybe<ArchiveNestedMetadataCreditListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField14List" relation: "MetadataCustomField14.archive"'s inverse relation */
  metadataCustomField14List?: InputMaybe<ArchiveNestedMetadataCustomField14ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField15List" relation: "MetadataCustomField15.archive"'s inverse relation */
  metadataCustomField15List?: InputMaybe<ArchiveNestedMetadataCustomField15ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField16List" relation: "MetadataCustomField16.archive"'s inverse relation */
  metadataCustomField16List?: InputMaybe<ArchiveNestedMetadataCustomField16ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField17List" relation: "MetadataCustomField17.archive"'s inverse relation */
  metadataCustomField17List?: InputMaybe<ArchiveNestedMetadataCustomField17ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField1List" relation: "MetadataCustomField1.archive"'s inverse relation */
  metadataCustomField1List?: InputMaybe<ArchiveNestedMetadataCustomField1ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField20List" relation: "MetadataCustomField20.archive"'s inverse relation */
  metadataCustomField20List?: InputMaybe<ArchiveNestedMetadataCustomField20ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField3List" relation: "MetadataCustomField3.archive"'s inverse relation */
  metadataCustomField3List?: InputMaybe<ArchiveNestedMetadataCustomField3ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField4List" relation: "MetadataCustomField4.archive"'s inverse relation */
  metadataCustomField4List?: InputMaybe<ArchiveNestedMetadataCustomField4ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField5List" relation: "MetadataCustomField5.archive"'s inverse relation */
  metadataCustomField5List?: InputMaybe<ArchiveNestedMetadataCustomField5ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField6List" relation: "MetadataCustomField6.archive"'s inverse relation */
  metadataCustomField6List?: InputMaybe<ArchiveNestedMetadataCustomField6ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField7List" relation: "MetadataCustomField7.archive"'s inverse relation */
  metadataCustomField7List?: InputMaybe<ArchiveNestedMetadataCustomField7ListUpdateInput>;
  /** Actions for the "Archive.metadataCustomField9List" relation: "MetadataCustomField9.archive"'s inverse relation */
  metadataCustomField9List?: InputMaybe<ArchiveNestedMetadataCustomField9ListUpdateInput>;
  /** Actions for the "Archive.metadataDateCreatedList" relation: "MetadataDateCreated.archive"'s inverse relation */
  metadataDateCreatedList?: InputMaybe<ArchiveNestedMetadataDateCreatedListUpdateInput>;
  /** Actions for the "Archive.metadataDateTimeOriginalList" relation: "MetadataDateTimeOriginal.archive"'s inverse relation */
  metadataDateTimeOriginalList?: InputMaybe<ArchiveNestedMetadataDateTimeOriginalListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryAccountList" relation: "MetadataDeliveryAccount.archive"'s inverse relation */
  metadataDeliveryAccountList?: InputMaybe<ArchiveNestedMetadataDeliveryAccountListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryCompanyList" relation: "MetadataDeliveryCompany.archive"'s inverse relation */
  metadataDeliveryCompanyList?: InputMaybe<ArchiveNestedMetadataDeliveryCompanyListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryCopyrightList" relation: "MetadataDeliveryCopyright.archive"'s inverse relation */
  metadataDeliveryCopyrightList?: InputMaybe<ArchiveNestedMetadataDeliveryCopyrightListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryDateFolderList" relation: "MetadataDeliveryDateFolder.archive"'s inverse relation */
  metadataDeliveryDateFolderList?: InputMaybe<ArchiveNestedMetadataDeliveryDateFolderListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryDateTimeList" relation: "MetadataDeliveryDateTime.archive"'s inverse relation */
  metadataDeliveryDateTimeList?: InputMaybe<ArchiveNestedMetadataDeliveryDateTimeListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryDcCreatorList" relation: "MetadataDeliveryDcCreator.archive"'s inverse relation */
  metadataDeliveryDcCreatorList?: InputMaybe<ArchiveNestedMetadataDeliveryDcCreatorListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryDcRightsList" relation: "MetadataDeliveryDcRights.archive"'s inverse relation */
  metadataDeliveryDcRightsList?: InputMaybe<ArchiveNestedMetadataDeliveryDcRightsListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryFolderList" relation: "MetadataDeliveryFolder.archive"'s inverse relation */
  metadataDeliveryFolderList?: InputMaybe<ArchiveNestedMetadataDeliveryFolderListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryKindList" relation: "MetadataDeliveryKind.archive"'s inverse relation */
  metadataDeliveryKindList?: InputMaybe<ArchiveNestedMetadataDeliveryKindListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryPathList" relation: "MetadataDeliveryPath.archive"'s inverse relation */
  metadataDeliveryPathList?: InputMaybe<ArchiveNestedMetadataDeliveryPathListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryPhotoshopCreditList" relation: "MetadataDeliveryPhotoshopCredit.archive"'s inverse relation */
  metadataDeliveryPhotoshopCreditList?: InputMaybe<ArchiveNestedMetadataDeliveryPhotoshopCreditListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryPhotoshopSourceList" relation: "MetadataDeliveryPhotoshopSource.archive"'s inverse relation */
  metadataDeliveryPhotoshopSourceList?: InputMaybe<ArchiveNestedMetadataDeliveryPhotoshopSourceListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryServiceList" relation: "MetadataDeliveryService.archive"'s inverse relation */
  metadataDeliveryServiceList?: InputMaybe<ArchiveNestedMetadataDeliveryServiceListUpdateInput>;
  /** Actions for the "Archive.metadataDeliverySubjectList" relation: "MetadataDeliverySubject.archive"'s inverse relation */
  metadataDeliverySubjectList?: InputMaybe<ArchiveNestedMetadataDeliverySubjectListUpdateInput>;
  /** Actions for the "Archive.metadataDeliveryUnderSubjectList" relation: "MetadataDeliveryUnderSubject.archive"'s inverse relation */
  metadataDeliveryUnderSubjectList?: InputMaybe<ArchiveNestedMetadataDeliveryUnderSubjectListUpdateInput>;
  /** Actions for the "Archive.metadataDepartmentList" relation: "MetadataDepartment.archive"'s inverse relation */
  metadataDepartmentList?: InputMaybe<ArchiveNestedMetadataDepartmentListUpdateInput>;
  /** Actions for the "Archive.metadataDescriptionList" relation: "MetadataDescription.archive"'s inverse relation */
  metadataDescriptionList?: InputMaybe<ArchiveNestedMetadataDescriptionListUpdateInput>;
  /** Actions for the "Archive.metadataEditionList" relation: "MetadataEdition.archive"'s inverse relation */
  metadataEditionList?: InputMaybe<ArchiveNestedMetadataEditionListUpdateInput>;
  /** Actions for the "Archive.metadataEditStatusList" relation: "MetadataEditStatus.archive"'s inverse relation */
  metadataEditStatusList?: InputMaybe<ArchiveNestedMetadataEditStatusListUpdateInput>;
  /** Actions for the "Archive.metadataFileStatusList" relation: "MetadataFileStatus.archive"'s inverse relation */
  metadataFileStatusList?: InputMaybe<ArchiveNestedMetadataFileStatusListUpdateInput>;
  /** Actions for the "Archive.metadataFormatList" relation: "MetadataFormat.archive"'s inverse relation */
  metadataFormatList?: InputMaybe<ArchiveNestedMetadataFormatListUpdateInput>;
  /** Actions for the "Archive.metadataHeaderList" relation: "MetadataHeader.archive"'s inverse relation */
  metadataHeaderList?: InputMaybe<ArchiveNestedMetadataHeaderListUpdateInput>;
  /** Actions for the "Archive.metadataHeaderPrismaList" relation: "MetadataHeaderPrisma.archive"'s inverse relation */
  metadataHeaderPrismaList?: InputMaybe<ArchiveNestedMetadataHeaderPrismaListUpdateInput>;
  /** Actions for the "Archive.metadataHeadlineList" relation: "MetadataHeadline.archive"'s inverse relation */
  metadataHeadlineList?: InputMaybe<ArchiveNestedMetadataHeadlineListUpdateInput>;
  /** Actions for the "Archive.metadataIdAssignmentList" relation: "MetadataIdAssignment.archive"'s inverse relation */
  metadataIdAssignmentList?: InputMaybe<ArchiveNestedMetadataIdAssignmentListUpdateInput>;
  /** Actions for the "Archive.metadataIdPhotoPrismaList" relation: "MetadataIdPhotoPrisma.archive"'s inverse relation */
  metadataIdPhotoPrismaList?: InputMaybe<ArchiveNestedMetadataIdPhotoPrismaListUpdateInput>;
  /** Actions for the "Archive.metadataIdSubjectList" relation: "MetadataIdSubject.archive"'s inverse relation */
  metadataIdSubjectList?: InputMaybe<ArchiveNestedMetadataIdSubjectListUpdateInput>;
  /** Actions for the "Archive.metadataImageNotesList" relation: "MetadataImageNotes.archive"'s inverse relation */
  metadataImageNotesList?: InputMaybe<ArchiveNestedMetadataImageNotesListUpdateInput>;
  /** Actions for the "Archive.metadataInstructionsList" relation: "MetadataInstructions.archive"'s inverse relation */
  metadataInstructionsList?: InputMaybe<ArchiveNestedMetadataInstructionsListUpdateInput>;
  /** Actions for the "Archive.metadataIssueList" relation: "MetadataIssue.archive"'s inverse relation */
  metadataIssueList?: InputMaybe<ArchiveNestedMetadataIssueListUpdateInput>;
  /** Actions for the "Archive.metadataKeywordsList" relation: "MetadataKeywords.archive"'s inverse relation */
  metadataKeywordsList?: InputMaybe<ArchiveNestedMetadataKeywordsListUpdateInput>;
  /** Actions for the "Archive.metadataObjectNameList" relation: "MetadataObjectName.archive"'s inverse relation */
  metadataObjectNameList?: InputMaybe<ArchiveNestedMetadataObjectNameListUpdateInput>;
  /** Actions for the "Archive.metadataOriginalNameList" relation: "MetadataOriginalName.archive"'s inverse relation */
  metadataOriginalNameList?: InputMaybe<ArchiveNestedMetadataOriginalNameListUpdateInput>;
  /** Actions for the "Archive.metadataPriceLevelList" relation: "MetadataPriceLevel.archive"'s inverse relation */
  metadataPriceLevelList?: InputMaybe<ArchiveNestedMetadataPriceLevelListUpdateInput>;
  /** Actions for the "Archive.metadataProcessHistoryList" relation: "MetadataProcessHistory.archive"'s inverse relation */
  metadataProcessHistoryList?: InputMaybe<ArchiveNestedMetadataProcessHistoryListUpdateInput>;
  /** Actions for the "Archive.metadataProcessStatusList" relation: "MetadataProcessStatus.archive"'s inverse relation */
  metadataProcessStatusList?: InputMaybe<ArchiveNestedMetadataProcessStatusListUpdateInput>;
  /** Actions for the "Archive.metadataProductList" relation: "MetadataProduct.archive"'s inverse relation */
  metadataProductList?: InputMaybe<ArchiveNestedMetadataProductListUpdateInput>;
  /** Actions for the "Archive.metadataProductsList" relation: "MetadataProducts.archive"'s inverse relation */
  metadataProductsList?: InputMaybe<ArchiveNestedMetadataProductsListUpdateInput>;
  /** Actions for the "Archive.metadataPublishingSubjectList" relation: "MetadataPublishingSubject.archive"'s inverse relation */
  metadataPublishingSubjectList?: InputMaybe<ArchiveNestedMetadataPublishingSubjectListUpdateInput>;
  /** Actions for the "Archive.metadataResolutionKindList" relation: "MetadataResolutionKind.archive"'s inverse relation */
  metadataResolutionKindList?: InputMaybe<ArchiveNestedMetadataResolutionKindListUpdateInput>;
  /** Actions for the "Archive.metadataRightsList" relation: "MetadataRights.archive"'s inverse relation */
  metadataRightsList?: InputMaybe<ArchiveNestedMetadataRightsListUpdateInput>;
  /** Actions for the "Archive.metadataSourceList" relation: "MetadataSource.archive"'s inverse relation */
  metadataSourceList?: InputMaybe<ArchiveNestedMetadataSourceListUpdateInput>;
  /** Actions for the "Archive.metadataSpecialInstructionsList" relation: "MetadataSpecialInstructions.archive"'s inverse relation */
  metadataSpecialInstructionsList?: InputMaybe<ArchiveNestedMetadataSpecialInstructionsListUpdateInput>;
  /** Actions for the "Archive.metadataSubjectCodeList" relation: "MetadataSubjectCode.archive"'s inverse relation */
  metadataSubjectCodeList?: InputMaybe<ArchiveNestedMetadataSubjectCodeListUpdateInput>;
  /** Actions for the "Archive.metadataSubjectList" relation: "MetadataSubject.archive"'s inverse relation */
  metadataSubjectList?: InputMaybe<ArchiveNestedMetadataSubjectListUpdateInput>;
  /** Actions for the "Archive.metadataSubjectPrismaList" relation: "MetadataSubjectPrisma.archive"'s inverse relation */
  metadataSubjectPrismaList?: InputMaybe<ArchiveNestedMetadataSubjectPrismaListUpdateInput>;
  /** Actions for the "Archive.metadataTitleList" relation: "MetadataTitle.archive"'s inverse relation */
  metadataTitleList?: InputMaybe<ArchiveNestedMetadataTitleListUpdateInput>;
  /** Actions for the "Archive.metadataTransferredByFullNameList" relation: "MetadataTransferredByFullName.archive"'s inverse relation */
  metadataTransferredByFullNameList?: InputMaybe<ArchiveNestedMetadataTransferredByFullNameListUpdateInput>;
  /** Actions for the "Archive.metadataTransferredByList" relation: "MetadataTransferredBy.archive"'s inverse relation */
  metadataTransferredByList?: InputMaybe<ArchiveNestedMetadataTransferredByListUpdateInput>;
  /** Actions for the "Archive.metadataTypeList" relation: "MetadataType.archive"'s inverse relation */
  metadataTypeList?: InputMaybe<ArchiveNestedMetadataTypeListUpdateInput>;
  /** Actions for the "Archive.metadataUndersubjectList" relation: "MetadataUndersubject.archive"'s inverse relation */
  metadataUndersubjectList?: InputMaybe<ArchiveNestedMetadataUndersubjectListUpdateInput>;
  /** Actions for the "Archive.metadataUnderUnderSubjectList" relation: "MetadataUnderUnderSubject.archive"'s inverse relation */
  metadataUnderUnderSubjectList?: InputMaybe<ArchiveNestedMetadataUnderUnderSubjectListUpdateInput>;
  /** Actions for the "Archive.metadataUploadedByFullNameList" relation: "MetadataUploadedByFullName.archive"'s inverse relation */
  metadataUploadedByFullNameList?: InputMaybe<ArchiveNestedMetadataUploadedByFullNameListUpdateInput>;
  /** Actions for the "Archive.metadataUploadedByList" relation: "MetadataUploadedBy.archive"'s inverse relation */
  metadataUploadedByList?: InputMaybe<ArchiveNestedMetadataUploadedByListUpdateInput>;
  /** Actions for the "Archive.metadataUploadTimeList" relation: "MetadataUploadTime.archive"'s inverse relation */
  metadataUploadTimeList?: InputMaybe<ArchiveNestedMetadataUploadTimeListUpdateInput>;
  /** Actions for the "Archive.metadataUrgencyList" relation: "MetadataUrgency.archive"'s inverse relation */
  metadataUrgencyList?: InputMaybe<ArchiveNestedMetadataUrgencyListUpdateInput>;
  /** Actions for the "Archive.metadataUserDefined195List" relation: "MetadataUserDefined195.archive"'s inverse relation */
  metadataUserDefined195List?: InputMaybe<ArchiveNestedMetadataUserDefined195ListUpdateInput>;
  /** Actions for the "Archive.metadataUserDefined237List" relation: "MetadataUserDefined237.archive"'s inverse relation */
  metadataUserDefined237List?: InputMaybe<ArchiveNestedMetadataUserDefined237ListUpdateInput>;
  /** Actions for the "Archive.metadataUserDefined238List" relation: "MetadataUserDefined238.archive"'s inverse relation */
  metadataUserDefined238List?: InputMaybe<ArchiveNestedMetadataUserDefined238ListUpdateInput>;
  /** Actions for the "Archive.metadataUserDefined239List" relation: "MetadataUserDefined239.archive"'s inverse relation */
  metadataUserDefined239List?: InputMaybe<ArchiveNestedMetadataUserDefined239ListUpdateInput>;
  /** Actions for the "Archive.metadataUserDefined242List" relation: "MetadataUserDefined242.archive"'s inverse relation */
  metadataUserDefined242List?: InputMaybe<ArchiveNestedMetadataUserDefined242ListUpdateInput>;
  /** Actions for the "Archive.metadataUserDefined62List" relation: "MetadataUserDefined62.archive"'s inverse relation */
  metadataUserDefined62List?: InputMaybe<ArchiveNestedMetadataUserDefined62ListUpdateInput>;
  /** Actions for the "Archive.metadataWorkflowKindList" relation: "MetadataWorkflowKind.archive"'s inverse relation */
  metadataWorkflowKindList?: InputMaybe<ArchiveNestedMetadataWorkflowKindListUpdateInput>;
  /** Actions for the "Archive.metadataXmpHistoryList" relation: "MetadataXmpHistory.archive"'s inverse relation */
  metadataXmpHistoryList?: InputMaybe<ArchiveNestedMetadataXmpHistoryListUpdateInput>;
  /** The archive name */
  name?: InputMaybe<ArchiveKeyType>;
  /** Actions for the "Archive.photoMetadatas" relation: "PhotoMetadata.archive"'s inverse relation */
  photoMetadatas?: InputMaybe<ArchiveNestedPhotoMetadatasUpdateInput>;
  /** Actions for the "Archive.photos" relation: "Photo.archive"'s inverse relation */
  photos?: InputMaybe<ArchiveNestedPhotosUpdateInput>;
  /** The archive type */
  type?: InputMaybe<ArchiveType>;
};

/** Filters the "Archive" nodes by specifying some conditions */
export type ArchiveWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<ArchiveWhereInput>>;
  archiveAgencies_some?: InputMaybe<ArchiveAgencyWhereInput>;
  archiveId?: InputMaybe<Scalars['Int']['input']>;
  archiveId_gt?: InputMaybe<Scalars['Int']['input']>;
  archiveId_gte?: InputMaybe<Scalars['Int']['input']>;
  archiveId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  archiveId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  archiveId_lt?: InputMaybe<Scalars['Int']['input']>;
  archiveId_lte?: InputMaybe<Scalars['Int']['input']>;
  archiveId_not?: InputMaybe<Scalars['Int']['input']>;
  archiveId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  archivePurgeSetting?: InputMaybe<ArchivePurgeSettingWhereInput>;
  archivePurgeSetting_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  categories_some?: InputMaybe<CategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  deliverySubjects_some?: InputMaybe<DeliverySubjectWhereInput>;
  gcImportSetting?: InputMaybe<GcImportSettingWhereInput>;
  gcImportSetting_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  hasCategories?: InputMaybe<Scalars['Boolean']['input']>;
  hasCategories_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  hasCategories_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  hasCategories_not?: InputMaybe<Scalars['Boolean']['input']>;
  hasCategories_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  importQueues_some?: InputMaybe<ImportQueueWhereInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_gt?: InputMaybe<Scalars['String']['input']>;
  label_gte?: InputMaybe<Scalars['String']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  label_lt?: InputMaybe<Scalars['String']['input']>;
  label_lte?: InputMaybe<Scalars['String']['input']>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  metadataAccessRightsList_some?: InputMaybe<MetadataAccessRightsWhereInput>;
  metadataAssetStateList_some?: InputMaybe<MetadataAssetStateWhereInput>;
  metadataBackupNameList_some?: InputMaybe<MetadataBackupNameWhereInput>;
  metadataBrandList_some?: InputMaybe<MetadataBrandWhereInput>;
  metadataBrandPrismaList_some?: InputMaybe<MetadataBrandPrismaWhereInput>;
  metadataBrandShortNameList_some?: InputMaybe<MetadataBrandShortNameWhereInput>;
  metadataByLineList_some?: InputMaybe<MetadataByLineWhereInput>;
  metadataCaptionAbstractList_some?: InputMaybe<MetadataCaptionAbstractWhereInput>;
  metadataCaptionList_some?: InputMaybe<MetadataCaptionWhereInput>;
  metadataCategoryList_some?: InputMaybe<MetadataCategoryWhereInput>;
  metadataCategoryPrismaList_some?: InputMaybe<MetadataCategoryPrismaWhereInput>;
  metadataCompanyList_some?: InputMaybe<MetadataCompanyWhereInput>;
  metadataCompanyShortNameList_some?: InputMaybe<MetadataCompanyShortNameWhereInput>;
  metadataCopyrightNoticeList_some?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
  metadataCreatorList_some?: InputMaybe<MetadataCreatorWhereInput>;
  metadataCreditList_some?: InputMaybe<MetadataCreditWhereInput>;
  metadataCustomField14List_some?: InputMaybe<MetadataCustomField14WhereInput>;
  metadataCustomField15List_some?: InputMaybe<MetadataCustomField15WhereInput>;
  metadataCustomField16List_some?: InputMaybe<MetadataCustomField16WhereInput>;
  metadataCustomField17List_some?: InputMaybe<MetadataCustomField17WhereInput>;
  metadataCustomField1List_some?: InputMaybe<MetadataCustomField1WhereInput>;
  metadataCustomField20List_some?: InputMaybe<MetadataCustomField20WhereInput>;
  metadataCustomField3List_some?: InputMaybe<MetadataCustomField3WhereInput>;
  metadataCustomField4List_some?: InputMaybe<MetadataCustomField4WhereInput>;
  metadataCustomField5List_some?: InputMaybe<MetadataCustomField5WhereInput>;
  metadataCustomField6List_some?: InputMaybe<MetadataCustomField6WhereInput>;
  metadataCustomField7List_some?: InputMaybe<MetadataCustomField7WhereInput>;
  metadataCustomField9List_some?: InputMaybe<MetadataCustomField9WhereInput>;
  metadataDateCreatedList_some?: InputMaybe<MetadataDateCreatedWhereInput>;
  metadataDateTimeOriginalList_some?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
  metadataDeliveryAccountList_some?: InputMaybe<MetadataDeliveryAccountWhereInput>;
  metadataDeliveryCompanyList_some?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
  metadataDeliveryCopyrightList_some?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
  metadataDeliveryDateFolderList_some?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
  metadataDeliveryDateTimeList_some?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
  metadataDeliveryDcCreatorList_some?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
  metadataDeliveryDcRightsList_some?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
  metadataDeliveryFolderList_some?: InputMaybe<MetadataDeliveryFolderWhereInput>;
  metadataDeliveryKindList_some?: InputMaybe<MetadataDeliveryKindWhereInput>;
  metadataDeliveryPathList_some?: InputMaybe<MetadataDeliveryPathWhereInput>;
  metadataDeliveryPhotoshopCreditList_some?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
  metadataDeliveryPhotoshopSourceList_some?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
  metadataDeliveryServiceList_some?: InputMaybe<MetadataDeliveryServiceWhereInput>;
  metadataDeliverySubjectList_some?: InputMaybe<MetadataDeliverySubjectWhereInput>;
  metadataDeliveryUnderSubjectList_some?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
  metadataDepartmentList_some?: InputMaybe<MetadataDepartmentWhereInput>;
  metadataDescriptionList_some?: InputMaybe<MetadataDescriptionWhereInput>;
  metadataEditionList_some?: InputMaybe<MetadataEditionWhereInput>;
  metadataEditStatusList_some?: InputMaybe<MetadataEditStatusWhereInput>;
  metadataFileStatusList_some?: InputMaybe<MetadataFileStatusWhereInput>;
  metadataFormatList_some?: InputMaybe<MetadataFormatWhereInput>;
  metadataHeaderList_some?: InputMaybe<MetadataHeaderWhereInput>;
  metadataHeaderPrismaList_some?: InputMaybe<MetadataHeaderPrismaWhereInput>;
  metadataHeadlineList_some?: InputMaybe<MetadataHeadlineWhereInput>;
  metadataIdAssignmentList_some?: InputMaybe<MetadataIdAssignmentWhereInput>;
  metadataIdPhotoPrismaList_some?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
  metadataIdSubjectList_some?: InputMaybe<MetadataIdSubjectWhereInput>;
  metadataImageNotesList_some?: InputMaybe<MetadataImageNotesWhereInput>;
  metadataInstructionsList_some?: InputMaybe<MetadataInstructionsWhereInput>;
  metadataIssueList_some?: InputMaybe<MetadataIssueWhereInput>;
  metadataKeywordsList_some?: InputMaybe<MetadataKeywordsWhereInput>;
  metadataObjectNameList_some?: InputMaybe<MetadataObjectNameWhereInput>;
  metadataOriginalNameList_some?: InputMaybe<MetadataOriginalNameWhereInput>;
  metadataPriceLevelList_some?: InputMaybe<MetadataPriceLevelWhereInput>;
  metadataProcessHistoryList_some?: InputMaybe<MetadataProcessHistoryWhereInput>;
  metadataProcessStatusList_some?: InputMaybe<MetadataProcessStatusWhereInput>;
  metadataProductList_some?: InputMaybe<MetadataProductWhereInput>;
  metadataProductsList_some?: InputMaybe<MetadataProductsWhereInput>;
  metadataPublishingSubjectList_some?: InputMaybe<MetadataPublishingSubjectWhereInput>;
  metadataResolutionKindList_some?: InputMaybe<MetadataResolutionKindWhereInput>;
  metadataRightsList_some?: InputMaybe<MetadataRightsWhereInput>;
  metadataSourceList_some?: InputMaybe<MetadataSourceWhereInput>;
  metadataSpecialInstructionsList_some?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
  metadataSubjectCodeList_some?: InputMaybe<MetadataSubjectCodeWhereInput>;
  metadataSubjectList_some?: InputMaybe<MetadataSubjectWhereInput>;
  metadataSubjectPrismaList_some?: InputMaybe<MetadataSubjectPrismaWhereInput>;
  metadataTitleList_some?: InputMaybe<MetadataTitleWhereInput>;
  metadataTransferredByFullNameList_some?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
  metadataTransferredByList_some?: InputMaybe<MetadataTransferredByWhereInput>;
  metadataTypeList_some?: InputMaybe<MetadataTypeWhereInput>;
  metadataUndersubjectList_some?: InputMaybe<MetadataUndersubjectWhereInput>;
  metadataUnderUnderSubjectList_some?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
  metadataUploadedByFullNameList_some?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
  metadataUploadedByList_some?: InputMaybe<MetadataUploadedByWhereInput>;
  metadataUploadTimeList_some?: InputMaybe<MetadataUploadTimeWhereInput>;
  metadataUrgencyList_some?: InputMaybe<MetadataUrgencyWhereInput>;
  metadataUserDefined195List_some?: InputMaybe<MetadataUserDefined195WhereInput>;
  metadataUserDefined237List_some?: InputMaybe<MetadataUserDefined237WhereInput>;
  metadataUserDefined238List_some?: InputMaybe<MetadataUserDefined238WhereInput>;
  metadataUserDefined239List_some?: InputMaybe<MetadataUserDefined239WhereInput>;
  metadataUserDefined242List_some?: InputMaybe<MetadataUserDefined242WhereInput>;
  metadataUserDefined62List_some?: InputMaybe<MetadataUserDefined62WhereInput>;
  metadataWorkflowKindList_some?: InputMaybe<MetadataWorkflowKindWhereInput>;
  metadataXmpHistoryList_some?: InputMaybe<MetadataXmpHistoryWhereInput>;
  name?: InputMaybe<ArchiveKeyType>;
  name_in?: InputMaybe<Array<InputMaybe<ArchiveKeyType>>>;
  name_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  name_not?: InputMaybe<ArchiveKeyType>;
  name_not_in?: InputMaybe<Array<InputMaybe<ArchiveKeyType>>>;
  NOT?: InputMaybe<ArchiveWhereInput>;
  OR?: InputMaybe<Array<ArchiveWhereInput>>;
  photoMetadatas_some?: InputMaybe<PhotoMetadataWhereInput>;
  photos_some?: InputMaybe<PhotoWhereInput>;
  type?: InputMaybe<ArchiveType>;
  type_in?: InputMaybe<Array<InputMaybe<ArchiveType>>>;
  type_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  type_not?: InputMaybe<ArchiveType>;
  type_not_in?: InputMaybe<Array<InputMaybe<ArchiveType>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Archive" node with one of these unique values:
 * - _id
 * - id
 * - archiveId
 */
export type ArchiveWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  archiveId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** "Category" resource's node */
export type Category = {
  __typename?: 'Category';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  archive: Archive;
  /** "Category.parent"'s inverse relation count */
  childCount: Scalars['Int']['output'];
  /** "Category.parent"'s inverse relation */
  children: Array<Category>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Category>;
  /** "Photo.category"'s inverse relation count */
  photoCount: Scalars['Int']['output'];
  /** "Photo.category"'s inverse relation */
  photos: Array<Photo>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** "Category" resource's node */
export type CategoryChildCountArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


/** "Category" resource's node */
export type CategoryChildrenArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


/** "Category" resource's node */
export type CategoryPhotoCountArgs = {
  where?: InputMaybe<PhotoWhereInput>;
};


/** "Category" resource's node */
export type CategoryPhotosArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoWhereInput>;
};

export type CategoryCreateInput = {
  /** Actions for the "Category.archive" relation */
  archive: CategoryNestedArchiveCreateInput;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.parent" relation */
  parent?: InputMaybe<CategoryNestedParentCreateInput>;
  /** Actions for the "Category.photos" relation: "Photo.category"'s inverse relation */
  photos?: InputMaybe<CategoryNestedPhotosCreateInput>;
};

export type CategoryNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "Category" node, through the "Category.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "Category" node, through the "Category.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "Category" node, through the "Category.archive" relation. */
  update?: InputMaybe<CategoryNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "Category" node, through the "Category.archive" relation. */
  upsert?: InputMaybe<CategoryNestedUpsertArchiveCreateInput>;
};

export type CategoryNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "Category" node, through the "Category.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "Category" node, through the "Category.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "Category" node, through the "Category.archive" relation. */
  update?: InputMaybe<CategoryNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "Category" node, through the "Category.archive" relation. */
  upsert?: InputMaybe<CategoryNestedUpsertArchiveUpdateInput>;
};

export type CategoryNestedChildrenCreateInput = {
  /** Connect existing "Category" nodes to the new "Category" node, through the "Category.children" relation. */
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Create new "Category" nodes and connect them to the new "Category" node, through the "Category.children" relation. */
  create?: InputMaybe<Array<CategoryWithForcedParentCreateInput>>;
};

export type CategoryNestedChildrenUpdateInput = {
  /** Connect existing "Category" nodes to the existing "Category" node, through the "Category.children" relation. */
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Create new "Category" nodes and connect them to the existing "Category" node, through the "Category.children" relation. */
  create?: InputMaybe<Array<CategoryWithForcedParentCreateInput>>;
  /** Delete existing "Category" nodes from the "Category.children" relation. */
  delete?: InputMaybe<Array<CategoryWithForcedParentWhereUniqueInput>>;
  /** Disconnect existing "Category" nodes of the "Category.children" relation. */
  disconnect?: InputMaybe<Array<CategoryWithForcedParentWhereUniqueInput>>;
  /** Update existing "Category" nodes and connect them to the existing "Category" node, through the "Category.children" relation. */
  update?: InputMaybe<Array<CategoryNestedUpdateChildrenUpdateInput>>;
  /** Upsert existing "Category" nodes and connect them to the existing "Category" node, through the "Category.children" relation. */
  upsert?: InputMaybe<Array<CategoryNestedUpsertChildrenUpdateInput>>;
};

export type CategoryNestedParentCreateInput = {
  /** Connect an existing "Category" node to the new "Category" node, through the "Category.parent" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "Category" node, through the "Category.parent" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "Category" node, through the "Category.parent" relation. */
  update?: InputMaybe<CategoryNestedUpdateParentCreateInput>;
  /** Create or update a "Category" node and connect it to the new "Category" node, through the "Category.parent" relation. */
  upsert?: InputMaybe<CategoryNestedUpsertParentCreateInput>;
};

export type CategoryNestedParentUpdateInput = {
  /** Connect an existing "Category" node to the existing "Category" node, through the "Category.parent" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the existing "Category" node, through the "Category.parent" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Disconnect the current connected "Category" node, if any, of the "Category.parent" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Category" node and connect it to the existing "Category" node, through the "Category.parent" relation. */
  update?: InputMaybe<CategoryNestedUpdateParentUpdateInput>;
  /** Create or update a "Category" node and connect it to the existing "Category" node, through the "Category.parent" relation. */
  upsert?: InputMaybe<CategoryNestedUpsertParentUpdateInput>;
};

export type CategoryNestedPhotosCreateInput = {
  /** Connect existing "Photo" nodes to the new "Category" node, through the "Category.photos" relation. */
  connect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Create new "Photo" nodes and connect them to the new "Category" node, through the "Category.photos" relation. */
  create?: InputMaybe<Array<PhotoWithForcedCategoryCreateInput>>;
};

export type CategoryNestedPhotosUpdateInput = {
  /** Connect existing "Photo" nodes to the existing "Category" node, through the "Category.photos" relation. */
  connect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Create new "Photo" nodes and connect them to the existing "Category" node, through the "Category.photos" relation. */
  create?: InputMaybe<Array<PhotoWithForcedCategoryCreateInput>>;
  /** Delete existing "Photo" nodes from the "Category.photos" relation. */
  delete?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Disconnect existing "Photo" nodes of the "Category.photos" relation. */
  disconnect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Update existing "Photo" nodes and connect them to the existing "Category" node, through the "Category.photos" relation. */
  update?: InputMaybe<Array<CategoryNestedUpdatePhotosUpdateInput>>;
  /** Upsert existing "Photo" nodes and connect them to the existing "Category" node, through the "Category.photos" relation. */
  upsert?: InputMaybe<Array<CategoryNestedUpsertPhotosUpdateInput>>;
};

export type CategoryNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type CategoryNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type CategoryNestedUpdateChildrenUpdateInput = {
  data: CategoryWithForcedParentUpdateInput;
  where: CategoryWithOptionalParentWhereUniqueInput;
};

export type CategoryNestedUpdateParentCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryNestedUpdateParentUpdateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryNestedUpdatePhotosUpdateInput = {
  data: PhotoWithForcedCategoryUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type CategoryNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type CategoryNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type CategoryNestedUpsertChildrenUpdateInput = {
  create: CategoryWithForcedParentCreateInput;
  update: CategoryWithForcedParentUpdateInput;
  where: CategoryWithOptionalParentWhereUniqueInput;
};

export type CategoryNestedUpsertParentCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryNestedUpsertParentUpdateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryNestedUpsertPhotosUpdateInput = {
  create: PhotoWithForcedCategoryCreateInput;
  update: PhotoWithForcedCategoryUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum CategoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CategoryUpdateInput = {
  /** Actions for the "Category.archive" relation */
  archive?: InputMaybe<CategoryNestedArchiveUpdateInput>;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenUpdateInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.parent" relation */
  parent?: InputMaybe<CategoryNestedParentUpdateInput>;
  /** Actions for the "Category.photos" relation: "Photo.category"'s inverse relation */
  photos?: InputMaybe<CategoryNestedPhotosUpdateInput>;
};

/** Filters the "Category" nodes by specifying some conditions */
export type CategoryWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  children_some?: InputMaybe<CategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_gt?: InputMaybe<Scalars['String']['input']>;
  label_gte?: InputMaybe<Scalars['String']['input']>;
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  label_lt?: InputMaybe<Scalars['String']['input']>;
  label_lte?: InputMaybe<Scalars['String']['input']>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<CategoryWhereInput>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  parent?: InputMaybe<CategoryWhereInput>;
  parent_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  photos_some?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "Category" node with one of these unique combinations of values:
 * - _id
 * - id
 * - archive, label, parent
 */
export type CategoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<CategoryWhereUniqueInput>;
};

export type CategoryWithForcedArchiveCreateInput = {
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.parent" relation */
  parent?: InputMaybe<CategoryNestedParentCreateInput>;
  /** Actions for the "Category.photos" relation: "Photo.category"'s inverse relation */
  photos?: InputMaybe<CategoryNestedPhotosCreateInput>;
};

export type CategoryWithForcedArchiveUpdateInput = {
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenUpdateInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.parent" relation */
  parent?: InputMaybe<CategoryNestedParentUpdateInput>;
  /** Actions for the "Category.photos" relation: "Photo.category"'s inverse relation */
  photos?: InputMaybe<CategoryNestedPhotosUpdateInput>;
};

/** Given a forced "archive", identifies exactly one "Category" node. */
export type CategoryWithForcedArchiveWhereUniqueInput = {
  label: Scalars['String']['input'];
  parent: CategoryWhereUniqueInput;
};

export type CategoryWithForcedParentCreateInput = {
  /** Actions for the "Category.archive" relation */
  archive: CategoryNestedArchiveCreateInput;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.photos" relation: "Photo.category"'s inverse relation */
  photos?: InputMaybe<CategoryNestedPhotosCreateInput>;
};

export type CategoryWithForcedParentUpdateInput = {
  /** Actions for the "Category.archive" relation */
  archive?: InputMaybe<CategoryNestedArchiveUpdateInput>;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenUpdateInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.photos" relation: "Photo.category"'s inverse relation */
  photos?: InputMaybe<CategoryNestedPhotosUpdateInput>;
};

/** Given a forced "parent", identifies exactly one "Category" node. */
export type CategoryWithForcedParentWhereUniqueInput = {
  archive: ArchiveWhereUniqueInput;
  label: Scalars['String']['input'];
};

/**
 * Given a known "archive", identifies exactly one "Category" node with one of these unique combinations of values:
 * - _id
 * - id
 * - archive (optional), label, parent
 */
export type CategoryWithOptionalArchiveWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<CategoryWhereUniqueInput>;
};

/**
 * Given a known "parent", identifies exactly one "Category" node with one of these unique combinations of values:
 * - _id
 * - id
 * - archive, label, parent (optional)
 */
export type CategoryWithOptionalParentWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<CategoryWhereUniqueInput>;
};

/** "DeliverySubject" resource's node */
export type DeliverySubject = {
  __typename?: 'DeliverySubject';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  agency: Scalars['String']['output'];
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  /** "Photo.deliverySubject"'s inverse relation count */
  photoCount: Scalars['Int']['output'];
  /** "Photo.deliverySubject"'s inverse relation */
  photos: Array<Photo>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** "DeliverySubject" resource's node */
export type DeliverySubjectPhotoCountArgs = {
  where?: InputMaybe<PhotoWhereInput>;
};


/** "DeliverySubject" resource's node */
export type DeliverySubjectPhotosArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoWhereInput>;
};

export type DeliverySubjectCreateInput = {
  agency: Scalars['String']['input'];
  /** Actions for the "DeliverySubject.archive" relation */
  archive: DeliverySubjectNestedArchiveCreateInput;
  name: Scalars['String']['input'];
  /** Actions for the "DeliverySubject.photos" relation: "Photo.deliverySubject"'s inverse relation */
  photos?: InputMaybe<DeliverySubjectNestedPhotosCreateInput>;
};

export type DeliverySubjectNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "DeliverySubject" node, through the "DeliverySubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "DeliverySubject" node, through the "DeliverySubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "DeliverySubject" node, through the "DeliverySubject.archive" relation. */
  update?: InputMaybe<DeliverySubjectNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "DeliverySubject" node, through the "DeliverySubject.archive" relation. */
  upsert?: InputMaybe<DeliverySubjectNestedUpsertArchiveCreateInput>;
};

export type DeliverySubjectNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "DeliverySubject" node, through the "DeliverySubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "DeliverySubject" node, through the "DeliverySubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "DeliverySubject" node, through the "DeliverySubject.archive" relation. */
  update?: InputMaybe<DeliverySubjectNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "DeliverySubject" node, through the "DeliverySubject.archive" relation. */
  upsert?: InputMaybe<DeliverySubjectNestedUpsertArchiveUpdateInput>;
};

export type DeliverySubjectNestedPhotosCreateInput = {
  /** Connect existing "Photo" nodes to the new "DeliverySubject" node, through the "DeliverySubject.photos" relation. */
  connect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Create new "Photo" nodes and connect them to the new "DeliverySubject" node, through the "DeliverySubject.photos" relation. */
  create?: InputMaybe<Array<PhotoWithForcedDeliverySubjectCreateInput>>;
};

export type DeliverySubjectNestedPhotosUpdateInput = {
  /** Connect existing "Photo" nodes to the existing "DeliverySubject" node, through the "DeliverySubject.photos" relation. */
  connect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Create new "Photo" nodes and connect them to the existing "DeliverySubject" node, through the "DeliverySubject.photos" relation. */
  create?: InputMaybe<Array<PhotoWithForcedDeliverySubjectCreateInput>>;
  /** Delete existing "Photo" nodes from the "DeliverySubject.photos" relation. */
  delete?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Disconnect existing "Photo" nodes of the "DeliverySubject.photos" relation. */
  disconnect?: InputMaybe<Array<PhotoWhereUniqueInput>>;
  /** Update existing "Photo" nodes and connect them to the existing "DeliverySubject" node, through the "DeliverySubject.photos" relation. */
  update?: InputMaybe<Array<DeliverySubjectNestedUpdatePhotosUpdateInput>>;
  /** Upsert existing "Photo" nodes and connect them to the existing "DeliverySubject" node, through the "DeliverySubject.photos" relation. */
  upsert?: InputMaybe<Array<DeliverySubjectNestedUpsertPhotosUpdateInput>>;
};

export type DeliverySubjectNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type DeliverySubjectNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type DeliverySubjectNestedUpdatePhotosUpdateInput = {
  data: PhotoWithForcedDeliverySubjectUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type DeliverySubjectNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type DeliverySubjectNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type DeliverySubjectNestedUpsertPhotosUpdateInput = {
  create: PhotoWithForcedDeliverySubjectCreateInput;
  update: PhotoWithForcedDeliverySubjectUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum DeliverySubjectOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  agency_ASC = 'agency_ASC',
  agency_DESC = 'agency_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type DeliverySubjectUpdateInput = {
  agency?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "DeliverySubject.archive" relation */
  archive?: InputMaybe<DeliverySubjectNestedArchiveUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "DeliverySubject.photos" relation: "Photo.deliverySubject"'s inverse relation */
  photos?: InputMaybe<DeliverySubjectNestedPhotosUpdateInput>;
};

/** Filters the "DeliverySubject" nodes by specifying some conditions */
export type DeliverySubjectWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  agency?: InputMaybe<Scalars['String']['input']>;
  agency_contains?: InputMaybe<Scalars['String']['input']>;
  agency_ends_with?: InputMaybe<Scalars['String']['input']>;
  agency_gt?: InputMaybe<Scalars['String']['input']>;
  agency_gte?: InputMaybe<Scalars['String']['input']>;
  agency_in?: InputMaybe<Array<Scalars['String']['input']>>;
  agency_lt?: InputMaybe<Scalars['String']['input']>;
  agency_lte?: InputMaybe<Scalars['String']['input']>;
  agency_not?: InputMaybe<Scalars['String']['input']>;
  agency_not_contains?: InputMaybe<Scalars['String']['input']>;
  agency_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  agency_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  agency_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  agency_starts_with?: InputMaybe<Scalars['String']['input']>;
  AND?: InputMaybe<Array<DeliverySubjectWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_contains?: InputMaybe<Scalars['String']['input']>;
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_gt?: InputMaybe<Scalars['String']['input']>;
  name_gte?: InputMaybe<Scalars['String']['input']>;
  name_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_lt?: InputMaybe<Scalars['String']['input']>;
  name_lte?: InputMaybe<Scalars['String']['input']>;
  name_not?: InputMaybe<Scalars['String']['input']>;
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  name_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<DeliverySubjectWhereInput>;
  OR?: InputMaybe<Array<DeliverySubjectWhereInput>>;
  photos_some?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "DeliverySubject" node with one of these unique combinations of values:
 * - _id
 * - agency, archive, name
 */
export type DeliverySubjectWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  agency?: InputMaybe<Scalars['String']['input']>;
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DeliverySubjectWithForcedArchiveCreateInput = {
  agency: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /** Actions for the "DeliverySubject.photos" relation: "Photo.deliverySubject"'s inverse relation */
  photos?: InputMaybe<DeliverySubjectNestedPhotosCreateInput>;
};

export type DeliverySubjectWithForcedArchiveUpdateInput = {
  agency?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "DeliverySubject.photos" relation: "Photo.deliverySubject"'s inverse relation */
  photos?: InputMaybe<DeliverySubjectNestedPhotosUpdateInput>;
};

/** Given a forced "archive", identifies exactly one "DeliverySubject" node. */
export type DeliverySubjectWithForcedArchiveWhereUniqueInput = {
  agency: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/**
 * Given a known "archive", identifies exactly one "DeliverySubject" node with one of these unique combinations of values:
 * - _id
 * - agency, archive (optional), name
 */
export type DeliverySubjectWithOptionalArchiveWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  agency?: InputMaybe<Scalars['String']['input']>;
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** "GcImportSetting" resource's node */
export type GcImportSetting = {
  __typename?: 'GcImportSetting';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID */
  id: Scalars['Int']['output'];
  period?: Maybe<Scalars['Int']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type GcImportSettingCreateInput = {
  /** Actions for the "GcImportSetting.archive" relation */
  archive: GcImportSettingNestedArchiveCreateInput;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
};

export type GcImportSettingNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "GcImportSetting" node, through the "GcImportSetting.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "GcImportSetting" node, through the "GcImportSetting.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "GcImportSetting" node, through the "GcImportSetting.archive" relation. */
  update?: InputMaybe<GcImportSettingNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "GcImportSetting" node, through the "GcImportSetting.archive" relation. */
  upsert?: InputMaybe<GcImportSettingNestedUpsertArchiveCreateInput>;
};

export type GcImportSettingNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "GcImportSetting" node, through the "GcImportSetting.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "GcImportSetting" node, through the "GcImportSetting.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "GcImportSetting" node, through the "GcImportSetting.archive" relation. */
  update?: InputMaybe<GcImportSettingNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "GcImportSetting" node, through the "GcImportSetting.archive" relation. */
  upsert?: InputMaybe<GcImportSettingNestedUpsertArchiveUpdateInput>;
};

export type GcImportSettingNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type GcImportSettingNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type GcImportSettingNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type GcImportSettingNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export enum GcImportSettingOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  enabled_ASC = 'enabled_ASC',
  enabled_DESC = 'enabled_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  period_ASC = 'period_ASC',
  period_DESC = 'period_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GcImportSettingUpdateInput = {
  /** Actions for the "GcImportSetting.archive" relation */
  archive?: InputMaybe<GcImportSettingNestedArchiveUpdateInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "GcImportSetting" nodes by specifying some conditions */
export type GcImportSettingWhereInput = {
  AND?: InputMaybe<Array<GcImportSettingWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  enabled_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_not?: InputMaybe<Scalars['Boolean']['input']>;
  enabled_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  NOT?: InputMaybe<GcImportSettingWhereInput>;
  OR?: InputMaybe<Array<GcImportSettingWhereInput>>;
  period?: InputMaybe<Scalars['Int']['input']>;
  period_gt?: InputMaybe<Scalars['Int']['input']>;
  period_gte?: InputMaybe<Scalars['Int']['input']>;
  period_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  period_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  period_lt?: InputMaybe<Scalars['Int']['input']>;
  period_lte?: InputMaybe<Scalars['Int']['input']>;
  period_not?: InputMaybe<Scalars['Int']['input']>;
  period_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "GcImportSetting" node with one of these unique values:
 * - id
 * - archive
 */
export type GcImportSettingWhereUniqueInput = {
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type GcImportSettingWithForcedArchiveCreateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
};

export type GcImportSettingWithForcedArchiveUpdateInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  period?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Given a known "archive", identifies exactly one "GcImportSetting" node with one of these unique values:
 * - id
 * - archive (optional)
 */
export type GcImportSettingWithOptionalArchiveWhereUniqueInput = {
  archive?: InputMaybe<ArchiveWhereUniqueInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** "ImportQueue" resource's node */
export type ImportQueue = {
  __typename?: 'ImportQueue';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  agency?: Maybe<Scalars['String']['output']>;
  archive?: Maybe<Archive>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  filename: Scalars['String']['output'];
  /** The date of photo importation */
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Photo>;
  retry?: Maybe<Scalars['Int']['output']>;
  s3key: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  /** import status */
  status: ImportQueueStatusType;
  subject?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type ImportQueueCreateInput = {
  agency?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "ImportQueue.archive" relation */
  archive?: InputMaybe<ImportQueueNestedArchiveCreateInput>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  filename: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "ImportQueue.photo" relation */
  photo?: InputMaybe<ImportQueueNestedPhotoCreateInput>;
  retry?: InputMaybe<Scalars['Int']['input']>;
  s3key: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  /** import status */
  status: ImportQueueStatusType;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ImportQueueNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "ImportQueue" node, through the "ImportQueue.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "ImportQueue" node, through the "ImportQueue.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "ImportQueue" node, through the "ImportQueue.archive" relation. */
  update?: InputMaybe<ImportQueueNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "ImportQueue" node, through the "ImportQueue.archive" relation. */
  upsert?: InputMaybe<ImportQueueNestedUpsertArchiveCreateInput>;
};

export type ImportQueueNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "ImportQueue" node, through the "ImportQueue.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "ImportQueue" node, through the "ImportQueue.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Disconnect the current connected "Archive" node, if any, of the "ImportQueue.archive" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Archive" node and connect it to the existing "ImportQueue" node, through the "ImportQueue.archive" relation. */
  update?: InputMaybe<ImportQueueNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "ImportQueue" node, through the "ImportQueue.archive" relation. */
  upsert?: InputMaybe<ImportQueueNestedUpsertArchiveUpdateInput>;
};

export type ImportQueueNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "ImportQueue" node, through the "ImportQueue.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "ImportQueue" node, through the "ImportQueue.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "ImportQueue" node, through the "ImportQueue.photo" relation. */
  update?: InputMaybe<ImportQueueNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "ImportQueue" node, through the "ImportQueue.photo" relation. */
  upsert?: InputMaybe<ImportQueueNestedUpsertPhotoCreateInput>;
};

export type ImportQueueNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "ImportQueue" node, through the "ImportQueue.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "ImportQueue" node, through the "ImportQueue.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Disconnect the current connected "Photo" node, if any, of the "ImportQueue.photo" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Photo" node and connect it to the existing "ImportQueue" node, through the "ImportQueue.photo" relation. */
  update?: InputMaybe<ImportQueueNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "ImportQueue" node, through the "ImportQueue.photo" relation. */
  upsert?: InputMaybe<ImportQueueNestedUpsertPhotoUpdateInput>;
};

export type ImportQueueNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ImportQueueNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ImportQueueNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type ImportQueueNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type ImportQueueNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ImportQueueNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type ImportQueueNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type ImportQueueNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum ImportQueueOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  agency_ASC = 'agency_ASC',
  agency_DESC = 'agency_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  duration_ASC = 'duration_ASC',
  duration_DESC = 'duration_DESC',
  filename_ASC = 'filename_ASC',
  filename_DESC = 'filename_DESC',
  importedAt_ASC = 'importedAt_ASC',
  importedAt_DESC = 'importedAt_DESC',
  message_ASC = 'message_ASC',
  message_DESC = 'message_DESC',
  retry_ASC = 'retry_ASC',
  retry_DESC = 'retry_DESC',
  s3key_ASC = 's3key_ASC',
  s3key_DESC = 's3key_DESC',
  size_ASC = 'size_ASC',
  size_DESC = 'size_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  subject_ASC = 'subject_ASC',
  subject_DESC = 'subject_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum ImportQueueStatusType {
  DELETED = 'DELETED',
  FAILED = 'FAILED',
  FINISHED = 'FINISHED',
  PENDING = 'PENDING'
}

export type ImportQueueUpdateInput = {
  agency?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "ImportQueue.archive" relation */
  archive?: InputMaybe<ImportQueueNestedArchiveUpdateInput>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "ImportQueue.photo" relation */
  photo?: InputMaybe<ImportQueueNestedPhotoUpdateInput>;
  retry?: InputMaybe<Scalars['Int']['input']>;
  s3key?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  /** import status */
  status?: InputMaybe<ImportQueueStatusType>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "ImportQueue" nodes by specifying some conditions */
export type ImportQueueWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  agency?: InputMaybe<Scalars['String']['input']>;
  agency_contains?: InputMaybe<Scalars['String']['input']>;
  agency_ends_with?: InputMaybe<Scalars['String']['input']>;
  agency_gt?: InputMaybe<Scalars['String']['input']>;
  agency_gte?: InputMaybe<Scalars['String']['input']>;
  agency_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agency_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  agency_lt?: InputMaybe<Scalars['String']['input']>;
  agency_lte?: InputMaybe<Scalars['String']['input']>;
  agency_not?: InputMaybe<Scalars['String']['input']>;
  agency_not_contains?: InputMaybe<Scalars['String']['input']>;
  agency_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  agency_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  agency_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  agency_starts_with?: InputMaybe<Scalars['String']['input']>;
  AND?: InputMaybe<Array<ImportQueueWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  archive_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  duration_gt?: InputMaybe<Scalars['Int']['input']>;
  duration_gte?: InputMaybe<Scalars['Int']['input']>;
  duration_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  duration_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  duration_lt?: InputMaybe<Scalars['Int']['input']>;
  duration_lte?: InputMaybe<Scalars['Int']['input']>;
  duration_not?: InputMaybe<Scalars['Int']['input']>;
  duration_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filename_contains?: InputMaybe<Scalars['String']['input']>;
  filename_ends_with?: InputMaybe<Scalars['String']['input']>;
  filename_gt?: InputMaybe<Scalars['String']['input']>;
  filename_gte?: InputMaybe<Scalars['String']['input']>;
  filename_in?: InputMaybe<Array<Scalars['String']['input']>>;
  filename_lt?: InputMaybe<Scalars['String']['input']>;
  filename_lte?: InputMaybe<Scalars['String']['input']>;
  filename_not?: InputMaybe<Scalars['String']['input']>;
  filename_not_contains?: InputMaybe<Scalars['String']['input']>;
  filename_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  filename_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  filename_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  filename_starts_with?: InputMaybe<Scalars['String']['input']>;
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  importedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  importedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  message_contains?: InputMaybe<Scalars['String']['input']>;
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  message_gt?: InputMaybe<Scalars['String']['input']>;
  message_gte?: InputMaybe<Scalars['String']['input']>;
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  message_lt?: InputMaybe<Scalars['String']['input']>;
  message_lte?: InputMaybe<Scalars['String']['input']>;
  message_not?: InputMaybe<Scalars['String']['input']>;
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<ImportQueueWhereInput>;
  OR?: InputMaybe<Array<ImportQueueWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  photo_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  retry?: InputMaybe<Scalars['Int']['input']>;
  retry_gt?: InputMaybe<Scalars['Int']['input']>;
  retry_gte?: InputMaybe<Scalars['Int']['input']>;
  retry_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  retry_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  retry_lt?: InputMaybe<Scalars['Int']['input']>;
  retry_lte?: InputMaybe<Scalars['Int']['input']>;
  retry_not?: InputMaybe<Scalars['Int']['input']>;
  retry_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  s3key?: InputMaybe<Scalars['String']['input']>;
  s3key_contains?: InputMaybe<Scalars['String']['input']>;
  s3key_ends_with?: InputMaybe<Scalars['String']['input']>;
  s3key_gt?: InputMaybe<Scalars['String']['input']>;
  s3key_gte?: InputMaybe<Scalars['String']['input']>;
  s3key_in?: InputMaybe<Array<Scalars['String']['input']>>;
  s3key_lt?: InputMaybe<Scalars['String']['input']>;
  s3key_lte?: InputMaybe<Scalars['String']['input']>;
  s3key_not?: InputMaybe<Scalars['String']['input']>;
  s3key_not_contains?: InputMaybe<Scalars['String']['input']>;
  s3key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  s3key_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  s3key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  s3key_starts_with?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  size_gt?: InputMaybe<Scalars['Int']['input']>;
  size_gte?: InputMaybe<Scalars['Int']['input']>;
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  size_lt?: InputMaybe<Scalars['Int']['input']>;
  size_lte?: InputMaybe<Scalars['Int']['input']>;
  size_not?: InputMaybe<Scalars['Int']['input']>;
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  status?: InputMaybe<ImportQueueStatusType>;
  status_in?: InputMaybe<Array<ImportQueueStatusType>>;
  status_not?: InputMaybe<ImportQueueStatusType>;
  status_not_in?: InputMaybe<Array<ImportQueueStatusType>>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subject_contains?: InputMaybe<Scalars['String']['input']>;
  subject_ends_with?: InputMaybe<Scalars['String']['input']>;
  subject_gt?: InputMaybe<Scalars['String']['input']>;
  subject_gte?: InputMaybe<Scalars['String']['input']>;
  subject_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subject_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  subject_lt?: InputMaybe<Scalars['String']['input']>;
  subject_lte?: InputMaybe<Scalars['String']['input']>;
  subject_not?: InputMaybe<Scalars['String']['input']>;
  subject_not_contains?: InputMaybe<Scalars['String']['input']>;
  subject_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  subject_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subject_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  subject_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_contains?: InputMaybe<Scalars['String']['input']>;
  type_ends_with?: InputMaybe<Scalars['String']['input']>;
  type_gt?: InputMaybe<Scalars['String']['input']>;
  type_gte?: InputMaybe<Scalars['String']['input']>;
  type_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  type_lt?: InputMaybe<Scalars['String']['input']>;
  type_lte?: InputMaybe<Scalars['String']['input']>;
  type_not?: InputMaybe<Scalars['String']['input']>;
  type_not_contains?: InputMaybe<Scalars['String']['input']>;
  type_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  type_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  type_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/**
 * Identifies exactly one "ImportQueue" node with one of these unique values:
 * - _id
 * - s3key
 * - photo
 */
export type ImportQueueWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  photo?: InputMaybe<PhotoWhereUniqueInput>;
  s3key?: InputMaybe<Scalars['String']['input']>;
};

export type ImportQueueWithForcedArchiveCreateInput = {
  agency?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  filename: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "ImportQueue.photo" relation */
  photo?: InputMaybe<ImportQueueNestedPhotoCreateInput>;
  retry?: InputMaybe<Scalars['Int']['input']>;
  s3key: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  /** import status */
  status: ImportQueueStatusType;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ImportQueueWithForcedArchiveUpdateInput = {
  agency?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "ImportQueue.photo" relation */
  photo?: InputMaybe<ImportQueueNestedPhotoUpdateInput>;
  retry?: InputMaybe<Scalars['Int']['input']>;
  s3key?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  /** import status */
  status?: InputMaybe<ImportQueueStatusType>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ImportQueueWithForcedPhotoCreateInput = {
  agency?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "ImportQueue.archive" relation */
  archive?: InputMaybe<ImportQueueNestedArchiveCreateInput>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  filename: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  retry?: InputMaybe<Scalars['Int']['input']>;
  s3key: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  /** import status */
  status: ImportQueueStatusType;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ImportQueueWithForcedPhotoUpdateInput = {
  agency?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "ImportQueue.archive" relation */
  archive?: InputMaybe<ImportQueueNestedArchiveUpdateInput>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  retry?: InputMaybe<Scalars['Int']['input']>;
  s3key?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  /** import status */
  status?: InputMaybe<ImportQueueStatusType>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Given a known "photo", identifies exactly one "ImportQueue" node with one of these unique values:
 * - _id
 * - s3key
 * - photo (optional)
 */
export type ImportQueueWithOptionalPhotoWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  photo?: InputMaybe<PhotoWhereUniqueInput>;
  s3key?: InputMaybe<Scalars['String']['input']>;
};

export type InformationAgency = {
  __typename?: 'InformationAgency';
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

/** "Metadata" resource's node */
export type Metadata = {
  __typename?: 'Metadata';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  legacyName?: Maybe<Scalars['String']['output']>;
  /** "MetadataAccessRights.metadata"'s inverse relation */
  metadataAccessRightsList: Array<MetadataAccessRights>;
  /** "MetadataAccessRights.metadata"'s inverse relation count */
  metadataAccessRightsListCount: Scalars['Int']['output'];
  /** "MetadataAssetState.metadata"'s inverse relation */
  metadataAssetStateList: Array<MetadataAssetState>;
  /** "MetadataAssetState.metadata"'s inverse relation count */
  metadataAssetStateListCount: Scalars['Int']['output'];
  /** "MetadataBackupName.metadata"'s inverse relation */
  metadataBackupNameList: Array<MetadataBackupName>;
  /** "MetadataBackupName.metadata"'s inverse relation count */
  metadataBackupNameListCount: Scalars['Int']['output'];
  /** "MetadataBrand.metadata"'s inverse relation */
  metadataBrandList: Array<MetadataBrand>;
  /** "MetadataBrand.metadata"'s inverse relation count */
  metadataBrandListCount: Scalars['Int']['output'];
  /** "MetadataBrandPrisma.metadata"'s inverse relation */
  metadataBrandPrismaList: Array<MetadataBrandPrisma>;
  /** "MetadataBrandPrisma.metadata"'s inverse relation count */
  metadataBrandPrismaListCount: Scalars['Int']['output'];
  /** "MetadataBrandShortName.metadata"'s inverse relation */
  metadataBrandShortNameList: Array<MetadataBrandShortName>;
  /** "MetadataBrandShortName.metadata"'s inverse relation count */
  metadataBrandShortNameListCount: Scalars['Int']['output'];
  /** "MetadataByLine.metadata"'s inverse relation */
  metadataByLineList: Array<MetadataByLine>;
  /** "MetadataByLine.metadata"'s inverse relation count */
  metadataByLineListCount: Scalars['Int']['output'];
  /** "MetadataCaptionAbstract.metadata"'s inverse relation */
  metadataCaptionAbstractList: Array<MetadataCaptionAbstract>;
  /** "MetadataCaptionAbstract.metadata"'s inverse relation count */
  metadataCaptionAbstractListCount: Scalars['Int']['output'];
  /** "MetadataCaption.metadata"'s inverse relation */
  metadataCaptionList: Array<MetadataCaption>;
  /** "MetadataCaption.metadata"'s inverse relation count */
  metadataCaptionListCount: Scalars['Int']['output'];
  /** "MetadataCategory.metadata"'s inverse relation */
  metadataCategoryList: Array<MetadataCategory>;
  /** "MetadataCategory.metadata"'s inverse relation count */
  metadataCategoryListCount: Scalars['Int']['output'];
  /** "MetadataCategoryPrisma.metadata"'s inverse relation */
  metadataCategoryPrismaList: Array<MetadataCategoryPrisma>;
  /** "MetadataCategoryPrisma.metadata"'s inverse relation count */
  metadataCategoryPrismaListCount: Scalars['Int']['output'];
  /** "MetadataCompany.metadata"'s inverse relation */
  metadataCompanyList: Array<MetadataCompany>;
  /** "MetadataCompany.metadata"'s inverse relation count */
  metadataCompanyListCount: Scalars['Int']['output'];
  /** "MetadataCompanyShortName.metadata"'s inverse relation */
  metadataCompanyShortNameList: Array<MetadataCompanyShortName>;
  /** "MetadataCompanyShortName.metadata"'s inverse relation count */
  metadataCompanyShortNameListCount: Scalars['Int']['output'];
  /** "MetadataCopyrightNotice.metadata"'s inverse relation */
  metadataCopyrightNoticeList: Array<MetadataCopyrightNotice>;
  /** "MetadataCopyrightNotice.metadata"'s inverse relation count */
  metadataCopyrightNoticeListCount: Scalars['Int']['output'];
  /** "MetadataCreator.metadata"'s inverse relation */
  metadataCreatorList: Array<MetadataCreator>;
  /** "MetadataCreator.metadata"'s inverse relation count */
  metadataCreatorListCount: Scalars['Int']['output'];
  /** "MetadataCredit.metadata"'s inverse relation */
  metadataCreditList: Array<MetadataCredit>;
  /** "MetadataCredit.metadata"'s inverse relation count */
  metadataCreditListCount: Scalars['Int']['output'];
  /** "MetadataCustomField14.metadata"'s inverse relation */
  metadataCustomField14List: Array<MetadataCustomField14>;
  /** "MetadataCustomField14.metadata"'s inverse relation count */
  metadataCustomField14ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField15.metadata"'s inverse relation */
  metadataCustomField15List: Array<MetadataCustomField15>;
  /** "MetadataCustomField15.metadata"'s inverse relation count */
  metadataCustomField15ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField16.metadata"'s inverse relation */
  metadataCustomField16List: Array<MetadataCustomField16>;
  /** "MetadataCustomField16.metadata"'s inverse relation count */
  metadataCustomField16ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField17.metadata"'s inverse relation */
  metadataCustomField17List: Array<MetadataCustomField17>;
  /** "MetadataCustomField17.metadata"'s inverse relation count */
  metadataCustomField17ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField1.metadata"'s inverse relation */
  metadataCustomField1List: Array<MetadataCustomField1>;
  /** "MetadataCustomField1.metadata"'s inverse relation count */
  metadataCustomField1ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField20.metadata"'s inverse relation */
  metadataCustomField20List: Array<MetadataCustomField20>;
  /** "MetadataCustomField20.metadata"'s inverse relation count */
  metadataCustomField20ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField3.metadata"'s inverse relation */
  metadataCustomField3List: Array<MetadataCustomField3>;
  /** "MetadataCustomField3.metadata"'s inverse relation count */
  metadataCustomField3ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField4.metadata"'s inverse relation */
  metadataCustomField4List: Array<MetadataCustomField4>;
  /** "MetadataCustomField4.metadata"'s inverse relation count */
  metadataCustomField4ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField5.metadata"'s inverse relation */
  metadataCustomField5List: Array<MetadataCustomField5>;
  /** "MetadataCustomField5.metadata"'s inverse relation count */
  metadataCustomField5ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField6.metadata"'s inverse relation */
  metadataCustomField6List: Array<MetadataCustomField6>;
  /** "MetadataCustomField6.metadata"'s inverse relation count */
  metadataCustomField6ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField7.metadata"'s inverse relation */
  metadataCustomField7List: Array<MetadataCustomField7>;
  /** "MetadataCustomField7.metadata"'s inverse relation count */
  metadataCustomField7ListCount: Scalars['Int']['output'];
  /** "MetadataCustomField9.metadata"'s inverse relation */
  metadataCustomField9List: Array<MetadataCustomField9>;
  /** "MetadataCustomField9.metadata"'s inverse relation count */
  metadataCustomField9ListCount: Scalars['Int']['output'];
  /** "MetadataDateCreated.metadata"'s inverse relation */
  metadataDateCreatedList: Array<MetadataDateCreated>;
  /** "MetadataDateCreated.metadata"'s inverse relation count */
  metadataDateCreatedListCount: Scalars['Int']['output'];
  /** "MetadataDateTimeOriginal.metadata"'s inverse relation */
  metadataDateTimeOriginalList: Array<MetadataDateTimeOriginal>;
  /** "MetadataDateTimeOriginal.metadata"'s inverse relation count */
  metadataDateTimeOriginalListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryAccount.metadata"'s inverse relation */
  metadataDeliveryAccountList: Array<MetadataDeliveryAccount>;
  /** "MetadataDeliveryAccount.metadata"'s inverse relation count */
  metadataDeliveryAccountListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryCompany.metadata"'s inverse relation */
  metadataDeliveryCompanyList: Array<MetadataDeliveryCompany>;
  /** "MetadataDeliveryCompany.metadata"'s inverse relation count */
  metadataDeliveryCompanyListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryCopyright.metadata"'s inverse relation */
  metadataDeliveryCopyrightList: Array<MetadataDeliveryCopyright>;
  /** "MetadataDeliveryCopyright.metadata"'s inverse relation count */
  metadataDeliveryCopyrightListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDateFolder.metadata"'s inverse relation */
  metadataDeliveryDateFolderList: Array<MetadataDeliveryDateFolder>;
  /** "MetadataDeliveryDateFolder.metadata"'s inverse relation count */
  metadataDeliveryDateFolderListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDateTime.metadata"'s inverse relation */
  metadataDeliveryDateTimeList: Array<MetadataDeliveryDateTime>;
  /** "MetadataDeliveryDateTime.metadata"'s inverse relation count */
  metadataDeliveryDateTimeListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDcCreator.metadata"'s inverse relation */
  metadataDeliveryDcCreatorList: Array<MetadataDeliveryDcCreator>;
  /** "MetadataDeliveryDcCreator.metadata"'s inverse relation count */
  metadataDeliveryDcCreatorListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDcRights.metadata"'s inverse relation */
  metadataDeliveryDcRightsList: Array<MetadataDeliveryDcRights>;
  /** "MetadataDeliveryDcRights.metadata"'s inverse relation count */
  metadataDeliveryDcRightsListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryFolder.metadata"'s inverse relation */
  metadataDeliveryFolderList: Array<MetadataDeliveryFolder>;
  /** "MetadataDeliveryFolder.metadata"'s inverse relation count */
  metadataDeliveryFolderListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryKind.metadata"'s inverse relation */
  metadataDeliveryKindList: Array<MetadataDeliveryKind>;
  /** "MetadataDeliveryKind.metadata"'s inverse relation count */
  metadataDeliveryKindListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryPath.metadata"'s inverse relation */
  metadataDeliveryPathList: Array<MetadataDeliveryPath>;
  /** "MetadataDeliveryPath.metadata"'s inverse relation count */
  metadataDeliveryPathListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryPhotoshopCredit.metadata"'s inverse relation */
  metadataDeliveryPhotoshopCreditList: Array<MetadataDeliveryPhotoshopCredit>;
  /** "MetadataDeliveryPhotoshopCredit.metadata"'s inverse relation count */
  metadataDeliveryPhotoshopCreditListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryPhotoshopSource.metadata"'s inverse relation */
  metadataDeliveryPhotoshopSourceList: Array<MetadataDeliveryPhotoshopSource>;
  /** "MetadataDeliveryPhotoshopSource.metadata"'s inverse relation count */
  metadataDeliveryPhotoshopSourceListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryService.metadata"'s inverse relation */
  metadataDeliveryServiceList: Array<MetadataDeliveryService>;
  /** "MetadataDeliveryService.metadata"'s inverse relation count */
  metadataDeliveryServiceListCount: Scalars['Int']['output'];
  /** "MetadataDeliverySubject.metadata"'s inverse relation */
  metadataDeliverySubjectList: Array<MetadataDeliverySubject>;
  /** "MetadataDeliverySubject.metadata"'s inverse relation count */
  metadataDeliverySubjectListCount: Scalars['Int']['output'];
  /** "MetadataDeliveryUnderSubject.metadata"'s inverse relation */
  metadataDeliveryUnderSubjectList: Array<MetadataDeliveryUnderSubject>;
  /** "MetadataDeliveryUnderSubject.metadata"'s inverse relation count */
  metadataDeliveryUnderSubjectListCount: Scalars['Int']['output'];
  /** "MetadataDepartment.metadata"'s inverse relation */
  metadataDepartmentList: Array<MetadataDepartment>;
  /** "MetadataDepartment.metadata"'s inverse relation count */
  metadataDepartmentListCount: Scalars['Int']['output'];
  /** "MetadataDescription.metadata"'s inverse relation */
  metadataDescriptionList: Array<MetadataDescription>;
  /** "MetadataDescription.metadata"'s inverse relation count */
  metadataDescriptionListCount: Scalars['Int']['output'];
  /** "MetadataEdition.metadata"'s inverse relation */
  metadataEditionList: Array<MetadataEdition>;
  /** "MetadataEdition.metadata"'s inverse relation count */
  metadataEditionListCount: Scalars['Int']['output'];
  /** "MetadataEditStatus.metadata"'s inverse relation */
  metadataEditStatusList: Array<MetadataEditStatus>;
  /** "MetadataEditStatus.metadata"'s inverse relation count */
  metadataEditStatusListCount: Scalars['Int']['output'];
  /** "MetadataFileStatus.metadata"'s inverse relation */
  metadataFileStatusList: Array<MetadataFileStatus>;
  /** "MetadataFileStatus.metadata"'s inverse relation count */
  metadataFileStatusListCount: Scalars['Int']['output'];
  /** "MetadataFormat.metadata"'s inverse relation */
  metadataFormatList: Array<MetadataFormat>;
  /** "MetadataFormat.metadata"'s inverse relation count */
  metadataFormatListCount: Scalars['Int']['output'];
  /** "MetadataHeader.metadata"'s inverse relation */
  metadataHeaderList: Array<MetadataHeader>;
  /** "MetadataHeader.metadata"'s inverse relation count */
  metadataHeaderListCount: Scalars['Int']['output'];
  /** "MetadataHeaderPrisma.metadata"'s inverse relation */
  metadataHeaderPrismaList: Array<MetadataHeaderPrisma>;
  /** "MetadataHeaderPrisma.metadata"'s inverse relation count */
  metadataHeaderPrismaListCount: Scalars['Int']['output'];
  /** "MetadataHeadline.metadata"'s inverse relation */
  metadataHeadlineList: Array<MetadataHeadline>;
  /** "MetadataHeadline.metadata"'s inverse relation count */
  metadataHeadlineListCount: Scalars['Int']['output'];
  /** "MetadataIdAssignment.metadata"'s inverse relation */
  metadataIdAssignmentList: Array<MetadataIdAssignment>;
  /** "MetadataIdAssignment.metadata"'s inverse relation count */
  metadataIdAssignmentListCount: Scalars['Int']['output'];
  /** "MetadataIdPhotoPrisma.metadata"'s inverse relation */
  metadataIdPhotoPrismaList: Array<MetadataIdPhotoPrisma>;
  /** "MetadataIdPhotoPrisma.metadata"'s inverse relation count */
  metadataIdPhotoPrismaListCount: Scalars['Int']['output'];
  /** "MetadataIdSubject.metadata"'s inverse relation */
  metadataIdSubjectList: Array<MetadataIdSubject>;
  /** "MetadataIdSubject.metadata"'s inverse relation count */
  metadataIdSubjectListCount: Scalars['Int']['output'];
  /** "MetadataImageNotes.metadata"'s inverse relation */
  metadataImageNotesList: Array<MetadataImageNotes>;
  /** "MetadataImageNotes.metadata"'s inverse relation count */
  metadataImageNotesListCount: Scalars['Int']['output'];
  /** "MetadataInstructions.metadata"'s inverse relation */
  metadataInstructionsList: Array<MetadataInstructions>;
  /** "MetadataInstructions.metadata"'s inverse relation count */
  metadataInstructionsListCount: Scalars['Int']['output'];
  /** "MetadataIssue.metadata"'s inverse relation */
  metadataIssueList: Array<MetadataIssue>;
  /** "MetadataIssue.metadata"'s inverse relation count */
  metadataIssueListCount: Scalars['Int']['output'];
  /** "MetadataKeywords.metadata"'s inverse relation */
  metadataKeywordsList: Array<MetadataKeywords>;
  /** "MetadataKeywords.metadata"'s inverse relation count */
  metadataKeywordsListCount: Scalars['Int']['output'];
  /** "MetadataObjectName.metadata"'s inverse relation */
  metadataObjectNameList: Array<MetadataObjectName>;
  /** "MetadataObjectName.metadata"'s inverse relation count */
  metadataObjectNameListCount: Scalars['Int']['output'];
  /** "MetadataOriginalName.metadata"'s inverse relation */
  metadataOriginalNameList: Array<MetadataOriginalName>;
  /** "MetadataOriginalName.metadata"'s inverse relation count */
  metadataOriginalNameListCount: Scalars['Int']['output'];
  /** "MetadataPriceLevel.metadata"'s inverse relation */
  metadataPriceLevelList: Array<MetadataPriceLevel>;
  /** "MetadataPriceLevel.metadata"'s inverse relation count */
  metadataPriceLevelListCount: Scalars['Int']['output'];
  /** "MetadataProcessHistory.metadata"'s inverse relation */
  metadataProcessHistoryList: Array<MetadataProcessHistory>;
  /** "MetadataProcessHistory.metadata"'s inverse relation count */
  metadataProcessHistoryListCount: Scalars['Int']['output'];
  /** "MetadataProcessStatus.metadata"'s inverse relation */
  metadataProcessStatusList: Array<MetadataProcessStatus>;
  /** "MetadataProcessStatus.metadata"'s inverse relation count */
  metadataProcessStatusListCount: Scalars['Int']['output'];
  /** "MetadataProduct.metadata"'s inverse relation */
  metadataProductList: Array<MetadataProduct>;
  /** "MetadataProduct.metadata"'s inverse relation count */
  metadataProductListCount: Scalars['Int']['output'];
  /** "MetadataProducts.metadata"'s inverse relation */
  metadataProductsList: Array<MetadataProducts>;
  /** "MetadataProducts.metadata"'s inverse relation count */
  metadataProductsListCount: Scalars['Int']['output'];
  /** "MetadataPublishingSubject.metadata"'s inverse relation */
  metadataPublishingSubjectList: Array<MetadataPublishingSubject>;
  /** "MetadataPublishingSubject.metadata"'s inverse relation count */
  metadataPublishingSubjectListCount: Scalars['Int']['output'];
  /** "MetadataResolutionKind.metadata"'s inverse relation */
  metadataResolutionKindList: Array<MetadataResolutionKind>;
  /** "MetadataResolutionKind.metadata"'s inverse relation count */
  metadataResolutionKindListCount: Scalars['Int']['output'];
  /** "MetadataRights.metadata"'s inverse relation */
  metadataRightsList: Array<MetadataRights>;
  /** "MetadataRights.metadata"'s inverse relation count */
  metadataRightsListCount: Scalars['Int']['output'];
  /** "MetadataSource.metadata"'s inverse relation */
  metadataSourceList: Array<MetadataSource>;
  /** "MetadataSource.metadata"'s inverse relation count */
  metadataSourceListCount: Scalars['Int']['output'];
  /** "MetadataSpecialInstructions.metadata"'s inverse relation */
  metadataSpecialInstructionsList: Array<MetadataSpecialInstructions>;
  /** "MetadataSpecialInstructions.metadata"'s inverse relation count */
  metadataSpecialInstructionsListCount: Scalars['Int']['output'];
  /** "MetadataSubjectCode.metadata"'s inverse relation */
  metadataSubjectCodeList: Array<MetadataSubjectCode>;
  /** "MetadataSubjectCode.metadata"'s inverse relation count */
  metadataSubjectCodeListCount: Scalars['Int']['output'];
  /** "MetadataSubject.metadata"'s inverse relation */
  metadataSubjectList: Array<MetadataSubject>;
  /** "MetadataSubject.metadata"'s inverse relation count */
  metadataSubjectListCount: Scalars['Int']['output'];
  /** "MetadataSubjectPrisma.metadata"'s inverse relation */
  metadataSubjectPrismaList: Array<MetadataSubjectPrisma>;
  /** "MetadataSubjectPrisma.metadata"'s inverse relation count */
  metadataSubjectPrismaListCount: Scalars['Int']['output'];
  /** "MetadataTitle.metadata"'s inverse relation */
  metadataTitleList: Array<MetadataTitle>;
  /** "MetadataTitle.metadata"'s inverse relation count */
  metadataTitleListCount: Scalars['Int']['output'];
  /** "MetadataTransferredByFullName.metadata"'s inverse relation */
  metadataTransferredByFullNameList: Array<MetadataTransferredByFullName>;
  /** "MetadataTransferredByFullName.metadata"'s inverse relation count */
  metadataTransferredByFullNameListCount: Scalars['Int']['output'];
  /** "MetadataTransferredBy.metadata"'s inverse relation */
  metadataTransferredByList: Array<MetadataTransferredBy>;
  /** "MetadataTransferredBy.metadata"'s inverse relation count */
  metadataTransferredByListCount: Scalars['Int']['output'];
  /** "MetadataType.metadata"'s inverse relation */
  metadataTypeList: Array<MetadataType>;
  /** "MetadataType.metadata"'s inverse relation count */
  metadataTypeListCount: Scalars['Int']['output'];
  /** "MetadataUndersubject.metadata"'s inverse relation */
  metadataUndersubjectList: Array<MetadataUndersubject>;
  /** "MetadataUndersubject.metadata"'s inverse relation count */
  metadataUndersubjectListCount: Scalars['Int']['output'];
  /** "MetadataUnderUnderSubject.metadata"'s inverse relation */
  metadataUnderUnderSubjectList: Array<MetadataUnderUnderSubject>;
  /** "MetadataUnderUnderSubject.metadata"'s inverse relation count */
  metadataUnderUnderSubjectListCount: Scalars['Int']['output'];
  /** "MetadataUploadedByFullName.metadata"'s inverse relation */
  metadataUploadedByFullNameList: Array<MetadataUploadedByFullName>;
  /** "MetadataUploadedByFullName.metadata"'s inverse relation count */
  metadataUploadedByFullNameListCount: Scalars['Int']['output'];
  /** "MetadataUploadedBy.metadata"'s inverse relation */
  metadataUploadedByList: Array<MetadataUploadedBy>;
  /** "MetadataUploadedBy.metadata"'s inverse relation count */
  metadataUploadedByListCount: Scalars['Int']['output'];
  /** "MetadataUploadTime.metadata"'s inverse relation */
  metadataUploadTimeList: Array<MetadataUploadTime>;
  /** "MetadataUploadTime.metadata"'s inverse relation count */
  metadataUploadTimeListCount: Scalars['Int']['output'];
  /** "MetadataUrgency.metadata"'s inverse relation */
  metadataUrgencyList: Array<MetadataUrgency>;
  /** "MetadataUrgency.metadata"'s inverse relation count */
  metadataUrgencyListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined195.metadata"'s inverse relation */
  metadataUserDefined195List: Array<MetadataUserDefined195>;
  /** "MetadataUserDefined195.metadata"'s inverse relation count */
  metadataUserDefined195ListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined237.metadata"'s inverse relation */
  metadataUserDefined237List: Array<MetadataUserDefined237>;
  /** "MetadataUserDefined237.metadata"'s inverse relation count */
  metadataUserDefined237ListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined238.metadata"'s inverse relation */
  metadataUserDefined238List: Array<MetadataUserDefined238>;
  /** "MetadataUserDefined238.metadata"'s inverse relation count */
  metadataUserDefined238ListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined239.metadata"'s inverse relation */
  metadataUserDefined239List: Array<MetadataUserDefined239>;
  /** "MetadataUserDefined239.metadata"'s inverse relation count */
  metadataUserDefined239ListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined242.metadata"'s inverse relation */
  metadataUserDefined242List: Array<MetadataUserDefined242>;
  /** "MetadataUserDefined242.metadata"'s inverse relation count */
  metadataUserDefined242ListCount: Scalars['Int']['output'];
  /** "MetadataUserDefined62.metadata"'s inverse relation */
  metadataUserDefined62List: Array<MetadataUserDefined62>;
  /** "MetadataUserDefined62.metadata"'s inverse relation count */
  metadataUserDefined62ListCount: Scalars['Int']['output'];
  /** "MetadataWorkflowKind.metadata"'s inverse relation */
  metadataWorkflowKindList: Array<MetadataWorkflowKind>;
  /** "MetadataWorkflowKind.metadata"'s inverse relation count */
  metadataWorkflowKindListCount: Scalars['Int']['output'];
  /** "MetadataXmpHistory.metadata"'s inverse relation */
  metadataXmpHistoryList: Array<MetadataXmpHistory>;
  /** "MetadataXmpHistory.metadata"'s inverse relation count */
  metadataXmpHistoryListCount: Scalars['Int']['output'];
  name: MetadataNameEnumType;
  namespace: Scalars['String']['output'];
  /** "PhotoMetadata.metadata"'s inverse relation count */
  photoMetadataCount: Scalars['Int']['output'];
  /** "PhotoMetadata.metadata"'s inverse relation */
  photoMetadatas: Array<PhotoMetadata>;
  structName?: Maybe<Scalars['String']['output']>;
  /** whether is this metadata value is a list or not, for display usage */
  type: MetadataValueTypeEnum;
};


/** "Metadata" resource's node */
export type MetadataMetadataAccessRightsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataAccessRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataAccessRightsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataAccessRightsListCountArgs = {
  where?: InputMaybe<MetadataAccessRightsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataAssetStateListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataAssetStateOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataAssetStateWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataAssetStateListCountArgs = {
  where?: InputMaybe<MetadataAssetStateWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataBackupNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBackupNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBackupNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataBackupNameListCountArgs = {
  where?: InputMaybe<MetadataBackupNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataBrandListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataBrandListCountArgs = {
  where?: InputMaybe<MetadataBrandWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataBrandPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandPrismaWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataBrandPrismaListCountArgs = {
  where?: InputMaybe<MetadataBrandPrismaWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataBrandShortNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandShortNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandShortNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataBrandShortNameListCountArgs = {
  where?: InputMaybe<MetadataBrandShortNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataByLineListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataByLineOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataByLineWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataByLineListCountArgs = {
  where?: InputMaybe<MetadataByLineWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCaptionAbstractListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCaptionAbstractOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCaptionAbstractWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCaptionAbstractListCountArgs = {
  where?: InputMaybe<MetadataCaptionAbstractWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCaptionListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCaptionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCaptionWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCaptionListCountArgs = {
  where?: InputMaybe<MetadataCaptionWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCategoryListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCategoryWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCategoryListCountArgs = {
  where?: InputMaybe<MetadataCategoryWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCategoryPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCategoryPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCategoryPrismaWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCategoryPrismaListCountArgs = {
  where?: InputMaybe<MetadataCategoryPrismaWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCompanyListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCompanyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCompanyWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCompanyListCountArgs = {
  where?: InputMaybe<MetadataCompanyWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCompanyShortNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCompanyShortNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCompanyShortNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCompanyShortNameListCountArgs = {
  where?: InputMaybe<MetadataCompanyShortNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCopyrightNoticeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCopyrightNoticeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCopyrightNoticeListCountArgs = {
  where?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCreatorListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCreatorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCreatorWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCreatorListCountArgs = {
  where?: InputMaybe<MetadataCreatorWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCreditListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCreditOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCreditWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCreditListCountArgs = {
  where?: InputMaybe<MetadataCreditWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField14ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField14OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField14WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField14ListCountArgs = {
  where?: InputMaybe<MetadataCustomField14WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField15ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField15OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField15WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField15ListCountArgs = {
  where?: InputMaybe<MetadataCustomField15WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField16ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField16OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField16WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField16ListCountArgs = {
  where?: InputMaybe<MetadataCustomField16WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField17ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField17OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField17WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField17ListCountArgs = {
  where?: InputMaybe<MetadataCustomField17WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField1ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField1OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField1WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField1ListCountArgs = {
  where?: InputMaybe<MetadataCustomField1WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField20ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField20OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField20WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField20ListCountArgs = {
  where?: InputMaybe<MetadataCustomField20WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField3ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField3OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField3WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField3ListCountArgs = {
  where?: InputMaybe<MetadataCustomField3WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField4ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField4OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField4WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField4ListCountArgs = {
  where?: InputMaybe<MetadataCustomField4WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField5ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField5OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField5WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField5ListCountArgs = {
  where?: InputMaybe<MetadataCustomField5WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField6ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField6OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField6WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField6ListCountArgs = {
  where?: InputMaybe<MetadataCustomField6WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField7ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField7OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField7WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField7ListCountArgs = {
  where?: InputMaybe<MetadataCustomField7WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField9ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField9OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField9WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataCustomField9ListCountArgs = {
  where?: InputMaybe<MetadataCustomField9WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDateCreatedListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDateCreatedOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDateCreatedWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDateCreatedListCountArgs = {
  where?: InputMaybe<MetadataDateCreatedWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDateTimeOriginalListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDateTimeOriginalOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDateTimeOriginalListCountArgs = {
  where?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryAccountListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryAccountOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryAccountWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryAccountListCountArgs = {
  where?: InputMaybe<MetadataDeliveryAccountWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryCompanyListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryCompanyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryCompanyListCountArgs = {
  where?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryCopyrightListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryCopyrightOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryCopyrightListCountArgs = {
  where?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryDateFolderListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDateFolderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryDateFolderListCountArgs = {
  where?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryDateTimeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDateTimeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryDateTimeListCountArgs = {
  where?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryDcCreatorListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDcCreatorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryDcCreatorListCountArgs = {
  where?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryDcRightsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDcRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryDcRightsListCountArgs = {
  where?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryFolderListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryFolderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryFolderWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryFolderListCountArgs = {
  where?: InputMaybe<MetadataDeliveryFolderWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryKindListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryKindWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryKindListCountArgs = {
  where?: InputMaybe<MetadataDeliveryKindWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryPathListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPathOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPathWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryPathListCountArgs = {
  where?: InputMaybe<MetadataDeliveryPathWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryPhotoshopCreditListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryPhotoshopCreditListCountArgs = {
  where?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryPhotoshopSourceListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryPhotoshopSourceListCountArgs = {
  where?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryServiceListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryServiceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryServiceWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryServiceListCountArgs = {
  where?: InputMaybe<MetadataDeliveryServiceWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliverySubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliverySubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliverySubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliverySubjectListCountArgs = {
  where?: InputMaybe<MetadataDeliverySubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryUnderSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryUnderSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDeliveryUnderSubjectListCountArgs = {
  where?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDepartmentListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDepartmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDepartmentWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDepartmentListCountArgs = {
  where?: InputMaybe<MetadataDepartmentWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDescriptionListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDescriptionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDescriptionWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataDescriptionListCountArgs = {
  where?: InputMaybe<MetadataDescriptionWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataEditionListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataEditionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataEditionWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataEditionListCountArgs = {
  where?: InputMaybe<MetadataEditionWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataEditStatusListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataEditStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataEditStatusWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataEditStatusListCountArgs = {
  where?: InputMaybe<MetadataEditStatusWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataFileStatusListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataFileStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataFileStatusWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataFileStatusListCountArgs = {
  where?: InputMaybe<MetadataFileStatusWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataFormatListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataFormatOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataFormatWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataFormatListCountArgs = {
  where?: InputMaybe<MetadataFormatWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataHeaderListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeaderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeaderWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataHeaderListCountArgs = {
  where?: InputMaybe<MetadataHeaderWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataHeaderPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeaderPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeaderPrismaWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataHeaderPrismaListCountArgs = {
  where?: InputMaybe<MetadataHeaderPrismaWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataHeadlineListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeadlineOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeadlineWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataHeadlineListCountArgs = {
  where?: InputMaybe<MetadataHeadlineWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataIdAssignmentListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdAssignmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdAssignmentWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataIdAssignmentListCountArgs = {
  where?: InputMaybe<MetadataIdAssignmentWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataIdPhotoPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdPhotoPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataIdPhotoPrismaListCountArgs = {
  where?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataIdSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdSubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataIdSubjectListCountArgs = {
  where?: InputMaybe<MetadataIdSubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataImageNotesListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataImageNotesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataImageNotesWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataImageNotesListCountArgs = {
  where?: InputMaybe<MetadataImageNotesWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataInstructionsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataInstructionsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataInstructionsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataInstructionsListCountArgs = {
  where?: InputMaybe<MetadataInstructionsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataIssueListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIssueOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIssueWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataIssueListCountArgs = {
  where?: InputMaybe<MetadataIssueWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataKeywordsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataKeywordsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataKeywordsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataKeywordsListCountArgs = {
  where?: InputMaybe<MetadataKeywordsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataObjectNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataObjectNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataObjectNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataObjectNameListCountArgs = {
  where?: InputMaybe<MetadataObjectNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataOriginalNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataOriginalNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataOriginalNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataOriginalNameListCountArgs = {
  where?: InputMaybe<MetadataOriginalNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataPriceLevelListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataPriceLevelOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataPriceLevelWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataPriceLevelListCountArgs = {
  where?: InputMaybe<MetadataPriceLevelWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataProcessHistoryListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProcessHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProcessHistoryWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataProcessHistoryListCountArgs = {
  where?: InputMaybe<MetadataProcessHistoryWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataProcessStatusListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProcessStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProcessStatusWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataProcessStatusListCountArgs = {
  where?: InputMaybe<MetadataProcessStatusWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataProductListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProductOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProductWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataProductListCountArgs = {
  where?: InputMaybe<MetadataProductWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataProductsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProductsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProductsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataProductsListCountArgs = {
  where?: InputMaybe<MetadataProductsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataPublishingSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataPublishingSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataPublishingSubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataPublishingSubjectListCountArgs = {
  where?: InputMaybe<MetadataPublishingSubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataResolutionKindListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataResolutionKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataResolutionKindWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataResolutionKindListCountArgs = {
  where?: InputMaybe<MetadataResolutionKindWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataRightsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataRightsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataRightsListCountArgs = {
  where?: InputMaybe<MetadataRightsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataSourceListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSourceWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataSourceListCountArgs = {
  where?: InputMaybe<MetadataSourceWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataSpecialInstructionsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSpecialInstructionsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataSpecialInstructionsListCountArgs = {
  where?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataSubjectCodeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectCodeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectCodeWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataSubjectCodeListCountArgs = {
  where?: InputMaybe<MetadataSubjectCodeWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataSubjectListCountArgs = {
  where?: InputMaybe<MetadataSubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataSubjectPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectPrismaWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataSubjectPrismaListCountArgs = {
  where?: InputMaybe<MetadataSubjectPrismaWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataTitleListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTitleOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTitleWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataTitleListCountArgs = {
  where?: InputMaybe<MetadataTitleWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataTransferredByFullNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTransferredByFullNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataTransferredByFullNameListCountArgs = {
  where?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataTransferredByListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTransferredByOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTransferredByWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataTransferredByListCountArgs = {
  where?: InputMaybe<MetadataTransferredByWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataTypeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTypeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTypeWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataTypeListCountArgs = {
  where?: InputMaybe<MetadataTypeWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUndersubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUndersubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUndersubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUndersubjectListCountArgs = {
  where?: InputMaybe<MetadataUndersubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUnderUnderSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUnderUnderSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUnderUnderSubjectListCountArgs = {
  where?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUploadedByFullNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadedByFullNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUploadedByFullNameListCountArgs = {
  where?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUploadedByListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadedByOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadedByWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUploadedByListCountArgs = {
  where?: InputMaybe<MetadataUploadedByWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUploadTimeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadTimeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadTimeWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUploadTimeListCountArgs = {
  where?: InputMaybe<MetadataUploadTimeWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUrgencyListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUrgencyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUrgencyWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUrgencyListCountArgs = {
  where?: InputMaybe<MetadataUrgencyWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined195ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined195OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined195WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined195ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined195WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined237ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined237OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined237WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined237ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined237WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined238ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined238OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined238WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined238ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined238WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined239ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined239OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined239WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined239ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined239WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined242ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined242OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined242WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined242ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined242WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined62ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined62OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined62WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataUserDefined62ListCountArgs = {
  where?: InputMaybe<MetadataUserDefined62WhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataWorkflowKindListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataWorkflowKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataWorkflowKindWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataWorkflowKindListCountArgs = {
  where?: InputMaybe<MetadataWorkflowKindWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataXmpHistoryListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataXmpHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataXmpHistoryWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataMetadataXmpHistoryListCountArgs = {
  where?: InputMaybe<MetadataXmpHistoryWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataPhotoMetadataCountArgs = {
  where?: InputMaybe<PhotoMetadataWhereInput>;
};


/** "Metadata" resource's node */
export type MetadataPhotoMetadatasArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoMetadataOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoMetadataWhereInput>;
};

/** "MetadataAccessRights" resource's node */
export type MetadataAccessRights = {
  __typename?: 'MetadataAccessRights';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataAccessRightsCreateInput = {
  /** Actions for the "MetadataAccessRights.archive" relation */
  archive: MetadataAccessRightsNestedArchiveCreateInput;
  /** Actions for the "MetadataAccessRights.metadata" relation */
  metadata: MetadataAccessRightsNestedMetadataCreateInput;
  /** Actions for the "MetadataAccessRights.photo" relation */
  photo: MetadataAccessRightsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAccessRightsNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataAccessRights" node, through the "MetadataAccessRights.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataAccessRights" node, through the "MetadataAccessRights.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataAccessRights" node, through the "MetadataAccessRights.archive" relation. */
  update?: InputMaybe<MetadataAccessRightsNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataAccessRights" node, through the "MetadataAccessRights.archive" relation. */
  upsert?: InputMaybe<MetadataAccessRightsNestedUpsertArchiveCreateInput>;
};

export type MetadataAccessRightsNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.archive" relation. */
  update?: InputMaybe<MetadataAccessRightsNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.archive" relation. */
  upsert?: InputMaybe<MetadataAccessRightsNestedUpsertArchiveUpdateInput>;
};

export type MetadataAccessRightsNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataAccessRights" node, through the "MetadataAccessRights.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataAccessRights" node, through the "MetadataAccessRights.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataAccessRights" node, through the "MetadataAccessRights.metadata" relation. */
  update?: InputMaybe<MetadataAccessRightsNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataAccessRights" node, through the "MetadataAccessRights.metadata" relation. */
  upsert?: InputMaybe<MetadataAccessRightsNestedUpsertMetadataCreateInput>;
};

export type MetadataAccessRightsNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.metadata" relation. */
  update?: InputMaybe<MetadataAccessRightsNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.metadata" relation. */
  upsert?: InputMaybe<MetadataAccessRightsNestedUpsertMetadataUpdateInput>;
};

export type MetadataAccessRightsNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataAccessRights" node, through the "MetadataAccessRights.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataAccessRights" node, through the "MetadataAccessRights.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataAccessRights" node, through the "MetadataAccessRights.photo" relation. */
  update?: InputMaybe<MetadataAccessRightsNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataAccessRights" node, through the "MetadataAccessRights.photo" relation. */
  upsert?: InputMaybe<MetadataAccessRightsNestedUpsertPhotoCreateInput>;
};

export type MetadataAccessRightsNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.photo" relation. */
  update?: InputMaybe<MetadataAccessRightsNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataAccessRights" node, through the "MetadataAccessRights.photo" relation. */
  upsert?: InputMaybe<MetadataAccessRightsNestedUpsertPhotoUpdateInput>;
};

export type MetadataAccessRightsNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataAccessRightsNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataAccessRightsOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataAccessRightsUpdateInput = {
  /** Actions for the "MetadataAccessRights.archive" relation */
  archive?: InputMaybe<MetadataAccessRightsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataAccessRights.metadata" relation */
  metadata?: InputMaybe<MetadataAccessRightsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataAccessRights.photo" relation */
  photo?: InputMaybe<MetadataAccessRightsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataAccessRights" nodes by specifying some conditions */
export type MetadataAccessRightsWhereInput = {
  AND?: InputMaybe<Array<MetadataAccessRightsWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataAccessRightsWhereInput>;
  OR?: InputMaybe<Array<MetadataAccessRightsWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataAccessRights" node. */
export type MetadataAccessRightsWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataAccessRightsWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataAccessRights.metadata" relation */
  metadata: MetadataAccessRightsNestedMetadataCreateInput;
  /** Actions for the "MetadataAccessRights.photo" relation */
  photo: MetadataAccessRightsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAccessRightsWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataAccessRights.metadata" relation */
  metadata?: InputMaybe<MetadataAccessRightsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataAccessRights.photo" relation */
  photo?: InputMaybe<MetadataAccessRightsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAccessRightsWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataAccessRights.archive" relation */
  archive: MetadataAccessRightsNestedArchiveCreateInput;
  /** Actions for the "MetadataAccessRights.photo" relation */
  photo: MetadataAccessRightsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAccessRightsWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataAccessRights.archive" relation */
  archive?: InputMaybe<MetadataAccessRightsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataAccessRights.photo" relation */
  photo?: InputMaybe<MetadataAccessRightsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAccessRightsWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataAccessRights.archive" relation */
  archive: MetadataAccessRightsNestedArchiveCreateInput;
  /** Actions for the "MetadataAccessRights.metadata" relation */
  metadata: MetadataAccessRightsNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAccessRightsWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataAccessRights.archive" relation */
  archive?: InputMaybe<MetadataAccessRightsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataAccessRights.metadata" relation */
  metadata?: InputMaybe<MetadataAccessRightsNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataAssetState" resource's node */
export type MetadataAssetState = {
  __typename?: 'MetadataAssetState';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataAssetStateCreateInput = {
  /** Actions for the "MetadataAssetState.archive" relation */
  archive: MetadataAssetStateNestedArchiveCreateInput;
  /** Actions for the "MetadataAssetState.metadata" relation */
  metadata: MetadataAssetStateNestedMetadataCreateInput;
  /** Actions for the "MetadataAssetState.photo" relation */
  photo: MetadataAssetStateNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAssetStateNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataAssetState" node, through the "MetadataAssetState.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataAssetState" node, through the "MetadataAssetState.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataAssetState" node, through the "MetadataAssetState.archive" relation. */
  update?: InputMaybe<MetadataAssetStateNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataAssetState" node, through the "MetadataAssetState.archive" relation. */
  upsert?: InputMaybe<MetadataAssetStateNestedUpsertArchiveCreateInput>;
};

export type MetadataAssetStateNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataAssetState" node, through the "MetadataAssetState.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataAssetState" node, through the "MetadataAssetState.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataAssetState" node, through the "MetadataAssetState.archive" relation. */
  update?: InputMaybe<MetadataAssetStateNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataAssetState" node, through the "MetadataAssetState.archive" relation. */
  upsert?: InputMaybe<MetadataAssetStateNestedUpsertArchiveUpdateInput>;
};

export type MetadataAssetStateNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataAssetState" node, through the "MetadataAssetState.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataAssetState" node, through the "MetadataAssetState.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataAssetState" node, through the "MetadataAssetState.metadata" relation. */
  update?: InputMaybe<MetadataAssetStateNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataAssetState" node, through the "MetadataAssetState.metadata" relation. */
  upsert?: InputMaybe<MetadataAssetStateNestedUpsertMetadataCreateInput>;
};

export type MetadataAssetStateNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataAssetState" node, through the "MetadataAssetState.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataAssetState" node, through the "MetadataAssetState.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataAssetState" node, through the "MetadataAssetState.metadata" relation. */
  update?: InputMaybe<MetadataAssetStateNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataAssetState" node, through the "MetadataAssetState.metadata" relation. */
  upsert?: InputMaybe<MetadataAssetStateNestedUpsertMetadataUpdateInput>;
};

export type MetadataAssetStateNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataAssetState" node, through the "MetadataAssetState.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataAssetState" node, through the "MetadataAssetState.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataAssetState" node, through the "MetadataAssetState.photo" relation. */
  update?: InputMaybe<MetadataAssetStateNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataAssetState" node, through the "MetadataAssetState.photo" relation. */
  upsert?: InputMaybe<MetadataAssetStateNestedUpsertPhotoCreateInput>;
};

export type MetadataAssetStateNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataAssetState" node, through the "MetadataAssetState.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataAssetState" node, through the "MetadataAssetState.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataAssetState" node, through the "MetadataAssetState.photo" relation. */
  update?: InputMaybe<MetadataAssetStateNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataAssetState" node, through the "MetadataAssetState.photo" relation. */
  upsert?: InputMaybe<MetadataAssetStateNestedUpsertPhotoUpdateInput>;
};

export type MetadataAssetStateNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataAssetStateNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataAssetStateNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataAssetStateNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataAssetStateNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataAssetStateNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataAssetStateNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataAssetStateNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataAssetStateNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataAssetStateNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataAssetStateNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataAssetStateNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataAssetStateOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataAssetStateUpdateInput = {
  /** Actions for the "MetadataAssetState.archive" relation */
  archive?: InputMaybe<MetadataAssetStateNestedArchiveUpdateInput>;
  /** Actions for the "MetadataAssetState.metadata" relation */
  metadata?: InputMaybe<MetadataAssetStateNestedMetadataUpdateInput>;
  /** Actions for the "MetadataAssetState.photo" relation */
  photo?: InputMaybe<MetadataAssetStateNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataAssetState" nodes by specifying some conditions */
export type MetadataAssetStateWhereInput = {
  AND?: InputMaybe<Array<MetadataAssetStateWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataAssetStateWhereInput>;
  OR?: InputMaybe<Array<MetadataAssetStateWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataAssetState" node. */
export type MetadataAssetStateWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataAssetStateWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataAssetState.metadata" relation */
  metadata: MetadataAssetStateNestedMetadataCreateInput;
  /** Actions for the "MetadataAssetState.photo" relation */
  photo: MetadataAssetStateNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAssetStateWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataAssetState.metadata" relation */
  metadata?: InputMaybe<MetadataAssetStateNestedMetadataUpdateInput>;
  /** Actions for the "MetadataAssetState.photo" relation */
  photo?: InputMaybe<MetadataAssetStateNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAssetStateWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataAssetState.archive" relation */
  archive: MetadataAssetStateNestedArchiveCreateInput;
  /** Actions for the "MetadataAssetState.photo" relation */
  photo: MetadataAssetStateNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAssetStateWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataAssetState.archive" relation */
  archive?: InputMaybe<MetadataAssetStateNestedArchiveUpdateInput>;
  /** Actions for the "MetadataAssetState.photo" relation */
  photo?: InputMaybe<MetadataAssetStateNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAssetStateWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataAssetState.archive" relation */
  archive: MetadataAssetStateNestedArchiveCreateInput;
  /** Actions for the "MetadataAssetState.metadata" relation */
  metadata: MetadataAssetStateNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataAssetStateWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataAssetState.archive" relation */
  archive?: InputMaybe<MetadataAssetStateNestedArchiveUpdateInput>;
  /** Actions for the "MetadataAssetState.metadata" relation */
  metadata?: InputMaybe<MetadataAssetStateNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataBackupName" resource's node */
export type MetadataBackupName = {
  __typename?: 'MetadataBackupName';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataBackupNameCreateInput = {
  /** Actions for the "MetadataBackupName.archive" relation */
  archive: MetadataBackupNameNestedArchiveCreateInput;
  /** Actions for the "MetadataBackupName.metadata" relation */
  metadata: MetadataBackupNameNestedMetadataCreateInput;
  /** Actions for the "MetadataBackupName.photo" relation */
  photo: MetadataBackupNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBackupNameNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataBackupName" node, through the "MetadataBackupName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataBackupName" node, through the "MetadataBackupName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataBackupName" node, through the "MetadataBackupName.archive" relation. */
  update?: InputMaybe<MetadataBackupNameNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataBackupName" node, through the "MetadataBackupName.archive" relation. */
  upsert?: InputMaybe<MetadataBackupNameNestedUpsertArchiveCreateInput>;
};

export type MetadataBackupNameNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataBackupName" node, through the "MetadataBackupName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataBackupName" node, through the "MetadataBackupName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataBackupName" node, through the "MetadataBackupName.archive" relation. */
  update?: InputMaybe<MetadataBackupNameNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataBackupName" node, through the "MetadataBackupName.archive" relation. */
  upsert?: InputMaybe<MetadataBackupNameNestedUpsertArchiveUpdateInput>;
};

export type MetadataBackupNameNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataBackupName" node, through the "MetadataBackupName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataBackupName" node, through the "MetadataBackupName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataBackupName" node, through the "MetadataBackupName.metadata" relation. */
  update?: InputMaybe<MetadataBackupNameNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataBackupName" node, through the "MetadataBackupName.metadata" relation. */
  upsert?: InputMaybe<MetadataBackupNameNestedUpsertMetadataCreateInput>;
};

export type MetadataBackupNameNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataBackupName" node, through the "MetadataBackupName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataBackupName" node, through the "MetadataBackupName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataBackupName" node, through the "MetadataBackupName.metadata" relation. */
  update?: InputMaybe<MetadataBackupNameNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataBackupName" node, through the "MetadataBackupName.metadata" relation. */
  upsert?: InputMaybe<MetadataBackupNameNestedUpsertMetadataUpdateInput>;
};

export type MetadataBackupNameNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataBackupName" node, through the "MetadataBackupName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataBackupName" node, through the "MetadataBackupName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataBackupName" node, through the "MetadataBackupName.photo" relation. */
  update?: InputMaybe<MetadataBackupNameNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataBackupName" node, through the "MetadataBackupName.photo" relation. */
  upsert?: InputMaybe<MetadataBackupNameNestedUpsertPhotoCreateInput>;
};

export type MetadataBackupNameNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataBackupName" node, through the "MetadataBackupName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataBackupName" node, through the "MetadataBackupName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataBackupName" node, through the "MetadataBackupName.photo" relation. */
  update?: InputMaybe<MetadataBackupNameNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataBackupName" node, through the "MetadataBackupName.photo" relation. */
  upsert?: InputMaybe<MetadataBackupNameNestedUpsertPhotoUpdateInput>;
};

export type MetadataBackupNameNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBackupNameNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBackupNameNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBackupNameNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBackupNameNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBackupNameNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBackupNameNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBackupNameNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBackupNameNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBackupNameNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBackupNameNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBackupNameNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataBackupNameOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataBackupNameUpdateInput = {
  /** Actions for the "MetadataBackupName.archive" relation */
  archive?: InputMaybe<MetadataBackupNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBackupName.metadata" relation */
  metadata?: InputMaybe<MetadataBackupNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataBackupName.photo" relation */
  photo?: InputMaybe<MetadataBackupNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataBackupName" nodes by specifying some conditions */
export type MetadataBackupNameWhereInput = {
  AND?: InputMaybe<Array<MetadataBackupNameWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataBackupNameWhereInput>;
  OR?: InputMaybe<Array<MetadataBackupNameWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataBackupName" node. */
export type MetadataBackupNameWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataBackupNameWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataBackupName.metadata" relation */
  metadata: MetadataBackupNameNestedMetadataCreateInput;
  /** Actions for the "MetadataBackupName.photo" relation */
  photo: MetadataBackupNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBackupNameWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataBackupName.metadata" relation */
  metadata?: InputMaybe<MetadataBackupNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataBackupName.photo" relation */
  photo?: InputMaybe<MetadataBackupNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBackupNameWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataBackupName.archive" relation */
  archive: MetadataBackupNameNestedArchiveCreateInput;
  /** Actions for the "MetadataBackupName.photo" relation */
  photo: MetadataBackupNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBackupNameWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataBackupName.archive" relation */
  archive?: InputMaybe<MetadataBackupNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBackupName.photo" relation */
  photo?: InputMaybe<MetadataBackupNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBackupNameWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataBackupName.archive" relation */
  archive: MetadataBackupNameNestedArchiveCreateInput;
  /** Actions for the "MetadataBackupName.metadata" relation */
  metadata: MetadataBackupNameNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBackupNameWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataBackupName.archive" relation */
  archive?: InputMaybe<MetadataBackupNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBackupName.metadata" relation */
  metadata?: InputMaybe<MetadataBackupNameNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataBrand" resource's node */
export type MetadataBrand = {
  __typename?: 'MetadataBrand';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataBrandCreateInput = {
  /** Actions for the "MetadataBrand.archive" relation */
  archive: MetadataBrandNestedArchiveCreateInput;
  /** Actions for the "MetadataBrand.metadata" relation */
  metadata: MetadataBrandNestedMetadataCreateInput;
  /** Actions for the "MetadataBrand.photo" relation */
  photo: MetadataBrandNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataBrand" node, through the "MetadataBrand.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataBrand" node, through the "MetadataBrand.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataBrand" node, through the "MetadataBrand.archive" relation. */
  update?: InputMaybe<MetadataBrandNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataBrand" node, through the "MetadataBrand.archive" relation. */
  upsert?: InputMaybe<MetadataBrandNestedUpsertArchiveCreateInput>;
};

export type MetadataBrandNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataBrand" node, through the "MetadataBrand.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataBrand" node, through the "MetadataBrand.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataBrand" node, through the "MetadataBrand.archive" relation. */
  update?: InputMaybe<MetadataBrandNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataBrand" node, through the "MetadataBrand.archive" relation. */
  upsert?: InputMaybe<MetadataBrandNestedUpsertArchiveUpdateInput>;
};

export type MetadataBrandNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataBrand" node, through the "MetadataBrand.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataBrand" node, through the "MetadataBrand.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataBrand" node, through the "MetadataBrand.metadata" relation. */
  update?: InputMaybe<MetadataBrandNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataBrand" node, through the "MetadataBrand.metadata" relation. */
  upsert?: InputMaybe<MetadataBrandNestedUpsertMetadataCreateInput>;
};

export type MetadataBrandNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataBrand" node, through the "MetadataBrand.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataBrand" node, through the "MetadataBrand.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataBrand" node, through the "MetadataBrand.metadata" relation. */
  update?: InputMaybe<MetadataBrandNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataBrand" node, through the "MetadataBrand.metadata" relation. */
  upsert?: InputMaybe<MetadataBrandNestedUpsertMetadataUpdateInput>;
};

export type MetadataBrandNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataBrand" node, through the "MetadataBrand.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataBrand" node, through the "MetadataBrand.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataBrand" node, through the "MetadataBrand.photo" relation. */
  update?: InputMaybe<MetadataBrandNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataBrand" node, through the "MetadataBrand.photo" relation. */
  upsert?: InputMaybe<MetadataBrandNestedUpsertPhotoCreateInput>;
};

export type MetadataBrandNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataBrand" node, through the "MetadataBrand.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataBrand" node, through the "MetadataBrand.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataBrand" node, through the "MetadataBrand.photo" relation. */
  update?: InputMaybe<MetadataBrandNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataBrand" node, through the "MetadataBrand.photo" relation. */
  upsert?: InputMaybe<MetadataBrandNestedUpsertPhotoUpdateInput>;
};

export type MetadataBrandNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBrandNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBrandNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBrandNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataBrandOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

/** "MetadataBrandPrisma" resource's node */
export type MetadataBrandPrisma = {
  __typename?: 'MetadataBrandPrisma';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataBrandPrismaCreateInput = {
  /** Actions for the "MetadataBrandPrisma.archive" relation */
  archive: MetadataBrandPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataBrandPrisma.metadata" relation */
  metadata: MetadataBrandPrismaNestedMetadataCreateInput;
  /** Actions for the "MetadataBrandPrisma.photo" relation */
  photo: MetadataBrandPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandPrismaNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.archive" relation. */
  update?: InputMaybe<MetadataBrandPrismaNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.archive" relation. */
  upsert?: InputMaybe<MetadataBrandPrismaNestedUpsertArchiveCreateInput>;
};

export type MetadataBrandPrismaNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.archive" relation. */
  update?: InputMaybe<MetadataBrandPrismaNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.archive" relation. */
  upsert?: InputMaybe<MetadataBrandPrismaNestedUpsertArchiveUpdateInput>;
};

export type MetadataBrandPrismaNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.metadata" relation. */
  update?: InputMaybe<MetadataBrandPrismaNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.metadata" relation. */
  upsert?: InputMaybe<MetadataBrandPrismaNestedUpsertMetadataCreateInput>;
};

export type MetadataBrandPrismaNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.metadata" relation. */
  update?: InputMaybe<MetadataBrandPrismaNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.metadata" relation. */
  upsert?: InputMaybe<MetadataBrandPrismaNestedUpsertMetadataUpdateInput>;
};

export type MetadataBrandPrismaNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.photo" relation. */
  update?: InputMaybe<MetadataBrandPrismaNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.photo" relation. */
  upsert?: InputMaybe<MetadataBrandPrismaNestedUpsertPhotoCreateInput>;
};

export type MetadataBrandPrismaNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.photo" relation. */
  update?: InputMaybe<MetadataBrandPrismaNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataBrandPrisma" node, through the "MetadataBrandPrisma.photo" relation. */
  upsert?: InputMaybe<MetadataBrandPrismaNestedUpsertPhotoUpdateInput>;
};

export type MetadataBrandPrismaNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBrandPrismaNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataBrandPrismaOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataBrandPrismaUpdateInput = {
  /** Actions for the "MetadataBrandPrisma.archive" relation */
  archive?: InputMaybe<MetadataBrandPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBrandPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataBrandPrismaNestedMetadataUpdateInput>;
  /** Actions for the "MetadataBrandPrisma.photo" relation */
  photo?: InputMaybe<MetadataBrandPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataBrandPrisma" nodes by specifying some conditions */
export type MetadataBrandPrismaWhereInput = {
  AND?: InputMaybe<Array<MetadataBrandPrismaWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataBrandPrismaWhereInput>;
  OR?: InputMaybe<Array<MetadataBrandPrismaWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataBrandPrisma" node. */
export type MetadataBrandPrismaWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataBrandPrismaWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataBrandPrisma.metadata" relation */
  metadata: MetadataBrandPrismaNestedMetadataCreateInput;
  /** Actions for the "MetadataBrandPrisma.photo" relation */
  photo: MetadataBrandPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandPrismaWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataBrandPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataBrandPrismaNestedMetadataUpdateInput>;
  /** Actions for the "MetadataBrandPrisma.photo" relation */
  photo?: InputMaybe<MetadataBrandPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandPrismaWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataBrandPrisma.archive" relation */
  archive: MetadataBrandPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataBrandPrisma.photo" relation */
  photo: MetadataBrandPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandPrismaWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataBrandPrisma.archive" relation */
  archive?: InputMaybe<MetadataBrandPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBrandPrisma.photo" relation */
  photo?: InputMaybe<MetadataBrandPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandPrismaWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataBrandPrisma.archive" relation */
  archive: MetadataBrandPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataBrandPrisma.metadata" relation */
  metadata: MetadataBrandPrismaNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandPrismaWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataBrandPrisma.archive" relation */
  archive?: InputMaybe<MetadataBrandPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBrandPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataBrandPrismaNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataBrandShortName" resource's node */
export type MetadataBrandShortName = {
  __typename?: 'MetadataBrandShortName';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataBrandShortNameCreateInput = {
  /** Actions for the "MetadataBrandShortName.archive" relation */
  archive: MetadataBrandShortNameNestedArchiveCreateInput;
  /** Actions for the "MetadataBrandShortName.metadata" relation */
  metadata: MetadataBrandShortNameNestedMetadataCreateInput;
  /** Actions for the "MetadataBrandShortName.photo" relation */
  photo: MetadataBrandShortNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandShortNameNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.archive" relation. */
  update?: InputMaybe<MetadataBrandShortNameNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.archive" relation. */
  upsert?: InputMaybe<MetadataBrandShortNameNestedUpsertArchiveCreateInput>;
};

export type MetadataBrandShortNameNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.archive" relation. */
  update?: InputMaybe<MetadataBrandShortNameNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.archive" relation. */
  upsert?: InputMaybe<MetadataBrandShortNameNestedUpsertArchiveUpdateInput>;
};

export type MetadataBrandShortNameNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.metadata" relation. */
  update?: InputMaybe<MetadataBrandShortNameNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.metadata" relation. */
  upsert?: InputMaybe<MetadataBrandShortNameNestedUpsertMetadataCreateInput>;
};

export type MetadataBrandShortNameNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.metadata" relation. */
  update?: InputMaybe<MetadataBrandShortNameNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.metadata" relation. */
  upsert?: InputMaybe<MetadataBrandShortNameNestedUpsertMetadataUpdateInput>;
};

export type MetadataBrandShortNameNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.photo" relation. */
  update?: InputMaybe<MetadataBrandShortNameNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataBrandShortName" node, through the "MetadataBrandShortName.photo" relation. */
  upsert?: InputMaybe<MetadataBrandShortNameNestedUpsertPhotoCreateInput>;
};

export type MetadataBrandShortNameNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.photo" relation. */
  update?: InputMaybe<MetadataBrandShortNameNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataBrandShortName" node, through the "MetadataBrandShortName.photo" relation. */
  upsert?: InputMaybe<MetadataBrandShortNameNestedUpsertPhotoUpdateInput>;
};

export type MetadataBrandShortNameNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataBrandShortNameNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataBrandShortNameOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataBrandShortNameUpdateInput = {
  /** Actions for the "MetadataBrandShortName.archive" relation */
  archive?: InputMaybe<MetadataBrandShortNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBrandShortName.metadata" relation */
  metadata?: InputMaybe<MetadataBrandShortNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataBrandShortName.photo" relation */
  photo?: InputMaybe<MetadataBrandShortNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataBrandShortName" nodes by specifying some conditions */
export type MetadataBrandShortNameWhereInput = {
  AND?: InputMaybe<Array<MetadataBrandShortNameWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataBrandShortNameWhereInput>;
  OR?: InputMaybe<Array<MetadataBrandShortNameWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataBrandShortName" node. */
export type MetadataBrandShortNameWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataBrandShortNameWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataBrandShortName.metadata" relation */
  metadata: MetadataBrandShortNameNestedMetadataCreateInput;
  /** Actions for the "MetadataBrandShortName.photo" relation */
  photo: MetadataBrandShortNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandShortNameWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataBrandShortName.metadata" relation */
  metadata?: InputMaybe<MetadataBrandShortNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataBrandShortName.photo" relation */
  photo?: InputMaybe<MetadataBrandShortNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandShortNameWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataBrandShortName.archive" relation */
  archive: MetadataBrandShortNameNestedArchiveCreateInput;
  /** Actions for the "MetadataBrandShortName.photo" relation */
  photo: MetadataBrandShortNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandShortNameWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataBrandShortName.archive" relation */
  archive?: InputMaybe<MetadataBrandShortNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBrandShortName.photo" relation */
  photo?: InputMaybe<MetadataBrandShortNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandShortNameWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataBrandShortName.archive" relation */
  archive: MetadataBrandShortNameNestedArchiveCreateInput;
  /** Actions for the "MetadataBrandShortName.metadata" relation */
  metadata: MetadataBrandShortNameNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandShortNameWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataBrandShortName.archive" relation */
  archive?: InputMaybe<MetadataBrandShortNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBrandShortName.metadata" relation */
  metadata?: InputMaybe<MetadataBrandShortNameNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandUpdateInput = {
  /** Actions for the "MetadataBrand.archive" relation */
  archive?: InputMaybe<MetadataBrandNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBrand.metadata" relation */
  metadata?: InputMaybe<MetadataBrandNestedMetadataUpdateInput>;
  /** Actions for the "MetadataBrand.photo" relation */
  photo?: InputMaybe<MetadataBrandNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataBrand" nodes by specifying some conditions */
export type MetadataBrandWhereInput = {
  AND?: InputMaybe<Array<MetadataBrandWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataBrandWhereInput>;
  OR?: InputMaybe<Array<MetadataBrandWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataBrand" node. */
export type MetadataBrandWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataBrandWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataBrand.metadata" relation */
  metadata: MetadataBrandNestedMetadataCreateInput;
  /** Actions for the "MetadataBrand.photo" relation */
  photo: MetadataBrandNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataBrand.metadata" relation */
  metadata?: InputMaybe<MetadataBrandNestedMetadataUpdateInput>;
  /** Actions for the "MetadataBrand.photo" relation */
  photo?: InputMaybe<MetadataBrandNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataBrand.archive" relation */
  archive: MetadataBrandNestedArchiveCreateInput;
  /** Actions for the "MetadataBrand.photo" relation */
  photo: MetadataBrandNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataBrand.archive" relation */
  archive?: InputMaybe<MetadataBrandNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBrand.photo" relation */
  photo?: InputMaybe<MetadataBrandNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataBrand.archive" relation */
  archive: MetadataBrandNestedArchiveCreateInput;
  /** Actions for the "MetadataBrand.metadata" relation */
  metadata: MetadataBrandNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataBrandWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataBrand.archive" relation */
  archive?: InputMaybe<MetadataBrandNestedArchiveUpdateInput>;
  /** Actions for the "MetadataBrand.metadata" relation */
  metadata?: InputMaybe<MetadataBrandNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataByLine" resource's node */
export type MetadataByLine = {
  __typename?: 'MetadataByLine';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataByLineCreateInput = {
  /** Actions for the "MetadataByLine.archive" relation */
  archive: MetadataByLineNestedArchiveCreateInput;
  /** Actions for the "MetadataByLine.metadata" relation */
  metadata: MetadataByLineNestedMetadataCreateInput;
  /** Actions for the "MetadataByLine.photo" relation */
  photo: MetadataByLineNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataByLineNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataByLine" node, through the "MetadataByLine.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataByLine" node, through the "MetadataByLine.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataByLine" node, through the "MetadataByLine.archive" relation. */
  update?: InputMaybe<MetadataByLineNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataByLine" node, through the "MetadataByLine.archive" relation. */
  upsert?: InputMaybe<MetadataByLineNestedUpsertArchiveCreateInput>;
};

export type MetadataByLineNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataByLine" node, through the "MetadataByLine.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataByLine" node, through the "MetadataByLine.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataByLine" node, through the "MetadataByLine.archive" relation. */
  update?: InputMaybe<MetadataByLineNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataByLine" node, through the "MetadataByLine.archive" relation. */
  upsert?: InputMaybe<MetadataByLineNestedUpsertArchiveUpdateInput>;
};

export type MetadataByLineNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataByLine" node, through the "MetadataByLine.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataByLine" node, through the "MetadataByLine.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataByLine" node, through the "MetadataByLine.metadata" relation. */
  update?: InputMaybe<MetadataByLineNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataByLine" node, through the "MetadataByLine.metadata" relation. */
  upsert?: InputMaybe<MetadataByLineNestedUpsertMetadataCreateInput>;
};

export type MetadataByLineNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataByLine" node, through the "MetadataByLine.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataByLine" node, through the "MetadataByLine.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataByLine" node, through the "MetadataByLine.metadata" relation. */
  update?: InputMaybe<MetadataByLineNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataByLine" node, through the "MetadataByLine.metadata" relation. */
  upsert?: InputMaybe<MetadataByLineNestedUpsertMetadataUpdateInput>;
};

export type MetadataByLineNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataByLine" node, through the "MetadataByLine.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataByLine" node, through the "MetadataByLine.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataByLine" node, through the "MetadataByLine.photo" relation. */
  update?: InputMaybe<MetadataByLineNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataByLine" node, through the "MetadataByLine.photo" relation. */
  upsert?: InputMaybe<MetadataByLineNestedUpsertPhotoCreateInput>;
};

export type MetadataByLineNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataByLine" node, through the "MetadataByLine.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataByLine" node, through the "MetadataByLine.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataByLine" node, through the "MetadataByLine.photo" relation. */
  update?: InputMaybe<MetadataByLineNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataByLine" node, through the "MetadataByLine.photo" relation. */
  upsert?: InputMaybe<MetadataByLineNestedUpsertPhotoUpdateInput>;
};

export type MetadataByLineNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataByLineNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataByLineNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataByLineNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataByLineNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataByLineNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataByLineNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataByLineNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataByLineNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataByLineNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataByLineNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataByLineNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataByLineOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataByLineUpdateInput = {
  /** Actions for the "MetadataByLine.archive" relation */
  archive?: InputMaybe<MetadataByLineNestedArchiveUpdateInput>;
  /** Actions for the "MetadataByLine.metadata" relation */
  metadata?: InputMaybe<MetadataByLineNestedMetadataUpdateInput>;
  /** Actions for the "MetadataByLine.photo" relation */
  photo?: InputMaybe<MetadataByLineNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataByLine" nodes by specifying some conditions */
export type MetadataByLineWhereInput = {
  AND?: InputMaybe<Array<MetadataByLineWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataByLineWhereInput>;
  OR?: InputMaybe<Array<MetadataByLineWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataByLine" node. */
export type MetadataByLineWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataByLineWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataByLine.metadata" relation */
  metadata: MetadataByLineNestedMetadataCreateInput;
  /** Actions for the "MetadataByLine.photo" relation */
  photo: MetadataByLineNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataByLineWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataByLine.metadata" relation */
  metadata?: InputMaybe<MetadataByLineNestedMetadataUpdateInput>;
  /** Actions for the "MetadataByLine.photo" relation */
  photo?: InputMaybe<MetadataByLineNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataByLineWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataByLine.archive" relation */
  archive: MetadataByLineNestedArchiveCreateInput;
  /** Actions for the "MetadataByLine.photo" relation */
  photo: MetadataByLineNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataByLineWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataByLine.archive" relation */
  archive?: InputMaybe<MetadataByLineNestedArchiveUpdateInput>;
  /** Actions for the "MetadataByLine.photo" relation */
  photo?: InputMaybe<MetadataByLineNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataByLineWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataByLine.archive" relation */
  archive: MetadataByLineNestedArchiveCreateInput;
  /** Actions for the "MetadataByLine.metadata" relation */
  metadata: MetadataByLineNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataByLineWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataByLine.archive" relation */
  archive?: InputMaybe<MetadataByLineNestedArchiveUpdateInput>;
  /** Actions for the "MetadataByLine.metadata" relation */
  metadata?: InputMaybe<MetadataByLineNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCaption" resource's node */
export type MetadataCaption = {
  __typename?: 'MetadataCaption';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** "MetadataCaptionAbstract" resource's node */
export type MetadataCaptionAbstract = {
  __typename?: 'MetadataCaptionAbstract';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCaptionAbstractCreateInput = {
  /** Actions for the "MetadataCaptionAbstract.archive" relation */
  archive: MetadataCaptionAbstractNestedArchiveCreateInput;
  /** Actions for the "MetadataCaptionAbstract.metadata" relation */
  metadata: MetadataCaptionAbstractNestedMetadataCreateInput;
  /** Actions for the "MetadataCaptionAbstract.photo" relation */
  photo: MetadataCaptionAbstractNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionAbstractNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.archive" relation. */
  update?: InputMaybe<MetadataCaptionAbstractNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.archive" relation. */
  upsert?: InputMaybe<MetadataCaptionAbstractNestedUpsertArchiveCreateInput>;
};

export type MetadataCaptionAbstractNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.archive" relation. */
  update?: InputMaybe<MetadataCaptionAbstractNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.archive" relation. */
  upsert?: InputMaybe<MetadataCaptionAbstractNestedUpsertArchiveUpdateInput>;
};

export type MetadataCaptionAbstractNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.metadata" relation. */
  update?: InputMaybe<MetadataCaptionAbstractNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.metadata" relation. */
  upsert?: InputMaybe<MetadataCaptionAbstractNestedUpsertMetadataCreateInput>;
};

export type MetadataCaptionAbstractNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.metadata" relation. */
  update?: InputMaybe<MetadataCaptionAbstractNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.metadata" relation. */
  upsert?: InputMaybe<MetadataCaptionAbstractNestedUpsertMetadataUpdateInput>;
};

export type MetadataCaptionAbstractNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.photo" relation. */
  update?: InputMaybe<MetadataCaptionAbstractNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.photo" relation. */
  upsert?: InputMaybe<MetadataCaptionAbstractNestedUpsertPhotoCreateInput>;
};

export type MetadataCaptionAbstractNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.photo" relation. */
  update?: InputMaybe<MetadataCaptionAbstractNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCaptionAbstract" node, through the "MetadataCaptionAbstract.photo" relation. */
  upsert?: InputMaybe<MetadataCaptionAbstractNestedUpsertPhotoUpdateInput>;
};

export type MetadataCaptionAbstractNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCaptionAbstractNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCaptionAbstractOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCaptionAbstractUpdateInput = {
  /** Actions for the "MetadataCaptionAbstract.archive" relation */
  archive?: InputMaybe<MetadataCaptionAbstractNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCaptionAbstract.metadata" relation */
  metadata?: InputMaybe<MetadataCaptionAbstractNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCaptionAbstract.photo" relation */
  photo?: InputMaybe<MetadataCaptionAbstractNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCaptionAbstract" nodes by specifying some conditions */
export type MetadataCaptionAbstractWhereInput = {
  AND?: InputMaybe<Array<MetadataCaptionAbstractWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCaptionAbstractWhereInput>;
  OR?: InputMaybe<Array<MetadataCaptionAbstractWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCaptionAbstract" node. */
export type MetadataCaptionAbstractWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCaptionAbstractWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCaptionAbstract.metadata" relation */
  metadata: MetadataCaptionAbstractNestedMetadataCreateInput;
  /** Actions for the "MetadataCaptionAbstract.photo" relation */
  photo: MetadataCaptionAbstractNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionAbstractWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCaptionAbstract.metadata" relation */
  metadata?: InputMaybe<MetadataCaptionAbstractNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCaptionAbstract.photo" relation */
  photo?: InputMaybe<MetadataCaptionAbstractNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionAbstractWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCaptionAbstract.archive" relation */
  archive: MetadataCaptionAbstractNestedArchiveCreateInput;
  /** Actions for the "MetadataCaptionAbstract.photo" relation */
  photo: MetadataCaptionAbstractNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionAbstractWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCaptionAbstract.archive" relation */
  archive?: InputMaybe<MetadataCaptionAbstractNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCaptionAbstract.photo" relation */
  photo?: InputMaybe<MetadataCaptionAbstractNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionAbstractWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCaptionAbstract.archive" relation */
  archive: MetadataCaptionAbstractNestedArchiveCreateInput;
  /** Actions for the "MetadataCaptionAbstract.metadata" relation */
  metadata: MetadataCaptionAbstractNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionAbstractWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCaptionAbstract.archive" relation */
  archive?: InputMaybe<MetadataCaptionAbstractNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCaptionAbstract.metadata" relation */
  metadata?: InputMaybe<MetadataCaptionAbstractNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionCreateInput = {
  /** Actions for the "MetadataCaption.archive" relation */
  archive: MetadataCaptionNestedArchiveCreateInput;
  /** Actions for the "MetadataCaption.metadata" relation */
  metadata: MetadataCaptionNestedMetadataCreateInput;
  /** Actions for the "MetadataCaption.photo" relation */
  photo: MetadataCaptionNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCaption" node, through the "MetadataCaption.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCaption" node, through the "MetadataCaption.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCaption" node, through the "MetadataCaption.archive" relation. */
  update?: InputMaybe<MetadataCaptionNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCaption" node, through the "MetadataCaption.archive" relation. */
  upsert?: InputMaybe<MetadataCaptionNestedUpsertArchiveCreateInput>;
};

export type MetadataCaptionNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCaption" node, through the "MetadataCaption.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCaption" node, through the "MetadataCaption.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCaption" node, through the "MetadataCaption.archive" relation. */
  update?: InputMaybe<MetadataCaptionNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCaption" node, through the "MetadataCaption.archive" relation. */
  upsert?: InputMaybe<MetadataCaptionNestedUpsertArchiveUpdateInput>;
};

export type MetadataCaptionNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCaption" node, through the "MetadataCaption.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCaption" node, through the "MetadataCaption.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCaption" node, through the "MetadataCaption.metadata" relation. */
  update?: InputMaybe<MetadataCaptionNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCaption" node, through the "MetadataCaption.metadata" relation. */
  upsert?: InputMaybe<MetadataCaptionNestedUpsertMetadataCreateInput>;
};

export type MetadataCaptionNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCaption" node, through the "MetadataCaption.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCaption" node, through the "MetadataCaption.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCaption" node, through the "MetadataCaption.metadata" relation. */
  update?: InputMaybe<MetadataCaptionNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCaption" node, through the "MetadataCaption.metadata" relation. */
  upsert?: InputMaybe<MetadataCaptionNestedUpsertMetadataUpdateInput>;
};

export type MetadataCaptionNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCaption" node, through the "MetadataCaption.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCaption" node, through the "MetadataCaption.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCaption" node, through the "MetadataCaption.photo" relation. */
  update?: InputMaybe<MetadataCaptionNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCaption" node, through the "MetadataCaption.photo" relation. */
  upsert?: InputMaybe<MetadataCaptionNestedUpsertPhotoCreateInput>;
};

export type MetadataCaptionNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCaption" node, through the "MetadataCaption.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCaption" node, through the "MetadataCaption.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCaption" node, through the "MetadataCaption.photo" relation. */
  update?: InputMaybe<MetadataCaptionNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCaption" node, through the "MetadataCaption.photo" relation. */
  upsert?: InputMaybe<MetadataCaptionNestedUpsertPhotoUpdateInput>;
};

export type MetadataCaptionNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCaptionNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCaptionNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCaptionNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCaptionNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCaptionNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCaptionNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCaptionNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCaptionNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCaptionNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCaptionNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCaptionNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCaptionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCaptionUpdateInput = {
  /** Actions for the "MetadataCaption.archive" relation */
  archive?: InputMaybe<MetadataCaptionNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCaption.metadata" relation */
  metadata?: InputMaybe<MetadataCaptionNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCaption.photo" relation */
  photo?: InputMaybe<MetadataCaptionNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCaption" nodes by specifying some conditions */
export type MetadataCaptionWhereInput = {
  AND?: InputMaybe<Array<MetadataCaptionWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCaptionWhereInput>;
  OR?: InputMaybe<Array<MetadataCaptionWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCaption" node. */
export type MetadataCaptionWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCaptionWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCaption.metadata" relation */
  metadata: MetadataCaptionNestedMetadataCreateInput;
  /** Actions for the "MetadataCaption.photo" relation */
  photo: MetadataCaptionNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCaption.metadata" relation */
  metadata?: InputMaybe<MetadataCaptionNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCaption.photo" relation */
  photo?: InputMaybe<MetadataCaptionNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCaption.archive" relation */
  archive: MetadataCaptionNestedArchiveCreateInput;
  /** Actions for the "MetadataCaption.photo" relation */
  photo: MetadataCaptionNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCaption.archive" relation */
  archive?: InputMaybe<MetadataCaptionNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCaption.photo" relation */
  photo?: InputMaybe<MetadataCaptionNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCaption.archive" relation */
  archive: MetadataCaptionNestedArchiveCreateInput;
  /** Actions for the "MetadataCaption.metadata" relation */
  metadata: MetadataCaptionNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCaptionWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCaption.archive" relation */
  archive?: InputMaybe<MetadataCaptionNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCaption.metadata" relation */
  metadata?: InputMaybe<MetadataCaptionNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCategory" resource's node */
export type MetadataCategory = {
  __typename?: 'MetadataCategory';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCategoryCreateInput = {
  /** Actions for the "MetadataCategory.archive" relation */
  archive: MetadataCategoryNestedArchiveCreateInput;
  /** Actions for the "MetadataCategory.metadata" relation */
  metadata: MetadataCategoryNestedMetadataCreateInput;
  /** Actions for the "MetadataCategory.photo" relation */
  photo: MetadataCategoryNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCategory" node, through the "MetadataCategory.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCategory" node, through the "MetadataCategory.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCategory" node, through the "MetadataCategory.archive" relation. */
  update?: InputMaybe<MetadataCategoryNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCategory" node, through the "MetadataCategory.archive" relation. */
  upsert?: InputMaybe<MetadataCategoryNestedUpsertArchiveCreateInput>;
};

export type MetadataCategoryNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCategory" node, through the "MetadataCategory.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCategory" node, through the "MetadataCategory.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCategory" node, through the "MetadataCategory.archive" relation. */
  update?: InputMaybe<MetadataCategoryNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCategory" node, through the "MetadataCategory.archive" relation. */
  upsert?: InputMaybe<MetadataCategoryNestedUpsertArchiveUpdateInput>;
};

export type MetadataCategoryNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCategory" node, through the "MetadataCategory.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCategory" node, through the "MetadataCategory.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCategory" node, through the "MetadataCategory.metadata" relation. */
  update?: InputMaybe<MetadataCategoryNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCategory" node, through the "MetadataCategory.metadata" relation. */
  upsert?: InputMaybe<MetadataCategoryNestedUpsertMetadataCreateInput>;
};

export type MetadataCategoryNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCategory" node, through the "MetadataCategory.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCategory" node, through the "MetadataCategory.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCategory" node, through the "MetadataCategory.metadata" relation. */
  update?: InputMaybe<MetadataCategoryNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCategory" node, through the "MetadataCategory.metadata" relation. */
  upsert?: InputMaybe<MetadataCategoryNestedUpsertMetadataUpdateInput>;
};

export type MetadataCategoryNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCategory" node, through the "MetadataCategory.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCategory" node, through the "MetadataCategory.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCategory" node, through the "MetadataCategory.photo" relation. */
  update?: InputMaybe<MetadataCategoryNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCategory" node, through the "MetadataCategory.photo" relation. */
  upsert?: InputMaybe<MetadataCategoryNestedUpsertPhotoCreateInput>;
};

export type MetadataCategoryNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCategory" node, through the "MetadataCategory.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCategory" node, through the "MetadataCategory.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCategory" node, through the "MetadataCategory.photo" relation. */
  update?: InputMaybe<MetadataCategoryNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCategory" node, through the "MetadataCategory.photo" relation. */
  upsert?: InputMaybe<MetadataCategoryNestedUpsertPhotoUpdateInput>;
};

export type MetadataCategoryNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCategoryNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCategoryNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCategoryNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCategoryNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCategoryNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCategoryNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCategoryNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCategoryNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCategoryNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCategoryNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCategoryNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCategoryOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

/** "MetadataCategoryPrisma" resource's node */
export type MetadataCategoryPrisma = {
  __typename?: 'MetadataCategoryPrisma';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCategoryPrismaCreateInput = {
  /** Actions for the "MetadataCategoryPrisma.archive" relation */
  archive: MetadataCategoryPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataCategoryPrisma.metadata" relation */
  metadata: MetadataCategoryPrismaNestedMetadataCreateInput;
  /** Actions for the "MetadataCategoryPrisma.photo" relation */
  photo: MetadataCategoryPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryPrismaNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.archive" relation. */
  update?: InputMaybe<MetadataCategoryPrismaNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.archive" relation. */
  upsert?: InputMaybe<MetadataCategoryPrismaNestedUpsertArchiveCreateInput>;
};

export type MetadataCategoryPrismaNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.archive" relation. */
  update?: InputMaybe<MetadataCategoryPrismaNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.archive" relation. */
  upsert?: InputMaybe<MetadataCategoryPrismaNestedUpsertArchiveUpdateInput>;
};

export type MetadataCategoryPrismaNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.metadata" relation. */
  update?: InputMaybe<MetadataCategoryPrismaNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.metadata" relation. */
  upsert?: InputMaybe<MetadataCategoryPrismaNestedUpsertMetadataCreateInput>;
};

export type MetadataCategoryPrismaNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.metadata" relation. */
  update?: InputMaybe<MetadataCategoryPrismaNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.metadata" relation. */
  upsert?: InputMaybe<MetadataCategoryPrismaNestedUpsertMetadataUpdateInput>;
};

export type MetadataCategoryPrismaNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.photo" relation. */
  update?: InputMaybe<MetadataCategoryPrismaNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.photo" relation. */
  upsert?: InputMaybe<MetadataCategoryPrismaNestedUpsertPhotoCreateInput>;
};

export type MetadataCategoryPrismaNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.photo" relation. */
  update?: InputMaybe<MetadataCategoryPrismaNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCategoryPrisma" node, through the "MetadataCategoryPrisma.photo" relation. */
  upsert?: InputMaybe<MetadataCategoryPrismaNestedUpsertPhotoUpdateInput>;
};

export type MetadataCategoryPrismaNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCategoryPrismaNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCategoryPrismaOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCategoryPrismaUpdateInput = {
  /** Actions for the "MetadataCategoryPrisma.archive" relation */
  archive?: InputMaybe<MetadataCategoryPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCategoryPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataCategoryPrismaNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCategoryPrisma.photo" relation */
  photo?: InputMaybe<MetadataCategoryPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCategoryPrisma" nodes by specifying some conditions */
export type MetadataCategoryPrismaWhereInput = {
  AND?: InputMaybe<Array<MetadataCategoryPrismaWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCategoryPrismaWhereInput>;
  OR?: InputMaybe<Array<MetadataCategoryPrismaWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCategoryPrisma" node. */
export type MetadataCategoryPrismaWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCategoryPrismaWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCategoryPrisma.metadata" relation */
  metadata: MetadataCategoryPrismaNestedMetadataCreateInput;
  /** Actions for the "MetadataCategoryPrisma.photo" relation */
  photo: MetadataCategoryPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryPrismaWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCategoryPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataCategoryPrismaNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCategoryPrisma.photo" relation */
  photo?: InputMaybe<MetadataCategoryPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryPrismaWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCategoryPrisma.archive" relation */
  archive: MetadataCategoryPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataCategoryPrisma.photo" relation */
  photo: MetadataCategoryPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryPrismaWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCategoryPrisma.archive" relation */
  archive?: InputMaybe<MetadataCategoryPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCategoryPrisma.photo" relation */
  photo?: InputMaybe<MetadataCategoryPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryPrismaWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCategoryPrisma.archive" relation */
  archive: MetadataCategoryPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataCategoryPrisma.metadata" relation */
  metadata: MetadataCategoryPrismaNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryPrismaWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCategoryPrisma.archive" relation */
  archive?: InputMaybe<MetadataCategoryPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCategoryPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataCategoryPrismaNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryUpdateInput = {
  /** Actions for the "MetadataCategory.archive" relation */
  archive?: InputMaybe<MetadataCategoryNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCategory.metadata" relation */
  metadata?: InputMaybe<MetadataCategoryNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCategory.photo" relation */
  photo?: InputMaybe<MetadataCategoryNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCategory" nodes by specifying some conditions */
export type MetadataCategoryWhereInput = {
  AND?: InputMaybe<Array<MetadataCategoryWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCategoryWhereInput>;
  OR?: InputMaybe<Array<MetadataCategoryWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCategory" node. */
export type MetadataCategoryWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCategoryWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCategory.metadata" relation */
  metadata: MetadataCategoryNestedMetadataCreateInput;
  /** Actions for the "MetadataCategory.photo" relation */
  photo: MetadataCategoryNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCategory.metadata" relation */
  metadata?: InputMaybe<MetadataCategoryNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCategory.photo" relation */
  photo?: InputMaybe<MetadataCategoryNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCategory.archive" relation */
  archive: MetadataCategoryNestedArchiveCreateInput;
  /** Actions for the "MetadataCategory.photo" relation */
  photo: MetadataCategoryNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCategory.archive" relation */
  archive?: InputMaybe<MetadataCategoryNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCategory.photo" relation */
  photo?: InputMaybe<MetadataCategoryNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCategory.archive" relation */
  archive: MetadataCategoryNestedArchiveCreateInput;
  /** Actions for the "MetadataCategory.metadata" relation */
  metadata: MetadataCategoryNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCategoryWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCategory.archive" relation */
  archive?: InputMaybe<MetadataCategoryNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCategory.metadata" relation */
  metadata?: InputMaybe<MetadataCategoryNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCompany" resource's node */
export type MetadataCompany = {
  __typename?: 'MetadataCompany';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCompanyCreateInput = {
  /** Actions for the "MetadataCompany.archive" relation */
  archive: MetadataCompanyNestedArchiveCreateInput;
  /** Actions for the "MetadataCompany.metadata" relation */
  metadata: MetadataCompanyNestedMetadataCreateInput;
  /** Actions for the "MetadataCompany.photo" relation */
  photo: MetadataCompanyNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCompany" node, through the "MetadataCompany.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCompany" node, through the "MetadataCompany.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCompany" node, through the "MetadataCompany.archive" relation. */
  update?: InputMaybe<MetadataCompanyNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCompany" node, through the "MetadataCompany.archive" relation. */
  upsert?: InputMaybe<MetadataCompanyNestedUpsertArchiveCreateInput>;
};

export type MetadataCompanyNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCompany" node, through the "MetadataCompany.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCompany" node, through the "MetadataCompany.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCompany" node, through the "MetadataCompany.archive" relation. */
  update?: InputMaybe<MetadataCompanyNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCompany" node, through the "MetadataCompany.archive" relation. */
  upsert?: InputMaybe<MetadataCompanyNestedUpsertArchiveUpdateInput>;
};

export type MetadataCompanyNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCompany" node, through the "MetadataCompany.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCompany" node, through the "MetadataCompany.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCompany" node, through the "MetadataCompany.metadata" relation. */
  update?: InputMaybe<MetadataCompanyNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCompany" node, through the "MetadataCompany.metadata" relation. */
  upsert?: InputMaybe<MetadataCompanyNestedUpsertMetadataCreateInput>;
};

export type MetadataCompanyNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCompany" node, through the "MetadataCompany.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCompany" node, through the "MetadataCompany.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCompany" node, through the "MetadataCompany.metadata" relation. */
  update?: InputMaybe<MetadataCompanyNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCompany" node, through the "MetadataCompany.metadata" relation. */
  upsert?: InputMaybe<MetadataCompanyNestedUpsertMetadataUpdateInput>;
};

export type MetadataCompanyNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCompany" node, through the "MetadataCompany.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCompany" node, through the "MetadataCompany.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCompany" node, through the "MetadataCompany.photo" relation. */
  update?: InputMaybe<MetadataCompanyNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCompany" node, through the "MetadataCompany.photo" relation. */
  upsert?: InputMaybe<MetadataCompanyNestedUpsertPhotoCreateInput>;
};

export type MetadataCompanyNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCompany" node, through the "MetadataCompany.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCompany" node, through the "MetadataCompany.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCompany" node, through the "MetadataCompany.photo" relation. */
  update?: InputMaybe<MetadataCompanyNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCompany" node, through the "MetadataCompany.photo" relation. */
  upsert?: InputMaybe<MetadataCompanyNestedUpsertPhotoUpdateInput>;
};

export type MetadataCompanyNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCompanyNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCompanyNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCompanyNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCompanyNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCompanyNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCompanyNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCompanyNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCompanyNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCompanyNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCompanyNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCompanyNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCompanyOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

/** "MetadataCompanyShortName" resource's node */
export type MetadataCompanyShortName = {
  __typename?: 'MetadataCompanyShortName';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCompanyShortNameCreateInput = {
  /** Actions for the "MetadataCompanyShortName.archive" relation */
  archive: MetadataCompanyShortNameNestedArchiveCreateInput;
  /** Actions for the "MetadataCompanyShortName.metadata" relation */
  metadata: MetadataCompanyShortNameNestedMetadataCreateInput;
  /** Actions for the "MetadataCompanyShortName.photo" relation */
  photo: MetadataCompanyShortNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyShortNameNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.archive" relation. */
  update?: InputMaybe<MetadataCompanyShortNameNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.archive" relation. */
  upsert?: InputMaybe<MetadataCompanyShortNameNestedUpsertArchiveCreateInput>;
};

export type MetadataCompanyShortNameNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.archive" relation. */
  update?: InputMaybe<MetadataCompanyShortNameNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.archive" relation. */
  upsert?: InputMaybe<MetadataCompanyShortNameNestedUpsertArchiveUpdateInput>;
};

export type MetadataCompanyShortNameNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.metadata" relation. */
  update?: InputMaybe<MetadataCompanyShortNameNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.metadata" relation. */
  upsert?: InputMaybe<MetadataCompanyShortNameNestedUpsertMetadataCreateInput>;
};

export type MetadataCompanyShortNameNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.metadata" relation. */
  update?: InputMaybe<MetadataCompanyShortNameNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.metadata" relation. */
  upsert?: InputMaybe<MetadataCompanyShortNameNestedUpsertMetadataUpdateInput>;
};

export type MetadataCompanyShortNameNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.photo" relation. */
  update?: InputMaybe<MetadataCompanyShortNameNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.photo" relation. */
  upsert?: InputMaybe<MetadataCompanyShortNameNestedUpsertPhotoCreateInput>;
};

export type MetadataCompanyShortNameNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.photo" relation. */
  update?: InputMaybe<MetadataCompanyShortNameNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCompanyShortName" node, through the "MetadataCompanyShortName.photo" relation. */
  upsert?: InputMaybe<MetadataCompanyShortNameNestedUpsertPhotoUpdateInput>;
};

export type MetadataCompanyShortNameNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCompanyShortNameNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCompanyShortNameOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCompanyShortNameUpdateInput = {
  /** Actions for the "MetadataCompanyShortName.archive" relation */
  archive?: InputMaybe<MetadataCompanyShortNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCompanyShortName.metadata" relation */
  metadata?: InputMaybe<MetadataCompanyShortNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCompanyShortName.photo" relation */
  photo?: InputMaybe<MetadataCompanyShortNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCompanyShortName" nodes by specifying some conditions */
export type MetadataCompanyShortNameWhereInput = {
  AND?: InputMaybe<Array<MetadataCompanyShortNameWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCompanyShortNameWhereInput>;
  OR?: InputMaybe<Array<MetadataCompanyShortNameWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCompanyShortName" node. */
export type MetadataCompanyShortNameWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCompanyShortNameWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCompanyShortName.metadata" relation */
  metadata: MetadataCompanyShortNameNestedMetadataCreateInput;
  /** Actions for the "MetadataCompanyShortName.photo" relation */
  photo: MetadataCompanyShortNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyShortNameWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCompanyShortName.metadata" relation */
  metadata?: InputMaybe<MetadataCompanyShortNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCompanyShortName.photo" relation */
  photo?: InputMaybe<MetadataCompanyShortNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyShortNameWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCompanyShortName.archive" relation */
  archive: MetadataCompanyShortNameNestedArchiveCreateInput;
  /** Actions for the "MetadataCompanyShortName.photo" relation */
  photo: MetadataCompanyShortNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyShortNameWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCompanyShortName.archive" relation */
  archive?: InputMaybe<MetadataCompanyShortNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCompanyShortName.photo" relation */
  photo?: InputMaybe<MetadataCompanyShortNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyShortNameWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCompanyShortName.archive" relation */
  archive: MetadataCompanyShortNameNestedArchiveCreateInput;
  /** Actions for the "MetadataCompanyShortName.metadata" relation */
  metadata: MetadataCompanyShortNameNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyShortNameWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCompanyShortName.archive" relation */
  archive?: InputMaybe<MetadataCompanyShortNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCompanyShortName.metadata" relation */
  metadata?: InputMaybe<MetadataCompanyShortNameNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyUpdateInput = {
  /** Actions for the "MetadataCompany.archive" relation */
  archive?: InputMaybe<MetadataCompanyNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCompany.metadata" relation */
  metadata?: InputMaybe<MetadataCompanyNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCompany.photo" relation */
  photo?: InputMaybe<MetadataCompanyNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCompany" nodes by specifying some conditions */
export type MetadataCompanyWhereInput = {
  AND?: InputMaybe<Array<MetadataCompanyWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCompanyWhereInput>;
  OR?: InputMaybe<Array<MetadataCompanyWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCompany" node. */
export type MetadataCompanyWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCompanyWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCompany.metadata" relation */
  metadata: MetadataCompanyNestedMetadataCreateInput;
  /** Actions for the "MetadataCompany.photo" relation */
  photo: MetadataCompanyNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCompany.metadata" relation */
  metadata?: InputMaybe<MetadataCompanyNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCompany.photo" relation */
  photo?: InputMaybe<MetadataCompanyNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCompany.archive" relation */
  archive: MetadataCompanyNestedArchiveCreateInput;
  /** Actions for the "MetadataCompany.photo" relation */
  photo: MetadataCompanyNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCompany.archive" relation */
  archive?: InputMaybe<MetadataCompanyNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCompany.photo" relation */
  photo?: InputMaybe<MetadataCompanyNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCompany.archive" relation */
  archive: MetadataCompanyNestedArchiveCreateInput;
  /** Actions for the "MetadataCompany.metadata" relation */
  metadata: MetadataCompanyNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCompanyWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCompany.archive" relation */
  archive?: InputMaybe<MetadataCompanyNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCompany.metadata" relation */
  metadata?: InputMaybe<MetadataCompanyNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCopyrightNotice" resource's node */
export type MetadataCopyrightNotice = {
  __typename?: 'MetadataCopyrightNotice';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCopyrightNoticeCreateInput = {
  /** Actions for the "MetadataCopyrightNotice.archive" relation */
  archive: MetadataCopyrightNoticeNestedArchiveCreateInput;
  /** Actions for the "MetadataCopyrightNotice.metadata" relation */
  metadata: MetadataCopyrightNoticeNestedMetadataCreateInput;
  /** Actions for the "MetadataCopyrightNotice.photo" relation */
  photo: MetadataCopyrightNoticeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCopyrightNoticeNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.archive" relation. */
  update?: InputMaybe<MetadataCopyrightNoticeNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.archive" relation. */
  upsert?: InputMaybe<MetadataCopyrightNoticeNestedUpsertArchiveCreateInput>;
};

export type MetadataCopyrightNoticeNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.archive" relation. */
  update?: InputMaybe<MetadataCopyrightNoticeNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.archive" relation. */
  upsert?: InputMaybe<MetadataCopyrightNoticeNestedUpsertArchiveUpdateInput>;
};

export type MetadataCopyrightNoticeNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.metadata" relation. */
  update?: InputMaybe<MetadataCopyrightNoticeNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.metadata" relation. */
  upsert?: InputMaybe<MetadataCopyrightNoticeNestedUpsertMetadataCreateInput>;
};

export type MetadataCopyrightNoticeNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.metadata" relation. */
  update?: InputMaybe<MetadataCopyrightNoticeNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.metadata" relation. */
  upsert?: InputMaybe<MetadataCopyrightNoticeNestedUpsertMetadataUpdateInput>;
};

export type MetadataCopyrightNoticeNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.photo" relation. */
  update?: InputMaybe<MetadataCopyrightNoticeNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.photo" relation. */
  upsert?: InputMaybe<MetadataCopyrightNoticeNestedUpsertPhotoCreateInput>;
};

export type MetadataCopyrightNoticeNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.photo" relation. */
  update?: InputMaybe<MetadataCopyrightNoticeNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCopyrightNotice" node, through the "MetadataCopyrightNotice.photo" relation. */
  upsert?: InputMaybe<MetadataCopyrightNoticeNestedUpsertPhotoUpdateInput>;
};

export type MetadataCopyrightNoticeNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCopyrightNoticeNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCopyrightNoticeOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCopyrightNoticeUpdateInput = {
  /** Actions for the "MetadataCopyrightNotice.archive" relation */
  archive?: InputMaybe<MetadataCopyrightNoticeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCopyrightNotice.metadata" relation */
  metadata?: InputMaybe<MetadataCopyrightNoticeNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCopyrightNotice.photo" relation */
  photo?: InputMaybe<MetadataCopyrightNoticeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCopyrightNotice" nodes by specifying some conditions */
export type MetadataCopyrightNoticeWhereInput = {
  AND?: InputMaybe<Array<MetadataCopyrightNoticeWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
  OR?: InputMaybe<Array<MetadataCopyrightNoticeWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCopyrightNotice" node. */
export type MetadataCopyrightNoticeWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCopyrightNoticeWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCopyrightNotice.metadata" relation */
  metadata: MetadataCopyrightNoticeNestedMetadataCreateInput;
  /** Actions for the "MetadataCopyrightNotice.photo" relation */
  photo: MetadataCopyrightNoticeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCopyrightNoticeWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCopyrightNotice.metadata" relation */
  metadata?: InputMaybe<MetadataCopyrightNoticeNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCopyrightNotice.photo" relation */
  photo?: InputMaybe<MetadataCopyrightNoticeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCopyrightNoticeWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCopyrightNotice.archive" relation */
  archive: MetadataCopyrightNoticeNestedArchiveCreateInput;
  /** Actions for the "MetadataCopyrightNotice.photo" relation */
  photo: MetadataCopyrightNoticeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCopyrightNoticeWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCopyrightNotice.archive" relation */
  archive?: InputMaybe<MetadataCopyrightNoticeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCopyrightNotice.photo" relation */
  photo?: InputMaybe<MetadataCopyrightNoticeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCopyrightNoticeWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCopyrightNotice.archive" relation */
  archive: MetadataCopyrightNoticeNestedArchiveCreateInput;
  /** Actions for the "MetadataCopyrightNotice.metadata" relation */
  metadata: MetadataCopyrightNoticeNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCopyrightNoticeWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCopyrightNotice.archive" relation */
  archive?: InputMaybe<MetadataCopyrightNoticeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCopyrightNotice.metadata" relation */
  metadata?: InputMaybe<MetadataCopyrightNoticeNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
  legacyName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Metadata.metadataAccessRightsList" relation: "MetadataAccessRights.metadata"'s inverse relation */
  metadataAccessRightsList?: InputMaybe<MetadataNestedMetadataAccessRightsListCreateInput>;
  /** Actions for the "Metadata.metadataAssetStateList" relation: "MetadataAssetState.metadata"'s inverse relation */
  metadataAssetStateList?: InputMaybe<MetadataNestedMetadataAssetStateListCreateInput>;
  /** Actions for the "Metadata.metadataBackupNameList" relation: "MetadataBackupName.metadata"'s inverse relation */
  metadataBackupNameList?: InputMaybe<MetadataNestedMetadataBackupNameListCreateInput>;
  /** Actions for the "Metadata.metadataBrandList" relation: "MetadataBrand.metadata"'s inverse relation */
  metadataBrandList?: InputMaybe<MetadataNestedMetadataBrandListCreateInput>;
  /** Actions for the "Metadata.metadataBrandPrismaList" relation: "MetadataBrandPrisma.metadata"'s inverse relation */
  metadataBrandPrismaList?: InputMaybe<MetadataNestedMetadataBrandPrismaListCreateInput>;
  /** Actions for the "Metadata.metadataBrandShortNameList" relation: "MetadataBrandShortName.metadata"'s inverse relation */
  metadataBrandShortNameList?: InputMaybe<MetadataNestedMetadataBrandShortNameListCreateInput>;
  /** Actions for the "Metadata.metadataByLineList" relation: "MetadataByLine.metadata"'s inverse relation */
  metadataByLineList?: InputMaybe<MetadataNestedMetadataByLineListCreateInput>;
  /** Actions for the "Metadata.metadataCaptionAbstractList" relation: "MetadataCaptionAbstract.metadata"'s inverse relation */
  metadataCaptionAbstractList?: InputMaybe<MetadataNestedMetadataCaptionAbstractListCreateInput>;
  /** Actions for the "Metadata.metadataCaptionList" relation: "MetadataCaption.metadata"'s inverse relation */
  metadataCaptionList?: InputMaybe<MetadataNestedMetadataCaptionListCreateInput>;
  /** Actions for the "Metadata.metadataCategoryList" relation: "MetadataCategory.metadata"'s inverse relation */
  metadataCategoryList?: InputMaybe<MetadataNestedMetadataCategoryListCreateInput>;
  /** Actions for the "Metadata.metadataCategoryPrismaList" relation: "MetadataCategoryPrisma.metadata"'s inverse relation */
  metadataCategoryPrismaList?: InputMaybe<MetadataNestedMetadataCategoryPrismaListCreateInput>;
  /** Actions for the "Metadata.metadataCompanyList" relation: "MetadataCompany.metadata"'s inverse relation */
  metadataCompanyList?: InputMaybe<MetadataNestedMetadataCompanyListCreateInput>;
  /** Actions for the "Metadata.metadataCompanyShortNameList" relation: "MetadataCompanyShortName.metadata"'s inverse relation */
  metadataCompanyShortNameList?: InputMaybe<MetadataNestedMetadataCompanyShortNameListCreateInput>;
  /** Actions for the "Metadata.metadataCopyrightNoticeList" relation: "MetadataCopyrightNotice.metadata"'s inverse relation */
  metadataCopyrightNoticeList?: InputMaybe<MetadataNestedMetadataCopyrightNoticeListCreateInput>;
  /** Actions for the "Metadata.metadataCreatorList" relation: "MetadataCreator.metadata"'s inverse relation */
  metadataCreatorList?: InputMaybe<MetadataNestedMetadataCreatorListCreateInput>;
  /** Actions for the "Metadata.metadataCreditList" relation: "MetadataCredit.metadata"'s inverse relation */
  metadataCreditList?: InputMaybe<MetadataNestedMetadataCreditListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField14List" relation: "MetadataCustomField14.metadata"'s inverse relation */
  metadataCustomField14List?: InputMaybe<MetadataNestedMetadataCustomField14ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField15List" relation: "MetadataCustomField15.metadata"'s inverse relation */
  metadataCustomField15List?: InputMaybe<MetadataNestedMetadataCustomField15ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField16List" relation: "MetadataCustomField16.metadata"'s inverse relation */
  metadataCustomField16List?: InputMaybe<MetadataNestedMetadataCustomField16ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField17List" relation: "MetadataCustomField17.metadata"'s inverse relation */
  metadataCustomField17List?: InputMaybe<MetadataNestedMetadataCustomField17ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField1List" relation: "MetadataCustomField1.metadata"'s inverse relation */
  metadataCustomField1List?: InputMaybe<MetadataNestedMetadataCustomField1ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField20List" relation: "MetadataCustomField20.metadata"'s inverse relation */
  metadataCustomField20List?: InputMaybe<MetadataNestedMetadataCustomField20ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField3List" relation: "MetadataCustomField3.metadata"'s inverse relation */
  metadataCustomField3List?: InputMaybe<MetadataNestedMetadataCustomField3ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField4List" relation: "MetadataCustomField4.metadata"'s inverse relation */
  metadataCustomField4List?: InputMaybe<MetadataNestedMetadataCustomField4ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField5List" relation: "MetadataCustomField5.metadata"'s inverse relation */
  metadataCustomField5List?: InputMaybe<MetadataNestedMetadataCustomField5ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField6List" relation: "MetadataCustomField6.metadata"'s inverse relation */
  metadataCustomField6List?: InputMaybe<MetadataNestedMetadataCustomField6ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField7List" relation: "MetadataCustomField7.metadata"'s inverse relation */
  metadataCustomField7List?: InputMaybe<MetadataNestedMetadataCustomField7ListCreateInput>;
  /** Actions for the "Metadata.metadataCustomField9List" relation: "MetadataCustomField9.metadata"'s inverse relation */
  metadataCustomField9List?: InputMaybe<MetadataNestedMetadataCustomField9ListCreateInput>;
  /** Actions for the "Metadata.metadataDateCreatedList" relation: "MetadataDateCreated.metadata"'s inverse relation */
  metadataDateCreatedList?: InputMaybe<MetadataNestedMetadataDateCreatedListCreateInput>;
  /** Actions for the "Metadata.metadataDateTimeOriginalList" relation: "MetadataDateTimeOriginal.metadata"'s inverse relation */
  metadataDateTimeOriginalList?: InputMaybe<MetadataNestedMetadataDateTimeOriginalListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryAccountList" relation: "MetadataDeliveryAccount.metadata"'s inverse relation */
  metadataDeliveryAccountList?: InputMaybe<MetadataNestedMetadataDeliveryAccountListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryCompanyList" relation: "MetadataDeliveryCompany.metadata"'s inverse relation */
  metadataDeliveryCompanyList?: InputMaybe<MetadataNestedMetadataDeliveryCompanyListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryCopyrightList" relation: "MetadataDeliveryCopyright.metadata"'s inverse relation */
  metadataDeliveryCopyrightList?: InputMaybe<MetadataNestedMetadataDeliveryCopyrightListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryDateFolderList" relation: "MetadataDeliveryDateFolder.metadata"'s inverse relation */
  metadataDeliveryDateFolderList?: InputMaybe<MetadataNestedMetadataDeliveryDateFolderListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryDateTimeList" relation: "MetadataDeliveryDateTime.metadata"'s inverse relation */
  metadataDeliveryDateTimeList?: InputMaybe<MetadataNestedMetadataDeliveryDateTimeListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryDcCreatorList" relation: "MetadataDeliveryDcCreator.metadata"'s inverse relation */
  metadataDeliveryDcCreatorList?: InputMaybe<MetadataNestedMetadataDeliveryDcCreatorListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryDcRightsList" relation: "MetadataDeliveryDcRights.metadata"'s inverse relation */
  metadataDeliveryDcRightsList?: InputMaybe<MetadataNestedMetadataDeliveryDcRightsListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryFolderList" relation: "MetadataDeliveryFolder.metadata"'s inverse relation */
  metadataDeliveryFolderList?: InputMaybe<MetadataNestedMetadataDeliveryFolderListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryKindList" relation: "MetadataDeliveryKind.metadata"'s inverse relation */
  metadataDeliveryKindList?: InputMaybe<MetadataNestedMetadataDeliveryKindListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryPathList" relation: "MetadataDeliveryPath.metadata"'s inverse relation */
  metadataDeliveryPathList?: InputMaybe<MetadataNestedMetadataDeliveryPathListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryPhotoshopCreditList" relation: "MetadataDeliveryPhotoshopCredit.metadata"'s inverse relation */
  metadataDeliveryPhotoshopCreditList?: InputMaybe<MetadataNestedMetadataDeliveryPhotoshopCreditListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryPhotoshopSourceList" relation: "MetadataDeliveryPhotoshopSource.metadata"'s inverse relation */
  metadataDeliveryPhotoshopSourceList?: InputMaybe<MetadataNestedMetadataDeliveryPhotoshopSourceListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryServiceList" relation: "MetadataDeliveryService.metadata"'s inverse relation */
  metadataDeliveryServiceList?: InputMaybe<MetadataNestedMetadataDeliveryServiceListCreateInput>;
  /** Actions for the "Metadata.metadataDeliverySubjectList" relation: "MetadataDeliverySubject.metadata"'s inverse relation */
  metadataDeliverySubjectList?: InputMaybe<MetadataNestedMetadataDeliverySubjectListCreateInput>;
  /** Actions for the "Metadata.metadataDeliveryUnderSubjectList" relation: "MetadataDeliveryUnderSubject.metadata"'s inverse relation */
  metadataDeliveryUnderSubjectList?: InputMaybe<MetadataNestedMetadataDeliveryUnderSubjectListCreateInput>;
  /** Actions for the "Metadata.metadataDepartmentList" relation: "MetadataDepartment.metadata"'s inverse relation */
  metadataDepartmentList?: InputMaybe<MetadataNestedMetadataDepartmentListCreateInput>;
  /** Actions for the "Metadata.metadataDescriptionList" relation: "MetadataDescription.metadata"'s inverse relation */
  metadataDescriptionList?: InputMaybe<MetadataNestedMetadataDescriptionListCreateInput>;
  /** Actions for the "Metadata.metadataEditionList" relation: "MetadataEdition.metadata"'s inverse relation */
  metadataEditionList?: InputMaybe<MetadataNestedMetadataEditionListCreateInput>;
  /** Actions for the "Metadata.metadataEditStatusList" relation: "MetadataEditStatus.metadata"'s inverse relation */
  metadataEditStatusList?: InputMaybe<MetadataNestedMetadataEditStatusListCreateInput>;
  /** Actions for the "Metadata.metadataFileStatusList" relation: "MetadataFileStatus.metadata"'s inverse relation */
  metadataFileStatusList?: InputMaybe<MetadataNestedMetadataFileStatusListCreateInput>;
  /** Actions for the "Metadata.metadataFormatList" relation: "MetadataFormat.metadata"'s inverse relation */
  metadataFormatList?: InputMaybe<MetadataNestedMetadataFormatListCreateInput>;
  /** Actions for the "Metadata.metadataHeaderList" relation: "MetadataHeader.metadata"'s inverse relation */
  metadataHeaderList?: InputMaybe<MetadataNestedMetadataHeaderListCreateInput>;
  /** Actions for the "Metadata.metadataHeaderPrismaList" relation: "MetadataHeaderPrisma.metadata"'s inverse relation */
  metadataHeaderPrismaList?: InputMaybe<MetadataNestedMetadataHeaderPrismaListCreateInput>;
  /** Actions for the "Metadata.metadataHeadlineList" relation: "MetadataHeadline.metadata"'s inverse relation */
  metadataHeadlineList?: InputMaybe<MetadataNestedMetadataHeadlineListCreateInput>;
  /** Actions for the "Metadata.metadataIdAssignmentList" relation: "MetadataIdAssignment.metadata"'s inverse relation */
  metadataIdAssignmentList?: InputMaybe<MetadataNestedMetadataIdAssignmentListCreateInput>;
  /** Actions for the "Metadata.metadataIdPhotoPrismaList" relation: "MetadataIdPhotoPrisma.metadata"'s inverse relation */
  metadataIdPhotoPrismaList?: InputMaybe<MetadataNestedMetadataIdPhotoPrismaListCreateInput>;
  /** Actions for the "Metadata.metadataIdSubjectList" relation: "MetadataIdSubject.metadata"'s inverse relation */
  metadataIdSubjectList?: InputMaybe<MetadataNestedMetadataIdSubjectListCreateInput>;
  /** Actions for the "Metadata.metadataImageNotesList" relation: "MetadataImageNotes.metadata"'s inverse relation */
  metadataImageNotesList?: InputMaybe<MetadataNestedMetadataImageNotesListCreateInput>;
  /** Actions for the "Metadata.metadataInstructionsList" relation: "MetadataInstructions.metadata"'s inverse relation */
  metadataInstructionsList?: InputMaybe<MetadataNestedMetadataInstructionsListCreateInput>;
  /** Actions for the "Metadata.metadataIssueList" relation: "MetadataIssue.metadata"'s inverse relation */
  metadataIssueList?: InputMaybe<MetadataNestedMetadataIssueListCreateInput>;
  /** Actions for the "Metadata.metadataKeywordsList" relation: "MetadataKeywords.metadata"'s inverse relation */
  metadataKeywordsList?: InputMaybe<MetadataNestedMetadataKeywordsListCreateInput>;
  /** Actions for the "Metadata.metadataObjectNameList" relation: "MetadataObjectName.metadata"'s inverse relation */
  metadataObjectNameList?: InputMaybe<MetadataNestedMetadataObjectNameListCreateInput>;
  /** Actions for the "Metadata.metadataOriginalNameList" relation: "MetadataOriginalName.metadata"'s inverse relation */
  metadataOriginalNameList?: InputMaybe<MetadataNestedMetadataOriginalNameListCreateInput>;
  /** Actions for the "Metadata.metadataPriceLevelList" relation: "MetadataPriceLevel.metadata"'s inverse relation */
  metadataPriceLevelList?: InputMaybe<MetadataNestedMetadataPriceLevelListCreateInput>;
  /** Actions for the "Metadata.metadataProcessHistoryList" relation: "MetadataProcessHistory.metadata"'s inverse relation */
  metadataProcessHistoryList?: InputMaybe<MetadataNestedMetadataProcessHistoryListCreateInput>;
  /** Actions for the "Metadata.metadataProcessStatusList" relation: "MetadataProcessStatus.metadata"'s inverse relation */
  metadataProcessStatusList?: InputMaybe<MetadataNestedMetadataProcessStatusListCreateInput>;
  /** Actions for the "Metadata.metadataProductList" relation: "MetadataProduct.metadata"'s inverse relation */
  metadataProductList?: InputMaybe<MetadataNestedMetadataProductListCreateInput>;
  /** Actions for the "Metadata.metadataProductsList" relation: "MetadataProducts.metadata"'s inverse relation */
  metadataProductsList?: InputMaybe<MetadataNestedMetadataProductsListCreateInput>;
  /** Actions for the "Metadata.metadataPublishingSubjectList" relation: "MetadataPublishingSubject.metadata"'s inverse relation */
  metadataPublishingSubjectList?: InputMaybe<MetadataNestedMetadataPublishingSubjectListCreateInput>;
  /** Actions for the "Metadata.metadataResolutionKindList" relation: "MetadataResolutionKind.metadata"'s inverse relation */
  metadataResolutionKindList?: InputMaybe<MetadataNestedMetadataResolutionKindListCreateInput>;
  /** Actions for the "Metadata.metadataRightsList" relation: "MetadataRights.metadata"'s inverse relation */
  metadataRightsList?: InputMaybe<MetadataNestedMetadataRightsListCreateInput>;
  /** Actions for the "Metadata.metadataSourceList" relation: "MetadataSource.metadata"'s inverse relation */
  metadataSourceList?: InputMaybe<MetadataNestedMetadataSourceListCreateInput>;
  /** Actions for the "Metadata.metadataSpecialInstructionsList" relation: "MetadataSpecialInstructions.metadata"'s inverse relation */
  metadataSpecialInstructionsList?: InputMaybe<MetadataNestedMetadataSpecialInstructionsListCreateInput>;
  /** Actions for the "Metadata.metadataSubjectCodeList" relation: "MetadataSubjectCode.metadata"'s inverse relation */
  metadataSubjectCodeList?: InputMaybe<MetadataNestedMetadataSubjectCodeListCreateInput>;
  /** Actions for the "Metadata.metadataSubjectList" relation: "MetadataSubject.metadata"'s inverse relation */
  metadataSubjectList?: InputMaybe<MetadataNestedMetadataSubjectListCreateInput>;
  /** Actions for the "Metadata.metadataSubjectPrismaList" relation: "MetadataSubjectPrisma.metadata"'s inverse relation */
  metadataSubjectPrismaList?: InputMaybe<MetadataNestedMetadataSubjectPrismaListCreateInput>;
  /** Actions for the "Metadata.metadataTitleList" relation: "MetadataTitle.metadata"'s inverse relation */
  metadataTitleList?: InputMaybe<MetadataNestedMetadataTitleListCreateInput>;
  /** Actions for the "Metadata.metadataTransferredByFullNameList" relation: "MetadataTransferredByFullName.metadata"'s inverse relation */
  metadataTransferredByFullNameList?: InputMaybe<MetadataNestedMetadataTransferredByFullNameListCreateInput>;
  /** Actions for the "Metadata.metadataTransferredByList" relation: "MetadataTransferredBy.metadata"'s inverse relation */
  metadataTransferredByList?: InputMaybe<MetadataNestedMetadataTransferredByListCreateInput>;
  /** Actions for the "Metadata.metadataTypeList" relation: "MetadataType.metadata"'s inverse relation */
  metadataTypeList?: InputMaybe<MetadataNestedMetadataTypeListCreateInput>;
  /** Actions for the "Metadata.metadataUndersubjectList" relation: "MetadataUndersubject.metadata"'s inverse relation */
  metadataUndersubjectList?: InputMaybe<MetadataNestedMetadataUndersubjectListCreateInput>;
  /** Actions for the "Metadata.metadataUnderUnderSubjectList" relation: "MetadataUnderUnderSubject.metadata"'s inverse relation */
  metadataUnderUnderSubjectList?: InputMaybe<MetadataNestedMetadataUnderUnderSubjectListCreateInput>;
  /** Actions for the "Metadata.metadataUploadedByFullNameList" relation: "MetadataUploadedByFullName.metadata"'s inverse relation */
  metadataUploadedByFullNameList?: InputMaybe<MetadataNestedMetadataUploadedByFullNameListCreateInput>;
  /** Actions for the "Metadata.metadataUploadedByList" relation: "MetadataUploadedBy.metadata"'s inverse relation */
  metadataUploadedByList?: InputMaybe<MetadataNestedMetadataUploadedByListCreateInput>;
  /** Actions for the "Metadata.metadataUploadTimeList" relation: "MetadataUploadTime.metadata"'s inverse relation */
  metadataUploadTimeList?: InputMaybe<MetadataNestedMetadataUploadTimeListCreateInput>;
  /** Actions for the "Metadata.metadataUrgencyList" relation: "MetadataUrgency.metadata"'s inverse relation */
  metadataUrgencyList?: InputMaybe<MetadataNestedMetadataUrgencyListCreateInput>;
  /** Actions for the "Metadata.metadataUserDefined195List" relation: "MetadataUserDefined195.metadata"'s inverse relation */
  metadataUserDefined195List?: InputMaybe<MetadataNestedMetadataUserDefined195ListCreateInput>;
  /** Actions for the "Metadata.metadataUserDefined237List" relation: "MetadataUserDefined237.metadata"'s inverse relation */
  metadataUserDefined237List?: InputMaybe<MetadataNestedMetadataUserDefined237ListCreateInput>;
  /** Actions for the "Metadata.metadataUserDefined238List" relation: "MetadataUserDefined238.metadata"'s inverse relation */
  metadataUserDefined238List?: InputMaybe<MetadataNestedMetadataUserDefined238ListCreateInput>;
  /** Actions for the "Metadata.metadataUserDefined239List" relation: "MetadataUserDefined239.metadata"'s inverse relation */
  metadataUserDefined239List?: InputMaybe<MetadataNestedMetadataUserDefined239ListCreateInput>;
  /** Actions for the "Metadata.metadataUserDefined242List" relation: "MetadataUserDefined242.metadata"'s inverse relation */
  metadataUserDefined242List?: InputMaybe<MetadataNestedMetadataUserDefined242ListCreateInput>;
  /** Actions for the "Metadata.metadataUserDefined62List" relation: "MetadataUserDefined62.metadata"'s inverse relation */
  metadataUserDefined62List?: InputMaybe<MetadataNestedMetadataUserDefined62ListCreateInput>;
  /** Actions for the "Metadata.metadataWorkflowKindList" relation: "MetadataWorkflowKind.metadata"'s inverse relation */
  metadataWorkflowKindList?: InputMaybe<MetadataNestedMetadataWorkflowKindListCreateInput>;
  /** Actions for the "Metadata.metadataXmpHistoryList" relation: "MetadataXmpHistory.metadata"'s inverse relation */
  metadataXmpHistoryList?: InputMaybe<MetadataNestedMetadataXmpHistoryListCreateInput>;
  name: MetadataNameEnumType;
  namespace: Scalars['String']['input'];
  /** Actions for the "Metadata.photoMetadatas" relation: "PhotoMetadata.metadata"'s inverse relation */
  photoMetadatas?: InputMaybe<MetadataNestedPhotoMetadatasCreateInput>;
  structName?: InputMaybe<Scalars['String']['input']>;
  /** whether is this metadata value is a list or not, for display usage */
  type: MetadataValueTypeEnum;
};

/** "MetadataCreator" resource's node */
export type MetadataCreator = {
  __typename?: 'MetadataCreator';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCreatorCreateInput = {
  /** Actions for the "MetadataCreator.archive" relation */
  archive: MetadataCreatorNestedArchiveCreateInput;
  /** Actions for the "MetadataCreator.metadata" relation */
  metadata: MetadataCreatorNestedMetadataCreateInput;
  /** Actions for the "MetadataCreator.photo" relation */
  photo: MetadataCreatorNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreatorNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCreator" node, through the "MetadataCreator.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCreator" node, through the "MetadataCreator.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCreator" node, through the "MetadataCreator.archive" relation. */
  update?: InputMaybe<MetadataCreatorNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCreator" node, through the "MetadataCreator.archive" relation. */
  upsert?: InputMaybe<MetadataCreatorNestedUpsertArchiveCreateInput>;
};

export type MetadataCreatorNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCreator" node, through the "MetadataCreator.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCreator" node, through the "MetadataCreator.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCreator" node, through the "MetadataCreator.archive" relation. */
  update?: InputMaybe<MetadataCreatorNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCreator" node, through the "MetadataCreator.archive" relation. */
  upsert?: InputMaybe<MetadataCreatorNestedUpsertArchiveUpdateInput>;
};

export type MetadataCreatorNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCreator" node, through the "MetadataCreator.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCreator" node, through the "MetadataCreator.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCreator" node, through the "MetadataCreator.metadata" relation. */
  update?: InputMaybe<MetadataCreatorNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCreator" node, through the "MetadataCreator.metadata" relation. */
  upsert?: InputMaybe<MetadataCreatorNestedUpsertMetadataCreateInput>;
};

export type MetadataCreatorNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCreator" node, through the "MetadataCreator.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCreator" node, through the "MetadataCreator.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCreator" node, through the "MetadataCreator.metadata" relation. */
  update?: InputMaybe<MetadataCreatorNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCreator" node, through the "MetadataCreator.metadata" relation. */
  upsert?: InputMaybe<MetadataCreatorNestedUpsertMetadataUpdateInput>;
};

export type MetadataCreatorNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCreator" node, through the "MetadataCreator.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCreator" node, through the "MetadataCreator.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCreator" node, through the "MetadataCreator.photo" relation. */
  update?: InputMaybe<MetadataCreatorNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCreator" node, through the "MetadataCreator.photo" relation. */
  upsert?: InputMaybe<MetadataCreatorNestedUpsertPhotoCreateInput>;
};

export type MetadataCreatorNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCreator" node, through the "MetadataCreator.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCreator" node, through the "MetadataCreator.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCreator" node, through the "MetadataCreator.photo" relation. */
  update?: InputMaybe<MetadataCreatorNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCreator" node, through the "MetadataCreator.photo" relation. */
  upsert?: InputMaybe<MetadataCreatorNestedUpsertPhotoUpdateInput>;
};

export type MetadataCreatorNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCreatorNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCreatorNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCreatorNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCreatorNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCreatorNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCreatorNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCreatorNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCreatorNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCreatorNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCreatorNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCreatorNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCreatorOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCreatorUpdateInput = {
  /** Actions for the "MetadataCreator.archive" relation */
  archive?: InputMaybe<MetadataCreatorNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCreator.metadata" relation */
  metadata?: InputMaybe<MetadataCreatorNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCreator.photo" relation */
  photo?: InputMaybe<MetadataCreatorNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCreator" nodes by specifying some conditions */
export type MetadataCreatorWhereInput = {
  AND?: InputMaybe<Array<MetadataCreatorWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCreatorWhereInput>;
  OR?: InputMaybe<Array<MetadataCreatorWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCreator" node. */
export type MetadataCreatorWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCreatorWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCreator.metadata" relation */
  metadata: MetadataCreatorNestedMetadataCreateInput;
  /** Actions for the "MetadataCreator.photo" relation */
  photo: MetadataCreatorNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreatorWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCreator.metadata" relation */
  metadata?: InputMaybe<MetadataCreatorNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCreator.photo" relation */
  photo?: InputMaybe<MetadataCreatorNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreatorWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCreator.archive" relation */
  archive: MetadataCreatorNestedArchiveCreateInput;
  /** Actions for the "MetadataCreator.photo" relation */
  photo: MetadataCreatorNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreatorWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCreator.archive" relation */
  archive?: InputMaybe<MetadataCreatorNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCreator.photo" relation */
  photo?: InputMaybe<MetadataCreatorNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreatorWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCreator.archive" relation */
  archive: MetadataCreatorNestedArchiveCreateInput;
  /** Actions for the "MetadataCreator.metadata" relation */
  metadata: MetadataCreatorNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreatorWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCreator.archive" relation */
  archive?: InputMaybe<MetadataCreatorNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCreator.metadata" relation */
  metadata?: InputMaybe<MetadataCreatorNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCredit" resource's node */
export type MetadataCredit = {
  __typename?: 'MetadataCredit';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCreditCreateInput = {
  /** Actions for the "MetadataCredit.archive" relation */
  archive: MetadataCreditNestedArchiveCreateInput;
  /** Actions for the "MetadataCredit.metadata" relation */
  metadata: MetadataCreditNestedMetadataCreateInput;
  /** Actions for the "MetadataCredit.photo" relation */
  photo: MetadataCreditNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreditNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCredit" node, through the "MetadataCredit.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCredit" node, through the "MetadataCredit.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCredit" node, through the "MetadataCredit.archive" relation. */
  update?: InputMaybe<MetadataCreditNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCredit" node, through the "MetadataCredit.archive" relation. */
  upsert?: InputMaybe<MetadataCreditNestedUpsertArchiveCreateInput>;
};

export type MetadataCreditNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCredit" node, through the "MetadataCredit.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCredit" node, through the "MetadataCredit.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCredit" node, through the "MetadataCredit.archive" relation. */
  update?: InputMaybe<MetadataCreditNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCredit" node, through the "MetadataCredit.archive" relation. */
  upsert?: InputMaybe<MetadataCreditNestedUpsertArchiveUpdateInput>;
};

export type MetadataCreditNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCredit" node, through the "MetadataCredit.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCredit" node, through the "MetadataCredit.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCredit" node, through the "MetadataCredit.metadata" relation. */
  update?: InputMaybe<MetadataCreditNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCredit" node, through the "MetadataCredit.metadata" relation. */
  upsert?: InputMaybe<MetadataCreditNestedUpsertMetadataCreateInput>;
};

export type MetadataCreditNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCredit" node, through the "MetadataCredit.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCredit" node, through the "MetadataCredit.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCredit" node, through the "MetadataCredit.metadata" relation. */
  update?: InputMaybe<MetadataCreditNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCredit" node, through the "MetadataCredit.metadata" relation. */
  upsert?: InputMaybe<MetadataCreditNestedUpsertMetadataUpdateInput>;
};

export type MetadataCreditNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCredit" node, through the "MetadataCredit.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCredit" node, through the "MetadataCredit.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCredit" node, through the "MetadataCredit.photo" relation. */
  update?: InputMaybe<MetadataCreditNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCredit" node, through the "MetadataCredit.photo" relation. */
  upsert?: InputMaybe<MetadataCreditNestedUpsertPhotoCreateInput>;
};

export type MetadataCreditNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCredit" node, through the "MetadataCredit.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCredit" node, through the "MetadataCredit.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCredit" node, through the "MetadataCredit.photo" relation. */
  update?: InputMaybe<MetadataCreditNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCredit" node, through the "MetadataCredit.photo" relation. */
  upsert?: InputMaybe<MetadataCreditNestedUpsertPhotoUpdateInput>;
};

export type MetadataCreditNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCreditNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCreditNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCreditNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCreditNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCreditNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCreditNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCreditNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCreditNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCreditNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCreditNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCreditNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCreditOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCreditUpdateInput = {
  /** Actions for the "MetadataCredit.archive" relation */
  archive?: InputMaybe<MetadataCreditNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCredit.metadata" relation */
  metadata?: InputMaybe<MetadataCreditNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCredit.photo" relation */
  photo?: InputMaybe<MetadataCreditNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCredit" nodes by specifying some conditions */
export type MetadataCreditWhereInput = {
  AND?: InputMaybe<Array<MetadataCreditWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCreditWhereInput>;
  OR?: InputMaybe<Array<MetadataCreditWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCredit" node. */
export type MetadataCreditWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCreditWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCredit.metadata" relation */
  metadata: MetadataCreditNestedMetadataCreateInput;
  /** Actions for the "MetadataCredit.photo" relation */
  photo: MetadataCreditNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreditWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCredit.metadata" relation */
  metadata?: InputMaybe<MetadataCreditNestedMetadataUpdateInput>;
  /** Actions for the "MetadataCredit.photo" relation */
  photo?: InputMaybe<MetadataCreditNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreditWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCredit.archive" relation */
  archive: MetadataCreditNestedArchiveCreateInput;
  /** Actions for the "MetadataCredit.photo" relation */
  photo: MetadataCreditNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreditWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCredit.archive" relation */
  archive?: InputMaybe<MetadataCreditNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCredit.photo" relation */
  photo?: InputMaybe<MetadataCreditNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreditWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCredit.archive" relation */
  archive: MetadataCreditNestedArchiveCreateInput;
  /** Actions for the "MetadataCredit.metadata" relation */
  metadata: MetadataCreditNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCreditWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCredit.archive" relation */
  archive?: InputMaybe<MetadataCreditNestedArchiveUpdateInput>;
  /** Actions for the "MetadataCredit.metadata" relation */
  metadata?: InputMaybe<MetadataCreditNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField1" resource's node */
export type MetadataCustomField1 = {
  __typename?: 'MetadataCustomField1';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** "MetadataCustomField14" resource's node */
export type MetadataCustomField14 = {
  __typename?: 'MetadataCustomField14';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField14CreateInput = {
  /** Actions for the "MetadataCustomField14.archive" relation */
  archive: MetadataCustomField14NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField14.metadata" relation */
  metadata: MetadataCustomField14NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField14.photo" relation */
  photo: MetadataCustomField14NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField14NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField14" node, through the "MetadataCustomField14.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField14" node, through the "MetadataCustomField14.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField14" node, through the "MetadataCustomField14.archive" relation. */
  update?: InputMaybe<MetadataCustomField14NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField14" node, through the "MetadataCustomField14.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField14NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField14NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.archive" relation. */
  update?: InputMaybe<MetadataCustomField14NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField14NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField14NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField14" node, through the "MetadataCustomField14.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField14" node, through the "MetadataCustomField14.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField14" node, through the "MetadataCustomField14.metadata" relation. */
  update?: InputMaybe<MetadataCustomField14NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField14" node, through the "MetadataCustomField14.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField14NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField14NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.metadata" relation. */
  update?: InputMaybe<MetadataCustomField14NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField14NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField14NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField14" node, through the "MetadataCustomField14.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField14" node, through the "MetadataCustomField14.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField14" node, through the "MetadataCustomField14.photo" relation. */
  update?: InputMaybe<MetadataCustomField14NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField14" node, through the "MetadataCustomField14.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField14NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField14NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.photo" relation. */
  update?: InputMaybe<MetadataCustomField14NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField14" node, through the "MetadataCustomField14.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField14NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField14NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField14NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField14NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField14NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField14NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField14NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField14NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField14NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField14NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField14NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField14NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField14NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField14OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField14UpdateInput = {
  /** Actions for the "MetadataCustomField14.archive" relation */
  archive?: InputMaybe<MetadataCustomField14NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField14.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField14NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField14.photo" relation */
  photo?: InputMaybe<MetadataCustomField14NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField14" nodes by specifying some conditions */
export type MetadataCustomField14WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField14WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField14WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField14WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField14" node. */
export type MetadataCustomField14WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField14WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField14.metadata" relation */
  metadata: MetadataCustomField14NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField14.photo" relation */
  photo: MetadataCustomField14NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField14WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField14.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField14NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField14.photo" relation */
  photo?: InputMaybe<MetadataCustomField14NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField14WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField14.archive" relation */
  archive: MetadataCustomField14NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField14.photo" relation */
  photo: MetadataCustomField14NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField14WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField14.archive" relation */
  archive?: InputMaybe<MetadataCustomField14NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField14.photo" relation */
  photo?: InputMaybe<MetadataCustomField14NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField14WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField14.archive" relation */
  archive: MetadataCustomField14NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField14.metadata" relation */
  metadata: MetadataCustomField14NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField14WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField14.archive" relation */
  archive?: InputMaybe<MetadataCustomField14NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField14.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField14NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField15" resource's node */
export type MetadataCustomField15 = {
  __typename?: 'MetadataCustomField15';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField15CreateInput = {
  /** Actions for the "MetadataCustomField15.archive" relation */
  archive: MetadataCustomField15NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField15.metadata" relation */
  metadata: MetadataCustomField15NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField15.photo" relation */
  photo: MetadataCustomField15NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField15NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField15" node, through the "MetadataCustomField15.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField15" node, through the "MetadataCustomField15.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField15" node, through the "MetadataCustomField15.archive" relation. */
  update?: InputMaybe<MetadataCustomField15NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField15" node, through the "MetadataCustomField15.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField15NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField15NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.archive" relation. */
  update?: InputMaybe<MetadataCustomField15NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField15NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField15NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField15" node, through the "MetadataCustomField15.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField15" node, through the "MetadataCustomField15.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField15" node, through the "MetadataCustomField15.metadata" relation. */
  update?: InputMaybe<MetadataCustomField15NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField15" node, through the "MetadataCustomField15.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField15NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField15NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.metadata" relation. */
  update?: InputMaybe<MetadataCustomField15NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField15NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField15NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField15" node, through the "MetadataCustomField15.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField15" node, through the "MetadataCustomField15.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField15" node, through the "MetadataCustomField15.photo" relation. */
  update?: InputMaybe<MetadataCustomField15NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField15" node, through the "MetadataCustomField15.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField15NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField15NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.photo" relation. */
  update?: InputMaybe<MetadataCustomField15NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField15" node, through the "MetadataCustomField15.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField15NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField15NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField15NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField15NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField15NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField15NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField15NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField15NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField15NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField15NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField15NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField15NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField15NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField15OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField15UpdateInput = {
  /** Actions for the "MetadataCustomField15.archive" relation */
  archive?: InputMaybe<MetadataCustomField15NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField15.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField15NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField15.photo" relation */
  photo?: InputMaybe<MetadataCustomField15NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField15" nodes by specifying some conditions */
export type MetadataCustomField15WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField15WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField15WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField15WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField15" node. */
export type MetadataCustomField15WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField15WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField15.metadata" relation */
  metadata: MetadataCustomField15NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField15.photo" relation */
  photo: MetadataCustomField15NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField15WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField15.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField15NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField15.photo" relation */
  photo?: InputMaybe<MetadataCustomField15NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField15WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField15.archive" relation */
  archive: MetadataCustomField15NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField15.photo" relation */
  photo: MetadataCustomField15NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField15WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField15.archive" relation */
  archive?: InputMaybe<MetadataCustomField15NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField15.photo" relation */
  photo?: InputMaybe<MetadataCustomField15NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField15WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField15.archive" relation */
  archive: MetadataCustomField15NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField15.metadata" relation */
  metadata: MetadataCustomField15NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField15WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField15.archive" relation */
  archive?: InputMaybe<MetadataCustomField15NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField15.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField15NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField16" resource's node */
export type MetadataCustomField16 = {
  __typename?: 'MetadataCustomField16';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField16CreateInput = {
  /** Actions for the "MetadataCustomField16.archive" relation */
  archive: MetadataCustomField16NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField16.metadata" relation */
  metadata: MetadataCustomField16NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField16.photo" relation */
  photo: MetadataCustomField16NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField16NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField16" node, through the "MetadataCustomField16.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField16" node, through the "MetadataCustomField16.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField16" node, through the "MetadataCustomField16.archive" relation. */
  update?: InputMaybe<MetadataCustomField16NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField16" node, through the "MetadataCustomField16.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField16NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField16NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.archive" relation. */
  update?: InputMaybe<MetadataCustomField16NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField16NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField16NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField16" node, through the "MetadataCustomField16.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField16" node, through the "MetadataCustomField16.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField16" node, through the "MetadataCustomField16.metadata" relation. */
  update?: InputMaybe<MetadataCustomField16NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField16" node, through the "MetadataCustomField16.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField16NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField16NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.metadata" relation. */
  update?: InputMaybe<MetadataCustomField16NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField16NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField16NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField16" node, through the "MetadataCustomField16.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField16" node, through the "MetadataCustomField16.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField16" node, through the "MetadataCustomField16.photo" relation. */
  update?: InputMaybe<MetadataCustomField16NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField16" node, through the "MetadataCustomField16.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField16NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField16NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.photo" relation. */
  update?: InputMaybe<MetadataCustomField16NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField16" node, through the "MetadataCustomField16.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField16NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField16NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField16NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField16NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField16NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField16NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField16NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField16NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField16NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField16NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField16NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField16NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField16NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField16OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField16UpdateInput = {
  /** Actions for the "MetadataCustomField16.archive" relation */
  archive?: InputMaybe<MetadataCustomField16NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField16.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField16NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField16.photo" relation */
  photo?: InputMaybe<MetadataCustomField16NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField16" nodes by specifying some conditions */
export type MetadataCustomField16WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField16WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField16WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField16WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField16" node. */
export type MetadataCustomField16WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField16WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField16.metadata" relation */
  metadata: MetadataCustomField16NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField16.photo" relation */
  photo: MetadataCustomField16NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField16WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField16.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField16NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField16.photo" relation */
  photo?: InputMaybe<MetadataCustomField16NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField16WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField16.archive" relation */
  archive: MetadataCustomField16NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField16.photo" relation */
  photo: MetadataCustomField16NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField16WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField16.archive" relation */
  archive?: InputMaybe<MetadataCustomField16NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField16.photo" relation */
  photo?: InputMaybe<MetadataCustomField16NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField16WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField16.archive" relation */
  archive: MetadataCustomField16NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField16.metadata" relation */
  metadata: MetadataCustomField16NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField16WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField16.archive" relation */
  archive?: InputMaybe<MetadataCustomField16NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField16.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField16NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField17" resource's node */
export type MetadataCustomField17 = {
  __typename?: 'MetadataCustomField17';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField17CreateInput = {
  /** Actions for the "MetadataCustomField17.archive" relation */
  archive: MetadataCustomField17NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField17.metadata" relation */
  metadata: MetadataCustomField17NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField17.photo" relation */
  photo: MetadataCustomField17NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField17NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField17" node, through the "MetadataCustomField17.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField17" node, through the "MetadataCustomField17.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField17" node, through the "MetadataCustomField17.archive" relation. */
  update?: InputMaybe<MetadataCustomField17NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField17" node, through the "MetadataCustomField17.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField17NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField17NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.archive" relation. */
  update?: InputMaybe<MetadataCustomField17NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField17NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField17NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField17" node, through the "MetadataCustomField17.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField17" node, through the "MetadataCustomField17.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField17" node, through the "MetadataCustomField17.metadata" relation. */
  update?: InputMaybe<MetadataCustomField17NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField17" node, through the "MetadataCustomField17.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField17NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField17NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.metadata" relation. */
  update?: InputMaybe<MetadataCustomField17NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField17NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField17NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField17" node, through the "MetadataCustomField17.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField17" node, through the "MetadataCustomField17.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField17" node, through the "MetadataCustomField17.photo" relation. */
  update?: InputMaybe<MetadataCustomField17NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField17" node, through the "MetadataCustomField17.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField17NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField17NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.photo" relation. */
  update?: InputMaybe<MetadataCustomField17NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField17" node, through the "MetadataCustomField17.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField17NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField17NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField17NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField17NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField17NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField17NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField17NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField17NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField17NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField17NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField17NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField17NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField17NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField17OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField17UpdateInput = {
  /** Actions for the "MetadataCustomField17.archive" relation */
  archive?: InputMaybe<MetadataCustomField17NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField17.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField17NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField17.photo" relation */
  photo?: InputMaybe<MetadataCustomField17NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField17" nodes by specifying some conditions */
export type MetadataCustomField17WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField17WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField17WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField17WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField17" node. */
export type MetadataCustomField17WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField17WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField17.metadata" relation */
  metadata: MetadataCustomField17NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField17.photo" relation */
  photo: MetadataCustomField17NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField17WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField17.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField17NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField17.photo" relation */
  photo?: InputMaybe<MetadataCustomField17NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField17WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField17.archive" relation */
  archive: MetadataCustomField17NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField17.photo" relation */
  photo: MetadataCustomField17NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField17WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField17.archive" relation */
  archive?: InputMaybe<MetadataCustomField17NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField17.photo" relation */
  photo?: InputMaybe<MetadataCustomField17NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField17WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField17.archive" relation */
  archive: MetadataCustomField17NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField17.metadata" relation */
  metadata: MetadataCustomField17NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField17WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField17.archive" relation */
  archive?: InputMaybe<MetadataCustomField17NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField17.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField17NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField1CreateInput = {
  /** Actions for the "MetadataCustomField1.archive" relation */
  archive: MetadataCustomField1NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField1.metadata" relation */
  metadata: MetadataCustomField1NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField1.photo" relation */
  photo: MetadataCustomField1NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField1NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField1" node, through the "MetadataCustomField1.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField1" node, through the "MetadataCustomField1.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField1" node, through the "MetadataCustomField1.archive" relation. */
  update?: InputMaybe<MetadataCustomField1NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField1" node, through the "MetadataCustomField1.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField1NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField1NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.archive" relation. */
  update?: InputMaybe<MetadataCustomField1NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField1NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField1NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField1" node, through the "MetadataCustomField1.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField1" node, through the "MetadataCustomField1.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField1" node, through the "MetadataCustomField1.metadata" relation. */
  update?: InputMaybe<MetadataCustomField1NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField1" node, through the "MetadataCustomField1.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField1NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField1NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.metadata" relation. */
  update?: InputMaybe<MetadataCustomField1NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField1NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField1NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField1" node, through the "MetadataCustomField1.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField1" node, through the "MetadataCustomField1.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField1" node, through the "MetadataCustomField1.photo" relation. */
  update?: InputMaybe<MetadataCustomField1NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField1" node, through the "MetadataCustomField1.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField1NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField1NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.photo" relation. */
  update?: InputMaybe<MetadataCustomField1NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField1" node, through the "MetadataCustomField1.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField1NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField1NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField1NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField1NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField1NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField1NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField1NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField1NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField1NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField1NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField1NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField1NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField1NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField1OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField1UpdateInput = {
  /** Actions for the "MetadataCustomField1.archive" relation */
  archive?: InputMaybe<MetadataCustomField1NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField1.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField1NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField1.photo" relation */
  photo?: InputMaybe<MetadataCustomField1NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField1" nodes by specifying some conditions */
export type MetadataCustomField1WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField1WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField1WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField1WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField1" node. */
export type MetadataCustomField1WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField1WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField1.metadata" relation */
  metadata: MetadataCustomField1NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField1.photo" relation */
  photo: MetadataCustomField1NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField1WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField1.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField1NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField1.photo" relation */
  photo?: InputMaybe<MetadataCustomField1NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField1WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField1.archive" relation */
  archive: MetadataCustomField1NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField1.photo" relation */
  photo: MetadataCustomField1NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField1WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField1.archive" relation */
  archive?: InputMaybe<MetadataCustomField1NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField1.photo" relation */
  photo?: InputMaybe<MetadataCustomField1NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField1WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField1.archive" relation */
  archive: MetadataCustomField1NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField1.metadata" relation */
  metadata: MetadataCustomField1NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField1WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField1.archive" relation */
  archive?: InputMaybe<MetadataCustomField1NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField1.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField1NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField20" resource's node */
export type MetadataCustomField20 = {
  __typename?: 'MetadataCustomField20';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField20CreateInput = {
  /** Actions for the "MetadataCustomField20.archive" relation */
  archive: MetadataCustomField20NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField20.metadata" relation */
  metadata: MetadataCustomField20NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField20.photo" relation */
  photo: MetadataCustomField20NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField20NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField20" node, through the "MetadataCustomField20.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField20" node, through the "MetadataCustomField20.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField20" node, through the "MetadataCustomField20.archive" relation. */
  update?: InputMaybe<MetadataCustomField20NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField20" node, through the "MetadataCustomField20.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField20NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField20NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.archive" relation. */
  update?: InputMaybe<MetadataCustomField20NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField20NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField20NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField20" node, through the "MetadataCustomField20.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField20" node, through the "MetadataCustomField20.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField20" node, through the "MetadataCustomField20.metadata" relation. */
  update?: InputMaybe<MetadataCustomField20NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField20" node, through the "MetadataCustomField20.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField20NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField20NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.metadata" relation. */
  update?: InputMaybe<MetadataCustomField20NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField20NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField20NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField20" node, through the "MetadataCustomField20.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField20" node, through the "MetadataCustomField20.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField20" node, through the "MetadataCustomField20.photo" relation. */
  update?: InputMaybe<MetadataCustomField20NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField20" node, through the "MetadataCustomField20.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField20NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField20NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.photo" relation. */
  update?: InputMaybe<MetadataCustomField20NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField20" node, through the "MetadataCustomField20.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField20NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField20NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField20NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField20NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField20NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField20NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField20NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField20NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField20NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField20NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField20NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField20NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField20NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField20OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField20UpdateInput = {
  /** Actions for the "MetadataCustomField20.archive" relation */
  archive?: InputMaybe<MetadataCustomField20NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField20.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField20NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField20.photo" relation */
  photo?: InputMaybe<MetadataCustomField20NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField20" nodes by specifying some conditions */
export type MetadataCustomField20WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField20WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField20WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField20WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField20" node. */
export type MetadataCustomField20WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField20WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField20.metadata" relation */
  metadata: MetadataCustomField20NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField20.photo" relation */
  photo: MetadataCustomField20NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField20WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField20.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField20NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField20.photo" relation */
  photo?: InputMaybe<MetadataCustomField20NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField20WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField20.archive" relation */
  archive: MetadataCustomField20NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField20.photo" relation */
  photo: MetadataCustomField20NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField20WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField20.archive" relation */
  archive?: InputMaybe<MetadataCustomField20NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField20.photo" relation */
  photo?: InputMaybe<MetadataCustomField20NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField20WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField20.archive" relation */
  archive: MetadataCustomField20NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField20.metadata" relation */
  metadata: MetadataCustomField20NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField20WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField20.archive" relation */
  archive?: InputMaybe<MetadataCustomField20NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField20.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField20NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField3" resource's node */
export type MetadataCustomField3 = {
  __typename?: 'MetadataCustomField3';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField3CreateInput = {
  /** Actions for the "MetadataCustomField3.archive" relation */
  archive: MetadataCustomField3NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField3.metadata" relation */
  metadata: MetadataCustomField3NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField3.photo" relation */
  photo: MetadataCustomField3NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField3NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField3" node, through the "MetadataCustomField3.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField3" node, through the "MetadataCustomField3.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField3" node, through the "MetadataCustomField3.archive" relation. */
  update?: InputMaybe<MetadataCustomField3NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField3" node, through the "MetadataCustomField3.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField3NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField3NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.archive" relation. */
  update?: InputMaybe<MetadataCustomField3NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField3NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField3NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField3" node, through the "MetadataCustomField3.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField3" node, through the "MetadataCustomField3.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField3" node, through the "MetadataCustomField3.metadata" relation. */
  update?: InputMaybe<MetadataCustomField3NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField3" node, through the "MetadataCustomField3.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField3NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField3NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.metadata" relation. */
  update?: InputMaybe<MetadataCustomField3NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField3NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField3NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField3" node, through the "MetadataCustomField3.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField3" node, through the "MetadataCustomField3.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField3" node, through the "MetadataCustomField3.photo" relation. */
  update?: InputMaybe<MetadataCustomField3NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField3" node, through the "MetadataCustomField3.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField3NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField3NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.photo" relation. */
  update?: InputMaybe<MetadataCustomField3NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField3" node, through the "MetadataCustomField3.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField3NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField3NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField3NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField3NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField3NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField3NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField3NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField3NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField3NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField3NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField3NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField3NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField3NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField3OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField3UpdateInput = {
  /** Actions for the "MetadataCustomField3.archive" relation */
  archive?: InputMaybe<MetadataCustomField3NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField3.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField3NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField3.photo" relation */
  photo?: InputMaybe<MetadataCustomField3NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField3" nodes by specifying some conditions */
export type MetadataCustomField3WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField3WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField3WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField3WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField3" node. */
export type MetadataCustomField3WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField3WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField3.metadata" relation */
  metadata: MetadataCustomField3NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField3.photo" relation */
  photo: MetadataCustomField3NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField3WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField3.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField3NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField3.photo" relation */
  photo?: InputMaybe<MetadataCustomField3NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField3WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField3.archive" relation */
  archive: MetadataCustomField3NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField3.photo" relation */
  photo: MetadataCustomField3NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField3WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField3.archive" relation */
  archive?: InputMaybe<MetadataCustomField3NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField3.photo" relation */
  photo?: InputMaybe<MetadataCustomField3NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField3WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField3.archive" relation */
  archive: MetadataCustomField3NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField3.metadata" relation */
  metadata: MetadataCustomField3NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField3WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField3.archive" relation */
  archive?: InputMaybe<MetadataCustomField3NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField3.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField3NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField4" resource's node */
export type MetadataCustomField4 = {
  __typename?: 'MetadataCustomField4';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField4CreateInput = {
  /** Actions for the "MetadataCustomField4.archive" relation */
  archive: MetadataCustomField4NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField4.metadata" relation */
  metadata: MetadataCustomField4NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField4.photo" relation */
  photo: MetadataCustomField4NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField4NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField4" node, through the "MetadataCustomField4.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField4" node, through the "MetadataCustomField4.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField4" node, through the "MetadataCustomField4.archive" relation. */
  update?: InputMaybe<MetadataCustomField4NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField4" node, through the "MetadataCustomField4.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField4NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField4NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.archive" relation. */
  update?: InputMaybe<MetadataCustomField4NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField4NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField4NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField4" node, through the "MetadataCustomField4.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField4" node, through the "MetadataCustomField4.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField4" node, through the "MetadataCustomField4.metadata" relation. */
  update?: InputMaybe<MetadataCustomField4NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField4" node, through the "MetadataCustomField4.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField4NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField4NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.metadata" relation. */
  update?: InputMaybe<MetadataCustomField4NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField4NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField4NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField4" node, through the "MetadataCustomField4.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField4" node, through the "MetadataCustomField4.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField4" node, through the "MetadataCustomField4.photo" relation. */
  update?: InputMaybe<MetadataCustomField4NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField4" node, through the "MetadataCustomField4.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField4NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField4NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.photo" relation. */
  update?: InputMaybe<MetadataCustomField4NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField4" node, through the "MetadataCustomField4.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField4NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField4NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField4NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField4NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField4NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField4NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField4NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField4NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField4NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField4NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField4NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField4NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField4NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField4OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField4UpdateInput = {
  /** Actions for the "MetadataCustomField4.archive" relation */
  archive?: InputMaybe<MetadataCustomField4NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField4.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField4NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField4.photo" relation */
  photo?: InputMaybe<MetadataCustomField4NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField4" nodes by specifying some conditions */
export type MetadataCustomField4WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField4WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField4WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField4WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField4" node. */
export type MetadataCustomField4WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField4WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField4.metadata" relation */
  metadata: MetadataCustomField4NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField4.photo" relation */
  photo: MetadataCustomField4NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField4WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField4.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField4NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField4.photo" relation */
  photo?: InputMaybe<MetadataCustomField4NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField4WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField4.archive" relation */
  archive: MetadataCustomField4NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField4.photo" relation */
  photo: MetadataCustomField4NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField4WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField4.archive" relation */
  archive?: InputMaybe<MetadataCustomField4NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField4.photo" relation */
  photo?: InputMaybe<MetadataCustomField4NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField4WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField4.archive" relation */
  archive: MetadataCustomField4NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField4.metadata" relation */
  metadata: MetadataCustomField4NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField4WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField4.archive" relation */
  archive?: InputMaybe<MetadataCustomField4NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField4.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField4NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField5" resource's node */
export type MetadataCustomField5 = {
  __typename?: 'MetadataCustomField5';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField5CreateInput = {
  /** Actions for the "MetadataCustomField5.archive" relation */
  archive: MetadataCustomField5NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField5.metadata" relation */
  metadata: MetadataCustomField5NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField5.photo" relation */
  photo: MetadataCustomField5NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField5NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField5" node, through the "MetadataCustomField5.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField5" node, through the "MetadataCustomField5.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField5" node, through the "MetadataCustomField5.archive" relation. */
  update?: InputMaybe<MetadataCustomField5NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField5" node, through the "MetadataCustomField5.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField5NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField5NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.archive" relation. */
  update?: InputMaybe<MetadataCustomField5NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField5NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField5NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField5" node, through the "MetadataCustomField5.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField5" node, through the "MetadataCustomField5.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField5" node, through the "MetadataCustomField5.metadata" relation. */
  update?: InputMaybe<MetadataCustomField5NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField5" node, through the "MetadataCustomField5.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField5NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField5NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.metadata" relation. */
  update?: InputMaybe<MetadataCustomField5NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField5NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField5NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField5" node, through the "MetadataCustomField5.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField5" node, through the "MetadataCustomField5.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField5" node, through the "MetadataCustomField5.photo" relation. */
  update?: InputMaybe<MetadataCustomField5NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField5" node, through the "MetadataCustomField5.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField5NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField5NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.photo" relation. */
  update?: InputMaybe<MetadataCustomField5NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField5" node, through the "MetadataCustomField5.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField5NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField5NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField5NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField5NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField5NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField5NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField5NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField5NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField5NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField5NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField5NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField5NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField5NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField5OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField5UpdateInput = {
  /** Actions for the "MetadataCustomField5.archive" relation */
  archive?: InputMaybe<MetadataCustomField5NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField5.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField5NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField5.photo" relation */
  photo?: InputMaybe<MetadataCustomField5NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField5" nodes by specifying some conditions */
export type MetadataCustomField5WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField5WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField5WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField5WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField5" node. */
export type MetadataCustomField5WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField5WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField5.metadata" relation */
  metadata: MetadataCustomField5NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField5.photo" relation */
  photo: MetadataCustomField5NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField5WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField5.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField5NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField5.photo" relation */
  photo?: InputMaybe<MetadataCustomField5NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField5WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField5.archive" relation */
  archive: MetadataCustomField5NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField5.photo" relation */
  photo: MetadataCustomField5NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField5WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField5.archive" relation */
  archive?: InputMaybe<MetadataCustomField5NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField5.photo" relation */
  photo?: InputMaybe<MetadataCustomField5NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField5WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField5.archive" relation */
  archive: MetadataCustomField5NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField5.metadata" relation */
  metadata: MetadataCustomField5NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField5WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField5.archive" relation */
  archive?: InputMaybe<MetadataCustomField5NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField5.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField5NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField6" resource's node */
export type MetadataCustomField6 = {
  __typename?: 'MetadataCustomField6';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField6CreateInput = {
  /** Actions for the "MetadataCustomField6.archive" relation */
  archive: MetadataCustomField6NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField6.metadata" relation */
  metadata: MetadataCustomField6NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField6.photo" relation */
  photo: MetadataCustomField6NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField6NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField6" node, through the "MetadataCustomField6.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField6" node, through the "MetadataCustomField6.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField6" node, through the "MetadataCustomField6.archive" relation. */
  update?: InputMaybe<MetadataCustomField6NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField6" node, through the "MetadataCustomField6.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField6NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField6NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.archive" relation. */
  update?: InputMaybe<MetadataCustomField6NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField6NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField6NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField6" node, through the "MetadataCustomField6.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField6" node, through the "MetadataCustomField6.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField6" node, through the "MetadataCustomField6.metadata" relation. */
  update?: InputMaybe<MetadataCustomField6NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField6" node, through the "MetadataCustomField6.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField6NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField6NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.metadata" relation. */
  update?: InputMaybe<MetadataCustomField6NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField6NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField6NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField6" node, through the "MetadataCustomField6.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField6" node, through the "MetadataCustomField6.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField6" node, through the "MetadataCustomField6.photo" relation. */
  update?: InputMaybe<MetadataCustomField6NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField6" node, through the "MetadataCustomField6.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField6NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField6NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.photo" relation. */
  update?: InputMaybe<MetadataCustomField6NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField6" node, through the "MetadataCustomField6.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField6NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField6NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField6NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField6NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField6NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField6NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField6NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField6NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField6NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField6NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField6NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField6NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField6NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField6OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField6UpdateInput = {
  /** Actions for the "MetadataCustomField6.archive" relation */
  archive?: InputMaybe<MetadataCustomField6NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField6.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField6NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField6.photo" relation */
  photo?: InputMaybe<MetadataCustomField6NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField6" nodes by specifying some conditions */
export type MetadataCustomField6WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField6WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField6WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField6WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField6" node. */
export type MetadataCustomField6WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField6WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField6.metadata" relation */
  metadata: MetadataCustomField6NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField6.photo" relation */
  photo: MetadataCustomField6NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField6WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField6.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField6NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField6.photo" relation */
  photo?: InputMaybe<MetadataCustomField6NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField6WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField6.archive" relation */
  archive: MetadataCustomField6NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField6.photo" relation */
  photo: MetadataCustomField6NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField6WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField6.archive" relation */
  archive?: InputMaybe<MetadataCustomField6NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField6.photo" relation */
  photo?: InputMaybe<MetadataCustomField6NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField6WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField6.archive" relation */
  archive: MetadataCustomField6NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField6.metadata" relation */
  metadata: MetadataCustomField6NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField6WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField6.archive" relation */
  archive?: InputMaybe<MetadataCustomField6NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField6.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField6NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField7" resource's node */
export type MetadataCustomField7 = {
  __typename?: 'MetadataCustomField7';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField7CreateInput = {
  /** Actions for the "MetadataCustomField7.archive" relation */
  archive: MetadataCustomField7NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField7.metadata" relation */
  metadata: MetadataCustomField7NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField7.photo" relation */
  photo: MetadataCustomField7NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField7NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField7" node, through the "MetadataCustomField7.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField7" node, through the "MetadataCustomField7.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField7" node, through the "MetadataCustomField7.archive" relation. */
  update?: InputMaybe<MetadataCustomField7NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField7" node, through the "MetadataCustomField7.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField7NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField7NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.archive" relation. */
  update?: InputMaybe<MetadataCustomField7NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField7NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField7NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField7" node, through the "MetadataCustomField7.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField7" node, through the "MetadataCustomField7.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField7" node, through the "MetadataCustomField7.metadata" relation. */
  update?: InputMaybe<MetadataCustomField7NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField7" node, through the "MetadataCustomField7.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField7NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField7NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.metadata" relation. */
  update?: InputMaybe<MetadataCustomField7NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField7NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField7NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField7" node, through the "MetadataCustomField7.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField7" node, through the "MetadataCustomField7.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField7" node, through the "MetadataCustomField7.photo" relation. */
  update?: InputMaybe<MetadataCustomField7NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField7" node, through the "MetadataCustomField7.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField7NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField7NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.photo" relation. */
  update?: InputMaybe<MetadataCustomField7NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField7" node, through the "MetadataCustomField7.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField7NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField7NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField7NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField7NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField7NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField7NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField7NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField7NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField7NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField7NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField7NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField7NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField7NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField7OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField7UpdateInput = {
  /** Actions for the "MetadataCustomField7.archive" relation */
  archive?: InputMaybe<MetadataCustomField7NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField7.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField7NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField7.photo" relation */
  photo?: InputMaybe<MetadataCustomField7NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField7" nodes by specifying some conditions */
export type MetadataCustomField7WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField7WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField7WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField7WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField7" node. */
export type MetadataCustomField7WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField7WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField7.metadata" relation */
  metadata: MetadataCustomField7NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField7.photo" relation */
  photo: MetadataCustomField7NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField7WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField7.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField7NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField7.photo" relation */
  photo?: InputMaybe<MetadataCustomField7NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField7WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField7.archive" relation */
  archive: MetadataCustomField7NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField7.photo" relation */
  photo: MetadataCustomField7NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField7WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField7.archive" relation */
  archive?: InputMaybe<MetadataCustomField7NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField7.photo" relation */
  photo?: InputMaybe<MetadataCustomField7NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField7WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField7.archive" relation */
  archive: MetadataCustomField7NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField7.metadata" relation */
  metadata: MetadataCustomField7NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField7WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField7.archive" relation */
  archive?: InputMaybe<MetadataCustomField7NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField7.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField7NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataCustomField9" resource's node */
export type MetadataCustomField9 = {
  __typename?: 'MetadataCustomField9';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataCustomField9CreateInput = {
  /** Actions for the "MetadataCustomField9.archive" relation */
  archive: MetadataCustomField9NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField9.metadata" relation */
  metadata: MetadataCustomField9NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField9.photo" relation */
  photo: MetadataCustomField9NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField9NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataCustomField9" node, through the "MetadataCustomField9.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataCustomField9" node, through the "MetadataCustomField9.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataCustomField9" node, through the "MetadataCustomField9.archive" relation. */
  update?: InputMaybe<MetadataCustomField9NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataCustomField9" node, through the "MetadataCustomField9.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField9NestedUpsertArchiveCreateInput>;
};

export type MetadataCustomField9NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.archive" relation. */
  update?: InputMaybe<MetadataCustomField9NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.archive" relation. */
  upsert?: InputMaybe<MetadataCustomField9NestedUpsertArchiveUpdateInput>;
};

export type MetadataCustomField9NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataCustomField9" node, through the "MetadataCustomField9.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataCustomField9" node, through the "MetadataCustomField9.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataCustomField9" node, through the "MetadataCustomField9.metadata" relation. */
  update?: InputMaybe<MetadataCustomField9NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataCustomField9" node, through the "MetadataCustomField9.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField9NestedUpsertMetadataCreateInput>;
};

export type MetadataCustomField9NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.metadata" relation. */
  update?: InputMaybe<MetadataCustomField9NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.metadata" relation. */
  upsert?: InputMaybe<MetadataCustomField9NestedUpsertMetadataUpdateInput>;
};

export type MetadataCustomField9NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataCustomField9" node, through the "MetadataCustomField9.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataCustomField9" node, through the "MetadataCustomField9.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataCustomField9" node, through the "MetadataCustomField9.photo" relation. */
  update?: InputMaybe<MetadataCustomField9NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataCustomField9" node, through the "MetadataCustomField9.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField9NestedUpsertPhotoCreateInput>;
};

export type MetadataCustomField9NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.photo" relation. */
  update?: InputMaybe<MetadataCustomField9NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataCustomField9" node, through the "MetadataCustomField9.photo" relation. */
  upsert?: InputMaybe<MetadataCustomField9NestedUpsertPhotoUpdateInput>;
};

export type MetadataCustomField9NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField9NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField9NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField9NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField9NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField9NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField9NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField9NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataCustomField9NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField9NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataCustomField9NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataCustomField9NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataCustomField9OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataCustomField9UpdateInput = {
  /** Actions for the "MetadataCustomField9.archive" relation */
  archive?: InputMaybe<MetadataCustomField9NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField9.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField9NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField9.photo" relation */
  photo?: InputMaybe<MetadataCustomField9NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataCustomField9" nodes by specifying some conditions */
export type MetadataCustomField9WhereInput = {
  AND?: InputMaybe<Array<MetadataCustomField9WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataCustomField9WhereInput>;
  OR?: InputMaybe<Array<MetadataCustomField9WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataCustomField9" node. */
export type MetadataCustomField9WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataCustomField9WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataCustomField9.metadata" relation */
  metadata: MetadataCustomField9NestedMetadataCreateInput;
  /** Actions for the "MetadataCustomField9.photo" relation */
  photo: MetadataCustomField9NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField9WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataCustomField9.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField9NestedMetadataUpdateInput>;
  /** Actions for the "MetadataCustomField9.photo" relation */
  photo?: InputMaybe<MetadataCustomField9NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField9WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataCustomField9.archive" relation */
  archive: MetadataCustomField9NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField9.photo" relation */
  photo: MetadataCustomField9NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField9WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataCustomField9.archive" relation */
  archive?: InputMaybe<MetadataCustomField9NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField9.photo" relation */
  photo?: InputMaybe<MetadataCustomField9NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField9WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataCustomField9.archive" relation */
  archive: MetadataCustomField9NestedArchiveCreateInput;
  /** Actions for the "MetadataCustomField9.metadata" relation */
  metadata: MetadataCustomField9NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataCustomField9WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataCustomField9.archive" relation */
  archive?: InputMaybe<MetadataCustomField9NestedArchiveUpdateInput>;
  /** Actions for the "MetadataCustomField9.metadata" relation */
  metadata?: InputMaybe<MetadataCustomField9NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDateCreated" resource's node */
export type MetadataDateCreated = {
  __typename?: 'MetadataDateCreated';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDateCreatedCreateInput = {
  /** Actions for the "MetadataDateCreated.archive" relation */
  archive: MetadataDateCreatedNestedArchiveCreateInput;
  /** Actions for the "MetadataDateCreated.metadata" relation */
  metadata: MetadataDateCreatedNestedMetadataCreateInput;
  /** Actions for the "MetadataDateCreated.photo" relation */
  photo: MetadataDateCreatedNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateCreatedNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDateCreated" node, through the "MetadataDateCreated.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDateCreated" node, through the "MetadataDateCreated.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDateCreated" node, through the "MetadataDateCreated.archive" relation. */
  update?: InputMaybe<MetadataDateCreatedNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDateCreated" node, through the "MetadataDateCreated.archive" relation. */
  upsert?: InputMaybe<MetadataDateCreatedNestedUpsertArchiveCreateInput>;
};

export type MetadataDateCreatedNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.archive" relation. */
  update?: InputMaybe<MetadataDateCreatedNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.archive" relation. */
  upsert?: InputMaybe<MetadataDateCreatedNestedUpsertArchiveUpdateInput>;
};

export type MetadataDateCreatedNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDateCreated" node, through the "MetadataDateCreated.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDateCreated" node, through the "MetadataDateCreated.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDateCreated" node, through the "MetadataDateCreated.metadata" relation. */
  update?: InputMaybe<MetadataDateCreatedNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDateCreated" node, through the "MetadataDateCreated.metadata" relation. */
  upsert?: InputMaybe<MetadataDateCreatedNestedUpsertMetadataCreateInput>;
};

export type MetadataDateCreatedNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.metadata" relation. */
  update?: InputMaybe<MetadataDateCreatedNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.metadata" relation. */
  upsert?: InputMaybe<MetadataDateCreatedNestedUpsertMetadataUpdateInput>;
};

export type MetadataDateCreatedNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDateCreated" node, through the "MetadataDateCreated.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDateCreated" node, through the "MetadataDateCreated.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDateCreated" node, through the "MetadataDateCreated.photo" relation. */
  update?: InputMaybe<MetadataDateCreatedNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDateCreated" node, through the "MetadataDateCreated.photo" relation. */
  upsert?: InputMaybe<MetadataDateCreatedNestedUpsertPhotoCreateInput>;
};

export type MetadataDateCreatedNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.photo" relation. */
  update?: InputMaybe<MetadataDateCreatedNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDateCreated" node, through the "MetadataDateCreated.photo" relation. */
  upsert?: InputMaybe<MetadataDateCreatedNestedUpsertPhotoUpdateInput>;
};

export type MetadataDateCreatedNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDateCreatedNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDateCreatedOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDateCreatedUpdateInput = {
  /** Actions for the "MetadataDateCreated.archive" relation */
  archive?: InputMaybe<MetadataDateCreatedNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDateCreated.metadata" relation */
  metadata?: InputMaybe<MetadataDateCreatedNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDateCreated.photo" relation */
  photo?: InputMaybe<MetadataDateCreatedNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDateCreated" nodes by specifying some conditions */
export type MetadataDateCreatedWhereInput = {
  AND?: InputMaybe<Array<MetadataDateCreatedWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDateCreatedWhereInput>;
  OR?: InputMaybe<Array<MetadataDateCreatedWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDateCreated" node. */
export type MetadataDateCreatedWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDateCreatedWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDateCreated.metadata" relation */
  metadata: MetadataDateCreatedNestedMetadataCreateInput;
  /** Actions for the "MetadataDateCreated.photo" relation */
  photo: MetadataDateCreatedNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateCreatedWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDateCreated.metadata" relation */
  metadata?: InputMaybe<MetadataDateCreatedNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDateCreated.photo" relation */
  photo?: InputMaybe<MetadataDateCreatedNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateCreatedWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDateCreated.archive" relation */
  archive: MetadataDateCreatedNestedArchiveCreateInput;
  /** Actions for the "MetadataDateCreated.photo" relation */
  photo: MetadataDateCreatedNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateCreatedWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDateCreated.archive" relation */
  archive?: InputMaybe<MetadataDateCreatedNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDateCreated.photo" relation */
  photo?: InputMaybe<MetadataDateCreatedNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateCreatedWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDateCreated.archive" relation */
  archive: MetadataDateCreatedNestedArchiveCreateInput;
  /** Actions for the "MetadataDateCreated.metadata" relation */
  metadata: MetadataDateCreatedNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateCreatedWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDateCreated.archive" relation */
  archive?: InputMaybe<MetadataDateCreatedNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDateCreated.metadata" relation */
  metadata?: InputMaybe<MetadataDateCreatedNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDateTimeOriginal" resource's node */
export type MetadataDateTimeOriginal = {
  __typename?: 'MetadataDateTimeOriginal';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDateTimeOriginalCreateInput = {
  /** Actions for the "MetadataDateTimeOriginal.archive" relation */
  archive: MetadataDateTimeOriginalNestedArchiveCreateInput;
  /** Actions for the "MetadataDateTimeOriginal.metadata" relation */
  metadata: MetadataDateTimeOriginalNestedMetadataCreateInput;
  /** Actions for the "MetadataDateTimeOriginal.photo" relation */
  photo: MetadataDateTimeOriginalNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateTimeOriginalNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.archive" relation. */
  update?: InputMaybe<MetadataDateTimeOriginalNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.archive" relation. */
  upsert?: InputMaybe<MetadataDateTimeOriginalNestedUpsertArchiveCreateInput>;
};

export type MetadataDateTimeOriginalNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.archive" relation. */
  update?: InputMaybe<MetadataDateTimeOriginalNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.archive" relation. */
  upsert?: InputMaybe<MetadataDateTimeOriginalNestedUpsertArchiveUpdateInput>;
};

export type MetadataDateTimeOriginalNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.metadata" relation. */
  update?: InputMaybe<MetadataDateTimeOriginalNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.metadata" relation. */
  upsert?: InputMaybe<MetadataDateTimeOriginalNestedUpsertMetadataCreateInput>;
};

export type MetadataDateTimeOriginalNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.metadata" relation. */
  update?: InputMaybe<MetadataDateTimeOriginalNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.metadata" relation. */
  upsert?: InputMaybe<MetadataDateTimeOriginalNestedUpsertMetadataUpdateInput>;
};

export type MetadataDateTimeOriginalNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.photo" relation. */
  update?: InputMaybe<MetadataDateTimeOriginalNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.photo" relation. */
  upsert?: InputMaybe<MetadataDateTimeOriginalNestedUpsertPhotoCreateInput>;
};

export type MetadataDateTimeOriginalNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.photo" relation. */
  update?: InputMaybe<MetadataDateTimeOriginalNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDateTimeOriginal" node, through the "MetadataDateTimeOriginal.photo" relation. */
  upsert?: InputMaybe<MetadataDateTimeOriginalNestedUpsertPhotoUpdateInput>;
};

export type MetadataDateTimeOriginalNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDateTimeOriginalNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDateTimeOriginalOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDateTimeOriginalUpdateInput = {
  /** Actions for the "MetadataDateTimeOriginal.archive" relation */
  archive?: InputMaybe<MetadataDateTimeOriginalNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDateTimeOriginal.metadata" relation */
  metadata?: InputMaybe<MetadataDateTimeOriginalNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDateTimeOriginal.photo" relation */
  photo?: InputMaybe<MetadataDateTimeOriginalNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDateTimeOriginal" nodes by specifying some conditions */
export type MetadataDateTimeOriginalWhereInput = {
  AND?: InputMaybe<Array<MetadataDateTimeOriginalWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
  OR?: InputMaybe<Array<MetadataDateTimeOriginalWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDateTimeOriginal" node. */
export type MetadataDateTimeOriginalWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDateTimeOriginalWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDateTimeOriginal.metadata" relation */
  metadata: MetadataDateTimeOriginalNestedMetadataCreateInput;
  /** Actions for the "MetadataDateTimeOriginal.photo" relation */
  photo: MetadataDateTimeOriginalNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateTimeOriginalWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDateTimeOriginal.metadata" relation */
  metadata?: InputMaybe<MetadataDateTimeOriginalNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDateTimeOriginal.photo" relation */
  photo?: InputMaybe<MetadataDateTimeOriginalNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateTimeOriginalWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDateTimeOriginal.archive" relation */
  archive: MetadataDateTimeOriginalNestedArchiveCreateInput;
  /** Actions for the "MetadataDateTimeOriginal.photo" relation */
  photo: MetadataDateTimeOriginalNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateTimeOriginalWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDateTimeOriginal.archive" relation */
  archive?: InputMaybe<MetadataDateTimeOriginalNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDateTimeOriginal.photo" relation */
  photo?: InputMaybe<MetadataDateTimeOriginalNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateTimeOriginalWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDateTimeOriginal.archive" relation */
  archive: MetadataDateTimeOriginalNestedArchiveCreateInput;
  /** Actions for the "MetadataDateTimeOriginal.metadata" relation */
  metadata: MetadataDateTimeOriginalNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDateTimeOriginalWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDateTimeOriginal.archive" relation */
  archive?: InputMaybe<MetadataDateTimeOriginalNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDateTimeOriginal.metadata" relation */
  metadata?: InputMaybe<MetadataDateTimeOriginalNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryAccount" resource's node */
export type MetadataDeliveryAccount = {
  __typename?: 'MetadataDeliveryAccount';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryAccountCreateInput = {
  /** Actions for the "MetadataDeliveryAccount.archive" relation */
  archive: MetadataDeliveryAccountNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryAccount.metadata" relation */
  metadata: MetadataDeliveryAccountNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryAccount.photo" relation */
  photo: MetadataDeliveryAccountNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryAccountNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.archive" relation. */
  update?: InputMaybe<MetadataDeliveryAccountNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryAccountNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryAccountNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.archive" relation. */
  update?: InputMaybe<MetadataDeliveryAccountNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryAccountNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryAccountNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryAccountNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryAccountNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryAccountNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryAccountNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryAccountNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryAccountNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.photo" relation. */
  update?: InputMaybe<MetadataDeliveryAccountNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryAccountNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryAccountNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.photo" relation. */
  update?: InputMaybe<MetadataDeliveryAccountNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryAccount" node, through the "MetadataDeliveryAccount.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryAccountNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryAccountNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryAccountNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryAccountOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryAccountUpdateInput = {
  /** Actions for the "MetadataDeliveryAccount.archive" relation */
  archive?: InputMaybe<MetadataDeliveryAccountNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryAccount.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryAccountNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryAccount.photo" relation */
  photo?: InputMaybe<MetadataDeliveryAccountNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryAccount" nodes by specifying some conditions */
export type MetadataDeliveryAccountWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryAccountWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryAccountWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryAccountWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryAccount" node. */
export type MetadataDeliveryAccountWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryAccountWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryAccount.metadata" relation */
  metadata: MetadataDeliveryAccountNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryAccount.photo" relation */
  photo: MetadataDeliveryAccountNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryAccountWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryAccount.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryAccountNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryAccount.photo" relation */
  photo?: InputMaybe<MetadataDeliveryAccountNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryAccountWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryAccount.archive" relation */
  archive: MetadataDeliveryAccountNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryAccount.photo" relation */
  photo: MetadataDeliveryAccountNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryAccountWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryAccount.archive" relation */
  archive?: InputMaybe<MetadataDeliveryAccountNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryAccount.photo" relation */
  photo?: InputMaybe<MetadataDeliveryAccountNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryAccountWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryAccount.archive" relation */
  archive: MetadataDeliveryAccountNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryAccount.metadata" relation */
  metadata: MetadataDeliveryAccountNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryAccountWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryAccount.archive" relation */
  archive?: InputMaybe<MetadataDeliveryAccountNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryAccount.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryAccountNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryCompany" resource's node */
export type MetadataDeliveryCompany = {
  __typename?: 'MetadataDeliveryCompany';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryCompanyCreateInput = {
  /** Actions for the "MetadataDeliveryCompany.archive" relation */
  archive: MetadataDeliveryCompanyNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryCompany.metadata" relation */
  metadata: MetadataDeliveryCompanyNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryCompany.photo" relation */
  photo: MetadataDeliveryCompanyNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCompanyNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.archive" relation. */
  update?: InputMaybe<MetadataDeliveryCompanyNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryCompanyNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryCompanyNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.archive" relation. */
  update?: InputMaybe<MetadataDeliveryCompanyNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryCompanyNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryCompanyNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryCompanyNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryCompanyNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryCompanyNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryCompanyNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryCompanyNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryCompanyNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.photo" relation. */
  update?: InputMaybe<MetadataDeliveryCompanyNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryCompanyNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryCompanyNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.photo" relation. */
  update?: InputMaybe<MetadataDeliveryCompanyNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryCompany" node, through the "MetadataDeliveryCompany.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryCompanyNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryCompanyNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryCompanyNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryCompanyOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryCompanyUpdateInput = {
  /** Actions for the "MetadataDeliveryCompany.archive" relation */
  archive?: InputMaybe<MetadataDeliveryCompanyNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryCompany.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryCompanyNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryCompany.photo" relation */
  photo?: InputMaybe<MetadataDeliveryCompanyNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryCompany" nodes by specifying some conditions */
export type MetadataDeliveryCompanyWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryCompanyWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryCompanyWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryCompany" node. */
export type MetadataDeliveryCompanyWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryCompanyWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryCompany.metadata" relation */
  metadata: MetadataDeliveryCompanyNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryCompany.photo" relation */
  photo: MetadataDeliveryCompanyNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCompanyWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryCompany.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryCompanyNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryCompany.photo" relation */
  photo?: InputMaybe<MetadataDeliveryCompanyNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCompanyWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryCompany.archive" relation */
  archive: MetadataDeliveryCompanyNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryCompany.photo" relation */
  photo: MetadataDeliveryCompanyNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCompanyWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryCompany.archive" relation */
  archive?: InputMaybe<MetadataDeliveryCompanyNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryCompany.photo" relation */
  photo?: InputMaybe<MetadataDeliveryCompanyNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCompanyWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryCompany.archive" relation */
  archive: MetadataDeliveryCompanyNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryCompany.metadata" relation */
  metadata: MetadataDeliveryCompanyNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCompanyWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryCompany.archive" relation */
  archive?: InputMaybe<MetadataDeliveryCompanyNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryCompany.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryCompanyNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryCopyright" resource's node */
export type MetadataDeliveryCopyright = {
  __typename?: 'MetadataDeliveryCopyright';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryCopyrightCreateInput = {
  /** Actions for the "MetadataDeliveryCopyright.archive" relation */
  archive: MetadataDeliveryCopyrightNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryCopyright.metadata" relation */
  metadata: MetadataDeliveryCopyrightNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryCopyright.photo" relation */
  photo: MetadataDeliveryCopyrightNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCopyrightNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.archive" relation. */
  update?: InputMaybe<MetadataDeliveryCopyrightNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryCopyrightNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryCopyrightNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.archive" relation. */
  update?: InputMaybe<MetadataDeliveryCopyrightNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryCopyrightNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryCopyrightNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryCopyrightNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryCopyrightNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryCopyrightNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryCopyrightNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryCopyrightNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryCopyrightNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.photo" relation. */
  update?: InputMaybe<MetadataDeliveryCopyrightNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryCopyrightNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryCopyrightNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.photo" relation. */
  update?: InputMaybe<MetadataDeliveryCopyrightNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryCopyright" node, through the "MetadataDeliveryCopyright.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryCopyrightNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryCopyrightNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryCopyrightNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryCopyrightOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryCopyrightUpdateInput = {
  /** Actions for the "MetadataDeliveryCopyright.archive" relation */
  archive?: InputMaybe<MetadataDeliveryCopyrightNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryCopyright.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryCopyrightNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryCopyright.photo" relation */
  photo?: InputMaybe<MetadataDeliveryCopyrightNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryCopyright" nodes by specifying some conditions */
export type MetadataDeliveryCopyrightWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryCopyrightWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryCopyrightWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryCopyright" node. */
export type MetadataDeliveryCopyrightWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryCopyrightWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryCopyright.metadata" relation */
  metadata: MetadataDeliveryCopyrightNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryCopyright.photo" relation */
  photo: MetadataDeliveryCopyrightNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCopyrightWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryCopyright.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryCopyrightNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryCopyright.photo" relation */
  photo?: InputMaybe<MetadataDeliveryCopyrightNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCopyrightWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryCopyright.archive" relation */
  archive: MetadataDeliveryCopyrightNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryCopyright.photo" relation */
  photo: MetadataDeliveryCopyrightNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCopyrightWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryCopyright.archive" relation */
  archive?: InputMaybe<MetadataDeliveryCopyrightNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryCopyright.photo" relation */
  photo?: InputMaybe<MetadataDeliveryCopyrightNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCopyrightWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryCopyright.archive" relation */
  archive: MetadataDeliveryCopyrightNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryCopyright.metadata" relation */
  metadata: MetadataDeliveryCopyrightNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryCopyrightWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryCopyright.archive" relation */
  archive?: InputMaybe<MetadataDeliveryCopyrightNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryCopyright.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryCopyrightNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryDateFolder" resource's node */
export type MetadataDeliveryDateFolder = {
  __typename?: 'MetadataDeliveryDateFolder';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryDateFolderCreateInput = {
  /** Actions for the "MetadataDeliveryDateFolder.archive" relation */
  archive: MetadataDeliveryDateFolderNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDateFolder.metadata" relation */
  metadata: MetadataDeliveryDateFolderNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryDateFolder.photo" relation */
  photo: MetadataDeliveryDateFolderNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateFolderNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.archive" relation. */
  update?: InputMaybe<MetadataDeliveryDateFolderNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateFolderNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryDateFolderNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.archive" relation. */
  update?: InputMaybe<MetadataDeliveryDateFolderNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateFolderNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryDateFolderNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryDateFolderNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateFolderNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryDateFolderNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryDateFolderNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateFolderNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryDateFolderNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.photo" relation. */
  update?: InputMaybe<MetadataDeliveryDateFolderNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateFolderNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryDateFolderNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.photo" relation. */
  update?: InputMaybe<MetadataDeliveryDateFolderNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryDateFolder" node, through the "MetadataDeliveryDateFolder.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateFolderNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryDateFolderNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDateFolderNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryDateFolderOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryDateFolderUpdateInput = {
  /** Actions for the "MetadataDeliveryDateFolder.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDateFolderNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDateFolder.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDateFolderNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryDateFolder.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDateFolderNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryDateFolder" nodes by specifying some conditions */
export type MetadataDeliveryDateFolderWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryDateFolderWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryDateFolderWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryDateFolder" node. */
export type MetadataDeliveryDateFolderWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryDateFolderWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryDateFolder.metadata" relation */
  metadata: MetadataDeliveryDateFolderNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryDateFolder.photo" relation */
  photo: MetadataDeliveryDateFolderNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateFolderWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryDateFolder.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDateFolderNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryDateFolder.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDateFolderNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateFolderWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryDateFolder.archive" relation */
  archive: MetadataDeliveryDateFolderNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDateFolder.photo" relation */
  photo: MetadataDeliveryDateFolderNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateFolderWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryDateFolder.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDateFolderNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDateFolder.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDateFolderNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateFolderWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryDateFolder.archive" relation */
  archive: MetadataDeliveryDateFolderNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDateFolder.metadata" relation */
  metadata: MetadataDeliveryDateFolderNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateFolderWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryDateFolder.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDateFolderNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDateFolder.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDateFolderNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryDateTime" resource's node */
export type MetadataDeliveryDateTime = {
  __typename?: 'MetadataDeliveryDateTime';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryDateTimeCreateInput = {
  /** Actions for the "MetadataDeliveryDateTime.archive" relation */
  archive: MetadataDeliveryDateTimeNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDateTime.metadata" relation */
  metadata: MetadataDeliveryDateTimeNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryDateTime.photo" relation */
  photo: MetadataDeliveryDateTimeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateTimeNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.archive" relation. */
  update?: InputMaybe<MetadataDeliveryDateTimeNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateTimeNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryDateTimeNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.archive" relation. */
  update?: InputMaybe<MetadataDeliveryDateTimeNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateTimeNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryDateTimeNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryDateTimeNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateTimeNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryDateTimeNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryDateTimeNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateTimeNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryDateTimeNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.photo" relation. */
  update?: InputMaybe<MetadataDeliveryDateTimeNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateTimeNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryDateTimeNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.photo" relation. */
  update?: InputMaybe<MetadataDeliveryDateTimeNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryDateTime" node, through the "MetadataDeliveryDateTime.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryDateTimeNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryDateTimeNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDateTimeNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryDateTimeOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryDateTimeUpdateInput = {
  /** Actions for the "MetadataDeliveryDateTime.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDateTimeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDateTime.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDateTimeNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryDateTime.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDateTimeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryDateTime" nodes by specifying some conditions */
export type MetadataDeliveryDateTimeWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryDateTimeWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryDateTimeWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryDateTime" node. */
export type MetadataDeliveryDateTimeWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryDateTimeWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryDateTime.metadata" relation */
  metadata: MetadataDeliveryDateTimeNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryDateTime.photo" relation */
  photo: MetadataDeliveryDateTimeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateTimeWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryDateTime.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDateTimeNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryDateTime.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDateTimeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateTimeWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryDateTime.archive" relation */
  archive: MetadataDeliveryDateTimeNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDateTime.photo" relation */
  photo: MetadataDeliveryDateTimeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateTimeWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryDateTime.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDateTimeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDateTime.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDateTimeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateTimeWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryDateTime.archive" relation */
  archive: MetadataDeliveryDateTimeNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDateTime.metadata" relation */
  metadata: MetadataDeliveryDateTimeNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDateTimeWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryDateTime.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDateTimeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDateTime.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDateTimeNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryDcCreator" resource's node */
export type MetadataDeliveryDcCreator = {
  __typename?: 'MetadataDeliveryDcCreator';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryDcCreatorCreateInput = {
  /** Actions for the "MetadataDeliveryDcCreator.archive" relation */
  archive: MetadataDeliveryDcCreatorNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDcCreator.metadata" relation */
  metadata: MetadataDeliveryDcCreatorNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryDcCreator.photo" relation */
  photo: MetadataDeliveryDcCreatorNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcCreatorNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.archive" relation. */
  update?: InputMaybe<MetadataDeliveryDcCreatorNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcCreatorNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryDcCreatorNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.archive" relation. */
  update?: InputMaybe<MetadataDeliveryDcCreatorNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcCreatorNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryDcCreatorNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryDcCreatorNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcCreatorNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryDcCreatorNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryDcCreatorNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcCreatorNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryDcCreatorNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.photo" relation. */
  update?: InputMaybe<MetadataDeliveryDcCreatorNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcCreatorNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryDcCreatorNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.photo" relation. */
  update?: InputMaybe<MetadataDeliveryDcCreatorNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryDcCreator" node, through the "MetadataDeliveryDcCreator.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcCreatorNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryDcCreatorNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDcCreatorNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryDcCreatorOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryDcCreatorUpdateInput = {
  /** Actions for the "MetadataDeliveryDcCreator.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDcCreatorNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDcCreator.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDcCreatorNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryDcCreator.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDcCreatorNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryDcCreator" nodes by specifying some conditions */
export type MetadataDeliveryDcCreatorWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryDcCreator" node. */
export type MetadataDeliveryDcCreatorWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryDcCreatorWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryDcCreator.metadata" relation */
  metadata: MetadataDeliveryDcCreatorNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryDcCreator.photo" relation */
  photo: MetadataDeliveryDcCreatorNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcCreatorWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryDcCreator.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDcCreatorNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryDcCreator.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDcCreatorNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcCreatorWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryDcCreator.archive" relation */
  archive: MetadataDeliveryDcCreatorNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDcCreator.photo" relation */
  photo: MetadataDeliveryDcCreatorNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcCreatorWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryDcCreator.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDcCreatorNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDcCreator.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDcCreatorNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcCreatorWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryDcCreator.archive" relation */
  archive: MetadataDeliveryDcCreatorNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDcCreator.metadata" relation */
  metadata: MetadataDeliveryDcCreatorNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcCreatorWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryDcCreator.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDcCreatorNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDcCreator.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDcCreatorNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryDcRights" resource's node */
export type MetadataDeliveryDcRights = {
  __typename?: 'MetadataDeliveryDcRights';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryDcRightsCreateInput = {
  /** Actions for the "MetadataDeliveryDcRights.archive" relation */
  archive: MetadataDeliveryDcRightsNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDcRights.metadata" relation */
  metadata: MetadataDeliveryDcRightsNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryDcRights.photo" relation */
  photo: MetadataDeliveryDcRightsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcRightsNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.archive" relation. */
  update?: InputMaybe<MetadataDeliveryDcRightsNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcRightsNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryDcRightsNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.archive" relation. */
  update?: InputMaybe<MetadataDeliveryDcRightsNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcRightsNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryDcRightsNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryDcRightsNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcRightsNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryDcRightsNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryDcRightsNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcRightsNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryDcRightsNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.photo" relation. */
  update?: InputMaybe<MetadataDeliveryDcRightsNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcRightsNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryDcRightsNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.photo" relation. */
  update?: InputMaybe<MetadataDeliveryDcRightsNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryDcRights" node, through the "MetadataDeliveryDcRights.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryDcRightsNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryDcRightsNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryDcRightsNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryDcRightsOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryDcRightsUpdateInput = {
  /** Actions for the "MetadataDeliveryDcRights.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDcRightsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDcRights.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDcRightsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryDcRights.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDcRightsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryDcRights" nodes by specifying some conditions */
export type MetadataDeliveryDcRightsWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryDcRightsWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryDcRightsWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryDcRights" node. */
export type MetadataDeliveryDcRightsWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryDcRightsWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryDcRights.metadata" relation */
  metadata: MetadataDeliveryDcRightsNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryDcRights.photo" relation */
  photo: MetadataDeliveryDcRightsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcRightsWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryDcRights.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDcRightsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryDcRights.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDcRightsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcRightsWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryDcRights.archive" relation */
  archive: MetadataDeliveryDcRightsNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDcRights.photo" relation */
  photo: MetadataDeliveryDcRightsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcRightsWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryDcRights.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDcRightsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDcRights.photo" relation */
  photo?: InputMaybe<MetadataDeliveryDcRightsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcRightsWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryDcRights.archive" relation */
  archive: MetadataDeliveryDcRightsNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryDcRights.metadata" relation */
  metadata: MetadataDeliveryDcRightsNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryDcRightsWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryDcRights.archive" relation */
  archive?: InputMaybe<MetadataDeliveryDcRightsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryDcRights.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryDcRightsNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryFolder" resource's node */
export type MetadataDeliveryFolder = {
  __typename?: 'MetadataDeliveryFolder';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryFolderCreateInput = {
  /** Actions for the "MetadataDeliveryFolder.archive" relation */
  archive: MetadataDeliveryFolderNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryFolder.metadata" relation */
  metadata: MetadataDeliveryFolderNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryFolder.photo" relation */
  photo: MetadataDeliveryFolderNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryFolderNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.archive" relation. */
  update?: InputMaybe<MetadataDeliveryFolderNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryFolderNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryFolderNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.archive" relation. */
  update?: InputMaybe<MetadataDeliveryFolderNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryFolderNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryFolderNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryFolderNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryFolderNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryFolderNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryFolderNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryFolderNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryFolderNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.photo" relation. */
  update?: InputMaybe<MetadataDeliveryFolderNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryFolderNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryFolderNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.photo" relation. */
  update?: InputMaybe<MetadataDeliveryFolderNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryFolder" node, through the "MetadataDeliveryFolder.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryFolderNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryFolderNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryFolderNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryFolderOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryFolderUpdateInput = {
  /** Actions for the "MetadataDeliveryFolder.archive" relation */
  archive?: InputMaybe<MetadataDeliveryFolderNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryFolder.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryFolderNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryFolder.photo" relation */
  photo?: InputMaybe<MetadataDeliveryFolderNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryFolder" nodes by specifying some conditions */
export type MetadataDeliveryFolderWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryFolderWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryFolderWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryFolderWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryFolder" node. */
export type MetadataDeliveryFolderWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryFolderWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryFolder.metadata" relation */
  metadata: MetadataDeliveryFolderNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryFolder.photo" relation */
  photo: MetadataDeliveryFolderNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryFolderWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryFolder.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryFolderNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryFolder.photo" relation */
  photo?: InputMaybe<MetadataDeliveryFolderNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryFolderWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryFolder.archive" relation */
  archive: MetadataDeliveryFolderNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryFolder.photo" relation */
  photo: MetadataDeliveryFolderNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryFolderWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryFolder.archive" relation */
  archive?: InputMaybe<MetadataDeliveryFolderNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryFolder.photo" relation */
  photo?: InputMaybe<MetadataDeliveryFolderNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryFolderWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryFolder.archive" relation */
  archive: MetadataDeliveryFolderNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryFolder.metadata" relation */
  metadata: MetadataDeliveryFolderNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryFolderWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryFolder.archive" relation */
  archive?: InputMaybe<MetadataDeliveryFolderNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryFolder.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryFolderNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryKind" resource's node */
export type MetadataDeliveryKind = {
  __typename?: 'MetadataDeliveryKind';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryKindCreateInput = {
  /** Actions for the "MetadataDeliveryKind.archive" relation */
  archive: MetadataDeliveryKindNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryKind.metadata" relation */
  metadata: MetadataDeliveryKindNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryKind.photo" relation */
  photo: MetadataDeliveryKindNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryKindNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.archive" relation. */
  update?: InputMaybe<MetadataDeliveryKindNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryKindNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryKindNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.archive" relation. */
  update?: InputMaybe<MetadataDeliveryKindNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryKindNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryKindNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryKindNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryKindNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryKindNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryKindNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryKindNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryKindNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.photo" relation. */
  update?: InputMaybe<MetadataDeliveryKindNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryKindNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryKindNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.photo" relation. */
  update?: InputMaybe<MetadataDeliveryKindNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryKind" node, through the "MetadataDeliveryKind.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryKindNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryKindNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryKindNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryKindOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryKindUpdateInput = {
  /** Actions for the "MetadataDeliveryKind.archive" relation */
  archive?: InputMaybe<MetadataDeliveryKindNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryKind.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryKindNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryKind.photo" relation */
  photo?: InputMaybe<MetadataDeliveryKindNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryKind" nodes by specifying some conditions */
export type MetadataDeliveryKindWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryKindWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryKindWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryKindWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryKind" node. */
export type MetadataDeliveryKindWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryKindWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryKind.metadata" relation */
  metadata: MetadataDeliveryKindNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryKind.photo" relation */
  photo: MetadataDeliveryKindNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryKindWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryKind.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryKindNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryKind.photo" relation */
  photo?: InputMaybe<MetadataDeliveryKindNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryKindWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryKind.archive" relation */
  archive: MetadataDeliveryKindNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryKind.photo" relation */
  photo: MetadataDeliveryKindNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryKindWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryKind.archive" relation */
  archive?: InputMaybe<MetadataDeliveryKindNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryKind.photo" relation */
  photo?: InputMaybe<MetadataDeliveryKindNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryKindWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryKind.archive" relation */
  archive: MetadataDeliveryKindNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryKind.metadata" relation */
  metadata: MetadataDeliveryKindNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryKindWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryKind.archive" relation */
  archive?: InputMaybe<MetadataDeliveryKindNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryKind.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryKindNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryPath" resource's node */
export type MetadataDeliveryPath = {
  __typename?: 'MetadataDeliveryPath';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryPathCreateInput = {
  /** Actions for the "MetadataDeliveryPath.archive" relation */
  archive: MetadataDeliveryPathNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryPath.metadata" relation */
  metadata: MetadataDeliveryPathNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryPath.photo" relation */
  photo: MetadataDeliveryPathNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPathNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.archive" relation. */
  update?: InputMaybe<MetadataDeliveryPathNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryPathNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryPathNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.archive" relation. */
  update?: InputMaybe<MetadataDeliveryPathNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryPathNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryPathNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryPathNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryPathNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryPathNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryPathNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryPathNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryPathNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.photo" relation. */
  update?: InputMaybe<MetadataDeliveryPathNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryPathNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryPathNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.photo" relation. */
  update?: InputMaybe<MetadataDeliveryPathNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryPath" node, through the "MetadataDeliveryPath.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryPathNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryPathNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryPathNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryPathOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryPathUpdateInput = {
  /** Actions for the "MetadataDeliveryPath.archive" relation */
  archive?: InputMaybe<MetadataDeliveryPathNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryPath.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryPathNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryPath.photo" relation */
  photo?: InputMaybe<MetadataDeliveryPathNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryPath" nodes by specifying some conditions */
export type MetadataDeliveryPathWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryPathWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryPathWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryPathWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryPath" node. */
export type MetadataDeliveryPathWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryPathWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryPath.metadata" relation */
  metadata: MetadataDeliveryPathNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryPath.photo" relation */
  photo: MetadataDeliveryPathNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPathWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryPath.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryPathNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryPath.photo" relation */
  photo?: InputMaybe<MetadataDeliveryPathNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPathWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryPath.archive" relation */
  archive: MetadataDeliveryPathNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryPath.photo" relation */
  photo: MetadataDeliveryPathNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPathWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryPath.archive" relation */
  archive?: InputMaybe<MetadataDeliveryPathNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryPath.photo" relation */
  photo?: InputMaybe<MetadataDeliveryPathNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPathWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryPath.archive" relation */
  archive: MetadataDeliveryPathNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryPath.metadata" relation */
  metadata: MetadataDeliveryPathNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPathWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryPath.archive" relation */
  archive?: InputMaybe<MetadataDeliveryPathNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryPath.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryPathNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryPhotoshopCredit" resource's node */
export type MetadataDeliveryPhotoshopCredit = {
  __typename?: 'MetadataDeliveryPhotoshopCredit';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryPhotoshopCreditCreateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopCredit.archive" relation */
  archive: MetadataDeliveryPhotoshopCreditNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryPhotoshopCredit.metadata" relation */
  metadata: MetadataDeliveryPhotoshopCreditNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryPhotoshopCredit.photo" relation */
  photo: MetadataDeliveryPhotoshopCreditNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopCreditNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.archive" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryPhotoshopCreditNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.archive" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryPhotoshopCreditNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryPhotoshopCreditNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryPhotoshopCreditNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.photo" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryPhotoshopCreditNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.photo" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryPhotoshopCredit" node, through the "MetadataDeliveryPhotoshopCredit.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryPhotoshopCreditNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopCreditNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryPhotoshopCreditOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryPhotoshopCreditUpdateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopCredit.archive" relation */
  archive?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryPhotoshopCredit.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryPhotoshopCredit.photo" relation */
  photo?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryPhotoshopCredit" nodes by specifying some conditions */
export type MetadataDeliveryPhotoshopCreditWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryPhotoshopCredit" node. */
export type MetadataDeliveryPhotoshopCreditWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryPhotoshopCreditWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopCredit.metadata" relation */
  metadata: MetadataDeliveryPhotoshopCreditNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryPhotoshopCredit.photo" relation */
  photo: MetadataDeliveryPhotoshopCreditNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopCreditWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopCredit.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryPhotoshopCredit.photo" relation */
  photo?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopCreditWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopCredit.archive" relation */
  archive: MetadataDeliveryPhotoshopCreditNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryPhotoshopCredit.photo" relation */
  photo: MetadataDeliveryPhotoshopCreditNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopCreditWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopCredit.archive" relation */
  archive?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryPhotoshopCredit.photo" relation */
  photo?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopCreditWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopCredit.archive" relation */
  archive: MetadataDeliveryPhotoshopCreditNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryPhotoshopCredit.metadata" relation */
  metadata: MetadataDeliveryPhotoshopCreditNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopCreditWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopCredit.archive" relation */
  archive?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryPhotoshopCredit.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryPhotoshopCreditNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryPhotoshopSource" resource's node */
export type MetadataDeliveryPhotoshopSource = {
  __typename?: 'MetadataDeliveryPhotoshopSource';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryPhotoshopSourceCreateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopSource.archive" relation */
  archive: MetadataDeliveryPhotoshopSourceNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryPhotoshopSource.metadata" relation */
  metadata: MetadataDeliveryPhotoshopSourceNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryPhotoshopSource.photo" relation */
  photo: MetadataDeliveryPhotoshopSourceNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopSourceNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.archive" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryPhotoshopSourceNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.archive" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryPhotoshopSourceNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryPhotoshopSourceNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryPhotoshopSourceNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.photo" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryPhotoshopSourceNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.photo" relation. */
  update?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryPhotoshopSource" node, through the "MetadataDeliveryPhotoshopSource.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryPhotoshopSourceNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryPhotoshopSourceNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryPhotoshopSourceOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryPhotoshopSourceUpdateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopSource.archive" relation */
  archive?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryPhotoshopSource.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryPhotoshopSource.photo" relation */
  photo?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryPhotoshopSource" nodes by specifying some conditions */
export type MetadataDeliveryPhotoshopSourceWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryPhotoshopSource" node. */
export type MetadataDeliveryPhotoshopSourceWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryPhotoshopSourceWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopSource.metadata" relation */
  metadata: MetadataDeliveryPhotoshopSourceNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryPhotoshopSource.photo" relation */
  photo: MetadataDeliveryPhotoshopSourceNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopSourceWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopSource.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryPhotoshopSource.photo" relation */
  photo?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopSourceWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopSource.archive" relation */
  archive: MetadataDeliveryPhotoshopSourceNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryPhotoshopSource.photo" relation */
  photo: MetadataDeliveryPhotoshopSourceNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopSourceWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopSource.archive" relation */
  archive?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryPhotoshopSource.photo" relation */
  photo?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopSourceWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopSource.archive" relation */
  archive: MetadataDeliveryPhotoshopSourceNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryPhotoshopSource.metadata" relation */
  metadata: MetadataDeliveryPhotoshopSourceNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryPhotoshopSourceWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryPhotoshopSource.archive" relation */
  archive?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryPhotoshopSource.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryPhotoshopSourceNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryService" resource's node */
export type MetadataDeliveryService = {
  __typename?: 'MetadataDeliveryService';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryServiceCreateInput = {
  /** Actions for the "MetadataDeliveryService.archive" relation */
  archive: MetadataDeliveryServiceNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryService.metadata" relation */
  metadata: MetadataDeliveryServiceNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryService.photo" relation */
  photo: MetadataDeliveryServiceNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryServiceNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.archive" relation. */
  update?: InputMaybe<MetadataDeliveryServiceNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryServiceNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryServiceNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.archive" relation. */
  update?: InputMaybe<MetadataDeliveryServiceNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryServiceNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryServiceNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryServiceNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryServiceNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryServiceNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryServiceNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryServiceNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryServiceNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.photo" relation. */
  update?: InputMaybe<MetadataDeliveryServiceNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryService" node, through the "MetadataDeliveryService.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryServiceNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryServiceNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.photo" relation. */
  update?: InputMaybe<MetadataDeliveryServiceNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryService" node, through the "MetadataDeliveryService.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryServiceNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryServiceNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryServiceNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryServiceOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryServiceUpdateInput = {
  /** Actions for the "MetadataDeliveryService.archive" relation */
  archive?: InputMaybe<MetadataDeliveryServiceNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryService.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryServiceNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryService.photo" relation */
  photo?: InputMaybe<MetadataDeliveryServiceNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryService" nodes by specifying some conditions */
export type MetadataDeliveryServiceWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryServiceWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryServiceWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryServiceWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryService" node. */
export type MetadataDeliveryServiceWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryServiceWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryService.metadata" relation */
  metadata: MetadataDeliveryServiceNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryService.photo" relation */
  photo: MetadataDeliveryServiceNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryServiceWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryService.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryServiceNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryService.photo" relation */
  photo?: InputMaybe<MetadataDeliveryServiceNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryServiceWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryService.archive" relation */
  archive: MetadataDeliveryServiceNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryService.photo" relation */
  photo: MetadataDeliveryServiceNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryServiceWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryService.archive" relation */
  archive?: InputMaybe<MetadataDeliveryServiceNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryService.photo" relation */
  photo?: InputMaybe<MetadataDeliveryServiceNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryServiceWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryService.archive" relation */
  archive: MetadataDeliveryServiceNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryService.metadata" relation */
  metadata: MetadataDeliveryServiceNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryServiceWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryService.archive" relation */
  archive?: InputMaybe<MetadataDeliveryServiceNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryService.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryServiceNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliverySubject" resource's node */
export type MetadataDeliverySubject = {
  __typename?: 'MetadataDeliverySubject';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliverySubjectCreateInput = {
  /** Actions for the "MetadataDeliverySubject.archive" relation */
  archive: MetadataDeliverySubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliverySubject.metadata" relation */
  metadata: MetadataDeliverySubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliverySubject.photo" relation */
  photo: MetadataDeliverySubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliverySubjectNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.archive" relation. */
  update?: InputMaybe<MetadataDeliverySubjectNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.archive" relation. */
  upsert?: InputMaybe<MetadataDeliverySubjectNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliverySubjectNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.archive" relation. */
  update?: InputMaybe<MetadataDeliverySubjectNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.archive" relation. */
  upsert?: InputMaybe<MetadataDeliverySubjectNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliverySubjectNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.metadata" relation. */
  update?: InputMaybe<MetadataDeliverySubjectNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliverySubjectNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliverySubjectNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.metadata" relation. */
  update?: InputMaybe<MetadataDeliverySubjectNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliverySubjectNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliverySubjectNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.photo" relation. */
  update?: InputMaybe<MetadataDeliverySubjectNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.photo" relation. */
  upsert?: InputMaybe<MetadataDeliverySubjectNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliverySubjectNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.photo" relation. */
  update?: InputMaybe<MetadataDeliverySubjectNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliverySubject" node, through the "MetadataDeliverySubject.photo" relation. */
  upsert?: InputMaybe<MetadataDeliverySubjectNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliverySubjectNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliverySubjectNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliverySubjectOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliverySubjectUpdateInput = {
  /** Actions for the "MetadataDeliverySubject.archive" relation */
  archive?: InputMaybe<MetadataDeliverySubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliverySubject.metadata" relation */
  metadata?: InputMaybe<MetadataDeliverySubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliverySubject.photo" relation */
  photo?: InputMaybe<MetadataDeliverySubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliverySubject" nodes by specifying some conditions */
export type MetadataDeliverySubjectWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliverySubjectWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliverySubjectWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliverySubjectWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliverySubject" node. */
export type MetadataDeliverySubjectWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliverySubjectWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliverySubject.metadata" relation */
  metadata: MetadataDeliverySubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliverySubject.photo" relation */
  photo: MetadataDeliverySubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliverySubjectWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliverySubject.metadata" relation */
  metadata?: InputMaybe<MetadataDeliverySubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliverySubject.photo" relation */
  photo?: InputMaybe<MetadataDeliverySubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliverySubjectWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliverySubject.archive" relation */
  archive: MetadataDeliverySubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliverySubject.photo" relation */
  photo: MetadataDeliverySubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliverySubjectWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliverySubject.archive" relation */
  archive?: InputMaybe<MetadataDeliverySubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliverySubject.photo" relation */
  photo?: InputMaybe<MetadataDeliverySubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliverySubjectWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliverySubject.archive" relation */
  archive: MetadataDeliverySubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliverySubject.metadata" relation */
  metadata: MetadataDeliverySubjectNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliverySubjectWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliverySubject.archive" relation */
  archive?: InputMaybe<MetadataDeliverySubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliverySubject.metadata" relation */
  metadata?: InputMaybe<MetadataDeliverySubjectNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDeliveryUnderSubject" resource's node */
export type MetadataDeliveryUnderSubject = {
  __typename?: 'MetadataDeliveryUnderSubject';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDeliveryUnderSubjectCreateInput = {
  /** Actions for the "MetadataDeliveryUnderSubject.archive" relation */
  archive: MetadataDeliveryUnderSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryUnderSubject.metadata" relation */
  metadata: MetadataDeliveryUnderSubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryUnderSubject.photo" relation */
  photo: MetadataDeliveryUnderSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryUnderSubjectNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.archive" relation. */
  update?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpsertArchiveCreateInput>;
};

export type MetadataDeliveryUnderSubjectNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.archive" relation. */
  update?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.archive" relation. */
  upsert?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpsertArchiveUpdateInput>;
};

export type MetadataDeliveryUnderSubjectNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpsertMetadataCreateInput>;
};

export type MetadataDeliveryUnderSubjectNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.metadata" relation. */
  update?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.metadata" relation. */
  upsert?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpsertMetadataUpdateInput>;
};

export type MetadataDeliveryUnderSubjectNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.photo" relation. */
  update?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpsertPhotoCreateInput>;
};

export type MetadataDeliveryUnderSubjectNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.photo" relation. */
  update?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDeliveryUnderSubject" node, through the "MetadataDeliveryUnderSubject.photo" relation. */
  upsert?: InputMaybe<MetadataDeliveryUnderSubjectNestedUpsertPhotoUpdateInput>;
};

export type MetadataDeliveryUnderSubjectNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDeliveryUnderSubjectNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDeliveryUnderSubjectOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDeliveryUnderSubjectUpdateInput = {
  /** Actions for the "MetadataDeliveryUnderSubject.archive" relation */
  archive?: InputMaybe<MetadataDeliveryUnderSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryUnderSubject.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryUnderSubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryUnderSubject.photo" relation */
  photo?: InputMaybe<MetadataDeliveryUnderSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDeliveryUnderSubject" nodes by specifying some conditions */
export type MetadataDeliveryUnderSubjectWhereInput = {
  AND?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
  OR?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDeliveryUnderSubject" node. */
export type MetadataDeliveryUnderSubjectWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDeliveryUnderSubjectWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDeliveryUnderSubject.metadata" relation */
  metadata: MetadataDeliveryUnderSubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataDeliveryUnderSubject.photo" relation */
  photo: MetadataDeliveryUnderSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryUnderSubjectWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDeliveryUnderSubject.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryUnderSubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDeliveryUnderSubject.photo" relation */
  photo?: InputMaybe<MetadataDeliveryUnderSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryUnderSubjectWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDeliveryUnderSubject.archive" relation */
  archive: MetadataDeliveryUnderSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryUnderSubject.photo" relation */
  photo: MetadataDeliveryUnderSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryUnderSubjectWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDeliveryUnderSubject.archive" relation */
  archive?: InputMaybe<MetadataDeliveryUnderSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryUnderSubject.photo" relation */
  photo?: InputMaybe<MetadataDeliveryUnderSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryUnderSubjectWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDeliveryUnderSubject.archive" relation */
  archive: MetadataDeliveryUnderSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataDeliveryUnderSubject.metadata" relation */
  metadata: MetadataDeliveryUnderSubjectNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDeliveryUnderSubjectWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDeliveryUnderSubject.archive" relation */
  archive?: InputMaybe<MetadataDeliveryUnderSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDeliveryUnderSubject.metadata" relation */
  metadata?: InputMaybe<MetadataDeliveryUnderSubjectNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDepartment" resource's node */
export type MetadataDepartment = {
  __typename?: 'MetadataDepartment';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDepartmentCreateInput = {
  /** Actions for the "MetadataDepartment.archive" relation */
  archive: MetadataDepartmentNestedArchiveCreateInput;
  /** Actions for the "MetadataDepartment.metadata" relation */
  metadata: MetadataDepartmentNestedMetadataCreateInput;
  /** Actions for the "MetadataDepartment.photo" relation */
  photo: MetadataDepartmentNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDepartmentNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDepartment" node, through the "MetadataDepartment.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDepartment" node, through the "MetadataDepartment.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDepartment" node, through the "MetadataDepartment.archive" relation. */
  update?: InputMaybe<MetadataDepartmentNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDepartment" node, through the "MetadataDepartment.archive" relation. */
  upsert?: InputMaybe<MetadataDepartmentNestedUpsertArchiveCreateInput>;
};

export type MetadataDepartmentNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDepartment" node, through the "MetadataDepartment.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDepartment" node, through the "MetadataDepartment.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDepartment" node, through the "MetadataDepartment.archive" relation. */
  update?: InputMaybe<MetadataDepartmentNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDepartment" node, through the "MetadataDepartment.archive" relation. */
  upsert?: InputMaybe<MetadataDepartmentNestedUpsertArchiveUpdateInput>;
};

export type MetadataDepartmentNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDepartment" node, through the "MetadataDepartment.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDepartment" node, through the "MetadataDepartment.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDepartment" node, through the "MetadataDepartment.metadata" relation. */
  update?: InputMaybe<MetadataDepartmentNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDepartment" node, through the "MetadataDepartment.metadata" relation. */
  upsert?: InputMaybe<MetadataDepartmentNestedUpsertMetadataCreateInput>;
};

export type MetadataDepartmentNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDepartment" node, through the "MetadataDepartment.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDepartment" node, through the "MetadataDepartment.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDepartment" node, through the "MetadataDepartment.metadata" relation. */
  update?: InputMaybe<MetadataDepartmentNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDepartment" node, through the "MetadataDepartment.metadata" relation. */
  upsert?: InputMaybe<MetadataDepartmentNestedUpsertMetadataUpdateInput>;
};

export type MetadataDepartmentNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDepartment" node, through the "MetadataDepartment.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDepartment" node, through the "MetadataDepartment.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDepartment" node, through the "MetadataDepartment.photo" relation. */
  update?: InputMaybe<MetadataDepartmentNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDepartment" node, through the "MetadataDepartment.photo" relation. */
  upsert?: InputMaybe<MetadataDepartmentNestedUpsertPhotoCreateInput>;
};

export type MetadataDepartmentNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDepartment" node, through the "MetadataDepartment.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDepartment" node, through the "MetadataDepartment.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDepartment" node, through the "MetadataDepartment.photo" relation. */
  update?: InputMaybe<MetadataDepartmentNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDepartment" node, through the "MetadataDepartment.photo" relation. */
  upsert?: InputMaybe<MetadataDepartmentNestedUpsertPhotoUpdateInput>;
};

export type MetadataDepartmentNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDepartmentNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDepartmentNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDepartmentNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDepartmentNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDepartmentNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDepartmentNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDepartmentNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDepartmentNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDepartmentNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDepartmentNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDepartmentNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDepartmentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDepartmentUpdateInput = {
  /** Actions for the "MetadataDepartment.archive" relation */
  archive?: InputMaybe<MetadataDepartmentNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDepartment.metadata" relation */
  metadata?: InputMaybe<MetadataDepartmentNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDepartment.photo" relation */
  photo?: InputMaybe<MetadataDepartmentNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDepartment" nodes by specifying some conditions */
export type MetadataDepartmentWhereInput = {
  AND?: InputMaybe<Array<MetadataDepartmentWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDepartmentWhereInput>;
  OR?: InputMaybe<Array<MetadataDepartmentWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDepartment" node. */
export type MetadataDepartmentWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDepartmentWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDepartment.metadata" relation */
  metadata: MetadataDepartmentNestedMetadataCreateInput;
  /** Actions for the "MetadataDepartment.photo" relation */
  photo: MetadataDepartmentNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDepartmentWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDepartment.metadata" relation */
  metadata?: InputMaybe<MetadataDepartmentNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDepartment.photo" relation */
  photo?: InputMaybe<MetadataDepartmentNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDepartmentWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDepartment.archive" relation */
  archive: MetadataDepartmentNestedArchiveCreateInput;
  /** Actions for the "MetadataDepartment.photo" relation */
  photo: MetadataDepartmentNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDepartmentWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDepartment.archive" relation */
  archive?: InputMaybe<MetadataDepartmentNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDepartment.photo" relation */
  photo?: InputMaybe<MetadataDepartmentNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDepartmentWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDepartment.archive" relation */
  archive: MetadataDepartmentNestedArchiveCreateInput;
  /** Actions for the "MetadataDepartment.metadata" relation */
  metadata: MetadataDepartmentNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDepartmentWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDepartment.archive" relation */
  archive?: InputMaybe<MetadataDepartmentNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDepartment.metadata" relation */
  metadata?: InputMaybe<MetadataDepartmentNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataDescription" resource's node */
export type MetadataDescription = {
  __typename?: 'MetadataDescription';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataDescriptionCreateInput = {
  /** Actions for the "MetadataDescription.archive" relation */
  archive: MetadataDescriptionNestedArchiveCreateInput;
  /** Actions for the "MetadataDescription.metadata" relation */
  metadata: MetadataDescriptionNestedMetadataCreateInput;
  /** Actions for the "MetadataDescription.photo" relation */
  photo: MetadataDescriptionNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDescriptionNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataDescription" node, through the "MetadataDescription.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataDescription" node, through the "MetadataDescription.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataDescription" node, through the "MetadataDescription.archive" relation. */
  update?: InputMaybe<MetadataDescriptionNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataDescription" node, through the "MetadataDescription.archive" relation. */
  upsert?: InputMaybe<MetadataDescriptionNestedUpsertArchiveCreateInput>;
};

export type MetadataDescriptionNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataDescription" node, through the "MetadataDescription.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataDescription" node, through the "MetadataDescription.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataDescription" node, through the "MetadataDescription.archive" relation. */
  update?: InputMaybe<MetadataDescriptionNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataDescription" node, through the "MetadataDescription.archive" relation. */
  upsert?: InputMaybe<MetadataDescriptionNestedUpsertArchiveUpdateInput>;
};

export type MetadataDescriptionNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataDescription" node, through the "MetadataDescription.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataDescription" node, through the "MetadataDescription.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataDescription" node, through the "MetadataDescription.metadata" relation. */
  update?: InputMaybe<MetadataDescriptionNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataDescription" node, through the "MetadataDescription.metadata" relation. */
  upsert?: InputMaybe<MetadataDescriptionNestedUpsertMetadataCreateInput>;
};

export type MetadataDescriptionNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataDescription" node, through the "MetadataDescription.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataDescription" node, through the "MetadataDescription.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataDescription" node, through the "MetadataDescription.metadata" relation. */
  update?: InputMaybe<MetadataDescriptionNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataDescription" node, through the "MetadataDescription.metadata" relation. */
  upsert?: InputMaybe<MetadataDescriptionNestedUpsertMetadataUpdateInput>;
};

export type MetadataDescriptionNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataDescription" node, through the "MetadataDescription.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataDescription" node, through the "MetadataDescription.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataDescription" node, through the "MetadataDescription.photo" relation. */
  update?: InputMaybe<MetadataDescriptionNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataDescription" node, through the "MetadataDescription.photo" relation. */
  upsert?: InputMaybe<MetadataDescriptionNestedUpsertPhotoCreateInput>;
};

export type MetadataDescriptionNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataDescription" node, through the "MetadataDescription.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataDescription" node, through the "MetadataDescription.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataDescription" node, through the "MetadataDescription.photo" relation. */
  update?: InputMaybe<MetadataDescriptionNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataDescription" node, through the "MetadataDescription.photo" relation. */
  upsert?: InputMaybe<MetadataDescriptionNestedUpsertPhotoUpdateInput>;
};

export type MetadataDescriptionNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDescriptionNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDescriptionNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDescriptionNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDescriptionNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDescriptionNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDescriptionNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDescriptionNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataDescriptionNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDescriptionNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataDescriptionNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataDescriptionNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataDescriptionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataDescriptionUpdateInput = {
  /** Actions for the "MetadataDescription.archive" relation */
  archive?: InputMaybe<MetadataDescriptionNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDescription.metadata" relation */
  metadata?: InputMaybe<MetadataDescriptionNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDescription.photo" relation */
  photo?: InputMaybe<MetadataDescriptionNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataDescription" nodes by specifying some conditions */
export type MetadataDescriptionWhereInput = {
  AND?: InputMaybe<Array<MetadataDescriptionWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataDescriptionWhereInput>;
  OR?: InputMaybe<Array<MetadataDescriptionWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataDescription" node. */
export type MetadataDescriptionWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataDescriptionWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataDescription.metadata" relation */
  metadata: MetadataDescriptionNestedMetadataCreateInput;
  /** Actions for the "MetadataDescription.photo" relation */
  photo: MetadataDescriptionNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDescriptionWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataDescription.metadata" relation */
  metadata?: InputMaybe<MetadataDescriptionNestedMetadataUpdateInput>;
  /** Actions for the "MetadataDescription.photo" relation */
  photo?: InputMaybe<MetadataDescriptionNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDescriptionWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataDescription.archive" relation */
  archive: MetadataDescriptionNestedArchiveCreateInput;
  /** Actions for the "MetadataDescription.photo" relation */
  photo: MetadataDescriptionNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDescriptionWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataDescription.archive" relation */
  archive?: InputMaybe<MetadataDescriptionNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDescription.photo" relation */
  photo?: InputMaybe<MetadataDescriptionNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDescriptionWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataDescription.archive" relation */
  archive: MetadataDescriptionNestedArchiveCreateInput;
  /** Actions for the "MetadataDescription.metadata" relation */
  metadata: MetadataDescriptionNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataDescriptionWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataDescription.archive" relation */
  archive?: InputMaybe<MetadataDescriptionNestedArchiveUpdateInput>;
  /** Actions for the "MetadataDescription.metadata" relation */
  metadata?: InputMaybe<MetadataDescriptionNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataEdition" resource's node */
export type MetadataEdition = {
  __typename?: 'MetadataEdition';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataEditionCreateInput = {
  /** Actions for the "MetadataEdition.archive" relation */
  archive: MetadataEditionNestedArchiveCreateInput;
  /** Actions for the "MetadataEdition.metadata" relation */
  metadata: MetadataEditionNestedMetadataCreateInput;
  /** Actions for the "MetadataEdition.photo" relation */
  photo: MetadataEditionNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditionNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataEdition" node, through the "MetadataEdition.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataEdition" node, through the "MetadataEdition.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataEdition" node, through the "MetadataEdition.archive" relation. */
  update?: InputMaybe<MetadataEditionNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataEdition" node, through the "MetadataEdition.archive" relation. */
  upsert?: InputMaybe<MetadataEditionNestedUpsertArchiveCreateInput>;
};

export type MetadataEditionNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataEdition" node, through the "MetadataEdition.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataEdition" node, through the "MetadataEdition.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataEdition" node, through the "MetadataEdition.archive" relation. */
  update?: InputMaybe<MetadataEditionNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataEdition" node, through the "MetadataEdition.archive" relation. */
  upsert?: InputMaybe<MetadataEditionNestedUpsertArchiveUpdateInput>;
};

export type MetadataEditionNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataEdition" node, through the "MetadataEdition.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataEdition" node, through the "MetadataEdition.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataEdition" node, through the "MetadataEdition.metadata" relation. */
  update?: InputMaybe<MetadataEditionNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataEdition" node, through the "MetadataEdition.metadata" relation. */
  upsert?: InputMaybe<MetadataEditionNestedUpsertMetadataCreateInput>;
};

export type MetadataEditionNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataEdition" node, through the "MetadataEdition.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataEdition" node, through the "MetadataEdition.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataEdition" node, through the "MetadataEdition.metadata" relation. */
  update?: InputMaybe<MetadataEditionNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataEdition" node, through the "MetadataEdition.metadata" relation. */
  upsert?: InputMaybe<MetadataEditionNestedUpsertMetadataUpdateInput>;
};

export type MetadataEditionNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataEdition" node, through the "MetadataEdition.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataEdition" node, through the "MetadataEdition.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataEdition" node, through the "MetadataEdition.photo" relation. */
  update?: InputMaybe<MetadataEditionNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataEdition" node, through the "MetadataEdition.photo" relation. */
  upsert?: InputMaybe<MetadataEditionNestedUpsertPhotoCreateInput>;
};

export type MetadataEditionNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataEdition" node, through the "MetadataEdition.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataEdition" node, through the "MetadataEdition.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataEdition" node, through the "MetadataEdition.photo" relation. */
  update?: InputMaybe<MetadataEditionNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataEdition" node, through the "MetadataEdition.photo" relation. */
  upsert?: InputMaybe<MetadataEditionNestedUpsertPhotoUpdateInput>;
};

export type MetadataEditionNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataEditionNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataEditionNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataEditionNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataEditionNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataEditionNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataEditionNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataEditionNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataEditionNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataEditionNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataEditionNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataEditionNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataEditionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataEditionUpdateInput = {
  /** Actions for the "MetadataEdition.archive" relation */
  archive?: InputMaybe<MetadataEditionNestedArchiveUpdateInput>;
  /** Actions for the "MetadataEdition.metadata" relation */
  metadata?: InputMaybe<MetadataEditionNestedMetadataUpdateInput>;
  /** Actions for the "MetadataEdition.photo" relation */
  photo?: InputMaybe<MetadataEditionNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataEdition" nodes by specifying some conditions */
export type MetadataEditionWhereInput = {
  AND?: InputMaybe<Array<MetadataEditionWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataEditionWhereInput>;
  OR?: InputMaybe<Array<MetadataEditionWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataEdition" node. */
export type MetadataEditionWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataEditionWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataEdition.metadata" relation */
  metadata: MetadataEditionNestedMetadataCreateInput;
  /** Actions for the "MetadataEdition.photo" relation */
  photo: MetadataEditionNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditionWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataEdition.metadata" relation */
  metadata?: InputMaybe<MetadataEditionNestedMetadataUpdateInput>;
  /** Actions for the "MetadataEdition.photo" relation */
  photo?: InputMaybe<MetadataEditionNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditionWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataEdition.archive" relation */
  archive: MetadataEditionNestedArchiveCreateInput;
  /** Actions for the "MetadataEdition.photo" relation */
  photo: MetadataEditionNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditionWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataEdition.archive" relation */
  archive?: InputMaybe<MetadataEditionNestedArchiveUpdateInput>;
  /** Actions for the "MetadataEdition.photo" relation */
  photo?: InputMaybe<MetadataEditionNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditionWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataEdition.archive" relation */
  archive: MetadataEditionNestedArchiveCreateInput;
  /** Actions for the "MetadataEdition.metadata" relation */
  metadata: MetadataEditionNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditionWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataEdition.archive" relation */
  archive?: InputMaybe<MetadataEditionNestedArchiveUpdateInput>;
  /** Actions for the "MetadataEdition.metadata" relation */
  metadata?: InputMaybe<MetadataEditionNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataEditStatus" resource's node */
export type MetadataEditStatus = {
  __typename?: 'MetadataEditStatus';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataEditStatusCreateInput = {
  /** Actions for the "MetadataEditStatus.archive" relation */
  archive: MetadataEditStatusNestedArchiveCreateInput;
  /** Actions for the "MetadataEditStatus.metadata" relation */
  metadata: MetadataEditStatusNestedMetadataCreateInput;
  /** Actions for the "MetadataEditStatus.photo" relation */
  photo: MetadataEditStatusNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditStatusNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataEditStatus" node, through the "MetadataEditStatus.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataEditStatus" node, through the "MetadataEditStatus.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataEditStatus" node, through the "MetadataEditStatus.archive" relation. */
  update?: InputMaybe<MetadataEditStatusNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataEditStatus" node, through the "MetadataEditStatus.archive" relation. */
  upsert?: InputMaybe<MetadataEditStatusNestedUpsertArchiveCreateInput>;
};

export type MetadataEditStatusNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.archive" relation. */
  update?: InputMaybe<MetadataEditStatusNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.archive" relation. */
  upsert?: InputMaybe<MetadataEditStatusNestedUpsertArchiveUpdateInput>;
};

export type MetadataEditStatusNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataEditStatus" node, through the "MetadataEditStatus.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataEditStatus" node, through the "MetadataEditStatus.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataEditStatus" node, through the "MetadataEditStatus.metadata" relation. */
  update?: InputMaybe<MetadataEditStatusNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataEditStatus" node, through the "MetadataEditStatus.metadata" relation. */
  upsert?: InputMaybe<MetadataEditStatusNestedUpsertMetadataCreateInput>;
};

export type MetadataEditStatusNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.metadata" relation. */
  update?: InputMaybe<MetadataEditStatusNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.metadata" relation. */
  upsert?: InputMaybe<MetadataEditStatusNestedUpsertMetadataUpdateInput>;
};

export type MetadataEditStatusNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataEditStatus" node, through the "MetadataEditStatus.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataEditStatus" node, through the "MetadataEditStatus.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataEditStatus" node, through the "MetadataEditStatus.photo" relation. */
  update?: InputMaybe<MetadataEditStatusNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataEditStatus" node, through the "MetadataEditStatus.photo" relation. */
  upsert?: InputMaybe<MetadataEditStatusNestedUpsertPhotoCreateInput>;
};

export type MetadataEditStatusNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.photo" relation. */
  update?: InputMaybe<MetadataEditStatusNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataEditStatus" node, through the "MetadataEditStatus.photo" relation. */
  upsert?: InputMaybe<MetadataEditStatusNestedUpsertPhotoUpdateInput>;
};

export type MetadataEditStatusNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataEditStatusNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataEditStatusNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataEditStatusNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataEditStatusNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataEditStatusNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataEditStatusNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataEditStatusNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataEditStatusNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataEditStatusNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataEditStatusNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataEditStatusNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataEditStatusOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataEditStatusUpdateInput = {
  /** Actions for the "MetadataEditStatus.archive" relation */
  archive?: InputMaybe<MetadataEditStatusNestedArchiveUpdateInput>;
  /** Actions for the "MetadataEditStatus.metadata" relation */
  metadata?: InputMaybe<MetadataEditStatusNestedMetadataUpdateInput>;
  /** Actions for the "MetadataEditStatus.photo" relation */
  photo?: InputMaybe<MetadataEditStatusNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataEditStatus" nodes by specifying some conditions */
export type MetadataEditStatusWhereInput = {
  AND?: InputMaybe<Array<MetadataEditStatusWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataEditStatusWhereInput>;
  OR?: InputMaybe<Array<MetadataEditStatusWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataEditStatus" node. */
export type MetadataEditStatusWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataEditStatusWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataEditStatus.metadata" relation */
  metadata: MetadataEditStatusNestedMetadataCreateInput;
  /** Actions for the "MetadataEditStatus.photo" relation */
  photo: MetadataEditStatusNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditStatusWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataEditStatus.metadata" relation */
  metadata?: InputMaybe<MetadataEditStatusNestedMetadataUpdateInput>;
  /** Actions for the "MetadataEditStatus.photo" relation */
  photo?: InputMaybe<MetadataEditStatusNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditStatusWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataEditStatus.archive" relation */
  archive: MetadataEditStatusNestedArchiveCreateInput;
  /** Actions for the "MetadataEditStatus.photo" relation */
  photo: MetadataEditStatusNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditStatusWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataEditStatus.archive" relation */
  archive?: InputMaybe<MetadataEditStatusNestedArchiveUpdateInput>;
  /** Actions for the "MetadataEditStatus.photo" relation */
  photo?: InputMaybe<MetadataEditStatusNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditStatusWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataEditStatus.archive" relation */
  archive: MetadataEditStatusNestedArchiveCreateInput;
  /** Actions for the "MetadataEditStatus.metadata" relation */
  metadata: MetadataEditStatusNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataEditStatusWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataEditStatus.archive" relation */
  archive?: InputMaybe<MetadataEditStatusNestedArchiveUpdateInput>;
  /** Actions for the "MetadataEditStatus.metadata" relation */
  metadata?: InputMaybe<MetadataEditStatusNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataFileStatus" resource's node */
export type MetadataFileStatus = {
  __typename?: 'MetadataFileStatus';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataFileStatusCreateInput = {
  /** Actions for the "MetadataFileStatus.archive" relation */
  archive: MetadataFileStatusNestedArchiveCreateInput;
  /** Actions for the "MetadataFileStatus.metadata" relation */
  metadata: MetadataFileStatusNestedMetadataCreateInput;
  /** Actions for the "MetadataFileStatus.photo" relation */
  photo: MetadataFileStatusNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFileStatusNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataFileStatus" node, through the "MetadataFileStatus.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataFileStatus" node, through the "MetadataFileStatus.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataFileStatus" node, through the "MetadataFileStatus.archive" relation. */
  update?: InputMaybe<MetadataFileStatusNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataFileStatus" node, through the "MetadataFileStatus.archive" relation. */
  upsert?: InputMaybe<MetadataFileStatusNestedUpsertArchiveCreateInput>;
};

export type MetadataFileStatusNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.archive" relation. */
  update?: InputMaybe<MetadataFileStatusNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.archive" relation. */
  upsert?: InputMaybe<MetadataFileStatusNestedUpsertArchiveUpdateInput>;
};

export type MetadataFileStatusNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataFileStatus" node, through the "MetadataFileStatus.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataFileStatus" node, through the "MetadataFileStatus.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataFileStatus" node, through the "MetadataFileStatus.metadata" relation. */
  update?: InputMaybe<MetadataFileStatusNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataFileStatus" node, through the "MetadataFileStatus.metadata" relation. */
  upsert?: InputMaybe<MetadataFileStatusNestedUpsertMetadataCreateInput>;
};

export type MetadataFileStatusNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.metadata" relation. */
  update?: InputMaybe<MetadataFileStatusNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.metadata" relation. */
  upsert?: InputMaybe<MetadataFileStatusNestedUpsertMetadataUpdateInput>;
};

export type MetadataFileStatusNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataFileStatus" node, through the "MetadataFileStatus.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataFileStatus" node, through the "MetadataFileStatus.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataFileStatus" node, through the "MetadataFileStatus.photo" relation. */
  update?: InputMaybe<MetadataFileStatusNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataFileStatus" node, through the "MetadataFileStatus.photo" relation. */
  upsert?: InputMaybe<MetadataFileStatusNestedUpsertPhotoCreateInput>;
};

export type MetadataFileStatusNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.photo" relation. */
  update?: InputMaybe<MetadataFileStatusNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataFileStatus" node, through the "MetadataFileStatus.photo" relation. */
  upsert?: InputMaybe<MetadataFileStatusNestedUpsertPhotoUpdateInput>;
};

export type MetadataFileStatusNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataFileStatusNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataFileStatusNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataFileStatusNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataFileStatusNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataFileStatusNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataFileStatusNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataFileStatusNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataFileStatusNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataFileStatusNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataFileStatusNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataFileStatusNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataFileStatusOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataFileStatusUpdateInput = {
  /** Actions for the "MetadataFileStatus.archive" relation */
  archive?: InputMaybe<MetadataFileStatusNestedArchiveUpdateInput>;
  /** Actions for the "MetadataFileStatus.metadata" relation */
  metadata?: InputMaybe<MetadataFileStatusNestedMetadataUpdateInput>;
  /** Actions for the "MetadataFileStatus.photo" relation */
  photo?: InputMaybe<MetadataFileStatusNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataFileStatus" nodes by specifying some conditions */
export type MetadataFileStatusWhereInput = {
  AND?: InputMaybe<Array<MetadataFileStatusWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataFileStatusWhereInput>;
  OR?: InputMaybe<Array<MetadataFileStatusWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataFileStatus" node. */
export type MetadataFileStatusWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataFileStatusWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataFileStatus.metadata" relation */
  metadata: MetadataFileStatusNestedMetadataCreateInput;
  /** Actions for the "MetadataFileStatus.photo" relation */
  photo: MetadataFileStatusNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFileStatusWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataFileStatus.metadata" relation */
  metadata?: InputMaybe<MetadataFileStatusNestedMetadataUpdateInput>;
  /** Actions for the "MetadataFileStatus.photo" relation */
  photo?: InputMaybe<MetadataFileStatusNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFileStatusWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataFileStatus.archive" relation */
  archive: MetadataFileStatusNestedArchiveCreateInput;
  /** Actions for the "MetadataFileStatus.photo" relation */
  photo: MetadataFileStatusNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFileStatusWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataFileStatus.archive" relation */
  archive?: InputMaybe<MetadataFileStatusNestedArchiveUpdateInput>;
  /** Actions for the "MetadataFileStatus.photo" relation */
  photo?: InputMaybe<MetadataFileStatusNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFileStatusWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataFileStatus.archive" relation */
  archive: MetadataFileStatusNestedArchiveCreateInput;
  /** Actions for the "MetadataFileStatus.metadata" relation */
  metadata: MetadataFileStatusNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFileStatusWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataFileStatus.archive" relation */
  archive?: InputMaybe<MetadataFileStatusNestedArchiveUpdateInput>;
  /** Actions for the "MetadataFileStatus.metadata" relation */
  metadata?: InputMaybe<MetadataFileStatusNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataFormat" resource's node */
export type MetadataFormat = {
  __typename?: 'MetadataFormat';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataFormatCreateInput = {
  /** Actions for the "MetadataFormat.archive" relation */
  archive: MetadataFormatNestedArchiveCreateInput;
  /** Actions for the "MetadataFormat.metadata" relation */
  metadata: MetadataFormatNestedMetadataCreateInput;
  /** Actions for the "MetadataFormat.photo" relation */
  photo: MetadataFormatNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFormatNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataFormat" node, through the "MetadataFormat.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataFormat" node, through the "MetadataFormat.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataFormat" node, through the "MetadataFormat.archive" relation. */
  update?: InputMaybe<MetadataFormatNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataFormat" node, through the "MetadataFormat.archive" relation. */
  upsert?: InputMaybe<MetadataFormatNestedUpsertArchiveCreateInput>;
};

export type MetadataFormatNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataFormat" node, through the "MetadataFormat.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataFormat" node, through the "MetadataFormat.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataFormat" node, through the "MetadataFormat.archive" relation. */
  update?: InputMaybe<MetadataFormatNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataFormat" node, through the "MetadataFormat.archive" relation. */
  upsert?: InputMaybe<MetadataFormatNestedUpsertArchiveUpdateInput>;
};

export type MetadataFormatNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataFormat" node, through the "MetadataFormat.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataFormat" node, through the "MetadataFormat.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataFormat" node, through the "MetadataFormat.metadata" relation. */
  update?: InputMaybe<MetadataFormatNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataFormat" node, through the "MetadataFormat.metadata" relation. */
  upsert?: InputMaybe<MetadataFormatNestedUpsertMetadataCreateInput>;
};

export type MetadataFormatNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataFormat" node, through the "MetadataFormat.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataFormat" node, through the "MetadataFormat.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataFormat" node, through the "MetadataFormat.metadata" relation. */
  update?: InputMaybe<MetadataFormatNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataFormat" node, through the "MetadataFormat.metadata" relation. */
  upsert?: InputMaybe<MetadataFormatNestedUpsertMetadataUpdateInput>;
};

export type MetadataFormatNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataFormat" node, through the "MetadataFormat.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataFormat" node, through the "MetadataFormat.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataFormat" node, through the "MetadataFormat.photo" relation. */
  update?: InputMaybe<MetadataFormatNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataFormat" node, through the "MetadataFormat.photo" relation. */
  upsert?: InputMaybe<MetadataFormatNestedUpsertPhotoCreateInput>;
};

export type MetadataFormatNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataFormat" node, through the "MetadataFormat.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataFormat" node, through the "MetadataFormat.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataFormat" node, through the "MetadataFormat.photo" relation. */
  update?: InputMaybe<MetadataFormatNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataFormat" node, through the "MetadataFormat.photo" relation. */
  upsert?: InputMaybe<MetadataFormatNestedUpsertPhotoUpdateInput>;
};

export type MetadataFormatNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataFormatNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataFormatNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataFormatNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataFormatNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataFormatNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataFormatNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataFormatNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataFormatNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataFormatNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataFormatNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataFormatNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataFormatOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataFormatUpdateInput = {
  /** Actions for the "MetadataFormat.archive" relation */
  archive?: InputMaybe<MetadataFormatNestedArchiveUpdateInput>;
  /** Actions for the "MetadataFormat.metadata" relation */
  metadata?: InputMaybe<MetadataFormatNestedMetadataUpdateInput>;
  /** Actions for the "MetadataFormat.photo" relation */
  photo?: InputMaybe<MetadataFormatNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataFormat" nodes by specifying some conditions */
export type MetadataFormatWhereInput = {
  AND?: InputMaybe<Array<MetadataFormatWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataFormatWhereInput>;
  OR?: InputMaybe<Array<MetadataFormatWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataFormat" node. */
export type MetadataFormatWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataFormatWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataFormat.metadata" relation */
  metadata: MetadataFormatNestedMetadataCreateInput;
  /** Actions for the "MetadataFormat.photo" relation */
  photo: MetadataFormatNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFormatWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataFormat.metadata" relation */
  metadata?: InputMaybe<MetadataFormatNestedMetadataUpdateInput>;
  /** Actions for the "MetadataFormat.photo" relation */
  photo?: InputMaybe<MetadataFormatNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFormatWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataFormat.archive" relation */
  archive: MetadataFormatNestedArchiveCreateInput;
  /** Actions for the "MetadataFormat.photo" relation */
  photo: MetadataFormatNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFormatWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataFormat.archive" relation */
  archive?: InputMaybe<MetadataFormatNestedArchiveUpdateInput>;
  /** Actions for the "MetadataFormat.photo" relation */
  photo?: InputMaybe<MetadataFormatNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFormatWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataFormat.archive" relation */
  archive: MetadataFormatNestedArchiveCreateInput;
  /** Actions for the "MetadataFormat.metadata" relation */
  metadata: MetadataFormatNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataFormatWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataFormat.archive" relation */
  archive?: InputMaybe<MetadataFormatNestedArchiveUpdateInput>;
  /** Actions for the "MetadataFormat.metadata" relation */
  metadata?: InputMaybe<MetadataFormatNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataHeader" resource's node */
export type MetadataHeader = {
  __typename?: 'MetadataHeader';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataHeaderCreateInput = {
  /** Actions for the "MetadataHeader.archive" relation */
  archive: MetadataHeaderNestedArchiveCreateInput;
  /** Actions for the "MetadataHeader.metadata" relation */
  metadata: MetadataHeaderNestedMetadataCreateInput;
  /** Actions for the "MetadataHeader.photo" relation */
  photo: MetadataHeaderNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataHeader" node, through the "MetadataHeader.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataHeader" node, through the "MetadataHeader.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataHeader" node, through the "MetadataHeader.archive" relation. */
  update?: InputMaybe<MetadataHeaderNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataHeader" node, through the "MetadataHeader.archive" relation. */
  upsert?: InputMaybe<MetadataHeaderNestedUpsertArchiveCreateInput>;
};

export type MetadataHeaderNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataHeader" node, through the "MetadataHeader.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataHeader" node, through the "MetadataHeader.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataHeader" node, through the "MetadataHeader.archive" relation. */
  update?: InputMaybe<MetadataHeaderNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataHeader" node, through the "MetadataHeader.archive" relation. */
  upsert?: InputMaybe<MetadataHeaderNestedUpsertArchiveUpdateInput>;
};

export type MetadataHeaderNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataHeader" node, through the "MetadataHeader.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataHeader" node, through the "MetadataHeader.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataHeader" node, through the "MetadataHeader.metadata" relation. */
  update?: InputMaybe<MetadataHeaderNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataHeader" node, through the "MetadataHeader.metadata" relation. */
  upsert?: InputMaybe<MetadataHeaderNestedUpsertMetadataCreateInput>;
};

export type MetadataHeaderNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataHeader" node, through the "MetadataHeader.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataHeader" node, through the "MetadataHeader.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataHeader" node, through the "MetadataHeader.metadata" relation. */
  update?: InputMaybe<MetadataHeaderNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataHeader" node, through the "MetadataHeader.metadata" relation. */
  upsert?: InputMaybe<MetadataHeaderNestedUpsertMetadataUpdateInput>;
};

export type MetadataHeaderNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataHeader" node, through the "MetadataHeader.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataHeader" node, through the "MetadataHeader.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataHeader" node, through the "MetadataHeader.photo" relation. */
  update?: InputMaybe<MetadataHeaderNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataHeader" node, through the "MetadataHeader.photo" relation. */
  upsert?: InputMaybe<MetadataHeaderNestedUpsertPhotoCreateInput>;
};

export type MetadataHeaderNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataHeader" node, through the "MetadataHeader.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataHeader" node, through the "MetadataHeader.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataHeader" node, through the "MetadataHeader.photo" relation. */
  update?: InputMaybe<MetadataHeaderNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataHeader" node, through the "MetadataHeader.photo" relation. */
  upsert?: InputMaybe<MetadataHeaderNestedUpsertPhotoUpdateInput>;
};

export type MetadataHeaderNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeaderNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeaderNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeaderNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeaderNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataHeaderNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataHeaderNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeaderNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeaderNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeaderNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeaderNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataHeaderNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataHeaderOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

/** "MetadataHeaderPrisma" resource's node */
export type MetadataHeaderPrisma = {
  __typename?: 'MetadataHeaderPrisma';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataHeaderPrismaCreateInput = {
  /** Actions for the "MetadataHeaderPrisma.archive" relation */
  archive: MetadataHeaderPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataHeaderPrisma.metadata" relation */
  metadata: MetadataHeaderPrismaNestedMetadataCreateInput;
  /** Actions for the "MetadataHeaderPrisma.photo" relation */
  photo: MetadataHeaderPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderPrismaNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.archive" relation. */
  update?: InputMaybe<MetadataHeaderPrismaNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.archive" relation. */
  upsert?: InputMaybe<MetadataHeaderPrismaNestedUpsertArchiveCreateInput>;
};

export type MetadataHeaderPrismaNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.archive" relation. */
  update?: InputMaybe<MetadataHeaderPrismaNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.archive" relation. */
  upsert?: InputMaybe<MetadataHeaderPrismaNestedUpsertArchiveUpdateInput>;
};

export type MetadataHeaderPrismaNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.metadata" relation. */
  update?: InputMaybe<MetadataHeaderPrismaNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.metadata" relation. */
  upsert?: InputMaybe<MetadataHeaderPrismaNestedUpsertMetadataCreateInput>;
};

export type MetadataHeaderPrismaNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.metadata" relation. */
  update?: InputMaybe<MetadataHeaderPrismaNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.metadata" relation. */
  upsert?: InputMaybe<MetadataHeaderPrismaNestedUpsertMetadataUpdateInput>;
};

export type MetadataHeaderPrismaNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.photo" relation. */
  update?: InputMaybe<MetadataHeaderPrismaNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.photo" relation. */
  upsert?: InputMaybe<MetadataHeaderPrismaNestedUpsertPhotoCreateInput>;
};

export type MetadataHeaderPrismaNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.photo" relation. */
  update?: InputMaybe<MetadataHeaderPrismaNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataHeaderPrisma" node, through the "MetadataHeaderPrisma.photo" relation. */
  upsert?: InputMaybe<MetadataHeaderPrismaNestedUpsertPhotoUpdateInput>;
};

export type MetadataHeaderPrismaNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataHeaderPrismaNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataHeaderPrismaOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataHeaderPrismaUpdateInput = {
  /** Actions for the "MetadataHeaderPrisma.archive" relation */
  archive?: InputMaybe<MetadataHeaderPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataHeaderPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataHeaderPrismaNestedMetadataUpdateInput>;
  /** Actions for the "MetadataHeaderPrisma.photo" relation */
  photo?: InputMaybe<MetadataHeaderPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataHeaderPrisma" nodes by specifying some conditions */
export type MetadataHeaderPrismaWhereInput = {
  AND?: InputMaybe<Array<MetadataHeaderPrismaWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataHeaderPrismaWhereInput>;
  OR?: InputMaybe<Array<MetadataHeaderPrismaWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataHeaderPrisma" node. */
export type MetadataHeaderPrismaWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataHeaderPrismaWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataHeaderPrisma.metadata" relation */
  metadata: MetadataHeaderPrismaNestedMetadataCreateInput;
  /** Actions for the "MetadataHeaderPrisma.photo" relation */
  photo: MetadataHeaderPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderPrismaWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataHeaderPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataHeaderPrismaNestedMetadataUpdateInput>;
  /** Actions for the "MetadataHeaderPrisma.photo" relation */
  photo?: InputMaybe<MetadataHeaderPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderPrismaWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataHeaderPrisma.archive" relation */
  archive: MetadataHeaderPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataHeaderPrisma.photo" relation */
  photo: MetadataHeaderPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderPrismaWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataHeaderPrisma.archive" relation */
  archive?: InputMaybe<MetadataHeaderPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataHeaderPrisma.photo" relation */
  photo?: InputMaybe<MetadataHeaderPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderPrismaWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataHeaderPrisma.archive" relation */
  archive: MetadataHeaderPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataHeaderPrisma.metadata" relation */
  metadata: MetadataHeaderPrismaNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderPrismaWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataHeaderPrisma.archive" relation */
  archive?: InputMaybe<MetadataHeaderPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataHeaderPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataHeaderPrismaNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderUpdateInput = {
  /** Actions for the "MetadataHeader.archive" relation */
  archive?: InputMaybe<MetadataHeaderNestedArchiveUpdateInput>;
  /** Actions for the "MetadataHeader.metadata" relation */
  metadata?: InputMaybe<MetadataHeaderNestedMetadataUpdateInput>;
  /** Actions for the "MetadataHeader.photo" relation */
  photo?: InputMaybe<MetadataHeaderNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataHeader" nodes by specifying some conditions */
export type MetadataHeaderWhereInput = {
  AND?: InputMaybe<Array<MetadataHeaderWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataHeaderWhereInput>;
  OR?: InputMaybe<Array<MetadataHeaderWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataHeader" node. */
export type MetadataHeaderWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataHeaderWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataHeader.metadata" relation */
  metadata: MetadataHeaderNestedMetadataCreateInput;
  /** Actions for the "MetadataHeader.photo" relation */
  photo: MetadataHeaderNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataHeader.metadata" relation */
  metadata?: InputMaybe<MetadataHeaderNestedMetadataUpdateInput>;
  /** Actions for the "MetadataHeader.photo" relation */
  photo?: InputMaybe<MetadataHeaderNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataHeader.archive" relation */
  archive: MetadataHeaderNestedArchiveCreateInput;
  /** Actions for the "MetadataHeader.photo" relation */
  photo: MetadataHeaderNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataHeader.archive" relation */
  archive?: InputMaybe<MetadataHeaderNestedArchiveUpdateInput>;
  /** Actions for the "MetadataHeader.photo" relation */
  photo?: InputMaybe<MetadataHeaderNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataHeader.archive" relation */
  archive: MetadataHeaderNestedArchiveCreateInput;
  /** Actions for the "MetadataHeader.metadata" relation */
  metadata: MetadataHeaderNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeaderWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataHeader.archive" relation */
  archive?: InputMaybe<MetadataHeaderNestedArchiveUpdateInput>;
  /** Actions for the "MetadataHeader.metadata" relation */
  metadata?: InputMaybe<MetadataHeaderNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataHeadline" resource's node */
export type MetadataHeadline = {
  __typename?: 'MetadataHeadline';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataHeadlineCreateInput = {
  /** Actions for the "MetadataHeadline.archive" relation */
  archive: MetadataHeadlineNestedArchiveCreateInput;
  /** Actions for the "MetadataHeadline.metadata" relation */
  metadata: MetadataHeadlineNestedMetadataCreateInput;
  /** Actions for the "MetadataHeadline.photo" relation */
  photo: MetadataHeadlineNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeadlineNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataHeadline" node, through the "MetadataHeadline.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataHeadline" node, through the "MetadataHeadline.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataHeadline" node, through the "MetadataHeadline.archive" relation. */
  update?: InputMaybe<MetadataHeadlineNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataHeadline" node, through the "MetadataHeadline.archive" relation. */
  upsert?: InputMaybe<MetadataHeadlineNestedUpsertArchiveCreateInput>;
};

export type MetadataHeadlineNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataHeadline" node, through the "MetadataHeadline.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataHeadline" node, through the "MetadataHeadline.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataHeadline" node, through the "MetadataHeadline.archive" relation. */
  update?: InputMaybe<MetadataHeadlineNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataHeadline" node, through the "MetadataHeadline.archive" relation. */
  upsert?: InputMaybe<MetadataHeadlineNestedUpsertArchiveUpdateInput>;
};

export type MetadataHeadlineNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataHeadline" node, through the "MetadataHeadline.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataHeadline" node, through the "MetadataHeadline.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataHeadline" node, through the "MetadataHeadline.metadata" relation. */
  update?: InputMaybe<MetadataHeadlineNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataHeadline" node, through the "MetadataHeadline.metadata" relation. */
  upsert?: InputMaybe<MetadataHeadlineNestedUpsertMetadataCreateInput>;
};

export type MetadataHeadlineNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataHeadline" node, through the "MetadataHeadline.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataHeadline" node, through the "MetadataHeadline.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataHeadline" node, through the "MetadataHeadline.metadata" relation. */
  update?: InputMaybe<MetadataHeadlineNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataHeadline" node, through the "MetadataHeadline.metadata" relation. */
  upsert?: InputMaybe<MetadataHeadlineNestedUpsertMetadataUpdateInput>;
};

export type MetadataHeadlineNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataHeadline" node, through the "MetadataHeadline.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataHeadline" node, through the "MetadataHeadline.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataHeadline" node, through the "MetadataHeadline.photo" relation. */
  update?: InputMaybe<MetadataHeadlineNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataHeadline" node, through the "MetadataHeadline.photo" relation. */
  upsert?: InputMaybe<MetadataHeadlineNestedUpsertPhotoCreateInput>;
};

export type MetadataHeadlineNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataHeadline" node, through the "MetadataHeadline.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataHeadline" node, through the "MetadataHeadline.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataHeadline" node, through the "MetadataHeadline.photo" relation. */
  update?: InputMaybe<MetadataHeadlineNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataHeadline" node, through the "MetadataHeadline.photo" relation. */
  upsert?: InputMaybe<MetadataHeadlineNestedUpsertPhotoUpdateInput>;
};

export type MetadataHeadlineNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeadlineNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeadlineNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeadlineNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeadlineNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataHeadlineNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataHeadlineNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeadlineNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataHeadlineNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeadlineNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataHeadlineNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataHeadlineNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataHeadlineOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataHeadlineUpdateInput = {
  /** Actions for the "MetadataHeadline.archive" relation */
  archive?: InputMaybe<MetadataHeadlineNestedArchiveUpdateInput>;
  /** Actions for the "MetadataHeadline.metadata" relation */
  metadata?: InputMaybe<MetadataHeadlineNestedMetadataUpdateInput>;
  /** Actions for the "MetadataHeadline.photo" relation */
  photo?: InputMaybe<MetadataHeadlineNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataHeadline" nodes by specifying some conditions */
export type MetadataHeadlineWhereInput = {
  AND?: InputMaybe<Array<MetadataHeadlineWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataHeadlineWhereInput>;
  OR?: InputMaybe<Array<MetadataHeadlineWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataHeadline" node. */
export type MetadataHeadlineWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataHeadlineWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataHeadline.metadata" relation */
  metadata: MetadataHeadlineNestedMetadataCreateInput;
  /** Actions for the "MetadataHeadline.photo" relation */
  photo: MetadataHeadlineNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeadlineWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataHeadline.metadata" relation */
  metadata?: InputMaybe<MetadataHeadlineNestedMetadataUpdateInput>;
  /** Actions for the "MetadataHeadline.photo" relation */
  photo?: InputMaybe<MetadataHeadlineNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeadlineWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataHeadline.archive" relation */
  archive: MetadataHeadlineNestedArchiveCreateInput;
  /** Actions for the "MetadataHeadline.photo" relation */
  photo: MetadataHeadlineNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeadlineWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataHeadline.archive" relation */
  archive?: InputMaybe<MetadataHeadlineNestedArchiveUpdateInput>;
  /** Actions for the "MetadataHeadline.photo" relation */
  photo?: InputMaybe<MetadataHeadlineNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeadlineWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataHeadline.archive" relation */
  archive: MetadataHeadlineNestedArchiveCreateInput;
  /** Actions for the "MetadataHeadline.metadata" relation */
  metadata: MetadataHeadlineNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataHeadlineWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataHeadline.archive" relation */
  archive?: InputMaybe<MetadataHeadlineNestedArchiveUpdateInput>;
  /** Actions for the "MetadataHeadline.metadata" relation */
  metadata?: InputMaybe<MetadataHeadlineNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataIdAssignment" resource's node */
export type MetadataIdAssignment = {
  __typename?: 'MetadataIdAssignment';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataIdAssignmentCreateInput = {
  /** Actions for the "MetadataIdAssignment.archive" relation */
  archive: MetadataIdAssignmentNestedArchiveCreateInput;
  /** Actions for the "MetadataIdAssignment.metadata" relation */
  metadata: MetadataIdAssignmentNestedMetadataCreateInput;
  /** Actions for the "MetadataIdAssignment.photo" relation */
  photo: MetadataIdAssignmentNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdAssignmentNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.archive" relation. */
  update?: InputMaybe<MetadataIdAssignmentNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.archive" relation. */
  upsert?: InputMaybe<MetadataIdAssignmentNestedUpsertArchiveCreateInput>;
};

export type MetadataIdAssignmentNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.archive" relation. */
  update?: InputMaybe<MetadataIdAssignmentNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.archive" relation. */
  upsert?: InputMaybe<MetadataIdAssignmentNestedUpsertArchiveUpdateInput>;
};

export type MetadataIdAssignmentNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.metadata" relation. */
  update?: InputMaybe<MetadataIdAssignmentNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.metadata" relation. */
  upsert?: InputMaybe<MetadataIdAssignmentNestedUpsertMetadataCreateInput>;
};

export type MetadataIdAssignmentNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.metadata" relation. */
  update?: InputMaybe<MetadataIdAssignmentNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.metadata" relation. */
  upsert?: InputMaybe<MetadataIdAssignmentNestedUpsertMetadataUpdateInput>;
};

export type MetadataIdAssignmentNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.photo" relation. */
  update?: InputMaybe<MetadataIdAssignmentNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataIdAssignment" node, through the "MetadataIdAssignment.photo" relation. */
  upsert?: InputMaybe<MetadataIdAssignmentNestedUpsertPhotoCreateInput>;
};

export type MetadataIdAssignmentNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.photo" relation. */
  update?: InputMaybe<MetadataIdAssignmentNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataIdAssignment" node, through the "MetadataIdAssignment.photo" relation. */
  upsert?: InputMaybe<MetadataIdAssignmentNestedUpsertPhotoUpdateInput>;
};

export type MetadataIdAssignmentNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIdAssignmentNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataIdAssignmentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataIdAssignmentUpdateInput = {
  /** Actions for the "MetadataIdAssignment.archive" relation */
  archive?: InputMaybe<MetadataIdAssignmentNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIdAssignment.metadata" relation */
  metadata?: InputMaybe<MetadataIdAssignmentNestedMetadataUpdateInput>;
  /** Actions for the "MetadataIdAssignment.photo" relation */
  photo?: InputMaybe<MetadataIdAssignmentNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataIdAssignment" nodes by specifying some conditions */
export type MetadataIdAssignmentWhereInput = {
  AND?: InputMaybe<Array<MetadataIdAssignmentWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataIdAssignmentWhereInput>;
  OR?: InputMaybe<Array<MetadataIdAssignmentWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataIdAssignment" node. */
export type MetadataIdAssignmentWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataIdAssignmentWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataIdAssignment.metadata" relation */
  metadata: MetadataIdAssignmentNestedMetadataCreateInput;
  /** Actions for the "MetadataIdAssignment.photo" relation */
  photo: MetadataIdAssignmentNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdAssignmentWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataIdAssignment.metadata" relation */
  metadata?: InputMaybe<MetadataIdAssignmentNestedMetadataUpdateInput>;
  /** Actions for the "MetadataIdAssignment.photo" relation */
  photo?: InputMaybe<MetadataIdAssignmentNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdAssignmentWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataIdAssignment.archive" relation */
  archive: MetadataIdAssignmentNestedArchiveCreateInput;
  /** Actions for the "MetadataIdAssignment.photo" relation */
  photo: MetadataIdAssignmentNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdAssignmentWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataIdAssignment.archive" relation */
  archive?: InputMaybe<MetadataIdAssignmentNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIdAssignment.photo" relation */
  photo?: InputMaybe<MetadataIdAssignmentNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdAssignmentWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataIdAssignment.archive" relation */
  archive: MetadataIdAssignmentNestedArchiveCreateInput;
  /** Actions for the "MetadataIdAssignment.metadata" relation */
  metadata: MetadataIdAssignmentNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdAssignmentWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataIdAssignment.archive" relation */
  archive?: InputMaybe<MetadataIdAssignmentNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIdAssignment.metadata" relation */
  metadata?: InputMaybe<MetadataIdAssignmentNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataIdPhotoPrisma" resource's node */
export type MetadataIdPhotoPrisma = {
  __typename?: 'MetadataIdPhotoPrisma';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataIdPhotoPrismaCreateInput = {
  /** Actions for the "MetadataIdPhotoPrisma.archive" relation */
  archive: MetadataIdPhotoPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataIdPhotoPrisma.metadata" relation */
  metadata: MetadataIdPhotoPrismaNestedMetadataCreateInput;
  /** Actions for the "MetadataIdPhotoPrisma.photo" relation */
  photo: MetadataIdPhotoPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdPhotoPrismaNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.archive" relation. */
  update?: InputMaybe<MetadataIdPhotoPrismaNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.archive" relation. */
  upsert?: InputMaybe<MetadataIdPhotoPrismaNestedUpsertArchiveCreateInput>;
};

export type MetadataIdPhotoPrismaNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.archive" relation. */
  update?: InputMaybe<MetadataIdPhotoPrismaNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.archive" relation. */
  upsert?: InputMaybe<MetadataIdPhotoPrismaNestedUpsertArchiveUpdateInput>;
};

export type MetadataIdPhotoPrismaNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.metadata" relation. */
  update?: InputMaybe<MetadataIdPhotoPrismaNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.metadata" relation. */
  upsert?: InputMaybe<MetadataIdPhotoPrismaNestedUpsertMetadataCreateInput>;
};

export type MetadataIdPhotoPrismaNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.metadata" relation. */
  update?: InputMaybe<MetadataIdPhotoPrismaNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.metadata" relation. */
  upsert?: InputMaybe<MetadataIdPhotoPrismaNestedUpsertMetadataUpdateInput>;
};

export type MetadataIdPhotoPrismaNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.photo" relation. */
  update?: InputMaybe<MetadataIdPhotoPrismaNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.photo" relation. */
  upsert?: InputMaybe<MetadataIdPhotoPrismaNestedUpsertPhotoCreateInput>;
};

export type MetadataIdPhotoPrismaNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.photo" relation. */
  update?: InputMaybe<MetadataIdPhotoPrismaNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataIdPhotoPrisma" node, through the "MetadataIdPhotoPrisma.photo" relation. */
  upsert?: InputMaybe<MetadataIdPhotoPrismaNestedUpsertPhotoUpdateInput>;
};

export type MetadataIdPhotoPrismaNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIdPhotoPrismaNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataIdPhotoPrismaOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataIdPhotoPrismaUpdateInput = {
  /** Actions for the "MetadataIdPhotoPrisma.archive" relation */
  archive?: InputMaybe<MetadataIdPhotoPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIdPhotoPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataIdPhotoPrismaNestedMetadataUpdateInput>;
  /** Actions for the "MetadataIdPhotoPrisma.photo" relation */
  photo?: InputMaybe<MetadataIdPhotoPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataIdPhotoPrisma" nodes by specifying some conditions */
export type MetadataIdPhotoPrismaWhereInput = {
  AND?: InputMaybe<Array<MetadataIdPhotoPrismaWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
  OR?: InputMaybe<Array<MetadataIdPhotoPrismaWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataIdPhotoPrisma" node. */
export type MetadataIdPhotoPrismaWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataIdPhotoPrismaWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataIdPhotoPrisma.metadata" relation */
  metadata: MetadataIdPhotoPrismaNestedMetadataCreateInput;
  /** Actions for the "MetadataIdPhotoPrisma.photo" relation */
  photo: MetadataIdPhotoPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdPhotoPrismaWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataIdPhotoPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataIdPhotoPrismaNestedMetadataUpdateInput>;
  /** Actions for the "MetadataIdPhotoPrisma.photo" relation */
  photo?: InputMaybe<MetadataIdPhotoPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdPhotoPrismaWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataIdPhotoPrisma.archive" relation */
  archive: MetadataIdPhotoPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataIdPhotoPrisma.photo" relation */
  photo: MetadataIdPhotoPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdPhotoPrismaWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataIdPhotoPrisma.archive" relation */
  archive?: InputMaybe<MetadataIdPhotoPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIdPhotoPrisma.photo" relation */
  photo?: InputMaybe<MetadataIdPhotoPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdPhotoPrismaWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataIdPhotoPrisma.archive" relation */
  archive: MetadataIdPhotoPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataIdPhotoPrisma.metadata" relation */
  metadata: MetadataIdPhotoPrismaNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdPhotoPrismaWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataIdPhotoPrisma.archive" relation */
  archive?: InputMaybe<MetadataIdPhotoPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIdPhotoPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataIdPhotoPrismaNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataIdSubject" resource's node */
export type MetadataIdSubject = {
  __typename?: 'MetadataIdSubject';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataIdSubjectCreateInput = {
  /** Actions for the "MetadataIdSubject.archive" relation */
  archive: MetadataIdSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataIdSubject.metadata" relation */
  metadata: MetadataIdSubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataIdSubject.photo" relation */
  photo: MetadataIdSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdSubjectNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataIdSubject" node, through the "MetadataIdSubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataIdSubject" node, through the "MetadataIdSubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataIdSubject" node, through the "MetadataIdSubject.archive" relation. */
  update?: InputMaybe<MetadataIdSubjectNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataIdSubject" node, through the "MetadataIdSubject.archive" relation. */
  upsert?: InputMaybe<MetadataIdSubjectNestedUpsertArchiveCreateInput>;
};

export type MetadataIdSubjectNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.archive" relation. */
  update?: InputMaybe<MetadataIdSubjectNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.archive" relation. */
  upsert?: InputMaybe<MetadataIdSubjectNestedUpsertArchiveUpdateInput>;
};

export type MetadataIdSubjectNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataIdSubject" node, through the "MetadataIdSubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataIdSubject" node, through the "MetadataIdSubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataIdSubject" node, through the "MetadataIdSubject.metadata" relation. */
  update?: InputMaybe<MetadataIdSubjectNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataIdSubject" node, through the "MetadataIdSubject.metadata" relation. */
  upsert?: InputMaybe<MetadataIdSubjectNestedUpsertMetadataCreateInput>;
};

export type MetadataIdSubjectNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.metadata" relation. */
  update?: InputMaybe<MetadataIdSubjectNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.metadata" relation. */
  upsert?: InputMaybe<MetadataIdSubjectNestedUpsertMetadataUpdateInput>;
};

export type MetadataIdSubjectNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataIdSubject" node, through the "MetadataIdSubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataIdSubject" node, through the "MetadataIdSubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataIdSubject" node, through the "MetadataIdSubject.photo" relation. */
  update?: InputMaybe<MetadataIdSubjectNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataIdSubject" node, through the "MetadataIdSubject.photo" relation. */
  upsert?: InputMaybe<MetadataIdSubjectNestedUpsertPhotoCreateInput>;
};

export type MetadataIdSubjectNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.photo" relation. */
  update?: InputMaybe<MetadataIdSubjectNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataIdSubject" node, through the "MetadataIdSubject.photo" relation. */
  upsert?: InputMaybe<MetadataIdSubjectNestedUpsertPhotoUpdateInput>;
};

export type MetadataIdSubjectNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIdSubjectNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataIdSubjectOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataIdSubjectUpdateInput = {
  /** Actions for the "MetadataIdSubject.archive" relation */
  archive?: InputMaybe<MetadataIdSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIdSubject.metadata" relation */
  metadata?: InputMaybe<MetadataIdSubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataIdSubject.photo" relation */
  photo?: InputMaybe<MetadataIdSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataIdSubject" nodes by specifying some conditions */
export type MetadataIdSubjectWhereInput = {
  AND?: InputMaybe<Array<MetadataIdSubjectWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataIdSubjectWhereInput>;
  OR?: InputMaybe<Array<MetadataIdSubjectWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataIdSubject" node. */
export type MetadataIdSubjectWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataIdSubjectWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataIdSubject.metadata" relation */
  metadata: MetadataIdSubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataIdSubject.photo" relation */
  photo: MetadataIdSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdSubjectWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataIdSubject.metadata" relation */
  metadata?: InputMaybe<MetadataIdSubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataIdSubject.photo" relation */
  photo?: InputMaybe<MetadataIdSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdSubjectWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataIdSubject.archive" relation */
  archive: MetadataIdSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataIdSubject.photo" relation */
  photo: MetadataIdSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdSubjectWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataIdSubject.archive" relation */
  archive?: InputMaybe<MetadataIdSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIdSubject.photo" relation */
  photo?: InputMaybe<MetadataIdSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdSubjectWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataIdSubject.archive" relation */
  archive: MetadataIdSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataIdSubject.metadata" relation */
  metadata: MetadataIdSubjectNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIdSubjectWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataIdSubject.archive" relation */
  archive?: InputMaybe<MetadataIdSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIdSubject.metadata" relation */
  metadata?: InputMaybe<MetadataIdSubjectNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataImageNotes" resource's node */
export type MetadataImageNotes = {
  __typename?: 'MetadataImageNotes';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataImageNotesCreateInput = {
  /** Actions for the "MetadataImageNotes.archive" relation */
  archive: MetadataImageNotesNestedArchiveCreateInput;
  /** Actions for the "MetadataImageNotes.metadata" relation */
  metadata: MetadataImageNotesNestedMetadataCreateInput;
  /** Actions for the "MetadataImageNotes.photo" relation */
  photo: MetadataImageNotesNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataImageNotesNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataImageNotes" node, through the "MetadataImageNotes.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataImageNotes" node, through the "MetadataImageNotes.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataImageNotes" node, through the "MetadataImageNotes.archive" relation. */
  update?: InputMaybe<MetadataImageNotesNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataImageNotes" node, through the "MetadataImageNotes.archive" relation. */
  upsert?: InputMaybe<MetadataImageNotesNestedUpsertArchiveCreateInput>;
};

export type MetadataImageNotesNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.archive" relation. */
  update?: InputMaybe<MetadataImageNotesNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.archive" relation. */
  upsert?: InputMaybe<MetadataImageNotesNestedUpsertArchiveUpdateInput>;
};

export type MetadataImageNotesNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataImageNotes" node, through the "MetadataImageNotes.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataImageNotes" node, through the "MetadataImageNotes.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataImageNotes" node, through the "MetadataImageNotes.metadata" relation. */
  update?: InputMaybe<MetadataImageNotesNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataImageNotes" node, through the "MetadataImageNotes.metadata" relation. */
  upsert?: InputMaybe<MetadataImageNotesNestedUpsertMetadataCreateInput>;
};

export type MetadataImageNotesNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.metadata" relation. */
  update?: InputMaybe<MetadataImageNotesNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.metadata" relation. */
  upsert?: InputMaybe<MetadataImageNotesNestedUpsertMetadataUpdateInput>;
};

export type MetadataImageNotesNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataImageNotes" node, through the "MetadataImageNotes.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataImageNotes" node, through the "MetadataImageNotes.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataImageNotes" node, through the "MetadataImageNotes.photo" relation. */
  update?: InputMaybe<MetadataImageNotesNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataImageNotes" node, through the "MetadataImageNotes.photo" relation. */
  upsert?: InputMaybe<MetadataImageNotesNestedUpsertPhotoCreateInput>;
};

export type MetadataImageNotesNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.photo" relation. */
  update?: InputMaybe<MetadataImageNotesNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataImageNotes" node, through the "MetadataImageNotes.photo" relation. */
  upsert?: InputMaybe<MetadataImageNotesNestedUpsertPhotoUpdateInput>;
};

export type MetadataImageNotesNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataImageNotesNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataImageNotesNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataImageNotesNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataImageNotesNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataImageNotesNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataImageNotesNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataImageNotesNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataImageNotesNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataImageNotesNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataImageNotesNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataImageNotesNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataImageNotesOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataImageNotesUpdateInput = {
  /** Actions for the "MetadataImageNotes.archive" relation */
  archive?: InputMaybe<MetadataImageNotesNestedArchiveUpdateInput>;
  /** Actions for the "MetadataImageNotes.metadata" relation */
  metadata?: InputMaybe<MetadataImageNotesNestedMetadataUpdateInput>;
  /** Actions for the "MetadataImageNotes.photo" relation */
  photo?: InputMaybe<MetadataImageNotesNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataImageNotes" nodes by specifying some conditions */
export type MetadataImageNotesWhereInput = {
  AND?: InputMaybe<Array<MetadataImageNotesWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataImageNotesWhereInput>;
  OR?: InputMaybe<Array<MetadataImageNotesWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataImageNotes" node. */
export type MetadataImageNotesWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataImageNotesWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataImageNotes.metadata" relation */
  metadata: MetadataImageNotesNestedMetadataCreateInput;
  /** Actions for the "MetadataImageNotes.photo" relation */
  photo: MetadataImageNotesNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataImageNotesWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataImageNotes.metadata" relation */
  metadata?: InputMaybe<MetadataImageNotesNestedMetadataUpdateInput>;
  /** Actions for the "MetadataImageNotes.photo" relation */
  photo?: InputMaybe<MetadataImageNotesNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataImageNotesWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataImageNotes.archive" relation */
  archive: MetadataImageNotesNestedArchiveCreateInput;
  /** Actions for the "MetadataImageNotes.photo" relation */
  photo: MetadataImageNotesNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataImageNotesWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataImageNotes.archive" relation */
  archive?: InputMaybe<MetadataImageNotesNestedArchiveUpdateInput>;
  /** Actions for the "MetadataImageNotes.photo" relation */
  photo?: InputMaybe<MetadataImageNotesNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataImageNotesWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataImageNotes.archive" relation */
  archive: MetadataImageNotesNestedArchiveCreateInput;
  /** Actions for the "MetadataImageNotes.metadata" relation */
  metadata: MetadataImageNotesNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataImageNotesWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataImageNotes.archive" relation */
  archive?: InputMaybe<MetadataImageNotesNestedArchiveUpdateInput>;
  /** Actions for the "MetadataImageNotes.metadata" relation */
  metadata?: InputMaybe<MetadataImageNotesNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataInstructions" resource's node */
export type MetadataInstructions = {
  __typename?: 'MetadataInstructions';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataInstructionsCreateInput = {
  /** Actions for the "MetadataInstructions.archive" relation */
  archive: MetadataInstructionsNestedArchiveCreateInput;
  /** Actions for the "MetadataInstructions.metadata" relation */
  metadata: MetadataInstructionsNestedMetadataCreateInput;
  /** Actions for the "MetadataInstructions.photo" relation */
  photo: MetadataInstructionsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataInstructionsNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataInstructions" node, through the "MetadataInstructions.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataInstructions" node, through the "MetadataInstructions.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataInstructions" node, through the "MetadataInstructions.archive" relation. */
  update?: InputMaybe<MetadataInstructionsNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataInstructions" node, through the "MetadataInstructions.archive" relation. */
  upsert?: InputMaybe<MetadataInstructionsNestedUpsertArchiveCreateInput>;
};

export type MetadataInstructionsNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataInstructions" node, through the "MetadataInstructions.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataInstructions" node, through the "MetadataInstructions.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataInstructions" node, through the "MetadataInstructions.archive" relation. */
  update?: InputMaybe<MetadataInstructionsNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataInstructions" node, through the "MetadataInstructions.archive" relation. */
  upsert?: InputMaybe<MetadataInstructionsNestedUpsertArchiveUpdateInput>;
};

export type MetadataInstructionsNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataInstructions" node, through the "MetadataInstructions.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataInstructions" node, through the "MetadataInstructions.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataInstructions" node, through the "MetadataInstructions.metadata" relation. */
  update?: InputMaybe<MetadataInstructionsNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataInstructions" node, through the "MetadataInstructions.metadata" relation. */
  upsert?: InputMaybe<MetadataInstructionsNestedUpsertMetadataCreateInput>;
};

export type MetadataInstructionsNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataInstructions" node, through the "MetadataInstructions.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataInstructions" node, through the "MetadataInstructions.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataInstructions" node, through the "MetadataInstructions.metadata" relation. */
  update?: InputMaybe<MetadataInstructionsNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataInstructions" node, through the "MetadataInstructions.metadata" relation. */
  upsert?: InputMaybe<MetadataInstructionsNestedUpsertMetadataUpdateInput>;
};

export type MetadataInstructionsNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataInstructions" node, through the "MetadataInstructions.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataInstructions" node, through the "MetadataInstructions.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataInstructions" node, through the "MetadataInstructions.photo" relation. */
  update?: InputMaybe<MetadataInstructionsNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataInstructions" node, through the "MetadataInstructions.photo" relation. */
  upsert?: InputMaybe<MetadataInstructionsNestedUpsertPhotoCreateInput>;
};

export type MetadataInstructionsNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataInstructions" node, through the "MetadataInstructions.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataInstructions" node, through the "MetadataInstructions.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataInstructions" node, through the "MetadataInstructions.photo" relation. */
  update?: InputMaybe<MetadataInstructionsNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataInstructions" node, through the "MetadataInstructions.photo" relation. */
  upsert?: InputMaybe<MetadataInstructionsNestedUpsertPhotoUpdateInput>;
};

export type MetadataInstructionsNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataInstructionsNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataInstructionsNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataInstructionsNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataInstructionsNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataInstructionsNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataInstructionsNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataInstructionsNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataInstructionsNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataInstructionsNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataInstructionsNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataInstructionsNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataInstructionsOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataInstructionsUpdateInput = {
  /** Actions for the "MetadataInstructions.archive" relation */
  archive?: InputMaybe<MetadataInstructionsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataInstructions.metadata" relation */
  metadata?: InputMaybe<MetadataInstructionsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataInstructions.photo" relation */
  photo?: InputMaybe<MetadataInstructionsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataInstructions" nodes by specifying some conditions */
export type MetadataInstructionsWhereInput = {
  AND?: InputMaybe<Array<MetadataInstructionsWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataInstructionsWhereInput>;
  OR?: InputMaybe<Array<MetadataInstructionsWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataInstructions" node. */
export type MetadataInstructionsWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataInstructionsWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataInstructions.metadata" relation */
  metadata: MetadataInstructionsNestedMetadataCreateInput;
  /** Actions for the "MetadataInstructions.photo" relation */
  photo: MetadataInstructionsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataInstructionsWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataInstructions.metadata" relation */
  metadata?: InputMaybe<MetadataInstructionsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataInstructions.photo" relation */
  photo?: InputMaybe<MetadataInstructionsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataInstructionsWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataInstructions.archive" relation */
  archive: MetadataInstructionsNestedArchiveCreateInput;
  /** Actions for the "MetadataInstructions.photo" relation */
  photo: MetadataInstructionsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataInstructionsWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataInstructions.archive" relation */
  archive?: InputMaybe<MetadataInstructionsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataInstructions.photo" relation */
  photo?: InputMaybe<MetadataInstructionsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataInstructionsWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataInstructions.archive" relation */
  archive: MetadataInstructionsNestedArchiveCreateInput;
  /** Actions for the "MetadataInstructions.metadata" relation */
  metadata: MetadataInstructionsNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataInstructionsWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataInstructions.archive" relation */
  archive?: InputMaybe<MetadataInstructionsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataInstructions.metadata" relation */
  metadata?: InputMaybe<MetadataInstructionsNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataIssue" resource's node */
export type MetadataIssue = {
  __typename?: 'MetadataIssue';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataIssueCreateInput = {
  /** Actions for the "MetadataIssue.archive" relation */
  archive: MetadataIssueNestedArchiveCreateInput;
  /** Actions for the "MetadataIssue.metadata" relation */
  metadata: MetadataIssueNestedMetadataCreateInput;
  /** Actions for the "MetadataIssue.photo" relation */
  photo: MetadataIssueNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIssueNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataIssue" node, through the "MetadataIssue.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataIssue" node, through the "MetadataIssue.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataIssue" node, through the "MetadataIssue.archive" relation. */
  update?: InputMaybe<MetadataIssueNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataIssue" node, through the "MetadataIssue.archive" relation. */
  upsert?: InputMaybe<MetadataIssueNestedUpsertArchiveCreateInput>;
};

export type MetadataIssueNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataIssue" node, through the "MetadataIssue.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataIssue" node, through the "MetadataIssue.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataIssue" node, through the "MetadataIssue.archive" relation. */
  update?: InputMaybe<MetadataIssueNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataIssue" node, through the "MetadataIssue.archive" relation. */
  upsert?: InputMaybe<MetadataIssueNestedUpsertArchiveUpdateInput>;
};

export type MetadataIssueNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataIssue" node, through the "MetadataIssue.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataIssue" node, through the "MetadataIssue.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataIssue" node, through the "MetadataIssue.metadata" relation. */
  update?: InputMaybe<MetadataIssueNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataIssue" node, through the "MetadataIssue.metadata" relation. */
  upsert?: InputMaybe<MetadataIssueNestedUpsertMetadataCreateInput>;
};

export type MetadataIssueNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataIssue" node, through the "MetadataIssue.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataIssue" node, through the "MetadataIssue.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataIssue" node, through the "MetadataIssue.metadata" relation. */
  update?: InputMaybe<MetadataIssueNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataIssue" node, through the "MetadataIssue.metadata" relation. */
  upsert?: InputMaybe<MetadataIssueNestedUpsertMetadataUpdateInput>;
};

export type MetadataIssueNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataIssue" node, through the "MetadataIssue.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataIssue" node, through the "MetadataIssue.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataIssue" node, through the "MetadataIssue.photo" relation. */
  update?: InputMaybe<MetadataIssueNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataIssue" node, through the "MetadataIssue.photo" relation. */
  upsert?: InputMaybe<MetadataIssueNestedUpsertPhotoCreateInput>;
};

export type MetadataIssueNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataIssue" node, through the "MetadataIssue.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataIssue" node, through the "MetadataIssue.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataIssue" node, through the "MetadataIssue.photo" relation. */
  update?: InputMaybe<MetadataIssueNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataIssue" node, through the "MetadataIssue.photo" relation. */
  upsert?: InputMaybe<MetadataIssueNestedUpsertPhotoUpdateInput>;
};

export type MetadataIssueNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIssueNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIssueNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIssueNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIssueNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIssueNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIssueNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIssueNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataIssueNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIssueNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataIssueNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataIssueNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataIssueOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataIssueUpdateInput = {
  /** Actions for the "MetadataIssue.archive" relation */
  archive?: InputMaybe<MetadataIssueNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIssue.metadata" relation */
  metadata?: InputMaybe<MetadataIssueNestedMetadataUpdateInput>;
  /** Actions for the "MetadataIssue.photo" relation */
  photo?: InputMaybe<MetadataIssueNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataIssue" nodes by specifying some conditions */
export type MetadataIssueWhereInput = {
  AND?: InputMaybe<Array<MetadataIssueWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataIssueWhereInput>;
  OR?: InputMaybe<Array<MetadataIssueWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataIssue" node. */
export type MetadataIssueWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataIssueWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataIssue.metadata" relation */
  metadata: MetadataIssueNestedMetadataCreateInput;
  /** Actions for the "MetadataIssue.photo" relation */
  photo: MetadataIssueNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIssueWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataIssue.metadata" relation */
  metadata?: InputMaybe<MetadataIssueNestedMetadataUpdateInput>;
  /** Actions for the "MetadataIssue.photo" relation */
  photo?: InputMaybe<MetadataIssueNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIssueWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataIssue.archive" relation */
  archive: MetadataIssueNestedArchiveCreateInput;
  /** Actions for the "MetadataIssue.photo" relation */
  photo: MetadataIssueNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIssueWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataIssue.archive" relation */
  archive?: InputMaybe<MetadataIssueNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIssue.photo" relation */
  photo?: InputMaybe<MetadataIssueNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIssueWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataIssue.archive" relation */
  archive: MetadataIssueNestedArchiveCreateInput;
  /** Actions for the "MetadataIssue.metadata" relation */
  metadata: MetadataIssueNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataIssueWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataIssue.archive" relation */
  archive?: InputMaybe<MetadataIssueNestedArchiveUpdateInput>;
  /** Actions for the "MetadataIssue.metadata" relation */
  metadata?: InputMaybe<MetadataIssueNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataKeywords" resource's node */
export type MetadataKeywords = {
  __typename?: 'MetadataKeywords';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataKeywordsCreateInput = {
  /** Actions for the "MetadataKeywords.archive" relation */
  archive: MetadataKeywordsNestedArchiveCreateInput;
  /** Actions for the "MetadataKeywords.metadata" relation */
  metadata: MetadataKeywordsNestedMetadataCreateInput;
  /** Actions for the "MetadataKeywords.photo" relation */
  photo: MetadataKeywordsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataKeywordsNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataKeywords" node, through the "MetadataKeywords.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataKeywords" node, through the "MetadataKeywords.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataKeywords" node, through the "MetadataKeywords.archive" relation. */
  update?: InputMaybe<MetadataKeywordsNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataKeywords" node, through the "MetadataKeywords.archive" relation. */
  upsert?: InputMaybe<MetadataKeywordsNestedUpsertArchiveCreateInput>;
};

export type MetadataKeywordsNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataKeywords" node, through the "MetadataKeywords.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataKeywords" node, through the "MetadataKeywords.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataKeywords" node, through the "MetadataKeywords.archive" relation. */
  update?: InputMaybe<MetadataKeywordsNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataKeywords" node, through the "MetadataKeywords.archive" relation. */
  upsert?: InputMaybe<MetadataKeywordsNestedUpsertArchiveUpdateInput>;
};

export type MetadataKeywordsNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataKeywords" node, through the "MetadataKeywords.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataKeywords" node, through the "MetadataKeywords.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataKeywords" node, through the "MetadataKeywords.metadata" relation. */
  update?: InputMaybe<MetadataKeywordsNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataKeywords" node, through the "MetadataKeywords.metadata" relation. */
  upsert?: InputMaybe<MetadataKeywordsNestedUpsertMetadataCreateInput>;
};

export type MetadataKeywordsNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataKeywords" node, through the "MetadataKeywords.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataKeywords" node, through the "MetadataKeywords.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataKeywords" node, through the "MetadataKeywords.metadata" relation. */
  update?: InputMaybe<MetadataKeywordsNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataKeywords" node, through the "MetadataKeywords.metadata" relation. */
  upsert?: InputMaybe<MetadataKeywordsNestedUpsertMetadataUpdateInput>;
};

export type MetadataKeywordsNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataKeywords" node, through the "MetadataKeywords.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataKeywords" node, through the "MetadataKeywords.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataKeywords" node, through the "MetadataKeywords.photo" relation. */
  update?: InputMaybe<MetadataKeywordsNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataKeywords" node, through the "MetadataKeywords.photo" relation. */
  upsert?: InputMaybe<MetadataKeywordsNestedUpsertPhotoCreateInput>;
};

export type MetadataKeywordsNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataKeywords" node, through the "MetadataKeywords.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataKeywords" node, through the "MetadataKeywords.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataKeywords" node, through the "MetadataKeywords.photo" relation. */
  update?: InputMaybe<MetadataKeywordsNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataKeywords" node, through the "MetadataKeywords.photo" relation. */
  upsert?: InputMaybe<MetadataKeywordsNestedUpsertPhotoUpdateInput>;
};

export type MetadataKeywordsNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataKeywordsNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataKeywordsNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataKeywordsNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataKeywordsNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataKeywordsNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataKeywordsNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataKeywordsNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataKeywordsNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataKeywordsNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataKeywordsNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataKeywordsNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataKeywordsOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataKeywordsUpdateInput = {
  /** Actions for the "MetadataKeywords.archive" relation */
  archive?: InputMaybe<MetadataKeywordsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataKeywords.metadata" relation */
  metadata?: InputMaybe<MetadataKeywordsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataKeywords.photo" relation */
  photo?: InputMaybe<MetadataKeywordsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataKeywords" nodes by specifying some conditions */
export type MetadataKeywordsWhereInput = {
  AND?: InputMaybe<Array<MetadataKeywordsWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataKeywordsWhereInput>;
  OR?: InputMaybe<Array<MetadataKeywordsWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataKeywords" node. */
export type MetadataKeywordsWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataKeywordsWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataKeywords.metadata" relation */
  metadata: MetadataKeywordsNestedMetadataCreateInput;
  /** Actions for the "MetadataKeywords.photo" relation */
  photo: MetadataKeywordsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataKeywordsWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataKeywords.metadata" relation */
  metadata?: InputMaybe<MetadataKeywordsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataKeywords.photo" relation */
  photo?: InputMaybe<MetadataKeywordsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataKeywordsWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataKeywords.archive" relation */
  archive: MetadataKeywordsNestedArchiveCreateInput;
  /** Actions for the "MetadataKeywords.photo" relation */
  photo: MetadataKeywordsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataKeywordsWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataKeywords.archive" relation */
  archive?: InputMaybe<MetadataKeywordsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataKeywords.photo" relation */
  photo?: InputMaybe<MetadataKeywordsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataKeywordsWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataKeywords.archive" relation */
  archive: MetadataKeywordsNestedArchiveCreateInput;
  /** Actions for the "MetadataKeywords.metadata" relation */
  metadata: MetadataKeywordsNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataKeywordsWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataKeywords.archive" relation */
  archive?: InputMaybe<MetadataKeywordsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataKeywords.metadata" relation */
  metadata?: InputMaybe<MetadataKeywordsNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum MetadataNameEnumType {
  AccessRights = 'AccessRights',
  AssetState = 'AssetState',
  Audience = 'Audience',
  BackupName = 'BackupName',
  BitmapGrayscalePicture = 'BitmapGrayscalePicture',
  Brand = 'Brand',
  BrandPrisma = 'BrandPrisma',
  BrandShortName = 'BrandShortName',
  Byline = 'Byline',
  Caption = 'Caption',
  CaptionAbstract = 'CaptionAbstract',
  Category = 'Category',
  CategoryPrisma = 'CategoryPrisma',
  Certificate = 'Certificate',
  Company = 'Company',
  CompanyShortName = 'CompanyShortName',
  ContainedIn = 'ContainedIn',
  CopyrightNotice = 'CopyrightNotice',
  CreatedTime = 'CreatedTime',
  creator = 'creator',
  Credit = 'Credit',
  CustomField1 = 'CustomField1',
  CustomField14 = 'CustomField14',
  CustomField15 = 'CustomField15',
  CustomField16 = 'CustomField16',
  CustomField17 = 'CustomField17',
  CustomField20 = 'CustomField20',
  CustomField3 = 'CustomField3',
  CustomField4 = 'CustomField4',
  CustomField5 = 'CustomField5',
  CustomField6 = 'CustomField6',
  CustomField7 = 'CustomField7',
  CustomField9 = 'CustomField9',
  DateCreated = 'DateCreated',
  DateTimeOriginal = 'DateTimeOriginal',
  DeliveryAccount = 'DeliveryAccount',
  DeliveryCompany = 'DeliveryCompany',
  DeliveryCopyright = 'DeliveryCopyright',
  DeliveryDateFolder = 'DeliveryDateFolder',
  DeliveryDateTime = 'DeliveryDateTime',
  DeliveryDcCreator = 'DeliveryDcCreator',
  DeliveryDcRights = 'DeliveryDcRights',
  DeliveryFileType = 'DeliveryFileType',
  DeliveryFolder = 'DeliveryFolder',
  DeliveryKind = 'DeliveryKind',
  DeliveryPath = 'DeliveryPath',
  DeliveryPersonShownintheImage = 'DeliveryPersonShownintheImage',
  DeliveryPhotoshopCredit = 'DeliveryPhotoshopCredit',
  DeliveryPhotoshopSource = 'DeliveryPhotoshopSource',
  DeliveryService = 'DeliveryService',
  DeliverySubject = 'DeliverySubject',
  DeliveryUnderSubject = 'DeliveryUnderSubject',
  Department = 'Department',
  description = 'description',
  DigitalAssetURL = 'DigitalAssetURL',
  Edition = 'Edition',
  EditStatus = 'EditStatus',
  EquipmentInstitution = 'EquipmentInstitution',
  EquipmentManufacturer = 'EquipmentManufacturer',
  ExifImageHeight = 'ExifImageHeight',
  ExifImageWidth = 'ExifImageWidth',
  FabStorage = 'FabStorage',
  FileInfoBitsPerPixel = 'FileInfoBitsPerPixel',
  FileInfoFrames = 'FileInfoFrames',
  FileInfoPhotometricInterpretation = 'FileInfoPhotometricInterpretation',
  FileInfoTransferSyntax = 'FileInfoTransferSyntax',
  FileStatus = 'FileStatus',
  Format = 'Format',
  Header = 'Header',
  HeaderPrisma = 'HeaderPrisma',
  Headline = 'Headline',
  History = 'History',
  ID_subject = 'ID_subject',
  IdAssignment = 'IdAssignment',
  IdPhotoPrisma = 'IdPhotoPrisma',
  ImageNotes = 'ImageNotes',
  Instructions = 'Instructions',
  Issue = 'Issue',
  Keywords = 'Keywords',
  Links = 'Links',
  MasterDocumentId = 'MasterDocumentId',
  MaxAvailHeight = 'MaxAvailHeight',
  MaxAvailWidth = 'MaxAvailWidth',
  morePermissions = 'morePermissions',
  ObjectCycle = 'ObjectCycle',
  ObjectName = 'ObjectName',
  OriginalName = 'OriginalName',
  Page = 'Page',
  PagePrisma = 'PagePrisma',
  PatientDOB = 'PatientDOB',
  PatientID = 'PatientID',
  PatientName = 'PatientName',
  PatientSex = 'PatientSex',
  PrepressPictureEditing = 'PrepressPictureEditing',
  PriceLevel = 'PriceLevel',
  PrintingProfile = 'PrintingProfile',
  ProcessHistory = 'ProcessHistory',
  ProcessStatus = 'ProcessStatus',
  Product = 'Product',
  Products = 'Products',
  publishingIssue = 'publishingIssue',
  publishingSubject = 'publishingSubject',
  QualifiedUsePrismaBy = 'QualifiedUsePrismaBy',
  QualifiedUsePrismaDate = 'QualifiedUsePrismaDate',
  QualifiedUsePrismaDuration = 'QualifiedUsePrismaDuration',
  RequiredPermission = 'RequiredPermission',
  ResolutionKind = 'ResolutionKind',
  rights = 'rights',
  Royaltyfree = 'Royaltyfree',
  SentTo = 'SentTo',
  SeriesDateTime = 'SeriesDateTime',
  SeriesDescription = 'SeriesDescription',
  SeriesModality = 'SeriesModality',
  SeriesNumber = 'SeriesNumber',
  Source = 'Source',
  SpecialInstructions = 'SpecialInstructions',
  StudyDateTime = 'StudyDateTime',
  StudyDescription = 'StudyDescription',
  StudyID = 'StudyID',
  StudyPhysician = 'StudyPhysician',
  subject = 'subject',
  SubjectCode = 'SubjectCode',
  SubjectPrisma = 'SubjectPrisma',
  title = 'title',
  TransferredBy = 'TransferredBy',
  TransferredByEmail = 'TransferredByEmail',
  TransferredByFullName = 'TransferredByFullName',
  Type = 'Type',
  Undersubject = 'Undersubject',
  UnderUnderSubject = 'UnderUnderSubject',
  UnitShortName = 'UnitShortName',
  UploadedBy = 'UploadedBy',
  UploadedByFullName = 'UploadedByFullName',
  UploadTime = 'UploadTime',
  Urgency = 'Urgency',
  UserDefined195 = 'UserDefined195',
  UserDefined237 = 'UserDefined237',
  UserDefined238 = 'UserDefined238',
  UserDefined239 = 'UserDefined239',
  UserDefined242 = 'UserDefined242',
  UserDefined62 = 'UserDefined62',
  Valid = 'Valid',
  WorkflowKind = 'WorkflowKind',
  XMPHistory = 'XMPHistory'
}

export type MetadataNestedMetadataAccessRightsListCreateInput = {
  /** Connect existing "MetadataAccessRights" nodes to the new "Metadata" node, through the "Metadata.metadataAccessRightsList" relation. */
  connect?: InputMaybe<Array<MetadataAccessRightsWhereUniqueInput>>;
  /** Create new "MetadataAccessRights" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataAccessRightsList" relation. */
  create?: InputMaybe<Array<MetadataAccessRightsWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataAccessRightsListUpdateInput = {
  /** Connect existing "MetadataAccessRights" nodes to the existing "Metadata" node, through the "Metadata.metadataAccessRightsList" relation. */
  connect?: InputMaybe<Array<MetadataAccessRightsWhereUniqueInput>>;
  /** Create new "MetadataAccessRights" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataAccessRightsList" relation. */
  create?: InputMaybe<Array<MetadataAccessRightsWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataAccessRights" nodes from the "Metadata.metadataAccessRightsList" relation. */
  delete?: InputMaybe<Array<MetadataAccessRightsWhereUniqueInput>>;
  /** Update existing "MetadataAccessRights" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataAccessRightsList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataAccessRightsListUpdateInput>>;
  /** Upsert existing "MetadataAccessRights" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataAccessRightsList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataAccessRightsListUpdateInput>>;
};

export type MetadataNestedMetadataAssetStateListCreateInput = {
  /** Connect existing "MetadataAssetState" nodes to the new "Metadata" node, through the "Metadata.metadataAssetStateList" relation. */
  connect?: InputMaybe<Array<MetadataAssetStateWhereUniqueInput>>;
  /** Create new "MetadataAssetState" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataAssetStateList" relation. */
  create?: InputMaybe<Array<MetadataAssetStateWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataAssetStateListUpdateInput = {
  /** Connect existing "MetadataAssetState" nodes to the existing "Metadata" node, through the "Metadata.metadataAssetStateList" relation. */
  connect?: InputMaybe<Array<MetadataAssetStateWhereUniqueInput>>;
  /** Create new "MetadataAssetState" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataAssetStateList" relation. */
  create?: InputMaybe<Array<MetadataAssetStateWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataAssetState" nodes from the "Metadata.metadataAssetStateList" relation. */
  delete?: InputMaybe<Array<MetadataAssetStateWhereUniqueInput>>;
  /** Update existing "MetadataAssetState" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataAssetStateList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataAssetStateListUpdateInput>>;
  /** Upsert existing "MetadataAssetState" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataAssetStateList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataAssetStateListUpdateInput>>;
};

export type MetadataNestedMetadataBackupNameListCreateInput = {
  /** Connect existing "MetadataBackupName" nodes to the new "Metadata" node, through the "Metadata.metadataBackupNameList" relation. */
  connect?: InputMaybe<Array<MetadataBackupNameWhereUniqueInput>>;
  /** Create new "MetadataBackupName" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataBackupNameList" relation. */
  create?: InputMaybe<Array<MetadataBackupNameWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataBackupNameListUpdateInput = {
  /** Connect existing "MetadataBackupName" nodes to the existing "Metadata" node, through the "Metadata.metadataBackupNameList" relation. */
  connect?: InputMaybe<Array<MetadataBackupNameWhereUniqueInput>>;
  /** Create new "MetadataBackupName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBackupNameList" relation. */
  create?: InputMaybe<Array<MetadataBackupNameWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataBackupName" nodes from the "Metadata.metadataBackupNameList" relation. */
  delete?: InputMaybe<Array<MetadataBackupNameWhereUniqueInput>>;
  /** Update existing "MetadataBackupName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBackupNameList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataBackupNameListUpdateInput>>;
  /** Upsert existing "MetadataBackupName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBackupNameList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataBackupNameListUpdateInput>>;
};

export type MetadataNestedMetadataBrandListCreateInput = {
  /** Connect existing "MetadataBrand" nodes to the new "Metadata" node, through the "Metadata.metadataBrandList" relation. */
  connect?: InputMaybe<Array<MetadataBrandWhereUniqueInput>>;
  /** Create new "MetadataBrand" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataBrandList" relation. */
  create?: InputMaybe<Array<MetadataBrandWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataBrandListUpdateInput = {
  /** Connect existing "MetadataBrand" nodes to the existing "Metadata" node, through the "Metadata.metadataBrandList" relation. */
  connect?: InputMaybe<Array<MetadataBrandWhereUniqueInput>>;
  /** Create new "MetadataBrand" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBrandList" relation. */
  create?: InputMaybe<Array<MetadataBrandWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataBrand" nodes from the "Metadata.metadataBrandList" relation. */
  delete?: InputMaybe<Array<MetadataBrandWhereUniqueInput>>;
  /** Update existing "MetadataBrand" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBrandList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataBrandListUpdateInput>>;
  /** Upsert existing "MetadataBrand" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBrandList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataBrandListUpdateInput>>;
};

export type MetadataNestedMetadataBrandPrismaListCreateInput = {
  /** Connect existing "MetadataBrandPrisma" nodes to the new "Metadata" node, through the "Metadata.metadataBrandPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataBrandPrismaWhereUniqueInput>>;
  /** Create new "MetadataBrandPrisma" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataBrandPrismaList" relation. */
  create?: InputMaybe<Array<MetadataBrandPrismaWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataBrandPrismaListUpdateInput = {
  /** Connect existing "MetadataBrandPrisma" nodes to the existing "Metadata" node, through the "Metadata.metadataBrandPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataBrandPrismaWhereUniqueInput>>;
  /** Create new "MetadataBrandPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBrandPrismaList" relation. */
  create?: InputMaybe<Array<MetadataBrandPrismaWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataBrandPrisma" nodes from the "Metadata.metadataBrandPrismaList" relation. */
  delete?: InputMaybe<Array<MetadataBrandPrismaWhereUniqueInput>>;
  /** Update existing "MetadataBrandPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBrandPrismaList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataBrandPrismaListUpdateInput>>;
  /** Upsert existing "MetadataBrandPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBrandPrismaList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataBrandPrismaListUpdateInput>>;
};

export type MetadataNestedMetadataBrandShortNameListCreateInput = {
  /** Connect existing "MetadataBrandShortName" nodes to the new "Metadata" node, through the "Metadata.metadataBrandShortNameList" relation. */
  connect?: InputMaybe<Array<MetadataBrandShortNameWhereUniqueInput>>;
  /** Create new "MetadataBrandShortName" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataBrandShortNameList" relation. */
  create?: InputMaybe<Array<MetadataBrandShortNameWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataBrandShortNameListUpdateInput = {
  /** Connect existing "MetadataBrandShortName" nodes to the existing "Metadata" node, through the "Metadata.metadataBrandShortNameList" relation. */
  connect?: InputMaybe<Array<MetadataBrandShortNameWhereUniqueInput>>;
  /** Create new "MetadataBrandShortName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBrandShortNameList" relation. */
  create?: InputMaybe<Array<MetadataBrandShortNameWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataBrandShortName" nodes from the "Metadata.metadataBrandShortNameList" relation. */
  delete?: InputMaybe<Array<MetadataBrandShortNameWhereUniqueInput>>;
  /** Update existing "MetadataBrandShortName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBrandShortNameList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataBrandShortNameListUpdateInput>>;
  /** Upsert existing "MetadataBrandShortName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataBrandShortNameList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataBrandShortNameListUpdateInput>>;
};

export type MetadataNestedMetadataByLineListCreateInput = {
  /** Connect existing "MetadataByLine" nodes to the new "Metadata" node, through the "Metadata.metadataByLineList" relation. */
  connect?: InputMaybe<Array<MetadataByLineWhereUniqueInput>>;
  /** Create new "MetadataByLine" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataByLineList" relation. */
  create?: InputMaybe<Array<MetadataByLineWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataByLineListUpdateInput = {
  /** Connect existing "MetadataByLine" nodes to the existing "Metadata" node, through the "Metadata.metadataByLineList" relation. */
  connect?: InputMaybe<Array<MetadataByLineWhereUniqueInput>>;
  /** Create new "MetadataByLine" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataByLineList" relation. */
  create?: InputMaybe<Array<MetadataByLineWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataByLine" nodes from the "Metadata.metadataByLineList" relation. */
  delete?: InputMaybe<Array<MetadataByLineWhereUniqueInput>>;
  /** Update existing "MetadataByLine" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataByLineList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataByLineListUpdateInput>>;
  /** Upsert existing "MetadataByLine" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataByLineList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataByLineListUpdateInput>>;
};

export type MetadataNestedMetadataCaptionAbstractListCreateInput = {
  /** Connect existing "MetadataCaptionAbstract" nodes to the new "Metadata" node, through the "Metadata.metadataCaptionAbstractList" relation. */
  connect?: InputMaybe<Array<MetadataCaptionAbstractWhereUniqueInput>>;
  /** Create new "MetadataCaptionAbstract" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCaptionAbstractList" relation. */
  create?: InputMaybe<Array<MetadataCaptionAbstractWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCaptionAbstractListUpdateInput = {
  /** Connect existing "MetadataCaptionAbstract" nodes to the existing "Metadata" node, through the "Metadata.metadataCaptionAbstractList" relation. */
  connect?: InputMaybe<Array<MetadataCaptionAbstractWhereUniqueInput>>;
  /** Create new "MetadataCaptionAbstract" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCaptionAbstractList" relation. */
  create?: InputMaybe<Array<MetadataCaptionAbstractWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCaptionAbstract" nodes from the "Metadata.metadataCaptionAbstractList" relation. */
  delete?: InputMaybe<Array<MetadataCaptionAbstractWhereUniqueInput>>;
  /** Update existing "MetadataCaptionAbstract" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCaptionAbstractList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCaptionAbstractListUpdateInput>>;
  /** Upsert existing "MetadataCaptionAbstract" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCaptionAbstractList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCaptionAbstractListUpdateInput>>;
};

export type MetadataNestedMetadataCaptionListCreateInput = {
  /** Connect existing "MetadataCaption" nodes to the new "Metadata" node, through the "Metadata.metadataCaptionList" relation. */
  connect?: InputMaybe<Array<MetadataCaptionWhereUniqueInput>>;
  /** Create new "MetadataCaption" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCaptionList" relation. */
  create?: InputMaybe<Array<MetadataCaptionWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCaptionListUpdateInput = {
  /** Connect existing "MetadataCaption" nodes to the existing "Metadata" node, through the "Metadata.metadataCaptionList" relation. */
  connect?: InputMaybe<Array<MetadataCaptionWhereUniqueInput>>;
  /** Create new "MetadataCaption" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCaptionList" relation. */
  create?: InputMaybe<Array<MetadataCaptionWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCaption" nodes from the "Metadata.metadataCaptionList" relation. */
  delete?: InputMaybe<Array<MetadataCaptionWhereUniqueInput>>;
  /** Update existing "MetadataCaption" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCaptionList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCaptionListUpdateInput>>;
  /** Upsert existing "MetadataCaption" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCaptionList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCaptionListUpdateInput>>;
};

export type MetadataNestedMetadataCategoryListCreateInput = {
  /** Connect existing "MetadataCategory" nodes to the new "Metadata" node, through the "Metadata.metadataCategoryList" relation. */
  connect?: InputMaybe<Array<MetadataCategoryWhereUniqueInput>>;
  /** Create new "MetadataCategory" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCategoryList" relation. */
  create?: InputMaybe<Array<MetadataCategoryWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCategoryListUpdateInput = {
  /** Connect existing "MetadataCategory" nodes to the existing "Metadata" node, through the "Metadata.metadataCategoryList" relation. */
  connect?: InputMaybe<Array<MetadataCategoryWhereUniqueInput>>;
  /** Create new "MetadataCategory" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCategoryList" relation. */
  create?: InputMaybe<Array<MetadataCategoryWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCategory" nodes from the "Metadata.metadataCategoryList" relation. */
  delete?: InputMaybe<Array<MetadataCategoryWhereUniqueInput>>;
  /** Update existing "MetadataCategory" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCategoryList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCategoryListUpdateInput>>;
  /** Upsert existing "MetadataCategory" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCategoryList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCategoryListUpdateInput>>;
};

export type MetadataNestedMetadataCategoryPrismaListCreateInput = {
  /** Connect existing "MetadataCategoryPrisma" nodes to the new "Metadata" node, through the "Metadata.metadataCategoryPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataCategoryPrismaWhereUniqueInput>>;
  /** Create new "MetadataCategoryPrisma" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCategoryPrismaList" relation. */
  create?: InputMaybe<Array<MetadataCategoryPrismaWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCategoryPrismaListUpdateInput = {
  /** Connect existing "MetadataCategoryPrisma" nodes to the existing "Metadata" node, through the "Metadata.metadataCategoryPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataCategoryPrismaWhereUniqueInput>>;
  /** Create new "MetadataCategoryPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCategoryPrismaList" relation. */
  create?: InputMaybe<Array<MetadataCategoryPrismaWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCategoryPrisma" nodes from the "Metadata.metadataCategoryPrismaList" relation. */
  delete?: InputMaybe<Array<MetadataCategoryPrismaWhereUniqueInput>>;
  /** Update existing "MetadataCategoryPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCategoryPrismaList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCategoryPrismaListUpdateInput>>;
  /** Upsert existing "MetadataCategoryPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCategoryPrismaList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCategoryPrismaListUpdateInput>>;
};

export type MetadataNestedMetadataCompanyListCreateInput = {
  /** Connect existing "MetadataCompany" nodes to the new "Metadata" node, through the "Metadata.metadataCompanyList" relation. */
  connect?: InputMaybe<Array<MetadataCompanyWhereUniqueInput>>;
  /** Create new "MetadataCompany" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCompanyList" relation. */
  create?: InputMaybe<Array<MetadataCompanyWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCompanyListUpdateInput = {
  /** Connect existing "MetadataCompany" nodes to the existing "Metadata" node, through the "Metadata.metadataCompanyList" relation. */
  connect?: InputMaybe<Array<MetadataCompanyWhereUniqueInput>>;
  /** Create new "MetadataCompany" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCompanyList" relation. */
  create?: InputMaybe<Array<MetadataCompanyWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCompany" nodes from the "Metadata.metadataCompanyList" relation. */
  delete?: InputMaybe<Array<MetadataCompanyWhereUniqueInput>>;
  /** Update existing "MetadataCompany" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCompanyList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCompanyListUpdateInput>>;
  /** Upsert existing "MetadataCompany" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCompanyList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCompanyListUpdateInput>>;
};

export type MetadataNestedMetadataCompanyShortNameListCreateInput = {
  /** Connect existing "MetadataCompanyShortName" nodes to the new "Metadata" node, through the "Metadata.metadataCompanyShortNameList" relation. */
  connect?: InputMaybe<Array<MetadataCompanyShortNameWhereUniqueInput>>;
  /** Create new "MetadataCompanyShortName" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCompanyShortNameList" relation. */
  create?: InputMaybe<Array<MetadataCompanyShortNameWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCompanyShortNameListUpdateInput = {
  /** Connect existing "MetadataCompanyShortName" nodes to the existing "Metadata" node, through the "Metadata.metadataCompanyShortNameList" relation. */
  connect?: InputMaybe<Array<MetadataCompanyShortNameWhereUniqueInput>>;
  /** Create new "MetadataCompanyShortName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCompanyShortNameList" relation. */
  create?: InputMaybe<Array<MetadataCompanyShortNameWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCompanyShortName" nodes from the "Metadata.metadataCompanyShortNameList" relation. */
  delete?: InputMaybe<Array<MetadataCompanyShortNameWhereUniqueInput>>;
  /** Update existing "MetadataCompanyShortName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCompanyShortNameList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCompanyShortNameListUpdateInput>>;
  /** Upsert existing "MetadataCompanyShortName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCompanyShortNameList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCompanyShortNameListUpdateInput>>;
};

export type MetadataNestedMetadataCopyrightNoticeListCreateInput = {
  /** Connect existing "MetadataCopyrightNotice" nodes to the new "Metadata" node, through the "Metadata.metadataCopyrightNoticeList" relation. */
  connect?: InputMaybe<Array<MetadataCopyrightNoticeWhereUniqueInput>>;
  /** Create new "MetadataCopyrightNotice" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCopyrightNoticeList" relation. */
  create?: InputMaybe<Array<MetadataCopyrightNoticeWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCopyrightNoticeListUpdateInput = {
  /** Connect existing "MetadataCopyrightNotice" nodes to the existing "Metadata" node, through the "Metadata.metadataCopyrightNoticeList" relation. */
  connect?: InputMaybe<Array<MetadataCopyrightNoticeWhereUniqueInput>>;
  /** Create new "MetadataCopyrightNotice" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCopyrightNoticeList" relation. */
  create?: InputMaybe<Array<MetadataCopyrightNoticeWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCopyrightNotice" nodes from the "Metadata.metadataCopyrightNoticeList" relation. */
  delete?: InputMaybe<Array<MetadataCopyrightNoticeWhereUniqueInput>>;
  /** Update existing "MetadataCopyrightNotice" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCopyrightNoticeList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCopyrightNoticeListUpdateInput>>;
  /** Upsert existing "MetadataCopyrightNotice" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCopyrightNoticeList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCopyrightNoticeListUpdateInput>>;
};

export type MetadataNestedMetadataCreatorListCreateInput = {
  /** Connect existing "MetadataCreator" nodes to the new "Metadata" node, through the "Metadata.metadataCreatorList" relation. */
  connect?: InputMaybe<Array<MetadataCreatorWhereUniqueInput>>;
  /** Create new "MetadataCreator" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCreatorList" relation. */
  create?: InputMaybe<Array<MetadataCreatorWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCreatorListUpdateInput = {
  /** Connect existing "MetadataCreator" nodes to the existing "Metadata" node, through the "Metadata.metadataCreatorList" relation. */
  connect?: InputMaybe<Array<MetadataCreatorWhereUniqueInput>>;
  /** Create new "MetadataCreator" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCreatorList" relation. */
  create?: InputMaybe<Array<MetadataCreatorWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCreator" nodes from the "Metadata.metadataCreatorList" relation. */
  delete?: InputMaybe<Array<MetadataCreatorWhereUniqueInput>>;
  /** Update existing "MetadataCreator" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCreatorList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCreatorListUpdateInput>>;
  /** Upsert existing "MetadataCreator" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCreatorList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCreatorListUpdateInput>>;
};

export type MetadataNestedMetadataCreditListCreateInput = {
  /** Connect existing "MetadataCredit" nodes to the new "Metadata" node, through the "Metadata.metadataCreditList" relation. */
  connect?: InputMaybe<Array<MetadataCreditWhereUniqueInput>>;
  /** Create new "MetadataCredit" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCreditList" relation. */
  create?: InputMaybe<Array<MetadataCreditWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCreditListUpdateInput = {
  /** Connect existing "MetadataCredit" nodes to the existing "Metadata" node, through the "Metadata.metadataCreditList" relation. */
  connect?: InputMaybe<Array<MetadataCreditWhereUniqueInput>>;
  /** Create new "MetadataCredit" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCreditList" relation. */
  create?: InputMaybe<Array<MetadataCreditWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCredit" nodes from the "Metadata.metadataCreditList" relation. */
  delete?: InputMaybe<Array<MetadataCreditWhereUniqueInput>>;
  /** Update existing "MetadataCredit" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCreditList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCreditListUpdateInput>>;
  /** Upsert existing "MetadataCredit" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCreditList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCreditListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField14ListCreateInput = {
  /** Connect existing "MetadataCustomField14" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField14List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField14WhereUniqueInput>>;
  /** Create new "MetadataCustomField14" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField14List" relation. */
  create?: InputMaybe<Array<MetadataCustomField14WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField14ListUpdateInput = {
  /** Connect existing "MetadataCustomField14" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField14List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField14WhereUniqueInput>>;
  /** Create new "MetadataCustomField14" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField14List" relation. */
  create?: InputMaybe<Array<MetadataCustomField14WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField14" nodes from the "Metadata.metadataCustomField14List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField14WhereUniqueInput>>;
  /** Update existing "MetadataCustomField14" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField14List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField14ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField14" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField14List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField14ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField15ListCreateInput = {
  /** Connect existing "MetadataCustomField15" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField15List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField15WhereUniqueInput>>;
  /** Create new "MetadataCustomField15" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField15List" relation. */
  create?: InputMaybe<Array<MetadataCustomField15WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField15ListUpdateInput = {
  /** Connect existing "MetadataCustomField15" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField15List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField15WhereUniqueInput>>;
  /** Create new "MetadataCustomField15" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField15List" relation. */
  create?: InputMaybe<Array<MetadataCustomField15WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField15" nodes from the "Metadata.metadataCustomField15List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField15WhereUniqueInput>>;
  /** Update existing "MetadataCustomField15" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField15List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField15ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField15" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField15List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField15ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField16ListCreateInput = {
  /** Connect existing "MetadataCustomField16" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField16List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField16WhereUniqueInput>>;
  /** Create new "MetadataCustomField16" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField16List" relation. */
  create?: InputMaybe<Array<MetadataCustomField16WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField16ListUpdateInput = {
  /** Connect existing "MetadataCustomField16" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField16List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField16WhereUniqueInput>>;
  /** Create new "MetadataCustomField16" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField16List" relation. */
  create?: InputMaybe<Array<MetadataCustomField16WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField16" nodes from the "Metadata.metadataCustomField16List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField16WhereUniqueInput>>;
  /** Update existing "MetadataCustomField16" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField16List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField16ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField16" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField16List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField16ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField17ListCreateInput = {
  /** Connect existing "MetadataCustomField17" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField17List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField17WhereUniqueInput>>;
  /** Create new "MetadataCustomField17" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField17List" relation. */
  create?: InputMaybe<Array<MetadataCustomField17WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField17ListUpdateInput = {
  /** Connect existing "MetadataCustomField17" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField17List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField17WhereUniqueInput>>;
  /** Create new "MetadataCustomField17" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField17List" relation. */
  create?: InputMaybe<Array<MetadataCustomField17WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField17" nodes from the "Metadata.metadataCustomField17List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField17WhereUniqueInput>>;
  /** Update existing "MetadataCustomField17" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField17List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField17ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField17" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField17List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField17ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField1ListCreateInput = {
  /** Connect existing "MetadataCustomField1" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField1List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField1WhereUniqueInput>>;
  /** Create new "MetadataCustomField1" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField1List" relation. */
  create?: InputMaybe<Array<MetadataCustomField1WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField1ListUpdateInput = {
  /** Connect existing "MetadataCustomField1" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField1List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField1WhereUniqueInput>>;
  /** Create new "MetadataCustomField1" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField1List" relation. */
  create?: InputMaybe<Array<MetadataCustomField1WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField1" nodes from the "Metadata.metadataCustomField1List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField1WhereUniqueInput>>;
  /** Update existing "MetadataCustomField1" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField1List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField1ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField1" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField1List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField1ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField20ListCreateInput = {
  /** Connect existing "MetadataCustomField20" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField20List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField20WhereUniqueInput>>;
  /** Create new "MetadataCustomField20" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField20List" relation. */
  create?: InputMaybe<Array<MetadataCustomField20WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField20ListUpdateInput = {
  /** Connect existing "MetadataCustomField20" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField20List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField20WhereUniqueInput>>;
  /** Create new "MetadataCustomField20" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField20List" relation. */
  create?: InputMaybe<Array<MetadataCustomField20WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField20" nodes from the "Metadata.metadataCustomField20List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField20WhereUniqueInput>>;
  /** Update existing "MetadataCustomField20" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField20List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField20ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField20" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField20List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField20ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField3ListCreateInput = {
  /** Connect existing "MetadataCustomField3" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField3List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField3WhereUniqueInput>>;
  /** Create new "MetadataCustomField3" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField3List" relation. */
  create?: InputMaybe<Array<MetadataCustomField3WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField3ListUpdateInput = {
  /** Connect existing "MetadataCustomField3" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField3List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField3WhereUniqueInput>>;
  /** Create new "MetadataCustomField3" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField3List" relation. */
  create?: InputMaybe<Array<MetadataCustomField3WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField3" nodes from the "Metadata.metadataCustomField3List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField3WhereUniqueInput>>;
  /** Update existing "MetadataCustomField3" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField3List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField3ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField3" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField3List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField3ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField4ListCreateInput = {
  /** Connect existing "MetadataCustomField4" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField4List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField4WhereUniqueInput>>;
  /** Create new "MetadataCustomField4" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField4List" relation. */
  create?: InputMaybe<Array<MetadataCustomField4WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField4ListUpdateInput = {
  /** Connect existing "MetadataCustomField4" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField4List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField4WhereUniqueInput>>;
  /** Create new "MetadataCustomField4" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField4List" relation. */
  create?: InputMaybe<Array<MetadataCustomField4WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField4" nodes from the "Metadata.metadataCustomField4List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField4WhereUniqueInput>>;
  /** Update existing "MetadataCustomField4" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField4List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField4ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField4" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField4List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField4ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField5ListCreateInput = {
  /** Connect existing "MetadataCustomField5" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField5List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField5WhereUniqueInput>>;
  /** Create new "MetadataCustomField5" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField5List" relation. */
  create?: InputMaybe<Array<MetadataCustomField5WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField5ListUpdateInput = {
  /** Connect existing "MetadataCustomField5" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField5List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField5WhereUniqueInput>>;
  /** Create new "MetadataCustomField5" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField5List" relation. */
  create?: InputMaybe<Array<MetadataCustomField5WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField5" nodes from the "Metadata.metadataCustomField5List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField5WhereUniqueInput>>;
  /** Update existing "MetadataCustomField5" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField5List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField5ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField5" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField5List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField5ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField6ListCreateInput = {
  /** Connect existing "MetadataCustomField6" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField6List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField6WhereUniqueInput>>;
  /** Create new "MetadataCustomField6" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField6List" relation. */
  create?: InputMaybe<Array<MetadataCustomField6WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField6ListUpdateInput = {
  /** Connect existing "MetadataCustomField6" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField6List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField6WhereUniqueInput>>;
  /** Create new "MetadataCustomField6" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField6List" relation. */
  create?: InputMaybe<Array<MetadataCustomField6WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField6" nodes from the "Metadata.metadataCustomField6List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField6WhereUniqueInput>>;
  /** Update existing "MetadataCustomField6" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField6List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField6ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField6" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField6List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField6ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField7ListCreateInput = {
  /** Connect existing "MetadataCustomField7" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField7List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField7WhereUniqueInput>>;
  /** Create new "MetadataCustomField7" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField7List" relation. */
  create?: InputMaybe<Array<MetadataCustomField7WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField7ListUpdateInput = {
  /** Connect existing "MetadataCustomField7" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField7List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField7WhereUniqueInput>>;
  /** Create new "MetadataCustomField7" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField7List" relation. */
  create?: InputMaybe<Array<MetadataCustomField7WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField7" nodes from the "Metadata.metadataCustomField7List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField7WhereUniqueInput>>;
  /** Update existing "MetadataCustomField7" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField7List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField7ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField7" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField7List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField7ListUpdateInput>>;
};

export type MetadataNestedMetadataCustomField9ListCreateInput = {
  /** Connect existing "MetadataCustomField9" nodes to the new "Metadata" node, through the "Metadata.metadataCustomField9List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField9WhereUniqueInput>>;
  /** Create new "MetadataCustomField9" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataCustomField9List" relation. */
  create?: InputMaybe<Array<MetadataCustomField9WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataCustomField9ListUpdateInput = {
  /** Connect existing "MetadataCustomField9" nodes to the existing "Metadata" node, through the "Metadata.metadataCustomField9List" relation. */
  connect?: InputMaybe<Array<MetadataCustomField9WhereUniqueInput>>;
  /** Create new "MetadataCustomField9" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField9List" relation. */
  create?: InputMaybe<Array<MetadataCustomField9WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataCustomField9" nodes from the "Metadata.metadataCustomField9List" relation. */
  delete?: InputMaybe<Array<MetadataCustomField9WhereUniqueInput>>;
  /** Update existing "MetadataCustomField9" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField9List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataCustomField9ListUpdateInput>>;
  /** Upsert existing "MetadataCustomField9" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataCustomField9List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataCustomField9ListUpdateInput>>;
};

export type MetadataNestedMetadataDateCreatedListCreateInput = {
  /** Connect existing "MetadataDateCreated" nodes to the new "Metadata" node, through the "Metadata.metadataDateCreatedList" relation. */
  connect?: InputMaybe<Array<MetadataDateCreatedWhereUniqueInput>>;
  /** Create new "MetadataDateCreated" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDateCreatedList" relation. */
  create?: InputMaybe<Array<MetadataDateCreatedWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDateCreatedListUpdateInput = {
  /** Connect existing "MetadataDateCreated" nodes to the existing "Metadata" node, through the "Metadata.metadataDateCreatedList" relation. */
  connect?: InputMaybe<Array<MetadataDateCreatedWhereUniqueInput>>;
  /** Create new "MetadataDateCreated" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDateCreatedList" relation. */
  create?: InputMaybe<Array<MetadataDateCreatedWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDateCreated" nodes from the "Metadata.metadataDateCreatedList" relation. */
  delete?: InputMaybe<Array<MetadataDateCreatedWhereUniqueInput>>;
  /** Update existing "MetadataDateCreated" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDateCreatedList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDateCreatedListUpdateInput>>;
  /** Upsert existing "MetadataDateCreated" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDateCreatedList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDateCreatedListUpdateInput>>;
};

export type MetadataNestedMetadataDateTimeOriginalListCreateInput = {
  /** Connect existing "MetadataDateTimeOriginal" nodes to the new "Metadata" node, through the "Metadata.metadataDateTimeOriginalList" relation. */
  connect?: InputMaybe<Array<MetadataDateTimeOriginalWhereUniqueInput>>;
  /** Create new "MetadataDateTimeOriginal" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDateTimeOriginalList" relation. */
  create?: InputMaybe<Array<MetadataDateTimeOriginalWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDateTimeOriginalListUpdateInput = {
  /** Connect existing "MetadataDateTimeOriginal" nodes to the existing "Metadata" node, through the "Metadata.metadataDateTimeOriginalList" relation. */
  connect?: InputMaybe<Array<MetadataDateTimeOriginalWhereUniqueInput>>;
  /** Create new "MetadataDateTimeOriginal" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDateTimeOriginalList" relation. */
  create?: InputMaybe<Array<MetadataDateTimeOriginalWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDateTimeOriginal" nodes from the "Metadata.metadataDateTimeOriginalList" relation. */
  delete?: InputMaybe<Array<MetadataDateTimeOriginalWhereUniqueInput>>;
  /** Update existing "MetadataDateTimeOriginal" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDateTimeOriginalList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDateTimeOriginalListUpdateInput>>;
  /** Upsert existing "MetadataDateTimeOriginal" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDateTimeOriginalList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDateTimeOriginalListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryAccountListCreateInput = {
  /** Connect existing "MetadataDeliveryAccount" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryAccountList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryAccountWhereUniqueInput>>;
  /** Create new "MetadataDeliveryAccount" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryAccountList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryAccountWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryAccountListUpdateInput = {
  /** Connect existing "MetadataDeliveryAccount" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryAccountList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryAccountWhereUniqueInput>>;
  /** Create new "MetadataDeliveryAccount" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryAccountList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryAccountWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryAccount" nodes from the "Metadata.metadataDeliveryAccountList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryAccountWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryAccount" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryAccountList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryAccountListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryAccount" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryAccountList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryAccountListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryCompanyListCreateInput = {
  /** Connect existing "MetadataDeliveryCompany" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryCompanyList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCompanyWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCompany" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryCompanyList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCompanyWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryCompanyListUpdateInput = {
  /** Connect existing "MetadataDeliveryCompany" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryCompanyList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCompanyWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCompany" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryCompanyList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCompanyWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryCompany" nodes from the "Metadata.metadataDeliveryCompanyList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryCompanyWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryCompany" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryCompanyList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryCompanyListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryCompany" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryCompanyList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryCompanyListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryCopyrightListCreateInput = {
  /** Connect existing "MetadataDeliveryCopyright" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryCopyrightList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCopyrightWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCopyright" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryCopyrightList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCopyrightWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryCopyrightListUpdateInput = {
  /** Connect existing "MetadataDeliveryCopyright" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryCopyrightList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCopyrightWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCopyright" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryCopyrightList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCopyrightWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryCopyright" nodes from the "Metadata.metadataDeliveryCopyrightList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryCopyrightWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryCopyright" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryCopyrightList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryCopyrightListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryCopyright" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryCopyrightList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryCopyrightListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryDateFolderListCreateInput = {
  /** Connect existing "MetadataDeliveryDateFolder" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryDateFolderList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateFolder" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryDateFolderList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateFolderWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryDateFolderListUpdateInput = {
  /** Connect existing "MetadataDeliveryDateFolder" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryDateFolderList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateFolder" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDateFolderList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateFolderWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryDateFolder" nodes from the "Metadata.metadataDeliveryDateFolderList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDateFolderWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDateFolder" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDateFolderList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryDateFolderListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDateFolder" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDateFolderList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryDateFolderListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryDateTimeListCreateInput = {
  /** Connect existing "MetadataDeliveryDateTime" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryDateTimeList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateTimeWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateTime" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryDateTimeList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateTimeWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryDateTimeListUpdateInput = {
  /** Connect existing "MetadataDeliveryDateTime" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryDateTimeList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateTimeWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateTime" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDateTimeList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateTimeWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryDateTime" nodes from the "Metadata.metadataDeliveryDateTimeList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDateTimeWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDateTime" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDateTimeList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryDateTimeListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDateTime" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDateTimeList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryDateTimeListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryDcCreatorListCreateInput = {
  /** Connect existing "MetadataDeliveryDcCreator" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryDcCreatorList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcCreator" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryDcCreatorList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcCreatorWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryDcCreatorListUpdateInput = {
  /** Connect existing "MetadataDeliveryDcCreator" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryDcCreatorList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcCreator" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDcCreatorList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcCreatorWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryDcCreator" nodes from the "Metadata.metadataDeliveryDcCreatorList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDcCreator" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDcCreatorList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryDcCreatorListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDcCreator" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDcCreatorList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryDcCreatorListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryDcRightsListCreateInput = {
  /** Connect existing "MetadataDeliveryDcRights" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryDcRightsList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcRightsWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcRights" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryDcRightsList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcRightsWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryDcRightsListUpdateInput = {
  /** Connect existing "MetadataDeliveryDcRights" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryDcRightsList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcRightsWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcRights" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDcRightsList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcRightsWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryDcRights" nodes from the "Metadata.metadataDeliveryDcRightsList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDcRightsWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDcRights" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDcRightsList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryDcRightsListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDcRights" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryDcRightsList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryDcRightsListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryFolderListCreateInput = {
  /** Connect existing "MetadataDeliveryFolder" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryFolderList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryFolder" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryFolderList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryFolderWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryFolderListUpdateInput = {
  /** Connect existing "MetadataDeliveryFolder" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryFolderList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryFolder" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryFolderList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryFolderWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryFolder" nodes from the "Metadata.metadataDeliveryFolderList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryFolderWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryFolder" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryFolderList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryFolderListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryFolder" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryFolderList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryFolderListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryKindListCreateInput = {
  /** Connect existing "MetadataDeliveryKind" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryKindList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryKindWhereUniqueInput>>;
  /** Create new "MetadataDeliveryKind" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryKindList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryKindWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryKindListUpdateInput = {
  /** Connect existing "MetadataDeliveryKind" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryKindList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryKindWhereUniqueInput>>;
  /** Create new "MetadataDeliveryKind" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryKindList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryKindWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryKind" nodes from the "Metadata.metadataDeliveryKindList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryKindWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryKind" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryKindList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryKindListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryKind" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryKindList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryKindListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryPathListCreateInput = {
  /** Connect existing "MetadataDeliveryPath" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryPathList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPathWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPath" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryPathList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPathWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryPathListUpdateInput = {
  /** Connect existing "MetadataDeliveryPath" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryPathList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPathWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPath" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryPathList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPathWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryPath" nodes from the "Metadata.metadataDeliveryPathList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryPathWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryPath" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryPathList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryPathListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryPath" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryPathList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryPathListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryPhotoshopCreditListCreateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopCredit" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopCreditList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopCredit" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopCreditList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryPhotoshopCreditListUpdateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopCredit" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopCreditList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopCredit" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopCreditList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryPhotoshopCredit" nodes from the "Metadata.metadataDeliveryPhotoshopCreditList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryPhotoshopCredit" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopCreditList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryPhotoshopCreditListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryPhotoshopCredit" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopCreditList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryPhotoshopCreditListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryPhotoshopSourceListCreateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopSource" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopSourceList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopSource" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopSourceList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryPhotoshopSourceListUpdateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopSource" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopSourceList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopSource" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopSourceList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryPhotoshopSource" nodes from the "Metadata.metadataDeliveryPhotoshopSourceList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryPhotoshopSource" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopSourceList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryPhotoshopSourceListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryPhotoshopSource" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryPhotoshopSourceList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryPhotoshopSourceListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryServiceListCreateInput = {
  /** Connect existing "MetadataDeliveryService" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryServiceList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryServiceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryService" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryServiceList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryServiceWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryServiceListUpdateInput = {
  /** Connect existing "MetadataDeliveryService" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryServiceList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryServiceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryService" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryServiceList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryServiceWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryService" nodes from the "Metadata.metadataDeliveryServiceList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryServiceWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryService" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryServiceList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryServiceListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryService" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryServiceList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryServiceListUpdateInput>>;
};

export type MetadataNestedMetadataDeliverySubjectListCreateInput = {
  /** Connect existing "MetadataDeliverySubject" nodes to the new "Metadata" node, through the "Metadata.metadataDeliverySubjectList" relation. */
  connect?: InputMaybe<Array<MetadataDeliverySubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliverySubject" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliverySubjectList" relation. */
  create?: InputMaybe<Array<MetadataDeliverySubjectWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliverySubjectListUpdateInput = {
  /** Connect existing "MetadataDeliverySubject" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliverySubjectList" relation. */
  connect?: InputMaybe<Array<MetadataDeliverySubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliverySubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliverySubjectList" relation. */
  create?: InputMaybe<Array<MetadataDeliverySubjectWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliverySubject" nodes from the "Metadata.metadataDeliverySubjectList" relation. */
  delete?: InputMaybe<Array<MetadataDeliverySubjectWhereUniqueInput>>;
  /** Update existing "MetadataDeliverySubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliverySubjectList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliverySubjectListUpdateInput>>;
  /** Upsert existing "MetadataDeliverySubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliverySubjectList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliverySubjectListUpdateInput>>;
};

export type MetadataNestedMetadataDeliveryUnderSubjectListCreateInput = {
  /** Connect existing "MetadataDeliveryUnderSubject" nodes to the new "Metadata" node, through the "Metadata.metadataDeliveryUnderSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliveryUnderSubject" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDeliveryUnderSubjectList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryUnderSubjectWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDeliveryUnderSubjectListUpdateInput = {
  /** Connect existing "MetadataDeliveryUnderSubject" nodes to the existing "Metadata" node, through the "Metadata.metadataDeliveryUnderSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliveryUnderSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryUnderSubjectList" relation. */
  create?: InputMaybe<Array<MetadataDeliveryUnderSubjectWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDeliveryUnderSubject" nodes from the "Metadata.metadataDeliveryUnderSubjectList" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryUnderSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryUnderSubjectList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDeliveryUnderSubjectListUpdateInput>>;
  /** Upsert existing "MetadataDeliveryUnderSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDeliveryUnderSubjectList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDeliveryUnderSubjectListUpdateInput>>;
};

export type MetadataNestedMetadataDepartmentListCreateInput = {
  /** Connect existing "MetadataDepartment" nodes to the new "Metadata" node, through the "Metadata.metadataDepartmentList" relation. */
  connect?: InputMaybe<Array<MetadataDepartmentWhereUniqueInput>>;
  /** Create new "MetadataDepartment" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDepartmentList" relation. */
  create?: InputMaybe<Array<MetadataDepartmentWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDepartmentListUpdateInput = {
  /** Connect existing "MetadataDepartment" nodes to the existing "Metadata" node, through the "Metadata.metadataDepartmentList" relation. */
  connect?: InputMaybe<Array<MetadataDepartmentWhereUniqueInput>>;
  /** Create new "MetadataDepartment" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDepartmentList" relation. */
  create?: InputMaybe<Array<MetadataDepartmentWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDepartment" nodes from the "Metadata.metadataDepartmentList" relation. */
  delete?: InputMaybe<Array<MetadataDepartmentWhereUniqueInput>>;
  /** Update existing "MetadataDepartment" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDepartmentList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDepartmentListUpdateInput>>;
  /** Upsert existing "MetadataDepartment" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDepartmentList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDepartmentListUpdateInput>>;
};

export type MetadataNestedMetadataDescriptionListCreateInput = {
  /** Connect existing "MetadataDescription" nodes to the new "Metadata" node, through the "Metadata.metadataDescriptionList" relation. */
  connect?: InputMaybe<Array<MetadataDescriptionWhereUniqueInput>>;
  /** Create new "MetadataDescription" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataDescriptionList" relation. */
  create?: InputMaybe<Array<MetadataDescriptionWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataDescriptionListUpdateInput = {
  /** Connect existing "MetadataDescription" nodes to the existing "Metadata" node, through the "Metadata.metadataDescriptionList" relation. */
  connect?: InputMaybe<Array<MetadataDescriptionWhereUniqueInput>>;
  /** Create new "MetadataDescription" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDescriptionList" relation. */
  create?: InputMaybe<Array<MetadataDescriptionWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataDescription" nodes from the "Metadata.metadataDescriptionList" relation. */
  delete?: InputMaybe<Array<MetadataDescriptionWhereUniqueInput>>;
  /** Update existing "MetadataDescription" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDescriptionList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataDescriptionListUpdateInput>>;
  /** Upsert existing "MetadataDescription" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataDescriptionList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataDescriptionListUpdateInput>>;
};

export type MetadataNestedMetadataEditionListCreateInput = {
  /** Connect existing "MetadataEdition" nodes to the new "Metadata" node, through the "Metadata.metadataEditionList" relation. */
  connect?: InputMaybe<Array<MetadataEditionWhereUniqueInput>>;
  /** Create new "MetadataEdition" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataEditionList" relation. */
  create?: InputMaybe<Array<MetadataEditionWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataEditionListUpdateInput = {
  /** Connect existing "MetadataEdition" nodes to the existing "Metadata" node, through the "Metadata.metadataEditionList" relation. */
  connect?: InputMaybe<Array<MetadataEditionWhereUniqueInput>>;
  /** Create new "MetadataEdition" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataEditionList" relation. */
  create?: InputMaybe<Array<MetadataEditionWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataEdition" nodes from the "Metadata.metadataEditionList" relation. */
  delete?: InputMaybe<Array<MetadataEditionWhereUniqueInput>>;
  /** Update existing "MetadataEdition" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataEditionList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataEditionListUpdateInput>>;
  /** Upsert existing "MetadataEdition" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataEditionList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataEditionListUpdateInput>>;
};

export type MetadataNestedMetadataEditStatusListCreateInput = {
  /** Connect existing "MetadataEditStatus" nodes to the new "Metadata" node, through the "Metadata.metadataEditStatusList" relation. */
  connect?: InputMaybe<Array<MetadataEditStatusWhereUniqueInput>>;
  /** Create new "MetadataEditStatus" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataEditStatusList" relation. */
  create?: InputMaybe<Array<MetadataEditStatusWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataEditStatusListUpdateInput = {
  /** Connect existing "MetadataEditStatus" nodes to the existing "Metadata" node, through the "Metadata.metadataEditStatusList" relation. */
  connect?: InputMaybe<Array<MetadataEditStatusWhereUniqueInput>>;
  /** Create new "MetadataEditStatus" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataEditStatusList" relation. */
  create?: InputMaybe<Array<MetadataEditStatusWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataEditStatus" nodes from the "Metadata.metadataEditStatusList" relation. */
  delete?: InputMaybe<Array<MetadataEditStatusWhereUniqueInput>>;
  /** Update existing "MetadataEditStatus" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataEditStatusList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataEditStatusListUpdateInput>>;
  /** Upsert existing "MetadataEditStatus" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataEditStatusList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataEditStatusListUpdateInput>>;
};

export type MetadataNestedMetadataFileStatusListCreateInput = {
  /** Connect existing "MetadataFileStatus" nodes to the new "Metadata" node, through the "Metadata.metadataFileStatusList" relation. */
  connect?: InputMaybe<Array<MetadataFileStatusWhereUniqueInput>>;
  /** Create new "MetadataFileStatus" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataFileStatusList" relation. */
  create?: InputMaybe<Array<MetadataFileStatusWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataFileStatusListUpdateInput = {
  /** Connect existing "MetadataFileStatus" nodes to the existing "Metadata" node, through the "Metadata.metadataFileStatusList" relation. */
  connect?: InputMaybe<Array<MetadataFileStatusWhereUniqueInput>>;
  /** Create new "MetadataFileStatus" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataFileStatusList" relation. */
  create?: InputMaybe<Array<MetadataFileStatusWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataFileStatus" nodes from the "Metadata.metadataFileStatusList" relation. */
  delete?: InputMaybe<Array<MetadataFileStatusWhereUniqueInput>>;
  /** Update existing "MetadataFileStatus" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataFileStatusList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataFileStatusListUpdateInput>>;
  /** Upsert existing "MetadataFileStatus" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataFileStatusList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataFileStatusListUpdateInput>>;
};

export type MetadataNestedMetadataFormatListCreateInput = {
  /** Connect existing "MetadataFormat" nodes to the new "Metadata" node, through the "Metadata.metadataFormatList" relation. */
  connect?: InputMaybe<Array<MetadataFormatWhereUniqueInput>>;
  /** Create new "MetadataFormat" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataFormatList" relation. */
  create?: InputMaybe<Array<MetadataFormatWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataFormatListUpdateInput = {
  /** Connect existing "MetadataFormat" nodes to the existing "Metadata" node, through the "Metadata.metadataFormatList" relation. */
  connect?: InputMaybe<Array<MetadataFormatWhereUniqueInput>>;
  /** Create new "MetadataFormat" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataFormatList" relation. */
  create?: InputMaybe<Array<MetadataFormatWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataFormat" nodes from the "Metadata.metadataFormatList" relation. */
  delete?: InputMaybe<Array<MetadataFormatWhereUniqueInput>>;
  /** Update existing "MetadataFormat" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataFormatList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataFormatListUpdateInput>>;
  /** Upsert existing "MetadataFormat" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataFormatList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataFormatListUpdateInput>>;
};

export type MetadataNestedMetadataHeaderListCreateInput = {
  /** Connect existing "MetadataHeader" nodes to the new "Metadata" node, through the "Metadata.metadataHeaderList" relation. */
  connect?: InputMaybe<Array<MetadataHeaderWhereUniqueInput>>;
  /** Create new "MetadataHeader" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataHeaderList" relation. */
  create?: InputMaybe<Array<MetadataHeaderWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataHeaderListUpdateInput = {
  /** Connect existing "MetadataHeader" nodes to the existing "Metadata" node, through the "Metadata.metadataHeaderList" relation. */
  connect?: InputMaybe<Array<MetadataHeaderWhereUniqueInput>>;
  /** Create new "MetadataHeader" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataHeaderList" relation. */
  create?: InputMaybe<Array<MetadataHeaderWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataHeader" nodes from the "Metadata.metadataHeaderList" relation. */
  delete?: InputMaybe<Array<MetadataHeaderWhereUniqueInput>>;
  /** Update existing "MetadataHeader" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataHeaderList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataHeaderListUpdateInput>>;
  /** Upsert existing "MetadataHeader" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataHeaderList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataHeaderListUpdateInput>>;
};

export type MetadataNestedMetadataHeaderPrismaListCreateInput = {
  /** Connect existing "MetadataHeaderPrisma" nodes to the new "Metadata" node, through the "Metadata.metadataHeaderPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataHeaderPrismaWhereUniqueInput>>;
  /** Create new "MetadataHeaderPrisma" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataHeaderPrismaList" relation. */
  create?: InputMaybe<Array<MetadataHeaderPrismaWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataHeaderPrismaListUpdateInput = {
  /** Connect existing "MetadataHeaderPrisma" nodes to the existing "Metadata" node, through the "Metadata.metadataHeaderPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataHeaderPrismaWhereUniqueInput>>;
  /** Create new "MetadataHeaderPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataHeaderPrismaList" relation. */
  create?: InputMaybe<Array<MetadataHeaderPrismaWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataHeaderPrisma" nodes from the "Metadata.metadataHeaderPrismaList" relation. */
  delete?: InputMaybe<Array<MetadataHeaderPrismaWhereUniqueInput>>;
  /** Update existing "MetadataHeaderPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataHeaderPrismaList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataHeaderPrismaListUpdateInput>>;
  /** Upsert existing "MetadataHeaderPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataHeaderPrismaList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataHeaderPrismaListUpdateInput>>;
};

export type MetadataNestedMetadataHeadlineListCreateInput = {
  /** Connect existing "MetadataHeadline" nodes to the new "Metadata" node, through the "Metadata.metadataHeadlineList" relation. */
  connect?: InputMaybe<Array<MetadataHeadlineWhereUniqueInput>>;
  /** Create new "MetadataHeadline" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataHeadlineList" relation. */
  create?: InputMaybe<Array<MetadataHeadlineWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataHeadlineListUpdateInput = {
  /** Connect existing "MetadataHeadline" nodes to the existing "Metadata" node, through the "Metadata.metadataHeadlineList" relation. */
  connect?: InputMaybe<Array<MetadataHeadlineWhereUniqueInput>>;
  /** Create new "MetadataHeadline" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataHeadlineList" relation. */
  create?: InputMaybe<Array<MetadataHeadlineWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataHeadline" nodes from the "Metadata.metadataHeadlineList" relation. */
  delete?: InputMaybe<Array<MetadataHeadlineWhereUniqueInput>>;
  /** Update existing "MetadataHeadline" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataHeadlineList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataHeadlineListUpdateInput>>;
  /** Upsert existing "MetadataHeadline" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataHeadlineList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataHeadlineListUpdateInput>>;
};

export type MetadataNestedMetadataIdAssignmentListCreateInput = {
  /** Connect existing "MetadataIdAssignment" nodes to the new "Metadata" node, through the "Metadata.metadataIdAssignmentList" relation. */
  connect?: InputMaybe<Array<MetadataIdAssignmentWhereUniqueInput>>;
  /** Create new "MetadataIdAssignment" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataIdAssignmentList" relation. */
  create?: InputMaybe<Array<MetadataIdAssignmentWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataIdAssignmentListUpdateInput = {
  /** Connect existing "MetadataIdAssignment" nodes to the existing "Metadata" node, through the "Metadata.metadataIdAssignmentList" relation. */
  connect?: InputMaybe<Array<MetadataIdAssignmentWhereUniqueInput>>;
  /** Create new "MetadataIdAssignment" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIdAssignmentList" relation. */
  create?: InputMaybe<Array<MetadataIdAssignmentWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataIdAssignment" nodes from the "Metadata.metadataIdAssignmentList" relation. */
  delete?: InputMaybe<Array<MetadataIdAssignmentWhereUniqueInput>>;
  /** Update existing "MetadataIdAssignment" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIdAssignmentList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataIdAssignmentListUpdateInput>>;
  /** Upsert existing "MetadataIdAssignment" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIdAssignmentList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataIdAssignmentListUpdateInput>>;
};

export type MetadataNestedMetadataIdPhotoPrismaListCreateInput = {
  /** Connect existing "MetadataIdPhotoPrisma" nodes to the new "Metadata" node, through the "Metadata.metadataIdPhotoPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataIdPhotoPrismaWhereUniqueInput>>;
  /** Create new "MetadataIdPhotoPrisma" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataIdPhotoPrismaList" relation. */
  create?: InputMaybe<Array<MetadataIdPhotoPrismaWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataIdPhotoPrismaListUpdateInput = {
  /** Connect existing "MetadataIdPhotoPrisma" nodes to the existing "Metadata" node, through the "Metadata.metadataIdPhotoPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataIdPhotoPrismaWhereUniqueInput>>;
  /** Create new "MetadataIdPhotoPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIdPhotoPrismaList" relation. */
  create?: InputMaybe<Array<MetadataIdPhotoPrismaWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataIdPhotoPrisma" nodes from the "Metadata.metadataIdPhotoPrismaList" relation. */
  delete?: InputMaybe<Array<MetadataIdPhotoPrismaWhereUniqueInput>>;
  /** Update existing "MetadataIdPhotoPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIdPhotoPrismaList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataIdPhotoPrismaListUpdateInput>>;
  /** Upsert existing "MetadataIdPhotoPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIdPhotoPrismaList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataIdPhotoPrismaListUpdateInput>>;
};

export type MetadataNestedMetadataIdSubjectListCreateInput = {
  /** Connect existing "MetadataIdSubject" nodes to the new "Metadata" node, through the "Metadata.metadataIdSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataIdSubjectWhereUniqueInput>>;
  /** Create new "MetadataIdSubject" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataIdSubjectList" relation. */
  create?: InputMaybe<Array<MetadataIdSubjectWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataIdSubjectListUpdateInput = {
  /** Connect existing "MetadataIdSubject" nodes to the existing "Metadata" node, through the "Metadata.metadataIdSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataIdSubjectWhereUniqueInput>>;
  /** Create new "MetadataIdSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIdSubjectList" relation. */
  create?: InputMaybe<Array<MetadataIdSubjectWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataIdSubject" nodes from the "Metadata.metadataIdSubjectList" relation. */
  delete?: InputMaybe<Array<MetadataIdSubjectWhereUniqueInput>>;
  /** Update existing "MetadataIdSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIdSubjectList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataIdSubjectListUpdateInput>>;
  /** Upsert existing "MetadataIdSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIdSubjectList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataIdSubjectListUpdateInput>>;
};

export type MetadataNestedMetadataImageNotesListCreateInput = {
  /** Connect existing "MetadataImageNotes" nodes to the new "Metadata" node, through the "Metadata.metadataImageNotesList" relation. */
  connect?: InputMaybe<Array<MetadataImageNotesWhereUniqueInput>>;
  /** Create new "MetadataImageNotes" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataImageNotesList" relation. */
  create?: InputMaybe<Array<MetadataImageNotesWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataImageNotesListUpdateInput = {
  /** Connect existing "MetadataImageNotes" nodes to the existing "Metadata" node, through the "Metadata.metadataImageNotesList" relation. */
  connect?: InputMaybe<Array<MetadataImageNotesWhereUniqueInput>>;
  /** Create new "MetadataImageNotes" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataImageNotesList" relation. */
  create?: InputMaybe<Array<MetadataImageNotesWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataImageNotes" nodes from the "Metadata.metadataImageNotesList" relation. */
  delete?: InputMaybe<Array<MetadataImageNotesWhereUniqueInput>>;
  /** Update existing "MetadataImageNotes" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataImageNotesList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataImageNotesListUpdateInput>>;
  /** Upsert existing "MetadataImageNotes" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataImageNotesList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataImageNotesListUpdateInput>>;
};

export type MetadataNestedMetadataInstructionsListCreateInput = {
  /** Connect existing "MetadataInstructions" nodes to the new "Metadata" node, through the "Metadata.metadataInstructionsList" relation. */
  connect?: InputMaybe<Array<MetadataInstructionsWhereUniqueInput>>;
  /** Create new "MetadataInstructions" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataInstructionsList" relation. */
  create?: InputMaybe<Array<MetadataInstructionsWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataInstructionsListUpdateInput = {
  /** Connect existing "MetadataInstructions" nodes to the existing "Metadata" node, through the "Metadata.metadataInstructionsList" relation. */
  connect?: InputMaybe<Array<MetadataInstructionsWhereUniqueInput>>;
  /** Create new "MetadataInstructions" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataInstructionsList" relation. */
  create?: InputMaybe<Array<MetadataInstructionsWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataInstructions" nodes from the "Metadata.metadataInstructionsList" relation. */
  delete?: InputMaybe<Array<MetadataInstructionsWhereUniqueInput>>;
  /** Update existing "MetadataInstructions" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataInstructionsList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataInstructionsListUpdateInput>>;
  /** Upsert existing "MetadataInstructions" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataInstructionsList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataInstructionsListUpdateInput>>;
};

export type MetadataNestedMetadataIssueListCreateInput = {
  /** Connect existing "MetadataIssue" nodes to the new "Metadata" node, through the "Metadata.metadataIssueList" relation. */
  connect?: InputMaybe<Array<MetadataIssueWhereUniqueInput>>;
  /** Create new "MetadataIssue" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataIssueList" relation. */
  create?: InputMaybe<Array<MetadataIssueWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataIssueListUpdateInput = {
  /** Connect existing "MetadataIssue" nodes to the existing "Metadata" node, through the "Metadata.metadataIssueList" relation. */
  connect?: InputMaybe<Array<MetadataIssueWhereUniqueInput>>;
  /** Create new "MetadataIssue" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIssueList" relation. */
  create?: InputMaybe<Array<MetadataIssueWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataIssue" nodes from the "Metadata.metadataIssueList" relation. */
  delete?: InputMaybe<Array<MetadataIssueWhereUniqueInput>>;
  /** Update existing "MetadataIssue" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIssueList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataIssueListUpdateInput>>;
  /** Upsert existing "MetadataIssue" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataIssueList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataIssueListUpdateInput>>;
};

export type MetadataNestedMetadataKeywordsListCreateInput = {
  /** Connect existing "MetadataKeywords" nodes to the new "Metadata" node, through the "Metadata.metadataKeywordsList" relation. */
  connect?: InputMaybe<Array<MetadataKeywordsWhereUniqueInput>>;
  /** Create new "MetadataKeywords" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataKeywordsList" relation. */
  create?: InputMaybe<Array<MetadataKeywordsWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataKeywordsListUpdateInput = {
  /** Connect existing "MetadataKeywords" nodes to the existing "Metadata" node, through the "Metadata.metadataKeywordsList" relation. */
  connect?: InputMaybe<Array<MetadataKeywordsWhereUniqueInput>>;
  /** Create new "MetadataKeywords" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataKeywordsList" relation. */
  create?: InputMaybe<Array<MetadataKeywordsWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataKeywords" nodes from the "Metadata.metadataKeywordsList" relation. */
  delete?: InputMaybe<Array<MetadataKeywordsWhereUniqueInput>>;
  /** Update existing "MetadataKeywords" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataKeywordsList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataKeywordsListUpdateInput>>;
  /** Upsert existing "MetadataKeywords" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataKeywordsList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataKeywordsListUpdateInput>>;
};

export type MetadataNestedMetadataObjectNameListCreateInput = {
  /** Connect existing "MetadataObjectName" nodes to the new "Metadata" node, through the "Metadata.metadataObjectNameList" relation. */
  connect?: InputMaybe<Array<MetadataObjectNameWhereUniqueInput>>;
  /** Create new "MetadataObjectName" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataObjectNameList" relation. */
  create?: InputMaybe<Array<MetadataObjectNameWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataObjectNameListUpdateInput = {
  /** Connect existing "MetadataObjectName" nodes to the existing "Metadata" node, through the "Metadata.metadataObjectNameList" relation. */
  connect?: InputMaybe<Array<MetadataObjectNameWhereUniqueInput>>;
  /** Create new "MetadataObjectName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataObjectNameList" relation. */
  create?: InputMaybe<Array<MetadataObjectNameWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataObjectName" nodes from the "Metadata.metadataObjectNameList" relation. */
  delete?: InputMaybe<Array<MetadataObjectNameWhereUniqueInput>>;
  /** Update existing "MetadataObjectName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataObjectNameList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataObjectNameListUpdateInput>>;
  /** Upsert existing "MetadataObjectName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataObjectNameList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataObjectNameListUpdateInput>>;
};

export type MetadataNestedMetadataOriginalNameListCreateInput = {
  /** Connect existing "MetadataOriginalName" nodes to the new "Metadata" node, through the "Metadata.metadataOriginalNameList" relation. */
  connect?: InputMaybe<Array<MetadataOriginalNameWhereUniqueInput>>;
  /** Create new "MetadataOriginalName" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataOriginalNameList" relation. */
  create?: InputMaybe<Array<MetadataOriginalNameWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataOriginalNameListUpdateInput = {
  /** Connect existing "MetadataOriginalName" nodes to the existing "Metadata" node, through the "Metadata.metadataOriginalNameList" relation. */
  connect?: InputMaybe<Array<MetadataOriginalNameWhereUniqueInput>>;
  /** Create new "MetadataOriginalName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataOriginalNameList" relation. */
  create?: InputMaybe<Array<MetadataOriginalNameWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataOriginalName" nodes from the "Metadata.metadataOriginalNameList" relation. */
  delete?: InputMaybe<Array<MetadataOriginalNameWhereUniqueInput>>;
  /** Update existing "MetadataOriginalName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataOriginalNameList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataOriginalNameListUpdateInput>>;
  /** Upsert existing "MetadataOriginalName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataOriginalNameList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataOriginalNameListUpdateInput>>;
};

export type MetadataNestedMetadataPriceLevelListCreateInput = {
  /** Connect existing "MetadataPriceLevel" nodes to the new "Metadata" node, through the "Metadata.metadataPriceLevelList" relation. */
  connect?: InputMaybe<Array<MetadataPriceLevelWhereUniqueInput>>;
  /** Create new "MetadataPriceLevel" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataPriceLevelList" relation. */
  create?: InputMaybe<Array<MetadataPriceLevelWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataPriceLevelListUpdateInput = {
  /** Connect existing "MetadataPriceLevel" nodes to the existing "Metadata" node, through the "Metadata.metadataPriceLevelList" relation. */
  connect?: InputMaybe<Array<MetadataPriceLevelWhereUniqueInput>>;
  /** Create new "MetadataPriceLevel" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataPriceLevelList" relation. */
  create?: InputMaybe<Array<MetadataPriceLevelWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataPriceLevel" nodes from the "Metadata.metadataPriceLevelList" relation. */
  delete?: InputMaybe<Array<MetadataPriceLevelWhereUniqueInput>>;
  /** Update existing "MetadataPriceLevel" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataPriceLevelList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataPriceLevelListUpdateInput>>;
  /** Upsert existing "MetadataPriceLevel" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataPriceLevelList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataPriceLevelListUpdateInput>>;
};

export type MetadataNestedMetadataProcessHistoryListCreateInput = {
  /** Connect existing "MetadataProcessHistory" nodes to the new "Metadata" node, through the "Metadata.metadataProcessHistoryList" relation. */
  connect?: InputMaybe<Array<MetadataProcessHistoryWhereUniqueInput>>;
  /** Create new "MetadataProcessHistory" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataProcessHistoryList" relation. */
  create?: InputMaybe<Array<MetadataProcessHistoryWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataProcessHistoryListUpdateInput = {
  /** Connect existing "MetadataProcessHistory" nodes to the existing "Metadata" node, through the "Metadata.metadataProcessHistoryList" relation. */
  connect?: InputMaybe<Array<MetadataProcessHistoryWhereUniqueInput>>;
  /** Create new "MetadataProcessHistory" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProcessHistoryList" relation. */
  create?: InputMaybe<Array<MetadataProcessHistoryWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataProcessHistory" nodes from the "Metadata.metadataProcessHistoryList" relation. */
  delete?: InputMaybe<Array<MetadataProcessHistoryWhereUniqueInput>>;
  /** Update existing "MetadataProcessHistory" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProcessHistoryList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataProcessHistoryListUpdateInput>>;
  /** Upsert existing "MetadataProcessHistory" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProcessHistoryList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataProcessHistoryListUpdateInput>>;
};

export type MetadataNestedMetadataProcessStatusListCreateInput = {
  /** Connect existing "MetadataProcessStatus" nodes to the new "Metadata" node, through the "Metadata.metadataProcessStatusList" relation. */
  connect?: InputMaybe<Array<MetadataProcessStatusWhereUniqueInput>>;
  /** Create new "MetadataProcessStatus" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataProcessStatusList" relation. */
  create?: InputMaybe<Array<MetadataProcessStatusWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataProcessStatusListUpdateInput = {
  /** Connect existing "MetadataProcessStatus" nodes to the existing "Metadata" node, through the "Metadata.metadataProcessStatusList" relation. */
  connect?: InputMaybe<Array<MetadataProcessStatusWhereUniqueInput>>;
  /** Create new "MetadataProcessStatus" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProcessStatusList" relation. */
  create?: InputMaybe<Array<MetadataProcessStatusWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataProcessStatus" nodes from the "Metadata.metadataProcessStatusList" relation. */
  delete?: InputMaybe<Array<MetadataProcessStatusWhereUniqueInput>>;
  /** Update existing "MetadataProcessStatus" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProcessStatusList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataProcessStatusListUpdateInput>>;
  /** Upsert existing "MetadataProcessStatus" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProcessStatusList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataProcessStatusListUpdateInput>>;
};

export type MetadataNestedMetadataProductListCreateInput = {
  /** Connect existing "MetadataProduct" nodes to the new "Metadata" node, through the "Metadata.metadataProductList" relation. */
  connect?: InputMaybe<Array<MetadataProductWhereUniqueInput>>;
  /** Create new "MetadataProduct" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataProductList" relation. */
  create?: InputMaybe<Array<MetadataProductWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataProductListUpdateInput = {
  /** Connect existing "MetadataProduct" nodes to the existing "Metadata" node, through the "Metadata.metadataProductList" relation. */
  connect?: InputMaybe<Array<MetadataProductWhereUniqueInput>>;
  /** Create new "MetadataProduct" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProductList" relation. */
  create?: InputMaybe<Array<MetadataProductWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataProduct" nodes from the "Metadata.metadataProductList" relation. */
  delete?: InputMaybe<Array<MetadataProductWhereUniqueInput>>;
  /** Update existing "MetadataProduct" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProductList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataProductListUpdateInput>>;
  /** Upsert existing "MetadataProduct" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProductList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataProductListUpdateInput>>;
};

export type MetadataNestedMetadataProductsListCreateInput = {
  /** Connect existing "MetadataProducts" nodes to the new "Metadata" node, through the "Metadata.metadataProductsList" relation. */
  connect?: InputMaybe<Array<MetadataProductsWhereUniqueInput>>;
  /** Create new "MetadataProducts" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataProductsList" relation. */
  create?: InputMaybe<Array<MetadataProductsWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataProductsListUpdateInput = {
  /** Connect existing "MetadataProducts" nodes to the existing "Metadata" node, through the "Metadata.metadataProductsList" relation. */
  connect?: InputMaybe<Array<MetadataProductsWhereUniqueInput>>;
  /** Create new "MetadataProducts" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProductsList" relation. */
  create?: InputMaybe<Array<MetadataProductsWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataProducts" nodes from the "Metadata.metadataProductsList" relation. */
  delete?: InputMaybe<Array<MetadataProductsWhereUniqueInput>>;
  /** Update existing "MetadataProducts" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProductsList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataProductsListUpdateInput>>;
  /** Upsert existing "MetadataProducts" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataProductsList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataProductsListUpdateInput>>;
};

export type MetadataNestedMetadataPublishingSubjectListCreateInput = {
  /** Connect existing "MetadataPublishingSubject" nodes to the new "Metadata" node, through the "Metadata.metadataPublishingSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataPublishingSubjectWhereUniqueInput>>;
  /** Create new "MetadataPublishingSubject" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataPublishingSubjectList" relation. */
  create?: InputMaybe<Array<MetadataPublishingSubjectWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataPublishingSubjectListUpdateInput = {
  /** Connect existing "MetadataPublishingSubject" nodes to the existing "Metadata" node, through the "Metadata.metadataPublishingSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataPublishingSubjectWhereUniqueInput>>;
  /** Create new "MetadataPublishingSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataPublishingSubjectList" relation. */
  create?: InputMaybe<Array<MetadataPublishingSubjectWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataPublishingSubject" nodes from the "Metadata.metadataPublishingSubjectList" relation. */
  delete?: InputMaybe<Array<MetadataPublishingSubjectWhereUniqueInput>>;
  /** Update existing "MetadataPublishingSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataPublishingSubjectList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataPublishingSubjectListUpdateInput>>;
  /** Upsert existing "MetadataPublishingSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataPublishingSubjectList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataPublishingSubjectListUpdateInput>>;
};

export type MetadataNestedMetadataResolutionKindListCreateInput = {
  /** Connect existing "MetadataResolutionKind" nodes to the new "Metadata" node, through the "Metadata.metadataResolutionKindList" relation. */
  connect?: InputMaybe<Array<MetadataResolutionKindWhereUniqueInput>>;
  /** Create new "MetadataResolutionKind" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataResolutionKindList" relation. */
  create?: InputMaybe<Array<MetadataResolutionKindWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataResolutionKindListUpdateInput = {
  /** Connect existing "MetadataResolutionKind" nodes to the existing "Metadata" node, through the "Metadata.metadataResolutionKindList" relation. */
  connect?: InputMaybe<Array<MetadataResolutionKindWhereUniqueInput>>;
  /** Create new "MetadataResolutionKind" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataResolutionKindList" relation. */
  create?: InputMaybe<Array<MetadataResolutionKindWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataResolutionKind" nodes from the "Metadata.metadataResolutionKindList" relation. */
  delete?: InputMaybe<Array<MetadataResolutionKindWhereUniqueInput>>;
  /** Update existing "MetadataResolutionKind" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataResolutionKindList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataResolutionKindListUpdateInput>>;
  /** Upsert existing "MetadataResolutionKind" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataResolutionKindList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataResolutionKindListUpdateInput>>;
};

export type MetadataNestedMetadataRightsListCreateInput = {
  /** Connect existing "MetadataRights" nodes to the new "Metadata" node, through the "Metadata.metadataRightsList" relation. */
  connect?: InputMaybe<Array<MetadataRightsWhereUniqueInput>>;
  /** Create new "MetadataRights" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataRightsList" relation. */
  create?: InputMaybe<Array<MetadataRightsWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataRightsListUpdateInput = {
  /** Connect existing "MetadataRights" nodes to the existing "Metadata" node, through the "Metadata.metadataRightsList" relation. */
  connect?: InputMaybe<Array<MetadataRightsWhereUniqueInput>>;
  /** Create new "MetadataRights" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataRightsList" relation. */
  create?: InputMaybe<Array<MetadataRightsWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataRights" nodes from the "Metadata.metadataRightsList" relation. */
  delete?: InputMaybe<Array<MetadataRightsWhereUniqueInput>>;
  /** Update existing "MetadataRights" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataRightsList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataRightsListUpdateInput>>;
  /** Upsert existing "MetadataRights" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataRightsList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataRightsListUpdateInput>>;
};

export type MetadataNestedMetadataSourceListCreateInput = {
  /** Connect existing "MetadataSource" nodes to the new "Metadata" node, through the "Metadata.metadataSourceList" relation. */
  connect?: InputMaybe<Array<MetadataSourceWhereUniqueInput>>;
  /** Create new "MetadataSource" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataSourceList" relation. */
  create?: InputMaybe<Array<MetadataSourceWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataSourceListUpdateInput = {
  /** Connect existing "MetadataSource" nodes to the existing "Metadata" node, through the "Metadata.metadataSourceList" relation. */
  connect?: InputMaybe<Array<MetadataSourceWhereUniqueInput>>;
  /** Create new "MetadataSource" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSourceList" relation. */
  create?: InputMaybe<Array<MetadataSourceWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataSource" nodes from the "Metadata.metadataSourceList" relation. */
  delete?: InputMaybe<Array<MetadataSourceWhereUniqueInput>>;
  /** Update existing "MetadataSource" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSourceList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataSourceListUpdateInput>>;
  /** Upsert existing "MetadataSource" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSourceList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataSourceListUpdateInput>>;
};

export type MetadataNestedMetadataSpecialInstructionsListCreateInput = {
  /** Connect existing "MetadataSpecialInstructions" nodes to the new "Metadata" node, through the "Metadata.metadataSpecialInstructionsList" relation. */
  connect?: InputMaybe<Array<MetadataSpecialInstructionsWhereUniqueInput>>;
  /** Create new "MetadataSpecialInstructions" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataSpecialInstructionsList" relation. */
  create?: InputMaybe<Array<MetadataSpecialInstructionsWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataSpecialInstructionsListUpdateInput = {
  /** Connect existing "MetadataSpecialInstructions" nodes to the existing "Metadata" node, through the "Metadata.metadataSpecialInstructionsList" relation. */
  connect?: InputMaybe<Array<MetadataSpecialInstructionsWhereUniqueInput>>;
  /** Create new "MetadataSpecialInstructions" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSpecialInstructionsList" relation. */
  create?: InputMaybe<Array<MetadataSpecialInstructionsWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataSpecialInstructions" nodes from the "Metadata.metadataSpecialInstructionsList" relation. */
  delete?: InputMaybe<Array<MetadataSpecialInstructionsWhereUniqueInput>>;
  /** Update existing "MetadataSpecialInstructions" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSpecialInstructionsList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataSpecialInstructionsListUpdateInput>>;
  /** Upsert existing "MetadataSpecialInstructions" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSpecialInstructionsList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataSpecialInstructionsListUpdateInput>>;
};

export type MetadataNestedMetadataSubjectCodeListCreateInput = {
  /** Connect existing "MetadataSubjectCode" nodes to the new "Metadata" node, through the "Metadata.metadataSubjectCodeList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectCodeWhereUniqueInput>>;
  /** Create new "MetadataSubjectCode" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataSubjectCodeList" relation. */
  create?: InputMaybe<Array<MetadataSubjectCodeWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataSubjectCodeListUpdateInput = {
  /** Connect existing "MetadataSubjectCode" nodes to the existing "Metadata" node, through the "Metadata.metadataSubjectCodeList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectCodeWhereUniqueInput>>;
  /** Create new "MetadataSubjectCode" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSubjectCodeList" relation. */
  create?: InputMaybe<Array<MetadataSubjectCodeWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataSubjectCode" nodes from the "Metadata.metadataSubjectCodeList" relation. */
  delete?: InputMaybe<Array<MetadataSubjectCodeWhereUniqueInput>>;
  /** Update existing "MetadataSubjectCode" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSubjectCodeList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataSubjectCodeListUpdateInput>>;
  /** Upsert existing "MetadataSubjectCode" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSubjectCodeList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataSubjectCodeListUpdateInput>>;
};

export type MetadataNestedMetadataSubjectListCreateInput = {
  /** Connect existing "MetadataSubject" nodes to the new "Metadata" node, through the "Metadata.metadataSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectWhereUniqueInput>>;
  /** Create new "MetadataSubject" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataSubjectList" relation. */
  create?: InputMaybe<Array<MetadataSubjectWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataSubjectListUpdateInput = {
  /** Connect existing "MetadataSubject" nodes to the existing "Metadata" node, through the "Metadata.metadataSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectWhereUniqueInput>>;
  /** Create new "MetadataSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSubjectList" relation. */
  create?: InputMaybe<Array<MetadataSubjectWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataSubject" nodes from the "Metadata.metadataSubjectList" relation. */
  delete?: InputMaybe<Array<MetadataSubjectWhereUniqueInput>>;
  /** Update existing "MetadataSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSubjectList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataSubjectListUpdateInput>>;
  /** Upsert existing "MetadataSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSubjectList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataSubjectListUpdateInput>>;
};

export type MetadataNestedMetadataSubjectPrismaListCreateInput = {
  /** Connect existing "MetadataSubjectPrisma" nodes to the new "Metadata" node, through the "Metadata.metadataSubjectPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectPrismaWhereUniqueInput>>;
  /** Create new "MetadataSubjectPrisma" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataSubjectPrismaList" relation. */
  create?: InputMaybe<Array<MetadataSubjectPrismaWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataSubjectPrismaListUpdateInput = {
  /** Connect existing "MetadataSubjectPrisma" nodes to the existing "Metadata" node, through the "Metadata.metadataSubjectPrismaList" relation. */
  connect?: InputMaybe<Array<MetadataSubjectPrismaWhereUniqueInput>>;
  /** Create new "MetadataSubjectPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSubjectPrismaList" relation. */
  create?: InputMaybe<Array<MetadataSubjectPrismaWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataSubjectPrisma" nodes from the "Metadata.metadataSubjectPrismaList" relation. */
  delete?: InputMaybe<Array<MetadataSubjectPrismaWhereUniqueInput>>;
  /** Update existing "MetadataSubjectPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSubjectPrismaList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataSubjectPrismaListUpdateInput>>;
  /** Upsert existing "MetadataSubjectPrisma" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataSubjectPrismaList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataSubjectPrismaListUpdateInput>>;
};

export type MetadataNestedMetadataTitleListCreateInput = {
  /** Connect existing "MetadataTitle" nodes to the new "Metadata" node, through the "Metadata.metadataTitleList" relation. */
  connect?: InputMaybe<Array<MetadataTitleWhereUniqueInput>>;
  /** Create new "MetadataTitle" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataTitleList" relation. */
  create?: InputMaybe<Array<MetadataTitleWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataTitleListUpdateInput = {
  /** Connect existing "MetadataTitle" nodes to the existing "Metadata" node, through the "Metadata.metadataTitleList" relation. */
  connect?: InputMaybe<Array<MetadataTitleWhereUniqueInput>>;
  /** Create new "MetadataTitle" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTitleList" relation. */
  create?: InputMaybe<Array<MetadataTitleWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataTitle" nodes from the "Metadata.metadataTitleList" relation. */
  delete?: InputMaybe<Array<MetadataTitleWhereUniqueInput>>;
  /** Update existing "MetadataTitle" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTitleList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataTitleListUpdateInput>>;
  /** Upsert existing "MetadataTitle" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTitleList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataTitleListUpdateInput>>;
};

export type MetadataNestedMetadataTransferredByFullNameListCreateInput = {
  /** Connect existing "MetadataTransferredByFullName" nodes to the new "Metadata" node, through the "Metadata.metadataTransferredByFullNameList" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByFullNameWhereUniqueInput>>;
  /** Create new "MetadataTransferredByFullName" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataTransferredByFullNameList" relation. */
  create?: InputMaybe<Array<MetadataTransferredByFullNameWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataTransferredByFullNameListUpdateInput = {
  /** Connect existing "MetadataTransferredByFullName" nodes to the existing "Metadata" node, through the "Metadata.metadataTransferredByFullNameList" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByFullNameWhereUniqueInput>>;
  /** Create new "MetadataTransferredByFullName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTransferredByFullNameList" relation. */
  create?: InputMaybe<Array<MetadataTransferredByFullNameWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataTransferredByFullName" nodes from the "Metadata.metadataTransferredByFullNameList" relation. */
  delete?: InputMaybe<Array<MetadataTransferredByFullNameWhereUniqueInput>>;
  /** Update existing "MetadataTransferredByFullName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTransferredByFullNameList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataTransferredByFullNameListUpdateInput>>;
  /** Upsert existing "MetadataTransferredByFullName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTransferredByFullNameList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataTransferredByFullNameListUpdateInput>>;
};

export type MetadataNestedMetadataTransferredByListCreateInput = {
  /** Connect existing "MetadataTransferredBy" nodes to the new "Metadata" node, through the "Metadata.metadataTransferredByList" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByWhereUniqueInput>>;
  /** Create new "MetadataTransferredBy" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataTransferredByList" relation. */
  create?: InputMaybe<Array<MetadataTransferredByWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataTransferredByListUpdateInput = {
  /** Connect existing "MetadataTransferredBy" nodes to the existing "Metadata" node, through the "Metadata.metadataTransferredByList" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByWhereUniqueInput>>;
  /** Create new "MetadataTransferredBy" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTransferredByList" relation. */
  create?: InputMaybe<Array<MetadataTransferredByWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataTransferredBy" nodes from the "Metadata.metadataTransferredByList" relation. */
  delete?: InputMaybe<Array<MetadataTransferredByWhereUniqueInput>>;
  /** Update existing "MetadataTransferredBy" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTransferredByList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataTransferredByListUpdateInput>>;
  /** Upsert existing "MetadataTransferredBy" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTransferredByList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataTransferredByListUpdateInput>>;
};

export type MetadataNestedMetadataTypeListCreateInput = {
  /** Connect existing "MetadataType" nodes to the new "Metadata" node, through the "Metadata.metadataTypeList" relation. */
  connect?: InputMaybe<Array<MetadataTypeWhereUniqueInput>>;
  /** Create new "MetadataType" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataTypeList" relation. */
  create?: InputMaybe<Array<MetadataTypeWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataTypeListUpdateInput = {
  /** Connect existing "MetadataType" nodes to the existing "Metadata" node, through the "Metadata.metadataTypeList" relation. */
  connect?: InputMaybe<Array<MetadataTypeWhereUniqueInput>>;
  /** Create new "MetadataType" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTypeList" relation. */
  create?: InputMaybe<Array<MetadataTypeWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataType" nodes from the "Metadata.metadataTypeList" relation. */
  delete?: InputMaybe<Array<MetadataTypeWhereUniqueInput>>;
  /** Update existing "MetadataType" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTypeList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataTypeListUpdateInput>>;
  /** Upsert existing "MetadataType" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataTypeList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataTypeListUpdateInput>>;
};

export type MetadataNestedMetadataUndersubjectListCreateInput = {
  /** Connect existing "MetadataUndersubject" nodes to the new "Metadata" node, through the "Metadata.metadataUndersubjectList" relation. */
  connect?: InputMaybe<Array<MetadataUndersubjectWhereUniqueInput>>;
  /** Create new "MetadataUndersubject" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUndersubjectList" relation. */
  create?: InputMaybe<Array<MetadataUndersubjectWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUndersubjectListUpdateInput = {
  /** Connect existing "MetadataUndersubject" nodes to the existing "Metadata" node, through the "Metadata.metadataUndersubjectList" relation. */
  connect?: InputMaybe<Array<MetadataUndersubjectWhereUniqueInput>>;
  /** Create new "MetadataUndersubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUndersubjectList" relation. */
  create?: InputMaybe<Array<MetadataUndersubjectWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUndersubject" nodes from the "Metadata.metadataUndersubjectList" relation. */
  delete?: InputMaybe<Array<MetadataUndersubjectWhereUniqueInput>>;
  /** Update existing "MetadataUndersubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUndersubjectList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUndersubjectListUpdateInput>>;
  /** Upsert existing "MetadataUndersubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUndersubjectList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUndersubjectListUpdateInput>>;
};

export type MetadataNestedMetadataUnderUnderSubjectListCreateInput = {
  /** Connect existing "MetadataUnderUnderSubject" nodes to the new "Metadata" node, through the "Metadata.metadataUnderUnderSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataUnderUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataUnderUnderSubject" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUnderUnderSubjectList" relation. */
  create?: InputMaybe<Array<MetadataUnderUnderSubjectWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUnderUnderSubjectListUpdateInput = {
  /** Connect existing "MetadataUnderUnderSubject" nodes to the existing "Metadata" node, through the "Metadata.metadataUnderUnderSubjectList" relation. */
  connect?: InputMaybe<Array<MetadataUnderUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataUnderUnderSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUnderUnderSubjectList" relation. */
  create?: InputMaybe<Array<MetadataUnderUnderSubjectWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUnderUnderSubject" nodes from the "Metadata.metadataUnderUnderSubjectList" relation. */
  delete?: InputMaybe<Array<MetadataUnderUnderSubjectWhereUniqueInput>>;
  /** Update existing "MetadataUnderUnderSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUnderUnderSubjectList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUnderUnderSubjectListUpdateInput>>;
  /** Upsert existing "MetadataUnderUnderSubject" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUnderUnderSubjectList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUnderUnderSubjectListUpdateInput>>;
};

export type MetadataNestedMetadataUploadedByFullNameListCreateInput = {
  /** Connect existing "MetadataUploadedByFullName" nodes to the new "Metadata" node, through the "Metadata.metadataUploadedByFullNameList" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByFullNameWhereUniqueInput>>;
  /** Create new "MetadataUploadedByFullName" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUploadedByFullNameList" relation. */
  create?: InputMaybe<Array<MetadataUploadedByFullNameWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUploadedByFullNameListUpdateInput = {
  /** Connect existing "MetadataUploadedByFullName" nodes to the existing "Metadata" node, through the "Metadata.metadataUploadedByFullNameList" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByFullNameWhereUniqueInput>>;
  /** Create new "MetadataUploadedByFullName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUploadedByFullNameList" relation. */
  create?: InputMaybe<Array<MetadataUploadedByFullNameWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUploadedByFullName" nodes from the "Metadata.metadataUploadedByFullNameList" relation. */
  delete?: InputMaybe<Array<MetadataUploadedByFullNameWhereUniqueInput>>;
  /** Update existing "MetadataUploadedByFullName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUploadedByFullNameList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUploadedByFullNameListUpdateInput>>;
  /** Upsert existing "MetadataUploadedByFullName" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUploadedByFullNameList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUploadedByFullNameListUpdateInput>>;
};

export type MetadataNestedMetadataUploadedByListCreateInput = {
  /** Connect existing "MetadataUploadedBy" nodes to the new "Metadata" node, through the "Metadata.metadataUploadedByList" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByWhereUniqueInput>>;
  /** Create new "MetadataUploadedBy" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUploadedByList" relation. */
  create?: InputMaybe<Array<MetadataUploadedByWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUploadedByListUpdateInput = {
  /** Connect existing "MetadataUploadedBy" nodes to the existing "Metadata" node, through the "Metadata.metadataUploadedByList" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByWhereUniqueInput>>;
  /** Create new "MetadataUploadedBy" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUploadedByList" relation. */
  create?: InputMaybe<Array<MetadataUploadedByWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUploadedBy" nodes from the "Metadata.metadataUploadedByList" relation. */
  delete?: InputMaybe<Array<MetadataUploadedByWhereUniqueInput>>;
  /** Update existing "MetadataUploadedBy" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUploadedByList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUploadedByListUpdateInput>>;
  /** Upsert existing "MetadataUploadedBy" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUploadedByList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUploadedByListUpdateInput>>;
};

export type MetadataNestedMetadataUploadTimeListCreateInput = {
  /** Connect existing "MetadataUploadTime" nodes to the new "Metadata" node, through the "Metadata.metadataUploadTimeList" relation. */
  connect?: InputMaybe<Array<MetadataUploadTimeWhereUniqueInput>>;
  /** Create new "MetadataUploadTime" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUploadTimeList" relation. */
  create?: InputMaybe<Array<MetadataUploadTimeWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUploadTimeListUpdateInput = {
  /** Connect existing "MetadataUploadTime" nodes to the existing "Metadata" node, through the "Metadata.metadataUploadTimeList" relation. */
  connect?: InputMaybe<Array<MetadataUploadTimeWhereUniqueInput>>;
  /** Create new "MetadataUploadTime" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUploadTimeList" relation. */
  create?: InputMaybe<Array<MetadataUploadTimeWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUploadTime" nodes from the "Metadata.metadataUploadTimeList" relation. */
  delete?: InputMaybe<Array<MetadataUploadTimeWhereUniqueInput>>;
  /** Update existing "MetadataUploadTime" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUploadTimeList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUploadTimeListUpdateInput>>;
  /** Upsert existing "MetadataUploadTime" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUploadTimeList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUploadTimeListUpdateInput>>;
};

export type MetadataNestedMetadataUrgencyListCreateInput = {
  /** Connect existing "MetadataUrgency" nodes to the new "Metadata" node, through the "Metadata.metadataUrgencyList" relation. */
  connect?: InputMaybe<Array<MetadataUrgencyWhereUniqueInput>>;
  /** Create new "MetadataUrgency" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUrgencyList" relation. */
  create?: InputMaybe<Array<MetadataUrgencyWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUrgencyListUpdateInput = {
  /** Connect existing "MetadataUrgency" nodes to the existing "Metadata" node, through the "Metadata.metadataUrgencyList" relation. */
  connect?: InputMaybe<Array<MetadataUrgencyWhereUniqueInput>>;
  /** Create new "MetadataUrgency" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUrgencyList" relation. */
  create?: InputMaybe<Array<MetadataUrgencyWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUrgency" nodes from the "Metadata.metadataUrgencyList" relation. */
  delete?: InputMaybe<Array<MetadataUrgencyWhereUniqueInput>>;
  /** Update existing "MetadataUrgency" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUrgencyList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUrgencyListUpdateInput>>;
  /** Upsert existing "MetadataUrgency" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUrgencyList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUrgencyListUpdateInput>>;
};

export type MetadataNestedMetadataUserDefined195ListCreateInput = {
  /** Connect existing "MetadataUserDefined195" nodes to the new "Metadata" node, through the "Metadata.metadataUserDefined195List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined195WhereUniqueInput>>;
  /** Create new "MetadataUserDefined195" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUserDefined195List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined195WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUserDefined195ListUpdateInput = {
  /** Connect existing "MetadataUserDefined195" nodes to the existing "Metadata" node, through the "Metadata.metadataUserDefined195List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined195WhereUniqueInput>>;
  /** Create new "MetadataUserDefined195" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined195List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined195WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUserDefined195" nodes from the "Metadata.metadataUserDefined195List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined195WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined195" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined195List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUserDefined195ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined195" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined195List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUserDefined195ListUpdateInput>>;
};

export type MetadataNestedMetadataUserDefined237ListCreateInput = {
  /** Connect existing "MetadataUserDefined237" nodes to the new "Metadata" node, through the "Metadata.metadataUserDefined237List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined237WhereUniqueInput>>;
  /** Create new "MetadataUserDefined237" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUserDefined237List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined237WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUserDefined237ListUpdateInput = {
  /** Connect existing "MetadataUserDefined237" nodes to the existing "Metadata" node, through the "Metadata.metadataUserDefined237List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined237WhereUniqueInput>>;
  /** Create new "MetadataUserDefined237" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined237List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined237WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUserDefined237" nodes from the "Metadata.metadataUserDefined237List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined237WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined237" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined237List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUserDefined237ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined237" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined237List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUserDefined237ListUpdateInput>>;
};

export type MetadataNestedMetadataUserDefined238ListCreateInput = {
  /** Connect existing "MetadataUserDefined238" nodes to the new "Metadata" node, through the "Metadata.metadataUserDefined238List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined238WhereUniqueInput>>;
  /** Create new "MetadataUserDefined238" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUserDefined238List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined238WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUserDefined238ListUpdateInput = {
  /** Connect existing "MetadataUserDefined238" nodes to the existing "Metadata" node, through the "Metadata.metadataUserDefined238List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined238WhereUniqueInput>>;
  /** Create new "MetadataUserDefined238" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined238List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined238WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUserDefined238" nodes from the "Metadata.metadataUserDefined238List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined238WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined238" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined238List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUserDefined238ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined238" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined238List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUserDefined238ListUpdateInput>>;
};

export type MetadataNestedMetadataUserDefined239ListCreateInput = {
  /** Connect existing "MetadataUserDefined239" nodes to the new "Metadata" node, through the "Metadata.metadataUserDefined239List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined239WhereUniqueInput>>;
  /** Create new "MetadataUserDefined239" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUserDefined239List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined239WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUserDefined239ListUpdateInput = {
  /** Connect existing "MetadataUserDefined239" nodes to the existing "Metadata" node, through the "Metadata.metadataUserDefined239List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined239WhereUniqueInput>>;
  /** Create new "MetadataUserDefined239" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined239List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined239WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUserDefined239" nodes from the "Metadata.metadataUserDefined239List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined239WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined239" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined239List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUserDefined239ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined239" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined239List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUserDefined239ListUpdateInput>>;
};

export type MetadataNestedMetadataUserDefined242ListCreateInput = {
  /** Connect existing "MetadataUserDefined242" nodes to the new "Metadata" node, through the "Metadata.metadataUserDefined242List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined242WhereUniqueInput>>;
  /** Create new "MetadataUserDefined242" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUserDefined242List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined242WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUserDefined242ListUpdateInput = {
  /** Connect existing "MetadataUserDefined242" nodes to the existing "Metadata" node, through the "Metadata.metadataUserDefined242List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined242WhereUniqueInput>>;
  /** Create new "MetadataUserDefined242" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined242List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined242WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUserDefined242" nodes from the "Metadata.metadataUserDefined242List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined242WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined242" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined242List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUserDefined242ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined242" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined242List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUserDefined242ListUpdateInput>>;
};

export type MetadataNestedMetadataUserDefined62ListCreateInput = {
  /** Connect existing "MetadataUserDefined62" nodes to the new "Metadata" node, through the "Metadata.metadataUserDefined62List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined62WhereUniqueInput>>;
  /** Create new "MetadataUserDefined62" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataUserDefined62List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined62WithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataUserDefined62ListUpdateInput = {
  /** Connect existing "MetadataUserDefined62" nodes to the existing "Metadata" node, through the "Metadata.metadataUserDefined62List" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined62WhereUniqueInput>>;
  /** Create new "MetadataUserDefined62" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined62List" relation. */
  create?: InputMaybe<Array<MetadataUserDefined62WithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataUserDefined62" nodes from the "Metadata.metadataUserDefined62List" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined62WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined62" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined62List" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataUserDefined62ListUpdateInput>>;
  /** Upsert existing "MetadataUserDefined62" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataUserDefined62List" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataUserDefined62ListUpdateInput>>;
};

export type MetadataNestedMetadataWorkflowKindListCreateInput = {
  /** Connect existing "MetadataWorkflowKind" nodes to the new "Metadata" node, through the "Metadata.metadataWorkflowKindList" relation. */
  connect?: InputMaybe<Array<MetadataWorkflowKindWhereUniqueInput>>;
  /** Create new "MetadataWorkflowKind" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataWorkflowKindList" relation. */
  create?: InputMaybe<Array<MetadataWorkflowKindWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataWorkflowKindListUpdateInput = {
  /** Connect existing "MetadataWorkflowKind" nodes to the existing "Metadata" node, through the "Metadata.metadataWorkflowKindList" relation. */
  connect?: InputMaybe<Array<MetadataWorkflowKindWhereUniqueInput>>;
  /** Create new "MetadataWorkflowKind" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataWorkflowKindList" relation. */
  create?: InputMaybe<Array<MetadataWorkflowKindWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataWorkflowKind" nodes from the "Metadata.metadataWorkflowKindList" relation. */
  delete?: InputMaybe<Array<MetadataWorkflowKindWhereUniqueInput>>;
  /** Update existing "MetadataWorkflowKind" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataWorkflowKindList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataWorkflowKindListUpdateInput>>;
  /** Upsert existing "MetadataWorkflowKind" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataWorkflowKindList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataWorkflowKindListUpdateInput>>;
};

export type MetadataNestedMetadataXmpHistoryListCreateInput = {
  /** Connect existing "MetadataXmpHistory" nodes to the new "Metadata" node, through the "Metadata.metadataXmpHistoryList" relation. */
  connect?: InputMaybe<Array<MetadataXmpHistoryWhereUniqueInput>>;
  /** Create new "MetadataXmpHistory" nodes and connect them to the new "Metadata" node, through the "Metadata.metadataXmpHistoryList" relation. */
  create?: InputMaybe<Array<MetadataXmpHistoryWithForcedMetadataCreateInput>>;
};

export type MetadataNestedMetadataXmpHistoryListUpdateInput = {
  /** Connect existing "MetadataXmpHistory" nodes to the existing "Metadata" node, through the "Metadata.metadataXmpHistoryList" relation. */
  connect?: InputMaybe<Array<MetadataXmpHistoryWhereUniqueInput>>;
  /** Create new "MetadataXmpHistory" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataXmpHistoryList" relation. */
  create?: InputMaybe<Array<MetadataXmpHistoryWithForcedMetadataCreateInput>>;
  /** Delete existing "MetadataXmpHistory" nodes from the "Metadata.metadataXmpHistoryList" relation. */
  delete?: InputMaybe<Array<MetadataXmpHistoryWhereUniqueInput>>;
  /** Update existing "MetadataXmpHistory" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataXmpHistoryList" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdateMetadataXmpHistoryListUpdateInput>>;
  /** Upsert existing "MetadataXmpHistory" nodes and connect them to the existing "Metadata" node, through the "Metadata.metadataXmpHistoryList" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertMetadataXmpHistoryListUpdateInput>>;
};

export type MetadataNestedPhotoMetadatasCreateInput = {
  /** Connect existing "PhotoMetadata" nodes to the new "Metadata" node, through the "Metadata.photoMetadatas" relation. */
  connect?: InputMaybe<Array<PhotoMetadataWhereUniqueInput>>;
  /** Create new "PhotoMetadata" nodes and connect them to the new "Metadata" node, through the "Metadata.photoMetadatas" relation. */
  create?: InputMaybe<Array<PhotoMetadataWithForcedMetadataCreateInput>>;
};

export type MetadataNestedPhotoMetadatasUpdateInput = {
  /** Connect existing "PhotoMetadata" nodes to the existing "Metadata" node, through the "Metadata.photoMetadatas" relation. */
  connect?: InputMaybe<Array<PhotoMetadataWhereUniqueInput>>;
  /** Create new "PhotoMetadata" nodes and connect them to the existing "Metadata" node, through the "Metadata.photoMetadatas" relation. */
  create?: InputMaybe<Array<PhotoMetadataWithForcedMetadataCreateInput>>;
  /** Delete existing "PhotoMetadata" nodes from the "Metadata.photoMetadatas" relation. */
  delete?: InputMaybe<Array<PhotoMetadataWhereUniqueInput>>;
  /** Update existing "PhotoMetadata" nodes and connect them to the existing "Metadata" node, through the "Metadata.photoMetadatas" relation. */
  update?: InputMaybe<Array<MetadataNestedUpdatePhotoMetadatasUpdateInput>>;
  /** Upsert existing "PhotoMetadata" nodes and connect them to the existing "Metadata" node, through the "Metadata.photoMetadatas" relation. */
  upsert?: InputMaybe<Array<MetadataNestedUpsertPhotoMetadatasUpdateInput>>;
};

export type MetadataNestedUpdateMetadataAccessRightsListUpdateInput = {
  data: MetadataAccessRightsWithForcedMetadataUpdateInput;
  where: MetadataAccessRightsWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataAssetStateListUpdateInput = {
  data: MetadataAssetStateWithForcedMetadataUpdateInput;
  where: MetadataAssetStateWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataBackupNameListUpdateInput = {
  data: MetadataBackupNameWithForcedMetadataUpdateInput;
  where: MetadataBackupNameWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataBrandListUpdateInput = {
  data: MetadataBrandWithForcedMetadataUpdateInput;
  where: MetadataBrandWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataBrandPrismaListUpdateInput = {
  data: MetadataBrandPrismaWithForcedMetadataUpdateInput;
  where: MetadataBrandPrismaWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataBrandShortNameListUpdateInput = {
  data: MetadataBrandShortNameWithForcedMetadataUpdateInput;
  where: MetadataBrandShortNameWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataByLineListUpdateInput = {
  data: MetadataByLineWithForcedMetadataUpdateInput;
  where: MetadataByLineWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCaptionAbstractListUpdateInput = {
  data: MetadataCaptionAbstractWithForcedMetadataUpdateInput;
  where: MetadataCaptionAbstractWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCaptionListUpdateInput = {
  data: MetadataCaptionWithForcedMetadataUpdateInput;
  where: MetadataCaptionWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCategoryListUpdateInput = {
  data: MetadataCategoryWithForcedMetadataUpdateInput;
  where: MetadataCategoryWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCategoryPrismaListUpdateInput = {
  data: MetadataCategoryPrismaWithForcedMetadataUpdateInput;
  where: MetadataCategoryPrismaWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCompanyListUpdateInput = {
  data: MetadataCompanyWithForcedMetadataUpdateInput;
  where: MetadataCompanyWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCompanyShortNameListUpdateInput = {
  data: MetadataCompanyShortNameWithForcedMetadataUpdateInput;
  where: MetadataCompanyShortNameWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCopyrightNoticeListUpdateInput = {
  data: MetadataCopyrightNoticeWithForcedMetadataUpdateInput;
  where: MetadataCopyrightNoticeWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCreatorListUpdateInput = {
  data: MetadataCreatorWithForcedMetadataUpdateInput;
  where: MetadataCreatorWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCreditListUpdateInput = {
  data: MetadataCreditWithForcedMetadataUpdateInput;
  where: MetadataCreditWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField14ListUpdateInput = {
  data: MetadataCustomField14WithForcedMetadataUpdateInput;
  where: MetadataCustomField14WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField15ListUpdateInput = {
  data: MetadataCustomField15WithForcedMetadataUpdateInput;
  where: MetadataCustomField15WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField16ListUpdateInput = {
  data: MetadataCustomField16WithForcedMetadataUpdateInput;
  where: MetadataCustomField16WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField17ListUpdateInput = {
  data: MetadataCustomField17WithForcedMetadataUpdateInput;
  where: MetadataCustomField17WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField1ListUpdateInput = {
  data: MetadataCustomField1WithForcedMetadataUpdateInput;
  where: MetadataCustomField1WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField20ListUpdateInput = {
  data: MetadataCustomField20WithForcedMetadataUpdateInput;
  where: MetadataCustomField20WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField3ListUpdateInput = {
  data: MetadataCustomField3WithForcedMetadataUpdateInput;
  where: MetadataCustomField3WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField4ListUpdateInput = {
  data: MetadataCustomField4WithForcedMetadataUpdateInput;
  where: MetadataCustomField4WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField5ListUpdateInput = {
  data: MetadataCustomField5WithForcedMetadataUpdateInput;
  where: MetadataCustomField5WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField6ListUpdateInput = {
  data: MetadataCustomField6WithForcedMetadataUpdateInput;
  where: MetadataCustomField6WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField7ListUpdateInput = {
  data: MetadataCustomField7WithForcedMetadataUpdateInput;
  where: MetadataCustomField7WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataCustomField9ListUpdateInput = {
  data: MetadataCustomField9WithForcedMetadataUpdateInput;
  where: MetadataCustomField9WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDateCreatedListUpdateInput = {
  data: MetadataDateCreatedWithForcedMetadataUpdateInput;
  where: MetadataDateCreatedWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDateTimeOriginalListUpdateInput = {
  data: MetadataDateTimeOriginalWithForcedMetadataUpdateInput;
  where: MetadataDateTimeOriginalWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryAccountListUpdateInput = {
  data: MetadataDeliveryAccountWithForcedMetadataUpdateInput;
  where: MetadataDeliveryAccountWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryCompanyListUpdateInput = {
  data: MetadataDeliveryCompanyWithForcedMetadataUpdateInput;
  where: MetadataDeliveryCompanyWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryCopyrightListUpdateInput = {
  data: MetadataDeliveryCopyrightWithForcedMetadataUpdateInput;
  where: MetadataDeliveryCopyrightWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryDateFolderListUpdateInput = {
  data: MetadataDeliveryDateFolderWithForcedMetadataUpdateInput;
  where: MetadataDeliveryDateFolderWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryDateTimeListUpdateInput = {
  data: MetadataDeliveryDateTimeWithForcedMetadataUpdateInput;
  where: MetadataDeliveryDateTimeWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryDcCreatorListUpdateInput = {
  data: MetadataDeliveryDcCreatorWithForcedMetadataUpdateInput;
  where: MetadataDeliveryDcCreatorWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryDcRightsListUpdateInput = {
  data: MetadataDeliveryDcRightsWithForcedMetadataUpdateInput;
  where: MetadataDeliveryDcRightsWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryFolderListUpdateInput = {
  data: MetadataDeliveryFolderWithForcedMetadataUpdateInput;
  where: MetadataDeliveryFolderWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryKindListUpdateInput = {
  data: MetadataDeliveryKindWithForcedMetadataUpdateInput;
  where: MetadataDeliveryKindWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryPathListUpdateInput = {
  data: MetadataDeliveryPathWithForcedMetadataUpdateInput;
  where: MetadataDeliveryPathWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryPhotoshopCreditListUpdateInput = {
  data: MetadataDeliveryPhotoshopCreditWithForcedMetadataUpdateInput;
  where: MetadataDeliveryPhotoshopCreditWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryPhotoshopSourceListUpdateInput = {
  data: MetadataDeliveryPhotoshopSourceWithForcedMetadataUpdateInput;
  where: MetadataDeliveryPhotoshopSourceWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryServiceListUpdateInput = {
  data: MetadataDeliveryServiceWithForcedMetadataUpdateInput;
  where: MetadataDeliveryServiceWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliverySubjectListUpdateInput = {
  data: MetadataDeliverySubjectWithForcedMetadataUpdateInput;
  where: MetadataDeliverySubjectWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDeliveryUnderSubjectListUpdateInput = {
  data: MetadataDeliveryUnderSubjectWithForcedMetadataUpdateInput;
  where: MetadataDeliveryUnderSubjectWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDepartmentListUpdateInput = {
  data: MetadataDepartmentWithForcedMetadataUpdateInput;
  where: MetadataDepartmentWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataDescriptionListUpdateInput = {
  data: MetadataDescriptionWithForcedMetadataUpdateInput;
  where: MetadataDescriptionWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataEditionListUpdateInput = {
  data: MetadataEditionWithForcedMetadataUpdateInput;
  where: MetadataEditionWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataEditStatusListUpdateInput = {
  data: MetadataEditStatusWithForcedMetadataUpdateInput;
  where: MetadataEditStatusWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataFileStatusListUpdateInput = {
  data: MetadataFileStatusWithForcedMetadataUpdateInput;
  where: MetadataFileStatusWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataFormatListUpdateInput = {
  data: MetadataFormatWithForcedMetadataUpdateInput;
  where: MetadataFormatWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataHeaderListUpdateInput = {
  data: MetadataHeaderWithForcedMetadataUpdateInput;
  where: MetadataHeaderWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataHeaderPrismaListUpdateInput = {
  data: MetadataHeaderPrismaWithForcedMetadataUpdateInput;
  where: MetadataHeaderPrismaWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataHeadlineListUpdateInput = {
  data: MetadataHeadlineWithForcedMetadataUpdateInput;
  where: MetadataHeadlineWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataIdAssignmentListUpdateInput = {
  data: MetadataIdAssignmentWithForcedMetadataUpdateInput;
  where: MetadataIdAssignmentWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataIdPhotoPrismaListUpdateInput = {
  data: MetadataIdPhotoPrismaWithForcedMetadataUpdateInput;
  where: MetadataIdPhotoPrismaWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataIdSubjectListUpdateInput = {
  data: MetadataIdSubjectWithForcedMetadataUpdateInput;
  where: MetadataIdSubjectWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataImageNotesListUpdateInput = {
  data: MetadataImageNotesWithForcedMetadataUpdateInput;
  where: MetadataImageNotesWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataInstructionsListUpdateInput = {
  data: MetadataInstructionsWithForcedMetadataUpdateInput;
  where: MetadataInstructionsWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataIssueListUpdateInput = {
  data: MetadataIssueWithForcedMetadataUpdateInput;
  where: MetadataIssueWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataKeywordsListUpdateInput = {
  data: MetadataKeywordsWithForcedMetadataUpdateInput;
  where: MetadataKeywordsWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataObjectNameListUpdateInput = {
  data: MetadataObjectNameWithForcedMetadataUpdateInput;
  where: MetadataObjectNameWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataOriginalNameListUpdateInput = {
  data: MetadataOriginalNameWithForcedMetadataUpdateInput;
  where: MetadataOriginalNameWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataPriceLevelListUpdateInput = {
  data: MetadataPriceLevelWithForcedMetadataUpdateInput;
  where: MetadataPriceLevelWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataProcessHistoryListUpdateInput = {
  data: MetadataProcessHistoryWithForcedMetadataUpdateInput;
  where: MetadataProcessHistoryWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataProcessStatusListUpdateInput = {
  data: MetadataProcessStatusWithForcedMetadataUpdateInput;
  where: MetadataProcessStatusWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataProductListUpdateInput = {
  data: MetadataProductWithForcedMetadataUpdateInput;
  where: MetadataProductWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataProductsListUpdateInput = {
  data: MetadataProductsWithForcedMetadataUpdateInput;
  where: MetadataProductsWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataPublishingSubjectListUpdateInput = {
  data: MetadataPublishingSubjectWithForcedMetadataUpdateInput;
  where: MetadataPublishingSubjectWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataResolutionKindListUpdateInput = {
  data: MetadataResolutionKindWithForcedMetadataUpdateInput;
  where: MetadataResolutionKindWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataRightsListUpdateInput = {
  data: MetadataRightsWithForcedMetadataUpdateInput;
  where: MetadataRightsWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataSourceListUpdateInput = {
  data: MetadataSourceWithForcedMetadataUpdateInput;
  where: MetadataSourceWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataSpecialInstructionsListUpdateInput = {
  data: MetadataSpecialInstructionsWithForcedMetadataUpdateInput;
  where: MetadataSpecialInstructionsWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataSubjectCodeListUpdateInput = {
  data: MetadataSubjectCodeWithForcedMetadataUpdateInput;
  where: MetadataSubjectCodeWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataSubjectListUpdateInput = {
  data: MetadataSubjectWithForcedMetadataUpdateInput;
  where: MetadataSubjectWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataSubjectPrismaListUpdateInput = {
  data: MetadataSubjectPrismaWithForcedMetadataUpdateInput;
  where: MetadataSubjectPrismaWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataTitleListUpdateInput = {
  data: MetadataTitleWithForcedMetadataUpdateInput;
  where: MetadataTitleWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataTransferredByFullNameListUpdateInput = {
  data: MetadataTransferredByFullNameWithForcedMetadataUpdateInput;
  where: MetadataTransferredByFullNameWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataTransferredByListUpdateInput = {
  data: MetadataTransferredByWithForcedMetadataUpdateInput;
  where: MetadataTransferredByWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataTypeListUpdateInput = {
  data: MetadataTypeWithForcedMetadataUpdateInput;
  where: MetadataTypeWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUndersubjectListUpdateInput = {
  data: MetadataUndersubjectWithForcedMetadataUpdateInput;
  where: MetadataUndersubjectWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUnderUnderSubjectListUpdateInput = {
  data: MetadataUnderUnderSubjectWithForcedMetadataUpdateInput;
  where: MetadataUnderUnderSubjectWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUploadedByFullNameListUpdateInput = {
  data: MetadataUploadedByFullNameWithForcedMetadataUpdateInput;
  where: MetadataUploadedByFullNameWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUploadedByListUpdateInput = {
  data: MetadataUploadedByWithForcedMetadataUpdateInput;
  where: MetadataUploadedByWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUploadTimeListUpdateInput = {
  data: MetadataUploadTimeWithForcedMetadataUpdateInput;
  where: MetadataUploadTimeWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUrgencyListUpdateInput = {
  data: MetadataUrgencyWithForcedMetadataUpdateInput;
  where: MetadataUrgencyWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUserDefined195ListUpdateInput = {
  data: MetadataUserDefined195WithForcedMetadataUpdateInput;
  where: MetadataUserDefined195WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUserDefined237ListUpdateInput = {
  data: MetadataUserDefined237WithForcedMetadataUpdateInput;
  where: MetadataUserDefined237WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUserDefined238ListUpdateInput = {
  data: MetadataUserDefined238WithForcedMetadataUpdateInput;
  where: MetadataUserDefined238WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUserDefined239ListUpdateInput = {
  data: MetadataUserDefined239WithForcedMetadataUpdateInput;
  where: MetadataUserDefined239WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUserDefined242ListUpdateInput = {
  data: MetadataUserDefined242WithForcedMetadataUpdateInput;
  where: MetadataUserDefined242WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataUserDefined62ListUpdateInput = {
  data: MetadataUserDefined62WithForcedMetadataUpdateInput;
  where: MetadataUserDefined62WhereUniqueInput;
};

export type MetadataNestedUpdateMetadataWorkflowKindListUpdateInput = {
  data: MetadataWorkflowKindWithForcedMetadataUpdateInput;
  where: MetadataWorkflowKindWhereUniqueInput;
};

export type MetadataNestedUpdateMetadataXmpHistoryListUpdateInput = {
  data: MetadataXmpHistoryWithForcedMetadataUpdateInput;
  where: MetadataXmpHistoryWhereUniqueInput;
};

export type MetadataNestedUpdatePhotoMetadatasUpdateInput = {
  data: PhotoMetadataWithForcedMetadataUpdateInput;
  where: PhotoMetadataWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataAccessRightsListUpdateInput = {
  create: MetadataAccessRightsWithForcedMetadataCreateInput;
  update: MetadataAccessRightsWithForcedMetadataUpdateInput;
  where: MetadataAccessRightsWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataAssetStateListUpdateInput = {
  create: MetadataAssetStateWithForcedMetadataCreateInput;
  update: MetadataAssetStateWithForcedMetadataUpdateInput;
  where: MetadataAssetStateWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataBackupNameListUpdateInput = {
  create: MetadataBackupNameWithForcedMetadataCreateInput;
  update: MetadataBackupNameWithForcedMetadataUpdateInput;
  where: MetadataBackupNameWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataBrandListUpdateInput = {
  create: MetadataBrandWithForcedMetadataCreateInput;
  update: MetadataBrandWithForcedMetadataUpdateInput;
  where: MetadataBrandWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataBrandPrismaListUpdateInput = {
  create: MetadataBrandPrismaWithForcedMetadataCreateInput;
  update: MetadataBrandPrismaWithForcedMetadataUpdateInput;
  where: MetadataBrandPrismaWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataBrandShortNameListUpdateInput = {
  create: MetadataBrandShortNameWithForcedMetadataCreateInput;
  update: MetadataBrandShortNameWithForcedMetadataUpdateInput;
  where: MetadataBrandShortNameWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataByLineListUpdateInput = {
  create: MetadataByLineWithForcedMetadataCreateInput;
  update: MetadataByLineWithForcedMetadataUpdateInput;
  where: MetadataByLineWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCaptionAbstractListUpdateInput = {
  create: MetadataCaptionAbstractWithForcedMetadataCreateInput;
  update: MetadataCaptionAbstractWithForcedMetadataUpdateInput;
  where: MetadataCaptionAbstractWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCaptionListUpdateInput = {
  create: MetadataCaptionWithForcedMetadataCreateInput;
  update: MetadataCaptionWithForcedMetadataUpdateInput;
  where: MetadataCaptionWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCategoryListUpdateInput = {
  create: MetadataCategoryWithForcedMetadataCreateInput;
  update: MetadataCategoryWithForcedMetadataUpdateInput;
  where: MetadataCategoryWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCategoryPrismaListUpdateInput = {
  create: MetadataCategoryPrismaWithForcedMetadataCreateInput;
  update: MetadataCategoryPrismaWithForcedMetadataUpdateInput;
  where: MetadataCategoryPrismaWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCompanyListUpdateInput = {
  create: MetadataCompanyWithForcedMetadataCreateInput;
  update: MetadataCompanyWithForcedMetadataUpdateInput;
  where: MetadataCompanyWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCompanyShortNameListUpdateInput = {
  create: MetadataCompanyShortNameWithForcedMetadataCreateInput;
  update: MetadataCompanyShortNameWithForcedMetadataUpdateInput;
  where: MetadataCompanyShortNameWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCopyrightNoticeListUpdateInput = {
  create: MetadataCopyrightNoticeWithForcedMetadataCreateInput;
  update: MetadataCopyrightNoticeWithForcedMetadataUpdateInput;
  where: MetadataCopyrightNoticeWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCreatorListUpdateInput = {
  create: MetadataCreatorWithForcedMetadataCreateInput;
  update: MetadataCreatorWithForcedMetadataUpdateInput;
  where: MetadataCreatorWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCreditListUpdateInput = {
  create: MetadataCreditWithForcedMetadataCreateInput;
  update: MetadataCreditWithForcedMetadataUpdateInput;
  where: MetadataCreditWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField14ListUpdateInput = {
  create: MetadataCustomField14WithForcedMetadataCreateInput;
  update: MetadataCustomField14WithForcedMetadataUpdateInput;
  where: MetadataCustomField14WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField15ListUpdateInput = {
  create: MetadataCustomField15WithForcedMetadataCreateInput;
  update: MetadataCustomField15WithForcedMetadataUpdateInput;
  where: MetadataCustomField15WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField16ListUpdateInput = {
  create: MetadataCustomField16WithForcedMetadataCreateInput;
  update: MetadataCustomField16WithForcedMetadataUpdateInput;
  where: MetadataCustomField16WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField17ListUpdateInput = {
  create: MetadataCustomField17WithForcedMetadataCreateInput;
  update: MetadataCustomField17WithForcedMetadataUpdateInput;
  where: MetadataCustomField17WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField1ListUpdateInput = {
  create: MetadataCustomField1WithForcedMetadataCreateInput;
  update: MetadataCustomField1WithForcedMetadataUpdateInput;
  where: MetadataCustomField1WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField20ListUpdateInput = {
  create: MetadataCustomField20WithForcedMetadataCreateInput;
  update: MetadataCustomField20WithForcedMetadataUpdateInput;
  where: MetadataCustomField20WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField3ListUpdateInput = {
  create: MetadataCustomField3WithForcedMetadataCreateInput;
  update: MetadataCustomField3WithForcedMetadataUpdateInput;
  where: MetadataCustomField3WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField4ListUpdateInput = {
  create: MetadataCustomField4WithForcedMetadataCreateInput;
  update: MetadataCustomField4WithForcedMetadataUpdateInput;
  where: MetadataCustomField4WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField5ListUpdateInput = {
  create: MetadataCustomField5WithForcedMetadataCreateInput;
  update: MetadataCustomField5WithForcedMetadataUpdateInput;
  where: MetadataCustomField5WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField6ListUpdateInput = {
  create: MetadataCustomField6WithForcedMetadataCreateInput;
  update: MetadataCustomField6WithForcedMetadataUpdateInput;
  where: MetadataCustomField6WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField7ListUpdateInput = {
  create: MetadataCustomField7WithForcedMetadataCreateInput;
  update: MetadataCustomField7WithForcedMetadataUpdateInput;
  where: MetadataCustomField7WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataCustomField9ListUpdateInput = {
  create: MetadataCustomField9WithForcedMetadataCreateInput;
  update: MetadataCustomField9WithForcedMetadataUpdateInput;
  where: MetadataCustomField9WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDateCreatedListUpdateInput = {
  create: MetadataDateCreatedWithForcedMetadataCreateInput;
  update: MetadataDateCreatedWithForcedMetadataUpdateInput;
  where: MetadataDateCreatedWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDateTimeOriginalListUpdateInput = {
  create: MetadataDateTimeOriginalWithForcedMetadataCreateInput;
  update: MetadataDateTimeOriginalWithForcedMetadataUpdateInput;
  where: MetadataDateTimeOriginalWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryAccountListUpdateInput = {
  create: MetadataDeliveryAccountWithForcedMetadataCreateInput;
  update: MetadataDeliveryAccountWithForcedMetadataUpdateInput;
  where: MetadataDeliveryAccountWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryCompanyListUpdateInput = {
  create: MetadataDeliveryCompanyWithForcedMetadataCreateInput;
  update: MetadataDeliveryCompanyWithForcedMetadataUpdateInput;
  where: MetadataDeliveryCompanyWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryCopyrightListUpdateInput = {
  create: MetadataDeliveryCopyrightWithForcedMetadataCreateInput;
  update: MetadataDeliveryCopyrightWithForcedMetadataUpdateInput;
  where: MetadataDeliveryCopyrightWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryDateFolderListUpdateInput = {
  create: MetadataDeliveryDateFolderWithForcedMetadataCreateInput;
  update: MetadataDeliveryDateFolderWithForcedMetadataUpdateInput;
  where: MetadataDeliveryDateFolderWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryDateTimeListUpdateInput = {
  create: MetadataDeliveryDateTimeWithForcedMetadataCreateInput;
  update: MetadataDeliveryDateTimeWithForcedMetadataUpdateInput;
  where: MetadataDeliveryDateTimeWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryDcCreatorListUpdateInput = {
  create: MetadataDeliveryDcCreatorWithForcedMetadataCreateInput;
  update: MetadataDeliveryDcCreatorWithForcedMetadataUpdateInput;
  where: MetadataDeliveryDcCreatorWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryDcRightsListUpdateInput = {
  create: MetadataDeliveryDcRightsWithForcedMetadataCreateInput;
  update: MetadataDeliveryDcRightsWithForcedMetadataUpdateInput;
  where: MetadataDeliveryDcRightsWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryFolderListUpdateInput = {
  create: MetadataDeliveryFolderWithForcedMetadataCreateInput;
  update: MetadataDeliveryFolderWithForcedMetadataUpdateInput;
  where: MetadataDeliveryFolderWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryKindListUpdateInput = {
  create: MetadataDeliveryKindWithForcedMetadataCreateInput;
  update: MetadataDeliveryKindWithForcedMetadataUpdateInput;
  where: MetadataDeliveryKindWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryPathListUpdateInput = {
  create: MetadataDeliveryPathWithForcedMetadataCreateInput;
  update: MetadataDeliveryPathWithForcedMetadataUpdateInput;
  where: MetadataDeliveryPathWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryPhotoshopCreditListUpdateInput = {
  create: MetadataDeliveryPhotoshopCreditWithForcedMetadataCreateInput;
  update: MetadataDeliveryPhotoshopCreditWithForcedMetadataUpdateInput;
  where: MetadataDeliveryPhotoshopCreditWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryPhotoshopSourceListUpdateInput = {
  create: MetadataDeliveryPhotoshopSourceWithForcedMetadataCreateInput;
  update: MetadataDeliveryPhotoshopSourceWithForcedMetadataUpdateInput;
  where: MetadataDeliveryPhotoshopSourceWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryServiceListUpdateInput = {
  create: MetadataDeliveryServiceWithForcedMetadataCreateInput;
  update: MetadataDeliveryServiceWithForcedMetadataUpdateInput;
  where: MetadataDeliveryServiceWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliverySubjectListUpdateInput = {
  create: MetadataDeliverySubjectWithForcedMetadataCreateInput;
  update: MetadataDeliverySubjectWithForcedMetadataUpdateInput;
  where: MetadataDeliverySubjectWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDeliveryUnderSubjectListUpdateInput = {
  create: MetadataDeliveryUnderSubjectWithForcedMetadataCreateInput;
  update: MetadataDeliveryUnderSubjectWithForcedMetadataUpdateInput;
  where: MetadataDeliveryUnderSubjectWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDepartmentListUpdateInput = {
  create: MetadataDepartmentWithForcedMetadataCreateInput;
  update: MetadataDepartmentWithForcedMetadataUpdateInput;
  where: MetadataDepartmentWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataDescriptionListUpdateInput = {
  create: MetadataDescriptionWithForcedMetadataCreateInput;
  update: MetadataDescriptionWithForcedMetadataUpdateInput;
  where: MetadataDescriptionWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataEditionListUpdateInput = {
  create: MetadataEditionWithForcedMetadataCreateInput;
  update: MetadataEditionWithForcedMetadataUpdateInput;
  where: MetadataEditionWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataEditStatusListUpdateInput = {
  create: MetadataEditStatusWithForcedMetadataCreateInput;
  update: MetadataEditStatusWithForcedMetadataUpdateInput;
  where: MetadataEditStatusWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataFileStatusListUpdateInput = {
  create: MetadataFileStatusWithForcedMetadataCreateInput;
  update: MetadataFileStatusWithForcedMetadataUpdateInput;
  where: MetadataFileStatusWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataFormatListUpdateInput = {
  create: MetadataFormatWithForcedMetadataCreateInput;
  update: MetadataFormatWithForcedMetadataUpdateInput;
  where: MetadataFormatWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataHeaderListUpdateInput = {
  create: MetadataHeaderWithForcedMetadataCreateInput;
  update: MetadataHeaderWithForcedMetadataUpdateInput;
  where: MetadataHeaderWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataHeaderPrismaListUpdateInput = {
  create: MetadataHeaderPrismaWithForcedMetadataCreateInput;
  update: MetadataHeaderPrismaWithForcedMetadataUpdateInput;
  where: MetadataHeaderPrismaWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataHeadlineListUpdateInput = {
  create: MetadataHeadlineWithForcedMetadataCreateInput;
  update: MetadataHeadlineWithForcedMetadataUpdateInput;
  where: MetadataHeadlineWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataIdAssignmentListUpdateInput = {
  create: MetadataIdAssignmentWithForcedMetadataCreateInput;
  update: MetadataIdAssignmentWithForcedMetadataUpdateInput;
  where: MetadataIdAssignmentWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataIdPhotoPrismaListUpdateInput = {
  create: MetadataIdPhotoPrismaWithForcedMetadataCreateInput;
  update: MetadataIdPhotoPrismaWithForcedMetadataUpdateInput;
  where: MetadataIdPhotoPrismaWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataIdSubjectListUpdateInput = {
  create: MetadataIdSubjectWithForcedMetadataCreateInput;
  update: MetadataIdSubjectWithForcedMetadataUpdateInput;
  where: MetadataIdSubjectWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataImageNotesListUpdateInput = {
  create: MetadataImageNotesWithForcedMetadataCreateInput;
  update: MetadataImageNotesWithForcedMetadataUpdateInput;
  where: MetadataImageNotesWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataInstructionsListUpdateInput = {
  create: MetadataInstructionsWithForcedMetadataCreateInput;
  update: MetadataInstructionsWithForcedMetadataUpdateInput;
  where: MetadataInstructionsWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataIssueListUpdateInput = {
  create: MetadataIssueWithForcedMetadataCreateInput;
  update: MetadataIssueWithForcedMetadataUpdateInput;
  where: MetadataIssueWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataKeywordsListUpdateInput = {
  create: MetadataKeywordsWithForcedMetadataCreateInput;
  update: MetadataKeywordsWithForcedMetadataUpdateInput;
  where: MetadataKeywordsWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataObjectNameListUpdateInput = {
  create: MetadataObjectNameWithForcedMetadataCreateInput;
  update: MetadataObjectNameWithForcedMetadataUpdateInput;
  where: MetadataObjectNameWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataOriginalNameListUpdateInput = {
  create: MetadataOriginalNameWithForcedMetadataCreateInput;
  update: MetadataOriginalNameWithForcedMetadataUpdateInput;
  where: MetadataOriginalNameWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataPriceLevelListUpdateInput = {
  create: MetadataPriceLevelWithForcedMetadataCreateInput;
  update: MetadataPriceLevelWithForcedMetadataUpdateInput;
  where: MetadataPriceLevelWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataProcessHistoryListUpdateInput = {
  create: MetadataProcessHistoryWithForcedMetadataCreateInput;
  update: MetadataProcessHistoryWithForcedMetadataUpdateInput;
  where: MetadataProcessHistoryWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataProcessStatusListUpdateInput = {
  create: MetadataProcessStatusWithForcedMetadataCreateInput;
  update: MetadataProcessStatusWithForcedMetadataUpdateInput;
  where: MetadataProcessStatusWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataProductListUpdateInput = {
  create: MetadataProductWithForcedMetadataCreateInput;
  update: MetadataProductWithForcedMetadataUpdateInput;
  where: MetadataProductWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataProductsListUpdateInput = {
  create: MetadataProductsWithForcedMetadataCreateInput;
  update: MetadataProductsWithForcedMetadataUpdateInput;
  where: MetadataProductsWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataPublishingSubjectListUpdateInput = {
  create: MetadataPublishingSubjectWithForcedMetadataCreateInput;
  update: MetadataPublishingSubjectWithForcedMetadataUpdateInput;
  where: MetadataPublishingSubjectWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataResolutionKindListUpdateInput = {
  create: MetadataResolutionKindWithForcedMetadataCreateInput;
  update: MetadataResolutionKindWithForcedMetadataUpdateInput;
  where: MetadataResolutionKindWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataRightsListUpdateInput = {
  create: MetadataRightsWithForcedMetadataCreateInput;
  update: MetadataRightsWithForcedMetadataUpdateInput;
  where: MetadataRightsWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataSourceListUpdateInput = {
  create: MetadataSourceWithForcedMetadataCreateInput;
  update: MetadataSourceWithForcedMetadataUpdateInput;
  where: MetadataSourceWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataSpecialInstructionsListUpdateInput = {
  create: MetadataSpecialInstructionsWithForcedMetadataCreateInput;
  update: MetadataSpecialInstructionsWithForcedMetadataUpdateInput;
  where: MetadataSpecialInstructionsWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataSubjectCodeListUpdateInput = {
  create: MetadataSubjectCodeWithForcedMetadataCreateInput;
  update: MetadataSubjectCodeWithForcedMetadataUpdateInput;
  where: MetadataSubjectCodeWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataSubjectListUpdateInput = {
  create: MetadataSubjectWithForcedMetadataCreateInput;
  update: MetadataSubjectWithForcedMetadataUpdateInput;
  where: MetadataSubjectWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataSubjectPrismaListUpdateInput = {
  create: MetadataSubjectPrismaWithForcedMetadataCreateInput;
  update: MetadataSubjectPrismaWithForcedMetadataUpdateInput;
  where: MetadataSubjectPrismaWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataTitleListUpdateInput = {
  create: MetadataTitleWithForcedMetadataCreateInput;
  update: MetadataTitleWithForcedMetadataUpdateInput;
  where: MetadataTitleWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataTransferredByFullNameListUpdateInput = {
  create: MetadataTransferredByFullNameWithForcedMetadataCreateInput;
  update: MetadataTransferredByFullNameWithForcedMetadataUpdateInput;
  where: MetadataTransferredByFullNameWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataTransferredByListUpdateInput = {
  create: MetadataTransferredByWithForcedMetadataCreateInput;
  update: MetadataTransferredByWithForcedMetadataUpdateInput;
  where: MetadataTransferredByWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataTypeListUpdateInput = {
  create: MetadataTypeWithForcedMetadataCreateInput;
  update: MetadataTypeWithForcedMetadataUpdateInput;
  where: MetadataTypeWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUndersubjectListUpdateInput = {
  create: MetadataUndersubjectWithForcedMetadataCreateInput;
  update: MetadataUndersubjectWithForcedMetadataUpdateInput;
  where: MetadataUndersubjectWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUnderUnderSubjectListUpdateInput = {
  create: MetadataUnderUnderSubjectWithForcedMetadataCreateInput;
  update: MetadataUnderUnderSubjectWithForcedMetadataUpdateInput;
  where: MetadataUnderUnderSubjectWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUploadedByFullNameListUpdateInput = {
  create: MetadataUploadedByFullNameWithForcedMetadataCreateInput;
  update: MetadataUploadedByFullNameWithForcedMetadataUpdateInput;
  where: MetadataUploadedByFullNameWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUploadedByListUpdateInput = {
  create: MetadataUploadedByWithForcedMetadataCreateInput;
  update: MetadataUploadedByWithForcedMetadataUpdateInput;
  where: MetadataUploadedByWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUploadTimeListUpdateInput = {
  create: MetadataUploadTimeWithForcedMetadataCreateInput;
  update: MetadataUploadTimeWithForcedMetadataUpdateInput;
  where: MetadataUploadTimeWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUrgencyListUpdateInput = {
  create: MetadataUrgencyWithForcedMetadataCreateInput;
  update: MetadataUrgencyWithForcedMetadataUpdateInput;
  where: MetadataUrgencyWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUserDefined195ListUpdateInput = {
  create: MetadataUserDefined195WithForcedMetadataCreateInput;
  update: MetadataUserDefined195WithForcedMetadataUpdateInput;
  where: MetadataUserDefined195WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUserDefined237ListUpdateInput = {
  create: MetadataUserDefined237WithForcedMetadataCreateInput;
  update: MetadataUserDefined237WithForcedMetadataUpdateInput;
  where: MetadataUserDefined237WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUserDefined238ListUpdateInput = {
  create: MetadataUserDefined238WithForcedMetadataCreateInput;
  update: MetadataUserDefined238WithForcedMetadataUpdateInput;
  where: MetadataUserDefined238WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUserDefined239ListUpdateInput = {
  create: MetadataUserDefined239WithForcedMetadataCreateInput;
  update: MetadataUserDefined239WithForcedMetadataUpdateInput;
  where: MetadataUserDefined239WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUserDefined242ListUpdateInput = {
  create: MetadataUserDefined242WithForcedMetadataCreateInput;
  update: MetadataUserDefined242WithForcedMetadataUpdateInput;
  where: MetadataUserDefined242WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataUserDefined62ListUpdateInput = {
  create: MetadataUserDefined62WithForcedMetadataCreateInput;
  update: MetadataUserDefined62WithForcedMetadataUpdateInput;
  where: MetadataUserDefined62WhereUniqueInput;
};

export type MetadataNestedUpsertMetadataWorkflowKindListUpdateInput = {
  create: MetadataWorkflowKindWithForcedMetadataCreateInput;
  update: MetadataWorkflowKindWithForcedMetadataUpdateInput;
  where: MetadataWorkflowKindWhereUniqueInput;
};

export type MetadataNestedUpsertMetadataXmpHistoryListUpdateInput = {
  create: MetadataXmpHistoryWithForcedMetadataCreateInput;
  update: MetadataXmpHistoryWithForcedMetadataUpdateInput;
  where: MetadataXmpHistoryWhereUniqueInput;
};

export type MetadataNestedUpsertPhotoMetadatasUpdateInput = {
  create: PhotoMetadataWithForcedMetadataCreateInput;
  update: PhotoMetadataWithForcedMetadataUpdateInput;
  where: PhotoMetadataWhereUniqueInput;
};

/** "MetadataObjectName" resource's node */
export type MetadataObjectName = {
  __typename?: 'MetadataObjectName';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataObjectNameCreateInput = {
  /** Actions for the "MetadataObjectName.archive" relation */
  archive: MetadataObjectNameNestedArchiveCreateInput;
  /** Actions for the "MetadataObjectName.metadata" relation */
  metadata: MetadataObjectNameNestedMetadataCreateInput;
  /** Actions for the "MetadataObjectName.photo" relation */
  photo: MetadataObjectNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataObjectNameNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataObjectName" node, through the "MetadataObjectName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataObjectName" node, through the "MetadataObjectName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataObjectName" node, through the "MetadataObjectName.archive" relation. */
  update?: InputMaybe<MetadataObjectNameNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataObjectName" node, through the "MetadataObjectName.archive" relation. */
  upsert?: InputMaybe<MetadataObjectNameNestedUpsertArchiveCreateInput>;
};

export type MetadataObjectNameNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataObjectName" node, through the "MetadataObjectName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataObjectName" node, through the "MetadataObjectName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataObjectName" node, through the "MetadataObjectName.archive" relation. */
  update?: InputMaybe<MetadataObjectNameNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataObjectName" node, through the "MetadataObjectName.archive" relation. */
  upsert?: InputMaybe<MetadataObjectNameNestedUpsertArchiveUpdateInput>;
};

export type MetadataObjectNameNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataObjectName" node, through the "MetadataObjectName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataObjectName" node, through the "MetadataObjectName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataObjectName" node, through the "MetadataObjectName.metadata" relation. */
  update?: InputMaybe<MetadataObjectNameNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataObjectName" node, through the "MetadataObjectName.metadata" relation. */
  upsert?: InputMaybe<MetadataObjectNameNestedUpsertMetadataCreateInput>;
};

export type MetadataObjectNameNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataObjectName" node, through the "MetadataObjectName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataObjectName" node, through the "MetadataObjectName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataObjectName" node, through the "MetadataObjectName.metadata" relation. */
  update?: InputMaybe<MetadataObjectNameNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataObjectName" node, through the "MetadataObjectName.metadata" relation. */
  upsert?: InputMaybe<MetadataObjectNameNestedUpsertMetadataUpdateInput>;
};

export type MetadataObjectNameNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataObjectName" node, through the "MetadataObjectName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataObjectName" node, through the "MetadataObjectName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataObjectName" node, through the "MetadataObjectName.photo" relation. */
  update?: InputMaybe<MetadataObjectNameNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataObjectName" node, through the "MetadataObjectName.photo" relation. */
  upsert?: InputMaybe<MetadataObjectNameNestedUpsertPhotoCreateInput>;
};

export type MetadataObjectNameNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataObjectName" node, through the "MetadataObjectName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataObjectName" node, through the "MetadataObjectName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataObjectName" node, through the "MetadataObjectName.photo" relation. */
  update?: InputMaybe<MetadataObjectNameNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataObjectName" node, through the "MetadataObjectName.photo" relation. */
  upsert?: InputMaybe<MetadataObjectNameNestedUpsertPhotoUpdateInput>;
};

export type MetadataObjectNameNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataObjectNameNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataObjectNameNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataObjectNameNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataObjectNameNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataObjectNameNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataObjectNameNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataObjectNameNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataObjectNameNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataObjectNameNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataObjectNameNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataObjectNameNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataObjectNameOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataObjectNameUpdateInput = {
  /** Actions for the "MetadataObjectName.archive" relation */
  archive?: InputMaybe<MetadataObjectNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataObjectName.metadata" relation */
  metadata?: InputMaybe<MetadataObjectNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataObjectName.photo" relation */
  photo?: InputMaybe<MetadataObjectNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataObjectName" nodes by specifying some conditions */
export type MetadataObjectNameWhereInput = {
  AND?: InputMaybe<Array<MetadataObjectNameWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataObjectNameWhereInput>;
  OR?: InputMaybe<Array<MetadataObjectNameWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataObjectName" node. */
export type MetadataObjectNameWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataObjectNameWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataObjectName.metadata" relation */
  metadata: MetadataObjectNameNestedMetadataCreateInput;
  /** Actions for the "MetadataObjectName.photo" relation */
  photo: MetadataObjectNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataObjectNameWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataObjectName.metadata" relation */
  metadata?: InputMaybe<MetadataObjectNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataObjectName.photo" relation */
  photo?: InputMaybe<MetadataObjectNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataObjectNameWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataObjectName.archive" relation */
  archive: MetadataObjectNameNestedArchiveCreateInput;
  /** Actions for the "MetadataObjectName.photo" relation */
  photo: MetadataObjectNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataObjectNameWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataObjectName.archive" relation */
  archive?: InputMaybe<MetadataObjectNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataObjectName.photo" relation */
  photo?: InputMaybe<MetadataObjectNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataObjectNameWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataObjectName.archive" relation */
  archive: MetadataObjectNameNestedArchiveCreateInput;
  /** Actions for the "MetadataObjectName.metadata" relation */
  metadata: MetadataObjectNameNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataObjectNameWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataObjectName.archive" relation */
  archive?: InputMaybe<MetadataObjectNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataObjectName.metadata" relation */
  metadata?: InputMaybe<MetadataObjectNameNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataOccurrenceQlType = {
  __typename?: 'MetadataOccurrenceQLType';
  occurrence: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export enum MetadataOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  legacyName_ASC = 'legacyName_ASC',
  legacyName_DESC = 'legacyName_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  namespace_ASC = 'namespace_ASC',
  namespace_DESC = 'namespace_DESC',
  structName_ASC = 'structName_ASC',
  structName_DESC = 'structName_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC'
}

/** "MetadataOriginalName" resource's node */
export type MetadataOriginalName = {
  __typename?: 'MetadataOriginalName';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataOriginalNameCreateInput = {
  /** Actions for the "MetadataOriginalName.archive" relation */
  archive: MetadataOriginalNameNestedArchiveCreateInput;
  /** Actions for the "MetadataOriginalName.metadata" relation */
  metadata: MetadataOriginalNameNestedMetadataCreateInput;
  /** Actions for the "MetadataOriginalName.photo" relation */
  photo: MetadataOriginalNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataOriginalNameNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataOriginalName" node, through the "MetadataOriginalName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataOriginalName" node, through the "MetadataOriginalName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataOriginalName" node, through the "MetadataOriginalName.archive" relation. */
  update?: InputMaybe<MetadataOriginalNameNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataOriginalName" node, through the "MetadataOriginalName.archive" relation. */
  upsert?: InputMaybe<MetadataOriginalNameNestedUpsertArchiveCreateInput>;
};

export type MetadataOriginalNameNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.archive" relation. */
  update?: InputMaybe<MetadataOriginalNameNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.archive" relation. */
  upsert?: InputMaybe<MetadataOriginalNameNestedUpsertArchiveUpdateInput>;
};

export type MetadataOriginalNameNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataOriginalName" node, through the "MetadataOriginalName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataOriginalName" node, through the "MetadataOriginalName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataOriginalName" node, through the "MetadataOriginalName.metadata" relation. */
  update?: InputMaybe<MetadataOriginalNameNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataOriginalName" node, through the "MetadataOriginalName.metadata" relation. */
  upsert?: InputMaybe<MetadataOriginalNameNestedUpsertMetadataCreateInput>;
};

export type MetadataOriginalNameNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.metadata" relation. */
  update?: InputMaybe<MetadataOriginalNameNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.metadata" relation. */
  upsert?: InputMaybe<MetadataOriginalNameNestedUpsertMetadataUpdateInput>;
};

export type MetadataOriginalNameNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataOriginalName" node, through the "MetadataOriginalName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataOriginalName" node, through the "MetadataOriginalName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataOriginalName" node, through the "MetadataOriginalName.photo" relation. */
  update?: InputMaybe<MetadataOriginalNameNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataOriginalName" node, through the "MetadataOriginalName.photo" relation. */
  upsert?: InputMaybe<MetadataOriginalNameNestedUpsertPhotoCreateInput>;
};

export type MetadataOriginalNameNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.photo" relation. */
  update?: InputMaybe<MetadataOriginalNameNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataOriginalName" node, through the "MetadataOriginalName.photo" relation. */
  upsert?: InputMaybe<MetadataOriginalNameNestedUpsertPhotoUpdateInput>;
};

export type MetadataOriginalNameNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataOriginalNameNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataOriginalNameOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataOriginalNameUpdateInput = {
  /** Actions for the "MetadataOriginalName.archive" relation */
  archive?: InputMaybe<MetadataOriginalNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataOriginalName.metadata" relation */
  metadata?: InputMaybe<MetadataOriginalNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataOriginalName.photo" relation */
  photo?: InputMaybe<MetadataOriginalNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataOriginalName" nodes by specifying some conditions */
export type MetadataOriginalNameWhereInput = {
  AND?: InputMaybe<Array<MetadataOriginalNameWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataOriginalNameWhereInput>;
  OR?: InputMaybe<Array<MetadataOriginalNameWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataOriginalName" node. */
export type MetadataOriginalNameWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataOriginalNameWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataOriginalName.metadata" relation */
  metadata: MetadataOriginalNameNestedMetadataCreateInput;
  /** Actions for the "MetadataOriginalName.photo" relation */
  photo: MetadataOriginalNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataOriginalNameWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataOriginalName.metadata" relation */
  metadata?: InputMaybe<MetadataOriginalNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataOriginalName.photo" relation */
  photo?: InputMaybe<MetadataOriginalNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataOriginalNameWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataOriginalName.archive" relation */
  archive: MetadataOriginalNameNestedArchiveCreateInput;
  /** Actions for the "MetadataOriginalName.photo" relation */
  photo: MetadataOriginalNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataOriginalNameWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataOriginalName.archive" relation */
  archive?: InputMaybe<MetadataOriginalNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataOriginalName.photo" relation */
  photo?: InputMaybe<MetadataOriginalNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataOriginalNameWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataOriginalName.archive" relation */
  archive: MetadataOriginalNameNestedArchiveCreateInput;
  /** Actions for the "MetadataOriginalName.metadata" relation */
  metadata: MetadataOriginalNameNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataOriginalNameWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataOriginalName.archive" relation */
  archive?: InputMaybe<MetadataOriginalNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataOriginalName.metadata" relation */
  metadata?: InputMaybe<MetadataOriginalNameNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataPriceLevel" resource's node */
export type MetadataPriceLevel = {
  __typename?: 'MetadataPriceLevel';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataPriceLevelCreateInput = {
  /** Actions for the "MetadataPriceLevel.archive" relation */
  archive: MetadataPriceLevelNestedArchiveCreateInput;
  /** Actions for the "MetadataPriceLevel.metadata" relation */
  metadata: MetadataPriceLevelNestedMetadataCreateInput;
  /** Actions for the "MetadataPriceLevel.photo" relation */
  photo: MetadataPriceLevelNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPriceLevelNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.archive" relation. */
  update?: InputMaybe<MetadataPriceLevelNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.archive" relation. */
  upsert?: InputMaybe<MetadataPriceLevelNestedUpsertArchiveCreateInput>;
};

export type MetadataPriceLevelNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.archive" relation. */
  update?: InputMaybe<MetadataPriceLevelNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.archive" relation. */
  upsert?: InputMaybe<MetadataPriceLevelNestedUpsertArchiveUpdateInput>;
};

export type MetadataPriceLevelNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.metadata" relation. */
  update?: InputMaybe<MetadataPriceLevelNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.metadata" relation. */
  upsert?: InputMaybe<MetadataPriceLevelNestedUpsertMetadataCreateInput>;
};

export type MetadataPriceLevelNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.metadata" relation. */
  update?: InputMaybe<MetadataPriceLevelNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.metadata" relation. */
  upsert?: InputMaybe<MetadataPriceLevelNestedUpsertMetadataUpdateInput>;
};

export type MetadataPriceLevelNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.photo" relation. */
  update?: InputMaybe<MetadataPriceLevelNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataPriceLevel" node, through the "MetadataPriceLevel.photo" relation. */
  upsert?: InputMaybe<MetadataPriceLevelNestedUpsertPhotoCreateInput>;
};

export type MetadataPriceLevelNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.photo" relation. */
  update?: InputMaybe<MetadataPriceLevelNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataPriceLevel" node, through the "MetadataPriceLevel.photo" relation. */
  upsert?: InputMaybe<MetadataPriceLevelNestedUpsertPhotoUpdateInput>;
};

export type MetadataPriceLevelNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataPriceLevelNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataPriceLevelOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataPriceLevelUpdateInput = {
  /** Actions for the "MetadataPriceLevel.archive" relation */
  archive?: InputMaybe<MetadataPriceLevelNestedArchiveUpdateInput>;
  /** Actions for the "MetadataPriceLevel.metadata" relation */
  metadata?: InputMaybe<MetadataPriceLevelNestedMetadataUpdateInput>;
  /** Actions for the "MetadataPriceLevel.photo" relation */
  photo?: InputMaybe<MetadataPriceLevelNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataPriceLevel" nodes by specifying some conditions */
export type MetadataPriceLevelWhereInput = {
  AND?: InputMaybe<Array<MetadataPriceLevelWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataPriceLevelWhereInput>;
  OR?: InputMaybe<Array<MetadataPriceLevelWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataPriceLevel" node. */
export type MetadataPriceLevelWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataPriceLevelWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataPriceLevel.metadata" relation */
  metadata: MetadataPriceLevelNestedMetadataCreateInput;
  /** Actions for the "MetadataPriceLevel.photo" relation */
  photo: MetadataPriceLevelNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPriceLevelWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataPriceLevel.metadata" relation */
  metadata?: InputMaybe<MetadataPriceLevelNestedMetadataUpdateInput>;
  /** Actions for the "MetadataPriceLevel.photo" relation */
  photo?: InputMaybe<MetadataPriceLevelNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPriceLevelWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataPriceLevel.archive" relation */
  archive: MetadataPriceLevelNestedArchiveCreateInput;
  /** Actions for the "MetadataPriceLevel.photo" relation */
  photo: MetadataPriceLevelNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPriceLevelWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataPriceLevel.archive" relation */
  archive?: InputMaybe<MetadataPriceLevelNestedArchiveUpdateInput>;
  /** Actions for the "MetadataPriceLevel.photo" relation */
  photo?: InputMaybe<MetadataPriceLevelNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPriceLevelWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataPriceLevel.archive" relation */
  archive: MetadataPriceLevelNestedArchiveCreateInput;
  /** Actions for the "MetadataPriceLevel.metadata" relation */
  metadata: MetadataPriceLevelNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPriceLevelWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataPriceLevel.archive" relation */
  archive?: InputMaybe<MetadataPriceLevelNestedArchiveUpdateInput>;
  /** Actions for the "MetadataPriceLevel.metadata" relation */
  metadata?: InputMaybe<MetadataPriceLevelNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataProcessHistory" resource's node */
export type MetadataProcessHistory = {
  __typename?: 'MetadataProcessHistory';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataProcessHistoryCreateInput = {
  /** Actions for the "MetadataProcessHistory.archive" relation */
  archive: MetadataProcessHistoryNestedArchiveCreateInput;
  /** Actions for the "MetadataProcessHistory.metadata" relation */
  metadata: MetadataProcessHistoryNestedMetadataCreateInput;
  /** Actions for the "MetadataProcessHistory.photo" relation */
  photo: MetadataProcessHistoryNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessHistoryNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.archive" relation. */
  update?: InputMaybe<MetadataProcessHistoryNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.archive" relation. */
  upsert?: InputMaybe<MetadataProcessHistoryNestedUpsertArchiveCreateInput>;
};

export type MetadataProcessHistoryNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.archive" relation. */
  update?: InputMaybe<MetadataProcessHistoryNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.archive" relation. */
  upsert?: InputMaybe<MetadataProcessHistoryNestedUpsertArchiveUpdateInput>;
};

export type MetadataProcessHistoryNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.metadata" relation. */
  update?: InputMaybe<MetadataProcessHistoryNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.metadata" relation. */
  upsert?: InputMaybe<MetadataProcessHistoryNestedUpsertMetadataCreateInput>;
};

export type MetadataProcessHistoryNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.metadata" relation. */
  update?: InputMaybe<MetadataProcessHistoryNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.metadata" relation. */
  upsert?: InputMaybe<MetadataProcessHistoryNestedUpsertMetadataUpdateInput>;
};

export type MetadataProcessHistoryNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.photo" relation. */
  update?: InputMaybe<MetadataProcessHistoryNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataProcessHistory" node, through the "MetadataProcessHistory.photo" relation. */
  upsert?: InputMaybe<MetadataProcessHistoryNestedUpsertPhotoCreateInput>;
};

export type MetadataProcessHistoryNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.photo" relation. */
  update?: InputMaybe<MetadataProcessHistoryNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataProcessHistory" node, through the "MetadataProcessHistory.photo" relation. */
  upsert?: InputMaybe<MetadataProcessHistoryNestedUpsertPhotoUpdateInput>;
};

export type MetadataProcessHistoryNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProcessHistoryNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataProcessHistoryOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataProcessHistoryUpdateInput = {
  /** Actions for the "MetadataProcessHistory.archive" relation */
  archive?: InputMaybe<MetadataProcessHistoryNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProcessHistory.metadata" relation */
  metadata?: InputMaybe<MetadataProcessHistoryNestedMetadataUpdateInput>;
  /** Actions for the "MetadataProcessHistory.photo" relation */
  photo?: InputMaybe<MetadataProcessHistoryNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataProcessHistory" nodes by specifying some conditions */
export type MetadataProcessHistoryWhereInput = {
  AND?: InputMaybe<Array<MetadataProcessHistoryWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataProcessHistoryWhereInput>;
  OR?: InputMaybe<Array<MetadataProcessHistoryWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataProcessHistory" node. */
export type MetadataProcessHistoryWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataProcessHistoryWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataProcessHistory.metadata" relation */
  metadata: MetadataProcessHistoryNestedMetadataCreateInput;
  /** Actions for the "MetadataProcessHistory.photo" relation */
  photo: MetadataProcessHistoryNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessHistoryWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataProcessHistory.metadata" relation */
  metadata?: InputMaybe<MetadataProcessHistoryNestedMetadataUpdateInput>;
  /** Actions for the "MetadataProcessHistory.photo" relation */
  photo?: InputMaybe<MetadataProcessHistoryNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessHistoryWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataProcessHistory.archive" relation */
  archive: MetadataProcessHistoryNestedArchiveCreateInput;
  /** Actions for the "MetadataProcessHistory.photo" relation */
  photo: MetadataProcessHistoryNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessHistoryWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataProcessHistory.archive" relation */
  archive?: InputMaybe<MetadataProcessHistoryNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProcessHistory.photo" relation */
  photo?: InputMaybe<MetadataProcessHistoryNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessHistoryWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataProcessHistory.archive" relation */
  archive: MetadataProcessHistoryNestedArchiveCreateInput;
  /** Actions for the "MetadataProcessHistory.metadata" relation */
  metadata: MetadataProcessHistoryNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessHistoryWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataProcessHistory.archive" relation */
  archive?: InputMaybe<MetadataProcessHistoryNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProcessHistory.metadata" relation */
  metadata?: InputMaybe<MetadataProcessHistoryNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataProcessStatus" resource's node */
export type MetadataProcessStatus = {
  __typename?: 'MetadataProcessStatus';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataProcessStatusCreateInput = {
  /** Actions for the "MetadataProcessStatus.archive" relation */
  archive: MetadataProcessStatusNestedArchiveCreateInput;
  /** Actions for the "MetadataProcessStatus.metadata" relation */
  metadata: MetadataProcessStatusNestedMetadataCreateInput;
  /** Actions for the "MetadataProcessStatus.photo" relation */
  photo: MetadataProcessStatusNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessStatusNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.archive" relation. */
  update?: InputMaybe<MetadataProcessStatusNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.archive" relation. */
  upsert?: InputMaybe<MetadataProcessStatusNestedUpsertArchiveCreateInput>;
};

export type MetadataProcessStatusNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.archive" relation. */
  update?: InputMaybe<MetadataProcessStatusNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.archive" relation. */
  upsert?: InputMaybe<MetadataProcessStatusNestedUpsertArchiveUpdateInput>;
};

export type MetadataProcessStatusNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.metadata" relation. */
  update?: InputMaybe<MetadataProcessStatusNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.metadata" relation. */
  upsert?: InputMaybe<MetadataProcessStatusNestedUpsertMetadataCreateInput>;
};

export type MetadataProcessStatusNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.metadata" relation. */
  update?: InputMaybe<MetadataProcessStatusNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.metadata" relation. */
  upsert?: InputMaybe<MetadataProcessStatusNestedUpsertMetadataUpdateInput>;
};

export type MetadataProcessStatusNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.photo" relation. */
  update?: InputMaybe<MetadataProcessStatusNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataProcessStatus" node, through the "MetadataProcessStatus.photo" relation. */
  upsert?: InputMaybe<MetadataProcessStatusNestedUpsertPhotoCreateInput>;
};

export type MetadataProcessStatusNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.photo" relation. */
  update?: InputMaybe<MetadataProcessStatusNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataProcessStatus" node, through the "MetadataProcessStatus.photo" relation. */
  upsert?: InputMaybe<MetadataProcessStatusNestedUpsertPhotoUpdateInput>;
};

export type MetadataProcessStatusNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProcessStatusNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataProcessStatusOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataProcessStatusUpdateInput = {
  /** Actions for the "MetadataProcessStatus.archive" relation */
  archive?: InputMaybe<MetadataProcessStatusNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProcessStatus.metadata" relation */
  metadata?: InputMaybe<MetadataProcessStatusNestedMetadataUpdateInput>;
  /** Actions for the "MetadataProcessStatus.photo" relation */
  photo?: InputMaybe<MetadataProcessStatusNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataProcessStatus" nodes by specifying some conditions */
export type MetadataProcessStatusWhereInput = {
  AND?: InputMaybe<Array<MetadataProcessStatusWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataProcessStatusWhereInput>;
  OR?: InputMaybe<Array<MetadataProcessStatusWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataProcessStatus" node. */
export type MetadataProcessStatusWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataProcessStatusWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataProcessStatus.metadata" relation */
  metadata: MetadataProcessStatusNestedMetadataCreateInput;
  /** Actions for the "MetadataProcessStatus.photo" relation */
  photo: MetadataProcessStatusNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessStatusWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataProcessStatus.metadata" relation */
  metadata?: InputMaybe<MetadataProcessStatusNestedMetadataUpdateInput>;
  /** Actions for the "MetadataProcessStatus.photo" relation */
  photo?: InputMaybe<MetadataProcessStatusNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessStatusWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataProcessStatus.archive" relation */
  archive: MetadataProcessStatusNestedArchiveCreateInput;
  /** Actions for the "MetadataProcessStatus.photo" relation */
  photo: MetadataProcessStatusNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessStatusWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataProcessStatus.archive" relation */
  archive?: InputMaybe<MetadataProcessStatusNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProcessStatus.photo" relation */
  photo?: InputMaybe<MetadataProcessStatusNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessStatusWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataProcessStatus.archive" relation */
  archive: MetadataProcessStatusNestedArchiveCreateInput;
  /** Actions for the "MetadataProcessStatus.metadata" relation */
  metadata: MetadataProcessStatusNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProcessStatusWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataProcessStatus.archive" relation */
  archive?: InputMaybe<MetadataProcessStatusNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProcessStatus.metadata" relation */
  metadata?: InputMaybe<MetadataProcessStatusNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataProduct" resource's node */
export type MetadataProduct = {
  __typename?: 'MetadataProduct';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataProductCreateInput = {
  /** Actions for the "MetadataProduct.archive" relation */
  archive: MetadataProductNestedArchiveCreateInput;
  /** Actions for the "MetadataProduct.metadata" relation */
  metadata: MetadataProductNestedMetadataCreateInput;
  /** Actions for the "MetadataProduct.photo" relation */
  photo: MetadataProductNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataProduct" node, through the "MetadataProduct.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataProduct" node, through the "MetadataProduct.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataProduct" node, through the "MetadataProduct.archive" relation. */
  update?: InputMaybe<MetadataProductNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataProduct" node, through the "MetadataProduct.archive" relation. */
  upsert?: InputMaybe<MetadataProductNestedUpsertArchiveCreateInput>;
};

export type MetadataProductNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataProduct" node, through the "MetadataProduct.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataProduct" node, through the "MetadataProduct.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataProduct" node, through the "MetadataProduct.archive" relation. */
  update?: InputMaybe<MetadataProductNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataProduct" node, through the "MetadataProduct.archive" relation. */
  upsert?: InputMaybe<MetadataProductNestedUpsertArchiveUpdateInput>;
};

export type MetadataProductNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataProduct" node, through the "MetadataProduct.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataProduct" node, through the "MetadataProduct.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataProduct" node, through the "MetadataProduct.metadata" relation. */
  update?: InputMaybe<MetadataProductNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataProduct" node, through the "MetadataProduct.metadata" relation. */
  upsert?: InputMaybe<MetadataProductNestedUpsertMetadataCreateInput>;
};

export type MetadataProductNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataProduct" node, through the "MetadataProduct.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataProduct" node, through the "MetadataProduct.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataProduct" node, through the "MetadataProduct.metadata" relation. */
  update?: InputMaybe<MetadataProductNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataProduct" node, through the "MetadataProduct.metadata" relation. */
  upsert?: InputMaybe<MetadataProductNestedUpsertMetadataUpdateInput>;
};

export type MetadataProductNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataProduct" node, through the "MetadataProduct.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataProduct" node, through the "MetadataProduct.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataProduct" node, through the "MetadataProduct.photo" relation. */
  update?: InputMaybe<MetadataProductNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataProduct" node, through the "MetadataProduct.photo" relation. */
  upsert?: InputMaybe<MetadataProductNestedUpsertPhotoCreateInput>;
};

export type MetadataProductNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataProduct" node, through the "MetadataProduct.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataProduct" node, through the "MetadataProduct.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataProduct" node, through the "MetadataProduct.photo" relation. */
  update?: InputMaybe<MetadataProductNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataProduct" node, through the "MetadataProduct.photo" relation. */
  upsert?: InputMaybe<MetadataProductNestedUpsertPhotoUpdateInput>;
};

export type MetadataProductNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProductNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProductNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProductNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProductNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProductNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProductNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProductNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProductNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProductNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProductNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProductNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataProductOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

/** "MetadataProducts" resource's node */
export type MetadataProducts = {
  __typename?: 'MetadataProducts';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataProductsCreateInput = {
  /** Actions for the "MetadataProducts.archive" relation */
  archive: MetadataProductsNestedArchiveCreateInput;
  /** Actions for the "MetadataProducts.metadata" relation */
  metadata: MetadataProductsNestedMetadataCreateInput;
  /** Actions for the "MetadataProducts.photo" relation */
  photo: MetadataProductsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductsNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataProducts" node, through the "MetadataProducts.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataProducts" node, through the "MetadataProducts.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataProducts" node, through the "MetadataProducts.archive" relation. */
  update?: InputMaybe<MetadataProductsNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataProducts" node, through the "MetadataProducts.archive" relation. */
  upsert?: InputMaybe<MetadataProductsNestedUpsertArchiveCreateInput>;
};

export type MetadataProductsNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataProducts" node, through the "MetadataProducts.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataProducts" node, through the "MetadataProducts.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataProducts" node, through the "MetadataProducts.archive" relation. */
  update?: InputMaybe<MetadataProductsNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataProducts" node, through the "MetadataProducts.archive" relation. */
  upsert?: InputMaybe<MetadataProductsNestedUpsertArchiveUpdateInput>;
};

export type MetadataProductsNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataProducts" node, through the "MetadataProducts.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataProducts" node, through the "MetadataProducts.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataProducts" node, through the "MetadataProducts.metadata" relation. */
  update?: InputMaybe<MetadataProductsNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataProducts" node, through the "MetadataProducts.metadata" relation. */
  upsert?: InputMaybe<MetadataProductsNestedUpsertMetadataCreateInput>;
};

export type MetadataProductsNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataProducts" node, through the "MetadataProducts.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataProducts" node, through the "MetadataProducts.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataProducts" node, through the "MetadataProducts.metadata" relation. */
  update?: InputMaybe<MetadataProductsNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataProducts" node, through the "MetadataProducts.metadata" relation. */
  upsert?: InputMaybe<MetadataProductsNestedUpsertMetadataUpdateInput>;
};

export type MetadataProductsNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataProducts" node, through the "MetadataProducts.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataProducts" node, through the "MetadataProducts.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataProducts" node, through the "MetadataProducts.photo" relation. */
  update?: InputMaybe<MetadataProductsNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataProducts" node, through the "MetadataProducts.photo" relation. */
  upsert?: InputMaybe<MetadataProductsNestedUpsertPhotoCreateInput>;
};

export type MetadataProductsNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataProducts" node, through the "MetadataProducts.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataProducts" node, through the "MetadataProducts.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataProducts" node, through the "MetadataProducts.photo" relation. */
  update?: InputMaybe<MetadataProductsNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataProducts" node, through the "MetadataProducts.photo" relation. */
  upsert?: InputMaybe<MetadataProductsNestedUpsertPhotoUpdateInput>;
};

export type MetadataProductsNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProductsNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProductsNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProductsNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProductsNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProductsNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProductsNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProductsNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataProductsNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProductsNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataProductsNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataProductsNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataProductsOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataProductsUpdateInput = {
  /** Actions for the "MetadataProducts.archive" relation */
  archive?: InputMaybe<MetadataProductsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProducts.metadata" relation */
  metadata?: InputMaybe<MetadataProductsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataProducts.photo" relation */
  photo?: InputMaybe<MetadataProductsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataProducts" nodes by specifying some conditions */
export type MetadataProductsWhereInput = {
  AND?: InputMaybe<Array<MetadataProductsWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataProductsWhereInput>;
  OR?: InputMaybe<Array<MetadataProductsWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataProducts" node. */
export type MetadataProductsWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataProductsWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataProducts.metadata" relation */
  metadata: MetadataProductsNestedMetadataCreateInput;
  /** Actions for the "MetadataProducts.photo" relation */
  photo: MetadataProductsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductsWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataProducts.metadata" relation */
  metadata?: InputMaybe<MetadataProductsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataProducts.photo" relation */
  photo?: InputMaybe<MetadataProductsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductsWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataProducts.archive" relation */
  archive: MetadataProductsNestedArchiveCreateInput;
  /** Actions for the "MetadataProducts.photo" relation */
  photo: MetadataProductsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductsWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataProducts.archive" relation */
  archive?: InputMaybe<MetadataProductsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProducts.photo" relation */
  photo?: InputMaybe<MetadataProductsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductsWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataProducts.archive" relation */
  archive: MetadataProductsNestedArchiveCreateInput;
  /** Actions for the "MetadataProducts.metadata" relation */
  metadata: MetadataProductsNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductsWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataProducts.archive" relation */
  archive?: InputMaybe<MetadataProductsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProducts.metadata" relation */
  metadata?: InputMaybe<MetadataProductsNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductUpdateInput = {
  /** Actions for the "MetadataProduct.archive" relation */
  archive?: InputMaybe<MetadataProductNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProduct.metadata" relation */
  metadata?: InputMaybe<MetadataProductNestedMetadataUpdateInput>;
  /** Actions for the "MetadataProduct.photo" relation */
  photo?: InputMaybe<MetadataProductNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataProduct" nodes by specifying some conditions */
export type MetadataProductWhereInput = {
  AND?: InputMaybe<Array<MetadataProductWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataProductWhereInput>;
  OR?: InputMaybe<Array<MetadataProductWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataProduct" node. */
export type MetadataProductWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataProductWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataProduct.metadata" relation */
  metadata: MetadataProductNestedMetadataCreateInput;
  /** Actions for the "MetadataProduct.photo" relation */
  photo: MetadataProductNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataProduct.metadata" relation */
  metadata?: InputMaybe<MetadataProductNestedMetadataUpdateInput>;
  /** Actions for the "MetadataProduct.photo" relation */
  photo?: InputMaybe<MetadataProductNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataProduct.archive" relation */
  archive: MetadataProductNestedArchiveCreateInput;
  /** Actions for the "MetadataProduct.photo" relation */
  photo: MetadataProductNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataProduct.archive" relation */
  archive?: InputMaybe<MetadataProductNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProduct.photo" relation */
  photo?: InputMaybe<MetadataProductNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataProduct.archive" relation */
  archive: MetadataProductNestedArchiveCreateInput;
  /** Actions for the "MetadataProduct.metadata" relation */
  metadata: MetadataProductNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataProductWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataProduct.archive" relation */
  archive?: InputMaybe<MetadataProductNestedArchiveUpdateInput>;
  /** Actions for the "MetadataProduct.metadata" relation */
  metadata?: InputMaybe<MetadataProductNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataPublishingSubject" resource's node */
export type MetadataPublishingSubject = {
  __typename?: 'MetadataPublishingSubject';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataPublishingSubjectCreateInput = {
  /** Actions for the "MetadataPublishingSubject.archive" relation */
  archive: MetadataPublishingSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataPublishingSubject.metadata" relation */
  metadata: MetadataPublishingSubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataPublishingSubject.photo" relation */
  photo: MetadataPublishingSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPublishingSubjectNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.archive" relation. */
  update?: InputMaybe<MetadataPublishingSubjectNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.archive" relation. */
  upsert?: InputMaybe<MetadataPublishingSubjectNestedUpsertArchiveCreateInput>;
};

export type MetadataPublishingSubjectNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.archive" relation. */
  update?: InputMaybe<MetadataPublishingSubjectNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.archive" relation. */
  upsert?: InputMaybe<MetadataPublishingSubjectNestedUpsertArchiveUpdateInput>;
};

export type MetadataPublishingSubjectNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.metadata" relation. */
  update?: InputMaybe<MetadataPublishingSubjectNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.metadata" relation. */
  upsert?: InputMaybe<MetadataPublishingSubjectNestedUpsertMetadataCreateInput>;
};

export type MetadataPublishingSubjectNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.metadata" relation. */
  update?: InputMaybe<MetadataPublishingSubjectNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.metadata" relation. */
  upsert?: InputMaybe<MetadataPublishingSubjectNestedUpsertMetadataUpdateInput>;
};

export type MetadataPublishingSubjectNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.photo" relation. */
  update?: InputMaybe<MetadataPublishingSubjectNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.photo" relation. */
  upsert?: InputMaybe<MetadataPublishingSubjectNestedUpsertPhotoCreateInput>;
};

export type MetadataPublishingSubjectNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.photo" relation. */
  update?: InputMaybe<MetadataPublishingSubjectNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataPublishingSubject" node, through the "MetadataPublishingSubject.photo" relation. */
  upsert?: InputMaybe<MetadataPublishingSubjectNestedUpsertPhotoUpdateInput>;
};

export type MetadataPublishingSubjectNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataPublishingSubjectNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataPublishingSubjectOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataPublishingSubjectUpdateInput = {
  /** Actions for the "MetadataPublishingSubject.archive" relation */
  archive?: InputMaybe<MetadataPublishingSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataPublishingSubject.metadata" relation */
  metadata?: InputMaybe<MetadataPublishingSubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataPublishingSubject.photo" relation */
  photo?: InputMaybe<MetadataPublishingSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataPublishingSubject" nodes by specifying some conditions */
export type MetadataPublishingSubjectWhereInput = {
  AND?: InputMaybe<Array<MetadataPublishingSubjectWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataPublishingSubjectWhereInput>;
  OR?: InputMaybe<Array<MetadataPublishingSubjectWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataPublishingSubject" node. */
export type MetadataPublishingSubjectWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataPublishingSubjectWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataPublishingSubject.metadata" relation */
  metadata: MetadataPublishingSubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataPublishingSubject.photo" relation */
  photo: MetadataPublishingSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPublishingSubjectWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataPublishingSubject.metadata" relation */
  metadata?: InputMaybe<MetadataPublishingSubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataPublishingSubject.photo" relation */
  photo?: InputMaybe<MetadataPublishingSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPublishingSubjectWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataPublishingSubject.archive" relation */
  archive: MetadataPublishingSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataPublishingSubject.photo" relation */
  photo: MetadataPublishingSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPublishingSubjectWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataPublishingSubject.archive" relation */
  archive?: InputMaybe<MetadataPublishingSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataPublishingSubject.photo" relation */
  photo?: InputMaybe<MetadataPublishingSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPublishingSubjectWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataPublishingSubject.archive" relation */
  archive: MetadataPublishingSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataPublishingSubject.metadata" relation */
  metadata: MetadataPublishingSubjectNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataPublishingSubjectWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataPublishingSubject.archive" relation */
  archive?: InputMaybe<MetadataPublishingSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataPublishingSubject.metadata" relation */
  metadata?: InputMaybe<MetadataPublishingSubjectNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataResolutionKind" resource's node */
export type MetadataResolutionKind = {
  __typename?: 'MetadataResolutionKind';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataResolutionKindCreateInput = {
  /** Actions for the "MetadataResolutionKind.archive" relation */
  archive: MetadataResolutionKindNestedArchiveCreateInput;
  /** Actions for the "MetadataResolutionKind.metadata" relation */
  metadata: MetadataResolutionKindNestedMetadataCreateInput;
  /** Actions for the "MetadataResolutionKind.photo" relation */
  photo: MetadataResolutionKindNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataResolutionKindNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.archive" relation. */
  update?: InputMaybe<MetadataResolutionKindNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.archive" relation. */
  upsert?: InputMaybe<MetadataResolutionKindNestedUpsertArchiveCreateInput>;
};

export type MetadataResolutionKindNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.archive" relation. */
  update?: InputMaybe<MetadataResolutionKindNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.archive" relation. */
  upsert?: InputMaybe<MetadataResolutionKindNestedUpsertArchiveUpdateInput>;
};

export type MetadataResolutionKindNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.metadata" relation. */
  update?: InputMaybe<MetadataResolutionKindNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.metadata" relation. */
  upsert?: InputMaybe<MetadataResolutionKindNestedUpsertMetadataCreateInput>;
};

export type MetadataResolutionKindNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.metadata" relation. */
  update?: InputMaybe<MetadataResolutionKindNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.metadata" relation. */
  upsert?: InputMaybe<MetadataResolutionKindNestedUpsertMetadataUpdateInput>;
};

export type MetadataResolutionKindNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.photo" relation. */
  update?: InputMaybe<MetadataResolutionKindNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataResolutionKind" node, through the "MetadataResolutionKind.photo" relation. */
  upsert?: InputMaybe<MetadataResolutionKindNestedUpsertPhotoCreateInput>;
};

export type MetadataResolutionKindNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.photo" relation. */
  update?: InputMaybe<MetadataResolutionKindNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataResolutionKind" node, through the "MetadataResolutionKind.photo" relation. */
  upsert?: InputMaybe<MetadataResolutionKindNestedUpsertPhotoUpdateInput>;
};

export type MetadataResolutionKindNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataResolutionKindNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataResolutionKindOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataResolutionKindUpdateInput = {
  /** Actions for the "MetadataResolutionKind.archive" relation */
  archive?: InputMaybe<MetadataResolutionKindNestedArchiveUpdateInput>;
  /** Actions for the "MetadataResolutionKind.metadata" relation */
  metadata?: InputMaybe<MetadataResolutionKindNestedMetadataUpdateInput>;
  /** Actions for the "MetadataResolutionKind.photo" relation */
  photo?: InputMaybe<MetadataResolutionKindNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataResolutionKind" nodes by specifying some conditions */
export type MetadataResolutionKindWhereInput = {
  AND?: InputMaybe<Array<MetadataResolutionKindWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataResolutionKindWhereInput>;
  OR?: InputMaybe<Array<MetadataResolutionKindWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataResolutionKind" node. */
export type MetadataResolutionKindWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataResolutionKindWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataResolutionKind.metadata" relation */
  metadata: MetadataResolutionKindNestedMetadataCreateInput;
  /** Actions for the "MetadataResolutionKind.photo" relation */
  photo: MetadataResolutionKindNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataResolutionKindWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataResolutionKind.metadata" relation */
  metadata?: InputMaybe<MetadataResolutionKindNestedMetadataUpdateInput>;
  /** Actions for the "MetadataResolutionKind.photo" relation */
  photo?: InputMaybe<MetadataResolutionKindNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataResolutionKindWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataResolutionKind.archive" relation */
  archive: MetadataResolutionKindNestedArchiveCreateInput;
  /** Actions for the "MetadataResolutionKind.photo" relation */
  photo: MetadataResolutionKindNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataResolutionKindWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataResolutionKind.archive" relation */
  archive?: InputMaybe<MetadataResolutionKindNestedArchiveUpdateInput>;
  /** Actions for the "MetadataResolutionKind.photo" relation */
  photo?: InputMaybe<MetadataResolutionKindNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataResolutionKindWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataResolutionKind.archive" relation */
  archive: MetadataResolutionKindNestedArchiveCreateInput;
  /** Actions for the "MetadataResolutionKind.metadata" relation */
  metadata: MetadataResolutionKindNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataResolutionKindWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataResolutionKind.archive" relation */
  archive?: InputMaybe<MetadataResolutionKindNestedArchiveUpdateInput>;
  /** Actions for the "MetadataResolutionKind.metadata" relation */
  metadata?: InputMaybe<MetadataResolutionKindNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataRights" resource's node */
export type MetadataRights = {
  __typename?: 'MetadataRights';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataRightsCreateInput = {
  /** Actions for the "MetadataRights.archive" relation */
  archive: MetadataRightsNestedArchiveCreateInput;
  /** Actions for the "MetadataRights.metadata" relation */
  metadata: MetadataRightsNestedMetadataCreateInput;
  /** Actions for the "MetadataRights.photo" relation */
  photo: MetadataRightsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataRightsNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataRights" node, through the "MetadataRights.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataRights" node, through the "MetadataRights.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataRights" node, through the "MetadataRights.archive" relation. */
  update?: InputMaybe<MetadataRightsNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataRights" node, through the "MetadataRights.archive" relation. */
  upsert?: InputMaybe<MetadataRightsNestedUpsertArchiveCreateInput>;
};

export type MetadataRightsNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataRights" node, through the "MetadataRights.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataRights" node, through the "MetadataRights.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataRights" node, through the "MetadataRights.archive" relation. */
  update?: InputMaybe<MetadataRightsNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataRights" node, through the "MetadataRights.archive" relation. */
  upsert?: InputMaybe<MetadataRightsNestedUpsertArchiveUpdateInput>;
};

export type MetadataRightsNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataRights" node, through the "MetadataRights.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataRights" node, through the "MetadataRights.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataRights" node, through the "MetadataRights.metadata" relation. */
  update?: InputMaybe<MetadataRightsNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataRights" node, through the "MetadataRights.metadata" relation. */
  upsert?: InputMaybe<MetadataRightsNestedUpsertMetadataCreateInput>;
};

export type MetadataRightsNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataRights" node, through the "MetadataRights.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataRights" node, through the "MetadataRights.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataRights" node, through the "MetadataRights.metadata" relation. */
  update?: InputMaybe<MetadataRightsNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataRights" node, through the "MetadataRights.metadata" relation. */
  upsert?: InputMaybe<MetadataRightsNestedUpsertMetadataUpdateInput>;
};

export type MetadataRightsNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataRights" node, through the "MetadataRights.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataRights" node, through the "MetadataRights.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataRights" node, through the "MetadataRights.photo" relation. */
  update?: InputMaybe<MetadataRightsNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataRights" node, through the "MetadataRights.photo" relation. */
  upsert?: InputMaybe<MetadataRightsNestedUpsertPhotoCreateInput>;
};

export type MetadataRightsNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataRights" node, through the "MetadataRights.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataRights" node, through the "MetadataRights.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataRights" node, through the "MetadataRights.photo" relation. */
  update?: InputMaybe<MetadataRightsNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataRights" node, through the "MetadataRights.photo" relation. */
  upsert?: InputMaybe<MetadataRightsNestedUpsertPhotoUpdateInput>;
};

export type MetadataRightsNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataRightsNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataRightsNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataRightsNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataRightsNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataRightsNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataRightsNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataRightsNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataRightsNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataRightsNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataRightsNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataRightsNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataRightsOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataRightsUpdateInput = {
  /** Actions for the "MetadataRights.archive" relation */
  archive?: InputMaybe<MetadataRightsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataRights.metadata" relation */
  metadata?: InputMaybe<MetadataRightsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataRights.photo" relation */
  photo?: InputMaybe<MetadataRightsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataRights" nodes by specifying some conditions */
export type MetadataRightsWhereInput = {
  AND?: InputMaybe<Array<MetadataRightsWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataRightsWhereInput>;
  OR?: InputMaybe<Array<MetadataRightsWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataRights" node. */
export type MetadataRightsWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataRightsWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataRights.metadata" relation */
  metadata: MetadataRightsNestedMetadataCreateInput;
  /** Actions for the "MetadataRights.photo" relation */
  photo: MetadataRightsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataRightsWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataRights.metadata" relation */
  metadata?: InputMaybe<MetadataRightsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataRights.photo" relation */
  photo?: InputMaybe<MetadataRightsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataRightsWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataRights.archive" relation */
  archive: MetadataRightsNestedArchiveCreateInput;
  /** Actions for the "MetadataRights.photo" relation */
  photo: MetadataRightsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataRightsWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataRights.archive" relation */
  archive?: InputMaybe<MetadataRightsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataRights.photo" relation */
  photo?: InputMaybe<MetadataRightsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataRightsWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataRights.archive" relation */
  archive: MetadataRightsNestedArchiveCreateInput;
  /** Actions for the "MetadataRights.metadata" relation */
  metadata: MetadataRightsNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataRightsWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataRights.archive" relation */
  archive?: InputMaybe<MetadataRightsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataRights.metadata" relation */
  metadata?: InputMaybe<MetadataRightsNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataSource" resource's node */
export type MetadataSource = {
  __typename?: 'MetadataSource';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataSourceCreateInput = {
  /** Actions for the "MetadataSource.archive" relation */
  archive: MetadataSourceNestedArchiveCreateInput;
  /** Actions for the "MetadataSource.metadata" relation */
  metadata: MetadataSourceNestedMetadataCreateInput;
  /** Actions for the "MetadataSource.photo" relation */
  photo: MetadataSourceNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSourceNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataSource" node, through the "MetadataSource.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataSource" node, through the "MetadataSource.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataSource" node, through the "MetadataSource.archive" relation. */
  update?: InputMaybe<MetadataSourceNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataSource" node, through the "MetadataSource.archive" relation. */
  upsert?: InputMaybe<MetadataSourceNestedUpsertArchiveCreateInput>;
};

export type MetadataSourceNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataSource" node, through the "MetadataSource.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataSource" node, through the "MetadataSource.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataSource" node, through the "MetadataSource.archive" relation. */
  update?: InputMaybe<MetadataSourceNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataSource" node, through the "MetadataSource.archive" relation. */
  upsert?: InputMaybe<MetadataSourceNestedUpsertArchiveUpdateInput>;
};

export type MetadataSourceNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataSource" node, through the "MetadataSource.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataSource" node, through the "MetadataSource.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataSource" node, through the "MetadataSource.metadata" relation. */
  update?: InputMaybe<MetadataSourceNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataSource" node, through the "MetadataSource.metadata" relation. */
  upsert?: InputMaybe<MetadataSourceNestedUpsertMetadataCreateInput>;
};

export type MetadataSourceNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataSource" node, through the "MetadataSource.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataSource" node, through the "MetadataSource.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataSource" node, through the "MetadataSource.metadata" relation. */
  update?: InputMaybe<MetadataSourceNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataSource" node, through the "MetadataSource.metadata" relation. */
  upsert?: InputMaybe<MetadataSourceNestedUpsertMetadataUpdateInput>;
};

export type MetadataSourceNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataSource" node, through the "MetadataSource.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataSource" node, through the "MetadataSource.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataSource" node, through the "MetadataSource.photo" relation. */
  update?: InputMaybe<MetadataSourceNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataSource" node, through the "MetadataSource.photo" relation. */
  upsert?: InputMaybe<MetadataSourceNestedUpsertPhotoCreateInput>;
};

export type MetadataSourceNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataSource" node, through the "MetadataSource.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataSource" node, through the "MetadataSource.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataSource" node, through the "MetadataSource.photo" relation. */
  update?: InputMaybe<MetadataSourceNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataSource" node, through the "MetadataSource.photo" relation. */
  upsert?: InputMaybe<MetadataSourceNestedUpsertPhotoUpdateInput>;
};

export type MetadataSourceNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSourceNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSourceNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSourceNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSourceNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSourceNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSourceNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSourceNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSourceNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSourceNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSourceNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSourceNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataSourceOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataSourceUpdateInput = {
  /** Actions for the "MetadataSource.archive" relation */
  archive?: InputMaybe<MetadataSourceNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSource.metadata" relation */
  metadata?: InputMaybe<MetadataSourceNestedMetadataUpdateInput>;
  /** Actions for the "MetadataSource.photo" relation */
  photo?: InputMaybe<MetadataSourceNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataSource" nodes by specifying some conditions */
export type MetadataSourceWhereInput = {
  AND?: InputMaybe<Array<MetadataSourceWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataSourceWhereInput>;
  OR?: InputMaybe<Array<MetadataSourceWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataSource" node. */
export type MetadataSourceWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataSourceWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataSource.metadata" relation */
  metadata: MetadataSourceNestedMetadataCreateInput;
  /** Actions for the "MetadataSource.photo" relation */
  photo: MetadataSourceNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSourceWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataSource.metadata" relation */
  metadata?: InputMaybe<MetadataSourceNestedMetadataUpdateInput>;
  /** Actions for the "MetadataSource.photo" relation */
  photo?: InputMaybe<MetadataSourceNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSourceWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataSource.archive" relation */
  archive: MetadataSourceNestedArchiveCreateInput;
  /** Actions for the "MetadataSource.photo" relation */
  photo: MetadataSourceNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSourceWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataSource.archive" relation */
  archive?: InputMaybe<MetadataSourceNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSource.photo" relation */
  photo?: InputMaybe<MetadataSourceNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSourceWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataSource.archive" relation */
  archive: MetadataSourceNestedArchiveCreateInput;
  /** Actions for the "MetadataSource.metadata" relation */
  metadata: MetadataSourceNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSourceWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataSource.archive" relation */
  archive?: InputMaybe<MetadataSourceNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSource.metadata" relation */
  metadata?: InputMaybe<MetadataSourceNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataSpecialInstructions" resource's node */
export type MetadataSpecialInstructions = {
  __typename?: 'MetadataSpecialInstructions';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataSpecialInstructionsCreateInput = {
  /** Actions for the "MetadataSpecialInstructions.archive" relation */
  archive: MetadataSpecialInstructionsNestedArchiveCreateInput;
  /** Actions for the "MetadataSpecialInstructions.metadata" relation */
  metadata: MetadataSpecialInstructionsNestedMetadataCreateInput;
  /** Actions for the "MetadataSpecialInstructions.photo" relation */
  photo: MetadataSpecialInstructionsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSpecialInstructionsNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.archive" relation. */
  update?: InputMaybe<MetadataSpecialInstructionsNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.archive" relation. */
  upsert?: InputMaybe<MetadataSpecialInstructionsNestedUpsertArchiveCreateInput>;
};

export type MetadataSpecialInstructionsNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.archive" relation. */
  update?: InputMaybe<MetadataSpecialInstructionsNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.archive" relation. */
  upsert?: InputMaybe<MetadataSpecialInstructionsNestedUpsertArchiveUpdateInput>;
};

export type MetadataSpecialInstructionsNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.metadata" relation. */
  update?: InputMaybe<MetadataSpecialInstructionsNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.metadata" relation. */
  upsert?: InputMaybe<MetadataSpecialInstructionsNestedUpsertMetadataCreateInput>;
};

export type MetadataSpecialInstructionsNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.metadata" relation. */
  update?: InputMaybe<MetadataSpecialInstructionsNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.metadata" relation. */
  upsert?: InputMaybe<MetadataSpecialInstructionsNestedUpsertMetadataUpdateInput>;
};

export type MetadataSpecialInstructionsNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.photo" relation. */
  update?: InputMaybe<MetadataSpecialInstructionsNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.photo" relation. */
  upsert?: InputMaybe<MetadataSpecialInstructionsNestedUpsertPhotoCreateInput>;
};

export type MetadataSpecialInstructionsNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.photo" relation. */
  update?: InputMaybe<MetadataSpecialInstructionsNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataSpecialInstructions" node, through the "MetadataSpecialInstructions.photo" relation. */
  upsert?: InputMaybe<MetadataSpecialInstructionsNestedUpsertPhotoUpdateInput>;
};

export type MetadataSpecialInstructionsNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSpecialInstructionsNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataSpecialInstructionsOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataSpecialInstructionsUpdateInput = {
  /** Actions for the "MetadataSpecialInstructions.archive" relation */
  archive?: InputMaybe<MetadataSpecialInstructionsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSpecialInstructions.metadata" relation */
  metadata?: InputMaybe<MetadataSpecialInstructionsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataSpecialInstructions.photo" relation */
  photo?: InputMaybe<MetadataSpecialInstructionsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataSpecialInstructions" nodes by specifying some conditions */
export type MetadataSpecialInstructionsWhereInput = {
  AND?: InputMaybe<Array<MetadataSpecialInstructionsWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
  OR?: InputMaybe<Array<MetadataSpecialInstructionsWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataSpecialInstructions" node. */
export type MetadataSpecialInstructionsWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataSpecialInstructionsWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataSpecialInstructions.metadata" relation */
  metadata: MetadataSpecialInstructionsNestedMetadataCreateInput;
  /** Actions for the "MetadataSpecialInstructions.photo" relation */
  photo: MetadataSpecialInstructionsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSpecialInstructionsWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataSpecialInstructions.metadata" relation */
  metadata?: InputMaybe<MetadataSpecialInstructionsNestedMetadataUpdateInput>;
  /** Actions for the "MetadataSpecialInstructions.photo" relation */
  photo?: InputMaybe<MetadataSpecialInstructionsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSpecialInstructionsWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataSpecialInstructions.archive" relation */
  archive: MetadataSpecialInstructionsNestedArchiveCreateInput;
  /** Actions for the "MetadataSpecialInstructions.photo" relation */
  photo: MetadataSpecialInstructionsNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSpecialInstructionsWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataSpecialInstructions.archive" relation */
  archive?: InputMaybe<MetadataSpecialInstructionsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSpecialInstructions.photo" relation */
  photo?: InputMaybe<MetadataSpecialInstructionsNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSpecialInstructionsWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataSpecialInstructions.archive" relation */
  archive: MetadataSpecialInstructionsNestedArchiveCreateInput;
  /** Actions for the "MetadataSpecialInstructions.metadata" relation */
  metadata: MetadataSpecialInstructionsNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSpecialInstructionsWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataSpecialInstructions.archive" relation */
  archive?: InputMaybe<MetadataSpecialInstructionsNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSpecialInstructions.metadata" relation */
  metadata?: InputMaybe<MetadataSpecialInstructionsNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataSubject" resource's node */
export type MetadataSubject = {
  __typename?: 'MetadataSubject';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** "MetadataSubjectCode" resource's node */
export type MetadataSubjectCode = {
  __typename?: 'MetadataSubjectCode';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataSubjectCodeCreateInput = {
  /** Actions for the "MetadataSubjectCode.archive" relation */
  archive: MetadataSubjectCodeNestedArchiveCreateInput;
  /** Actions for the "MetadataSubjectCode.metadata" relation */
  metadata: MetadataSubjectCodeNestedMetadataCreateInput;
  /** Actions for the "MetadataSubjectCode.photo" relation */
  photo: MetadataSubjectCodeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectCodeNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.archive" relation. */
  update?: InputMaybe<MetadataSubjectCodeNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.archive" relation. */
  upsert?: InputMaybe<MetadataSubjectCodeNestedUpsertArchiveCreateInput>;
};

export type MetadataSubjectCodeNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.archive" relation. */
  update?: InputMaybe<MetadataSubjectCodeNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.archive" relation. */
  upsert?: InputMaybe<MetadataSubjectCodeNestedUpsertArchiveUpdateInput>;
};

export type MetadataSubjectCodeNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.metadata" relation. */
  update?: InputMaybe<MetadataSubjectCodeNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.metadata" relation. */
  upsert?: InputMaybe<MetadataSubjectCodeNestedUpsertMetadataCreateInput>;
};

export type MetadataSubjectCodeNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.metadata" relation. */
  update?: InputMaybe<MetadataSubjectCodeNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.metadata" relation. */
  upsert?: InputMaybe<MetadataSubjectCodeNestedUpsertMetadataUpdateInput>;
};

export type MetadataSubjectCodeNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.photo" relation. */
  update?: InputMaybe<MetadataSubjectCodeNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataSubjectCode" node, through the "MetadataSubjectCode.photo" relation. */
  upsert?: InputMaybe<MetadataSubjectCodeNestedUpsertPhotoCreateInput>;
};

export type MetadataSubjectCodeNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.photo" relation. */
  update?: InputMaybe<MetadataSubjectCodeNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataSubjectCode" node, through the "MetadataSubjectCode.photo" relation. */
  upsert?: InputMaybe<MetadataSubjectCodeNestedUpsertPhotoUpdateInput>;
};

export type MetadataSubjectCodeNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSubjectCodeNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataSubjectCodeOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataSubjectCodeUpdateInput = {
  /** Actions for the "MetadataSubjectCode.archive" relation */
  archive?: InputMaybe<MetadataSubjectCodeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSubjectCode.metadata" relation */
  metadata?: InputMaybe<MetadataSubjectCodeNestedMetadataUpdateInput>;
  /** Actions for the "MetadataSubjectCode.photo" relation */
  photo?: InputMaybe<MetadataSubjectCodeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataSubjectCode" nodes by specifying some conditions */
export type MetadataSubjectCodeWhereInput = {
  AND?: InputMaybe<Array<MetadataSubjectCodeWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataSubjectCodeWhereInput>;
  OR?: InputMaybe<Array<MetadataSubjectCodeWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataSubjectCode" node. */
export type MetadataSubjectCodeWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataSubjectCodeWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataSubjectCode.metadata" relation */
  metadata: MetadataSubjectCodeNestedMetadataCreateInput;
  /** Actions for the "MetadataSubjectCode.photo" relation */
  photo: MetadataSubjectCodeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectCodeWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataSubjectCode.metadata" relation */
  metadata?: InputMaybe<MetadataSubjectCodeNestedMetadataUpdateInput>;
  /** Actions for the "MetadataSubjectCode.photo" relation */
  photo?: InputMaybe<MetadataSubjectCodeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectCodeWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataSubjectCode.archive" relation */
  archive: MetadataSubjectCodeNestedArchiveCreateInput;
  /** Actions for the "MetadataSubjectCode.photo" relation */
  photo: MetadataSubjectCodeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectCodeWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataSubjectCode.archive" relation */
  archive?: InputMaybe<MetadataSubjectCodeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSubjectCode.photo" relation */
  photo?: InputMaybe<MetadataSubjectCodeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectCodeWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataSubjectCode.archive" relation */
  archive: MetadataSubjectCodeNestedArchiveCreateInput;
  /** Actions for the "MetadataSubjectCode.metadata" relation */
  metadata: MetadataSubjectCodeNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectCodeWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataSubjectCode.archive" relation */
  archive?: InputMaybe<MetadataSubjectCodeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSubjectCode.metadata" relation */
  metadata?: InputMaybe<MetadataSubjectCodeNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectCreateInput = {
  /** Actions for the "MetadataSubject.archive" relation */
  archive: MetadataSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataSubject.metadata" relation */
  metadata: MetadataSubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataSubject.photo" relation */
  photo: MetadataSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataSubject" node, through the "MetadataSubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataSubject" node, through the "MetadataSubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataSubject" node, through the "MetadataSubject.archive" relation. */
  update?: InputMaybe<MetadataSubjectNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataSubject" node, through the "MetadataSubject.archive" relation. */
  upsert?: InputMaybe<MetadataSubjectNestedUpsertArchiveCreateInput>;
};

export type MetadataSubjectNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataSubject" node, through the "MetadataSubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataSubject" node, through the "MetadataSubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataSubject" node, through the "MetadataSubject.archive" relation. */
  update?: InputMaybe<MetadataSubjectNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataSubject" node, through the "MetadataSubject.archive" relation. */
  upsert?: InputMaybe<MetadataSubjectNestedUpsertArchiveUpdateInput>;
};

export type MetadataSubjectNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataSubject" node, through the "MetadataSubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataSubject" node, through the "MetadataSubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataSubject" node, through the "MetadataSubject.metadata" relation. */
  update?: InputMaybe<MetadataSubjectNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataSubject" node, through the "MetadataSubject.metadata" relation. */
  upsert?: InputMaybe<MetadataSubjectNestedUpsertMetadataCreateInput>;
};

export type MetadataSubjectNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataSubject" node, through the "MetadataSubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataSubject" node, through the "MetadataSubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataSubject" node, through the "MetadataSubject.metadata" relation. */
  update?: InputMaybe<MetadataSubjectNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataSubject" node, through the "MetadataSubject.metadata" relation. */
  upsert?: InputMaybe<MetadataSubjectNestedUpsertMetadataUpdateInput>;
};

export type MetadataSubjectNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataSubject" node, through the "MetadataSubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataSubject" node, through the "MetadataSubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataSubject" node, through the "MetadataSubject.photo" relation. */
  update?: InputMaybe<MetadataSubjectNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataSubject" node, through the "MetadataSubject.photo" relation. */
  upsert?: InputMaybe<MetadataSubjectNestedUpsertPhotoCreateInput>;
};

export type MetadataSubjectNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataSubject" node, through the "MetadataSubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataSubject" node, through the "MetadataSubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataSubject" node, through the "MetadataSubject.photo" relation. */
  update?: InputMaybe<MetadataSubjectNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataSubject" node, through the "MetadataSubject.photo" relation. */
  upsert?: InputMaybe<MetadataSubjectNestedUpsertPhotoUpdateInput>;
};

export type MetadataSubjectNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSubjectNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSubjectNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSubjectNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataSubjectOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

/** "MetadataSubjectPrisma" resource's node */
export type MetadataSubjectPrisma = {
  __typename?: 'MetadataSubjectPrisma';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataSubjectPrismaCreateInput = {
  /** Actions for the "MetadataSubjectPrisma.archive" relation */
  archive: MetadataSubjectPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataSubjectPrisma.metadata" relation */
  metadata: MetadataSubjectPrismaNestedMetadataCreateInput;
  /** Actions for the "MetadataSubjectPrisma.photo" relation */
  photo: MetadataSubjectPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectPrismaNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.archive" relation. */
  update?: InputMaybe<MetadataSubjectPrismaNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.archive" relation. */
  upsert?: InputMaybe<MetadataSubjectPrismaNestedUpsertArchiveCreateInput>;
};

export type MetadataSubjectPrismaNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.archive" relation. */
  update?: InputMaybe<MetadataSubjectPrismaNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.archive" relation. */
  upsert?: InputMaybe<MetadataSubjectPrismaNestedUpsertArchiveUpdateInput>;
};

export type MetadataSubjectPrismaNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.metadata" relation. */
  update?: InputMaybe<MetadataSubjectPrismaNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.metadata" relation. */
  upsert?: InputMaybe<MetadataSubjectPrismaNestedUpsertMetadataCreateInput>;
};

export type MetadataSubjectPrismaNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.metadata" relation. */
  update?: InputMaybe<MetadataSubjectPrismaNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.metadata" relation. */
  upsert?: InputMaybe<MetadataSubjectPrismaNestedUpsertMetadataUpdateInput>;
};

export type MetadataSubjectPrismaNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.photo" relation. */
  update?: InputMaybe<MetadataSubjectPrismaNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.photo" relation. */
  upsert?: InputMaybe<MetadataSubjectPrismaNestedUpsertPhotoCreateInput>;
};

export type MetadataSubjectPrismaNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.photo" relation. */
  update?: InputMaybe<MetadataSubjectPrismaNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataSubjectPrisma" node, through the "MetadataSubjectPrisma.photo" relation. */
  upsert?: InputMaybe<MetadataSubjectPrismaNestedUpsertPhotoUpdateInput>;
};

export type MetadataSubjectPrismaNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataSubjectPrismaNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataSubjectPrismaOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataSubjectPrismaUpdateInput = {
  /** Actions for the "MetadataSubjectPrisma.archive" relation */
  archive?: InputMaybe<MetadataSubjectPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSubjectPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataSubjectPrismaNestedMetadataUpdateInput>;
  /** Actions for the "MetadataSubjectPrisma.photo" relation */
  photo?: InputMaybe<MetadataSubjectPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataSubjectPrisma" nodes by specifying some conditions */
export type MetadataSubjectPrismaWhereInput = {
  AND?: InputMaybe<Array<MetadataSubjectPrismaWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataSubjectPrismaWhereInput>;
  OR?: InputMaybe<Array<MetadataSubjectPrismaWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataSubjectPrisma" node. */
export type MetadataSubjectPrismaWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataSubjectPrismaWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataSubjectPrisma.metadata" relation */
  metadata: MetadataSubjectPrismaNestedMetadataCreateInput;
  /** Actions for the "MetadataSubjectPrisma.photo" relation */
  photo: MetadataSubjectPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectPrismaWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataSubjectPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataSubjectPrismaNestedMetadataUpdateInput>;
  /** Actions for the "MetadataSubjectPrisma.photo" relation */
  photo?: InputMaybe<MetadataSubjectPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectPrismaWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataSubjectPrisma.archive" relation */
  archive: MetadataSubjectPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataSubjectPrisma.photo" relation */
  photo: MetadataSubjectPrismaNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectPrismaWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataSubjectPrisma.archive" relation */
  archive?: InputMaybe<MetadataSubjectPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSubjectPrisma.photo" relation */
  photo?: InputMaybe<MetadataSubjectPrismaNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectPrismaWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataSubjectPrisma.archive" relation */
  archive: MetadataSubjectPrismaNestedArchiveCreateInput;
  /** Actions for the "MetadataSubjectPrisma.metadata" relation */
  metadata: MetadataSubjectPrismaNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectPrismaWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataSubjectPrisma.archive" relation */
  archive?: InputMaybe<MetadataSubjectPrismaNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSubjectPrisma.metadata" relation */
  metadata?: InputMaybe<MetadataSubjectPrismaNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectUpdateInput = {
  /** Actions for the "MetadataSubject.archive" relation */
  archive?: InputMaybe<MetadataSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSubject.metadata" relation */
  metadata?: InputMaybe<MetadataSubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataSubject.photo" relation */
  photo?: InputMaybe<MetadataSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataSubject" nodes by specifying some conditions */
export type MetadataSubjectWhereInput = {
  AND?: InputMaybe<Array<MetadataSubjectWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataSubjectWhereInput>;
  OR?: InputMaybe<Array<MetadataSubjectWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataSubject" node. */
export type MetadataSubjectWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataSubjectWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataSubject.metadata" relation */
  metadata: MetadataSubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataSubject.photo" relation */
  photo: MetadataSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataSubject.metadata" relation */
  metadata?: InputMaybe<MetadataSubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataSubject.photo" relation */
  photo?: InputMaybe<MetadataSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataSubject.archive" relation */
  archive: MetadataSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataSubject.photo" relation */
  photo: MetadataSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataSubject.archive" relation */
  archive?: InputMaybe<MetadataSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSubject.photo" relation */
  photo?: InputMaybe<MetadataSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataSubject.archive" relation */
  archive: MetadataSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataSubject.metadata" relation */
  metadata: MetadataSubjectNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataSubjectWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataSubject.archive" relation */
  archive?: InputMaybe<MetadataSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataSubject.metadata" relation */
  metadata?: InputMaybe<MetadataSubjectNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataTitle" resource's node */
export type MetadataTitle = {
  __typename?: 'MetadataTitle';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataTitleCreateInput = {
  /** Actions for the "MetadataTitle.archive" relation */
  archive: MetadataTitleNestedArchiveCreateInput;
  /** Actions for the "MetadataTitle.metadata" relation */
  metadata: MetadataTitleNestedMetadataCreateInput;
  /** Actions for the "MetadataTitle.photo" relation */
  photo: MetadataTitleNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTitleNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataTitle" node, through the "MetadataTitle.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataTitle" node, through the "MetadataTitle.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataTitle" node, through the "MetadataTitle.archive" relation. */
  update?: InputMaybe<MetadataTitleNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataTitle" node, through the "MetadataTitle.archive" relation. */
  upsert?: InputMaybe<MetadataTitleNestedUpsertArchiveCreateInput>;
};

export type MetadataTitleNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataTitle" node, through the "MetadataTitle.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataTitle" node, through the "MetadataTitle.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataTitle" node, through the "MetadataTitle.archive" relation. */
  update?: InputMaybe<MetadataTitleNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataTitle" node, through the "MetadataTitle.archive" relation. */
  upsert?: InputMaybe<MetadataTitleNestedUpsertArchiveUpdateInput>;
};

export type MetadataTitleNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataTitle" node, through the "MetadataTitle.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataTitle" node, through the "MetadataTitle.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataTitle" node, through the "MetadataTitle.metadata" relation. */
  update?: InputMaybe<MetadataTitleNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataTitle" node, through the "MetadataTitle.metadata" relation. */
  upsert?: InputMaybe<MetadataTitleNestedUpsertMetadataCreateInput>;
};

export type MetadataTitleNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataTitle" node, through the "MetadataTitle.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataTitle" node, through the "MetadataTitle.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataTitle" node, through the "MetadataTitle.metadata" relation. */
  update?: InputMaybe<MetadataTitleNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataTitle" node, through the "MetadataTitle.metadata" relation. */
  upsert?: InputMaybe<MetadataTitleNestedUpsertMetadataUpdateInput>;
};

export type MetadataTitleNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataTitle" node, through the "MetadataTitle.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataTitle" node, through the "MetadataTitle.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataTitle" node, through the "MetadataTitle.photo" relation. */
  update?: InputMaybe<MetadataTitleNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataTitle" node, through the "MetadataTitle.photo" relation. */
  upsert?: InputMaybe<MetadataTitleNestedUpsertPhotoCreateInput>;
};

export type MetadataTitleNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataTitle" node, through the "MetadataTitle.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataTitle" node, through the "MetadataTitle.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataTitle" node, through the "MetadataTitle.photo" relation. */
  update?: InputMaybe<MetadataTitleNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataTitle" node, through the "MetadataTitle.photo" relation. */
  upsert?: InputMaybe<MetadataTitleNestedUpsertPhotoUpdateInput>;
};

export type MetadataTitleNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTitleNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTitleNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTitleNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTitleNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTitleNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTitleNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTitleNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTitleNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTitleNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTitleNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTitleNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataTitleOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataTitleUpdateInput = {
  /** Actions for the "MetadataTitle.archive" relation */
  archive?: InputMaybe<MetadataTitleNestedArchiveUpdateInput>;
  /** Actions for the "MetadataTitle.metadata" relation */
  metadata?: InputMaybe<MetadataTitleNestedMetadataUpdateInput>;
  /** Actions for the "MetadataTitle.photo" relation */
  photo?: InputMaybe<MetadataTitleNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataTitle" nodes by specifying some conditions */
export type MetadataTitleWhereInput = {
  AND?: InputMaybe<Array<MetadataTitleWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataTitleWhereInput>;
  OR?: InputMaybe<Array<MetadataTitleWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataTitle" node. */
export type MetadataTitleWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataTitleWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataTitle.metadata" relation */
  metadata: MetadataTitleNestedMetadataCreateInput;
  /** Actions for the "MetadataTitle.photo" relation */
  photo: MetadataTitleNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTitleWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataTitle.metadata" relation */
  metadata?: InputMaybe<MetadataTitleNestedMetadataUpdateInput>;
  /** Actions for the "MetadataTitle.photo" relation */
  photo?: InputMaybe<MetadataTitleNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTitleWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataTitle.archive" relation */
  archive: MetadataTitleNestedArchiveCreateInput;
  /** Actions for the "MetadataTitle.photo" relation */
  photo: MetadataTitleNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTitleWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataTitle.archive" relation */
  archive?: InputMaybe<MetadataTitleNestedArchiveUpdateInput>;
  /** Actions for the "MetadataTitle.photo" relation */
  photo?: InputMaybe<MetadataTitleNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTitleWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataTitle.archive" relation */
  archive: MetadataTitleNestedArchiveCreateInput;
  /** Actions for the "MetadataTitle.metadata" relation */
  metadata: MetadataTitleNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTitleWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataTitle.archive" relation */
  archive?: InputMaybe<MetadataTitleNestedArchiveUpdateInput>;
  /** Actions for the "MetadataTitle.metadata" relation */
  metadata?: InputMaybe<MetadataTitleNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataTransferredBy" resource's node */
export type MetadataTransferredBy = {
  __typename?: 'MetadataTransferredBy';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataTransferredByCreateInput = {
  /** Actions for the "MetadataTransferredBy.archive" relation */
  archive: MetadataTransferredByNestedArchiveCreateInput;
  /** Actions for the "MetadataTransferredBy.metadata" relation */
  metadata: MetadataTransferredByNestedMetadataCreateInput;
  /** Actions for the "MetadataTransferredBy.photo" relation */
  photo: MetadataTransferredByNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataTransferredByFullName" resource's node */
export type MetadataTransferredByFullName = {
  __typename?: 'MetadataTransferredByFullName';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataTransferredByFullNameCreateInput = {
  /** Actions for the "MetadataTransferredByFullName.archive" relation */
  archive: MetadataTransferredByFullNameNestedArchiveCreateInput;
  /** Actions for the "MetadataTransferredByFullName.metadata" relation */
  metadata: MetadataTransferredByFullNameNestedMetadataCreateInput;
  /** Actions for the "MetadataTransferredByFullName.photo" relation */
  photo: MetadataTransferredByFullNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByFullNameNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.archive" relation. */
  update?: InputMaybe<MetadataTransferredByFullNameNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.archive" relation. */
  upsert?: InputMaybe<MetadataTransferredByFullNameNestedUpsertArchiveCreateInput>;
};

export type MetadataTransferredByFullNameNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.archive" relation. */
  update?: InputMaybe<MetadataTransferredByFullNameNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.archive" relation. */
  upsert?: InputMaybe<MetadataTransferredByFullNameNestedUpsertArchiveUpdateInput>;
};

export type MetadataTransferredByFullNameNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.metadata" relation. */
  update?: InputMaybe<MetadataTransferredByFullNameNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.metadata" relation. */
  upsert?: InputMaybe<MetadataTransferredByFullNameNestedUpsertMetadataCreateInput>;
};

export type MetadataTransferredByFullNameNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.metadata" relation. */
  update?: InputMaybe<MetadataTransferredByFullNameNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.metadata" relation. */
  upsert?: InputMaybe<MetadataTransferredByFullNameNestedUpsertMetadataUpdateInput>;
};

export type MetadataTransferredByFullNameNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.photo" relation. */
  update?: InputMaybe<MetadataTransferredByFullNameNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.photo" relation. */
  upsert?: InputMaybe<MetadataTransferredByFullNameNestedUpsertPhotoCreateInput>;
};

export type MetadataTransferredByFullNameNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.photo" relation. */
  update?: InputMaybe<MetadataTransferredByFullNameNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataTransferredByFullName" node, through the "MetadataTransferredByFullName.photo" relation. */
  upsert?: InputMaybe<MetadataTransferredByFullNameNestedUpsertPhotoUpdateInput>;
};

export type MetadataTransferredByFullNameNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTransferredByFullNameNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataTransferredByFullNameOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataTransferredByFullNameUpdateInput = {
  /** Actions for the "MetadataTransferredByFullName.archive" relation */
  archive?: InputMaybe<MetadataTransferredByFullNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataTransferredByFullName.metadata" relation */
  metadata?: InputMaybe<MetadataTransferredByFullNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataTransferredByFullName.photo" relation */
  photo?: InputMaybe<MetadataTransferredByFullNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataTransferredByFullName" nodes by specifying some conditions */
export type MetadataTransferredByFullNameWhereInput = {
  AND?: InputMaybe<Array<MetadataTransferredByFullNameWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
  OR?: InputMaybe<Array<MetadataTransferredByFullNameWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataTransferredByFullName" node. */
export type MetadataTransferredByFullNameWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataTransferredByFullNameWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataTransferredByFullName.metadata" relation */
  metadata: MetadataTransferredByFullNameNestedMetadataCreateInput;
  /** Actions for the "MetadataTransferredByFullName.photo" relation */
  photo: MetadataTransferredByFullNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByFullNameWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataTransferredByFullName.metadata" relation */
  metadata?: InputMaybe<MetadataTransferredByFullNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataTransferredByFullName.photo" relation */
  photo?: InputMaybe<MetadataTransferredByFullNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByFullNameWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataTransferredByFullName.archive" relation */
  archive: MetadataTransferredByFullNameNestedArchiveCreateInput;
  /** Actions for the "MetadataTransferredByFullName.photo" relation */
  photo: MetadataTransferredByFullNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByFullNameWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataTransferredByFullName.archive" relation */
  archive?: InputMaybe<MetadataTransferredByFullNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataTransferredByFullName.photo" relation */
  photo?: InputMaybe<MetadataTransferredByFullNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByFullNameWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataTransferredByFullName.archive" relation */
  archive: MetadataTransferredByFullNameNestedArchiveCreateInput;
  /** Actions for the "MetadataTransferredByFullName.metadata" relation */
  metadata: MetadataTransferredByFullNameNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByFullNameWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataTransferredByFullName.archive" relation */
  archive?: InputMaybe<MetadataTransferredByFullNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataTransferredByFullName.metadata" relation */
  metadata?: InputMaybe<MetadataTransferredByFullNameNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.archive" relation. */
  update?: InputMaybe<MetadataTransferredByNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.archive" relation. */
  upsert?: InputMaybe<MetadataTransferredByNestedUpsertArchiveCreateInput>;
};

export type MetadataTransferredByNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.archive" relation. */
  update?: InputMaybe<MetadataTransferredByNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.archive" relation. */
  upsert?: InputMaybe<MetadataTransferredByNestedUpsertArchiveUpdateInput>;
};

export type MetadataTransferredByNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.metadata" relation. */
  update?: InputMaybe<MetadataTransferredByNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.metadata" relation. */
  upsert?: InputMaybe<MetadataTransferredByNestedUpsertMetadataCreateInput>;
};

export type MetadataTransferredByNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.metadata" relation. */
  update?: InputMaybe<MetadataTransferredByNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.metadata" relation. */
  upsert?: InputMaybe<MetadataTransferredByNestedUpsertMetadataUpdateInput>;
};

export type MetadataTransferredByNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.photo" relation. */
  update?: InputMaybe<MetadataTransferredByNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataTransferredBy" node, through the "MetadataTransferredBy.photo" relation. */
  upsert?: InputMaybe<MetadataTransferredByNestedUpsertPhotoCreateInput>;
};

export type MetadataTransferredByNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.photo" relation. */
  update?: InputMaybe<MetadataTransferredByNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataTransferredBy" node, through the "MetadataTransferredBy.photo" relation. */
  upsert?: InputMaybe<MetadataTransferredByNestedUpsertPhotoUpdateInput>;
};

export type MetadataTransferredByNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTransferredByNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTransferredByNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTransferredByNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTransferredByNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTransferredByNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTransferredByNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTransferredByNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTransferredByNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTransferredByNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTransferredByNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTransferredByNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataTransferredByOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataTransferredByUpdateInput = {
  /** Actions for the "MetadataTransferredBy.archive" relation */
  archive?: InputMaybe<MetadataTransferredByNestedArchiveUpdateInput>;
  /** Actions for the "MetadataTransferredBy.metadata" relation */
  metadata?: InputMaybe<MetadataTransferredByNestedMetadataUpdateInput>;
  /** Actions for the "MetadataTransferredBy.photo" relation */
  photo?: InputMaybe<MetadataTransferredByNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataTransferredBy" nodes by specifying some conditions */
export type MetadataTransferredByWhereInput = {
  AND?: InputMaybe<Array<MetadataTransferredByWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataTransferredByWhereInput>;
  OR?: InputMaybe<Array<MetadataTransferredByWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataTransferredBy" node. */
export type MetadataTransferredByWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataTransferredByWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataTransferredBy.metadata" relation */
  metadata: MetadataTransferredByNestedMetadataCreateInput;
  /** Actions for the "MetadataTransferredBy.photo" relation */
  photo: MetadataTransferredByNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataTransferredBy.metadata" relation */
  metadata?: InputMaybe<MetadataTransferredByNestedMetadataUpdateInput>;
  /** Actions for the "MetadataTransferredBy.photo" relation */
  photo?: InputMaybe<MetadataTransferredByNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataTransferredBy.archive" relation */
  archive: MetadataTransferredByNestedArchiveCreateInput;
  /** Actions for the "MetadataTransferredBy.photo" relation */
  photo: MetadataTransferredByNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataTransferredBy.archive" relation */
  archive?: InputMaybe<MetadataTransferredByNestedArchiveUpdateInput>;
  /** Actions for the "MetadataTransferredBy.photo" relation */
  photo?: InputMaybe<MetadataTransferredByNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataTransferredBy.archive" relation */
  archive: MetadataTransferredByNestedArchiveCreateInput;
  /** Actions for the "MetadataTransferredBy.metadata" relation */
  metadata: MetadataTransferredByNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTransferredByWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataTransferredBy.archive" relation */
  archive?: InputMaybe<MetadataTransferredByNestedArchiveUpdateInput>;
  /** Actions for the "MetadataTransferredBy.metadata" relation */
  metadata?: InputMaybe<MetadataTransferredByNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataType" resource's node */
export type MetadataType = {
  __typename?: 'MetadataType';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataTypeCreateInput = {
  /** Actions for the "MetadataType.archive" relation */
  archive: MetadataTypeNestedArchiveCreateInput;
  /** Actions for the "MetadataType.metadata" relation */
  metadata: MetadataTypeNestedMetadataCreateInput;
  /** Actions for the "MetadataType.photo" relation */
  photo: MetadataTypeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTypeNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataType" node, through the "MetadataType.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataType" node, through the "MetadataType.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataType" node, through the "MetadataType.archive" relation. */
  update?: InputMaybe<MetadataTypeNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataType" node, through the "MetadataType.archive" relation. */
  upsert?: InputMaybe<MetadataTypeNestedUpsertArchiveCreateInput>;
};

export type MetadataTypeNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataType" node, through the "MetadataType.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataType" node, through the "MetadataType.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataType" node, through the "MetadataType.archive" relation. */
  update?: InputMaybe<MetadataTypeNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataType" node, through the "MetadataType.archive" relation. */
  upsert?: InputMaybe<MetadataTypeNestedUpsertArchiveUpdateInput>;
};

export type MetadataTypeNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataType" node, through the "MetadataType.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataType" node, through the "MetadataType.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataType" node, through the "MetadataType.metadata" relation. */
  update?: InputMaybe<MetadataTypeNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataType" node, through the "MetadataType.metadata" relation. */
  upsert?: InputMaybe<MetadataTypeNestedUpsertMetadataCreateInput>;
};

export type MetadataTypeNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataType" node, through the "MetadataType.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataType" node, through the "MetadataType.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataType" node, through the "MetadataType.metadata" relation. */
  update?: InputMaybe<MetadataTypeNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataType" node, through the "MetadataType.metadata" relation. */
  upsert?: InputMaybe<MetadataTypeNestedUpsertMetadataUpdateInput>;
};

export type MetadataTypeNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataType" node, through the "MetadataType.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataType" node, through the "MetadataType.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataType" node, through the "MetadataType.photo" relation. */
  update?: InputMaybe<MetadataTypeNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataType" node, through the "MetadataType.photo" relation. */
  upsert?: InputMaybe<MetadataTypeNestedUpsertPhotoCreateInput>;
};

export type MetadataTypeNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataType" node, through the "MetadataType.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataType" node, through the "MetadataType.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataType" node, through the "MetadataType.photo" relation. */
  update?: InputMaybe<MetadataTypeNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataType" node, through the "MetadataType.photo" relation. */
  upsert?: InputMaybe<MetadataTypeNestedUpsertPhotoUpdateInput>;
};

export type MetadataTypeNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTypeNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTypeNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTypeNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTypeNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTypeNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTypeNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTypeNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataTypeNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTypeNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataTypeNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataTypeNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataTypeOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataTypeUpdateInput = {
  /** Actions for the "MetadataType.archive" relation */
  archive?: InputMaybe<MetadataTypeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataType.metadata" relation */
  metadata?: InputMaybe<MetadataTypeNestedMetadataUpdateInput>;
  /** Actions for the "MetadataType.photo" relation */
  photo?: InputMaybe<MetadataTypeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataType" nodes by specifying some conditions */
export type MetadataTypeWhereInput = {
  AND?: InputMaybe<Array<MetadataTypeWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataTypeWhereInput>;
  OR?: InputMaybe<Array<MetadataTypeWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataType" node. */
export type MetadataTypeWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataTypeWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataType.metadata" relation */
  metadata: MetadataTypeNestedMetadataCreateInput;
  /** Actions for the "MetadataType.photo" relation */
  photo: MetadataTypeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTypeWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataType.metadata" relation */
  metadata?: InputMaybe<MetadataTypeNestedMetadataUpdateInput>;
  /** Actions for the "MetadataType.photo" relation */
  photo?: InputMaybe<MetadataTypeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTypeWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataType.archive" relation */
  archive: MetadataTypeNestedArchiveCreateInput;
  /** Actions for the "MetadataType.photo" relation */
  photo: MetadataTypeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTypeWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataType.archive" relation */
  archive?: InputMaybe<MetadataTypeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataType.photo" relation */
  photo?: InputMaybe<MetadataTypeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTypeWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataType.archive" relation */
  archive: MetadataTypeNestedArchiveCreateInput;
  /** Actions for the "MetadataType.metadata" relation */
  metadata: MetadataTypeNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataTypeWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataType.archive" relation */
  archive?: InputMaybe<MetadataTypeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataType.metadata" relation */
  metadata?: InputMaybe<MetadataTypeNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUndersubject" resource's node */
export type MetadataUndersubject = {
  __typename?: 'MetadataUndersubject';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUndersubjectCreateInput = {
  /** Actions for the "MetadataUndersubject.archive" relation */
  archive: MetadataUndersubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataUndersubject.metadata" relation */
  metadata: MetadataUndersubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataUndersubject.photo" relation */
  photo: MetadataUndersubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUndersubjectNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUndersubject" node, through the "MetadataUndersubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUndersubject" node, through the "MetadataUndersubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUndersubject" node, through the "MetadataUndersubject.archive" relation. */
  update?: InputMaybe<MetadataUndersubjectNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUndersubject" node, through the "MetadataUndersubject.archive" relation. */
  upsert?: InputMaybe<MetadataUndersubjectNestedUpsertArchiveCreateInput>;
};

export type MetadataUndersubjectNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.archive" relation. */
  update?: InputMaybe<MetadataUndersubjectNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.archive" relation. */
  upsert?: InputMaybe<MetadataUndersubjectNestedUpsertArchiveUpdateInput>;
};

export type MetadataUndersubjectNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUndersubject" node, through the "MetadataUndersubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUndersubject" node, through the "MetadataUndersubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUndersubject" node, through the "MetadataUndersubject.metadata" relation. */
  update?: InputMaybe<MetadataUndersubjectNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUndersubject" node, through the "MetadataUndersubject.metadata" relation. */
  upsert?: InputMaybe<MetadataUndersubjectNestedUpsertMetadataCreateInput>;
};

export type MetadataUndersubjectNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.metadata" relation. */
  update?: InputMaybe<MetadataUndersubjectNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.metadata" relation. */
  upsert?: InputMaybe<MetadataUndersubjectNestedUpsertMetadataUpdateInput>;
};

export type MetadataUndersubjectNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUndersubject" node, through the "MetadataUndersubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUndersubject" node, through the "MetadataUndersubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUndersubject" node, through the "MetadataUndersubject.photo" relation. */
  update?: InputMaybe<MetadataUndersubjectNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUndersubject" node, through the "MetadataUndersubject.photo" relation. */
  upsert?: InputMaybe<MetadataUndersubjectNestedUpsertPhotoCreateInput>;
};

export type MetadataUndersubjectNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.photo" relation. */
  update?: InputMaybe<MetadataUndersubjectNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUndersubject" node, through the "MetadataUndersubject.photo" relation. */
  upsert?: InputMaybe<MetadataUndersubjectNestedUpsertPhotoUpdateInput>;
};

export type MetadataUndersubjectNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUndersubjectNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUndersubjectOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUndersubjectUpdateInput = {
  /** Actions for the "MetadataUndersubject.archive" relation */
  archive?: InputMaybe<MetadataUndersubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUndersubject.metadata" relation */
  metadata?: InputMaybe<MetadataUndersubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUndersubject.photo" relation */
  photo?: InputMaybe<MetadataUndersubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUndersubject" nodes by specifying some conditions */
export type MetadataUndersubjectWhereInput = {
  AND?: InputMaybe<Array<MetadataUndersubjectWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUndersubjectWhereInput>;
  OR?: InputMaybe<Array<MetadataUndersubjectWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUndersubject" node. */
export type MetadataUndersubjectWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUndersubjectWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUndersubject.metadata" relation */
  metadata: MetadataUndersubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataUndersubject.photo" relation */
  photo: MetadataUndersubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUndersubjectWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUndersubject.metadata" relation */
  metadata?: InputMaybe<MetadataUndersubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUndersubject.photo" relation */
  photo?: InputMaybe<MetadataUndersubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUndersubjectWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUndersubject.archive" relation */
  archive: MetadataUndersubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataUndersubject.photo" relation */
  photo: MetadataUndersubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUndersubjectWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUndersubject.archive" relation */
  archive?: InputMaybe<MetadataUndersubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUndersubject.photo" relation */
  photo?: InputMaybe<MetadataUndersubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUndersubjectWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUndersubject.archive" relation */
  archive: MetadataUndersubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataUndersubject.metadata" relation */
  metadata: MetadataUndersubjectNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUndersubjectWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUndersubject.archive" relation */
  archive?: InputMaybe<MetadataUndersubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUndersubject.metadata" relation */
  metadata?: InputMaybe<MetadataUndersubjectNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUnderUnderSubject" resource's node */
export type MetadataUnderUnderSubject = {
  __typename?: 'MetadataUnderUnderSubject';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUnderUnderSubjectCreateInput = {
  /** Actions for the "MetadataUnderUnderSubject.archive" relation */
  archive: MetadataUnderUnderSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataUnderUnderSubject.metadata" relation */
  metadata: MetadataUnderUnderSubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataUnderUnderSubject.photo" relation */
  photo: MetadataUnderUnderSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUnderUnderSubjectNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.archive" relation. */
  update?: InputMaybe<MetadataUnderUnderSubjectNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.archive" relation. */
  upsert?: InputMaybe<MetadataUnderUnderSubjectNestedUpsertArchiveCreateInput>;
};

export type MetadataUnderUnderSubjectNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.archive" relation. */
  update?: InputMaybe<MetadataUnderUnderSubjectNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.archive" relation. */
  upsert?: InputMaybe<MetadataUnderUnderSubjectNestedUpsertArchiveUpdateInput>;
};

export type MetadataUnderUnderSubjectNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.metadata" relation. */
  update?: InputMaybe<MetadataUnderUnderSubjectNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.metadata" relation. */
  upsert?: InputMaybe<MetadataUnderUnderSubjectNestedUpsertMetadataCreateInput>;
};

export type MetadataUnderUnderSubjectNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.metadata" relation. */
  update?: InputMaybe<MetadataUnderUnderSubjectNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.metadata" relation. */
  upsert?: InputMaybe<MetadataUnderUnderSubjectNestedUpsertMetadataUpdateInput>;
};

export type MetadataUnderUnderSubjectNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.photo" relation. */
  update?: InputMaybe<MetadataUnderUnderSubjectNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.photo" relation. */
  upsert?: InputMaybe<MetadataUnderUnderSubjectNestedUpsertPhotoCreateInput>;
};

export type MetadataUnderUnderSubjectNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.photo" relation. */
  update?: InputMaybe<MetadataUnderUnderSubjectNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUnderUnderSubject" node, through the "MetadataUnderUnderSubject.photo" relation. */
  upsert?: InputMaybe<MetadataUnderUnderSubjectNestedUpsertPhotoUpdateInput>;
};

export type MetadataUnderUnderSubjectNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUnderUnderSubjectNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUnderUnderSubjectOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUnderUnderSubjectUpdateInput = {
  /** Actions for the "MetadataUnderUnderSubject.archive" relation */
  archive?: InputMaybe<MetadataUnderUnderSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUnderUnderSubject.metadata" relation */
  metadata?: InputMaybe<MetadataUnderUnderSubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUnderUnderSubject.photo" relation */
  photo?: InputMaybe<MetadataUnderUnderSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUnderUnderSubject" nodes by specifying some conditions */
export type MetadataUnderUnderSubjectWhereInput = {
  AND?: InputMaybe<Array<MetadataUnderUnderSubjectWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
  OR?: InputMaybe<Array<MetadataUnderUnderSubjectWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUnderUnderSubject" node. */
export type MetadataUnderUnderSubjectWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUnderUnderSubjectWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUnderUnderSubject.metadata" relation */
  metadata: MetadataUnderUnderSubjectNestedMetadataCreateInput;
  /** Actions for the "MetadataUnderUnderSubject.photo" relation */
  photo: MetadataUnderUnderSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUnderUnderSubjectWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUnderUnderSubject.metadata" relation */
  metadata?: InputMaybe<MetadataUnderUnderSubjectNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUnderUnderSubject.photo" relation */
  photo?: InputMaybe<MetadataUnderUnderSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUnderUnderSubjectWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUnderUnderSubject.archive" relation */
  archive: MetadataUnderUnderSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataUnderUnderSubject.photo" relation */
  photo: MetadataUnderUnderSubjectNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUnderUnderSubjectWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUnderUnderSubject.archive" relation */
  archive?: InputMaybe<MetadataUnderUnderSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUnderUnderSubject.photo" relation */
  photo?: InputMaybe<MetadataUnderUnderSubjectNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUnderUnderSubjectWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUnderUnderSubject.archive" relation */
  archive: MetadataUnderUnderSubjectNestedArchiveCreateInput;
  /** Actions for the "MetadataUnderUnderSubject.metadata" relation */
  metadata: MetadataUnderUnderSubjectNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUnderUnderSubjectWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUnderUnderSubject.archive" relation */
  archive?: InputMaybe<MetadataUnderUnderSubjectNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUnderUnderSubject.metadata" relation */
  metadata?: InputMaybe<MetadataUnderUnderSubjectNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUpdateInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  legacyName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Metadata.metadataAccessRightsList" relation: "MetadataAccessRights.metadata"'s inverse relation */
  metadataAccessRightsList?: InputMaybe<MetadataNestedMetadataAccessRightsListUpdateInput>;
  /** Actions for the "Metadata.metadataAssetStateList" relation: "MetadataAssetState.metadata"'s inverse relation */
  metadataAssetStateList?: InputMaybe<MetadataNestedMetadataAssetStateListUpdateInput>;
  /** Actions for the "Metadata.metadataBackupNameList" relation: "MetadataBackupName.metadata"'s inverse relation */
  metadataBackupNameList?: InputMaybe<MetadataNestedMetadataBackupNameListUpdateInput>;
  /** Actions for the "Metadata.metadataBrandList" relation: "MetadataBrand.metadata"'s inverse relation */
  metadataBrandList?: InputMaybe<MetadataNestedMetadataBrandListUpdateInput>;
  /** Actions for the "Metadata.metadataBrandPrismaList" relation: "MetadataBrandPrisma.metadata"'s inverse relation */
  metadataBrandPrismaList?: InputMaybe<MetadataNestedMetadataBrandPrismaListUpdateInput>;
  /** Actions for the "Metadata.metadataBrandShortNameList" relation: "MetadataBrandShortName.metadata"'s inverse relation */
  metadataBrandShortNameList?: InputMaybe<MetadataNestedMetadataBrandShortNameListUpdateInput>;
  /** Actions for the "Metadata.metadataByLineList" relation: "MetadataByLine.metadata"'s inverse relation */
  metadataByLineList?: InputMaybe<MetadataNestedMetadataByLineListUpdateInput>;
  /** Actions for the "Metadata.metadataCaptionAbstractList" relation: "MetadataCaptionAbstract.metadata"'s inverse relation */
  metadataCaptionAbstractList?: InputMaybe<MetadataNestedMetadataCaptionAbstractListUpdateInput>;
  /** Actions for the "Metadata.metadataCaptionList" relation: "MetadataCaption.metadata"'s inverse relation */
  metadataCaptionList?: InputMaybe<MetadataNestedMetadataCaptionListUpdateInput>;
  /** Actions for the "Metadata.metadataCategoryList" relation: "MetadataCategory.metadata"'s inverse relation */
  metadataCategoryList?: InputMaybe<MetadataNestedMetadataCategoryListUpdateInput>;
  /** Actions for the "Metadata.metadataCategoryPrismaList" relation: "MetadataCategoryPrisma.metadata"'s inverse relation */
  metadataCategoryPrismaList?: InputMaybe<MetadataNestedMetadataCategoryPrismaListUpdateInput>;
  /** Actions for the "Metadata.metadataCompanyList" relation: "MetadataCompany.metadata"'s inverse relation */
  metadataCompanyList?: InputMaybe<MetadataNestedMetadataCompanyListUpdateInput>;
  /** Actions for the "Metadata.metadataCompanyShortNameList" relation: "MetadataCompanyShortName.metadata"'s inverse relation */
  metadataCompanyShortNameList?: InputMaybe<MetadataNestedMetadataCompanyShortNameListUpdateInput>;
  /** Actions for the "Metadata.metadataCopyrightNoticeList" relation: "MetadataCopyrightNotice.metadata"'s inverse relation */
  metadataCopyrightNoticeList?: InputMaybe<MetadataNestedMetadataCopyrightNoticeListUpdateInput>;
  /** Actions for the "Metadata.metadataCreatorList" relation: "MetadataCreator.metadata"'s inverse relation */
  metadataCreatorList?: InputMaybe<MetadataNestedMetadataCreatorListUpdateInput>;
  /** Actions for the "Metadata.metadataCreditList" relation: "MetadataCredit.metadata"'s inverse relation */
  metadataCreditList?: InputMaybe<MetadataNestedMetadataCreditListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField14List" relation: "MetadataCustomField14.metadata"'s inverse relation */
  metadataCustomField14List?: InputMaybe<MetadataNestedMetadataCustomField14ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField15List" relation: "MetadataCustomField15.metadata"'s inverse relation */
  metadataCustomField15List?: InputMaybe<MetadataNestedMetadataCustomField15ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField16List" relation: "MetadataCustomField16.metadata"'s inverse relation */
  metadataCustomField16List?: InputMaybe<MetadataNestedMetadataCustomField16ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField17List" relation: "MetadataCustomField17.metadata"'s inverse relation */
  metadataCustomField17List?: InputMaybe<MetadataNestedMetadataCustomField17ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField1List" relation: "MetadataCustomField1.metadata"'s inverse relation */
  metadataCustomField1List?: InputMaybe<MetadataNestedMetadataCustomField1ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField20List" relation: "MetadataCustomField20.metadata"'s inverse relation */
  metadataCustomField20List?: InputMaybe<MetadataNestedMetadataCustomField20ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField3List" relation: "MetadataCustomField3.metadata"'s inverse relation */
  metadataCustomField3List?: InputMaybe<MetadataNestedMetadataCustomField3ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField4List" relation: "MetadataCustomField4.metadata"'s inverse relation */
  metadataCustomField4List?: InputMaybe<MetadataNestedMetadataCustomField4ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField5List" relation: "MetadataCustomField5.metadata"'s inverse relation */
  metadataCustomField5List?: InputMaybe<MetadataNestedMetadataCustomField5ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField6List" relation: "MetadataCustomField6.metadata"'s inverse relation */
  metadataCustomField6List?: InputMaybe<MetadataNestedMetadataCustomField6ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField7List" relation: "MetadataCustomField7.metadata"'s inverse relation */
  metadataCustomField7List?: InputMaybe<MetadataNestedMetadataCustomField7ListUpdateInput>;
  /** Actions for the "Metadata.metadataCustomField9List" relation: "MetadataCustomField9.metadata"'s inverse relation */
  metadataCustomField9List?: InputMaybe<MetadataNestedMetadataCustomField9ListUpdateInput>;
  /** Actions for the "Metadata.metadataDateCreatedList" relation: "MetadataDateCreated.metadata"'s inverse relation */
  metadataDateCreatedList?: InputMaybe<MetadataNestedMetadataDateCreatedListUpdateInput>;
  /** Actions for the "Metadata.metadataDateTimeOriginalList" relation: "MetadataDateTimeOriginal.metadata"'s inverse relation */
  metadataDateTimeOriginalList?: InputMaybe<MetadataNestedMetadataDateTimeOriginalListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryAccountList" relation: "MetadataDeliveryAccount.metadata"'s inverse relation */
  metadataDeliveryAccountList?: InputMaybe<MetadataNestedMetadataDeliveryAccountListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryCompanyList" relation: "MetadataDeliveryCompany.metadata"'s inverse relation */
  metadataDeliveryCompanyList?: InputMaybe<MetadataNestedMetadataDeliveryCompanyListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryCopyrightList" relation: "MetadataDeliveryCopyright.metadata"'s inverse relation */
  metadataDeliveryCopyrightList?: InputMaybe<MetadataNestedMetadataDeliveryCopyrightListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryDateFolderList" relation: "MetadataDeliveryDateFolder.metadata"'s inverse relation */
  metadataDeliveryDateFolderList?: InputMaybe<MetadataNestedMetadataDeliveryDateFolderListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryDateTimeList" relation: "MetadataDeliveryDateTime.metadata"'s inverse relation */
  metadataDeliveryDateTimeList?: InputMaybe<MetadataNestedMetadataDeliveryDateTimeListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryDcCreatorList" relation: "MetadataDeliveryDcCreator.metadata"'s inverse relation */
  metadataDeliveryDcCreatorList?: InputMaybe<MetadataNestedMetadataDeliveryDcCreatorListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryDcRightsList" relation: "MetadataDeliveryDcRights.metadata"'s inverse relation */
  metadataDeliveryDcRightsList?: InputMaybe<MetadataNestedMetadataDeliveryDcRightsListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryFolderList" relation: "MetadataDeliveryFolder.metadata"'s inverse relation */
  metadataDeliveryFolderList?: InputMaybe<MetadataNestedMetadataDeliveryFolderListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryKindList" relation: "MetadataDeliveryKind.metadata"'s inverse relation */
  metadataDeliveryKindList?: InputMaybe<MetadataNestedMetadataDeliveryKindListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryPathList" relation: "MetadataDeliveryPath.metadata"'s inverse relation */
  metadataDeliveryPathList?: InputMaybe<MetadataNestedMetadataDeliveryPathListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryPhotoshopCreditList" relation: "MetadataDeliveryPhotoshopCredit.metadata"'s inverse relation */
  metadataDeliveryPhotoshopCreditList?: InputMaybe<MetadataNestedMetadataDeliveryPhotoshopCreditListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryPhotoshopSourceList" relation: "MetadataDeliveryPhotoshopSource.metadata"'s inverse relation */
  metadataDeliveryPhotoshopSourceList?: InputMaybe<MetadataNestedMetadataDeliveryPhotoshopSourceListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryServiceList" relation: "MetadataDeliveryService.metadata"'s inverse relation */
  metadataDeliveryServiceList?: InputMaybe<MetadataNestedMetadataDeliveryServiceListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliverySubjectList" relation: "MetadataDeliverySubject.metadata"'s inverse relation */
  metadataDeliverySubjectList?: InputMaybe<MetadataNestedMetadataDeliverySubjectListUpdateInput>;
  /** Actions for the "Metadata.metadataDeliveryUnderSubjectList" relation: "MetadataDeliveryUnderSubject.metadata"'s inverse relation */
  metadataDeliveryUnderSubjectList?: InputMaybe<MetadataNestedMetadataDeliveryUnderSubjectListUpdateInput>;
  /** Actions for the "Metadata.metadataDepartmentList" relation: "MetadataDepartment.metadata"'s inverse relation */
  metadataDepartmentList?: InputMaybe<MetadataNestedMetadataDepartmentListUpdateInput>;
  /** Actions for the "Metadata.metadataDescriptionList" relation: "MetadataDescription.metadata"'s inverse relation */
  metadataDescriptionList?: InputMaybe<MetadataNestedMetadataDescriptionListUpdateInput>;
  /** Actions for the "Metadata.metadataEditionList" relation: "MetadataEdition.metadata"'s inverse relation */
  metadataEditionList?: InputMaybe<MetadataNestedMetadataEditionListUpdateInput>;
  /** Actions for the "Metadata.metadataEditStatusList" relation: "MetadataEditStatus.metadata"'s inverse relation */
  metadataEditStatusList?: InputMaybe<MetadataNestedMetadataEditStatusListUpdateInput>;
  /** Actions for the "Metadata.metadataFileStatusList" relation: "MetadataFileStatus.metadata"'s inverse relation */
  metadataFileStatusList?: InputMaybe<MetadataNestedMetadataFileStatusListUpdateInput>;
  /** Actions for the "Metadata.metadataFormatList" relation: "MetadataFormat.metadata"'s inverse relation */
  metadataFormatList?: InputMaybe<MetadataNestedMetadataFormatListUpdateInput>;
  /** Actions for the "Metadata.metadataHeaderList" relation: "MetadataHeader.metadata"'s inverse relation */
  metadataHeaderList?: InputMaybe<MetadataNestedMetadataHeaderListUpdateInput>;
  /** Actions for the "Metadata.metadataHeaderPrismaList" relation: "MetadataHeaderPrisma.metadata"'s inverse relation */
  metadataHeaderPrismaList?: InputMaybe<MetadataNestedMetadataHeaderPrismaListUpdateInput>;
  /** Actions for the "Metadata.metadataHeadlineList" relation: "MetadataHeadline.metadata"'s inverse relation */
  metadataHeadlineList?: InputMaybe<MetadataNestedMetadataHeadlineListUpdateInput>;
  /** Actions for the "Metadata.metadataIdAssignmentList" relation: "MetadataIdAssignment.metadata"'s inverse relation */
  metadataIdAssignmentList?: InputMaybe<MetadataNestedMetadataIdAssignmentListUpdateInput>;
  /** Actions for the "Metadata.metadataIdPhotoPrismaList" relation: "MetadataIdPhotoPrisma.metadata"'s inverse relation */
  metadataIdPhotoPrismaList?: InputMaybe<MetadataNestedMetadataIdPhotoPrismaListUpdateInput>;
  /** Actions for the "Metadata.metadataIdSubjectList" relation: "MetadataIdSubject.metadata"'s inverse relation */
  metadataIdSubjectList?: InputMaybe<MetadataNestedMetadataIdSubjectListUpdateInput>;
  /** Actions for the "Metadata.metadataImageNotesList" relation: "MetadataImageNotes.metadata"'s inverse relation */
  metadataImageNotesList?: InputMaybe<MetadataNestedMetadataImageNotesListUpdateInput>;
  /** Actions for the "Metadata.metadataInstructionsList" relation: "MetadataInstructions.metadata"'s inverse relation */
  metadataInstructionsList?: InputMaybe<MetadataNestedMetadataInstructionsListUpdateInput>;
  /** Actions for the "Metadata.metadataIssueList" relation: "MetadataIssue.metadata"'s inverse relation */
  metadataIssueList?: InputMaybe<MetadataNestedMetadataIssueListUpdateInput>;
  /** Actions for the "Metadata.metadataKeywordsList" relation: "MetadataKeywords.metadata"'s inverse relation */
  metadataKeywordsList?: InputMaybe<MetadataNestedMetadataKeywordsListUpdateInput>;
  /** Actions for the "Metadata.metadataObjectNameList" relation: "MetadataObjectName.metadata"'s inverse relation */
  metadataObjectNameList?: InputMaybe<MetadataNestedMetadataObjectNameListUpdateInput>;
  /** Actions for the "Metadata.metadataOriginalNameList" relation: "MetadataOriginalName.metadata"'s inverse relation */
  metadataOriginalNameList?: InputMaybe<MetadataNestedMetadataOriginalNameListUpdateInput>;
  /** Actions for the "Metadata.metadataPriceLevelList" relation: "MetadataPriceLevel.metadata"'s inverse relation */
  metadataPriceLevelList?: InputMaybe<MetadataNestedMetadataPriceLevelListUpdateInput>;
  /** Actions for the "Metadata.metadataProcessHistoryList" relation: "MetadataProcessHistory.metadata"'s inverse relation */
  metadataProcessHistoryList?: InputMaybe<MetadataNestedMetadataProcessHistoryListUpdateInput>;
  /** Actions for the "Metadata.metadataProcessStatusList" relation: "MetadataProcessStatus.metadata"'s inverse relation */
  metadataProcessStatusList?: InputMaybe<MetadataNestedMetadataProcessStatusListUpdateInput>;
  /** Actions for the "Metadata.metadataProductList" relation: "MetadataProduct.metadata"'s inverse relation */
  metadataProductList?: InputMaybe<MetadataNestedMetadataProductListUpdateInput>;
  /** Actions for the "Metadata.metadataProductsList" relation: "MetadataProducts.metadata"'s inverse relation */
  metadataProductsList?: InputMaybe<MetadataNestedMetadataProductsListUpdateInput>;
  /** Actions for the "Metadata.metadataPublishingSubjectList" relation: "MetadataPublishingSubject.metadata"'s inverse relation */
  metadataPublishingSubjectList?: InputMaybe<MetadataNestedMetadataPublishingSubjectListUpdateInput>;
  /** Actions for the "Metadata.metadataResolutionKindList" relation: "MetadataResolutionKind.metadata"'s inverse relation */
  metadataResolutionKindList?: InputMaybe<MetadataNestedMetadataResolutionKindListUpdateInput>;
  /** Actions for the "Metadata.metadataRightsList" relation: "MetadataRights.metadata"'s inverse relation */
  metadataRightsList?: InputMaybe<MetadataNestedMetadataRightsListUpdateInput>;
  /** Actions for the "Metadata.metadataSourceList" relation: "MetadataSource.metadata"'s inverse relation */
  metadataSourceList?: InputMaybe<MetadataNestedMetadataSourceListUpdateInput>;
  /** Actions for the "Metadata.metadataSpecialInstructionsList" relation: "MetadataSpecialInstructions.metadata"'s inverse relation */
  metadataSpecialInstructionsList?: InputMaybe<MetadataNestedMetadataSpecialInstructionsListUpdateInput>;
  /** Actions for the "Metadata.metadataSubjectCodeList" relation: "MetadataSubjectCode.metadata"'s inverse relation */
  metadataSubjectCodeList?: InputMaybe<MetadataNestedMetadataSubjectCodeListUpdateInput>;
  /** Actions for the "Metadata.metadataSubjectList" relation: "MetadataSubject.metadata"'s inverse relation */
  metadataSubjectList?: InputMaybe<MetadataNestedMetadataSubjectListUpdateInput>;
  /** Actions for the "Metadata.metadataSubjectPrismaList" relation: "MetadataSubjectPrisma.metadata"'s inverse relation */
  metadataSubjectPrismaList?: InputMaybe<MetadataNestedMetadataSubjectPrismaListUpdateInput>;
  /** Actions for the "Metadata.metadataTitleList" relation: "MetadataTitle.metadata"'s inverse relation */
  metadataTitleList?: InputMaybe<MetadataNestedMetadataTitleListUpdateInput>;
  /** Actions for the "Metadata.metadataTransferredByFullNameList" relation: "MetadataTransferredByFullName.metadata"'s inverse relation */
  metadataTransferredByFullNameList?: InputMaybe<MetadataNestedMetadataTransferredByFullNameListUpdateInput>;
  /** Actions for the "Metadata.metadataTransferredByList" relation: "MetadataTransferredBy.metadata"'s inverse relation */
  metadataTransferredByList?: InputMaybe<MetadataNestedMetadataTransferredByListUpdateInput>;
  /** Actions for the "Metadata.metadataTypeList" relation: "MetadataType.metadata"'s inverse relation */
  metadataTypeList?: InputMaybe<MetadataNestedMetadataTypeListUpdateInput>;
  /** Actions for the "Metadata.metadataUndersubjectList" relation: "MetadataUndersubject.metadata"'s inverse relation */
  metadataUndersubjectList?: InputMaybe<MetadataNestedMetadataUndersubjectListUpdateInput>;
  /** Actions for the "Metadata.metadataUnderUnderSubjectList" relation: "MetadataUnderUnderSubject.metadata"'s inverse relation */
  metadataUnderUnderSubjectList?: InputMaybe<MetadataNestedMetadataUnderUnderSubjectListUpdateInput>;
  /** Actions for the "Metadata.metadataUploadedByFullNameList" relation: "MetadataUploadedByFullName.metadata"'s inverse relation */
  metadataUploadedByFullNameList?: InputMaybe<MetadataNestedMetadataUploadedByFullNameListUpdateInput>;
  /** Actions for the "Metadata.metadataUploadedByList" relation: "MetadataUploadedBy.metadata"'s inverse relation */
  metadataUploadedByList?: InputMaybe<MetadataNestedMetadataUploadedByListUpdateInput>;
  /** Actions for the "Metadata.metadataUploadTimeList" relation: "MetadataUploadTime.metadata"'s inverse relation */
  metadataUploadTimeList?: InputMaybe<MetadataNestedMetadataUploadTimeListUpdateInput>;
  /** Actions for the "Metadata.metadataUrgencyList" relation: "MetadataUrgency.metadata"'s inverse relation */
  metadataUrgencyList?: InputMaybe<MetadataNestedMetadataUrgencyListUpdateInput>;
  /** Actions for the "Metadata.metadataUserDefined195List" relation: "MetadataUserDefined195.metadata"'s inverse relation */
  metadataUserDefined195List?: InputMaybe<MetadataNestedMetadataUserDefined195ListUpdateInput>;
  /** Actions for the "Metadata.metadataUserDefined237List" relation: "MetadataUserDefined237.metadata"'s inverse relation */
  metadataUserDefined237List?: InputMaybe<MetadataNestedMetadataUserDefined237ListUpdateInput>;
  /** Actions for the "Metadata.metadataUserDefined238List" relation: "MetadataUserDefined238.metadata"'s inverse relation */
  metadataUserDefined238List?: InputMaybe<MetadataNestedMetadataUserDefined238ListUpdateInput>;
  /** Actions for the "Metadata.metadataUserDefined239List" relation: "MetadataUserDefined239.metadata"'s inverse relation */
  metadataUserDefined239List?: InputMaybe<MetadataNestedMetadataUserDefined239ListUpdateInput>;
  /** Actions for the "Metadata.metadataUserDefined242List" relation: "MetadataUserDefined242.metadata"'s inverse relation */
  metadataUserDefined242List?: InputMaybe<MetadataNestedMetadataUserDefined242ListUpdateInput>;
  /** Actions for the "Metadata.metadataUserDefined62List" relation: "MetadataUserDefined62.metadata"'s inverse relation */
  metadataUserDefined62List?: InputMaybe<MetadataNestedMetadataUserDefined62ListUpdateInput>;
  /** Actions for the "Metadata.metadataWorkflowKindList" relation: "MetadataWorkflowKind.metadata"'s inverse relation */
  metadataWorkflowKindList?: InputMaybe<MetadataNestedMetadataWorkflowKindListUpdateInput>;
  /** Actions for the "Metadata.metadataXmpHistoryList" relation: "MetadataXmpHistory.metadata"'s inverse relation */
  metadataXmpHistoryList?: InputMaybe<MetadataNestedMetadataXmpHistoryListUpdateInput>;
  name?: InputMaybe<MetadataNameEnumType>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Metadata.photoMetadatas" relation: "PhotoMetadata.metadata"'s inverse relation */
  photoMetadatas?: InputMaybe<MetadataNestedPhotoMetadatasUpdateInput>;
  structName?: InputMaybe<Scalars['String']['input']>;
  /** whether is this metadata value is a list or not, for display usage */
  type?: InputMaybe<MetadataValueTypeEnum>;
};

/** "MetadataUploadedBy" resource's node */
export type MetadataUploadedBy = {
  __typename?: 'MetadataUploadedBy';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUploadedByCreateInput = {
  /** Actions for the "MetadataUploadedBy.archive" relation */
  archive: MetadataUploadedByNestedArchiveCreateInput;
  /** Actions for the "MetadataUploadedBy.metadata" relation */
  metadata: MetadataUploadedByNestedMetadataCreateInput;
  /** Actions for the "MetadataUploadedBy.photo" relation */
  photo: MetadataUploadedByNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUploadedByFullName" resource's node */
export type MetadataUploadedByFullName = {
  __typename?: 'MetadataUploadedByFullName';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUploadedByFullNameCreateInput = {
  /** Actions for the "MetadataUploadedByFullName.archive" relation */
  archive: MetadataUploadedByFullNameNestedArchiveCreateInput;
  /** Actions for the "MetadataUploadedByFullName.metadata" relation */
  metadata: MetadataUploadedByFullNameNestedMetadataCreateInput;
  /** Actions for the "MetadataUploadedByFullName.photo" relation */
  photo: MetadataUploadedByFullNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByFullNameNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.archive" relation. */
  update?: InputMaybe<MetadataUploadedByFullNameNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.archive" relation. */
  upsert?: InputMaybe<MetadataUploadedByFullNameNestedUpsertArchiveCreateInput>;
};

export type MetadataUploadedByFullNameNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.archive" relation. */
  update?: InputMaybe<MetadataUploadedByFullNameNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.archive" relation. */
  upsert?: InputMaybe<MetadataUploadedByFullNameNestedUpsertArchiveUpdateInput>;
};

export type MetadataUploadedByFullNameNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.metadata" relation. */
  update?: InputMaybe<MetadataUploadedByFullNameNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.metadata" relation. */
  upsert?: InputMaybe<MetadataUploadedByFullNameNestedUpsertMetadataCreateInput>;
};

export type MetadataUploadedByFullNameNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.metadata" relation. */
  update?: InputMaybe<MetadataUploadedByFullNameNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.metadata" relation. */
  upsert?: InputMaybe<MetadataUploadedByFullNameNestedUpsertMetadataUpdateInput>;
};

export type MetadataUploadedByFullNameNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.photo" relation. */
  update?: InputMaybe<MetadataUploadedByFullNameNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.photo" relation. */
  upsert?: InputMaybe<MetadataUploadedByFullNameNestedUpsertPhotoCreateInput>;
};

export type MetadataUploadedByFullNameNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.photo" relation. */
  update?: InputMaybe<MetadataUploadedByFullNameNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUploadedByFullName" node, through the "MetadataUploadedByFullName.photo" relation. */
  upsert?: InputMaybe<MetadataUploadedByFullNameNestedUpsertPhotoUpdateInput>;
};

export type MetadataUploadedByFullNameNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUploadedByFullNameNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUploadedByFullNameOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUploadedByFullNameUpdateInput = {
  /** Actions for the "MetadataUploadedByFullName.archive" relation */
  archive?: InputMaybe<MetadataUploadedByFullNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUploadedByFullName.metadata" relation */
  metadata?: InputMaybe<MetadataUploadedByFullNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUploadedByFullName.photo" relation */
  photo?: InputMaybe<MetadataUploadedByFullNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUploadedByFullName" nodes by specifying some conditions */
export type MetadataUploadedByFullNameWhereInput = {
  AND?: InputMaybe<Array<MetadataUploadedByFullNameWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
  OR?: InputMaybe<Array<MetadataUploadedByFullNameWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUploadedByFullName" node. */
export type MetadataUploadedByFullNameWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUploadedByFullNameWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUploadedByFullName.metadata" relation */
  metadata: MetadataUploadedByFullNameNestedMetadataCreateInput;
  /** Actions for the "MetadataUploadedByFullName.photo" relation */
  photo: MetadataUploadedByFullNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByFullNameWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUploadedByFullName.metadata" relation */
  metadata?: InputMaybe<MetadataUploadedByFullNameNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUploadedByFullName.photo" relation */
  photo?: InputMaybe<MetadataUploadedByFullNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByFullNameWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUploadedByFullName.archive" relation */
  archive: MetadataUploadedByFullNameNestedArchiveCreateInput;
  /** Actions for the "MetadataUploadedByFullName.photo" relation */
  photo: MetadataUploadedByFullNameNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByFullNameWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUploadedByFullName.archive" relation */
  archive?: InputMaybe<MetadataUploadedByFullNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUploadedByFullName.photo" relation */
  photo?: InputMaybe<MetadataUploadedByFullNameNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByFullNameWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUploadedByFullName.archive" relation */
  archive: MetadataUploadedByFullNameNestedArchiveCreateInput;
  /** Actions for the "MetadataUploadedByFullName.metadata" relation */
  metadata: MetadataUploadedByFullNameNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByFullNameWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUploadedByFullName.archive" relation */
  archive?: InputMaybe<MetadataUploadedByFullNameNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUploadedByFullName.metadata" relation */
  metadata?: InputMaybe<MetadataUploadedByFullNameNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.archive" relation. */
  update?: InputMaybe<MetadataUploadedByNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.archive" relation. */
  upsert?: InputMaybe<MetadataUploadedByNestedUpsertArchiveCreateInput>;
};

export type MetadataUploadedByNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.archive" relation. */
  update?: InputMaybe<MetadataUploadedByNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.archive" relation. */
  upsert?: InputMaybe<MetadataUploadedByNestedUpsertArchiveUpdateInput>;
};

export type MetadataUploadedByNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.metadata" relation. */
  update?: InputMaybe<MetadataUploadedByNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.metadata" relation. */
  upsert?: InputMaybe<MetadataUploadedByNestedUpsertMetadataCreateInput>;
};

export type MetadataUploadedByNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.metadata" relation. */
  update?: InputMaybe<MetadataUploadedByNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.metadata" relation. */
  upsert?: InputMaybe<MetadataUploadedByNestedUpsertMetadataUpdateInput>;
};

export type MetadataUploadedByNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.photo" relation. */
  update?: InputMaybe<MetadataUploadedByNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUploadedBy" node, through the "MetadataUploadedBy.photo" relation. */
  upsert?: InputMaybe<MetadataUploadedByNestedUpsertPhotoCreateInput>;
};

export type MetadataUploadedByNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.photo" relation. */
  update?: InputMaybe<MetadataUploadedByNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUploadedBy" node, through the "MetadataUploadedBy.photo" relation. */
  upsert?: InputMaybe<MetadataUploadedByNestedUpsertPhotoUpdateInput>;
};

export type MetadataUploadedByNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadedByNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadedByNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadedByNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadedByNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUploadedByNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUploadedByNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadedByNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadedByNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadedByNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadedByNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUploadedByNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUploadedByOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUploadedByUpdateInput = {
  /** Actions for the "MetadataUploadedBy.archive" relation */
  archive?: InputMaybe<MetadataUploadedByNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUploadedBy.metadata" relation */
  metadata?: InputMaybe<MetadataUploadedByNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUploadedBy.photo" relation */
  photo?: InputMaybe<MetadataUploadedByNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUploadedBy" nodes by specifying some conditions */
export type MetadataUploadedByWhereInput = {
  AND?: InputMaybe<Array<MetadataUploadedByWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUploadedByWhereInput>;
  OR?: InputMaybe<Array<MetadataUploadedByWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUploadedBy" node. */
export type MetadataUploadedByWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUploadedByWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUploadedBy.metadata" relation */
  metadata: MetadataUploadedByNestedMetadataCreateInput;
  /** Actions for the "MetadataUploadedBy.photo" relation */
  photo: MetadataUploadedByNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUploadedBy.metadata" relation */
  metadata?: InputMaybe<MetadataUploadedByNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUploadedBy.photo" relation */
  photo?: InputMaybe<MetadataUploadedByNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUploadedBy.archive" relation */
  archive: MetadataUploadedByNestedArchiveCreateInput;
  /** Actions for the "MetadataUploadedBy.photo" relation */
  photo: MetadataUploadedByNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUploadedBy.archive" relation */
  archive?: InputMaybe<MetadataUploadedByNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUploadedBy.photo" relation */
  photo?: InputMaybe<MetadataUploadedByNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUploadedBy.archive" relation */
  archive: MetadataUploadedByNestedArchiveCreateInput;
  /** Actions for the "MetadataUploadedBy.metadata" relation */
  metadata: MetadataUploadedByNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadedByWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUploadedBy.archive" relation */
  archive?: InputMaybe<MetadataUploadedByNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUploadedBy.metadata" relation */
  metadata?: InputMaybe<MetadataUploadedByNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUploadTime" resource's node */
export type MetadataUploadTime = {
  __typename?: 'MetadataUploadTime';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUploadTimeCreateInput = {
  /** Actions for the "MetadataUploadTime.archive" relation */
  archive: MetadataUploadTimeNestedArchiveCreateInput;
  /** Actions for the "MetadataUploadTime.metadata" relation */
  metadata: MetadataUploadTimeNestedMetadataCreateInput;
  /** Actions for the "MetadataUploadTime.photo" relation */
  photo: MetadataUploadTimeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadTimeNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUploadTime" node, through the "MetadataUploadTime.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUploadTime" node, through the "MetadataUploadTime.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUploadTime" node, through the "MetadataUploadTime.archive" relation. */
  update?: InputMaybe<MetadataUploadTimeNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUploadTime" node, through the "MetadataUploadTime.archive" relation. */
  upsert?: InputMaybe<MetadataUploadTimeNestedUpsertArchiveCreateInput>;
};

export type MetadataUploadTimeNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.archive" relation. */
  update?: InputMaybe<MetadataUploadTimeNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.archive" relation. */
  upsert?: InputMaybe<MetadataUploadTimeNestedUpsertArchiveUpdateInput>;
};

export type MetadataUploadTimeNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUploadTime" node, through the "MetadataUploadTime.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUploadTime" node, through the "MetadataUploadTime.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUploadTime" node, through the "MetadataUploadTime.metadata" relation. */
  update?: InputMaybe<MetadataUploadTimeNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUploadTime" node, through the "MetadataUploadTime.metadata" relation. */
  upsert?: InputMaybe<MetadataUploadTimeNestedUpsertMetadataCreateInput>;
};

export type MetadataUploadTimeNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.metadata" relation. */
  update?: InputMaybe<MetadataUploadTimeNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.metadata" relation. */
  upsert?: InputMaybe<MetadataUploadTimeNestedUpsertMetadataUpdateInput>;
};

export type MetadataUploadTimeNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUploadTime" node, through the "MetadataUploadTime.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUploadTime" node, through the "MetadataUploadTime.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUploadTime" node, through the "MetadataUploadTime.photo" relation. */
  update?: InputMaybe<MetadataUploadTimeNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUploadTime" node, through the "MetadataUploadTime.photo" relation. */
  upsert?: InputMaybe<MetadataUploadTimeNestedUpsertPhotoCreateInput>;
};

export type MetadataUploadTimeNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.photo" relation. */
  update?: InputMaybe<MetadataUploadTimeNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUploadTime" node, through the "MetadataUploadTime.photo" relation. */
  upsert?: InputMaybe<MetadataUploadTimeNestedUpsertPhotoUpdateInput>;
};

export type MetadataUploadTimeNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUploadTimeNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUploadTimeOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUploadTimeUpdateInput = {
  /** Actions for the "MetadataUploadTime.archive" relation */
  archive?: InputMaybe<MetadataUploadTimeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUploadTime.metadata" relation */
  metadata?: InputMaybe<MetadataUploadTimeNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUploadTime.photo" relation */
  photo?: InputMaybe<MetadataUploadTimeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUploadTime" nodes by specifying some conditions */
export type MetadataUploadTimeWhereInput = {
  AND?: InputMaybe<Array<MetadataUploadTimeWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUploadTimeWhereInput>;
  OR?: InputMaybe<Array<MetadataUploadTimeWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUploadTime" node. */
export type MetadataUploadTimeWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUploadTimeWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUploadTime.metadata" relation */
  metadata: MetadataUploadTimeNestedMetadataCreateInput;
  /** Actions for the "MetadataUploadTime.photo" relation */
  photo: MetadataUploadTimeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadTimeWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUploadTime.metadata" relation */
  metadata?: InputMaybe<MetadataUploadTimeNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUploadTime.photo" relation */
  photo?: InputMaybe<MetadataUploadTimeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadTimeWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUploadTime.archive" relation */
  archive: MetadataUploadTimeNestedArchiveCreateInput;
  /** Actions for the "MetadataUploadTime.photo" relation */
  photo: MetadataUploadTimeNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadTimeWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUploadTime.archive" relation */
  archive?: InputMaybe<MetadataUploadTimeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUploadTime.photo" relation */
  photo?: InputMaybe<MetadataUploadTimeNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadTimeWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUploadTime.archive" relation */
  archive: MetadataUploadTimeNestedArchiveCreateInput;
  /** Actions for the "MetadataUploadTime.metadata" relation */
  metadata: MetadataUploadTimeNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUploadTimeWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUploadTime.archive" relation */
  archive?: InputMaybe<MetadataUploadTimeNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUploadTime.metadata" relation */
  metadata?: InputMaybe<MetadataUploadTimeNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUrgency" resource's node */
export type MetadataUrgency = {
  __typename?: 'MetadataUrgency';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUrgencyCreateInput = {
  /** Actions for the "MetadataUrgency.archive" relation */
  archive: MetadataUrgencyNestedArchiveCreateInput;
  /** Actions for the "MetadataUrgency.metadata" relation */
  metadata: MetadataUrgencyNestedMetadataCreateInput;
  /** Actions for the "MetadataUrgency.photo" relation */
  photo: MetadataUrgencyNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUrgencyNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUrgency" node, through the "MetadataUrgency.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUrgency" node, through the "MetadataUrgency.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUrgency" node, through the "MetadataUrgency.archive" relation. */
  update?: InputMaybe<MetadataUrgencyNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUrgency" node, through the "MetadataUrgency.archive" relation. */
  upsert?: InputMaybe<MetadataUrgencyNestedUpsertArchiveCreateInput>;
};

export type MetadataUrgencyNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUrgency" node, through the "MetadataUrgency.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUrgency" node, through the "MetadataUrgency.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUrgency" node, through the "MetadataUrgency.archive" relation. */
  update?: InputMaybe<MetadataUrgencyNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUrgency" node, through the "MetadataUrgency.archive" relation. */
  upsert?: InputMaybe<MetadataUrgencyNestedUpsertArchiveUpdateInput>;
};

export type MetadataUrgencyNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUrgency" node, through the "MetadataUrgency.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUrgency" node, through the "MetadataUrgency.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUrgency" node, through the "MetadataUrgency.metadata" relation. */
  update?: InputMaybe<MetadataUrgencyNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUrgency" node, through the "MetadataUrgency.metadata" relation. */
  upsert?: InputMaybe<MetadataUrgencyNestedUpsertMetadataCreateInput>;
};

export type MetadataUrgencyNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUrgency" node, through the "MetadataUrgency.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUrgency" node, through the "MetadataUrgency.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUrgency" node, through the "MetadataUrgency.metadata" relation. */
  update?: InputMaybe<MetadataUrgencyNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUrgency" node, through the "MetadataUrgency.metadata" relation. */
  upsert?: InputMaybe<MetadataUrgencyNestedUpsertMetadataUpdateInput>;
};

export type MetadataUrgencyNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUrgency" node, through the "MetadataUrgency.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUrgency" node, through the "MetadataUrgency.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUrgency" node, through the "MetadataUrgency.photo" relation. */
  update?: InputMaybe<MetadataUrgencyNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUrgency" node, through the "MetadataUrgency.photo" relation. */
  upsert?: InputMaybe<MetadataUrgencyNestedUpsertPhotoCreateInput>;
};

export type MetadataUrgencyNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUrgency" node, through the "MetadataUrgency.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUrgency" node, through the "MetadataUrgency.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUrgency" node, through the "MetadataUrgency.photo" relation. */
  update?: InputMaybe<MetadataUrgencyNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUrgency" node, through the "MetadataUrgency.photo" relation. */
  upsert?: InputMaybe<MetadataUrgencyNestedUpsertPhotoUpdateInput>;
};

export type MetadataUrgencyNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUrgencyNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUrgencyNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUrgencyNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUrgencyNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUrgencyNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUrgencyNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUrgencyNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUrgencyNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUrgencyNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUrgencyNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUrgencyNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUrgencyOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUrgencyUpdateInput = {
  /** Actions for the "MetadataUrgency.archive" relation */
  archive?: InputMaybe<MetadataUrgencyNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUrgency.metadata" relation */
  metadata?: InputMaybe<MetadataUrgencyNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUrgency.photo" relation */
  photo?: InputMaybe<MetadataUrgencyNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUrgency" nodes by specifying some conditions */
export type MetadataUrgencyWhereInput = {
  AND?: InputMaybe<Array<MetadataUrgencyWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUrgencyWhereInput>;
  OR?: InputMaybe<Array<MetadataUrgencyWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUrgency" node. */
export type MetadataUrgencyWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUrgencyWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUrgency.metadata" relation */
  metadata: MetadataUrgencyNestedMetadataCreateInput;
  /** Actions for the "MetadataUrgency.photo" relation */
  photo: MetadataUrgencyNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUrgencyWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUrgency.metadata" relation */
  metadata?: InputMaybe<MetadataUrgencyNestedMetadataUpdateInput>;
  /** Actions for the "MetadataUrgency.photo" relation */
  photo?: InputMaybe<MetadataUrgencyNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUrgencyWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUrgency.archive" relation */
  archive: MetadataUrgencyNestedArchiveCreateInput;
  /** Actions for the "MetadataUrgency.photo" relation */
  photo: MetadataUrgencyNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUrgencyWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUrgency.archive" relation */
  archive?: InputMaybe<MetadataUrgencyNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUrgency.photo" relation */
  photo?: InputMaybe<MetadataUrgencyNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUrgencyWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUrgency.archive" relation */
  archive: MetadataUrgencyNestedArchiveCreateInput;
  /** Actions for the "MetadataUrgency.metadata" relation */
  metadata: MetadataUrgencyNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUrgencyWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUrgency.archive" relation */
  archive?: InputMaybe<MetadataUrgencyNestedArchiveUpdateInput>;
  /** Actions for the "MetadataUrgency.metadata" relation */
  metadata?: InputMaybe<MetadataUrgencyNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUserDefined195" resource's node */
export type MetadataUserDefined195 = {
  __typename?: 'MetadataUserDefined195';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUserDefined195CreateInput = {
  /** Actions for the "MetadataUserDefined195.archive" relation */
  archive: MetadataUserDefined195NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined195.metadata" relation */
  metadata: MetadataUserDefined195NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined195.photo" relation */
  photo: MetadataUserDefined195NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined195NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.archive" relation. */
  update?: InputMaybe<MetadataUserDefined195NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined195NestedUpsertArchiveCreateInput>;
};

export type MetadataUserDefined195NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.archive" relation. */
  update?: InputMaybe<MetadataUserDefined195NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined195NestedUpsertArchiveUpdateInput>;
};

export type MetadataUserDefined195NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined195NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined195NestedUpsertMetadataCreateInput>;
};

export type MetadataUserDefined195NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined195NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined195NestedUpsertMetadataUpdateInput>;
};

export type MetadataUserDefined195NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.photo" relation. */
  update?: InputMaybe<MetadataUserDefined195NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUserDefined195" node, through the "MetadataUserDefined195.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined195NestedUpsertPhotoCreateInput>;
};

export type MetadataUserDefined195NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.photo" relation. */
  update?: InputMaybe<MetadataUserDefined195NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUserDefined195" node, through the "MetadataUserDefined195.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined195NestedUpsertPhotoUpdateInput>;
};

export type MetadataUserDefined195NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined195NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUserDefined195OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUserDefined195UpdateInput = {
  /** Actions for the "MetadataUserDefined195.archive" relation */
  archive?: InputMaybe<MetadataUserDefined195NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined195.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined195NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined195.photo" relation */
  photo?: InputMaybe<MetadataUserDefined195NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUserDefined195" nodes by specifying some conditions */
export type MetadataUserDefined195WhereInput = {
  AND?: InputMaybe<Array<MetadataUserDefined195WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUserDefined195WhereInput>;
  OR?: InputMaybe<Array<MetadataUserDefined195WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUserDefined195" node. */
export type MetadataUserDefined195WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUserDefined195WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUserDefined195.metadata" relation */
  metadata: MetadataUserDefined195NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined195.photo" relation */
  photo: MetadataUserDefined195NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined195WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUserDefined195.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined195NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined195.photo" relation */
  photo?: InputMaybe<MetadataUserDefined195NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined195WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUserDefined195.archive" relation */
  archive: MetadataUserDefined195NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined195.photo" relation */
  photo: MetadataUserDefined195NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined195WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUserDefined195.archive" relation */
  archive?: InputMaybe<MetadataUserDefined195NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined195.photo" relation */
  photo?: InputMaybe<MetadataUserDefined195NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined195WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUserDefined195.archive" relation */
  archive: MetadataUserDefined195NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined195.metadata" relation */
  metadata: MetadataUserDefined195NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined195WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUserDefined195.archive" relation */
  archive?: InputMaybe<MetadataUserDefined195NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined195.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined195NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUserDefined237" resource's node */
export type MetadataUserDefined237 = {
  __typename?: 'MetadataUserDefined237';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUserDefined237CreateInput = {
  /** Actions for the "MetadataUserDefined237.archive" relation */
  archive: MetadataUserDefined237NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined237.metadata" relation */
  metadata: MetadataUserDefined237NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined237.photo" relation */
  photo: MetadataUserDefined237NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined237NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.archive" relation. */
  update?: InputMaybe<MetadataUserDefined237NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined237NestedUpsertArchiveCreateInput>;
};

export type MetadataUserDefined237NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.archive" relation. */
  update?: InputMaybe<MetadataUserDefined237NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined237NestedUpsertArchiveUpdateInput>;
};

export type MetadataUserDefined237NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined237NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined237NestedUpsertMetadataCreateInput>;
};

export type MetadataUserDefined237NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined237NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined237NestedUpsertMetadataUpdateInput>;
};

export type MetadataUserDefined237NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.photo" relation. */
  update?: InputMaybe<MetadataUserDefined237NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUserDefined237" node, through the "MetadataUserDefined237.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined237NestedUpsertPhotoCreateInput>;
};

export type MetadataUserDefined237NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.photo" relation. */
  update?: InputMaybe<MetadataUserDefined237NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUserDefined237" node, through the "MetadataUserDefined237.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined237NestedUpsertPhotoUpdateInput>;
};

export type MetadataUserDefined237NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined237NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUserDefined237OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUserDefined237UpdateInput = {
  /** Actions for the "MetadataUserDefined237.archive" relation */
  archive?: InputMaybe<MetadataUserDefined237NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined237.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined237NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined237.photo" relation */
  photo?: InputMaybe<MetadataUserDefined237NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUserDefined237" nodes by specifying some conditions */
export type MetadataUserDefined237WhereInput = {
  AND?: InputMaybe<Array<MetadataUserDefined237WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUserDefined237WhereInput>;
  OR?: InputMaybe<Array<MetadataUserDefined237WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUserDefined237" node. */
export type MetadataUserDefined237WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUserDefined237WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUserDefined237.metadata" relation */
  metadata: MetadataUserDefined237NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined237.photo" relation */
  photo: MetadataUserDefined237NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined237WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUserDefined237.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined237NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined237.photo" relation */
  photo?: InputMaybe<MetadataUserDefined237NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined237WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUserDefined237.archive" relation */
  archive: MetadataUserDefined237NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined237.photo" relation */
  photo: MetadataUserDefined237NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined237WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUserDefined237.archive" relation */
  archive?: InputMaybe<MetadataUserDefined237NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined237.photo" relation */
  photo?: InputMaybe<MetadataUserDefined237NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined237WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUserDefined237.archive" relation */
  archive: MetadataUserDefined237NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined237.metadata" relation */
  metadata: MetadataUserDefined237NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined237WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUserDefined237.archive" relation */
  archive?: InputMaybe<MetadataUserDefined237NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined237.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined237NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUserDefined238" resource's node */
export type MetadataUserDefined238 = {
  __typename?: 'MetadataUserDefined238';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUserDefined238CreateInput = {
  /** Actions for the "MetadataUserDefined238.archive" relation */
  archive: MetadataUserDefined238NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined238.metadata" relation */
  metadata: MetadataUserDefined238NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined238.photo" relation */
  photo: MetadataUserDefined238NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined238NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.archive" relation. */
  update?: InputMaybe<MetadataUserDefined238NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined238NestedUpsertArchiveCreateInput>;
};

export type MetadataUserDefined238NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.archive" relation. */
  update?: InputMaybe<MetadataUserDefined238NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined238NestedUpsertArchiveUpdateInput>;
};

export type MetadataUserDefined238NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined238NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined238NestedUpsertMetadataCreateInput>;
};

export type MetadataUserDefined238NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined238NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined238NestedUpsertMetadataUpdateInput>;
};

export type MetadataUserDefined238NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.photo" relation. */
  update?: InputMaybe<MetadataUserDefined238NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUserDefined238" node, through the "MetadataUserDefined238.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined238NestedUpsertPhotoCreateInput>;
};

export type MetadataUserDefined238NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.photo" relation. */
  update?: InputMaybe<MetadataUserDefined238NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUserDefined238" node, through the "MetadataUserDefined238.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined238NestedUpsertPhotoUpdateInput>;
};

export type MetadataUserDefined238NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined238NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUserDefined238OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUserDefined238UpdateInput = {
  /** Actions for the "MetadataUserDefined238.archive" relation */
  archive?: InputMaybe<MetadataUserDefined238NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined238.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined238NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined238.photo" relation */
  photo?: InputMaybe<MetadataUserDefined238NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUserDefined238" nodes by specifying some conditions */
export type MetadataUserDefined238WhereInput = {
  AND?: InputMaybe<Array<MetadataUserDefined238WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUserDefined238WhereInput>;
  OR?: InputMaybe<Array<MetadataUserDefined238WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUserDefined238" node. */
export type MetadataUserDefined238WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUserDefined238WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUserDefined238.metadata" relation */
  metadata: MetadataUserDefined238NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined238.photo" relation */
  photo: MetadataUserDefined238NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined238WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUserDefined238.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined238NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined238.photo" relation */
  photo?: InputMaybe<MetadataUserDefined238NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined238WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUserDefined238.archive" relation */
  archive: MetadataUserDefined238NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined238.photo" relation */
  photo: MetadataUserDefined238NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined238WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUserDefined238.archive" relation */
  archive?: InputMaybe<MetadataUserDefined238NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined238.photo" relation */
  photo?: InputMaybe<MetadataUserDefined238NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined238WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUserDefined238.archive" relation */
  archive: MetadataUserDefined238NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined238.metadata" relation */
  metadata: MetadataUserDefined238NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined238WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUserDefined238.archive" relation */
  archive?: InputMaybe<MetadataUserDefined238NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined238.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined238NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUserDefined239" resource's node */
export type MetadataUserDefined239 = {
  __typename?: 'MetadataUserDefined239';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUserDefined239CreateInput = {
  /** Actions for the "MetadataUserDefined239.archive" relation */
  archive: MetadataUserDefined239NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined239.metadata" relation */
  metadata: MetadataUserDefined239NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined239.photo" relation */
  photo: MetadataUserDefined239NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined239NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.archive" relation. */
  update?: InputMaybe<MetadataUserDefined239NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined239NestedUpsertArchiveCreateInput>;
};

export type MetadataUserDefined239NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.archive" relation. */
  update?: InputMaybe<MetadataUserDefined239NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined239NestedUpsertArchiveUpdateInput>;
};

export type MetadataUserDefined239NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined239NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined239NestedUpsertMetadataCreateInput>;
};

export type MetadataUserDefined239NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined239NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined239NestedUpsertMetadataUpdateInput>;
};

export type MetadataUserDefined239NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.photo" relation. */
  update?: InputMaybe<MetadataUserDefined239NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUserDefined239" node, through the "MetadataUserDefined239.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined239NestedUpsertPhotoCreateInput>;
};

export type MetadataUserDefined239NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.photo" relation. */
  update?: InputMaybe<MetadataUserDefined239NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUserDefined239" node, through the "MetadataUserDefined239.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined239NestedUpsertPhotoUpdateInput>;
};

export type MetadataUserDefined239NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined239NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUserDefined239OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUserDefined239UpdateInput = {
  /** Actions for the "MetadataUserDefined239.archive" relation */
  archive?: InputMaybe<MetadataUserDefined239NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined239.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined239NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined239.photo" relation */
  photo?: InputMaybe<MetadataUserDefined239NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUserDefined239" nodes by specifying some conditions */
export type MetadataUserDefined239WhereInput = {
  AND?: InputMaybe<Array<MetadataUserDefined239WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUserDefined239WhereInput>;
  OR?: InputMaybe<Array<MetadataUserDefined239WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUserDefined239" node. */
export type MetadataUserDefined239WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUserDefined239WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUserDefined239.metadata" relation */
  metadata: MetadataUserDefined239NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined239.photo" relation */
  photo: MetadataUserDefined239NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined239WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUserDefined239.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined239NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined239.photo" relation */
  photo?: InputMaybe<MetadataUserDefined239NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined239WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUserDefined239.archive" relation */
  archive: MetadataUserDefined239NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined239.photo" relation */
  photo: MetadataUserDefined239NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined239WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUserDefined239.archive" relation */
  archive?: InputMaybe<MetadataUserDefined239NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined239.photo" relation */
  photo?: InputMaybe<MetadataUserDefined239NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined239WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUserDefined239.archive" relation */
  archive: MetadataUserDefined239NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined239.metadata" relation */
  metadata: MetadataUserDefined239NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined239WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUserDefined239.archive" relation */
  archive?: InputMaybe<MetadataUserDefined239NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined239.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined239NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUserDefined242" resource's node */
export type MetadataUserDefined242 = {
  __typename?: 'MetadataUserDefined242';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUserDefined242CreateInput = {
  /** Actions for the "MetadataUserDefined242.archive" relation */
  archive: MetadataUserDefined242NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined242.metadata" relation */
  metadata: MetadataUserDefined242NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined242.photo" relation */
  photo: MetadataUserDefined242NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined242NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.archive" relation. */
  update?: InputMaybe<MetadataUserDefined242NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined242NestedUpsertArchiveCreateInput>;
};

export type MetadataUserDefined242NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.archive" relation. */
  update?: InputMaybe<MetadataUserDefined242NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined242NestedUpsertArchiveUpdateInput>;
};

export type MetadataUserDefined242NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined242NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined242NestedUpsertMetadataCreateInput>;
};

export type MetadataUserDefined242NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined242NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined242NestedUpsertMetadataUpdateInput>;
};

export type MetadataUserDefined242NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.photo" relation. */
  update?: InputMaybe<MetadataUserDefined242NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUserDefined242" node, through the "MetadataUserDefined242.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined242NestedUpsertPhotoCreateInput>;
};

export type MetadataUserDefined242NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.photo" relation. */
  update?: InputMaybe<MetadataUserDefined242NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUserDefined242" node, through the "MetadataUserDefined242.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined242NestedUpsertPhotoUpdateInput>;
};

export type MetadataUserDefined242NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined242NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUserDefined242OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUserDefined242UpdateInput = {
  /** Actions for the "MetadataUserDefined242.archive" relation */
  archive?: InputMaybe<MetadataUserDefined242NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined242.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined242NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined242.photo" relation */
  photo?: InputMaybe<MetadataUserDefined242NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUserDefined242" nodes by specifying some conditions */
export type MetadataUserDefined242WhereInput = {
  AND?: InputMaybe<Array<MetadataUserDefined242WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUserDefined242WhereInput>;
  OR?: InputMaybe<Array<MetadataUserDefined242WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUserDefined242" node. */
export type MetadataUserDefined242WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUserDefined242WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUserDefined242.metadata" relation */
  metadata: MetadataUserDefined242NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined242.photo" relation */
  photo: MetadataUserDefined242NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined242WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUserDefined242.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined242NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined242.photo" relation */
  photo?: InputMaybe<MetadataUserDefined242NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined242WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUserDefined242.archive" relation */
  archive: MetadataUserDefined242NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined242.photo" relation */
  photo: MetadataUserDefined242NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined242WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUserDefined242.archive" relation */
  archive?: InputMaybe<MetadataUserDefined242NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined242.photo" relation */
  photo?: InputMaybe<MetadataUserDefined242NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined242WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUserDefined242.archive" relation */
  archive: MetadataUserDefined242NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined242.metadata" relation */
  metadata: MetadataUserDefined242NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined242WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUserDefined242.archive" relation */
  archive?: InputMaybe<MetadataUserDefined242NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined242.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined242NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataUserDefined62" resource's node */
export type MetadataUserDefined62 = {
  __typename?: 'MetadataUserDefined62';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataUserDefined62CreateInput = {
  /** Actions for the "MetadataUserDefined62.archive" relation */
  archive: MetadataUserDefined62NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined62.metadata" relation */
  metadata: MetadataUserDefined62NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined62.photo" relation */
  photo: MetadataUserDefined62NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined62NestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.archive" relation. */
  update?: InputMaybe<MetadataUserDefined62NestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined62NestedUpsertArchiveCreateInput>;
};

export type MetadataUserDefined62NestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.archive" relation. */
  update?: InputMaybe<MetadataUserDefined62NestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.archive" relation. */
  upsert?: InputMaybe<MetadataUserDefined62NestedUpsertArchiveUpdateInput>;
};

export type MetadataUserDefined62NestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined62NestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined62NestedUpsertMetadataCreateInput>;
};

export type MetadataUserDefined62NestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.metadata" relation. */
  update?: InputMaybe<MetadataUserDefined62NestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.metadata" relation. */
  upsert?: InputMaybe<MetadataUserDefined62NestedUpsertMetadataUpdateInput>;
};

export type MetadataUserDefined62NestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.photo" relation. */
  update?: InputMaybe<MetadataUserDefined62NestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataUserDefined62" node, through the "MetadataUserDefined62.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined62NestedUpsertPhotoCreateInput>;
};

export type MetadataUserDefined62NestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.photo" relation. */
  update?: InputMaybe<MetadataUserDefined62NestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataUserDefined62" node, through the "MetadataUserDefined62.photo" relation. */
  upsert?: InputMaybe<MetadataUserDefined62NestedUpsertPhotoUpdateInput>;
};

export type MetadataUserDefined62NestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataUserDefined62NestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataUserDefined62OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataUserDefined62UpdateInput = {
  /** Actions for the "MetadataUserDefined62.archive" relation */
  archive?: InputMaybe<MetadataUserDefined62NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined62.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined62NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined62.photo" relation */
  photo?: InputMaybe<MetadataUserDefined62NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataUserDefined62" nodes by specifying some conditions */
export type MetadataUserDefined62WhereInput = {
  AND?: InputMaybe<Array<MetadataUserDefined62WhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataUserDefined62WhereInput>;
  OR?: InputMaybe<Array<MetadataUserDefined62WhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataUserDefined62" node. */
export type MetadataUserDefined62WhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataUserDefined62WithForcedArchiveCreateInput = {
  /** Actions for the "MetadataUserDefined62.metadata" relation */
  metadata: MetadataUserDefined62NestedMetadataCreateInput;
  /** Actions for the "MetadataUserDefined62.photo" relation */
  photo: MetadataUserDefined62NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined62WithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataUserDefined62.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined62NestedMetadataUpdateInput>;
  /** Actions for the "MetadataUserDefined62.photo" relation */
  photo?: InputMaybe<MetadataUserDefined62NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined62WithForcedMetadataCreateInput = {
  /** Actions for the "MetadataUserDefined62.archive" relation */
  archive: MetadataUserDefined62NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined62.photo" relation */
  photo: MetadataUserDefined62NestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined62WithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataUserDefined62.archive" relation */
  archive?: InputMaybe<MetadataUserDefined62NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined62.photo" relation */
  photo?: InputMaybe<MetadataUserDefined62NestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined62WithForcedPhotoCreateInput = {
  /** Actions for the "MetadataUserDefined62.archive" relation */
  archive: MetadataUserDefined62NestedArchiveCreateInput;
  /** Actions for the "MetadataUserDefined62.metadata" relation */
  metadata: MetadataUserDefined62NestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataUserDefined62WithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataUserDefined62.archive" relation */
  archive?: InputMaybe<MetadataUserDefined62NestedArchiveUpdateInput>;
  /** Actions for the "MetadataUserDefined62.metadata" relation */
  metadata?: InputMaybe<MetadataUserDefined62NestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum MetadataValueTypeEnum {
  Date = 'Date',
  List = 'List',
  Text = 'Text'
}

/** Filters the "Metadata" nodes by specifying some conditions */
export type MetadataWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<MetadataWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_gt?: InputMaybe<Scalars['String']['input']>;
  label_gte?: InputMaybe<Scalars['String']['input']>;
  label_in?: InputMaybe<Array<Scalars['String']['input']>>;
  label_lt?: InputMaybe<Scalars['String']['input']>;
  label_lte?: InputMaybe<Scalars['String']['input']>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  legacyName?: InputMaybe<Scalars['String']['input']>;
  legacyName_contains?: InputMaybe<Scalars['String']['input']>;
  legacyName_ends_with?: InputMaybe<Scalars['String']['input']>;
  legacyName_gt?: InputMaybe<Scalars['String']['input']>;
  legacyName_gte?: InputMaybe<Scalars['String']['input']>;
  legacyName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legacyName_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  legacyName_lt?: InputMaybe<Scalars['String']['input']>;
  legacyName_lte?: InputMaybe<Scalars['String']['input']>;
  legacyName_not?: InputMaybe<Scalars['String']['input']>;
  legacyName_not_contains?: InputMaybe<Scalars['String']['input']>;
  legacyName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  legacyName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legacyName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  legacyName_starts_with?: InputMaybe<Scalars['String']['input']>;
  metadataAccessRightsList_some?: InputMaybe<MetadataAccessRightsWhereInput>;
  metadataAssetStateList_some?: InputMaybe<MetadataAssetStateWhereInput>;
  metadataBackupNameList_some?: InputMaybe<MetadataBackupNameWhereInput>;
  metadataBrandList_some?: InputMaybe<MetadataBrandWhereInput>;
  metadataBrandPrismaList_some?: InputMaybe<MetadataBrandPrismaWhereInput>;
  metadataBrandShortNameList_some?: InputMaybe<MetadataBrandShortNameWhereInput>;
  metadataByLineList_some?: InputMaybe<MetadataByLineWhereInput>;
  metadataCaptionAbstractList_some?: InputMaybe<MetadataCaptionAbstractWhereInput>;
  metadataCaptionList_some?: InputMaybe<MetadataCaptionWhereInput>;
  metadataCategoryList_some?: InputMaybe<MetadataCategoryWhereInput>;
  metadataCategoryPrismaList_some?: InputMaybe<MetadataCategoryPrismaWhereInput>;
  metadataCompanyList_some?: InputMaybe<MetadataCompanyWhereInput>;
  metadataCompanyShortNameList_some?: InputMaybe<MetadataCompanyShortNameWhereInput>;
  metadataCopyrightNoticeList_some?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
  metadataCreatorList_some?: InputMaybe<MetadataCreatorWhereInput>;
  metadataCreditList_some?: InputMaybe<MetadataCreditWhereInput>;
  metadataCustomField14List_some?: InputMaybe<MetadataCustomField14WhereInput>;
  metadataCustomField15List_some?: InputMaybe<MetadataCustomField15WhereInput>;
  metadataCustomField16List_some?: InputMaybe<MetadataCustomField16WhereInput>;
  metadataCustomField17List_some?: InputMaybe<MetadataCustomField17WhereInput>;
  metadataCustomField1List_some?: InputMaybe<MetadataCustomField1WhereInput>;
  metadataCustomField20List_some?: InputMaybe<MetadataCustomField20WhereInput>;
  metadataCustomField3List_some?: InputMaybe<MetadataCustomField3WhereInput>;
  metadataCustomField4List_some?: InputMaybe<MetadataCustomField4WhereInput>;
  metadataCustomField5List_some?: InputMaybe<MetadataCustomField5WhereInput>;
  metadataCustomField6List_some?: InputMaybe<MetadataCustomField6WhereInput>;
  metadataCustomField7List_some?: InputMaybe<MetadataCustomField7WhereInput>;
  metadataCustomField9List_some?: InputMaybe<MetadataCustomField9WhereInput>;
  metadataDateCreatedList_some?: InputMaybe<MetadataDateCreatedWhereInput>;
  metadataDateTimeOriginalList_some?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
  metadataDeliveryAccountList_some?: InputMaybe<MetadataDeliveryAccountWhereInput>;
  metadataDeliveryCompanyList_some?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
  metadataDeliveryCopyrightList_some?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
  metadataDeliveryDateFolderList_some?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
  metadataDeliveryDateTimeList_some?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
  metadataDeliveryDcCreatorList_some?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
  metadataDeliveryDcRightsList_some?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
  metadataDeliveryFolderList_some?: InputMaybe<MetadataDeliveryFolderWhereInput>;
  metadataDeliveryKindList_some?: InputMaybe<MetadataDeliveryKindWhereInput>;
  metadataDeliveryPathList_some?: InputMaybe<MetadataDeliveryPathWhereInput>;
  metadataDeliveryPhotoshopCreditList_some?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
  metadataDeliveryPhotoshopSourceList_some?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
  metadataDeliveryServiceList_some?: InputMaybe<MetadataDeliveryServiceWhereInput>;
  metadataDeliverySubjectList_some?: InputMaybe<MetadataDeliverySubjectWhereInput>;
  metadataDeliveryUnderSubjectList_some?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
  metadataDepartmentList_some?: InputMaybe<MetadataDepartmentWhereInput>;
  metadataDescriptionList_some?: InputMaybe<MetadataDescriptionWhereInput>;
  metadataEditionList_some?: InputMaybe<MetadataEditionWhereInput>;
  metadataEditStatusList_some?: InputMaybe<MetadataEditStatusWhereInput>;
  metadataFileStatusList_some?: InputMaybe<MetadataFileStatusWhereInput>;
  metadataFormatList_some?: InputMaybe<MetadataFormatWhereInput>;
  metadataHeaderList_some?: InputMaybe<MetadataHeaderWhereInput>;
  metadataHeaderPrismaList_some?: InputMaybe<MetadataHeaderPrismaWhereInput>;
  metadataHeadlineList_some?: InputMaybe<MetadataHeadlineWhereInput>;
  metadataIdAssignmentList_some?: InputMaybe<MetadataIdAssignmentWhereInput>;
  metadataIdPhotoPrismaList_some?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
  metadataIdSubjectList_some?: InputMaybe<MetadataIdSubjectWhereInput>;
  metadataImageNotesList_some?: InputMaybe<MetadataImageNotesWhereInput>;
  metadataInstructionsList_some?: InputMaybe<MetadataInstructionsWhereInput>;
  metadataIssueList_some?: InputMaybe<MetadataIssueWhereInput>;
  metadataKeywordsList_some?: InputMaybe<MetadataKeywordsWhereInput>;
  metadataObjectNameList_some?: InputMaybe<MetadataObjectNameWhereInput>;
  metadataOriginalNameList_some?: InputMaybe<MetadataOriginalNameWhereInput>;
  metadataPriceLevelList_some?: InputMaybe<MetadataPriceLevelWhereInput>;
  metadataProcessHistoryList_some?: InputMaybe<MetadataProcessHistoryWhereInput>;
  metadataProcessStatusList_some?: InputMaybe<MetadataProcessStatusWhereInput>;
  metadataProductList_some?: InputMaybe<MetadataProductWhereInput>;
  metadataProductsList_some?: InputMaybe<MetadataProductsWhereInput>;
  metadataPublishingSubjectList_some?: InputMaybe<MetadataPublishingSubjectWhereInput>;
  metadataResolutionKindList_some?: InputMaybe<MetadataResolutionKindWhereInput>;
  metadataRightsList_some?: InputMaybe<MetadataRightsWhereInput>;
  metadataSourceList_some?: InputMaybe<MetadataSourceWhereInput>;
  metadataSpecialInstructionsList_some?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
  metadataSubjectCodeList_some?: InputMaybe<MetadataSubjectCodeWhereInput>;
  metadataSubjectList_some?: InputMaybe<MetadataSubjectWhereInput>;
  metadataSubjectPrismaList_some?: InputMaybe<MetadataSubjectPrismaWhereInput>;
  metadataTitleList_some?: InputMaybe<MetadataTitleWhereInput>;
  metadataTransferredByFullNameList_some?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
  metadataTransferredByList_some?: InputMaybe<MetadataTransferredByWhereInput>;
  metadataTypeList_some?: InputMaybe<MetadataTypeWhereInput>;
  metadataUndersubjectList_some?: InputMaybe<MetadataUndersubjectWhereInput>;
  metadataUnderUnderSubjectList_some?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
  metadataUploadedByFullNameList_some?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
  metadataUploadedByList_some?: InputMaybe<MetadataUploadedByWhereInput>;
  metadataUploadTimeList_some?: InputMaybe<MetadataUploadTimeWhereInput>;
  metadataUrgencyList_some?: InputMaybe<MetadataUrgencyWhereInput>;
  metadataUserDefined195List_some?: InputMaybe<MetadataUserDefined195WhereInput>;
  metadataUserDefined237List_some?: InputMaybe<MetadataUserDefined237WhereInput>;
  metadataUserDefined238List_some?: InputMaybe<MetadataUserDefined238WhereInput>;
  metadataUserDefined239List_some?: InputMaybe<MetadataUserDefined239WhereInput>;
  metadataUserDefined242List_some?: InputMaybe<MetadataUserDefined242WhereInput>;
  metadataUserDefined62List_some?: InputMaybe<MetadataUserDefined62WhereInput>;
  metadataWorkflowKindList_some?: InputMaybe<MetadataWorkflowKindWhereInput>;
  metadataXmpHistoryList_some?: InputMaybe<MetadataXmpHistoryWhereInput>;
  name?: InputMaybe<MetadataNameEnumType>;
  name_in?: InputMaybe<Array<MetadataNameEnumType>>;
  name_not?: InputMaybe<MetadataNameEnumType>;
  name_not_in?: InputMaybe<Array<MetadataNameEnumType>>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  namespace_contains?: InputMaybe<Scalars['String']['input']>;
  namespace_ends_with?: InputMaybe<Scalars['String']['input']>;
  namespace_gt?: InputMaybe<Scalars['String']['input']>;
  namespace_gte?: InputMaybe<Scalars['String']['input']>;
  namespace_in?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace_lt?: InputMaybe<Scalars['String']['input']>;
  namespace_lte?: InputMaybe<Scalars['String']['input']>;
  namespace_not?: InputMaybe<Scalars['String']['input']>;
  namespace_not_contains?: InputMaybe<Scalars['String']['input']>;
  namespace_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  namespace_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  namespace_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<MetadataWhereInput>;
  OR?: InputMaybe<Array<MetadataWhereInput>>;
  photoMetadatas_some?: InputMaybe<PhotoMetadataWhereInput>;
  structName?: InputMaybe<Scalars['String']['input']>;
  structName_contains?: InputMaybe<Scalars['String']['input']>;
  structName_ends_with?: InputMaybe<Scalars['String']['input']>;
  structName_gt?: InputMaybe<Scalars['String']['input']>;
  structName_gte?: InputMaybe<Scalars['String']['input']>;
  structName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structName_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  structName_lt?: InputMaybe<Scalars['String']['input']>;
  structName_lte?: InputMaybe<Scalars['String']['input']>;
  structName_not?: InputMaybe<Scalars['String']['input']>;
  structName_not_contains?: InputMaybe<Scalars['String']['input']>;
  structName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  structName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  structName_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<MetadataValueTypeEnum>;
  type_in?: InputMaybe<Array<MetadataValueTypeEnum>>;
  type_not?: InputMaybe<MetadataValueTypeEnum>;
  type_not_in?: InputMaybe<Array<MetadataValueTypeEnum>>;
};

/**
 * Identifies exactly one "Metadata" node with one of these unique values:
 * - _id
 * - id
 * - name
 */
export type MetadataWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<MetadataNameEnumType>;
};

/** "MetadataWorkflowKind" resource's node */
export type MetadataWorkflowKind = {
  __typename?: 'MetadataWorkflowKind';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataWorkflowKindCreateInput = {
  /** Actions for the "MetadataWorkflowKind.archive" relation */
  archive: MetadataWorkflowKindNestedArchiveCreateInput;
  /** Actions for the "MetadataWorkflowKind.metadata" relation */
  metadata: MetadataWorkflowKindNestedMetadataCreateInput;
  /** Actions for the "MetadataWorkflowKind.photo" relation */
  photo: MetadataWorkflowKindNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataWorkflowKindNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.archive" relation. */
  update?: InputMaybe<MetadataWorkflowKindNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.archive" relation. */
  upsert?: InputMaybe<MetadataWorkflowKindNestedUpsertArchiveCreateInput>;
};

export type MetadataWorkflowKindNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.archive" relation. */
  update?: InputMaybe<MetadataWorkflowKindNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.archive" relation. */
  upsert?: InputMaybe<MetadataWorkflowKindNestedUpsertArchiveUpdateInput>;
};

export type MetadataWorkflowKindNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.metadata" relation. */
  update?: InputMaybe<MetadataWorkflowKindNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.metadata" relation. */
  upsert?: InputMaybe<MetadataWorkflowKindNestedUpsertMetadataCreateInput>;
};

export type MetadataWorkflowKindNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.metadata" relation. */
  update?: InputMaybe<MetadataWorkflowKindNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.metadata" relation. */
  upsert?: InputMaybe<MetadataWorkflowKindNestedUpsertMetadataUpdateInput>;
};

export type MetadataWorkflowKindNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.photo" relation. */
  update?: InputMaybe<MetadataWorkflowKindNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.photo" relation. */
  upsert?: InputMaybe<MetadataWorkflowKindNestedUpsertPhotoCreateInput>;
};

export type MetadataWorkflowKindNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.photo" relation. */
  update?: InputMaybe<MetadataWorkflowKindNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataWorkflowKind" node, through the "MetadataWorkflowKind.photo" relation. */
  upsert?: InputMaybe<MetadataWorkflowKindNestedUpsertPhotoUpdateInput>;
};

export type MetadataWorkflowKindNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataWorkflowKindNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataWorkflowKindOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataWorkflowKindUpdateInput = {
  /** Actions for the "MetadataWorkflowKind.archive" relation */
  archive?: InputMaybe<MetadataWorkflowKindNestedArchiveUpdateInput>;
  /** Actions for the "MetadataWorkflowKind.metadata" relation */
  metadata?: InputMaybe<MetadataWorkflowKindNestedMetadataUpdateInput>;
  /** Actions for the "MetadataWorkflowKind.photo" relation */
  photo?: InputMaybe<MetadataWorkflowKindNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataWorkflowKind" nodes by specifying some conditions */
export type MetadataWorkflowKindWhereInput = {
  AND?: InputMaybe<Array<MetadataWorkflowKindWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataWorkflowKindWhereInput>;
  OR?: InputMaybe<Array<MetadataWorkflowKindWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataWorkflowKind" node. */
export type MetadataWorkflowKindWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataWorkflowKindWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataWorkflowKind.metadata" relation */
  metadata: MetadataWorkflowKindNestedMetadataCreateInput;
  /** Actions for the "MetadataWorkflowKind.photo" relation */
  photo: MetadataWorkflowKindNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataWorkflowKindWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataWorkflowKind.metadata" relation */
  metadata?: InputMaybe<MetadataWorkflowKindNestedMetadataUpdateInput>;
  /** Actions for the "MetadataWorkflowKind.photo" relation */
  photo?: InputMaybe<MetadataWorkflowKindNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataWorkflowKindWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataWorkflowKind.archive" relation */
  archive: MetadataWorkflowKindNestedArchiveCreateInput;
  /** Actions for the "MetadataWorkflowKind.photo" relation */
  photo: MetadataWorkflowKindNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataWorkflowKindWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataWorkflowKind.archive" relation */
  archive?: InputMaybe<MetadataWorkflowKindNestedArchiveUpdateInput>;
  /** Actions for the "MetadataWorkflowKind.photo" relation */
  photo?: InputMaybe<MetadataWorkflowKindNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataWorkflowKindWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataWorkflowKind.archive" relation */
  archive: MetadataWorkflowKindNestedArchiveCreateInput;
  /** Actions for the "MetadataWorkflowKind.metadata" relation */
  metadata: MetadataWorkflowKindNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataWorkflowKindWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataWorkflowKind.archive" relation */
  archive?: InputMaybe<MetadataWorkflowKindNestedArchiveUpdateInput>;
  /** Actions for the "MetadataWorkflowKind.metadata" relation */
  metadata?: InputMaybe<MetadataWorkflowKindNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** "MetadataXmpHistory" resource's node */
export type MetadataXmpHistory = {
  __typename?: 'MetadataXmpHistory';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MetadataXmpHistoryCreateInput = {
  /** Actions for the "MetadataXmpHistory.archive" relation */
  archive: MetadataXmpHistoryNestedArchiveCreateInput;
  /** Actions for the "MetadataXmpHistory.metadata" relation */
  metadata: MetadataXmpHistoryNestedMetadataCreateInput;
  /** Actions for the "MetadataXmpHistory.photo" relation */
  photo: MetadataXmpHistoryNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataXmpHistoryNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.archive" relation. */
  update?: InputMaybe<MetadataXmpHistoryNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.archive" relation. */
  upsert?: InputMaybe<MetadataXmpHistoryNestedUpsertArchiveCreateInput>;
};

export type MetadataXmpHistoryNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.archive" relation. */
  update?: InputMaybe<MetadataXmpHistoryNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.archive" relation. */
  upsert?: InputMaybe<MetadataXmpHistoryNestedUpsertArchiveUpdateInput>;
};

export type MetadataXmpHistoryNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.metadata" relation. */
  update?: InputMaybe<MetadataXmpHistoryNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.metadata" relation. */
  upsert?: InputMaybe<MetadataXmpHistoryNestedUpsertMetadataCreateInput>;
};

export type MetadataXmpHistoryNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.metadata" relation. */
  update?: InputMaybe<MetadataXmpHistoryNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.metadata" relation. */
  upsert?: InputMaybe<MetadataXmpHistoryNestedUpsertMetadataUpdateInput>;
};

export type MetadataXmpHistoryNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.photo" relation. */
  update?: InputMaybe<MetadataXmpHistoryNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "MetadataXmpHistory" node, through the "MetadataXmpHistory.photo" relation. */
  upsert?: InputMaybe<MetadataXmpHistoryNestedUpsertPhotoCreateInput>;
};

export type MetadataXmpHistoryNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.photo" relation. */
  update?: InputMaybe<MetadataXmpHistoryNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "MetadataXmpHistory" node, through the "MetadataXmpHistory.photo" relation. */
  upsert?: InputMaybe<MetadataXmpHistoryNestedUpsertPhotoUpdateInput>;
};

export type MetadataXmpHistoryNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type MetadataXmpHistoryNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum MetadataXmpHistoryOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type MetadataXmpHistoryUpdateInput = {
  /** Actions for the "MetadataXmpHistory.archive" relation */
  archive?: InputMaybe<MetadataXmpHistoryNestedArchiveUpdateInput>;
  /** Actions for the "MetadataXmpHistory.metadata" relation */
  metadata?: InputMaybe<MetadataXmpHistoryNestedMetadataUpdateInput>;
  /** Actions for the "MetadataXmpHistory.photo" relation */
  photo?: InputMaybe<MetadataXmpHistoryNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "MetadataXmpHistory" nodes by specifying some conditions */
export type MetadataXmpHistoryWhereInput = {
  AND?: InputMaybe<Array<MetadataXmpHistoryWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<MetadataXmpHistoryWhereInput>;
  OR?: InputMaybe<Array<MetadataXmpHistoryWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "MetadataXmpHistory" node. */
export type MetadataXmpHistoryWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type MetadataXmpHistoryWithForcedArchiveCreateInput = {
  /** Actions for the "MetadataXmpHistory.metadata" relation */
  metadata: MetadataXmpHistoryNestedMetadataCreateInput;
  /** Actions for the "MetadataXmpHistory.photo" relation */
  photo: MetadataXmpHistoryNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataXmpHistoryWithForcedArchiveUpdateInput = {
  /** Actions for the "MetadataXmpHistory.metadata" relation */
  metadata?: InputMaybe<MetadataXmpHistoryNestedMetadataUpdateInput>;
  /** Actions for the "MetadataXmpHistory.photo" relation */
  photo?: InputMaybe<MetadataXmpHistoryNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataXmpHistoryWithForcedMetadataCreateInput = {
  /** Actions for the "MetadataXmpHistory.archive" relation */
  archive: MetadataXmpHistoryNestedArchiveCreateInput;
  /** Actions for the "MetadataXmpHistory.photo" relation */
  photo: MetadataXmpHistoryNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataXmpHistoryWithForcedMetadataUpdateInput = {
  /** Actions for the "MetadataXmpHistory.archive" relation */
  archive?: InputMaybe<MetadataXmpHistoryNestedArchiveUpdateInput>;
  /** Actions for the "MetadataXmpHistory.photo" relation */
  photo?: InputMaybe<MetadataXmpHistoryNestedPhotoUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataXmpHistoryWithForcedPhotoCreateInput = {
  /** Actions for the "MetadataXmpHistory.archive" relation */
  archive: MetadataXmpHistoryNestedArchiveCreateInput;
  /** Actions for the "MetadataXmpHistory.metadata" relation */
  metadata: MetadataXmpHistoryNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type MetadataXmpHistoryWithForcedPhotoUpdateInput = {
  /** Actions for the "MetadataXmpHistory.archive" relation */
  archive?: InputMaybe<MetadataXmpHistoryNestedArchiveUpdateInput>;
  /** Actions for the "MetadataXmpHistory.metadata" relation */
  metadata?: InputMaybe<MetadataXmpHistoryNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** clone a photo */
  clonePhoto: Photo;
  /** Create a single "Agency" node. */
  createAgency: Agency;
  /** Create a single "Archive" node. */
  createArchive: Archive;
  /** Create a single "ArchiveAgency" node. */
  createArchiveAgency: ArchiveAgency;
  /** Create a single "ArchivePurgeSetting" node. */
  createArchivePurgeSetting: ArchivePurgeSetting;
  /** Create a single "Category" node. */
  createCategory: Category;
  /** Create a single "DeliverySubject" node. */
  createDeliverySubject: DeliverySubject;
  /** Create a single "GcImportSetting" node. */
  createGcImportSetting: GcImportSetting;
  /** Create a single "ImportQueue" node. */
  createImportQueue: ImportQueue;
  /** Create a single "Metadata" node. */
  createMetadata: Metadata;
  /** Create a single "MetadataAccessRights" node. */
  createMetadataAccessRights: MetadataAccessRights;
  /** Create a single "MetadataAssetState" node. */
  createMetadataAssetState: MetadataAssetState;
  /** Create a single "MetadataBackupName" node. */
  createMetadataBackupName: MetadataBackupName;
  /** Create a single "MetadataBrand" node. */
  createMetadataBrand: MetadataBrand;
  /** Create a single "MetadataBrandPrisma" node. */
  createMetadataBrandPrisma: MetadataBrandPrisma;
  /** Create a single "MetadataBrandShortName" node. */
  createMetadataBrandShortName: MetadataBrandShortName;
  /** Create a single "MetadataByLine" node. */
  createMetadataByLine: MetadataByLine;
  /** Create a single "MetadataCaption" node. */
  createMetadataCaption: MetadataCaption;
  /** Create a single "MetadataCaptionAbstract" node. */
  createMetadataCaptionAbstract: MetadataCaptionAbstract;
  /** Create a single "MetadataCategory" node. */
  createMetadataCategory: MetadataCategory;
  /** Create a single "MetadataCategoryPrisma" node. */
  createMetadataCategoryPrisma: MetadataCategoryPrisma;
  /** Create a single "MetadataCompany" node. */
  createMetadataCompany: MetadataCompany;
  /** Create a single "MetadataCompanyShortName" node. */
  createMetadataCompanyShortName: MetadataCompanyShortName;
  /** Create a single "MetadataCopyrightNotice" node. */
  createMetadataCopyrightNotice: MetadataCopyrightNotice;
  /** Create a single "MetadataCreator" node. */
  createMetadataCreator: MetadataCreator;
  /** Create a single "MetadataCredit" node. */
  createMetadataCredit: MetadataCredit;
  /** Create a single "MetadataCustomField1" node. */
  createMetadataCustomField1: MetadataCustomField1;
  /** Create a single "MetadataCustomField14" node. */
  createMetadataCustomField14: MetadataCustomField14;
  /** Create a single "MetadataCustomField15" node. */
  createMetadataCustomField15: MetadataCustomField15;
  /** Create a single "MetadataCustomField16" node. */
  createMetadataCustomField16: MetadataCustomField16;
  /** Create a single "MetadataCustomField17" node. */
  createMetadataCustomField17: MetadataCustomField17;
  /** Create a single "MetadataCustomField20" node. */
  createMetadataCustomField20: MetadataCustomField20;
  /** Create a single "MetadataCustomField3" node. */
  createMetadataCustomField3: MetadataCustomField3;
  /** Create a single "MetadataCustomField4" node. */
  createMetadataCustomField4: MetadataCustomField4;
  /** Create a single "MetadataCustomField5" node. */
  createMetadataCustomField5: MetadataCustomField5;
  /** Create a single "MetadataCustomField6" node. */
  createMetadataCustomField6: MetadataCustomField6;
  /** Create a single "MetadataCustomField7" node. */
  createMetadataCustomField7: MetadataCustomField7;
  /** Create a single "MetadataCustomField9" node. */
  createMetadataCustomField9: MetadataCustomField9;
  /** Create a single "MetadataDateCreated" node. */
  createMetadataDateCreated: MetadataDateCreated;
  /** Create a single "MetadataDateTimeOriginal" node. */
  createMetadataDateTimeOriginal: MetadataDateTimeOriginal;
  /** Create a single "MetadataDeliveryAccount" node. */
  createMetadataDeliveryAccount: MetadataDeliveryAccount;
  /** Create a single "MetadataDeliveryCompany" node. */
  createMetadataDeliveryCompany: MetadataDeliveryCompany;
  /** Create a single "MetadataDeliveryCopyright" node. */
  createMetadataDeliveryCopyright: MetadataDeliveryCopyright;
  /** Create a single "MetadataDeliveryDateFolder" node. */
  createMetadataDeliveryDateFolder: MetadataDeliveryDateFolder;
  /** Create a single "MetadataDeliveryDateTime" node. */
  createMetadataDeliveryDateTime: MetadataDeliveryDateTime;
  /** Create a single "MetadataDeliveryDcCreator" node. */
  createMetadataDeliveryDcCreator: MetadataDeliveryDcCreator;
  /** Create a single "MetadataDeliveryDcRights" node. */
  createMetadataDeliveryDcRights: MetadataDeliveryDcRights;
  /** Create a single "MetadataDeliveryFolder" node. */
  createMetadataDeliveryFolder: MetadataDeliveryFolder;
  /** Create a single "MetadataDeliveryKind" node. */
  createMetadataDeliveryKind: MetadataDeliveryKind;
  /** Create a single "MetadataDeliveryPath" node. */
  createMetadataDeliveryPath: MetadataDeliveryPath;
  /** Create a single "MetadataDeliveryPhotoshopCredit" node. */
  createMetadataDeliveryPhotoshopCredit: MetadataDeliveryPhotoshopCredit;
  /** Create a single "MetadataDeliveryPhotoshopSource" node. */
  createMetadataDeliveryPhotoshopSource: MetadataDeliveryPhotoshopSource;
  /** Create a single "MetadataDeliveryService" node. */
  createMetadataDeliveryService: MetadataDeliveryService;
  /** Create a single "MetadataDeliverySubject" node. */
  createMetadataDeliverySubject: MetadataDeliverySubject;
  /** Create a single "MetadataDeliveryUnderSubject" node. */
  createMetadataDeliveryUnderSubject: MetadataDeliveryUnderSubject;
  /** Create a single "MetadataDepartment" node. */
  createMetadataDepartment: MetadataDepartment;
  /** Create a single "MetadataDescription" node. */
  createMetadataDescription: MetadataDescription;
  /** Create a single "MetadataEdition" node. */
  createMetadataEdition: MetadataEdition;
  /** Create a single "MetadataEditStatus" node. */
  createMetadataEditStatus: MetadataEditStatus;
  /** Create a single "MetadataFileStatus" node. */
  createMetadataFileStatus: MetadataFileStatus;
  /** Create a single "MetadataFormat" node. */
  createMetadataFormat: MetadataFormat;
  /** Create a single "MetadataHeader" node. */
  createMetadataHeader: MetadataHeader;
  /** Create a single "MetadataHeaderPrisma" node. */
  createMetadataHeaderPrisma: MetadataHeaderPrisma;
  /** Create a single "MetadataHeadline" node. */
  createMetadataHeadline: MetadataHeadline;
  /** Create a single "MetadataIdAssignment" node. */
  createMetadataIdAssignment: MetadataIdAssignment;
  /** Create a single "MetadataIdPhotoPrisma" node. */
  createMetadataIdPhotoPrisma: MetadataIdPhotoPrisma;
  /** Create a single "MetadataIdSubject" node. */
  createMetadataIdSubject: MetadataIdSubject;
  /** Create a single "MetadataImageNotes" node. */
  createMetadataImageNotes: MetadataImageNotes;
  /** Create a single "MetadataInstructions" node. */
  createMetadataInstructions: MetadataInstructions;
  /** Create a single "MetadataIssue" node. */
  createMetadataIssue: MetadataIssue;
  /** Create a single "MetadataKeywords" node. */
  createMetadataKeywords: MetadataKeywords;
  /** Create a single "MetadataObjectName" node. */
  createMetadataObjectName: MetadataObjectName;
  /** Create a single "MetadataOriginalName" node. */
  createMetadataOriginalName: MetadataOriginalName;
  /** Create a single "MetadataPriceLevel" node. */
  createMetadataPriceLevel: MetadataPriceLevel;
  /** Create a single "MetadataProcessHistory" node. */
  createMetadataProcessHistory: MetadataProcessHistory;
  /** Create a single "MetadataProcessStatus" node. */
  createMetadataProcessStatus: MetadataProcessStatus;
  /** Create a single "MetadataProduct" node. */
  createMetadataProduct: MetadataProduct;
  /** Create a single "MetadataProducts" node. */
  createMetadataProducts: MetadataProducts;
  /** Create a single "MetadataPublishingSubject" node. */
  createMetadataPublishingSubject: MetadataPublishingSubject;
  /** Create a single "MetadataResolutionKind" node. */
  createMetadataResolutionKind: MetadataResolutionKind;
  /** Create a single "MetadataRights" node. */
  createMetadataRights: MetadataRights;
  /** Create a single "MetadataSource" node. */
  createMetadataSource: MetadataSource;
  /** Create a single "MetadataSpecialInstructions" node. */
  createMetadataSpecialInstructions: MetadataSpecialInstructions;
  /** Create a single "MetadataSubject" node. */
  createMetadataSubject: MetadataSubject;
  /** Create a single "MetadataSubjectCode" node. */
  createMetadataSubjectCode: MetadataSubjectCode;
  /** Create a single "MetadataSubjectPrisma" node. */
  createMetadataSubjectPrisma: MetadataSubjectPrisma;
  /** Create a single "MetadataTitle" node. */
  createMetadataTitle: MetadataTitle;
  /** Create a single "MetadataTransferredBy" node. */
  createMetadataTransferredBy: MetadataTransferredBy;
  /** Create a single "MetadataTransferredByFullName" node. */
  createMetadataTransferredByFullName: MetadataTransferredByFullName;
  /** Create a single "MetadataType" node. */
  createMetadataType: MetadataType;
  /** Create a single "MetadataUndersubject" node. */
  createMetadataUndersubject: MetadataUndersubject;
  /** Create a single "MetadataUnderUnderSubject" node. */
  createMetadataUnderUnderSubject: MetadataUnderUnderSubject;
  /** Create a single "MetadataUploadedBy" node. */
  createMetadataUploadedBy: MetadataUploadedBy;
  /** Create a single "MetadataUploadedByFullName" node. */
  createMetadataUploadedByFullName: MetadataUploadedByFullName;
  /** Create a single "MetadataUploadTime" node. */
  createMetadataUploadTime: MetadataUploadTime;
  /** Create a single "MetadataUrgency" node. */
  createMetadataUrgency: MetadataUrgency;
  /** Create a single "MetadataUserDefined195" node. */
  createMetadataUserDefined195: MetadataUserDefined195;
  /** Create a single "MetadataUserDefined237" node. */
  createMetadataUserDefined237: MetadataUserDefined237;
  /** Create a single "MetadataUserDefined238" node. */
  createMetadataUserDefined238: MetadataUserDefined238;
  /** Create a single "MetadataUserDefined239" node. */
  createMetadataUserDefined239: MetadataUserDefined239;
  /** Create a single "MetadataUserDefined242" node. */
  createMetadataUserDefined242: MetadataUserDefined242;
  /** Create a single "MetadataUserDefined62" node. */
  createMetadataUserDefined62: MetadataUserDefined62;
  /** Create a single "MetadataWorkflowKind" node. */
  createMetadataWorkflowKind: MetadataWorkflowKind;
  /** Create a single "MetadataXmpHistory" node. */
  createMetadataXmpHistory: MetadataXmpHistory;
  /** Create a single "Photo" node. */
  createPhoto: Photo;
  /** Create a single "PhotoMetadata" node. */
  createPhotoMetadata: PhotoMetadata;
  /** Create a single "PhotoPublication" node. */
  createPhotoPublication: PhotoPublication;
  /** Delete a single "Agency" node. */
  deleteAgency?: Maybe<Agency>;
  /** Delete a single "Archive" node. */
  deleteArchive?: Maybe<Archive>;
  /** Delete a single "ArchiveAgency" node. */
  deleteArchiveAgency?: Maybe<ArchiveAgency>;
  /** Delete a single "ArchivePurgeSetting" node. */
  deleteArchivePurgeSetting?: Maybe<ArchivePurgeSetting>;
  /** Delete a single "Category" node. */
  deleteCategory?: Maybe<Category>;
  /** Delete a single "DeliverySubject" node. */
  deleteDeliverySubject?: Maybe<DeliverySubject>;
  /** Delete a single "GcImportSetting" node. */
  deleteGcImportSetting?: Maybe<GcImportSetting>;
  /** Delete a single "ImportQueue" node. */
  deleteImportQueue?: Maybe<ImportQueue>;
  /** Delete a single "Metadata" node. */
  deleteMetadata?: Maybe<Metadata>;
  /** Delete a single "MetadataAccessRights" node. */
  deleteMetadataAccessRights?: Maybe<MetadataAccessRights>;
  /** Delete a single "MetadataAssetState" node. */
  deleteMetadataAssetState?: Maybe<MetadataAssetState>;
  /** Delete a single "MetadataBackupName" node. */
  deleteMetadataBackupName?: Maybe<MetadataBackupName>;
  /** Delete a single "MetadataBrand" node. */
  deleteMetadataBrand?: Maybe<MetadataBrand>;
  /** Delete a single "MetadataBrandPrisma" node. */
  deleteMetadataBrandPrisma?: Maybe<MetadataBrandPrisma>;
  /** Delete a single "MetadataBrandShortName" node. */
  deleteMetadataBrandShortName?: Maybe<MetadataBrandShortName>;
  /** Delete a single "MetadataByLine" node. */
  deleteMetadataByLine?: Maybe<MetadataByLine>;
  /** Delete a single "MetadataCaption" node. */
  deleteMetadataCaption?: Maybe<MetadataCaption>;
  /** Delete a single "MetadataCaptionAbstract" node. */
  deleteMetadataCaptionAbstract?: Maybe<MetadataCaptionAbstract>;
  /** Delete a single "MetadataCategory" node. */
  deleteMetadataCategory?: Maybe<MetadataCategory>;
  /** Delete a single "MetadataCategoryPrisma" node. */
  deleteMetadataCategoryPrisma?: Maybe<MetadataCategoryPrisma>;
  /** Delete a single "MetadataCompany" node. */
  deleteMetadataCompany?: Maybe<MetadataCompany>;
  /** Delete a single "MetadataCompanyShortName" node. */
  deleteMetadataCompanyShortName?: Maybe<MetadataCompanyShortName>;
  /** Delete a single "MetadataCopyrightNotice" node. */
  deleteMetadataCopyrightNotice?: Maybe<MetadataCopyrightNotice>;
  /** Delete a single "MetadataCreator" node. */
  deleteMetadataCreator?: Maybe<MetadataCreator>;
  /** Delete a single "MetadataCredit" node. */
  deleteMetadataCredit?: Maybe<MetadataCredit>;
  /** Delete a single "MetadataCustomField1" node. */
  deleteMetadataCustomField1?: Maybe<MetadataCustomField1>;
  /** Delete a single "MetadataCustomField14" node. */
  deleteMetadataCustomField14?: Maybe<MetadataCustomField14>;
  /** Delete a single "MetadataCustomField15" node. */
  deleteMetadataCustomField15?: Maybe<MetadataCustomField15>;
  /** Delete a single "MetadataCustomField16" node. */
  deleteMetadataCustomField16?: Maybe<MetadataCustomField16>;
  /** Delete a single "MetadataCustomField17" node. */
  deleteMetadataCustomField17?: Maybe<MetadataCustomField17>;
  /** Delete a single "MetadataCustomField20" node. */
  deleteMetadataCustomField20?: Maybe<MetadataCustomField20>;
  /** Delete a single "MetadataCustomField3" node. */
  deleteMetadataCustomField3?: Maybe<MetadataCustomField3>;
  /** Delete a single "MetadataCustomField4" node. */
  deleteMetadataCustomField4?: Maybe<MetadataCustomField4>;
  /** Delete a single "MetadataCustomField5" node. */
  deleteMetadataCustomField5?: Maybe<MetadataCustomField5>;
  /** Delete a single "MetadataCustomField6" node. */
  deleteMetadataCustomField6?: Maybe<MetadataCustomField6>;
  /** Delete a single "MetadataCustomField7" node. */
  deleteMetadataCustomField7?: Maybe<MetadataCustomField7>;
  /** Delete a single "MetadataCustomField9" node. */
  deleteMetadataCustomField9?: Maybe<MetadataCustomField9>;
  /** Delete a single "MetadataDateCreated" node. */
  deleteMetadataDateCreated?: Maybe<MetadataDateCreated>;
  /** Delete a single "MetadataDateTimeOriginal" node. */
  deleteMetadataDateTimeOriginal?: Maybe<MetadataDateTimeOriginal>;
  /** Delete a single "MetadataDeliveryAccount" node. */
  deleteMetadataDeliveryAccount?: Maybe<MetadataDeliveryAccount>;
  /** Delete a single "MetadataDeliveryCompany" node. */
  deleteMetadataDeliveryCompany?: Maybe<MetadataDeliveryCompany>;
  /** Delete a single "MetadataDeliveryCopyright" node. */
  deleteMetadataDeliveryCopyright?: Maybe<MetadataDeliveryCopyright>;
  /** Delete a single "MetadataDeliveryDateFolder" node. */
  deleteMetadataDeliveryDateFolder?: Maybe<MetadataDeliveryDateFolder>;
  /** Delete a single "MetadataDeliveryDateTime" node. */
  deleteMetadataDeliveryDateTime?: Maybe<MetadataDeliveryDateTime>;
  /** Delete a single "MetadataDeliveryDcCreator" node. */
  deleteMetadataDeliveryDcCreator?: Maybe<MetadataDeliveryDcCreator>;
  /** Delete a single "MetadataDeliveryDcRights" node. */
  deleteMetadataDeliveryDcRights?: Maybe<MetadataDeliveryDcRights>;
  /** Delete a single "MetadataDeliveryFolder" node. */
  deleteMetadataDeliveryFolder?: Maybe<MetadataDeliveryFolder>;
  /** Delete a single "MetadataDeliveryKind" node. */
  deleteMetadataDeliveryKind?: Maybe<MetadataDeliveryKind>;
  /** Delete a single "MetadataDeliveryPath" node. */
  deleteMetadataDeliveryPath?: Maybe<MetadataDeliveryPath>;
  /** Delete a single "MetadataDeliveryPhotoshopCredit" node. */
  deleteMetadataDeliveryPhotoshopCredit?: Maybe<MetadataDeliveryPhotoshopCredit>;
  /** Delete a single "MetadataDeliveryPhotoshopSource" node. */
  deleteMetadataDeliveryPhotoshopSource?: Maybe<MetadataDeliveryPhotoshopSource>;
  /** Delete a single "MetadataDeliveryService" node. */
  deleteMetadataDeliveryService?: Maybe<MetadataDeliveryService>;
  /** Delete a single "MetadataDeliverySubject" node. */
  deleteMetadataDeliverySubject?: Maybe<MetadataDeliverySubject>;
  /** Delete a single "MetadataDeliveryUnderSubject" node. */
  deleteMetadataDeliveryUnderSubject?: Maybe<MetadataDeliveryUnderSubject>;
  /** Delete a single "MetadataDepartment" node. */
  deleteMetadataDepartment?: Maybe<MetadataDepartment>;
  /** Delete a single "MetadataDescription" node. */
  deleteMetadataDescription?: Maybe<MetadataDescription>;
  /** Delete a single "MetadataEdition" node. */
  deleteMetadataEdition?: Maybe<MetadataEdition>;
  /** Delete a single "MetadataEditStatus" node. */
  deleteMetadataEditStatus?: Maybe<MetadataEditStatus>;
  /** Delete a single "MetadataFileStatus" node. */
  deleteMetadataFileStatus?: Maybe<MetadataFileStatus>;
  /** Delete a single "MetadataFormat" node. */
  deleteMetadataFormat?: Maybe<MetadataFormat>;
  /** Delete a single "MetadataHeader" node. */
  deleteMetadataHeader?: Maybe<MetadataHeader>;
  /** Delete a single "MetadataHeaderPrisma" node. */
  deleteMetadataHeaderPrisma?: Maybe<MetadataHeaderPrisma>;
  /** Delete a single "MetadataHeadline" node. */
  deleteMetadataHeadline?: Maybe<MetadataHeadline>;
  /** Delete a single "MetadataIdAssignment" node. */
  deleteMetadataIdAssignment?: Maybe<MetadataIdAssignment>;
  /** Delete a single "MetadataIdPhotoPrisma" node. */
  deleteMetadataIdPhotoPrisma?: Maybe<MetadataIdPhotoPrisma>;
  /** Delete a single "MetadataIdSubject" node. */
  deleteMetadataIdSubject?: Maybe<MetadataIdSubject>;
  /** Delete a single "MetadataImageNotes" node. */
  deleteMetadataImageNotes?: Maybe<MetadataImageNotes>;
  /** Delete a single "MetadataInstructions" node. */
  deleteMetadataInstructions?: Maybe<MetadataInstructions>;
  /** Delete a single "MetadataIssue" node. */
  deleteMetadataIssue?: Maybe<MetadataIssue>;
  /** Delete a single "MetadataKeywords" node. */
  deleteMetadataKeywords?: Maybe<MetadataKeywords>;
  /** Delete a single "MetadataObjectName" node. */
  deleteMetadataObjectName?: Maybe<MetadataObjectName>;
  /** Delete a single "MetadataOriginalName" node. */
  deleteMetadataOriginalName?: Maybe<MetadataOriginalName>;
  /** Delete a single "MetadataPriceLevel" node. */
  deleteMetadataPriceLevel?: Maybe<MetadataPriceLevel>;
  /** Delete a single "MetadataProcessHistory" node. */
  deleteMetadataProcessHistory?: Maybe<MetadataProcessHistory>;
  /** Delete a single "MetadataProcessStatus" node. */
  deleteMetadataProcessStatus?: Maybe<MetadataProcessStatus>;
  /** Delete a single "MetadataProduct" node. */
  deleteMetadataProduct?: Maybe<MetadataProduct>;
  /** Delete a single "MetadataProducts" node. */
  deleteMetadataProducts?: Maybe<MetadataProducts>;
  /** Delete a single "MetadataPublishingSubject" node. */
  deleteMetadataPublishingSubject?: Maybe<MetadataPublishingSubject>;
  /** Delete a single "MetadataResolutionKind" node. */
  deleteMetadataResolutionKind?: Maybe<MetadataResolutionKind>;
  /** Delete a single "MetadataRights" node. */
  deleteMetadataRights?: Maybe<MetadataRights>;
  /** Delete a single "MetadataSource" node. */
  deleteMetadataSource?: Maybe<MetadataSource>;
  /** Delete a single "MetadataSpecialInstructions" node. */
  deleteMetadataSpecialInstructions?: Maybe<MetadataSpecialInstructions>;
  /** Delete a single "MetadataSubject" node. */
  deleteMetadataSubject?: Maybe<MetadataSubject>;
  /** Delete a single "MetadataSubjectCode" node. */
  deleteMetadataSubjectCode?: Maybe<MetadataSubjectCode>;
  /** Delete a single "MetadataSubjectPrisma" node. */
  deleteMetadataSubjectPrisma?: Maybe<MetadataSubjectPrisma>;
  /** Delete a single "MetadataTitle" node. */
  deleteMetadataTitle?: Maybe<MetadataTitle>;
  /** Delete a single "MetadataTransferredBy" node. */
  deleteMetadataTransferredBy?: Maybe<MetadataTransferredBy>;
  /** Delete a single "MetadataTransferredByFullName" node. */
  deleteMetadataTransferredByFullName?: Maybe<MetadataTransferredByFullName>;
  /** Delete a single "MetadataType" node. */
  deleteMetadataType?: Maybe<MetadataType>;
  /** Delete a single "MetadataUndersubject" node. */
  deleteMetadataUndersubject?: Maybe<MetadataUndersubject>;
  /** Delete a single "MetadataUnderUnderSubject" node. */
  deleteMetadataUnderUnderSubject?: Maybe<MetadataUnderUnderSubject>;
  /** Delete a single "MetadataUploadedBy" node. */
  deleteMetadataUploadedBy?: Maybe<MetadataUploadedBy>;
  /** Delete a single "MetadataUploadedByFullName" node. */
  deleteMetadataUploadedByFullName?: Maybe<MetadataUploadedByFullName>;
  /** Delete a single "MetadataUploadTime" node. */
  deleteMetadataUploadTime?: Maybe<MetadataUploadTime>;
  /** Delete a single "MetadataUrgency" node. */
  deleteMetadataUrgency?: Maybe<MetadataUrgency>;
  /** Delete a single "MetadataUserDefined195" node. */
  deleteMetadataUserDefined195?: Maybe<MetadataUserDefined195>;
  /** Delete a single "MetadataUserDefined237" node. */
  deleteMetadataUserDefined237?: Maybe<MetadataUserDefined237>;
  /** Delete a single "MetadataUserDefined238" node. */
  deleteMetadataUserDefined238?: Maybe<MetadataUserDefined238>;
  /** Delete a single "MetadataUserDefined239" node. */
  deleteMetadataUserDefined239?: Maybe<MetadataUserDefined239>;
  /** Delete a single "MetadataUserDefined242" node. */
  deleteMetadataUserDefined242?: Maybe<MetadataUserDefined242>;
  /** Delete a single "MetadataUserDefined62" node. */
  deleteMetadataUserDefined62?: Maybe<MetadataUserDefined62>;
  /** Delete a single "MetadataWorkflowKind" node. */
  deleteMetadataWorkflowKind?: Maybe<MetadataWorkflowKind>;
  /** Delete a single "MetadataXmpHistory" node. */
  deleteMetadataXmpHistory?: Maybe<MetadataXmpHistory>;
  /** Delete a single "Photo" node. */
  deletePhoto?: Maybe<Photo>;
  /** Delete a single "PhotoMetadata" node. */
  deletePhotoMetadata?: Maybe<PhotoMetadata>;
  /** Delete a single "PhotoPublication" node. */
  deletePhotoPublication?: Maybe<PhotoPublication>;
  /** Update a single "Agency" node. */
  updateAgency?: Maybe<Agency>;
  /** Update a single "Archive" node. */
  updateArchive?: Maybe<Archive>;
  /** Update a single "ArchiveAgency" node. */
  updateArchiveAgency?: Maybe<ArchiveAgency>;
  /** Update a single "ArchivePurgeSetting" node. */
  updateArchivePurgeSetting?: Maybe<ArchivePurgeSetting>;
  /** Update a single "Category" node. */
  updateCategory?: Maybe<Category>;
  /** Update a single "DeliverySubject" node. */
  updateDeliverySubject?: Maybe<DeliverySubject>;
  /** Update a single "GcImportSetting" node. */
  updateGcImportSetting?: Maybe<GcImportSetting>;
  /** Update a single "ImportQueue" node. */
  updateImportQueue?: Maybe<ImportQueue>;
  /** Update a single "Metadata" node. */
  updateMetadata?: Maybe<Metadata>;
  /** Update a single "MetadataAccessRights" node. */
  updateMetadataAccessRights?: Maybe<MetadataAccessRights>;
  /** Update a single "MetadataAssetState" node. */
  updateMetadataAssetState?: Maybe<MetadataAssetState>;
  /** Update a single "MetadataBackupName" node. */
  updateMetadataBackupName?: Maybe<MetadataBackupName>;
  /** Update a single "MetadataBrand" node. */
  updateMetadataBrand?: Maybe<MetadataBrand>;
  /** Update a single "MetadataBrandPrisma" node. */
  updateMetadataBrandPrisma?: Maybe<MetadataBrandPrisma>;
  /** Update a single "MetadataBrandShortName" node. */
  updateMetadataBrandShortName?: Maybe<MetadataBrandShortName>;
  /** Update a single "MetadataByLine" node. */
  updateMetadataByLine?: Maybe<MetadataByLine>;
  /** Update a single "MetadataCaption" node. */
  updateMetadataCaption?: Maybe<MetadataCaption>;
  /** Update a single "MetadataCaptionAbstract" node. */
  updateMetadataCaptionAbstract?: Maybe<MetadataCaptionAbstract>;
  /** Update a single "MetadataCategory" node. */
  updateMetadataCategory?: Maybe<MetadataCategory>;
  /** Update a single "MetadataCategoryPrisma" node. */
  updateMetadataCategoryPrisma?: Maybe<MetadataCategoryPrisma>;
  /** Update a single "MetadataCompany" node. */
  updateMetadataCompany?: Maybe<MetadataCompany>;
  /** Update a single "MetadataCompanyShortName" node. */
  updateMetadataCompanyShortName?: Maybe<MetadataCompanyShortName>;
  /** Update a single "MetadataCopyrightNotice" node. */
  updateMetadataCopyrightNotice?: Maybe<MetadataCopyrightNotice>;
  /** Update a single "MetadataCreator" node. */
  updateMetadataCreator?: Maybe<MetadataCreator>;
  /** Update a single "MetadataCredit" node. */
  updateMetadataCredit?: Maybe<MetadataCredit>;
  /** Update a single "MetadataCustomField1" node. */
  updateMetadataCustomField1?: Maybe<MetadataCustomField1>;
  /** Update a single "MetadataCustomField14" node. */
  updateMetadataCustomField14?: Maybe<MetadataCustomField14>;
  /** Update a single "MetadataCustomField15" node. */
  updateMetadataCustomField15?: Maybe<MetadataCustomField15>;
  /** Update a single "MetadataCustomField16" node. */
  updateMetadataCustomField16?: Maybe<MetadataCustomField16>;
  /** Update a single "MetadataCustomField17" node. */
  updateMetadataCustomField17?: Maybe<MetadataCustomField17>;
  /** Update a single "MetadataCustomField20" node. */
  updateMetadataCustomField20?: Maybe<MetadataCustomField20>;
  /** Update a single "MetadataCustomField3" node. */
  updateMetadataCustomField3?: Maybe<MetadataCustomField3>;
  /** Update a single "MetadataCustomField4" node. */
  updateMetadataCustomField4?: Maybe<MetadataCustomField4>;
  /** Update a single "MetadataCustomField5" node. */
  updateMetadataCustomField5?: Maybe<MetadataCustomField5>;
  /** Update a single "MetadataCustomField6" node. */
  updateMetadataCustomField6?: Maybe<MetadataCustomField6>;
  /** Update a single "MetadataCustomField7" node. */
  updateMetadataCustomField7?: Maybe<MetadataCustomField7>;
  /** Update a single "MetadataCustomField9" node. */
  updateMetadataCustomField9?: Maybe<MetadataCustomField9>;
  /** Update a single "MetadataDateCreated" node. */
  updateMetadataDateCreated?: Maybe<MetadataDateCreated>;
  /** Update a single "MetadataDateTimeOriginal" node. */
  updateMetadataDateTimeOriginal?: Maybe<MetadataDateTimeOriginal>;
  /** Update a single "MetadataDeliveryAccount" node. */
  updateMetadataDeliveryAccount?: Maybe<MetadataDeliveryAccount>;
  /** Update a single "MetadataDeliveryCompany" node. */
  updateMetadataDeliveryCompany?: Maybe<MetadataDeliveryCompany>;
  /** Update a single "MetadataDeliveryCopyright" node. */
  updateMetadataDeliveryCopyright?: Maybe<MetadataDeliveryCopyright>;
  /** Update a single "MetadataDeliveryDateFolder" node. */
  updateMetadataDeliveryDateFolder?: Maybe<MetadataDeliveryDateFolder>;
  /** Update a single "MetadataDeliveryDateTime" node. */
  updateMetadataDeliveryDateTime?: Maybe<MetadataDeliveryDateTime>;
  /** Update a single "MetadataDeliveryDcCreator" node. */
  updateMetadataDeliveryDcCreator?: Maybe<MetadataDeliveryDcCreator>;
  /** Update a single "MetadataDeliveryDcRights" node. */
  updateMetadataDeliveryDcRights?: Maybe<MetadataDeliveryDcRights>;
  /** Update a single "MetadataDeliveryFolder" node. */
  updateMetadataDeliveryFolder?: Maybe<MetadataDeliveryFolder>;
  /** Update a single "MetadataDeliveryKind" node. */
  updateMetadataDeliveryKind?: Maybe<MetadataDeliveryKind>;
  /** Update a single "MetadataDeliveryPath" node. */
  updateMetadataDeliveryPath?: Maybe<MetadataDeliveryPath>;
  /** Update a single "MetadataDeliveryPhotoshopCredit" node. */
  updateMetadataDeliveryPhotoshopCredit?: Maybe<MetadataDeliveryPhotoshopCredit>;
  /** Update a single "MetadataDeliveryPhotoshopSource" node. */
  updateMetadataDeliveryPhotoshopSource?: Maybe<MetadataDeliveryPhotoshopSource>;
  /** Update a single "MetadataDeliveryService" node. */
  updateMetadataDeliveryService?: Maybe<MetadataDeliveryService>;
  /** Update a single "MetadataDeliverySubject" node. */
  updateMetadataDeliverySubject?: Maybe<MetadataDeliverySubject>;
  /** Update a single "MetadataDeliveryUnderSubject" node. */
  updateMetadataDeliveryUnderSubject?: Maybe<MetadataDeliveryUnderSubject>;
  /** Update a single "MetadataDepartment" node. */
  updateMetadataDepartment?: Maybe<MetadataDepartment>;
  /** Update a single "MetadataDescription" node. */
  updateMetadataDescription?: Maybe<MetadataDescription>;
  /** Update a single "MetadataEdition" node. */
  updateMetadataEdition?: Maybe<MetadataEdition>;
  /** Update a single "MetadataEditStatus" node. */
  updateMetadataEditStatus?: Maybe<MetadataEditStatus>;
  /** Update a single "MetadataFileStatus" node. */
  updateMetadataFileStatus?: Maybe<MetadataFileStatus>;
  /** Update a single "MetadataFormat" node. */
  updateMetadataFormat?: Maybe<MetadataFormat>;
  /** Update a single "MetadataHeader" node. */
  updateMetadataHeader?: Maybe<MetadataHeader>;
  /** Update a single "MetadataHeaderPrisma" node. */
  updateMetadataHeaderPrisma?: Maybe<MetadataHeaderPrisma>;
  /** Update a single "MetadataHeadline" node. */
  updateMetadataHeadline?: Maybe<MetadataHeadline>;
  /** Update a single "MetadataIdAssignment" node. */
  updateMetadataIdAssignment?: Maybe<MetadataIdAssignment>;
  /** Update a single "MetadataIdPhotoPrisma" node. */
  updateMetadataIdPhotoPrisma?: Maybe<MetadataIdPhotoPrisma>;
  /** Update a single "MetadataIdSubject" node. */
  updateMetadataIdSubject?: Maybe<MetadataIdSubject>;
  /** Update a single "MetadataImageNotes" node. */
  updateMetadataImageNotes?: Maybe<MetadataImageNotes>;
  /** Update a single "MetadataInstructions" node. */
  updateMetadataInstructions?: Maybe<MetadataInstructions>;
  /** Update a single "MetadataIssue" node. */
  updateMetadataIssue?: Maybe<MetadataIssue>;
  /** Update a single "MetadataKeywords" node. */
  updateMetadataKeywords?: Maybe<MetadataKeywords>;
  /** Update a single "MetadataObjectName" node. */
  updateMetadataObjectName?: Maybe<MetadataObjectName>;
  /** Update a single "MetadataOriginalName" node. */
  updateMetadataOriginalName?: Maybe<MetadataOriginalName>;
  /** Update a single "MetadataPriceLevel" node. */
  updateMetadataPriceLevel?: Maybe<MetadataPriceLevel>;
  /** Update a single "MetadataProcessHistory" node. */
  updateMetadataProcessHistory?: Maybe<MetadataProcessHistory>;
  /** Update a single "MetadataProcessStatus" node. */
  updateMetadataProcessStatus?: Maybe<MetadataProcessStatus>;
  /** Update a single "MetadataProduct" node. */
  updateMetadataProduct?: Maybe<MetadataProduct>;
  /** Update a single "MetadataProducts" node. */
  updateMetadataProducts?: Maybe<MetadataProducts>;
  /** Update a single "MetadataPublishingSubject" node. */
  updateMetadataPublishingSubject?: Maybe<MetadataPublishingSubject>;
  /** Update a single "MetadataResolutionKind" node. */
  updateMetadataResolutionKind?: Maybe<MetadataResolutionKind>;
  /** Update a single "MetadataRights" node. */
  updateMetadataRights?: Maybe<MetadataRights>;
  /** Update a single "MetadataSource" node. */
  updateMetadataSource?: Maybe<MetadataSource>;
  /** Update a single "MetadataSpecialInstructions" node. */
  updateMetadataSpecialInstructions?: Maybe<MetadataSpecialInstructions>;
  /** Update a single "MetadataSubject" node. */
  updateMetadataSubject?: Maybe<MetadataSubject>;
  /** Update a single "MetadataSubjectCode" node. */
  updateMetadataSubjectCode?: Maybe<MetadataSubjectCode>;
  /** Update a single "MetadataSubjectPrisma" node. */
  updateMetadataSubjectPrisma?: Maybe<MetadataSubjectPrisma>;
  /** Update a single "MetadataTitle" node. */
  updateMetadataTitle?: Maybe<MetadataTitle>;
  /** Update a single "MetadataTransferredBy" node. */
  updateMetadataTransferredBy?: Maybe<MetadataTransferredBy>;
  /** Update a single "MetadataTransferredByFullName" node. */
  updateMetadataTransferredByFullName?: Maybe<MetadataTransferredByFullName>;
  /** Update a single "MetadataType" node. */
  updateMetadataType?: Maybe<MetadataType>;
  /** Update a single "MetadataUndersubject" node. */
  updateMetadataUndersubject?: Maybe<MetadataUndersubject>;
  /** Update a single "MetadataUnderUnderSubject" node. */
  updateMetadataUnderUnderSubject?: Maybe<MetadataUnderUnderSubject>;
  /** Update a single "MetadataUploadedBy" node. */
  updateMetadataUploadedBy?: Maybe<MetadataUploadedBy>;
  /** Update a single "MetadataUploadedByFullName" node. */
  updateMetadataUploadedByFullName?: Maybe<MetadataUploadedByFullName>;
  /** Update a single "MetadataUploadTime" node. */
  updateMetadataUploadTime?: Maybe<MetadataUploadTime>;
  /** Update a single "MetadataUrgency" node. */
  updateMetadataUrgency?: Maybe<MetadataUrgency>;
  /** Update a single "MetadataUserDefined195" node. */
  updateMetadataUserDefined195?: Maybe<MetadataUserDefined195>;
  /** Update a single "MetadataUserDefined237" node. */
  updateMetadataUserDefined237?: Maybe<MetadataUserDefined237>;
  /** Update a single "MetadataUserDefined238" node. */
  updateMetadataUserDefined238?: Maybe<MetadataUserDefined238>;
  /** Update a single "MetadataUserDefined239" node. */
  updateMetadataUserDefined239?: Maybe<MetadataUserDefined239>;
  /** Update a single "MetadataUserDefined242" node. */
  updateMetadataUserDefined242?: Maybe<MetadataUserDefined242>;
  /** Update a single "MetadataUserDefined62" node. */
  updateMetadataUserDefined62?: Maybe<MetadataUserDefined62>;
  /** Update a single "MetadataWorkflowKind" node. */
  updateMetadataWorkflowKind?: Maybe<MetadataWorkflowKind>;
  /** Update a single "MetadataXmpHistory" node. */
  updateMetadataXmpHistory?: Maybe<MetadataXmpHistory>;
  /** Update a single "Photo" node. */
  updatePhoto?: Maybe<Photo>;
  /** Update files metadatas */
  updatePhotoFile?: Maybe<Photo>;
  /** Update a single "PhotoMetadata" node. */
  updatePhotoMetadata?: Maybe<PhotoMetadata>;
  /** Update a single "PhotoPublication" node. */
  updatePhotoPublication?: Maybe<PhotoPublication>;
  /** Update or create a single "Agency" node. */
  upsertAgency: Agency;
  /** Update or create a single "Archive" node. */
  upsertArchive: Archive;
  /** Update or create a single "ArchiveAgency" node. */
  upsertArchiveAgency: ArchiveAgency;
  /** Update or create a single "ArchivePurgeSetting" node. */
  upsertArchivePurgeSetting: ArchivePurgeSetting;
  /** Update or create a single "Category" node. */
  upsertCategory: Category;
  /** Update or create a single "DeliverySubject" node. */
  upsertDeliverySubject: DeliverySubject;
  /** Update or create a single "GcImportSetting" node. */
  upsertGcImportSetting: GcImportSetting;
  /** Update or create a single "ImportQueue" node. */
  upsertImportQueue: ImportQueue;
  /** Update or create a single "Metadata" node. */
  upsertMetadata: Metadata;
  /** Update or create a single "MetadataAccessRights" node. */
  upsertMetadataAccessRights: MetadataAccessRights;
  /** Update or create a single "MetadataAssetState" node. */
  upsertMetadataAssetState: MetadataAssetState;
  /** Update or create a single "MetadataBackupName" node. */
  upsertMetadataBackupName: MetadataBackupName;
  /** Update or create a single "MetadataBrand" node. */
  upsertMetadataBrand: MetadataBrand;
  /** Update or create a single "MetadataBrandPrisma" node. */
  upsertMetadataBrandPrisma: MetadataBrandPrisma;
  /** Update or create a single "MetadataBrandShortName" node. */
  upsertMetadataBrandShortName: MetadataBrandShortName;
  /** Update or create a single "MetadataByLine" node. */
  upsertMetadataByLine: MetadataByLine;
  /** Update or create a single "MetadataCaption" node. */
  upsertMetadataCaption: MetadataCaption;
  /** Update or create a single "MetadataCaptionAbstract" node. */
  upsertMetadataCaptionAbstract: MetadataCaptionAbstract;
  /** Update or create a single "MetadataCategory" node. */
  upsertMetadataCategory: MetadataCategory;
  /** Update or create a single "MetadataCategoryPrisma" node. */
  upsertMetadataCategoryPrisma: MetadataCategoryPrisma;
  /** Update or create a single "MetadataCompany" node. */
  upsertMetadataCompany: MetadataCompany;
  /** Update or create a single "MetadataCompanyShortName" node. */
  upsertMetadataCompanyShortName: MetadataCompanyShortName;
  /** Update or create a single "MetadataCopyrightNotice" node. */
  upsertMetadataCopyrightNotice: MetadataCopyrightNotice;
  /** Update or create a single "MetadataCreator" node. */
  upsertMetadataCreator: MetadataCreator;
  /** Update or create a single "MetadataCredit" node. */
  upsertMetadataCredit: MetadataCredit;
  /** Update or create a single "MetadataCustomField1" node. */
  upsertMetadataCustomField1: MetadataCustomField1;
  /** Update or create a single "MetadataCustomField14" node. */
  upsertMetadataCustomField14: MetadataCustomField14;
  /** Update or create a single "MetadataCustomField15" node. */
  upsertMetadataCustomField15: MetadataCustomField15;
  /** Update or create a single "MetadataCustomField16" node. */
  upsertMetadataCustomField16: MetadataCustomField16;
  /** Update or create a single "MetadataCustomField17" node. */
  upsertMetadataCustomField17: MetadataCustomField17;
  /** Update or create a single "MetadataCustomField20" node. */
  upsertMetadataCustomField20: MetadataCustomField20;
  /** Update or create a single "MetadataCustomField3" node. */
  upsertMetadataCustomField3: MetadataCustomField3;
  /** Update or create a single "MetadataCustomField4" node. */
  upsertMetadataCustomField4: MetadataCustomField4;
  /** Update or create a single "MetadataCustomField5" node. */
  upsertMetadataCustomField5: MetadataCustomField5;
  /** Update or create a single "MetadataCustomField6" node. */
  upsertMetadataCustomField6: MetadataCustomField6;
  /** Update or create a single "MetadataCustomField7" node. */
  upsertMetadataCustomField7: MetadataCustomField7;
  /** Update or create a single "MetadataCustomField9" node. */
  upsertMetadataCustomField9: MetadataCustomField9;
  /** Update or create a single "MetadataDateCreated" node. */
  upsertMetadataDateCreated: MetadataDateCreated;
  /** Update or create a single "MetadataDateTimeOriginal" node. */
  upsertMetadataDateTimeOriginal: MetadataDateTimeOriginal;
  /** Update or create a single "MetadataDeliveryAccount" node. */
  upsertMetadataDeliveryAccount: MetadataDeliveryAccount;
  /** Update or create a single "MetadataDeliveryCompany" node. */
  upsertMetadataDeliveryCompany: MetadataDeliveryCompany;
  /** Update or create a single "MetadataDeliveryCopyright" node. */
  upsertMetadataDeliveryCopyright: MetadataDeliveryCopyright;
  /** Update or create a single "MetadataDeliveryDateFolder" node. */
  upsertMetadataDeliveryDateFolder: MetadataDeliveryDateFolder;
  /** Update or create a single "MetadataDeliveryDateTime" node. */
  upsertMetadataDeliveryDateTime: MetadataDeliveryDateTime;
  /** Update or create a single "MetadataDeliveryDcCreator" node. */
  upsertMetadataDeliveryDcCreator: MetadataDeliveryDcCreator;
  /** Update or create a single "MetadataDeliveryDcRights" node. */
  upsertMetadataDeliveryDcRights: MetadataDeliveryDcRights;
  /** Update or create a single "MetadataDeliveryFolder" node. */
  upsertMetadataDeliveryFolder: MetadataDeliveryFolder;
  /** Update or create a single "MetadataDeliveryKind" node. */
  upsertMetadataDeliveryKind: MetadataDeliveryKind;
  /** Update or create a single "MetadataDeliveryPath" node. */
  upsertMetadataDeliveryPath: MetadataDeliveryPath;
  /** Update or create a single "MetadataDeliveryPhotoshopCredit" node. */
  upsertMetadataDeliveryPhotoshopCredit: MetadataDeliveryPhotoshopCredit;
  /** Update or create a single "MetadataDeliveryPhotoshopSource" node. */
  upsertMetadataDeliveryPhotoshopSource: MetadataDeliveryPhotoshopSource;
  /** Update or create a single "MetadataDeliveryService" node. */
  upsertMetadataDeliveryService: MetadataDeliveryService;
  /** Update or create a single "MetadataDeliverySubject" node. */
  upsertMetadataDeliverySubject: MetadataDeliverySubject;
  /** Update or create a single "MetadataDeliveryUnderSubject" node. */
  upsertMetadataDeliveryUnderSubject: MetadataDeliveryUnderSubject;
  /** Update or create a single "MetadataDepartment" node. */
  upsertMetadataDepartment: MetadataDepartment;
  /** Update or create a single "MetadataDescription" node. */
  upsertMetadataDescription: MetadataDescription;
  /** Update or create a single "MetadataEdition" node. */
  upsertMetadataEdition: MetadataEdition;
  /** Update or create a single "MetadataEditStatus" node. */
  upsertMetadataEditStatus: MetadataEditStatus;
  /** Update or create a single "MetadataFileStatus" node. */
  upsertMetadataFileStatus: MetadataFileStatus;
  /** Update or create a single "MetadataFormat" node. */
  upsertMetadataFormat: MetadataFormat;
  /** Update or create a single "MetadataHeader" node. */
  upsertMetadataHeader: MetadataHeader;
  /** Update or create a single "MetadataHeaderPrisma" node. */
  upsertMetadataHeaderPrisma: MetadataHeaderPrisma;
  /** Update or create a single "MetadataHeadline" node. */
  upsertMetadataHeadline: MetadataHeadline;
  /** Update or create a single "MetadataIdAssignment" node. */
  upsertMetadataIdAssignment: MetadataIdAssignment;
  /** Update or create a single "MetadataIdPhotoPrisma" node. */
  upsertMetadataIdPhotoPrisma: MetadataIdPhotoPrisma;
  /** Update or create a single "MetadataIdSubject" node. */
  upsertMetadataIdSubject: MetadataIdSubject;
  /** Update or create a single "MetadataImageNotes" node. */
  upsertMetadataImageNotes: MetadataImageNotes;
  /** Update or create a single "MetadataInstructions" node. */
  upsertMetadataInstructions: MetadataInstructions;
  /** Update or create a single "MetadataIssue" node. */
  upsertMetadataIssue: MetadataIssue;
  /** Update or create a single "MetadataKeywords" node. */
  upsertMetadataKeywords: MetadataKeywords;
  /** Update or create a single "MetadataObjectName" node. */
  upsertMetadataObjectName: MetadataObjectName;
  /** Update or create a single "MetadataOriginalName" node. */
  upsertMetadataOriginalName: MetadataOriginalName;
  /** Update or create a single "MetadataPriceLevel" node. */
  upsertMetadataPriceLevel: MetadataPriceLevel;
  /** Update or create a single "MetadataProcessHistory" node. */
  upsertMetadataProcessHistory: MetadataProcessHistory;
  /** Update or create a single "MetadataProcessStatus" node. */
  upsertMetadataProcessStatus: MetadataProcessStatus;
  /** Update or create a single "MetadataProduct" node. */
  upsertMetadataProduct: MetadataProduct;
  /** Update or create a single "MetadataProducts" node. */
  upsertMetadataProducts: MetadataProducts;
  /** Update or create a single "MetadataPublishingSubject" node. */
  upsertMetadataPublishingSubject: MetadataPublishingSubject;
  /** Update or create a single "MetadataResolutionKind" node. */
  upsertMetadataResolutionKind: MetadataResolutionKind;
  /** Update or create a single "MetadataRights" node. */
  upsertMetadataRights: MetadataRights;
  /** Update or create a single "MetadataSource" node. */
  upsertMetadataSource: MetadataSource;
  /** Update or create a single "MetadataSpecialInstructions" node. */
  upsertMetadataSpecialInstructions: MetadataSpecialInstructions;
  /** Update or create a single "MetadataSubject" node. */
  upsertMetadataSubject: MetadataSubject;
  /** Update or create a single "MetadataSubjectCode" node. */
  upsertMetadataSubjectCode: MetadataSubjectCode;
  /** Update or create a single "MetadataSubjectPrisma" node. */
  upsertMetadataSubjectPrisma: MetadataSubjectPrisma;
  /** Update or create a single "MetadataTitle" node. */
  upsertMetadataTitle: MetadataTitle;
  /** Update or create a single "MetadataTransferredBy" node. */
  upsertMetadataTransferredBy: MetadataTransferredBy;
  /** Update or create a single "MetadataTransferredByFullName" node. */
  upsertMetadataTransferredByFullName: MetadataTransferredByFullName;
  /** Update or create a single "MetadataType" node. */
  upsertMetadataType: MetadataType;
  /** Update or create a single "MetadataUndersubject" node. */
  upsertMetadataUndersubject: MetadataUndersubject;
  /** Update or create a single "MetadataUnderUnderSubject" node. */
  upsertMetadataUnderUnderSubject: MetadataUnderUnderSubject;
  /** Update or create a single "MetadataUploadedBy" node. */
  upsertMetadataUploadedBy: MetadataUploadedBy;
  /** Update or create a single "MetadataUploadedByFullName" node. */
  upsertMetadataUploadedByFullName: MetadataUploadedByFullName;
  /** Update or create a single "MetadataUploadTime" node. */
  upsertMetadataUploadTime: MetadataUploadTime;
  /** Update or create a single "MetadataUrgency" node. */
  upsertMetadataUrgency: MetadataUrgency;
  /** Update or create a single "MetadataUserDefined195" node. */
  upsertMetadataUserDefined195: MetadataUserDefined195;
  /** Update or create a single "MetadataUserDefined237" node. */
  upsertMetadataUserDefined237: MetadataUserDefined237;
  /** Update or create a single "MetadataUserDefined238" node. */
  upsertMetadataUserDefined238: MetadataUserDefined238;
  /** Update or create a single "MetadataUserDefined239" node. */
  upsertMetadataUserDefined239: MetadataUserDefined239;
  /** Update or create a single "MetadataUserDefined242" node. */
  upsertMetadataUserDefined242: MetadataUserDefined242;
  /** Update or create a single "MetadataUserDefined62" node. */
  upsertMetadataUserDefined62: MetadataUserDefined62;
  /** Update or create a single "MetadataWorkflowKind" node. */
  upsertMetadataWorkflowKind: MetadataWorkflowKind;
  /** Update or create a single "MetadataXmpHistory" node. */
  upsertMetadataXmpHistory: MetadataXmpHistory;
  /** Update or create a single "Photo" node. */
  upsertPhoto: Photo;
  /** Update or create a single "PhotoMetadata" node. */
  upsertPhotoMetadata: PhotoMetadata;
  /** Update or create a single "PhotoPublication" node. */
  upsertPhotoPublication: PhotoPublication;
};


export type MutationClonePhotoArgs = {
  create: PhotoCreateInput;
  sourceId: Scalars['String']['input'];
};


export type MutationCreateAgencyArgs = {
  data: AgencyCreateInput;
};


export type MutationCreateArchiveArgs = {
  data: ArchiveCreateInput;
};


export type MutationCreateArchiveAgencyArgs = {
  data: ArchiveAgencyCreateInput;
};


export type MutationCreateArchivePurgeSettingArgs = {
  data: ArchivePurgeSettingCreateInput;
};


export type MutationCreateCategoryArgs = {
  data: CategoryCreateInput;
};


export type MutationCreateDeliverySubjectArgs = {
  data: DeliverySubjectCreateInput;
};


export type MutationCreateGcImportSettingArgs = {
  data: GcImportSettingCreateInput;
};


export type MutationCreateImportQueueArgs = {
  data: ImportQueueCreateInput;
};


export type MutationCreateMetadataArgs = {
  data: MetadataCreateInput;
};


export type MutationCreateMetadataAccessRightsArgs = {
  data: MetadataAccessRightsCreateInput;
};


export type MutationCreateMetadataAssetStateArgs = {
  data: MetadataAssetStateCreateInput;
};


export type MutationCreateMetadataBackupNameArgs = {
  data: MetadataBackupNameCreateInput;
};


export type MutationCreateMetadataBrandArgs = {
  data: MetadataBrandCreateInput;
};


export type MutationCreateMetadataBrandPrismaArgs = {
  data: MetadataBrandPrismaCreateInput;
};


export type MutationCreateMetadataBrandShortNameArgs = {
  data: MetadataBrandShortNameCreateInput;
};


export type MutationCreateMetadataByLineArgs = {
  data: MetadataByLineCreateInput;
};


export type MutationCreateMetadataCaptionArgs = {
  data: MetadataCaptionCreateInput;
};


export type MutationCreateMetadataCaptionAbstractArgs = {
  data: MetadataCaptionAbstractCreateInput;
};


export type MutationCreateMetadataCategoryArgs = {
  data: MetadataCategoryCreateInput;
};


export type MutationCreateMetadataCategoryPrismaArgs = {
  data: MetadataCategoryPrismaCreateInput;
};


export type MutationCreateMetadataCompanyArgs = {
  data: MetadataCompanyCreateInput;
};


export type MutationCreateMetadataCompanyShortNameArgs = {
  data: MetadataCompanyShortNameCreateInput;
};


export type MutationCreateMetadataCopyrightNoticeArgs = {
  data: MetadataCopyrightNoticeCreateInput;
};


export type MutationCreateMetadataCreatorArgs = {
  data: MetadataCreatorCreateInput;
};


export type MutationCreateMetadataCreditArgs = {
  data: MetadataCreditCreateInput;
};


export type MutationCreateMetadataCustomField1Args = {
  data: MetadataCustomField1CreateInput;
};


export type MutationCreateMetadataCustomField14Args = {
  data: MetadataCustomField14CreateInput;
};


export type MutationCreateMetadataCustomField15Args = {
  data: MetadataCustomField15CreateInput;
};


export type MutationCreateMetadataCustomField16Args = {
  data: MetadataCustomField16CreateInput;
};


export type MutationCreateMetadataCustomField17Args = {
  data: MetadataCustomField17CreateInput;
};


export type MutationCreateMetadataCustomField20Args = {
  data: MetadataCustomField20CreateInput;
};


export type MutationCreateMetadataCustomField3Args = {
  data: MetadataCustomField3CreateInput;
};


export type MutationCreateMetadataCustomField4Args = {
  data: MetadataCustomField4CreateInput;
};


export type MutationCreateMetadataCustomField5Args = {
  data: MetadataCustomField5CreateInput;
};


export type MutationCreateMetadataCustomField6Args = {
  data: MetadataCustomField6CreateInput;
};


export type MutationCreateMetadataCustomField7Args = {
  data: MetadataCustomField7CreateInput;
};


export type MutationCreateMetadataCustomField9Args = {
  data: MetadataCustomField9CreateInput;
};


export type MutationCreateMetadataDateCreatedArgs = {
  data: MetadataDateCreatedCreateInput;
};


export type MutationCreateMetadataDateTimeOriginalArgs = {
  data: MetadataDateTimeOriginalCreateInput;
};


export type MutationCreateMetadataDeliveryAccountArgs = {
  data: MetadataDeliveryAccountCreateInput;
};


export type MutationCreateMetadataDeliveryCompanyArgs = {
  data: MetadataDeliveryCompanyCreateInput;
};


export type MutationCreateMetadataDeliveryCopyrightArgs = {
  data: MetadataDeliveryCopyrightCreateInput;
};


export type MutationCreateMetadataDeliveryDateFolderArgs = {
  data: MetadataDeliveryDateFolderCreateInput;
};


export type MutationCreateMetadataDeliveryDateTimeArgs = {
  data: MetadataDeliveryDateTimeCreateInput;
};


export type MutationCreateMetadataDeliveryDcCreatorArgs = {
  data: MetadataDeliveryDcCreatorCreateInput;
};


export type MutationCreateMetadataDeliveryDcRightsArgs = {
  data: MetadataDeliveryDcRightsCreateInput;
};


export type MutationCreateMetadataDeliveryFolderArgs = {
  data: MetadataDeliveryFolderCreateInput;
};


export type MutationCreateMetadataDeliveryKindArgs = {
  data: MetadataDeliveryKindCreateInput;
};


export type MutationCreateMetadataDeliveryPathArgs = {
  data: MetadataDeliveryPathCreateInput;
};


export type MutationCreateMetadataDeliveryPhotoshopCreditArgs = {
  data: MetadataDeliveryPhotoshopCreditCreateInput;
};


export type MutationCreateMetadataDeliveryPhotoshopSourceArgs = {
  data: MetadataDeliveryPhotoshopSourceCreateInput;
};


export type MutationCreateMetadataDeliveryServiceArgs = {
  data: MetadataDeliveryServiceCreateInput;
};


export type MutationCreateMetadataDeliverySubjectArgs = {
  data: MetadataDeliverySubjectCreateInput;
};


export type MutationCreateMetadataDeliveryUnderSubjectArgs = {
  data: MetadataDeliveryUnderSubjectCreateInput;
};


export type MutationCreateMetadataDepartmentArgs = {
  data: MetadataDepartmentCreateInput;
};


export type MutationCreateMetadataDescriptionArgs = {
  data: MetadataDescriptionCreateInput;
};


export type MutationCreateMetadataEditionArgs = {
  data: MetadataEditionCreateInput;
};


export type MutationCreateMetadataEditStatusArgs = {
  data: MetadataEditStatusCreateInput;
};


export type MutationCreateMetadataFileStatusArgs = {
  data: MetadataFileStatusCreateInput;
};


export type MutationCreateMetadataFormatArgs = {
  data: MetadataFormatCreateInput;
};


export type MutationCreateMetadataHeaderArgs = {
  data: MetadataHeaderCreateInput;
};


export type MutationCreateMetadataHeaderPrismaArgs = {
  data: MetadataHeaderPrismaCreateInput;
};


export type MutationCreateMetadataHeadlineArgs = {
  data: MetadataHeadlineCreateInput;
};


export type MutationCreateMetadataIdAssignmentArgs = {
  data: MetadataIdAssignmentCreateInput;
};


export type MutationCreateMetadataIdPhotoPrismaArgs = {
  data: MetadataIdPhotoPrismaCreateInput;
};


export type MutationCreateMetadataIdSubjectArgs = {
  data: MetadataIdSubjectCreateInput;
};


export type MutationCreateMetadataImageNotesArgs = {
  data: MetadataImageNotesCreateInput;
};


export type MutationCreateMetadataInstructionsArgs = {
  data: MetadataInstructionsCreateInput;
};


export type MutationCreateMetadataIssueArgs = {
  data: MetadataIssueCreateInput;
};


export type MutationCreateMetadataKeywordsArgs = {
  data: MetadataKeywordsCreateInput;
};


export type MutationCreateMetadataObjectNameArgs = {
  data: MetadataObjectNameCreateInput;
};


export type MutationCreateMetadataOriginalNameArgs = {
  data: MetadataOriginalNameCreateInput;
};


export type MutationCreateMetadataPriceLevelArgs = {
  data: MetadataPriceLevelCreateInput;
};


export type MutationCreateMetadataProcessHistoryArgs = {
  data: MetadataProcessHistoryCreateInput;
};


export type MutationCreateMetadataProcessStatusArgs = {
  data: MetadataProcessStatusCreateInput;
};


export type MutationCreateMetadataProductArgs = {
  data: MetadataProductCreateInput;
};


export type MutationCreateMetadataProductsArgs = {
  data: MetadataProductsCreateInput;
};


export type MutationCreateMetadataPublishingSubjectArgs = {
  data: MetadataPublishingSubjectCreateInput;
};


export type MutationCreateMetadataResolutionKindArgs = {
  data: MetadataResolutionKindCreateInput;
};


export type MutationCreateMetadataRightsArgs = {
  data: MetadataRightsCreateInput;
};


export type MutationCreateMetadataSourceArgs = {
  data: MetadataSourceCreateInput;
};


export type MutationCreateMetadataSpecialInstructionsArgs = {
  data: MetadataSpecialInstructionsCreateInput;
};


export type MutationCreateMetadataSubjectArgs = {
  data: MetadataSubjectCreateInput;
};


export type MutationCreateMetadataSubjectCodeArgs = {
  data: MetadataSubjectCodeCreateInput;
};


export type MutationCreateMetadataSubjectPrismaArgs = {
  data: MetadataSubjectPrismaCreateInput;
};


export type MutationCreateMetadataTitleArgs = {
  data: MetadataTitleCreateInput;
};


export type MutationCreateMetadataTransferredByArgs = {
  data: MetadataTransferredByCreateInput;
};


export type MutationCreateMetadataTransferredByFullNameArgs = {
  data: MetadataTransferredByFullNameCreateInput;
};


export type MutationCreateMetadataTypeArgs = {
  data: MetadataTypeCreateInput;
};


export type MutationCreateMetadataUndersubjectArgs = {
  data: MetadataUndersubjectCreateInput;
};


export type MutationCreateMetadataUnderUnderSubjectArgs = {
  data: MetadataUnderUnderSubjectCreateInput;
};


export type MutationCreateMetadataUploadedByArgs = {
  data: MetadataUploadedByCreateInput;
};


export type MutationCreateMetadataUploadedByFullNameArgs = {
  data: MetadataUploadedByFullNameCreateInput;
};


export type MutationCreateMetadataUploadTimeArgs = {
  data: MetadataUploadTimeCreateInput;
};


export type MutationCreateMetadataUrgencyArgs = {
  data: MetadataUrgencyCreateInput;
};


export type MutationCreateMetadataUserDefined195Args = {
  data: MetadataUserDefined195CreateInput;
};


export type MutationCreateMetadataUserDefined237Args = {
  data: MetadataUserDefined237CreateInput;
};


export type MutationCreateMetadataUserDefined238Args = {
  data: MetadataUserDefined238CreateInput;
};


export type MutationCreateMetadataUserDefined239Args = {
  data: MetadataUserDefined239CreateInput;
};


export type MutationCreateMetadataUserDefined242Args = {
  data: MetadataUserDefined242CreateInput;
};


export type MutationCreateMetadataUserDefined62Args = {
  data: MetadataUserDefined62CreateInput;
};


export type MutationCreateMetadataWorkflowKindArgs = {
  data: MetadataWorkflowKindCreateInput;
};


export type MutationCreateMetadataXmpHistoryArgs = {
  data: MetadataXmpHistoryCreateInput;
};


export type MutationCreatePhotoArgs = {
  data: PhotoCreateInput;
};


export type MutationCreatePhotoMetadataArgs = {
  data: PhotoMetadataCreateInput;
};


export type MutationCreatePhotoPublicationArgs = {
  data: PhotoPublicationCreateInput;
};


export type MutationDeleteAgencyArgs = {
  where: AgencyWhereUniqueInput;
};


export type MutationDeleteArchiveArgs = {
  where: ArchiveWhereUniqueInput;
};


export type MutationDeleteArchiveAgencyArgs = {
  where: ArchiveAgencyWhereUniqueInput;
};


export type MutationDeleteArchivePurgeSettingArgs = {
  where: ArchivePurgeSettingWhereUniqueInput;
};


export type MutationDeleteCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type MutationDeleteDeliverySubjectArgs = {
  where: DeliverySubjectWhereUniqueInput;
};


export type MutationDeleteGcImportSettingArgs = {
  where: GcImportSettingWhereUniqueInput;
};


export type MutationDeleteImportQueueArgs = {
  where: ImportQueueWhereUniqueInput;
};


export type MutationDeleteMetadataArgs = {
  where: MetadataWhereUniqueInput;
};


export type MutationDeleteMetadataAccessRightsArgs = {
  where: MetadataAccessRightsWhereUniqueInput;
};


export type MutationDeleteMetadataAssetStateArgs = {
  where: MetadataAssetStateWhereUniqueInput;
};


export type MutationDeleteMetadataBackupNameArgs = {
  where: MetadataBackupNameWhereUniqueInput;
};


export type MutationDeleteMetadataBrandArgs = {
  where: MetadataBrandWhereUniqueInput;
};


export type MutationDeleteMetadataBrandPrismaArgs = {
  where: MetadataBrandPrismaWhereUniqueInput;
};


export type MutationDeleteMetadataBrandShortNameArgs = {
  where: MetadataBrandShortNameWhereUniqueInput;
};


export type MutationDeleteMetadataByLineArgs = {
  where: MetadataByLineWhereUniqueInput;
};


export type MutationDeleteMetadataCaptionArgs = {
  where: MetadataCaptionWhereUniqueInput;
};


export type MutationDeleteMetadataCaptionAbstractArgs = {
  where: MetadataCaptionAbstractWhereUniqueInput;
};


export type MutationDeleteMetadataCategoryArgs = {
  where: MetadataCategoryWhereUniqueInput;
};


export type MutationDeleteMetadataCategoryPrismaArgs = {
  where: MetadataCategoryPrismaWhereUniqueInput;
};


export type MutationDeleteMetadataCompanyArgs = {
  where: MetadataCompanyWhereUniqueInput;
};


export type MutationDeleteMetadataCompanyShortNameArgs = {
  where: MetadataCompanyShortNameWhereUniqueInput;
};


export type MutationDeleteMetadataCopyrightNoticeArgs = {
  where: MetadataCopyrightNoticeWhereUniqueInput;
};


export type MutationDeleteMetadataCreatorArgs = {
  where: MetadataCreatorWhereUniqueInput;
};


export type MutationDeleteMetadataCreditArgs = {
  where: MetadataCreditWhereUniqueInput;
};


export type MutationDeleteMetadataCustomField1Args = {
  where: MetadataCustomField1WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField14Args = {
  where: MetadataCustomField14WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField15Args = {
  where: MetadataCustomField15WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField16Args = {
  where: MetadataCustomField16WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField17Args = {
  where: MetadataCustomField17WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField20Args = {
  where: MetadataCustomField20WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField3Args = {
  where: MetadataCustomField3WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField4Args = {
  where: MetadataCustomField4WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField5Args = {
  where: MetadataCustomField5WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField6Args = {
  where: MetadataCustomField6WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField7Args = {
  where: MetadataCustomField7WhereUniqueInput;
};


export type MutationDeleteMetadataCustomField9Args = {
  where: MetadataCustomField9WhereUniqueInput;
};


export type MutationDeleteMetadataDateCreatedArgs = {
  where: MetadataDateCreatedWhereUniqueInput;
};


export type MutationDeleteMetadataDateTimeOriginalArgs = {
  where: MetadataDateTimeOriginalWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryAccountArgs = {
  where: MetadataDeliveryAccountWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryCompanyArgs = {
  where: MetadataDeliveryCompanyWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryCopyrightArgs = {
  where: MetadataDeliveryCopyrightWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryDateFolderArgs = {
  where: MetadataDeliveryDateFolderWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryDateTimeArgs = {
  where: MetadataDeliveryDateTimeWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryDcCreatorArgs = {
  where: MetadataDeliveryDcCreatorWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryDcRightsArgs = {
  where: MetadataDeliveryDcRightsWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryFolderArgs = {
  where: MetadataDeliveryFolderWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryKindArgs = {
  where: MetadataDeliveryKindWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryPathArgs = {
  where: MetadataDeliveryPathWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryPhotoshopCreditArgs = {
  where: MetadataDeliveryPhotoshopCreditWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryPhotoshopSourceArgs = {
  where: MetadataDeliveryPhotoshopSourceWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryServiceArgs = {
  where: MetadataDeliveryServiceWhereUniqueInput;
};


export type MutationDeleteMetadataDeliverySubjectArgs = {
  where: MetadataDeliverySubjectWhereUniqueInput;
};


export type MutationDeleteMetadataDeliveryUnderSubjectArgs = {
  where: MetadataDeliveryUnderSubjectWhereUniqueInput;
};


export type MutationDeleteMetadataDepartmentArgs = {
  where: MetadataDepartmentWhereUniqueInput;
};


export type MutationDeleteMetadataDescriptionArgs = {
  where: MetadataDescriptionWhereUniqueInput;
};


export type MutationDeleteMetadataEditionArgs = {
  where: MetadataEditionWhereUniqueInput;
};


export type MutationDeleteMetadataEditStatusArgs = {
  where: MetadataEditStatusWhereUniqueInput;
};


export type MutationDeleteMetadataFileStatusArgs = {
  where: MetadataFileStatusWhereUniqueInput;
};


export type MutationDeleteMetadataFormatArgs = {
  where: MetadataFormatWhereUniqueInput;
};


export type MutationDeleteMetadataHeaderArgs = {
  where: MetadataHeaderWhereUniqueInput;
};


export type MutationDeleteMetadataHeaderPrismaArgs = {
  where: MetadataHeaderPrismaWhereUniqueInput;
};


export type MutationDeleteMetadataHeadlineArgs = {
  where: MetadataHeadlineWhereUniqueInput;
};


export type MutationDeleteMetadataIdAssignmentArgs = {
  where: MetadataIdAssignmentWhereUniqueInput;
};


export type MutationDeleteMetadataIdPhotoPrismaArgs = {
  where: MetadataIdPhotoPrismaWhereUniqueInput;
};


export type MutationDeleteMetadataIdSubjectArgs = {
  where: MetadataIdSubjectWhereUniqueInput;
};


export type MutationDeleteMetadataImageNotesArgs = {
  where: MetadataImageNotesWhereUniqueInput;
};


export type MutationDeleteMetadataInstructionsArgs = {
  where: MetadataInstructionsWhereUniqueInput;
};


export type MutationDeleteMetadataIssueArgs = {
  where: MetadataIssueWhereUniqueInput;
};


export type MutationDeleteMetadataKeywordsArgs = {
  where: MetadataKeywordsWhereUniqueInput;
};


export type MutationDeleteMetadataObjectNameArgs = {
  where: MetadataObjectNameWhereUniqueInput;
};


export type MutationDeleteMetadataOriginalNameArgs = {
  where: MetadataOriginalNameWhereUniqueInput;
};


export type MutationDeleteMetadataPriceLevelArgs = {
  where: MetadataPriceLevelWhereUniqueInput;
};


export type MutationDeleteMetadataProcessHistoryArgs = {
  where: MetadataProcessHistoryWhereUniqueInput;
};


export type MutationDeleteMetadataProcessStatusArgs = {
  where: MetadataProcessStatusWhereUniqueInput;
};


export type MutationDeleteMetadataProductArgs = {
  where: MetadataProductWhereUniqueInput;
};


export type MutationDeleteMetadataProductsArgs = {
  where: MetadataProductsWhereUniqueInput;
};


export type MutationDeleteMetadataPublishingSubjectArgs = {
  where: MetadataPublishingSubjectWhereUniqueInput;
};


export type MutationDeleteMetadataResolutionKindArgs = {
  where: MetadataResolutionKindWhereUniqueInput;
};


export type MutationDeleteMetadataRightsArgs = {
  where: MetadataRightsWhereUniqueInput;
};


export type MutationDeleteMetadataSourceArgs = {
  where: MetadataSourceWhereUniqueInput;
};


export type MutationDeleteMetadataSpecialInstructionsArgs = {
  where: MetadataSpecialInstructionsWhereUniqueInput;
};


export type MutationDeleteMetadataSubjectArgs = {
  where: MetadataSubjectWhereUniqueInput;
};


export type MutationDeleteMetadataSubjectCodeArgs = {
  where: MetadataSubjectCodeWhereUniqueInput;
};


export type MutationDeleteMetadataSubjectPrismaArgs = {
  where: MetadataSubjectPrismaWhereUniqueInput;
};


export type MutationDeleteMetadataTitleArgs = {
  where: MetadataTitleWhereUniqueInput;
};


export type MutationDeleteMetadataTransferredByArgs = {
  where: MetadataTransferredByWhereUniqueInput;
};


export type MutationDeleteMetadataTransferredByFullNameArgs = {
  where: MetadataTransferredByFullNameWhereUniqueInput;
};


export type MutationDeleteMetadataTypeArgs = {
  where: MetadataTypeWhereUniqueInput;
};


export type MutationDeleteMetadataUndersubjectArgs = {
  where: MetadataUndersubjectWhereUniqueInput;
};


export type MutationDeleteMetadataUnderUnderSubjectArgs = {
  where: MetadataUnderUnderSubjectWhereUniqueInput;
};


export type MutationDeleteMetadataUploadedByArgs = {
  where: MetadataUploadedByWhereUniqueInput;
};


export type MutationDeleteMetadataUploadedByFullNameArgs = {
  where: MetadataUploadedByFullNameWhereUniqueInput;
};


export type MutationDeleteMetadataUploadTimeArgs = {
  where: MetadataUploadTimeWhereUniqueInput;
};


export type MutationDeleteMetadataUrgencyArgs = {
  where: MetadataUrgencyWhereUniqueInput;
};


export type MutationDeleteMetadataUserDefined195Args = {
  where: MetadataUserDefined195WhereUniqueInput;
};


export type MutationDeleteMetadataUserDefined237Args = {
  where: MetadataUserDefined237WhereUniqueInput;
};


export type MutationDeleteMetadataUserDefined238Args = {
  where: MetadataUserDefined238WhereUniqueInput;
};


export type MutationDeleteMetadataUserDefined239Args = {
  where: MetadataUserDefined239WhereUniqueInput;
};


export type MutationDeleteMetadataUserDefined242Args = {
  where: MetadataUserDefined242WhereUniqueInput;
};


export type MutationDeleteMetadataUserDefined62Args = {
  where: MetadataUserDefined62WhereUniqueInput;
};


export type MutationDeleteMetadataWorkflowKindArgs = {
  where: MetadataWorkflowKindWhereUniqueInput;
};


export type MutationDeleteMetadataXmpHistoryArgs = {
  where: MetadataXmpHistoryWhereUniqueInput;
};


export type MutationDeletePhotoArgs = {
  where: PhotoWhereUniqueInput;
};


export type MutationDeletePhotoMetadataArgs = {
  where: PhotoMetadataWhereUniqueInput;
};


export type MutationDeletePhotoPublicationArgs = {
  where: PhotoPublicationWhereUniqueInput;
};


export type MutationUpdateAgencyArgs = {
  data: AgencyUpdateInput;
  where: AgencyWhereUniqueInput;
};


export type MutationUpdateArchiveArgs = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};


export type MutationUpdateArchiveAgencyArgs = {
  data: ArchiveAgencyUpdateInput;
  where: ArchiveAgencyWhereUniqueInput;
};


export type MutationUpdateArchivePurgeSettingArgs = {
  data: ArchivePurgeSettingUpdateInput;
  where: ArchivePurgeSettingWhereUniqueInput;
};


export type MutationUpdateCategoryArgs = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpdateDeliverySubjectArgs = {
  data: DeliverySubjectUpdateInput;
  where: DeliverySubjectWhereUniqueInput;
};


export type MutationUpdateGcImportSettingArgs = {
  data: GcImportSettingUpdateInput;
  where: GcImportSettingWhereUniqueInput;
};


export type MutationUpdateImportQueueArgs = {
  data: ImportQueueUpdateInput;
  where: ImportQueueWhereUniqueInput;
};


export type MutationUpdateMetadataArgs = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};


export type MutationUpdateMetadataAccessRightsArgs = {
  data: MetadataAccessRightsUpdateInput;
  where: MetadataAccessRightsWhereUniqueInput;
};


export type MutationUpdateMetadataAssetStateArgs = {
  data: MetadataAssetStateUpdateInput;
  where: MetadataAssetStateWhereUniqueInput;
};


export type MutationUpdateMetadataBackupNameArgs = {
  data: MetadataBackupNameUpdateInput;
  where: MetadataBackupNameWhereUniqueInput;
};


export type MutationUpdateMetadataBrandArgs = {
  data: MetadataBrandUpdateInput;
  where: MetadataBrandWhereUniqueInput;
};


export type MutationUpdateMetadataBrandPrismaArgs = {
  data: MetadataBrandPrismaUpdateInput;
  where: MetadataBrandPrismaWhereUniqueInput;
};


export type MutationUpdateMetadataBrandShortNameArgs = {
  data: MetadataBrandShortNameUpdateInput;
  where: MetadataBrandShortNameWhereUniqueInput;
};


export type MutationUpdateMetadataByLineArgs = {
  data: MetadataByLineUpdateInput;
  where: MetadataByLineWhereUniqueInput;
};


export type MutationUpdateMetadataCaptionArgs = {
  data: MetadataCaptionUpdateInput;
  where: MetadataCaptionWhereUniqueInput;
};


export type MutationUpdateMetadataCaptionAbstractArgs = {
  data: MetadataCaptionAbstractUpdateInput;
  where: MetadataCaptionAbstractWhereUniqueInput;
};


export type MutationUpdateMetadataCategoryArgs = {
  data: MetadataCategoryUpdateInput;
  where: MetadataCategoryWhereUniqueInput;
};


export type MutationUpdateMetadataCategoryPrismaArgs = {
  data: MetadataCategoryPrismaUpdateInput;
  where: MetadataCategoryPrismaWhereUniqueInput;
};


export type MutationUpdateMetadataCompanyArgs = {
  data: MetadataCompanyUpdateInput;
  where: MetadataCompanyWhereUniqueInput;
};


export type MutationUpdateMetadataCompanyShortNameArgs = {
  data: MetadataCompanyShortNameUpdateInput;
  where: MetadataCompanyShortNameWhereUniqueInput;
};


export type MutationUpdateMetadataCopyrightNoticeArgs = {
  data: MetadataCopyrightNoticeUpdateInput;
  where: MetadataCopyrightNoticeWhereUniqueInput;
};


export type MutationUpdateMetadataCreatorArgs = {
  data: MetadataCreatorUpdateInput;
  where: MetadataCreatorWhereUniqueInput;
};


export type MutationUpdateMetadataCreditArgs = {
  data: MetadataCreditUpdateInput;
  where: MetadataCreditWhereUniqueInput;
};


export type MutationUpdateMetadataCustomField1Args = {
  data: MetadataCustomField1UpdateInput;
  where: MetadataCustomField1WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField14Args = {
  data: MetadataCustomField14UpdateInput;
  where: MetadataCustomField14WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField15Args = {
  data: MetadataCustomField15UpdateInput;
  where: MetadataCustomField15WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField16Args = {
  data: MetadataCustomField16UpdateInput;
  where: MetadataCustomField16WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField17Args = {
  data: MetadataCustomField17UpdateInput;
  where: MetadataCustomField17WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField20Args = {
  data: MetadataCustomField20UpdateInput;
  where: MetadataCustomField20WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField3Args = {
  data: MetadataCustomField3UpdateInput;
  where: MetadataCustomField3WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField4Args = {
  data: MetadataCustomField4UpdateInput;
  where: MetadataCustomField4WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField5Args = {
  data: MetadataCustomField5UpdateInput;
  where: MetadataCustomField5WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField6Args = {
  data: MetadataCustomField6UpdateInput;
  where: MetadataCustomField6WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField7Args = {
  data: MetadataCustomField7UpdateInput;
  where: MetadataCustomField7WhereUniqueInput;
};


export type MutationUpdateMetadataCustomField9Args = {
  data: MetadataCustomField9UpdateInput;
  where: MetadataCustomField9WhereUniqueInput;
};


export type MutationUpdateMetadataDateCreatedArgs = {
  data: MetadataDateCreatedUpdateInput;
  where: MetadataDateCreatedWhereUniqueInput;
};


export type MutationUpdateMetadataDateTimeOriginalArgs = {
  data: MetadataDateTimeOriginalUpdateInput;
  where: MetadataDateTimeOriginalWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryAccountArgs = {
  data: MetadataDeliveryAccountUpdateInput;
  where: MetadataDeliveryAccountWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryCompanyArgs = {
  data: MetadataDeliveryCompanyUpdateInput;
  where: MetadataDeliveryCompanyWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryCopyrightArgs = {
  data: MetadataDeliveryCopyrightUpdateInput;
  where: MetadataDeliveryCopyrightWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryDateFolderArgs = {
  data: MetadataDeliveryDateFolderUpdateInput;
  where: MetadataDeliveryDateFolderWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryDateTimeArgs = {
  data: MetadataDeliveryDateTimeUpdateInput;
  where: MetadataDeliveryDateTimeWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryDcCreatorArgs = {
  data: MetadataDeliveryDcCreatorUpdateInput;
  where: MetadataDeliveryDcCreatorWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryDcRightsArgs = {
  data: MetadataDeliveryDcRightsUpdateInput;
  where: MetadataDeliveryDcRightsWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryFolderArgs = {
  data: MetadataDeliveryFolderUpdateInput;
  where: MetadataDeliveryFolderWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryKindArgs = {
  data: MetadataDeliveryKindUpdateInput;
  where: MetadataDeliveryKindWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryPathArgs = {
  data: MetadataDeliveryPathUpdateInput;
  where: MetadataDeliveryPathWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryPhotoshopCreditArgs = {
  data: MetadataDeliveryPhotoshopCreditUpdateInput;
  where: MetadataDeliveryPhotoshopCreditWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryPhotoshopSourceArgs = {
  data: MetadataDeliveryPhotoshopSourceUpdateInput;
  where: MetadataDeliveryPhotoshopSourceWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryServiceArgs = {
  data: MetadataDeliveryServiceUpdateInput;
  where: MetadataDeliveryServiceWhereUniqueInput;
};


export type MutationUpdateMetadataDeliverySubjectArgs = {
  data: MetadataDeliverySubjectUpdateInput;
  where: MetadataDeliverySubjectWhereUniqueInput;
};


export type MutationUpdateMetadataDeliveryUnderSubjectArgs = {
  data: MetadataDeliveryUnderSubjectUpdateInput;
  where: MetadataDeliveryUnderSubjectWhereUniqueInput;
};


export type MutationUpdateMetadataDepartmentArgs = {
  data: MetadataDepartmentUpdateInput;
  where: MetadataDepartmentWhereUniqueInput;
};


export type MutationUpdateMetadataDescriptionArgs = {
  data: MetadataDescriptionUpdateInput;
  where: MetadataDescriptionWhereUniqueInput;
};


export type MutationUpdateMetadataEditionArgs = {
  data: MetadataEditionUpdateInput;
  where: MetadataEditionWhereUniqueInput;
};


export type MutationUpdateMetadataEditStatusArgs = {
  data: MetadataEditStatusUpdateInput;
  where: MetadataEditStatusWhereUniqueInput;
};


export type MutationUpdateMetadataFileStatusArgs = {
  data: MetadataFileStatusUpdateInput;
  where: MetadataFileStatusWhereUniqueInput;
};


export type MutationUpdateMetadataFormatArgs = {
  data: MetadataFormatUpdateInput;
  where: MetadataFormatWhereUniqueInput;
};


export type MutationUpdateMetadataHeaderArgs = {
  data: MetadataHeaderUpdateInput;
  where: MetadataHeaderWhereUniqueInput;
};


export type MutationUpdateMetadataHeaderPrismaArgs = {
  data: MetadataHeaderPrismaUpdateInput;
  where: MetadataHeaderPrismaWhereUniqueInput;
};


export type MutationUpdateMetadataHeadlineArgs = {
  data: MetadataHeadlineUpdateInput;
  where: MetadataHeadlineWhereUniqueInput;
};


export type MutationUpdateMetadataIdAssignmentArgs = {
  data: MetadataIdAssignmentUpdateInput;
  where: MetadataIdAssignmentWhereUniqueInput;
};


export type MutationUpdateMetadataIdPhotoPrismaArgs = {
  data: MetadataIdPhotoPrismaUpdateInput;
  where: MetadataIdPhotoPrismaWhereUniqueInput;
};


export type MutationUpdateMetadataIdSubjectArgs = {
  data: MetadataIdSubjectUpdateInput;
  where: MetadataIdSubjectWhereUniqueInput;
};


export type MutationUpdateMetadataImageNotesArgs = {
  data: MetadataImageNotesUpdateInput;
  where: MetadataImageNotesWhereUniqueInput;
};


export type MutationUpdateMetadataInstructionsArgs = {
  data: MetadataInstructionsUpdateInput;
  where: MetadataInstructionsWhereUniqueInput;
};


export type MutationUpdateMetadataIssueArgs = {
  data: MetadataIssueUpdateInput;
  where: MetadataIssueWhereUniqueInput;
};


export type MutationUpdateMetadataKeywordsArgs = {
  data: MetadataKeywordsUpdateInput;
  where: MetadataKeywordsWhereUniqueInput;
};


export type MutationUpdateMetadataObjectNameArgs = {
  data: MetadataObjectNameUpdateInput;
  where: MetadataObjectNameWhereUniqueInput;
};


export type MutationUpdateMetadataOriginalNameArgs = {
  data: MetadataOriginalNameUpdateInput;
  where: MetadataOriginalNameWhereUniqueInput;
};


export type MutationUpdateMetadataPriceLevelArgs = {
  data: MetadataPriceLevelUpdateInput;
  where: MetadataPriceLevelWhereUniqueInput;
};


export type MutationUpdateMetadataProcessHistoryArgs = {
  data: MetadataProcessHistoryUpdateInput;
  where: MetadataProcessHistoryWhereUniqueInput;
};


export type MutationUpdateMetadataProcessStatusArgs = {
  data: MetadataProcessStatusUpdateInput;
  where: MetadataProcessStatusWhereUniqueInput;
};


export type MutationUpdateMetadataProductArgs = {
  data: MetadataProductUpdateInput;
  where: MetadataProductWhereUniqueInput;
};


export type MutationUpdateMetadataProductsArgs = {
  data: MetadataProductsUpdateInput;
  where: MetadataProductsWhereUniqueInput;
};


export type MutationUpdateMetadataPublishingSubjectArgs = {
  data: MetadataPublishingSubjectUpdateInput;
  where: MetadataPublishingSubjectWhereUniqueInput;
};


export type MutationUpdateMetadataResolutionKindArgs = {
  data: MetadataResolutionKindUpdateInput;
  where: MetadataResolutionKindWhereUniqueInput;
};


export type MutationUpdateMetadataRightsArgs = {
  data: MetadataRightsUpdateInput;
  where: MetadataRightsWhereUniqueInput;
};


export type MutationUpdateMetadataSourceArgs = {
  data: MetadataSourceUpdateInput;
  where: MetadataSourceWhereUniqueInput;
};


export type MutationUpdateMetadataSpecialInstructionsArgs = {
  data: MetadataSpecialInstructionsUpdateInput;
  where: MetadataSpecialInstructionsWhereUniqueInput;
};


export type MutationUpdateMetadataSubjectArgs = {
  data: MetadataSubjectUpdateInput;
  where: MetadataSubjectWhereUniqueInput;
};


export type MutationUpdateMetadataSubjectCodeArgs = {
  data: MetadataSubjectCodeUpdateInput;
  where: MetadataSubjectCodeWhereUniqueInput;
};


export type MutationUpdateMetadataSubjectPrismaArgs = {
  data: MetadataSubjectPrismaUpdateInput;
  where: MetadataSubjectPrismaWhereUniqueInput;
};


export type MutationUpdateMetadataTitleArgs = {
  data: MetadataTitleUpdateInput;
  where: MetadataTitleWhereUniqueInput;
};


export type MutationUpdateMetadataTransferredByArgs = {
  data: MetadataTransferredByUpdateInput;
  where: MetadataTransferredByWhereUniqueInput;
};


export type MutationUpdateMetadataTransferredByFullNameArgs = {
  data: MetadataTransferredByFullNameUpdateInput;
  where: MetadataTransferredByFullNameWhereUniqueInput;
};


export type MutationUpdateMetadataTypeArgs = {
  data: MetadataTypeUpdateInput;
  where: MetadataTypeWhereUniqueInput;
};


export type MutationUpdateMetadataUndersubjectArgs = {
  data: MetadataUndersubjectUpdateInput;
  where: MetadataUndersubjectWhereUniqueInput;
};


export type MutationUpdateMetadataUnderUnderSubjectArgs = {
  data: MetadataUnderUnderSubjectUpdateInput;
  where: MetadataUnderUnderSubjectWhereUniqueInput;
};


export type MutationUpdateMetadataUploadedByArgs = {
  data: MetadataUploadedByUpdateInput;
  where: MetadataUploadedByWhereUniqueInput;
};


export type MutationUpdateMetadataUploadedByFullNameArgs = {
  data: MetadataUploadedByFullNameUpdateInput;
  where: MetadataUploadedByFullNameWhereUniqueInput;
};


export type MutationUpdateMetadataUploadTimeArgs = {
  data: MetadataUploadTimeUpdateInput;
  where: MetadataUploadTimeWhereUniqueInput;
};


export type MutationUpdateMetadataUrgencyArgs = {
  data: MetadataUrgencyUpdateInput;
  where: MetadataUrgencyWhereUniqueInput;
};


export type MutationUpdateMetadataUserDefined195Args = {
  data: MetadataUserDefined195UpdateInput;
  where: MetadataUserDefined195WhereUniqueInput;
};


export type MutationUpdateMetadataUserDefined237Args = {
  data: MetadataUserDefined237UpdateInput;
  where: MetadataUserDefined237WhereUniqueInput;
};


export type MutationUpdateMetadataUserDefined238Args = {
  data: MetadataUserDefined238UpdateInput;
  where: MetadataUserDefined238WhereUniqueInput;
};


export type MutationUpdateMetadataUserDefined239Args = {
  data: MetadataUserDefined239UpdateInput;
  where: MetadataUserDefined239WhereUniqueInput;
};


export type MutationUpdateMetadataUserDefined242Args = {
  data: MetadataUserDefined242UpdateInput;
  where: MetadataUserDefined242WhereUniqueInput;
};


export type MutationUpdateMetadataUserDefined62Args = {
  data: MetadataUserDefined62UpdateInput;
  where: MetadataUserDefined62WhereUniqueInput;
};


export type MutationUpdateMetadataWorkflowKindArgs = {
  data: MetadataWorkflowKindUpdateInput;
  where: MetadataWorkflowKindWhereUniqueInput;
};


export type MutationUpdateMetadataXmpHistoryArgs = {
  data: MetadataXmpHistoryUpdateInput;
  where: MetadataXmpHistoryWhereUniqueInput;
};


export type MutationUpdatePhotoArgs = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};


export type MutationUpdatePhotoFileArgs = {
  photoId: Scalars['String']['input'];
};


export type MutationUpdatePhotoMetadataArgs = {
  data: PhotoMetadataUpdateInput;
  where: PhotoMetadataWhereUniqueInput;
};


export type MutationUpdatePhotoPublicationArgs = {
  data: PhotoPublicationUpdateInput;
  where: PhotoPublicationWhereUniqueInput;
};


export type MutationUpsertAgencyArgs = {
  create: AgencyCreateInput;
  update: AgencyUpdateInput;
  where: AgencyWhereUniqueInput;
};


export type MutationUpsertArchiveArgs = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};


export type MutationUpsertArchiveAgencyArgs = {
  create: ArchiveAgencyCreateInput;
  update: ArchiveAgencyUpdateInput;
  where: ArchiveAgencyWhereUniqueInput;
};


export type MutationUpsertArchivePurgeSettingArgs = {
  create: ArchivePurgeSettingCreateInput;
  update: ArchivePurgeSettingUpdateInput;
  where: ArchivePurgeSettingWhereUniqueInput;
};


export type MutationUpsertCategoryArgs = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpsertDeliverySubjectArgs = {
  create: DeliverySubjectCreateInput;
  update: DeliverySubjectUpdateInput;
  where: DeliverySubjectWhereUniqueInput;
};


export type MutationUpsertGcImportSettingArgs = {
  create: GcImportSettingCreateInput;
  update: GcImportSettingUpdateInput;
  where: GcImportSettingWhereUniqueInput;
};


export type MutationUpsertImportQueueArgs = {
  create: ImportQueueCreateInput;
  update: ImportQueueUpdateInput;
  where: ImportQueueWhereUniqueInput;
};


export type MutationUpsertMetadataArgs = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};


export type MutationUpsertMetadataAccessRightsArgs = {
  create: MetadataAccessRightsCreateInput;
  update: MetadataAccessRightsUpdateInput;
  where: MetadataAccessRightsWhereUniqueInput;
};


export type MutationUpsertMetadataAssetStateArgs = {
  create: MetadataAssetStateCreateInput;
  update: MetadataAssetStateUpdateInput;
  where: MetadataAssetStateWhereUniqueInput;
};


export type MutationUpsertMetadataBackupNameArgs = {
  create: MetadataBackupNameCreateInput;
  update: MetadataBackupNameUpdateInput;
  where: MetadataBackupNameWhereUniqueInput;
};


export type MutationUpsertMetadataBrandArgs = {
  create: MetadataBrandCreateInput;
  update: MetadataBrandUpdateInput;
  where: MetadataBrandWhereUniqueInput;
};


export type MutationUpsertMetadataBrandPrismaArgs = {
  create: MetadataBrandPrismaCreateInput;
  update: MetadataBrandPrismaUpdateInput;
  where: MetadataBrandPrismaWhereUniqueInput;
};


export type MutationUpsertMetadataBrandShortNameArgs = {
  create: MetadataBrandShortNameCreateInput;
  update: MetadataBrandShortNameUpdateInput;
  where: MetadataBrandShortNameWhereUniqueInput;
};


export type MutationUpsertMetadataByLineArgs = {
  create: MetadataByLineCreateInput;
  update: MetadataByLineUpdateInput;
  where: MetadataByLineWhereUniqueInput;
};


export type MutationUpsertMetadataCaptionArgs = {
  create: MetadataCaptionCreateInput;
  update: MetadataCaptionUpdateInput;
  where: MetadataCaptionWhereUniqueInput;
};


export type MutationUpsertMetadataCaptionAbstractArgs = {
  create: MetadataCaptionAbstractCreateInput;
  update: MetadataCaptionAbstractUpdateInput;
  where: MetadataCaptionAbstractWhereUniqueInput;
};


export type MutationUpsertMetadataCategoryArgs = {
  create: MetadataCategoryCreateInput;
  update: MetadataCategoryUpdateInput;
  where: MetadataCategoryWhereUniqueInput;
};


export type MutationUpsertMetadataCategoryPrismaArgs = {
  create: MetadataCategoryPrismaCreateInput;
  update: MetadataCategoryPrismaUpdateInput;
  where: MetadataCategoryPrismaWhereUniqueInput;
};


export type MutationUpsertMetadataCompanyArgs = {
  create: MetadataCompanyCreateInput;
  update: MetadataCompanyUpdateInput;
  where: MetadataCompanyWhereUniqueInput;
};


export type MutationUpsertMetadataCompanyShortNameArgs = {
  create: MetadataCompanyShortNameCreateInput;
  update: MetadataCompanyShortNameUpdateInput;
  where: MetadataCompanyShortNameWhereUniqueInput;
};


export type MutationUpsertMetadataCopyrightNoticeArgs = {
  create: MetadataCopyrightNoticeCreateInput;
  update: MetadataCopyrightNoticeUpdateInput;
  where: MetadataCopyrightNoticeWhereUniqueInput;
};


export type MutationUpsertMetadataCreatorArgs = {
  create: MetadataCreatorCreateInput;
  update: MetadataCreatorUpdateInput;
  where: MetadataCreatorWhereUniqueInput;
};


export type MutationUpsertMetadataCreditArgs = {
  create: MetadataCreditCreateInput;
  update: MetadataCreditUpdateInput;
  where: MetadataCreditWhereUniqueInput;
};


export type MutationUpsertMetadataCustomField1Args = {
  create: MetadataCustomField1CreateInput;
  update: MetadataCustomField1UpdateInput;
  where: MetadataCustomField1WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField14Args = {
  create: MetadataCustomField14CreateInput;
  update: MetadataCustomField14UpdateInput;
  where: MetadataCustomField14WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField15Args = {
  create: MetadataCustomField15CreateInput;
  update: MetadataCustomField15UpdateInput;
  where: MetadataCustomField15WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField16Args = {
  create: MetadataCustomField16CreateInput;
  update: MetadataCustomField16UpdateInput;
  where: MetadataCustomField16WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField17Args = {
  create: MetadataCustomField17CreateInput;
  update: MetadataCustomField17UpdateInput;
  where: MetadataCustomField17WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField20Args = {
  create: MetadataCustomField20CreateInput;
  update: MetadataCustomField20UpdateInput;
  where: MetadataCustomField20WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField3Args = {
  create: MetadataCustomField3CreateInput;
  update: MetadataCustomField3UpdateInput;
  where: MetadataCustomField3WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField4Args = {
  create: MetadataCustomField4CreateInput;
  update: MetadataCustomField4UpdateInput;
  where: MetadataCustomField4WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField5Args = {
  create: MetadataCustomField5CreateInput;
  update: MetadataCustomField5UpdateInput;
  where: MetadataCustomField5WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField6Args = {
  create: MetadataCustomField6CreateInput;
  update: MetadataCustomField6UpdateInput;
  where: MetadataCustomField6WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField7Args = {
  create: MetadataCustomField7CreateInput;
  update: MetadataCustomField7UpdateInput;
  where: MetadataCustomField7WhereUniqueInput;
};


export type MutationUpsertMetadataCustomField9Args = {
  create: MetadataCustomField9CreateInput;
  update: MetadataCustomField9UpdateInput;
  where: MetadataCustomField9WhereUniqueInput;
};


export type MutationUpsertMetadataDateCreatedArgs = {
  create: MetadataDateCreatedCreateInput;
  update: MetadataDateCreatedUpdateInput;
  where: MetadataDateCreatedWhereUniqueInput;
};


export type MutationUpsertMetadataDateTimeOriginalArgs = {
  create: MetadataDateTimeOriginalCreateInput;
  update: MetadataDateTimeOriginalUpdateInput;
  where: MetadataDateTimeOriginalWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryAccountArgs = {
  create: MetadataDeliveryAccountCreateInput;
  update: MetadataDeliveryAccountUpdateInput;
  where: MetadataDeliveryAccountWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryCompanyArgs = {
  create: MetadataDeliveryCompanyCreateInput;
  update: MetadataDeliveryCompanyUpdateInput;
  where: MetadataDeliveryCompanyWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryCopyrightArgs = {
  create: MetadataDeliveryCopyrightCreateInput;
  update: MetadataDeliveryCopyrightUpdateInput;
  where: MetadataDeliveryCopyrightWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryDateFolderArgs = {
  create: MetadataDeliveryDateFolderCreateInput;
  update: MetadataDeliveryDateFolderUpdateInput;
  where: MetadataDeliveryDateFolderWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryDateTimeArgs = {
  create: MetadataDeliveryDateTimeCreateInput;
  update: MetadataDeliveryDateTimeUpdateInput;
  where: MetadataDeliveryDateTimeWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryDcCreatorArgs = {
  create: MetadataDeliveryDcCreatorCreateInput;
  update: MetadataDeliveryDcCreatorUpdateInput;
  where: MetadataDeliveryDcCreatorWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryDcRightsArgs = {
  create: MetadataDeliveryDcRightsCreateInput;
  update: MetadataDeliveryDcRightsUpdateInput;
  where: MetadataDeliveryDcRightsWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryFolderArgs = {
  create: MetadataDeliveryFolderCreateInput;
  update: MetadataDeliveryFolderUpdateInput;
  where: MetadataDeliveryFolderWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryKindArgs = {
  create: MetadataDeliveryKindCreateInput;
  update: MetadataDeliveryKindUpdateInput;
  where: MetadataDeliveryKindWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryPathArgs = {
  create: MetadataDeliveryPathCreateInput;
  update: MetadataDeliveryPathUpdateInput;
  where: MetadataDeliveryPathWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryPhotoshopCreditArgs = {
  create: MetadataDeliveryPhotoshopCreditCreateInput;
  update: MetadataDeliveryPhotoshopCreditUpdateInput;
  where: MetadataDeliveryPhotoshopCreditWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryPhotoshopSourceArgs = {
  create: MetadataDeliveryPhotoshopSourceCreateInput;
  update: MetadataDeliveryPhotoshopSourceUpdateInput;
  where: MetadataDeliveryPhotoshopSourceWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryServiceArgs = {
  create: MetadataDeliveryServiceCreateInput;
  update: MetadataDeliveryServiceUpdateInput;
  where: MetadataDeliveryServiceWhereUniqueInput;
};


export type MutationUpsertMetadataDeliverySubjectArgs = {
  create: MetadataDeliverySubjectCreateInput;
  update: MetadataDeliverySubjectUpdateInput;
  where: MetadataDeliverySubjectWhereUniqueInput;
};


export type MutationUpsertMetadataDeliveryUnderSubjectArgs = {
  create: MetadataDeliveryUnderSubjectCreateInput;
  update: MetadataDeliveryUnderSubjectUpdateInput;
  where: MetadataDeliveryUnderSubjectWhereUniqueInput;
};


export type MutationUpsertMetadataDepartmentArgs = {
  create: MetadataDepartmentCreateInput;
  update: MetadataDepartmentUpdateInput;
  where: MetadataDepartmentWhereUniqueInput;
};


export type MutationUpsertMetadataDescriptionArgs = {
  create: MetadataDescriptionCreateInput;
  update: MetadataDescriptionUpdateInput;
  where: MetadataDescriptionWhereUniqueInput;
};


export type MutationUpsertMetadataEditionArgs = {
  create: MetadataEditionCreateInput;
  update: MetadataEditionUpdateInput;
  where: MetadataEditionWhereUniqueInput;
};


export type MutationUpsertMetadataEditStatusArgs = {
  create: MetadataEditStatusCreateInput;
  update: MetadataEditStatusUpdateInput;
  where: MetadataEditStatusWhereUniqueInput;
};


export type MutationUpsertMetadataFileStatusArgs = {
  create: MetadataFileStatusCreateInput;
  update: MetadataFileStatusUpdateInput;
  where: MetadataFileStatusWhereUniqueInput;
};


export type MutationUpsertMetadataFormatArgs = {
  create: MetadataFormatCreateInput;
  update: MetadataFormatUpdateInput;
  where: MetadataFormatWhereUniqueInput;
};


export type MutationUpsertMetadataHeaderArgs = {
  create: MetadataHeaderCreateInput;
  update: MetadataHeaderUpdateInput;
  where: MetadataHeaderWhereUniqueInput;
};


export type MutationUpsertMetadataHeaderPrismaArgs = {
  create: MetadataHeaderPrismaCreateInput;
  update: MetadataHeaderPrismaUpdateInput;
  where: MetadataHeaderPrismaWhereUniqueInput;
};


export type MutationUpsertMetadataHeadlineArgs = {
  create: MetadataHeadlineCreateInput;
  update: MetadataHeadlineUpdateInput;
  where: MetadataHeadlineWhereUniqueInput;
};


export type MutationUpsertMetadataIdAssignmentArgs = {
  create: MetadataIdAssignmentCreateInput;
  update: MetadataIdAssignmentUpdateInput;
  where: MetadataIdAssignmentWhereUniqueInput;
};


export type MutationUpsertMetadataIdPhotoPrismaArgs = {
  create: MetadataIdPhotoPrismaCreateInput;
  update: MetadataIdPhotoPrismaUpdateInput;
  where: MetadataIdPhotoPrismaWhereUniqueInput;
};


export type MutationUpsertMetadataIdSubjectArgs = {
  create: MetadataIdSubjectCreateInput;
  update: MetadataIdSubjectUpdateInput;
  where: MetadataIdSubjectWhereUniqueInput;
};


export type MutationUpsertMetadataImageNotesArgs = {
  create: MetadataImageNotesCreateInput;
  update: MetadataImageNotesUpdateInput;
  where: MetadataImageNotesWhereUniqueInput;
};


export type MutationUpsertMetadataInstructionsArgs = {
  create: MetadataInstructionsCreateInput;
  update: MetadataInstructionsUpdateInput;
  where: MetadataInstructionsWhereUniqueInput;
};


export type MutationUpsertMetadataIssueArgs = {
  create: MetadataIssueCreateInput;
  update: MetadataIssueUpdateInput;
  where: MetadataIssueWhereUniqueInput;
};


export type MutationUpsertMetadataKeywordsArgs = {
  create: MetadataKeywordsCreateInput;
  update: MetadataKeywordsUpdateInput;
  where: MetadataKeywordsWhereUniqueInput;
};


export type MutationUpsertMetadataObjectNameArgs = {
  create: MetadataObjectNameCreateInput;
  update: MetadataObjectNameUpdateInput;
  where: MetadataObjectNameWhereUniqueInput;
};


export type MutationUpsertMetadataOriginalNameArgs = {
  create: MetadataOriginalNameCreateInput;
  update: MetadataOriginalNameUpdateInput;
  where: MetadataOriginalNameWhereUniqueInput;
};


export type MutationUpsertMetadataPriceLevelArgs = {
  create: MetadataPriceLevelCreateInput;
  update: MetadataPriceLevelUpdateInput;
  where: MetadataPriceLevelWhereUniqueInput;
};


export type MutationUpsertMetadataProcessHistoryArgs = {
  create: MetadataProcessHistoryCreateInput;
  update: MetadataProcessHistoryUpdateInput;
  where: MetadataProcessHistoryWhereUniqueInput;
};


export type MutationUpsertMetadataProcessStatusArgs = {
  create: MetadataProcessStatusCreateInput;
  update: MetadataProcessStatusUpdateInput;
  where: MetadataProcessStatusWhereUniqueInput;
};


export type MutationUpsertMetadataProductArgs = {
  create: MetadataProductCreateInput;
  update: MetadataProductUpdateInput;
  where: MetadataProductWhereUniqueInput;
};


export type MutationUpsertMetadataProductsArgs = {
  create: MetadataProductsCreateInput;
  update: MetadataProductsUpdateInput;
  where: MetadataProductsWhereUniqueInput;
};


export type MutationUpsertMetadataPublishingSubjectArgs = {
  create: MetadataPublishingSubjectCreateInput;
  update: MetadataPublishingSubjectUpdateInput;
  where: MetadataPublishingSubjectWhereUniqueInput;
};


export type MutationUpsertMetadataResolutionKindArgs = {
  create: MetadataResolutionKindCreateInput;
  update: MetadataResolutionKindUpdateInput;
  where: MetadataResolutionKindWhereUniqueInput;
};


export type MutationUpsertMetadataRightsArgs = {
  create: MetadataRightsCreateInput;
  update: MetadataRightsUpdateInput;
  where: MetadataRightsWhereUniqueInput;
};


export type MutationUpsertMetadataSourceArgs = {
  create: MetadataSourceCreateInput;
  update: MetadataSourceUpdateInput;
  where: MetadataSourceWhereUniqueInput;
};


export type MutationUpsertMetadataSpecialInstructionsArgs = {
  create: MetadataSpecialInstructionsCreateInput;
  update: MetadataSpecialInstructionsUpdateInput;
  where: MetadataSpecialInstructionsWhereUniqueInput;
};


export type MutationUpsertMetadataSubjectArgs = {
  create: MetadataSubjectCreateInput;
  update: MetadataSubjectUpdateInput;
  where: MetadataSubjectWhereUniqueInput;
};


export type MutationUpsertMetadataSubjectCodeArgs = {
  create: MetadataSubjectCodeCreateInput;
  update: MetadataSubjectCodeUpdateInput;
  where: MetadataSubjectCodeWhereUniqueInput;
};


export type MutationUpsertMetadataSubjectPrismaArgs = {
  create: MetadataSubjectPrismaCreateInput;
  update: MetadataSubjectPrismaUpdateInput;
  where: MetadataSubjectPrismaWhereUniqueInput;
};


export type MutationUpsertMetadataTitleArgs = {
  create: MetadataTitleCreateInput;
  update: MetadataTitleUpdateInput;
  where: MetadataTitleWhereUniqueInput;
};


export type MutationUpsertMetadataTransferredByArgs = {
  create: MetadataTransferredByCreateInput;
  update: MetadataTransferredByUpdateInput;
  where: MetadataTransferredByWhereUniqueInput;
};


export type MutationUpsertMetadataTransferredByFullNameArgs = {
  create: MetadataTransferredByFullNameCreateInput;
  update: MetadataTransferredByFullNameUpdateInput;
  where: MetadataTransferredByFullNameWhereUniqueInput;
};


export type MutationUpsertMetadataTypeArgs = {
  create: MetadataTypeCreateInput;
  update: MetadataTypeUpdateInput;
  where: MetadataTypeWhereUniqueInput;
};


export type MutationUpsertMetadataUndersubjectArgs = {
  create: MetadataUndersubjectCreateInput;
  update: MetadataUndersubjectUpdateInput;
  where: MetadataUndersubjectWhereUniqueInput;
};


export type MutationUpsertMetadataUnderUnderSubjectArgs = {
  create: MetadataUnderUnderSubjectCreateInput;
  update: MetadataUnderUnderSubjectUpdateInput;
  where: MetadataUnderUnderSubjectWhereUniqueInput;
};


export type MutationUpsertMetadataUploadedByArgs = {
  create: MetadataUploadedByCreateInput;
  update: MetadataUploadedByUpdateInput;
  where: MetadataUploadedByWhereUniqueInput;
};


export type MutationUpsertMetadataUploadedByFullNameArgs = {
  create: MetadataUploadedByFullNameCreateInput;
  update: MetadataUploadedByFullNameUpdateInput;
  where: MetadataUploadedByFullNameWhereUniqueInput;
};


export type MutationUpsertMetadataUploadTimeArgs = {
  create: MetadataUploadTimeCreateInput;
  update: MetadataUploadTimeUpdateInput;
  where: MetadataUploadTimeWhereUniqueInput;
};


export type MutationUpsertMetadataUrgencyArgs = {
  create: MetadataUrgencyCreateInput;
  update: MetadataUrgencyUpdateInput;
  where: MetadataUrgencyWhereUniqueInput;
};


export type MutationUpsertMetadataUserDefined195Args = {
  create: MetadataUserDefined195CreateInput;
  update: MetadataUserDefined195UpdateInput;
  where: MetadataUserDefined195WhereUniqueInput;
};


export type MutationUpsertMetadataUserDefined237Args = {
  create: MetadataUserDefined237CreateInput;
  update: MetadataUserDefined237UpdateInput;
  where: MetadataUserDefined237WhereUniqueInput;
};


export type MutationUpsertMetadataUserDefined238Args = {
  create: MetadataUserDefined238CreateInput;
  update: MetadataUserDefined238UpdateInput;
  where: MetadataUserDefined238WhereUniqueInput;
};


export type MutationUpsertMetadataUserDefined239Args = {
  create: MetadataUserDefined239CreateInput;
  update: MetadataUserDefined239UpdateInput;
  where: MetadataUserDefined239WhereUniqueInput;
};


export type MutationUpsertMetadataUserDefined242Args = {
  create: MetadataUserDefined242CreateInput;
  update: MetadataUserDefined242UpdateInput;
  where: MetadataUserDefined242WhereUniqueInput;
};


export type MutationUpsertMetadataUserDefined62Args = {
  create: MetadataUserDefined62CreateInput;
  update: MetadataUserDefined62UpdateInput;
  where: MetadataUserDefined62WhereUniqueInput;
};


export type MutationUpsertMetadataWorkflowKindArgs = {
  create: MetadataWorkflowKindCreateInput;
  update: MetadataWorkflowKindUpdateInput;
  where: MetadataWorkflowKindWhereUniqueInput;
};


export type MutationUpsertMetadataXmpHistoryArgs = {
  create: MetadataXmpHistoryCreateInput;
  update: MetadataXmpHistoryUpdateInput;
  where: MetadataXmpHistoryWhereUniqueInput;
};


export type MutationUpsertPhotoArgs = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};


export type MutationUpsertPhotoMetadataArgs = {
  create: PhotoMetadataCreateInput;
  update: PhotoMetadataUpdateInput;
  where: PhotoMetadataWhereUniqueInput;
};


export type MutationUpsertPhotoPublicationArgs = {
  create: PhotoPublicationCreateInput;
  update: PhotoPublicationUpdateInput;
  where: PhotoPublicationWhereUniqueInput;
};

/** "Photo" resource's node */
export type Photo = {
  __typename?: 'Photo';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  agency?: Maybe<Agency>;
  archive: Archive;
  category?: Maybe<Category>;
  /** asset content type */
  contentType?: Maybe<Scalars['String']['output']>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  deliverySubject?: Maybe<DeliverySubject>;
  /** get private download URL */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  filesize?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** The date of the photo's importation */
  importedAt?: Maybe<Scalars['DateTime']['output']>;
  /** "ImportQueue.photo"'s inverse relation */
  importQueue?: Maybe<ImportQueue>;
  isLegacy?: Maybe<Scalars['Boolean']['output']>;
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  /** "MetadataAccessRights.photo"'s inverse relation count */
  Metadata_AccessRightCount: Scalars['Int']['output'];
  /** "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights: Array<MetadataAccessRights>;
  /** "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState: Array<MetadataAssetState>;
  /** "MetadataAssetState.photo"'s inverse relation count */
  Metadata_AssetStateCount: Scalars['Int']['output'];
  /** "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName: Array<MetadataBackupName>;
  /** "MetadataBackupName.photo"'s inverse relation count */
  Metadata_BackupNameCount: Scalars['Int']['output'];
  /** "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand: Array<MetadataBrand>;
  /** "MetadataBrand.photo"'s inverse relation count */
  Metadata_BrandCount: Scalars['Int']['output'];
  /** "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma: Array<MetadataBrandPrisma>;
  /** "MetadataBrandPrisma.photo"'s inverse relation count */
  Metadata_BrandPrismaCount: Scalars['Int']['output'];
  /** "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName: Array<MetadataBrandShortName>;
  /** "MetadataBrandShortName.photo"'s inverse relation count */
  Metadata_BrandShortNameCount: Scalars['Int']['output'];
  /** "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line: Array<MetadataByLine>;
  /** "MetadataByLine.photo"'s inverse relation count */
  Metadata_By_lineCount: Scalars['Int']['output'];
  /** "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption: Array<MetadataCaption>;
  /** "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract: Array<MetadataCaptionAbstract>;
  /** "MetadataCaptionAbstract.photo"'s inverse relation count */
  Metadata_Caption_AbstractCount: Scalars['Int']['output'];
  /** "MetadataCaption.photo"'s inverse relation count */
  Metadata_CaptionCount: Scalars['Int']['output'];
  /** "MetadataCategory.photo"'s inverse relation */
  Metadata_Category: Array<MetadataCategory>;
  /** "MetadataCategory.photo"'s inverse relation count */
  Metadata_CategoryCount: Scalars['Int']['output'];
  /** "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma: Array<MetadataCategoryPrisma>;
  /** "MetadataCategoryPrisma.photo"'s inverse relation count */
  Metadata_CategoryPrismaCount: Scalars['Int']['output'];
  /** "MetadataCompany.photo"'s inverse relation */
  Metadata_Company: Array<MetadataCompany>;
  /** "MetadataCompany.photo"'s inverse relation count */
  Metadata_CompanyCount: Scalars['Int']['output'];
  /** "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName: Array<MetadataCompanyShortName>;
  /** "MetadataCompanyShortName.photo"'s inverse relation count */
  Metadata_CompanyShortNameCount: Scalars['Int']['output'];
  /** "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice: Array<MetadataCopyrightNotice>;
  /** "MetadataCopyrightNotice.photo"'s inverse relation count */
  Metadata_CopyrightNoticeCount: Scalars['Int']['output'];
  /** "MetadataCreator.photo"'s inverse relation */
  Metadata_creator: Array<MetadataCreator>;
  /** "MetadataCreator.photo"'s inverse relation count */
  Metadata_creatorCount: Scalars['Int']['output'];
  /** "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit: Array<MetadataCredit>;
  /** "MetadataCredit.photo"'s inverse relation count */
  Metadata_CreditCount: Scalars['Int']['output'];
  /** "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1: Array<MetadataCustomField1>;
  /** "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14: Array<MetadataCustomField14>;
  /** "MetadataCustomField14.photo"'s inverse relation count */
  Metadata_CustomField14Count: Scalars['Int']['output'];
  /** "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15: Array<MetadataCustomField15>;
  /** "MetadataCustomField15.photo"'s inverse relation count */
  Metadata_CustomField15Count: Scalars['Int']['output'];
  /** "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16: Array<MetadataCustomField16>;
  /** "MetadataCustomField16.photo"'s inverse relation count */
  Metadata_CustomField16Count: Scalars['Int']['output'];
  /** "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17: Array<MetadataCustomField17>;
  /** "MetadataCustomField17.photo"'s inverse relation count */
  Metadata_CustomField17Count: Scalars['Int']['output'];
  /** "MetadataCustomField1.photo"'s inverse relation count */
  Metadata_CustomField1Count: Scalars['Int']['output'];
  /** "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20: Array<MetadataCustomField20>;
  /** "MetadataCustomField20.photo"'s inverse relation count */
  Metadata_CustomField20Count: Scalars['Int']['output'];
  /** "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3: Array<MetadataCustomField3>;
  /** "MetadataCustomField3.photo"'s inverse relation count */
  Metadata_CustomField3Count: Scalars['Int']['output'];
  /** "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4: Array<MetadataCustomField4>;
  /** "MetadataCustomField4.photo"'s inverse relation count */
  Metadata_CustomField4Count: Scalars['Int']['output'];
  /** "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5: Array<MetadataCustomField5>;
  /** "MetadataCustomField5.photo"'s inverse relation count */
  Metadata_CustomField5Count: Scalars['Int']['output'];
  /** "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6: Array<MetadataCustomField6>;
  /** "MetadataCustomField6.photo"'s inverse relation count */
  Metadata_CustomField6Count: Scalars['Int']['output'];
  /** "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7: Array<MetadataCustomField7>;
  /** "MetadataCustomField7.photo"'s inverse relation count */
  Metadata_CustomField7Count: Scalars['Int']['output'];
  /** "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9: Array<MetadataCustomField9>;
  /** "MetadataCustomField9.photo"'s inverse relation count */
  Metadata_CustomField9Count: Scalars['Int']['output'];
  /** "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated: Array<MetadataDateCreated>;
  /** "MetadataDateCreated.photo"'s inverse relation count */
  Metadata_DateCreatedCount: Scalars['Int']['output'];
  /** "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal: Array<MetadataDateTimeOriginal>;
  /** "MetadataDateTimeOriginal.photo"'s inverse relation count */
  Metadata_DateTimeOriginalCount: Scalars['Int']['output'];
  /** "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount: Array<MetadataDeliveryAccount>;
  /** "MetadataDeliveryAccount.photo"'s inverse relation count */
  Metadata_DeliveryAccountCount: Scalars['Int']['output'];
  /** "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany: Array<MetadataDeliveryCompany>;
  /** "MetadataDeliveryCompany.photo"'s inverse relation count */
  Metadata_DeliveryCompanyCount: Scalars['Int']['output'];
  /** "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright: Array<MetadataDeliveryCopyright>;
  /** "MetadataDeliveryCopyright.photo"'s inverse relation count */
  Metadata_DeliveryCopyrightCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder: Array<MetadataDeliveryDateFolder>;
  /** "MetadataDeliveryDateFolder.photo"'s inverse relation count */
  Metadata_DeliveryDateFolderCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime: Array<MetadataDeliveryDateTime>;
  /** "MetadataDeliveryDateTime.photo"'s inverse relation count */
  Metadata_DeliveryDateTimeCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator: Array<MetadataDeliveryDcCreator>;
  /** "MetadataDeliveryDcCreator.photo"'s inverse relation count */
  Metadata_DeliveryDcCreatorCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDcRights.photo"'s inverse relation count */
  Metadata_DeliveryDcRightCount: Scalars['Int']['output'];
  /** "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights: Array<MetadataDeliveryDcRights>;
  /** "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder: Array<MetadataDeliveryFolder>;
  /** "MetadataDeliveryFolder.photo"'s inverse relation count */
  Metadata_DeliveryFolderCount: Scalars['Int']['output'];
  /** "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind: Array<MetadataDeliveryKind>;
  /** "MetadataDeliveryKind.photo"'s inverse relation count */
  Metadata_DeliveryKindCount: Scalars['Int']['output'];
  /** "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath: Array<MetadataDeliveryPath>;
  /** "MetadataDeliveryPath.photo"'s inverse relation count */
  Metadata_DeliveryPathCount: Scalars['Int']['output'];
  /** "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit: Array<MetadataDeliveryPhotoshopCredit>;
  /** "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation count */
  Metadata_DeliveryPhotoshopCreditCount: Scalars['Int']['output'];
  /** "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource: Array<MetadataDeliveryPhotoshopSource>;
  /** "MetadataDeliveryPhotoshopSource.photo"'s inverse relation count */
  Metadata_DeliveryPhotoshopSourceCount: Scalars['Int']['output'];
  /** "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService: Array<MetadataDeliveryService>;
  /** "MetadataDeliveryService.photo"'s inverse relation count */
  Metadata_DeliveryServiceCount: Scalars['Int']['output'];
  /** "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject: Array<MetadataDeliverySubject>;
  /** "MetadataDeliverySubject.photo"'s inverse relation count */
  Metadata_DeliverySubjectCount: Scalars['Int']['output'];
  /** "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject: Array<MetadataDeliveryUnderSubject>;
  /** "MetadataDeliveryUnderSubject.photo"'s inverse relation count */
  Metadata_DeliveryUnderSubjectCount: Scalars['Int']['output'];
  /** "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department: Array<MetadataDepartment>;
  /** "MetadataDepartment.photo"'s inverse relation count */
  Metadata_DepartmentCount: Scalars['Int']['output'];
  /** "MetadataDescription.photo"'s inverse relation */
  Metadata_description: Array<MetadataDescription>;
  /** "MetadataDescription.photo"'s inverse relation count */
  Metadata_descriptionCount: Scalars['Int']['output'];
  /** "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition: Array<MetadataEdition>;
  /** "MetadataEdition.photo"'s inverse relation count */
  Metadata_EditionCount: Scalars['Int']['output'];
  /** "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus: Array<MetadataEditStatus>;
  /** "MetadataEditStatus.photo"'s inverse relation count */
  Metadata_EditStatusCount: Scalars['Int']['output'];
  /** "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus: Array<MetadataFileStatus>;
  /** "MetadataFileStatus.photo"'s inverse relation count */
  Metadata_FileStatusCount: Scalars['Int']['output'];
  /** "MetadataFormat.photo"'s inverse relation */
  Metadata_Format: Array<MetadataFormat>;
  /** "MetadataFormat.photo"'s inverse relation count */
  Metadata_FormatCount: Scalars['Int']['output'];
  /** "MetadataHeader.photo"'s inverse relation */
  Metadata_Header: Array<MetadataHeader>;
  /** "MetadataHeader.photo"'s inverse relation count */
  Metadata_HeaderCount: Scalars['Int']['output'];
  /** "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma: Array<MetadataHeaderPrisma>;
  /** "MetadataHeaderPrisma.photo"'s inverse relation count */
  Metadata_HeaderPrismaCount: Scalars['Int']['output'];
  /** "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline: Array<MetadataHeadline>;
  /** "MetadataHeadline.photo"'s inverse relation count */
  Metadata_HeadlineCount: Scalars['Int']['output'];
  /** "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject: Array<MetadataIdSubject>;
  /** "MetadataIdSubject.photo"'s inverse relation count */
  Metadata_ID_subjectCount: Scalars['Int']['output'];
  /** "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment: Array<MetadataIdAssignment>;
  /** "MetadataIdAssignment.photo"'s inverse relation count */
  Metadata_IdAssignmentCount: Scalars['Int']['output'];
  /** "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma: Array<MetadataIdPhotoPrisma>;
  /** "MetadataIdPhotoPrisma.photo"'s inverse relation count */
  Metadata_IdPhotoPrismaCount: Scalars['Int']['output'];
  /** "MetadataImageNotes.photo"'s inverse relation count */
  Metadata_ImageNoteCount: Scalars['Int']['output'];
  /** "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes: Array<MetadataImageNotes>;
  /** "MetadataInstructions.photo"'s inverse relation count */
  Metadata_InstructionCount: Scalars['Int']['output'];
  /** "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions: Array<MetadataInstructions>;
  /** "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue: Array<MetadataIssue>;
  /** "MetadataIssue.photo"'s inverse relation count */
  Metadata_IssueCount: Scalars['Int']['output'];
  /** "MetadataKeywords.photo"'s inverse relation count */
  Metadata_KeywordCount: Scalars['Int']['output'];
  /** "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords: Array<MetadataKeywords>;
  /** "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName: Array<MetadataObjectName>;
  /** "MetadataObjectName.photo"'s inverse relation count */
  Metadata_ObjectNameCount: Scalars['Int']['output'];
  /** "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName: Array<MetadataOriginalName>;
  /** "MetadataOriginalName.photo"'s inverse relation count */
  Metadata_OriginalNameCount: Scalars['Int']['output'];
  /** "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel: Array<MetadataPriceLevel>;
  /** "MetadataPriceLevel.photo"'s inverse relation count */
  Metadata_PriceLevelCount: Scalars['Int']['output'];
  /** "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory: Array<MetadataProcessHistory>;
  /** "MetadataProcessHistory.photo"'s inverse relation count */
  Metadata_ProcessHistoryCount: Scalars['Int']['output'];
  /** "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus: Array<MetadataProcessStatus>;
  /** "MetadataProcessStatus.photo"'s inverse relation count */
  Metadata_ProcessStatusCount: Scalars['Int']['output'];
  /** "MetadataProduct.photo"'s inverse relation */
  Metadata_Product: Array<MetadataProduct>;
  /** "MetadataProducts.photo"'s inverse relation count */
  Metadata_ProductCount: Scalars['Int']['output'];
  /** "MetadataProducts.photo"'s inverse relation */
  Metadata_Products: Array<MetadataProducts>;
  /** "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject: Array<MetadataPublishingSubject>;
  /** "MetadataPublishingSubject.photo"'s inverse relation count */
  Metadata_publishingSubjectCount: Scalars['Int']['output'];
  /** "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind: Array<MetadataResolutionKind>;
  /** "MetadataResolutionKind.photo"'s inverse relation count */
  Metadata_ResolutionKindCount: Scalars['Int']['output'];
  /** "MetadataRights.photo"'s inverse relation count */
  Metadata_rightCount: Scalars['Int']['output'];
  /** "MetadataRights.photo"'s inverse relation */
  Metadata_rights: Array<MetadataRights>;
  /** "MetadataSource.photo"'s inverse relation */
  Metadata_Source: Array<MetadataSource>;
  /** "MetadataSource.photo"'s inverse relation count */
  Metadata_SourceCount: Scalars['Int']['output'];
  /** "MetadataSpecialInstructions.photo"'s inverse relation count */
  Metadata_SpecialInstructionCount: Scalars['Int']['output'];
  /** "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions: Array<MetadataSpecialInstructions>;
  /** "MetadataSubject.photo"'s inverse relation */
  Metadata_subject: Array<MetadataSubject>;
  /** "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode: Array<MetadataSubjectCode>;
  /** "MetadataSubjectCode.photo"'s inverse relation count */
  Metadata_SubjectCodeCount: Scalars['Int']['output'];
  /** "MetadataSubject.photo"'s inverse relation count */
  Metadata_subjectCount: Scalars['Int']['output'];
  /** "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma: Array<MetadataSubjectPrisma>;
  /** "MetadataSubjectPrisma.photo"'s inverse relation count */
  Metadata_SubjectPrismaCount: Scalars['Int']['output'];
  /** "MetadataTitle.photo"'s inverse relation */
  Metadata_title: Array<MetadataTitle>;
  /** "MetadataTitle.photo"'s inverse relation count */
  Metadata_titleCount: Scalars['Int']['output'];
  /** "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy: Array<MetadataTransferredBy>;
  /** "MetadataTransferredBy.photo"'s inverse relation count */
  Metadata_TransferredByCount: Scalars['Int']['output'];
  /** "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName: Array<MetadataTransferredByFullName>;
  /** "MetadataTransferredByFullName.photo"'s inverse relation count */
  Metadata_TransferredByFullNameCount: Scalars['Int']['output'];
  /** "MetadataType.photo"'s inverse relation */
  Metadata_Type: Array<MetadataType>;
  /** "MetadataType.photo"'s inverse relation count */
  Metadata_TypeCount: Scalars['Int']['output'];
  /** "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject: Array<MetadataUndersubject>;
  /** "MetadataUndersubject.photo"'s inverse relation count */
  Metadata_UndersubjectCount: Scalars['Int']['output'];
  /** "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject: Array<MetadataUnderUnderSubject>;
  /** "MetadataUnderUnderSubject.photo"'s inverse relation count */
  Metadata_UnderUnderSubjectCount: Scalars['Int']['output'];
  /** "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy: Array<MetadataUploadedBy>;
  /** "MetadataUploadedBy.photo"'s inverse relation count */
  Metadata_UploadedByCount: Scalars['Int']['output'];
  /** "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName: Array<MetadataUploadedByFullName>;
  /** "MetadataUploadedByFullName.photo"'s inverse relation count */
  Metadata_UploadedByFullNameCount: Scalars['Int']['output'];
  /** "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime: Array<MetadataUploadTime>;
  /** "MetadataUploadTime.photo"'s inverse relation count */
  Metadata_UploadTimeCount: Scalars['Int']['output'];
  /** "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency: Array<MetadataUrgency>;
  /** "MetadataUrgency.photo"'s inverse relation count */
  Metadata_UrgencyCount: Scalars['Int']['output'];
  /** "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195: Array<MetadataUserDefined195>;
  /** "MetadataUserDefined195.photo"'s inverse relation count */
  Metadata_UserDefined195Count: Scalars['Int']['output'];
  /** "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237: Array<MetadataUserDefined237>;
  /** "MetadataUserDefined237.photo"'s inverse relation count */
  Metadata_UserDefined237Count: Scalars['Int']['output'];
  /** "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238: Array<MetadataUserDefined238>;
  /** "MetadataUserDefined238.photo"'s inverse relation count */
  Metadata_UserDefined238Count: Scalars['Int']['output'];
  /** "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239: Array<MetadataUserDefined239>;
  /** "MetadataUserDefined239.photo"'s inverse relation count */
  Metadata_UserDefined239Count: Scalars['Int']['output'];
  /** "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242: Array<MetadataUserDefined242>;
  /** "MetadataUserDefined242.photo"'s inverse relation count */
  Metadata_UserDefined242Count: Scalars['Int']['output'];
  /** "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62: Array<MetadataUserDefined62>;
  /** "MetadataUserDefined62.photo"'s inverse relation count */
  Metadata_UserDefined62Count: Scalars['Int']['output'];
  /** "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind: Array<MetadataWorkflowKind>;
  /** "MetadataWorkflowKind.photo"'s inverse relation count */
  Metadata_WorkflowKindCount: Scalars['Int']['output'];
  /** "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory: Array<MetadataXmpHistory>;
  /** "MetadataXmpHistory.photo"'s inverse relation count */
  Metadata_XMPHistoryCount: Scalars['Int']['output'];
  /** optimized photo metadata listing by name for convenience */
  metadataByName?: Maybe<Scalars['JSONObject']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  /** "PhotoMetadata.photo"'s inverse relation count */
  photoMetadataCount: Scalars['Int']['output'];
  /** "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas: Array<PhotoMetadata>;
  /** "PhotoPublication.photo"'s inverse relation count */
  photoPublicationCount: Scalars['Int']['output'];
  /** "PhotoPublication.photo"'s inverse relation */
  photoPublications: Array<PhotoPublication>;
  /** get all supported resized previews */
  previews?: Maybe<Array<Preview>>;
  /** get an expirable public download URL */
  publicUrl?: Maybe<Scalars['String']['output']>;
  synced?: Maybe<Scalars['Boolean']['output']>;
  /** The date of the photo's capture */
  takenAt?: Maybe<Scalars['DateTime']['output']>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  /** get presigned url from S3 */
  uploadUrl?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};


/** "Photo" resource's node */
export type PhotoMetadata_AccessRightCountArgs = {
  where?: InputMaybe<MetadataAccessRightsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_AccessRightsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataAccessRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataAccessRightsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_AssetStateArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataAssetStateOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataAssetStateWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_AssetStateCountArgs = {
  where?: InputMaybe<MetadataAssetStateWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_BackupNameArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBackupNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBackupNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_BackupNameCountArgs = {
  where?: InputMaybe<MetadataBackupNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_BrandArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_BrandCountArgs = {
  where?: InputMaybe<MetadataBrandWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_BrandPrismaArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandPrismaWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_BrandPrismaCountArgs = {
  where?: InputMaybe<MetadataBrandPrismaWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_BrandShortNameArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandShortNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandShortNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_BrandShortNameCountArgs = {
  where?: InputMaybe<MetadataBrandShortNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_By_LineArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataByLineOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataByLineWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_By_LineCountArgs = {
  where?: InputMaybe<MetadataByLineWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CaptionArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCaptionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCaptionWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_Caption_AbstractArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCaptionAbstractOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCaptionAbstractWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_Caption_AbstractCountArgs = {
  where?: InputMaybe<MetadataCaptionAbstractWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CaptionCountArgs = {
  where?: InputMaybe<MetadataCaptionWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CategoryArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCategoryWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CategoryCountArgs = {
  where?: InputMaybe<MetadataCategoryWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CategoryPrismaArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCategoryPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCategoryPrismaWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CategoryPrismaCountArgs = {
  where?: InputMaybe<MetadataCategoryPrismaWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CompanyArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCompanyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCompanyWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CompanyCountArgs = {
  where?: InputMaybe<MetadataCompanyWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CompanyShortNameArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCompanyShortNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCompanyShortNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CompanyShortNameCountArgs = {
  where?: InputMaybe<MetadataCompanyShortNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CopyrightNoticeArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCopyrightNoticeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CopyrightNoticeCountArgs = {
  where?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CreatorArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCreatorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCreatorWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CreatorCountArgs = {
  where?: InputMaybe<MetadataCreatorWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CreditArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCreditOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCreditWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CreditCountArgs = {
  where?: InputMaybe<MetadataCreditWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField1Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField1OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField1WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField14Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField14OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField14WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField14CountArgs = {
  where?: InputMaybe<MetadataCustomField14WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField15Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField15OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField15WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField15CountArgs = {
  where?: InputMaybe<MetadataCustomField15WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField16Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField16OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField16WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField16CountArgs = {
  where?: InputMaybe<MetadataCustomField16WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField17Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField17OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField17WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField17CountArgs = {
  where?: InputMaybe<MetadataCustomField17WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField1CountArgs = {
  where?: InputMaybe<MetadataCustomField1WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField20Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField20OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField20WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField20CountArgs = {
  where?: InputMaybe<MetadataCustomField20WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField3Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField3OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField3WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField3CountArgs = {
  where?: InputMaybe<MetadataCustomField3WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField4Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField4OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField4WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField4CountArgs = {
  where?: InputMaybe<MetadataCustomField4WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField5Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField5OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField5WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField5CountArgs = {
  where?: InputMaybe<MetadataCustomField5WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField6Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField6OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField6WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField6CountArgs = {
  where?: InputMaybe<MetadataCustomField6WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField7Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField7OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField7WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField7CountArgs = {
  where?: InputMaybe<MetadataCustomField7WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField9Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField9OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField9WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_CustomField9CountArgs = {
  where?: InputMaybe<MetadataCustomField9WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DateCreatedArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDateCreatedOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDateCreatedWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DateCreatedCountArgs = {
  where?: InputMaybe<MetadataDateCreatedWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DateTimeOriginalArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDateTimeOriginalOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DateTimeOriginalCountArgs = {
  where?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryAccountArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryAccountOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryAccountWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryAccountCountArgs = {
  where?: InputMaybe<MetadataDeliveryAccountWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryCompanyArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryCompanyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryCompanyCountArgs = {
  where?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryCopyrightArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryCopyrightOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryCopyrightCountArgs = {
  where?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryDateFolderArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDateFolderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryDateFolderCountArgs = {
  where?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryDateTimeArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDateTimeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryDateTimeCountArgs = {
  where?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryDcCreatorArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDcCreatorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryDcCreatorCountArgs = {
  where?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryDcRightCountArgs = {
  where?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryDcRightsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDcRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryFolderArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryFolderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryFolderWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryFolderCountArgs = {
  where?: InputMaybe<MetadataDeliveryFolderWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryKindArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryKindWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryKindCountArgs = {
  where?: InputMaybe<MetadataDeliveryKindWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryPathArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPathOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPathWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryPathCountArgs = {
  where?: InputMaybe<MetadataDeliveryPathWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryPhotoshopCreditArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryPhotoshopCreditCountArgs = {
  where?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryPhotoshopSourceArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryPhotoshopSourceCountArgs = {
  where?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryServiceArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryServiceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryServiceWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryServiceCountArgs = {
  where?: InputMaybe<MetadataDeliveryServiceWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliverySubjectArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliverySubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliverySubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliverySubjectCountArgs = {
  where?: InputMaybe<MetadataDeliverySubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryUnderSubjectArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryUnderSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DeliveryUnderSubjectCountArgs = {
  where?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DepartmentArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDepartmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDepartmentWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DepartmentCountArgs = {
  where?: InputMaybe<MetadataDepartmentWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DescriptionArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDescriptionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDescriptionWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_DescriptionCountArgs = {
  where?: InputMaybe<MetadataDescriptionWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_EditionArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataEditionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataEditionWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_EditionCountArgs = {
  where?: InputMaybe<MetadataEditionWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_EditStatusArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataEditStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataEditStatusWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_EditStatusCountArgs = {
  where?: InputMaybe<MetadataEditStatusWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_FileStatusArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataFileStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataFileStatusWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_FileStatusCountArgs = {
  where?: InputMaybe<MetadataFileStatusWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_FormatArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataFormatOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataFormatWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_FormatCountArgs = {
  where?: InputMaybe<MetadataFormatWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_HeaderArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeaderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeaderWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_HeaderCountArgs = {
  where?: InputMaybe<MetadataHeaderWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_HeaderPrismaArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeaderPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeaderPrismaWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_HeaderPrismaCountArgs = {
  where?: InputMaybe<MetadataHeaderPrismaWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_HeadlineArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeadlineOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeadlineWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_HeadlineCountArgs = {
  where?: InputMaybe<MetadataHeadlineWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_Id_SubjectArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdSubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_Id_SubjectCountArgs = {
  where?: InputMaybe<MetadataIdSubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_IdAssignmentArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdAssignmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdAssignmentWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_IdAssignmentCountArgs = {
  where?: InputMaybe<MetadataIdAssignmentWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_IdPhotoPrismaArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdPhotoPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_IdPhotoPrismaCountArgs = {
  where?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ImageNoteCountArgs = {
  where?: InputMaybe<MetadataImageNotesWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ImageNotesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataImageNotesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataImageNotesWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_InstructionCountArgs = {
  where?: InputMaybe<MetadataInstructionsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_InstructionsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataInstructionsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataInstructionsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_IssueArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIssueOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIssueWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_IssueCountArgs = {
  where?: InputMaybe<MetadataIssueWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_KeywordCountArgs = {
  where?: InputMaybe<MetadataKeywordsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_KeywordsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataKeywordsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataKeywordsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ObjectNameArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataObjectNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataObjectNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ObjectNameCountArgs = {
  where?: InputMaybe<MetadataObjectNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_OriginalNameArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataOriginalNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataOriginalNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_OriginalNameCountArgs = {
  where?: InputMaybe<MetadataOriginalNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_PriceLevelArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataPriceLevelOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataPriceLevelWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_PriceLevelCountArgs = {
  where?: InputMaybe<MetadataPriceLevelWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ProcessHistoryArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProcessHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProcessHistoryWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ProcessHistoryCountArgs = {
  where?: InputMaybe<MetadataProcessHistoryWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ProcessStatusArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProcessStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProcessStatusWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ProcessStatusCountArgs = {
  where?: InputMaybe<MetadataProcessStatusWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ProductArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProductOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProductWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ProductCountArgs = {
  where?: InputMaybe<MetadataProductsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ProductsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProductsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProductsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_PublishingSubjectArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataPublishingSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataPublishingSubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_PublishingSubjectCountArgs = {
  where?: InputMaybe<MetadataPublishingSubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ResolutionKindArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataResolutionKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataResolutionKindWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_ResolutionKindCountArgs = {
  where?: InputMaybe<MetadataResolutionKindWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_RightCountArgs = {
  where?: InputMaybe<MetadataRightsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_RightsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataRightsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_SourceArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSourceWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_SourceCountArgs = {
  where?: InputMaybe<MetadataSourceWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_SpecialInstructionCountArgs = {
  where?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_SpecialInstructionsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSpecialInstructionsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_SubjectArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_SubjectCodeArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectCodeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectCodeWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_SubjectCodeCountArgs = {
  where?: InputMaybe<MetadataSubjectCodeWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_SubjectCountArgs = {
  where?: InputMaybe<MetadataSubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_SubjectPrismaArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectPrismaWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_SubjectPrismaCountArgs = {
  where?: InputMaybe<MetadataSubjectPrismaWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_TitleArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTitleOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTitleWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_TitleCountArgs = {
  where?: InputMaybe<MetadataTitleWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_TransferredByArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTransferredByOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTransferredByWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_TransferredByCountArgs = {
  where?: InputMaybe<MetadataTransferredByWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_TransferredByFullNameArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTransferredByFullNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_TransferredByFullNameCountArgs = {
  where?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_TypeArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTypeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTypeWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_TypeCountArgs = {
  where?: InputMaybe<MetadataTypeWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UndersubjectArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUndersubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUndersubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UndersubjectCountArgs = {
  where?: InputMaybe<MetadataUndersubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UnderUnderSubjectArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUnderUnderSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UnderUnderSubjectCountArgs = {
  where?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UploadedByArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadedByOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadedByWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UploadedByCountArgs = {
  where?: InputMaybe<MetadataUploadedByWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UploadedByFullNameArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadedByFullNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UploadedByFullNameCountArgs = {
  where?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UploadTimeArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadTimeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadTimeWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UploadTimeCountArgs = {
  where?: InputMaybe<MetadataUploadTimeWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UrgencyArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUrgencyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUrgencyWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UrgencyCountArgs = {
  where?: InputMaybe<MetadataUrgencyWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined195Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined195OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined195WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined195CountArgs = {
  where?: InputMaybe<MetadataUserDefined195WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined237Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined237OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined237WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined237CountArgs = {
  where?: InputMaybe<MetadataUserDefined237WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined238Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined238OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined238WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined238CountArgs = {
  where?: InputMaybe<MetadataUserDefined238WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined239Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined239OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined239WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined239CountArgs = {
  where?: InputMaybe<MetadataUserDefined239WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined242Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined242OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined242WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined242CountArgs = {
  where?: InputMaybe<MetadataUserDefined242WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined62Args = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined62OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined62WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_UserDefined62CountArgs = {
  where?: InputMaybe<MetadataUserDefined62WhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_WorkflowKindArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataWorkflowKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataWorkflowKindWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_WorkflowKindCountArgs = {
  where?: InputMaybe<MetadataWorkflowKindWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_XmpHistoryArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataXmpHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataXmpHistoryWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadata_XmpHistoryCountArgs = {
  where?: InputMaybe<MetadataXmpHistoryWhereInput>;
};


/** "Photo" resource's node */
export type PhotoMetadataByNameArgs = {
  names?: InputMaybe<Array<InputMaybe<MetadataNameEnumType>>>;
};


/** "Photo" resource's node */
export type PhotoPhotoMetadataCountArgs = {
  where?: InputMaybe<PhotoMetadataWhereInput>;
};


/** "Photo" resource's node */
export type PhotoPhotoMetadatasArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoMetadataOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoMetadataWhereInput>;
};


/** "Photo" resource's node */
export type PhotoPhotoPublicationCountArgs = {
  where?: InputMaybe<PhotoPublicationWhereInput>;
};


/** "Photo" resource's node */
export type PhotoPhotoPublicationsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoPublicationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoPublicationWhereInput>;
};

export type PhotoCreateInput = {
  /** Actions for the "Photo.agency" relation */
  agency?: InputMaybe<PhotoNestedAgencyCreateInput>;
  /** Actions for the "Photo.archive" relation */
  archive: PhotoNestedArchiveCreateInput;
  /** Actions for the "Photo.category" relation */
  category?: InputMaybe<PhotoNestedCategoryCreateInput>;
  /** asset content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.deliverySubject" relation */
  deliverySubject?: InputMaybe<PhotoNestedDeliverySubjectCreateInput>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The date of the photo's importation */
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Photo.importQueue" relation: "ImportQueue.photo"'s inverse relation */
  importQueue?: InputMaybe<PhotoNestedImportQueueCreateInput>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Photo.Metadata_AccessRights" relation: "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights?: InputMaybe<PhotoNestedMetadataAccessrightsCreateInput>;
  /** Actions for the "Photo.Metadata_AssetState" relation: "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState?: InputMaybe<PhotoNestedMetadataAssetstateCreateInput>;
  /** Actions for the "Photo.Metadata_BackupName" relation: "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName?: InputMaybe<PhotoNestedMetadataBackupnameCreateInput>;
  /** Actions for the "Photo.Metadata_Brand" relation: "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand?: InputMaybe<PhotoNestedMetadataBrandCreateInput>;
  /** Actions for the "Photo.Metadata_BrandPrisma" relation: "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma?: InputMaybe<PhotoNestedMetadataBrandprismaCreateInput>;
  /** Actions for the "Photo.Metadata_BrandShortName" relation: "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName?: InputMaybe<PhotoNestedMetadataBrandshortnameCreateInput>;
  /** Actions for the "Photo.Metadata_By_line" relation: "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line?: InputMaybe<PhotoNestedMetadataByLineCreateInput>;
  /** Actions for the "Photo.Metadata_Caption" relation: "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption?: InputMaybe<PhotoNestedMetadataCaptionCreateInput>;
  /** Actions for the "Photo.Metadata_Caption_Abstract" relation: "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract?: InputMaybe<PhotoNestedMetadataCaptionAbstractCreateInput>;
  /** Actions for the "Photo.Metadata_Category" relation: "MetadataCategory.photo"'s inverse relation */
  Metadata_Category?: InputMaybe<PhotoNestedMetadataCategoryCreateInput>;
  /** Actions for the "Photo.Metadata_CategoryPrisma" relation: "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma?: InputMaybe<PhotoNestedMetadataCategoryprismaCreateInput>;
  /** Actions for the "Photo.Metadata_Company" relation: "MetadataCompany.photo"'s inverse relation */
  Metadata_Company?: InputMaybe<PhotoNestedMetadataCompanyCreateInput>;
  /** Actions for the "Photo.Metadata_CompanyShortName" relation: "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName?: InputMaybe<PhotoNestedMetadataCompanyshortnameCreateInput>;
  /** Actions for the "Photo.Metadata_CopyrightNotice" relation: "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice?: InputMaybe<PhotoNestedMetadataCopyrightnoticeCreateInput>;
  /** Actions for the "Photo.Metadata_creator" relation: "MetadataCreator.photo"'s inverse relation */
  Metadata_creator?: InputMaybe<PhotoNestedMetadataCreatorCreateInput>;
  /** Actions for the "Photo.Metadata_Credit" relation: "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit?: InputMaybe<PhotoNestedMetadataCreditCreateInput>;
  /** Actions for the "Photo.Metadata_CustomField1" relation: "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1?: InputMaybe<PhotoNestedMetadataCustomfield1CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField14" relation: "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14?: InputMaybe<PhotoNestedMetadataCustomfield14CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField15" relation: "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15?: InputMaybe<PhotoNestedMetadataCustomfield15CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField16" relation: "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16?: InputMaybe<PhotoNestedMetadataCustomfield16CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField17" relation: "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17?: InputMaybe<PhotoNestedMetadataCustomfield17CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField20" relation: "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20?: InputMaybe<PhotoNestedMetadataCustomfield20CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField3" relation: "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3?: InputMaybe<PhotoNestedMetadataCustomfield3CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField4" relation: "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4?: InputMaybe<PhotoNestedMetadataCustomfield4CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField5" relation: "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5?: InputMaybe<PhotoNestedMetadataCustomfield5CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField6" relation: "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6?: InputMaybe<PhotoNestedMetadataCustomfield6CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField7" relation: "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7?: InputMaybe<PhotoNestedMetadataCustomfield7CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField9" relation: "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9?: InputMaybe<PhotoNestedMetadataCustomfield9CreateInput>;
  /** Actions for the "Photo.Metadata_DateCreated" relation: "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated?: InputMaybe<PhotoNestedMetadataDatecreatedCreateInput>;
  /** Actions for the "Photo.Metadata_DateTimeOriginal" relation: "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal?: InputMaybe<PhotoNestedMetadataDatetimeoriginalCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryAccount" relation: "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount?: InputMaybe<PhotoNestedMetadataDeliveryaccountCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCompany" relation: "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany?: InputMaybe<PhotoNestedMetadataDeliverycompanyCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCopyright" relation: "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright?: InputMaybe<PhotoNestedMetadataDeliverycopyrightCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateFolder" relation: "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder?: InputMaybe<PhotoNestedMetadataDeliverydatefolderCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateTime" relation: "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime?: InputMaybe<PhotoNestedMetadataDeliverydatetimeCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcCreator" relation: "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator?: InputMaybe<PhotoNestedMetadataDeliverydccreatorCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcRights" relation: "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights?: InputMaybe<PhotoNestedMetadataDeliverydcrightsCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryFolder" relation: "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder?: InputMaybe<PhotoNestedMetadataDeliveryfolderCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryKind" relation: "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind?: InputMaybe<PhotoNestedMetadataDeliverykindCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPath" relation: "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath?: InputMaybe<PhotoNestedMetadataDeliverypathCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopCredit" relation: "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopcreditCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopSource" relation: "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopsourceCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryService" relation: "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService?: InputMaybe<PhotoNestedMetadataDeliveryserviceCreateInput>;
  /** Actions for the "Photo.Metadata_DeliverySubject" relation: "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject?: InputMaybe<PhotoNestedMetadataDeliverysubjectCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryUnderSubject" relation: "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject?: InputMaybe<PhotoNestedMetadataDeliveryundersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_Department" relation: "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department?: InputMaybe<PhotoNestedMetadataDepartmentCreateInput>;
  /** Actions for the "Photo.Metadata_description" relation: "MetadataDescription.photo"'s inverse relation */
  Metadata_description?: InputMaybe<PhotoNestedMetadataDescriptionCreateInput>;
  /** Actions for the "Photo.Metadata_Edition" relation: "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition?: InputMaybe<PhotoNestedMetadataEditionCreateInput>;
  /** Actions for the "Photo.Metadata_EditStatus" relation: "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus?: InputMaybe<PhotoNestedMetadataEditstatusCreateInput>;
  /** Actions for the "Photo.Metadata_FileStatus" relation: "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus?: InputMaybe<PhotoNestedMetadataFilestatusCreateInput>;
  /** Actions for the "Photo.Metadata_Format" relation: "MetadataFormat.photo"'s inverse relation */
  Metadata_Format?: InputMaybe<PhotoNestedMetadataFormatCreateInput>;
  /** Actions for the "Photo.Metadata_Header" relation: "MetadataHeader.photo"'s inverse relation */
  Metadata_Header?: InputMaybe<PhotoNestedMetadataHeaderCreateInput>;
  /** Actions for the "Photo.Metadata_HeaderPrisma" relation: "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma?: InputMaybe<PhotoNestedMetadataHeaderprismaCreateInput>;
  /** Actions for the "Photo.Metadata_Headline" relation: "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline?: InputMaybe<PhotoNestedMetadataHeadlineCreateInput>;
  /** Actions for the "Photo.Metadata_ID_subject" relation: "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject?: InputMaybe<PhotoNestedMetadataIdSubjectCreateInput>;
  /** Actions for the "Photo.Metadata_IdAssignment" relation: "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment?: InputMaybe<PhotoNestedMetadataIdassignmentCreateInput>;
  /** Actions for the "Photo.Metadata_IdPhotoPrisma" relation: "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma?: InputMaybe<PhotoNestedMetadataIdphotoprismaCreateInput>;
  /** Actions for the "Photo.Metadata_ImageNotes" relation: "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes?: InputMaybe<PhotoNestedMetadataImagenotesCreateInput>;
  /** Actions for the "Photo.Metadata_Instructions" relation: "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions?: InputMaybe<PhotoNestedMetadataInstructionsCreateInput>;
  /** Actions for the "Photo.Metadata_Issue" relation: "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue?: InputMaybe<PhotoNestedMetadataIssueCreateInput>;
  /** Actions for the "Photo.Metadata_Keywords" relation: "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords?: InputMaybe<PhotoNestedMetadataKeywordsCreateInput>;
  /** Actions for the "Photo.Metadata_ObjectName" relation: "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName?: InputMaybe<PhotoNestedMetadataObjectnameCreateInput>;
  /** Actions for the "Photo.Metadata_OriginalName" relation: "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName?: InputMaybe<PhotoNestedMetadataOriginalnameCreateInput>;
  /** Actions for the "Photo.Metadata_PriceLevel" relation: "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel?: InputMaybe<PhotoNestedMetadataPricelevelCreateInput>;
  /** Actions for the "Photo.Metadata_ProcessHistory" relation: "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory?: InputMaybe<PhotoNestedMetadataProcesshistoryCreateInput>;
  /** Actions for the "Photo.Metadata_ProcessStatus" relation: "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus?: InputMaybe<PhotoNestedMetadataProcessstatusCreateInput>;
  /** Actions for the "Photo.Metadata_Product" relation: "MetadataProduct.photo"'s inverse relation */
  Metadata_Product?: InputMaybe<PhotoNestedMetadataProductCreateInput>;
  /** Actions for the "Photo.Metadata_Products" relation: "MetadataProducts.photo"'s inverse relation */
  Metadata_Products?: InputMaybe<PhotoNestedMetadataProductsCreateInput>;
  /** Actions for the "Photo.Metadata_publishingSubject" relation: "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject?: InputMaybe<PhotoNestedMetadataPublishingsubjectCreateInput>;
  /** Actions for the "Photo.Metadata_ResolutionKind" relation: "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind?: InputMaybe<PhotoNestedMetadataResolutionkindCreateInput>;
  /** Actions for the "Photo.Metadata_rights" relation: "MetadataRights.photo"'s inverse relation */
  Metadata_rights?: InputMaybe<PhotoNestedMetadataRightsCreateInput>;
  /** Actions for the "Photo.Metadata_Source" relation: "MetadataSource.photo"'s inverse relation */
  Metadata_Source?: InputMaybe<PhotoNestedMetadataSourceCreateInput>;
  /** Actions for the "Photo.Metadata_SpecialInstructions" relation: "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions?: InputMaybe<PhotoNestedMetadataSpecialinstructionsCreateInput>;
  /** Actions for the "Photo.Metadata_subject" relation: "MetadataSubject.photo"'s inverse relation */
  Metadata_subject?: InputMaybe<PhotoNestedMetadataSubjectCreateInput>;
  /** Actions for the "Photo.Metadata_SubjectCode" relation: "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode?: InputMaybe<PhotoNestedMetadataSubjectcodeCreateInput>;
  /** Actions for the "Photo.Metadata_SubjectPrisma" relation: "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma?: InputMaybe<PhotoNestedMetadataSubjectprismaCreateInput>;
  /** Actions for the "Photo.Metadata_title" relation: "MetadataTitle.photo"'s inverse relation */
  Metadata_title?: InputMaybe<PhotoNestedMetadataTitleCreateInput>;
  /** Actions for the "Photo.Metadata_TransferredBy" relation: "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy?: InputMaybe<PhotoNestedMetadataTransferredbyCreateInput>;
  /** Actions for the "Photo.Metadata_TransferredByFullName" relation: "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName?: InputMaybe<PhotoNestedMetadataTransferredbyfullnameCreateInput>;
  /** Actions for the "Photo.Metadata_Type" relation: "MetadataType.photo"'s inverse relation */
  Metadata_Type?: InputMaybe<PhotoNestedMetadataTypeCreateInput>;
  /** Actions for the "Photo.Metadata_Undersubject" relation: "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject?: InputMaybe<PhotoNestedMetadataUndersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_UnderUnderSubject" relation: "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject?: InputMaybe<PhotoNestedMetadataUnderundersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_UploadedBy" relation: "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy?: InputMaybe<PhotoNestedMetadataUploadedbyCreateInput>;
  /** Actions for the "Photo.Metadata_UploadedByFullName" relation: "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName?: InputMaybe<PhotoNestedMetadataUploadedbyfullnameCreateInput>;
  /** Actions for the "Photo.Metadata_UploadTime" relation: "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime?: InputMaybe<PhotoNestedMetadataUploadtimeCreateInput>;
  /** Actions for the "Photo.Metadata_Urgency" relation: "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency?: InputMaybe<PhotoNestedMetadataUrgencyCreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined195" relation: "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195?: InputMaybe<PhotoNestedMetadataUserdefined195CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined237" relation: "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237?: InputMaybe<PhotoNestedMetadataUserdefined237CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined238" relation: "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238?: InputMaybe<PhotoNestedMetadataUserdefined238CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined239" relation: "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239?: InputMaybe<PhotoNestedMetadataUserdefined239CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined242" relation: "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242?: InputMaybe<PhotoNestedMetadataUserdefined242CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined62" relation: "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62?: InputMaybe<PhotoNestedMetadataUserdefined62CreateInput>;
  /** Actions for the "Photo.Metadata_WorkflowKind" relation: "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind?: InputMaybe<PhotoNestedMetadataWorkflowkindCreateInput>;
  /** Actions for the "Photo.Metadata_XMPHistory" relation: "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory?: InputMaybe<PhotoNestedMetadataXmphistoryCreateInput>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.photoMetadatas" relation: "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas?: InputMaybe<PhotoNestedPhotoMetadatasCreateInput>;
  /** Actions for the "Photo.photoPublications" relation: "PhotoPublication.photo"'s inverse relation */
  photoPublications?: InputMaybe<PhotoNestedPhotoPublicationsCreateInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the photo's capture */
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** "PhotoMetadata" resource's node */
export type PhotoMetadata = {
  __typename?: 'PhotoMetadata';
  archive: Archive;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The ID */
  id: Scalars['Int']['output'];
  metadata: Metadata;
  photo: Photo;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type PhotoMetadataCreateInput = {
  /** Actions for the "PhotoMetadata.archive" relation */
  archive: PhotoMetadataNestedArchiveCreateInput;
  /** Actions for the "PhotoMetadata.metadata" relation */
  metadata: PhotoMetadataNestedMetadataCreateInput;
  /** Actions for the "PhotoMetadata.photo" relation */
  photo: PhotoMetadataNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoMetadataNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "PhotoMetadata" node, through the "PhotoMetadata.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "PhotoMetadata" node, through the "PhotoMetadata.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "PhotoMetadata" node, through the "PhotoMetadata.archive" relation. */
  update?: InputMaybe<PhotoMetadataNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "PhotoMetadata" node, through the "PhotoMetadata.archive" relation. */
  upsert?: InputMaybe<PhotoMetadataNestedUpsertArchiveCreateInput>;
};

export type PhotoMetadataNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "PhotoMetadata" node, through the "PhotoMetadata.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "PhotoMetadata" node, through the "PhotoMetadata.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "PhotoMetadata" node, through the "PhotoMetadata.archive" relation. */
  update?: InputMaybe<PhotoMetadataNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "PhotoMetadata" node, through the "PhotoMetadata.archive" relation. */
  upsert?: InputMaybe<PhotoMetadataNestedUpsertArchiveUpdateInput>;
};

export type PhotoMetadataNestedMetadataCreateInput = {
  /** Connect an existing "Metadata" node to the new "PhotoMetadata" node, through the "PhotoMetadata.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the new "PhotoMetadata" node, through the "PhotoMetadata.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the new "PhotoMetadata" node, through the "PhotoMetadata.metadata" relation. */
  update?: InputMaybe<PhotoMetadataNestedUpdateMetadataCreateInput>;
  /** Create or update a "Metadata" node and connect it to the new "PhotoMetadata" node, through the "PhotoMetadata.metadata" relation. */
  upsert?: InputMaybe<PhotoMetadataNestedUpsertMetadataCreateInput>;
};

export type PhotoMetadataNestedMetadataUpdateInput = {
  /** Connect an existing "Metadata" node to the existing "PhotoMetadata" node, through the "PhotoMetadata.metadata" relation. */
  connect?: InputMaybe<MetadataWhereUniqueInput>;
  /** Create a new "Metadata" node and connect it to the existing "PhotoMetadata" node, through the "PhotoMetadata.metadata" relation. */
  create?: InputMaybe<MetadataCreateInput>;
  /** Update an existing "Metadata" node and connect it to the existing "PhotoMetadata" node, through the "PhotoMetadata.metadata" relation. */
  update?: InputMaybe<PhotoMetadataNestedUpdateMetadataUpdateInput>;
  /** Create or update a "Metadata" node and connect it to the existing "PhotoMetadata" node, through the "PhotoMetadata.metadata" relation. */
  upsert?: InputMaybe<PhotoMetadataNestedUpsertMetadataUpdateInput>;
};

export type PhotoMetadataNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "PhotoMetadata" node, through the "PhotoMetadata.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "PhotoMetadata" node, through the "PhotoMetadata.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "PhotoMetadata" node, through the "PhotoMetadata.photo" relation. */
  update?: InputMaybe<PhotoMetadataNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "PhotoMetadata" node, through the "PhotoMetadata.photo" relation. */
  upsert?: InputMaybe<PhotoMetadataNestedUpsertPhotoCreateInput>;
};

export type PhotoMetadataNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type PhotoMetadataNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type PhotoMetadataNestedUpdateMetadataCreateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type PhotoMetadataNestedUpdateMetadataUpdateInput = {
  data: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type PhotoMetadataNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type PhotoMetadataNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type PhotoMetadataNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type PhotoMetadataNestedUpsertMetadataCreateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type PhotoMetadataNestedUpsertMetadataUpdateInput = {
  create: MetadataCreateInput;
  update: MetadataUpdateInput;
  where: MetadataWhereUniqueInput;
};

export type PhotoMetadataNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum PhotoMetadataOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type PhotoMetadataUpdateInput = {
  /** Actions for the "PhotoMetadata.archive" relation */
  archive?: InputMaybe<PhotoMetadataNestedArchiveUpdateInput>;
  /** Actions for the "PhotoMetadata.metadata" relation */
  metadata?: InputMaybe<PhotoMetadataNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "PhotoMetadata" nodes by specifying some conditions */
export type PhotoMetadataWhereInput = {
  AND?: InputMaybe<Array<PhotoMetadataWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  metadata?: InputMaybe<MetadataWhereInput>;
  NOT?: InputMaybe<PhotoMetadataWhereInput>;
  OR?: InputMaybe<Array<PhotoMetadataWhereInput>>;
  photo?: InputMaybe<PhotoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  value?: InputMaybe<Scalars['String']['input']>;
  value_contains?: InputMaybe<Scalars['String']['input']>;
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_gt?: InputMaybe<Scalars['String']['input']>;
  value_gte?: InputMaybe<Scalars['String']['input']>;
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  value_lt?: InputMaybe<Scalars['String']['input']>;
  value_lte?: InputMaybe<Scalars['String']['input']>;
  value_not?: InputMaybe<Scalars['String']['input']>;
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "PhotoMetadata" node. */
export type PhotoMetadataWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

export type PhotoMetadataWithForcedArchiveCreateInput = {
  /** Actions for the "PhotoMetadata.metadata" relation */
  metadata: PhotoMetadataNestedMetadataCreateInput;
  /** Actions for the "PhotoMetadata.photo" relation */
  photo: PhotoMetadataNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoMetadataWithForcedArchiveUpdateInput = {
  /** Actions for the "PhotoMetadata.metadata" relation */
  metadata?: InputMaybe<PhotoMetadataNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoMetadataWithForcedMetadataCreateInput = {
  /** Actions for the "PhotoMetadata.archive" relation */
  archive: PhotoMetadataNestedArchiveCreateInput;
  /** Actions for the "PhotoMetadata.photo" relation */
  photo: PhotoMetadataNestedPhotoCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoMetadataWithForcedMetadataUpdateInput = {
  /** Actions for the "PhotoMetadata.archive" relation */
  archive?: InputMaybe<PhotoMetadataNestedArchiveUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoMetadataWithForcedPhotoCreateInput = {
  /** Actions for the "PhotoMetadata.archive" relation */
  archive: PhotoMetadataNestedArchiveCreateInput;
  /** Actions for the "PhotoMetadata.metadata" relation */
  metadata: PhotoMetadataNestedMetadataCreateInput;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoMetadataWithForcedPhotoUpdateInput = {
  /** Actions for the "PhotoMetadata.archive" relation */
  archive?: InputMaybe<PhotoMetadataNestedArchiveUpdateInput>;
  /** Actions for the "PhotoMetadata.metadata" relation */
  metadata?: InputMaybe<PhotoMetadataNestedMetadataUpdateInput>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoNestedAgencyCreateInput = {
  /** Connect an existing "Agency" node to the new "Photo" node, through the "Photo.agency" relation. */
  connect?: InputMaybe<AgencyWhereUniqueInput>;
  /** Create a new "Agency" node and connect it to the new "Photo" node, through the "Photo.agency" relation. */
  create?: InputMaybe<AgencyCreateInput>;
  /** Update an existing "Agency" node and connect it to the new "Photo" node, through the "Photo.agency" relation. */
  update?: InputMaybe<PhotoNestedUpdateAgencyCreateInput>;
  /** Create or update a "Agency" node and connect it to the new "Photo" node, through the "Photo.agency" relation. */
  upsert?: InputMaybe<PhotoNestedUpsertAgencyCreateInput>;
};

export type PhotoNestedAgencyUpdateInput = {
  /** Connect an existing "Agency" node to the existing "Photo" node, through the "Photo.agency" relation. */
  connect?: InputMaybe<AgencyWhereUniqueInput>;
  /** Create a new "Agency" node and connect it to the existing "Photo" node, through the "Photo.agency" relation. */
  create?: InputMaybe<AgencyCreateInput>;
  /** Disconnect the current connected "Agency" node, if any, of the "Photo.agency" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Agency" node and connect it to the existing "Photo" node, through the "Photo.agency" relation. */
  update?: InputMaybe<PhotoNestedUpdateAgencyUpdateInput>;
  /** Create or update a "Agency" node and connect it to the existing "Photo" node, through the "Photo.agency" relation. */
  upsert?: InputMaybe<PhotoNestedUpsertAgencyUpdateInput>;
};

export type PhotoNestedArchiveCreateInput = {
  /** Connect an existing "Archive" node to the new "Photo" node, through the "Photo.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the new "Photo" node, through the "Photo.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the new "Photo" node, through the "Photo.archive" relation. */
  update?: InputMaybe<PhotoNestedUpdateArchiveCreateInput>;
  /** Create or update a "Archive" node and connect it to the new "Photo" node, through the "Photo.archive" relation. */
  upsert?: InputMaybe<PhotoNestedUpsertArchiveCreateInput>;
};

export type PhotoNestedArchiveUpdateInput = {
  /** Connect an existing "Archive" node to the existing "Photo" node, through the "Photo.archive" relation. */
  connect?: InputMaybe<ArchiveWhereUniqueInput>;
  /** Create a new "Archive" node and connect it to the existing "Photo" node, through the "Photo.archive" relation. */
  create?: InputMaybe<ArchiveCreateInput>;
  /** Update an existing "Archive" node and connect it to the existing "Photo" node, through the "Photo.archive" relation. */
  update?: InputMaybe<PhotoNestedUpdateArchiveUpdateInput>;
  /** Create or update a "Archive" node and connect it to the existing "Photo" node, through the "Photo.archive" relation. */
  upsert?: InputMaybe<PhotoNestedUpsertArchiveUpdateInput>;
};

export type PhotoNestedCategoryCreateInput = {
  /** Connect an existing "Category" node to the new "Photo" node, through the "Photo.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "Photo" node, through the "Photo.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "Photo" node, through the "Photo.category" relation. */
  update?: InputMaybe<PhotoNestedUpdateCategoryCreateInput>;
  /** Create or update a "Category" node and connect it to the new "Photo" node, through the "Photo.category" relation. */
  upsert?: InputMaybe<PhotoNestedUpsertCategoryCreateInput>;
};

export type PhotoNestedCategoryUpdateInput = {
  /** Connect an existing "Category" node to the existing "Photo" node, through the "Photo.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the existing "Photo" node, through the "Photo.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Disconnect the current connected "Category" node, if any, of the "Photo.category" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Category" node and connect it to the existing "Photo" node, through the "Photo.category" relation. */
  update?: InputMaybe<PhotoNestedUpdateCategoryUpdateInput>;
  /** Create or update a "Category" node and connect it to the existing "Photo" node, through the "Photo.category" relation. */
  upsert?: InputMaybe<PhotoNestedUpsertCategoryUpdateInput>;
};

export type PhotoNestedDeliverySubjectCreateInput = {
  /** Connect an existing "DeliverySubject" node to the new "Photo" node, through the "Photo.deliverySubject" relation. */
  connect?: InputMaybe<DeliverySubjectWhereUniqueInput>;
  /** Create a new "DeliverySubject" node and connect it to the new "Photo" node, through the "Photo.deliverySubject" relation. */
  create?: InputMaybe<DeliverySubjectCreateInput>;
  /** Update an existing "DeliverySubject" node and connect it to the new "Photo" node, through the "Photo.deliverySubject" relation. */
  update?: InputMaybe<PhotoNestedUpdateDeliverySubjectCreateInput>;
  /** Create or update a "DeliverySubject" node and connect it to the new "Photo" node, through the "Photo.deliverySubject" relation. */
  upsert?: InputMaybe<PhotoNestedUpsertDeliverySubjectCreateInput>;
};

export type PhotoNestedDeliverySubjectUpdateInput = {
  /** Connect an existing "DeliverySubject" node to the existing "Photo" node, through the "Photo.deliverySubject" relation. */
  connect?: InputMaybe<DeliverySubjectWhereUniqueInput>;
  /** Create a new "DeliverySubject" node and connect it to the existing "Photo" node, through the "Photo.deliverySubject" relation. */
  create?: InputMaybe<DeliverySubjectCreateInput>;
  /** Disconnect the current connected "DeliverySubject" node, if any, of the "Photo.deliverySubject" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "DeliverySubject" node and connect it to the existing "Photo" node, through the "Photo.deliverySubject" relation. */
  update?: InputMaybe<PhotoNestedUpdateDeliverySubjectUpdateInput>;
  /** Create or update a "DeliverySubject" node and connect it to the existing "Photo" node, through the "Photo.deliverySubject" relation. */
  upsert?: InputMaybe<PhotoNestedUpsertDeliverySubjectUpdateInput>;
};

export type PhotoNestedImportQueueCreateInput = {
  /** Connect an existing "ImportQueue" node to the new "Photo" node, through the "Photo.importQueue" relation. */
  connect?: InputMaybe<ImportQueueWhereUniqueInput>;
  /** Create a new "ImportQueue" node and connect it to the new "Photo" node, through the "Photo.importQueue" relation. */
  create?: InputMaybe<ImportQueueWithForcedPhotoCreateInput>;
};

export type PhotoNestedImportQueueUpdateInput = {
  /** Connect an existing "ImportQueue" node to the existing "Photo" node, through the "Photo.importQueue" relation. */
  connect?: InputMaybe<ImportQueueWhereUniqueInput>;
  /** Create a new "ImportQueue" node and connect it to the existing "Photo" node, through the "Photo.importQueue" relation. */
  create?: InputMaybe<ImportQueueWithForcedPhotoCreateInput>;
  /** Delete an existing "ImportQueue" node from the "Photo.importQueue" relation. */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect an existing "ImportQueue" node of the "Photo.importQueue" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "ImportQueue" node and connect it to the existing "Photo" node, through the "Photo.importQueue" relation. */
  update?: InputMaybe<PhotoNestedUpdateImportQueueUpdateInput>;
  /** Upsert an existing "ImportQueue" node and connect it to the existing "Photo" node, through the "Photo.importQueue" relation. */
  upsert?: InputMaybe<PhotoNestedUpsertImportQueueUpdateInput>;
};

export type PhotoNestedMetadataAccessrightsCreateInput = {
  /** Connect existing "MetadataAccessRights" nodes to the new "Photo" node, through the "Photo.Metadata_AccessRights" relation. */
  connect?: InputMaybe<Array<MetadataAccessRightsWhereUniqueInput>>;
  /** Create new "MetadataAccessRights" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_AccessRights" relation. */
  create?: InputMaybe<Array<MetadataAccessRightsWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataAccessrightsUpdateInput = {
  /** Connect existing "MetadataAccessRights" nodes to the existing "Photo" node, through the "Photo.Metadata_AccessRights" relation. */
  connect?: InputMaybe<Array<MetadataAccessRightsWhereUniqueInput>>;
  /** Create new "MetadataAccessRights" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_AccessRights" relation. */
  create?: InputMaybe<Array<MetadataAccessRightsWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataAccessRights" nodes from the "Photo.Metadata_AccessRights" relation. */
  delete?: InputMaybe<Array<MetadataAccessRightsWhereUniqueInput>>;
  /** Update existing "MetadataAccessRights" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_AccessRights" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataAccessrightsUpdateInput>>;
  /** Upsert existing "MetadataAccessRights" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_AccessRights" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataAccessrightsUpdateInput>>;
};

export type PhotoNestedMetadataAssetstateCreateInput = {
  /** Connect existing "MetadataAssetState" nodes to the new "Photo" node, through the "Photo.Metadata_AssetState" relation. */
  connect?: InputMaybe<Array<MetadataAssetStateWhereUniqueInput>>;
  /** Create new "MetadataAssetState" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_AssetState" relation. */
  create?: InputMaybe<Array<MetadataAssetStateWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataAssetstateUpdateInput = {
  /** Connect existing "MetadataAssetState" nodes to the existing "Photo" node, through the "Photo.Metadata_AssetState" relation. */
  connect?: InputMaybe<Array<MetadataAssetStateWhereUniqueInput>>;
  /** Create new "MetadataAssetState" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_AssetState" relation. */
  create?: InputMaybe<Array<MetadataAssetStateWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataAssetState" nodes from the "Photo.Metadata_AssetState" relation. */
  delete?: InputMaybe<Array<MetadataAssetStateWhereUniqueInput>>;
  /** Update existing "MetadataAssetState" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_AssetState" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataAssetstateUpdateInput>>;
  /** Upsert existing "MetadataAssetState" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_AssetState" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataAssetstateUpdateInput>>;
};

export type PhotoNestedMetadataBackupnameCreateInput = {
  /** Connect existing "MetadataBackupName" nodes to the new "Photo" node, through the "Photo.Metadata_BackupName" relation. */
  connect?: InputMaybe<Array<MetadataBackupNameWhereUniqueInput>>;
  /** Create new "MetadataBackupName" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_BackupName" relation. */
  create?: InputMaybe<Array<MetadataBackupNameWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataBackupnameUpdateInput = {
  /** Connect existing "MetadataBackupName" nodes to the existing "Photo" node, through the "Photo.Metadata_BackupName" relation. */
  connect?: InputMaybe<Array<MetadataBackupNameWhereUniqueInput>>;
  /** Create new "MetadataBackupName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_BackupName" relation. */
  create?: InputMaybe<Array<MetadataBackupNameWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataBackupName" nodes from the "Photo.Metadata_BackupName" relation. */
  delete?: InputMaybe<Array<MetadataBackupNameWhereUniqueInput>>;
  /** Update existing "MetadataBackupName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_BackupName" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataBackupnameUpdateInput>>;
  /** Upsert existing "MetadataBackupName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_BackupName" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataBackupnameUpdateInput>>;
};

export type PhotoNestedMetadataBrandCreateInput = {
  /** Connect existing "MetadataBrand" nodes to the new "Photo" node, through the "Photo.Metadata_Brand" relation. */
  connect?: InputMaybe<Array<MetadataBrandWhereUniqueInput>>;
  /** Create new "MetadataBrand" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Brand" relation. */
  create?: InputMaybe<Array<MetadataBrandWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataBrandprismaCreateInput = {
  /** Connect existing "MetadataBrandPrisma" nodes to the new "Photo" node, through the "Photo.Metadata_BrandPrisma" relation. */
  connect?: InputMaybe<Array<MetadataBrandPrismaWhereUniqueInput>>;
  /** Create new "MetadataBrandPrisma" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_BrandPrisma" relation. */
  create?: InputMaybe<Array<MetadataBrandPrismaWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataBrandprismaUpdateInput = {
  /** Connect existing "MetadataBrandPrisma" nodes to the existing "Photo" node, through the "Photo.Metadata_BrandPrisma" relation. */
  connect?: InputMaybe<Array<MetadataBrandPrismaWhereUniqueInput>>;
  /** Create new "MetadataBrandPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_BrandPrisma" relation. */
  create?: InputMaybe<Array<MetadataBrandPrismaWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataBrandPrisma" nodes from the "Photo.Metadata_BrandPrisma" relation. */
  delete?: InputMaybe<Array<MetadataBrandPrismaWhereUniqueInput>>;
  /** Update existing "MetadataBrandPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_BrandPrisma" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataBrandprismaUpdateInput>>;
  /** Upsert existing "MetadataBrandPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_BrandPrisma" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataBrandprismaUpdateInput>>;
};

export type PhotoNestedMetadataBrandshortnameCreateInput = {
  /** Connect existing "MetadataBrandShortName" nodes to the new "Photo" node, through the "Photo.Metadata_BrandShortName" relation. */
  connect?: InputMaybe<Array<MetadataBrandShortNameWhereUniqueInput>>;
  /** Create new "MetadataBrandShortName" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_BrandShortName" relation. */
  create?: InputMaybe<Array<MetadataBrandShortNameWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataBrandshortnameUpdateInput = {
  /** Connect existing "MetadataBrandShortName" nodes to the existing "Photo" node, through the "Photo.Metadata_BrandShortName" relation. */
  connect?: InputMaybe<Array<MetadataBrandShortNameWhereUniqueInput>>;
  /** Create new "MetadataBrandShortName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_BrandShortName" relation. */
  create?: InputMaybe<Array<MetadataBrandShortNameWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataBrandShortName" nodes from the "Photo.Metadata_BrandShortName" relation. */
  delete?: InputMaybe<Array<MetadataBrandShortNameWhereUniqueInput>>;
  /** Update existing "MetadataBrandShortName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_BrandShortName" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataBrandshortnameUpdateInput>>;
  /** Upsert existing "MetadataBrandShortName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_BrandShortName" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataBrandshortnameUpdateInput>>;
};

export type PhotoNestedMetadataBrandUpdateInput = {
  /** Connect existing "MetadataBrand" nodes to the existing "Photo" node, through the "Photo.Metadata_Brand" relation. */
  connect?: InputMaybe<Array<MetadataBrandWhereUniqueInput>>;
  /** Create new "MetadataBrand" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Brand" relation. */
  create?: InputMaybe<Array<MetadataBrandWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataBrand" nodes from the "Photo.Metadata_Brand" relation. */
  delete?: InputMaybe<Array<MetadataBrandWhereUniqueInput>>;
  /** Update existing "MetadataBrand" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Brand" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataBrandUpdateInput>>;
  /** Upsert existing "MetadataBrand" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Brand" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataBrandUpdateInput>>;
};

export type PhotoNestedMetadataByLineCreateInput = {
  /** Connect existing "MetadataByLine" nodes to the new "Photo" node, through the "Photo.Metadata_By_line" relation. */
  connect?: InputMaybe<Array<MetadataByLineWhereUniqueInput>>;
  /** Create new "MetadataByLine" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_By_line" relation. */
  create?: InputMaybe<Array<MetadataByLineWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataByLineUpdateInput = {
  /** Connect existing "MetadataByLine" nodes to the existing "Photo" node, through the "Photo.Metadata_By_line" relation. */
  connect?: InputMaybe<Array<MetadataByLineWhereUniqueInput>>;
  /** Create new "MetadataByLine" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_By_line" relation. */
  create?: InputMaybe<Array<MetadataByLineWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataByLine" nodes from the "Photo.Metadata_By_line" relation. */
  delete?: InputMaybe<Array<MetadataByLineWhereUniqueInput>>;
  /** Update existing "MetadataByLine" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_By_line" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataByLineUpdateInput>>;
  /** Upsert existing "MetadataByLine" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_By_line" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataByLineUpdateInput>>;
};

export type PhotoNestedMetadataCaptionAbstractCreateInput = {
  /** Connect existing "MetadataCaptionAbstract" nodes to the new "Photo" node, through the "Photo.Metadata_Caption_Abstract" relation. */
  connect?: InputMaybe<Array<MetadataCaptionAbstractWhereUniqueInput>>;
  /** Create new "MetadataCaptionAbstract" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Caption_Abstract" relation. */
  create?: InputMaybe<Array<MetadataCaptionAbstractWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCaptionAbstractUpdateInput = {
  /** Connect existing "MetadataCaptionAbstract" nodes to the existing "Photo" node, through the "Photo.Metadata_Caption_Abstract" relation. */
  connect?: InputMaybe<Array<MetadataCaptionAbstractWhereUniqueInput>>;
  /** Create new "MetadataCaptionAbstract" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Caption_Abstract" relation. */
  create?: InputMaybe<Array<MetadataCaptionAbstractWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCaptionAbstract" nodes from the "Photo.Metadata_Caption_Abstract" relation. */
  delete?: InputMaybe<Array<MetadataCaptionAbstractWhereUniqueInput>>;
  /** Update existing "MetadataCaptionAbstract" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Caption_Abstract" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCaptionAbstractUpdateInput>>;
  /** Upsert existing "MetadataCaptionAbstract" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Caption_Abstract" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCaptionAbstractUpdateInput>>;
};

export type PhotoNestedMetadataCaptionCreateInput = {
  /** Connect existing "MetadataCaption" nodes to the new "Photo" node, through the "Photo.Metadata_Caption" relation. */
  connect?: InputMaybe<Array<MetadataCaptionWhereUniqueInput>>;
  /** Create new "MetadataCaption" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Caption" relation. */
  create?: InputMaybe<Array<MetadataCaptionWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCaptionUpdateInput = {
  /** Connect existing "MetadataCaption" nodes to the existing "Photo" node, through the "Photo.Metadata_Caption" relation. */
  connect?: InputMaybe<Array<MetadataCaptionWhereUniqueInput>>;
  /** Create new "MetadataCaption" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Caption" relation. */
  create?: InputMaybe<Array<MetadataCaptionWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCaption" nodes from the "Photo.Metadata_Caption" relation. */
  delete?: InputMaybe<Array<MetadataCaptionWhereUniqueInput>>;
  /** Update existing "MetadataCaption" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Caption" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCaptionUpdateInput>>;
  /** Upsert existing "MetadataCaption" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Caption" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCaptionUpdateInput>>;
};

export type PhotoNestedMetadataCategoryCreateInput = {
  /** Connect existing "MetadataCategory" nodes to the new "Photo" node, through the "Photo.Metadata_Category" relation. */
  connect?: InputMaybe<Array<MetadataCategoryWhereUniqueInput>>;
  /** Create new "MetadataCategory" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Category" relation. */
  create?: InputMaybe<Array<MetadataCategoryWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCategoryprismaCreateInput = {
  /** Connect existing "MetadataCategoryPrisma" nodes to the new "Photo" node, through the "Photo.Metadata_CategoryPrisma" relation. */
  connect?: InputMaybe<Array<MetadataCategoryPrismaWhereUniqueInput>>;
  /** Create new "MetadataCategoryPrisma" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CategoryPrisma" relation. */
  create?: InputMaybe<Array<MetadataCategoryPrismaWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCategoryprismaUpdateInput = {
  /** Connect existing "MetadataCategoryPrisma" nodes to the existing "Photo" node, through the "Photo.Metadata_CategoryPrisma" relation. */
  connect?: InputMaybe<Array<MetadataCategoryPrismaWhereUniqueInput>>;
  /** Create new "MetadataCategoryPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CategoryPrisma" relation. */
  create?: InputMaybe<Array<MetadataCategoryPrismaWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCategoryPrisma" nodes from the "Photo.Metadata_CategoryPrisma" relation. */
  delete?: InputMaybe<Array<MetadataCategoryPrismaWhereUniqueInput>>;
  /** Update existing "MetadataCategoryPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CategoryPrisma" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCategoryprismaUpdateInput>>;
  /** Upsert existing "MetadataCategoryPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CategoryPrisma" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCategoryprismaUpdateInput>>;
};

export type PhotoNestedMetadataCategoryUpdateInput = {
  /** Connect existing "MetadataCategory" nodes to the existing "Photo" node, through the "Photo.Metadata_Category" relation. */
  connect?: InputMaybe<Array<MetadataCategoryWhereUniqueInput>>;
  /** Create new "MetadataCategory" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Category" relation. */
  create?: InputMaybe<Array<MetadataCategoryWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCategory" nodes from the "Photo.Metadata_Category" relation. */
  delete?: InputMaybe<Array<MetadataCategoryWhereUniqueInput>>;
  /** Update existing "MetadataCategory" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Category" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCategoryUpdateInput>>;
  /** Upsert existing "MetadataCategory" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Category" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCategoryUpdateInput>>;
};

export type PhotoNestedMetadataCompanyCreateInput = {
  /** Connect existing "MetadataCompany" nodes to the new "Photo" node, through the "Photo.Metadata_Company" relation. */
  connect?: InputMaybe<Array<MetadataCompanyWhereUniqueInput>>;
  /** Create new "MetadataCompany" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Company" relation. */
  create?: InputMaybe<Array<MetadataCompanyWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCompanyshortnameCreateInput = {
  /** Connect existing "MetadataCompanyShortName" nodes to the new "Photo" node, through the "Photo.Metadata_CompanyShortName" relation. */
  connect?: InputMaybe<Array<MetadataCompanyShortNameWhereUniqueInput>>;
  /** Create new "MetadataCompanyShortName" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CompanyShortName" relation. */
  create?: InputMaybe<Array<MetadataCompanyShortNameWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCompanyshortnameUpdateInput = {
  /** Connect existing "MetadataCompanyShortName" nodes to the existing "Photo" node, through the "Photo.Metadata_CompanyShortName" relation. */
  connect?: InputMaybe<Array<MetadataCompanyShortNameWhereUniqueInput>>;
  /** Create new "MetadataCompanyShortName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CompanyShortName" relation. */
  create?: InputMaybe<Array<MetadataCompanyShortNameWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCompanyShortName" nodes from the "Photo.Metadata_CompanyShortName" relation. */
  delete?: InputMaybe<Array<MetadataCompanyShortNameWhereUniqueInput>>;
  /** Update existing "MetadataCompanyShortName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CompanyShortName" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCompanyshortnameUpdateInput>>;
  /** Upsert existing "MetadataCompanyShortName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CompanyShortName" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCompanyshortnameUpdateInput>>;
};

export type PhotoNestedMetadataCompanyUpdateInput = {
  /** Connect existing "MetadataCompany" nodes to the existing "Photo" node, through the "Photo.Metadata_Company" relation. */
  connect?: InputMaybe<Array<MetadataCompanyWhereUniqueInput>>;
  /** Create new "MetadataCompany" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Company" relation. */
  create?: InputMaybe<Array<MetadataCompanyWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCompany" nodes from the "Photo.Metadata_Company" relation. */
  delete?: InputMaybe<Array<MetadataCompanyWhereUniqueInput>>;
  /** Update existing "MetadataCompany" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Company" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCompanyUpdateInput>>;
  /** Upsert existing "MetadataCompany" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Company" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCompanyUpdateInput>>;
};

export type PhotoNestedMetadataCopyrightnoticeCreateInput = {
  /** Connect existing "MetadataCopyrightNotice" nodes to the new "Photo" node, through the "Photo.Metadata_CopyrightNotice" relation. */
  connect?: InputMaybe<Array<MetadataCopyrightNoticeWhereUniqueInput>>;
  /** Create new "MetadataCopyrightNotice" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CopyrightNotice" relation. */
  create?: InputMaybe<Array<MetadataCopyrightNoticeWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCopyrightnoticeUpdateInput = {
  /** Connect existing "MetadataCopyrightNotice" nodes to the existing "Photo" node, through the "Photo.Metadata_CopyrightNotice" relation. */
  connect?: InputMaybe<Array<MetadataCopyrightNoticeWhereUniqueInput>>;
  /** Create new "MetadataCopyrightNotice" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CopyrightNotice" relation. */
  create?: InputMaybe<Array<MetadataCopyrightNoticeWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCopyrightNotice" nodes from the "Photo.Metadata_CopyrightNotice" relation. */
  delete?: InputMaybe<Array<MetadataCopyrightNoticeWhereUniqueInput>>;
  /** Update existing "MetadataCopyrightNotice" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CopyrightNotice" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCopyrightnoticeUpdateInput>>;
  /** Upsert existing "MetadataCopyrightNotice" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CopyrightNotice" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCopyrightnoticeUpdateInput>>;
};

export type PhotoNestedMetadataCreatorCreateInput = {
  /** Connect existing "MetadataCreator" nodes to the new "Photo" node, through the "Photo.Metadata_creator" relation. */
  connect?: InputMaybe<Array<MetadataCreatorWhereUniqueInput>>;
  /** Create new "MetadataCreator" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_creator" relation. */
  create?: InputMaybe<Array<MetadataCreatorWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCreatorUpdateInput = {
  /** Connect existing "MetadataCreator" nodes to the existing "Photo" node, through the "Photo.Metadata_creator" relation. */
  connect?: InputMaybe<Array<MetadataCreatorWhereUniqueInput>>;
  /** Create new "MetadataCreator" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_creator" relation. */
  create?: InputMaybe<Array<MetadataCreatorWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCreator" nodes from the "Photo.Metadata_creator" relation. */
  delete?: InputMaybe<Array<MetadataCreatorWhereUniqueInput>>;
  /** Update existing "MetadataCreator" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_creator" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCreatorUpdateInput>>;
  /** Upsert existing "MetadataCreator" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_creator" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCreatorUpdateInput>>;
};

export type PhotoNestedMetadataCreditCreateInput = {
  /** Connect existing "MetadataCredit" nodes to the new "Photo" node, through the "Photo.Metadata_Credit" relation. */
  connect?: InputMaybe<Array<MetadataCreditWhereUniqueInput>>;
  /** Create new "MetadataCredit" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Credit" relation. */
  create?: InputMaybe<Array<MetadataCreditWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCreditUpdateInput = {
  /** Connect existing "MetadataCredit" nodes to the existing "Photo" node, through the "Photo.Metadata_Credit" relation. */
  connect?: InputMaybe<Array<MetadataCreditWhereUniqueInput>>;
  /** Create new "MetadataCredit" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Credit" relation. */
  create?: InputMaybe<Array<MetadataCreditWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCredit" nodes from the "Photo.Metadata_Credit" relation. */
  delete?: InputMaybe<Array<MetadataCreditWhereUniqueInput>>;
  /** Update existing "MetadataCredit" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Credit" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCreditUpdateInput>>;
  /** Upsert existing "MetadataCredit" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Credit" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCreditUpdateInput>>;
};

export type PhotoNestedMetadataCustomfield14CreateInput = {
  /** Connect existing "MetadataCustomField14" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField14" relation. */
  connect?: InputMaybe<Array<MetadataCustomField14WhereUniqueInput>>;
  /** Create new "MetadataCustomField14" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField14" relation. */
  create?: InputMaybe<Array<MetadataCustomField14WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield14UpdateInput = {
  /** Connect existing "MetadataCustomField14" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField14" relation. */
  connect?: InputMaybe<Array<MetadataCustomField14WhereUniqueInput>>;
  /** Create new "MetadataCustomField14" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField14" relation. */
  create?: InputMaybe<Array<MetadataCustomField14WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField14" nodes from the "Photo.Metadata_CustomField14" relation. */
  delete?: InputMaybe<Array<MetadataCustomField14WhereUniqueInput>>;
  /** Update existing "MetadataCustomField14" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField14" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield14UpdateInput>>;
  /** Upsert existing "MetadataCustomField14" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField14" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield14UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield15CreateInput = {
  /** Connect existing "MetadataCustomField15" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField15" relation. */
  connect?: InputMaybe<Array<MetadataCustomField15WhereUniqueInput>>;
  /** Create new "MetadataCustomField15" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField15" relation. */
  create?: InputMaybe<Array<MetadataCustomField15WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield15UpdateInput = {
  /** Connect existing "MetadataCustomField15" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField15" relation. */
  connect?: InputMaybe<Array<MetadataCustomField15WhereUniqueInput>>;
  /** Create new "MetadataCustomField15" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField15" relation. */
  create?: InputMaybe<Array<MetadataCustomField15WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField15" nodes from the "Photo.Metadata_CustomField15" relation. */
  delete?: InputMaybe<Array<MetadataCustomField15WhereUniqueInput>>;
  /** Update existing "MetadataCustomField15" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField15" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield15UpdateInput>>;
  /** Upsert existing "MetadataCustomField15" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField15" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield15UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield16CreateInput = {
  /** Connect existing "MetadataCustomField16" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField16" relation. */
  connect?: InputMaybe<Array<MetadataCustomField16WhereUniqueInput>>;
  /** Create new "MetadataCustomField16" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField16" relation. */
  create?: InputMaybe<Array<MetadataCustomField16WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield16UpdateInput = {
  /** Connect existing "MetadataCustomField16" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField16" relation. */
  connect?: InputMaybe<Array<MetadataCustomField16WhereUniqueInput>>;
  /** Create new "MetadataCustomField16" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField16" relation. */
  create?: InputMaybe<Array<MetadataCustomField16WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField16" nodes from the "Photo.Metadata_CustomField16" relation. */
  delete?: InputMaybe<Array<MetadataCustomField16WhereUniqueInput>>;
  /** Update existing "MetadataCustomField16" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField16" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield16UpdateInput>>;
  /** Upsert existing "MetadataCustomField16" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField16" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield16UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield17CreateInput = {
  /** Connect existing "MetadataCustomField17" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField17" relation. */
  connect?: InputMaybe<Array<MetadataCustomField17WhereUniqueInput>>;
  /** Create new "MetadataCustomField17" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField17" relation. */
  create?: InputMaybe<Array<MetadataCustomField17WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield17UpdateInput = {
  /** Connect existing "MetadataCustomField17" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField17" relation. */
  connect?: InputMaybe<Array<MetadataCustomField17WhereUniqueInput>>;
  /** Create new "MetadataCustomField17" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField17" relation. */
  create?: InputMaybe<Array<MetadataCustomField17WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField17" nodes from the "Photo.Metadata_CustomField17" relation. */
  delete?: InputMaybe<Array<MetadataCustomField17WhereUniqueInput>>;
  /** Update existing "MetadataCustomField17" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField17" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield17UpdateInput>>;
  /** Upsert existing "MetadataCustomField17" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField17" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield17UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield1CreateInput = {
  /** Connect existing "MetadataCustomField1" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField1" relation. */
  connect?: InputMaybe<Array<MetadataCustomField1WhereUniqueInput>>;
  /** Create new "MetadataCustomField1" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField1" relation. */
  create?: InputMaybe<Array<MetadataCustomField1WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield1UpdateInput = {
  /** Connect existing "MetadataCustomField1" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField1" relation. */
  connect?: InputMaybe<Array<MetadataCustomField1WhereUniqueInput>>;
  /** Create new "MetadataCustomField1" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField1" relation. */
  create?: InputMaybe<Array<MetadataCustomField1WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField1" nodes from the "Photo.Metadata_CustomField1" relation. */
  delete?: InputMaybe<Array<MetadataCustomField1WhereUniqueInput>>;
  /** Update existing "MetadataCustomField1" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField1" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield1UpdateInput>>;
  /** Upsert existing "MetadataCustomField1" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField1" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield1UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield20CreateInput = {
  /** Connect existing "MetadataCustomField20" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField20" relation. */
  connect?: InputMaybe<Array<MetadataCustomField20WhereUniqueInput>>;
  /** Create new "MetadataCustomField20" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField20" relation. */
  create?: InputMaybe<Array<MetadataCustomField20WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield20UpdateInput = {
  /** Connect existing "MetadataCustomField20" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField20" relation. */
  connect?: InputMaybe<Array<MetadataCustomField20WhereUniqueInput>>;
  /** Create new "MetadataCustomField20" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField20" relation. */
  create?: InputMaybe<Array<MetadataCustomField20WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField20" nodes from the "Photo.Metadata_CustomField20" relation. */
  delete?: InputMaybe<Array<MetadataCustomField20WhereUniqueInput>>;
  /** Update existing "MetadataCustomField20" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField20" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield20UpdateInput>>;
  /** Upsert existing "MetadataCustomField20" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField20" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield20UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield3CreateInput = {
  /** Connect existing "MetadataCustomField3" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField3" relation. */
  connect?: InputMaybe<Array<MetadataCustomField3WhereUniqueInput>>;
  /** Create new "MetadataCustomField3" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField3" relation. */
  create?: InputMaybe<Array<MetadataCustomField3WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield3UpdateInput = {
  /** Connect existing "MetadataCustomField3" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField3" relation. */
  connect?: InputMaybe<Array<MetadataCustomField3WhereUniqueInput>>;
  /** Create new "MetadataCustomField3" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField3" relation. */
  create?: InputMaybe<Array<MetadataCustomField3WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField3" nodes from the "Photo.Metadata_CustomField3" relation. */
  delete?: InputMaybe<Array<MetadataCustomField3WhereUniqueInput>>;
  /** Update existing "MetadataCustomField3" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField3" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield3UpdateInput>>;
  /** Upsert existing "MetadataCustomField3" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField3" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield3UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield4CreateInput = {
  /** Connect existing "MetadataCustomField4" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField4" relation. */
  connect?: InputMaybe<Array<MetadataCustomField4WhereUniqueInput>>;
  /** Create new "MetadataCustomField4" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField4" relation. */
  create?: InputMaybe<Array<MetadataCustomField4WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield4UpdateInput = {
  /** Connect existing "MetadataCustomField4" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField4" relation. */
  connect?: InputMaybe<Array<MetadataCustomField4WhereUniqueInput>>;
  /** Create new "MetadataCustomField4" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField4" relation. */
  create?: InputMaybe<Array<MetadataCustomField4WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField4" nodes from the "Photo.Metadata_CustomField4" relation. */
  delete?: InputMaybe<Array<MetadataCustomField4WhereUniqueInput>>;
  /** Update existing "MetadataCustomField4" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField4" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield4UpdateInput>>;
  /** Upsert existing "MetadataCustomField4" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField4" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield4UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield5CreateInput = {
  /** Connect existing "MetadataCustomField5" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField5" relation. */
  connect?: InputMaybe<Array<MetadataCustomField5WhereUniqueInput>>;
  /** Create new "MetadataCustomField5" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField5" relation. */
  create?: InputMaybe<Array<MetadataCustomField5WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield5UpdateInput = {
  /** Connect existing "MetadataCustomField5" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField5" relation. */
  connect?: InputMaybe<Array<MetadataCustomField5WhereUniqueInput>>;
  /** Create new "MetadataCustomField5" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField5" relation. */
  create?: InputMaybe<Array<MetadataCustomField5WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField5" nodes from the "Photo.Metadata_CustomField5" relation. */
  delete?: InputMaybe<Array<MetadataCustomField5WhereUniqueInput>>;
  /** Update existing "MetadataCustomField5" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField5" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield5UpdateInput>>;
  /** Upsert existing "MetadataCustomField5" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField5" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield5UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield6CreateInput = {
  /** Connect existing "MetadataCustomField6" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField6" relation. */
  connect?: InputMaybe<Array<MetadataCustomField6WhereUniqueInput>>;
  /** Create new "MetadataCustomField6" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField6" relation. */
  create?: InputMaybe<Array<MetadataCustomField6WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield6UpdateInput = {
  /** Connect existing "MetadataCustomField6" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField6" relation. */
  connect?: InputMaybe<Array<MetadataCustomField6WhereUniqueInput>>;
  /** Create new "MetadataCustomField6" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField6" relation. */
  create?: InputMaybe<Array<MetadataCustomField6WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField6" nodes from the "Photo.Metadata_CustomField6" relation. */
  delete?: InputMaybe<Array<MetadataCustomField6WhereUniqueInput>>;
  /** Update existing "MetadataCustomField6" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField6" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield6UpdateInput>>;
  /** Upsert existing "MetadataCustomField6" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField6" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield6UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield7CreateInput = {
  /** Connect existing "MetadataCustomField7" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField7" relation. */
  connect?: InputMaybe<Array<MetadataCustomField7WhereUniqueInput>>;
  /** Create new "MetadataCustomField7" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField7" relation. */
  create?: InputMaybe<Array<MetadataCustomField7WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield7UpdateInput = {
  /** Connect existing "MetadataCustomField7" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField7" relation. */
  connect?: InputMaybe<Array<MetadataCustomField7WhereUniqueInput>>;
  /** Create new "MetadataCustomField7" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField7" relation. */
  create?: InputMaybe<Array<MetadataCustomField7WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField7" nodes from the "Photo.Metadata_CustomField7" relation. */
  delete?: InputMaybe<Array<MetadataCustomField7WhereUniqueInput>>;
  /** Update existing "MetadataCustomField7" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField7" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield7UpdateInput>>;
  /** Upsert existing "MetadataCustomField7" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField7" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield7UpdateInput>>;
};

export type PhotoNestedMetadataCustomfield9CreateInput = {
  /** Connect existing "MetadataCustomField9" nodes to the new "Photo" node, through the "Photo.Metadata_CustomField9" relation. */
  connect?: InputMaybe<Array<MetadataCustomField9WhereUniqueInput>>;
  /** Create new "MetadataCustomField9" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_CustomField9" relation. */
  create?: InputMaybe<Array<MetadataCustomField9WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataCustomfield9UpdateInput = {
  /** Connect existing "MetadataCustomField9" nodes to the existing "Photo" node, through the "Photo.Metadata_CustomField9" relation. */
  connect?: InputMaybe<Array<MetadataCustomField9WhereUniqueInput>>;
  /** Create new "MetadataCustomField9" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField9" relation. */
  create?: InputMaybe<Array<MetadataCustomField9WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataCustomField9" nodes from the "Photo.Metadata_CustomField9" relation. */
  delete?: InputMaybe<Array<MetadataCustomField9WhereUniqueInput>>;
  /** Update existing "MetadataCustomField9" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField9" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataCustomfield9UpdateInput>>;
  /** Upsert existing "MetadataCustomField9" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_CustomField9" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataCustomfield9UpdateInput>>;
};

export type PhotoNestedMetadataDatecreatedCreateInput = {
  /** Connect existing "MetadataDateCreated" nodes to the new "Photo" node, through the "Photo.Metadata_DateCreated" relation. */
  connect?: InputMaybe<Array<MetadataDateCreatedWhereUniqueInput>>;
  /** Create new "MetadataDateCreated" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DateCreated" relation. */
  create?: InputMaybe<Array<MetadataDateCreatedWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDatecreatedUpdateInput = {
  /** Connect existing "MetadataDateCreated" nodes to the existing "Photo" node, through the "Photo.Metadata_DateCreated" relation. */
  connect?: InputMaybe<Array<MetadataDateCreatedWhereUniqueInput>>;
  /** Create new "MetadataDateCreated" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DateCreated" relation. */
  create?: InputMaybe<Array<MetadataDateCreatedWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDateCreated" nodes from the "Photo.Metadata_DateCreated" relation. */
  delete?: InputMaybe<Array<MetadataDateCreatedWhereUniqueInput>>;
  /** Update existing "MetadataDateCreated" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DateCreated" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDatecreatedUpdateInput>>;
  /** Upsert existing "MetadataDateCreated" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DateCreated" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDatecreatedUpdateInput>>;
};

export type PhotoNestedMetadataDatetimeoriginalCreateInput = {
  /** Connect existing "MetadataDateTimeOriginal" nodes to the new "Photo" node, through the "Photo.Metadata_DateTimeOriginal" relation. */
  connect?: InputMaybe<Array<MetadataDateTimeOriginalWhereUniqueInput>>;
  /** Create new "MetadataDateTimeOriginal" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DateTimeOriginal" relation. */
  create?: InputMaybe<Array<MetadataDateTimeOriginalWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDatetimeoriginalUpdateInput = {
  /** Connect existing "MetadataDateTimeOriginal" nodes to the existing "Photo" node, through the "Photo.Metadata_DateTimeOriginal" relation. */
  connect?: InputMaybe<Array<MetadataDateTimeOriginalWhereUniqueInput>>;
  /** Create new "MetadataDateTimeOriginal" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DateTimeOriginal" relation. */
  create?: InputMaybe<Array<MetadataDateTimeOriginalWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDateTimeOriginal" nodes from the "Photo.Metadata_DateTimeOriginal" relation. */
  delete?: InputMaybe<Array<MetadataDateTimeOriginalWhereUniqueInput>>;
  /** Update existing "MetadataDateTimeOriginal" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DateTimeOriginal" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDatetimeoriginalUpdateInput>>;
  /** Upsert existing "MetadataDateTimeOriginal" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DateTimeOriginal" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDatetimeoriginalUpdateInput>>;
};

export type PhotoNestedMetadataDeliveryaccountCreateInput = {
  /** Connect existing "MetadataDeliveryAccount" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryAccount" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryAccountWhereUniqueInput>>;
  /** Create new "MetadataDeliveryAccount" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryAccount" relation. */
  create?: InputMaybe<Array<MetadataDeliveryAccountWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliveryaccountUpdateInput = {
  /** Connect existing "MetadataDeliveryAccount" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryAccount" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryAccountWhereUniqueInput>>;
  /** Create new "MetadataDeliveryAccount" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryAccount" relation. */
  create?: InputMaybe<Array<MetadataDeliveryAccountWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryAccount" nodes from the "Photo.Metadata_DeliveryAccount" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryAccountWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryAccount" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryAccount" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliveryaccountUpdateInput>>;
  /** Upsert existing "MetadataDeliveryAccount" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryAccount" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliveryaccountUpdateInput>>;
};

export type PhotoNestedMetadataDeliverycompanyCreateInput = {
  /** Connect existing "MetadataDeliveryCompany" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryCompany" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCompanyWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCompany" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryCompany" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCompanyWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliverycompanyUpdateInput = {
  /** Connect existing "MetadataDeliveryCompany" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryCompany" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCompanyWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCompany" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryCompany" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCompanyWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryCompany" nodes from the "Photo.Metadata_DeliveryCompany" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryCompanyWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryCompany" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryCompany" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliverycompanyUpdateInput>>;
  /** Upsert existing "MetadataDeliveryCompany" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryCompany" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliverycompanyUpdateInput>>;
};

export type PhotoNestedMetadataDeliverycopyrightCreateInput = {
  /** Connect existing "MetadataDeliveryCopyright" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryCopyright" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCopyrightWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCopyright" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryCopyright" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCopyrightWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliverycopyrightUpdateInput = {
  /** Connect existing "MetadataDeliveryCopyright" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryCopyright" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryCopyrightWhereUniqueInput>>;
  /** Create new "MetadataDeliveryCopyright" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryCopyright" relation. */
  create?: InputMaybe<Array<MetadataDeliveryCopyrightWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryCopyright" nodes from the "Photo.Metadata_DeliveryCopyright" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryCopyrightWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryCopyright" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryCopyright" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliverycopyrightUpdateInput>>;
  /** Upsert existing "MetadataDeliveryCopyright" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryCopyright" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliverycopyrightUpdateInput>>;
};

export type PhotoNestedMetadataDeliverydatefolderCreateInput = {
  /** Connect existing "MetadataDeliveryDateFolder" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryDateFolder" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateFolder" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryDateFolder" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateFolderWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliverydatefolderUpdateInput = {
  /** Connect existing "MetadataDeliveryDateFolder" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryDateFolder" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateFolder" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDateFolder" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateFolderWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryDateFolder" nodes from the "Photo.Metadata_DeliveryDateFolder" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDateFolderWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDateFolder" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDateFolder" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliverydatefolderUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDateFolder" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDateFolder" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliverydatefolderUpdateInput>>;
};

export type PhotoNestedMetadataDeliverydatetimeCreateInput = {
  /** Connect existing "MetadataDeliveryDateTime" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryDateTime" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateTimeWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateTime" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryDateTime" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateTimeWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliverydatetimeUpdateInput = {
  /** Connect existing "MetadataDeliveryDateTime" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryDateTime" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDateTimeWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDateTime" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDateTime" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDateTimeWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryDateTime" nodes from the "Photo.Metadata_DeliveryDateTime" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDateTimeWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDateTime" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDateTime" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliverydatetimeUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDateTime" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDateTime" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliverydatetimeUpdateInput>>;
};

export type PhotoNestedMetadataDeliverydccreatorCreateInput = {
  /** Connect existing "MetadataDeliveryDcCreator" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryDcCreator" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcCreator" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryDcCreator" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcCreatorWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliverydccreatorUpdateInput = {
  /** Connect existing "MetadataDeliveryDcCreator" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryDcCreator" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcCreator" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDcCreator" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcCreatorWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryDcCreator" nodes from the "Photo.Metadata_DeliveryDcCreator" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDcCreatorWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDcCreator" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDcCreator" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliverydccreatorUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDcCreator" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDcCreator" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliverydccreatorUpdateInput>>;
};

export type PhotoNestedMetadataDeliverydcrightsCreateInput = {
  /** Connect existing "MetadataDeliveryDcRights" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryDcRights" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcRightsWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcRights" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryDcRights" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcRightsWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliverydcrightsUpdateInput = {
  /** Connect existing "MetadataDeliveryDcRights" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryDcRights" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryDcRightsWhereUniqueInput>>;
  /** Create new "MetadataDeliveryDcRights" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDcRights" relation. */
  create?: InputMaybe<Array<MetadataDeliveryDcRightsWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryDcRights" nodes from the "Photo.Metadata_DeliveryDcRights" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryDcRightsWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryDcRights" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDcRights" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliverydcrightsUpdateInput>>;
  /** Upsert existing "MetadataDeliveryDcRights" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryDcRights" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliverydcrightsUpdateInput>>;
};

export type PhotoNestedMetadataDeliveryfolderCreateInput = {
  /** Connect existing "MetadataDeliveryFolder" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryFolder" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryFolder" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryFolder" relation. */
  create?: InputMaybe<Array<MetadataDeliveryFolderWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliveryfolderUpdateInput = {
  /** Connect existing "MetadataDeliveryFolder" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryFolder" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryFolderWhereUniqueInput>>;
  /** Create new "MetadataDeliveryFolder" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryFolder" relation. */
  create?: InputMaybe<Array<MetadataDeliveryFolderWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryFolder" nodes from the "Photo.Metadata_DeliveryFolder" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryFolderWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryFolder" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryFolder" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliveryfolderUpdateInput>>;
  /** Upsert existing "MetadataDeliveryFolder" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryFolder" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliveryfolderUpdateInput>>;
};

export type PhotoNestedMetadataDeliverykindCreateInput = {
  /** Connect existing "MetadataDeliveryKind" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryKind" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryKindWhereUniqueInput>>;
  /** Create new "MetadataDeliveryKind" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryKind" relation. */
  create?: InputMaybe<Array<MetadataDeliveryKindWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliverykindUpdateInput = {
  /** Connect existing "MetadataDeliveryKind" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryKind" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryKindWhereUniqueInput>>;
  /** Create new "MetadataDeliveryKind" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryKind" relation. */
  create?: InputMaybe<Array<MetadataDeliveryKindWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryKind" nodes from the "Photo.Metadata_DeliveryKind" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryKindWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryKind" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryKind" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliverykindUpdateInput>>;
  /** Upsert existing "MetadataDeliveryKind" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryKind" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliverykindUpdateInput>>;
};

export type PhotoNestedMetadataDeliverypathCreateInput = {
  /** Connect existing "MetadataDeliveryPath" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryPath" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPathWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPath" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryPath" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPathWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliverypathUpdateInput = {
  /** Connect existing "MetadataDeliveryPath" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryPath" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPathWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPath" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryPath" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPathWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryPath" nodes from the "Photo.Metadata_DeliveryPath" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryPathWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryPath" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryPath" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliverypathUpdateInput>>;
  /** Upsert existing "MetadataDeliveryPath" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryPath" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliverypathUpdateInput>>;
};

export type PhotoNestedMetadataDeliveryphotoshopcreditCreateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopCredit" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopCredit" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopCredit" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopCredit" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliveryphotoshopcreditUpdateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopCredit" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopCredit" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopCredit" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopCredit" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryPhotoshopCredit" nodes from the "Photo.Metadata_DeliveryPhotoshopCredit" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryPhotoshopCredit" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopCredit" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliveryphotoshopcreditUpdateInput>>;
  /** Upsert existing "MetadataDeliveryPhotoshopCredit" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopCredit" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliveryphotoshopcreditUpdateInput>>;
};

export type PhotoNestedMetadataDeliveryphotoshopsourceCreateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopSource" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopSource" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopSource" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopSource" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliveryphotoshopsourceUpdateInput = {
  /** Connect existing "MetadataDeliveryPhotoshopSource" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopSource" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryPhotoshopSource" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopSource" relation. */
  create?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryPhotoshopSource" nodes from the "Photo.Metadata_DeliveryPhotoshopSource" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryPhotoshopSource" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopSource" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliveryphotoshopsourceUpdateInput>>;
  /** Upsert existing "MetadataDeliveryPhotoshopSource" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryPhotoshopSource" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliveryphotoshopsourceUpdateInput>>;
};

export type PhotoNestedMetadataDeliveryserviceCreateInput = {
  /** Connect existing "MetadataDeliveryService" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryService" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryServiceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryService" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryService" relation. */
  create?: InputMaybe<Array<MetadataDeliveryServiceWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliveryserviceUpdateInput = {
  /** Connect existing "MetadataDeliveryService" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryService" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryServiceWhereUniqueInput>>;
  /** Create new "MetadataDeliveryService" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryService" relation. */
  create?: InputMaybe<Array<MetadataDeliveryServiceWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryService" nodes from the "Photo.Metadata_DeliveryService" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryServiceWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryService" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryService" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliveryserviceUpdateInput>>;
  /** Upsert existing "MetadataDeliveryService" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryService" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliveryserviceUpdateInput>>;
};

export type PhotoNestedMetadataDeliverysubjectCreateInput = {
  /** Connect existing "MetadataDeliverySubject" nodes to the new "Photo" node, through the "Photo.Metadata_DeliverySubject" relation. */
  connect?: InputMaybe<Array<MetadataDeliverySubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliverySubject" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliverySubject" relation. */
  create?: InputMaybe<Array<MetadataDeliverySubjectWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliverysubjectUpdateInput = {
  /** Connect existing "MetadataDeliverySubject" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliverySubject" relation. */
  connect?: InputMaybe<Array<MetadataDeliverySubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliverySubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliverySubject" relation. */
  create?: InputMaybe<Array<MetadataDeliverySubjectWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliverySubject" nodes from the "Photo.Metadata_DeliverySubject" relation. */
  delete?: InputMaybe<Array<MetadataDeliverySubjectWhereUniqueInput>>;
  /** Update existing "MetadataDeliverySubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliverySubject" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliverysubjectUpdateInput>>;
  /** Upsert existing "MetadataDeliverySubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliverySubject" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliverysubjectUpdateInput>>;
};

export type PhotoNestedMetadataDeliveryundersubjectCreateInput = {
  /** Connect existing "MetadataDeliveryUnderSubject" nodes to the new "Photo" node, through the "Photo.Metadata_DeliveryUnderSubject" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliveryUnderSubject" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_DeliveryUnderSubject" relation. */
  create?: InputMaybe<Array<MetadataDeliveryUnderSubjectWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDeliveryundersubjectUpdateInput = {
  /** Connect existing "MetadataDeliveryUnderSubject" nodes to the existing "Photo" node, through the "Photo.Metadata_DeliveryUnderSubject" relation. */
  connect?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataDeliveryUnderSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryUnderSubject" relation. */
  create?: InputMaybe<Array<MetadataDeliveryUnderSubjectWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDeliveryUnderSubject" nodes from the "Photo.Metadata_DeliveryUnderSubject" relation. */
  delete?: InputMaybe<Array<MetadataDeliveryUnderSubjectWhereUniqueInput>>;
  /** Update existing "MetadataDeliveryUnderSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryUnderSubject" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDeliveryundersubjectUpdateInput>>;
  /** Upsert existing "MetadataDeliveryUnderSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_DeliveryUnderSubject" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDeliveryundersubjectUpdateInput>>;
};

export type PhotoNestedMetadataDepartmentCreateInput = {
  /** Connect existing "MetadataDepartment" nodes to the new "Photo" node, through the "Photo.Metadata_Department" relation. */
  connect?: InputMaybe<Array<MetadataDepartmentWhereUniqueInput>>;
  /** Create new "MetadataDepartment" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Department" relation. */
  create?: InputMaybe<Array<MetadataDepartmentWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDepartmentUpdateInput = {
  /** Connect existing "MetadataDepartment" nodes to the existing "Photo" node, through the "Photo.Metadata_Department" relation. */
  connect?: InputMaybe<Array<MetadataDepartmentWhereUniqueInput>>;
  /** Create new "MetadataDepartment" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Department" relation. */
  create?: InputMaybe<Array<MetadataDepartmentWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDepartment" nodes from the "Photo.Metadata_Department" relation. */
  delete?: InputMaybe<Array<MetadataDepartmentWhereUniqueInput>>;
  /** Update existing "MetadataDepartment" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Department" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDepartmentUpdateInput>>;
  /** Upsert existing "MetadataDepartment" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Department" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDepartmentUpdateInput>>;
};

export type PhotoNestedMetadataDescriptionCreateInput = {
  /** Connect existing "MetadataDescription" nodes to the new "Photo" node, through the "Photo.Metadata_description" relation. */
  connect?: InputMaybe<Array<MetadataDescriptionWhereUniqueInput>>;
  /** Create new "MetadataDescription" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_description" relation. */
  create?: InputMaybe<Array<MetadataDescriptionWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataDescriptionUpdateInput = {
  /** Connect existing "MetadataDescription" nodes to the existing "Photo" node, through the "Photo.Metadata_description" relation. */
  connect?: InputMaybe<Array<MetadataDescriptionWhereUniqueInput>>;
  /** Create new "MetadataDescription" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_description" relation. */
  create?: InputMaybe<Array<MetadataDescriptionWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataDescription" nodes from the "Photo.Metadata_description" relation. */
  delete?: InputMaybe<Array<MetadataDescriptionWhereUniqueInput>>;
  /** Update existing "MetadataDescription" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_description" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataDescriptionUpdateInput>>;
  /** Upsert existing "MetadataDescription" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_description" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataDescriptionUpdateInput>>;
};

export type PhotoNestedMetadataEditionCreateInput = {
  /** Connect existing "MetadataEdition" nodes to the new "Photo" node, through the "Photo.Metadata_Edition" relation. */
  connect?: InputMaybe<Array<MetadataEditionWhereUniqueInput>>;
  /** Create new "MetadataEdition" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Edition" relation. */
  create?: InputMaybe<Array<MetadataEditionWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataEditionUpdateInput = {
  /** Connect existing "MetadataEdition" nodes to the existing "Photo" node, through the "Photo.Metadata_Edition" relation. */
  connect?: InputMaybe<Array<MetadataEditionWhereUniqueInput>>;
  /** Create new "MetadataEdition" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Edition" relation. */
  create?: InputMaybe<Array<MetadataEditionWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataEdition" nodes from the "Photo.Metadata_Edition" relation. */
  delete?: InputMaybe<Array<MetadataEditionWhereUniqueInput>>;
  /** Update existing "MetadataEdition" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Edition" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataEditionUpdateInput>>;
  /** Upsert existing "MetadataEdition" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Edition" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataEditionUpdateInput>>;
};

export type PhotoNestedMetadataEditstatusCreateInput = {
  /** Connect existing "MetadataEditStatus" nodes to the new "Photo" node, through the "Photo.Metadata_EditStatus" relation. */
  connect?: InputMaybe<Array<MetadataEditStatusWhereUniqueInput>>;
  /** Create new "MetadataEditStatus" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_EditStatus" relation. */
  create?: InputMaybe<Array<MetadataEditStatusWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataEditstatusUpdateInput = {
  /** Connect existing "MetadataEditStatus" nodes to the existing "Photo" node, through the "Photo.Metadata_EditStatus" relation. */
  connect?: InputMaybe<Array<MetadataEditStatusWhereUniqueInput>>;
  /** Create new "MetadataEditStatus" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_EditStatus" relation. */
  create?: InputMaybe<Array<MetadataEditStatusWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataEditStatus" nodes from the "Photo.Metadata_EditStatus" relation. */
  delete?: InputMaybe<Array<MetadataEditStatusWhereUniqueInput>>;
  /** Update existing "MetadataEditStatus" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_EditStatus" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataEditstatusUpdateInput>>;
  /** Upsert existing "MetadataEditStatus" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_EditStatus" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataEditstatusUpdateInput>>;
};

export type PhotoNestedMetadataFilestatusCreateInput = {
  /** Connect existing "MetadataFileStatus" nodes to the new "Photo" node, through the "Photo.Metadata_FileStatus" relation. */
  connect?: InputMaybe<Array<MetadataFileStatusWhereUniqueInput>>;
  /** Create new "MetadataFileStatus" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_FileStatus" relation. */
  create?: InputMaybe<Array<MetadataFileStatusWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataFilestatusUpdateInput = {
  /** Connect existing "MetadataFileStatus" nodes to the existing "Photo" node, through the "Photo.Metadata_FileStatus" relation. */
  connect?: InputMaybe<Array<MetadataFileStatusWhereUniqueInput>>;
  /** Create new "MetadataFileStatus" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_FileStatus" relation. */
  create?: InputMaybe<Array<MetadataFileStatusWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataFileStatus" nodes from the "Photo.Metadata_FileStatus" relation. */
  delete?: InputMaybe<Array<MetadataFileStatusWhereUniqueInput>>;
  /** Update existing "MetadataFileStatus" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_FileStatus" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataFilestatusUpdateInput>>;
  /** Upsert existing "MetadataFileStatus" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_FileStatus" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataFilestatusUpdateInput>>;
};

export type PhotoNestedMetadataFormatCreateInput = {
  /** Connect existing "MetadataFormat" nodes to the new "Photo" node, through the "Photo.Metadata_Format" relation. */
  connect?: InputMaybe<Array<MetadataFormatWhereUniqueInput>>;
  /** Create new "MetadataFormat" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Format" relation. */
  create?: InputMaybe<Array<MetadataFormatWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataFormatUpdateInput = {
  /** Connect existing "MetadataFormat" nodes to the existing "Photo" node, through the "Photo.Metadata_Format" relation. */
  connect?: InputMaybe<Array<MetadataFormatWhereUniqueInput>>;
  /** Create new "MetadataFormat" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Format" relation. */
  create?: InputMaybe<Array<MetadataFormatWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataFormat" nodes from the "Photo.Metadata_Format" relation. */
  delete?: InputMaybe<Array<MetadataFormatWhereUniqueInput>>;
  /** Update existing "MetadataFormat" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Format" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataFormatUpdateInput>>;
  /** Upsert existing "MetadataFormat" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Format" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataFormatUpdateInput>>;
};

export type PhotoNestedMetadataHeaderCreateInput = {
  /** Connect existing "MetadataHeader" nodes to the new "Photo" node, through the "Photo.Metadata_Header" relation. */
  connect?: InputMaybe<Array<MetadataHeaderWhereUniqueInput>>;
  /** Create new "MetadataHeader" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Header" relation. */
  create?: InputMaybe<Array<MetadataHeaderWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataHeaderprismaCreateInput = {
  /** Connect existing "MetadataHeaderPrisma" nodes to the new "Photo" node, through the "Photo.Metadata_HeaderPrisma" relation. */
  connect?: InputMaybe<Array<MetadataHeaderPrismaWhereUniqueInput>>;
  /** Create new "MetadataHeaderPrisma" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_HeaderPrisma" relation. */
  create?: InputMaybe<Array<MetadataHeaderPrismaWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataHeaderprismaUpdateInput = {
  /** Connect existing "MetadataHeaderPrisma" nodes to the existing "Photo" node, through the "Photo.Metadata_HeaderPrisma" relation. */
  connect?: InputMaybe<Array<MetadataHeaderPrismaWhereUniqueInput>>;
  /** Create new "MetadataHeaderPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_HeaderPrisma" relation. */
  create?: InputMaybe<Array<MetadataHeaderPrismaWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataHeaderPrisma" nodes from the "Photo.Metadata_HeaderPrisma" relation. */
  delete?: InputMaybe<Array<MetadataHeaderPrismaWhereUniqueInput>>;
  /** Update existing "MetadataHeaderPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_HeaderPrisma" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataHeaderprismaUpdateInput>>;
  /** Upsert existing "MetadataHeaderPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_HeaderPrisma" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataHeaderprismaUpdateInput>>;
};

export type PhotoNestedMetadataHeaderUpdateInput = {
  /** Connect existing "MetadataHeader" nodes to the existing "Photo" node, through the "Photo.Metadata_Header" relation. */
  connect?: InputMaybe<Array<MetadataHeaderWhereUniqueInput>>;
  /** Create new "MetadataHeader" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Header" relation. */
  create?: InputMaybe<Array<MetadataHeaderWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataHeader" nodes from the "Photo.Metadata_Header" relation. */
  delete?: InputMaybe<Array<MetadataHeaderWhereUniqueInput>>;
  /** Update existing "MetadataHeader" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Header" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataHeaderUpdateInput>>;
  /** Upsert existing "MetadataHeader" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Header" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataHeaderUpdateInput>>;
};

export type PhotoNestedMetadataHeadlineCreateInput = {
  /** Connect existing "MetadataHeadline" nodes to the new "Photo" node, through the "Photo.Metadata_Headline" relation. */
  connect?: InputMaybe<Array<MetadataHeadlineWhereUniqueInput>>;
  /** Create new "MetadataHeadline" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Headline" relation. */
  create?: InputMaybe<Array<MetadataHeadlineWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataHeadlineUpdateInput = {
  /** Connect existing "MetadataHeadline" nodes to the existing "Photo" node, through the "Photo.Metadata_Headline" relation. */
  connect?: InputMaybe<Array<MetadataHeadlineWhereUniqueInput>>;
  /** Create new "MetadataHeadline" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Headline" relation. */
  create?: InputMaybe<Array<MetadataHeadlineWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataHeadline" nodes from the "Photo.Metadata_Headline" relation. */
  delete?: InputMaybe<Array<MetadataHeadlineWhereUniqueInput>>;
  /** Update existing "MetadataHeadline" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Headline" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataHeadlineUpdateInput>>;
  /** Upsert existing "MetadataHeadline" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Headline" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataHeadlineUpdateInput>>;
};

export type PhotoNestedMetadataIdassignmentCreateInput = {
  /** Connect existing "MetadataIdAssignment" nodes to the new "Photo" node, through the "Photo.Metadata_IdAssignment" relation. */
  connect?: InputMaybe<Array<MetadataIdAssignmentWhereUniqueInput>>;
  /** Create new "MetadataIdAssignment" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_IdAssignment" relation. */
  create?: InputMaybe<Array<MetadataIdAssignmentWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataIdassignmentUpdateInput = {
  /** Connect existing "MetadataIdAssignment" nodes to the existing "Photo" node, through the "Photo.Metadata_IdAssignment" relation. */
  connect?: InputMaybe<Array<MetadataIdAssignmentWhereUniqueInput>>;
  /** Create new "MetadataIdAssignment" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_IdAssignment" relation. */
  create?: InputMaybe<Array<MetadataIdAssignmentWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataIdAssignment" nodes from the "Photo.Metadata_IdAssignment" relation. */
  delete?: InputMaybe<Array<MetadataIdAssignmentWhereUniqueInput>>;
  /** Update existing "MetadataIdAssignment" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_IdAssignment" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataIdassignmentUpdateInput>>;
  /** Upsert existing "MetadataIdAssignment" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_IdAssignment" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataIdassignmentUpdateInput>>;
};

export type PhotoNestedMetadataIdphotoprismaCreateInput = {
  /** Connect existing "MetadataIdPhotoPrisma" nodes to the new "Photo" node, through the "Photo.Metadata_IdPhotoPrisma" relation. */
  connect?: InputMaybe<Array<MetadataIdPhotoPrismaWhereUniqueInput>>;
  /** Create new "MetadataIdPhotoPrisma" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_IdPhotoPrisma" relation. */
  create?: InputMaybe<Array<MetadataIdPhotoPrismaWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataIdphotoprismaUpdateInput = {
  /** Connect existing "MetadataIdPhotoPrisma" nodes to the existing "Photo" node, through the "Photo.Metadata_IdPhotoPrisma" relation. */
  connect?: InputMaybe<Array<MetadataIdPhotoPrismaWhereUniqueInput>>;
  /** Create new "MetadataIdPhotoPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_IdPhotoPrisma" relation. */
  create?: InputMaybe<Array<MetadataIdPhotoPrismaWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataIdPhotoPrisma" nodes from the "Photo.Metadata_IdPhotoPrisma" relation. */
  delete?: InputMaybe<Array<MetadataIdPhotoPrismaWhereUniqueInput>>;
  /** Update existing "MetadataIdPhotoPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_IdPhotoPrisma" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataIdphotoprismaUpdateInput>>;
  /** Upsert existing "MetadataIdPhotoPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_IdPhotoPrisma" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataIdphotoprismaUpdateInput>>;
};

export type PhotoNestedMetadataIdSubjectCreateInput = {
  /** Connect existing "MetadataIdSubject" nodes to the new "Photo" node, through the "Photo.Metadata_ID_subject" relation. */
  connect?: InputMaybe<Array<MetadataIdSubjectWhereUniqueInput>>;
  /** Create new "MetadataIdSubject" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_ID_subject" relation. */
  create?: InputMaybe<Array<MetadataIdSubjectWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataIdSubjectUpdateInput = {
  /** Connect existing "MetadataIdSubject" nodes to the existing "Photo" node, through the "Photo.Metadata_ID_subject" relation. */
  connect?: InputMaybe<Array<MetadataIdSubjectWhereUniqueInput>>;
  /** Create new "MetadataIdSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ID_subject" relation. */
  create?: InputMaybe<Array<MetadataIdSubjectWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataIdSubject" nodes from the "Photo.Metadata_ID_subject" relation. */
  delete?: InputMaybe<Array<MetadataIdSubjectWhereUniqueInput>>;
  /** Update existing "MetadataIdSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ID_subject" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataIdSubjectUpdateInput>>;
  /** Upsert existing "MetadataIdSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ID_subject" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataIdSubjectUpdateInput>>;
};

export type PhotoNestedMetadataImagenotesCreateInput = {
  /** Connect existing "MetadataImageNotes" nodes to the new "Photo" node, through the "Photo.Metadata_ImageNotes" relation. */
  connect?: InputMaybe<Array<MetadataImageNotesWhereUniqueInput>>;
  /** Create new "MetadataImageNotes" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_ImageNotes" relation. */
  create?: InputMaybe<Array<MetadataImageNotesWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataImagenotesUpdateInput = {
  /** Connect existing "MetadataImageNotes" nodes to the existing "Photo" node, through the "Photo.Metadata_ImageNotes" relation. */
  connect?: InputMaybe<Array<MetadataImageNotesWhereUniqueInput>>;
  /** Create new "MetadataImageNotes" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ImageNotes" relation. */
  create?: InputMaybe<Array<MetadataImageNotesWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataImageNotes" nodes from the "Photo.Metadata_ImageNotes" relation. */
  delete?: InputMaybe<Array<MetadataImageNotesWhereUniqueInput>>;
  /** Update existing "MetadataImageNotes" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ImageNotes" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataImagenotesUpdateInput>>;
  /** Upsert existing "MetadataImageNotes" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ImageNotes" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataImagenotesUpdateInput>>;
};

export type PhotoNestedMetadataInstructionsCreateInput = {
  /** Connect existing "MetadataInstructions" nodes to the new "Photo" node, through the "Photo.Metadata_Instructions" relation. */
  connect?: InputMaybe<Array<MetadataInstructionsWhereUniqueInput>>;
  /** Create new "MetadataInstructions" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Instructions" relation. */
  create?: InputMaybe<Array<MetadataInstructionsWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataInstructionsUpdateInput = {
  /** Connect existing "MetadataInstructions" nodes to the existing "Photo" node, through the "Photo.Metadata_Instructions" relation. */
  connect?: InputMaybe<Array<MetadataInstructionsWhereUniqueInput>>;
  /** Create new "MetadataInstructions" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Instructions" relation. */
  create?: InputMaybe<Array<MetadataInstructionsWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataInstructions" nodes from the "Photo.Metadata_Instructions" relation. */
  delete?: InputMaybe<Array<MetadataInstructionsWhereUniqueInput>>;
  /** Update existing "MetadataInstructions" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Instructions" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataInstructionsUpdateInput>>;
  /** Upsert existing "MetadataInstructions" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Instructions" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataInstructionsUpdateInput>>;
};

export type PhotoNestedMetadataIssueCreateInput = {
  /** Connect existing "MetadataIssue" nodes to the new "Photo" node, through the "Photo.Metadata_Issue" relation. */
  connect?: InputMaybe<Array<MetadataIssueWhereUniqueInput>>;
  /** Create new "MetadataIssue" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Issue" relation. */
  create?: InputMaybe<Array<MetadataIssueWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataIssueUpdateInput = {
  /** Connect existing "MetadataIssue" nodes to the existing "Photo" node, through the "Photo.Metadata_Issue" relation. */
  connect?: InputMaybe<Array<MetadataIssueWhereUniqueInput>>;
  /** Create new "MetadataIssue" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Issue" relation. */
  create?: InputMaybe<Array<MetadataIssueWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataIssue" nodes from the "Photo.Metadata_Issue" relation. */
  delete?: InputMaybe<Array<MetadataIssueWhereUniqueInput>>;
  /** Update existing "MetadataIssue" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Issue" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataIssueUpdateInput>>;
  /** Upsert existing "MetadataIssue" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Issue" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataIssueUpdateInput>>;
};

export type PhotoNestedMetadataKeywordsCreateInput = {
  /** Connect existing "MetadataKeywords" nodes to the new "Photo" node, through the "Photo.Metadata_Keywords" relation. */
  connect?: InputMaybe<Array<MetadataKeywordsWhereUniqueInput>>;
  /** Create new "MetadataKeywords" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Keywords" relation. */
  create?: InputMaybe<Array<MetadataKeywordsWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataKeywordsUpdateInput = {
  /** Connect existing "MetadataKeywords" nodes to the existing "Photo" node, through the "Photo.Metadata_Keywords" relation. */
  connect?: InputMaybe<Array<MetadataKeywordsWhereUniqueInput>>;
  /** Create new "MetadataKeywords" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Keywords" relation. */
  create?: InputMaybe<Array<MetadataKeywordsWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataKeywords" nodes from the "Photo.Metadata_Keywords" relation. */
  delete?: InputMaybe<Array<MetadataKeywordsWhereUniqueInput>>;
  /** Update existing "MetadataKeywords" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Keywords" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataKeywordsUpdateInput>>;
  /** Upsert existing "MetadataKeywords" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Keywords" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataKeywordsUpdateInput>>;
};

export type PhotoNestedMetadataObjectnameCreateInput = {
  /** Connect existing "MetadataObjectName" nodes to the new "Photo" node, through the "Photo.Metadata_ObjectName" relation. */
  connect?: InputMaybe<Array<MetadataObjectNameWhereUniqueInput>>;
  /** Create new "MetadataObjectName" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_ObjectName" relation. */
  create?: InputMaybe<Array<MetadataObjectNameWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataObjectnameUpdateInput = {
  /** Connect existing "MetadataObjectName" nodes to the existing "Photo" node, through the "Photo.Metadata_ObjectName" relation. */
  connect?: InputMaybe<Array<MetadataObjectNameWhereUniqueInput>>;
  /** Create new "MetadataObjectName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ObjectName" relation. */
  create?: InputMaybe<Array<MetadataObjectNameWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataObjectName" nodes from the "Photo.Metadata_ObjectName" relation. */
  delete?: InputMaybe<Array<MetadataObjectNameWhereUniqueInput>>;
  /** Update existing "MetadataObjectName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ObjectName" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataObjectnameUpdateInput>>;
  /** Upsert existing "MetadataObjectName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ObjectName" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataObjectnameUpdateInput>>;
};

export type PhotoNestedMetadataOriginalnameCreateInput = {
  /** Connect existing "MetadataOriginalName" nodes to the new "Photo" node, through the "Photo.Metadata_OriginalName" relation. */
  connect?: InputMaybe<Array<MetadataOriginalNameWhereUniqueInput>>;
  /** Create new "MetadataOriginalName" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_OriginalName" relation. */
  create?: InputMaybe<Array<MetadataOriginalNameWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataOriginalnameUpdateInput = {
  /** Connect existing "MetadataOriginalName" nodes to the existing "Photo" node, through the "Photo.Metadata_OriginalName" relation. */
  connect?: InputMaybe<Array<MetadataOriginalNameWhereUniqueInput>>;
  /** Create new "MetadataOriginalName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_OriginalName" relation. */
  create?: InputMaybe<Array<MetadataOriginalNameWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataOriginalName" nodes from the "Photo.Metadata_OriginalName" relation. */
  delete?: InputMaybe<Array<MetadataOriginalNameWhereUniqueInput>>;
  /** Update existing "MetadataOriginalName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_OriginalName" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataOriginalnameUpdateInput>>;
  /** Upsert existing "MetadataOriginalName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_OriginalName" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataOriginalnameUpdateInput>>;
};

export type PhotoNestedMetadataPricelevelCreateInput = {
  /** Connect existing "MetadataPriceLevel" nodes to the new "Photo" node, through the "Photo.Metadata_PriceLevel" relation. */
  connect?: InputMaybe<Array<MetadataPriceLevelWhereUniqueInput>>;
  /** Create new "MetadataPriceLevel" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_PriceLevel" relation. */
  create?: InputMaybe<Array<MetadataPriceLevelWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataPricelevelUpdateInput = {
  /** Connect existing "MetadataPriceLevel" nodes to the existing "Photo" node, through the "Photo.Metadata_PriceLevel" relation. */
  connect?: InputMaybe<Array<MetadataPriceLevelWhereUniqueInput>>;
  /** Create new "MetadataPriceLevel" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_PriceLevel" relation. */
  create?: InputMaybe<Array<MetadataPriceLevelWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataPriceLevel" nodes from the "Photo.Metadata_PriceLevel" relation. */
  delete?: InputMaybe<Array<MetadataPriceLevelWhereUniqueInput>>;
  /** Update existing "MetadataPriceLevel" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_PriceLevel" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataPricelevelUpdateInput>>;
  /** Upsert existing "MetadataPriceLevel" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_PriceLevel" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataPricelevelUpdateInput>>;
};

export type PhotoNestedMetadataProcesshistoryCreateInput = {
  /** Connect existing "MetadataProcessHistory" nodes to the new "Photo" node, through the "Photo.Metadata_ProcessHistory" relation. */
  connect?: InputMaybe<Array<MetadataProcessHistoryWhereUniqueInput>>;
  /** Create new "MetadataProcessHistory" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_ProcessHistory" relation. */
  create?: InputMaybe<Array<MetadataProcessHistoryWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataProcesshistoryUpdateInput = {
  /** Connect existing "MetadataProcessHistory" nodes to the existing "Photo" node, through the "Photo.Metadata_ProcessHistory" relation. */
  connect?: InputMaybe<Array<MetadataProcessHistoryWhereUniqueInput>>;
  /** Create new "MetadataProcessHistory" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ProcessHistory" relation. */
  create?: InputMaybe<Array<MetadataProcessHistoryWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataProcessHistory" nodes from the "Photo.Metadata_ProcessHistory" relation. */
  delete?: InputMaybe<Array<MetadataProcessHistoryWhereUniqueInput>>;
  /** Update existing "MetadataProcessHistory" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ProcessHistory" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataProcesshistoryUpdateInput>>;
  /** Upsert existing "MetadataProcessHistory" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ProcessHistory" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataProcesshistoryUpdateInput>>;
};

export type PhotoNestedMetadataProcessstatusCreateInput = {
  /** Connect existing "MetadataProcessStatus" nodes to the new "Photo" node, through the "Photo.Metadata_ProcessStatus" relation. */
  connect?: InputMaybe<Array<MetadataProcessStatusWhereUniqueInput>>;
  /** Create new "MetadataProcessStatus" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_ProcessStatus" relation. */
  create?: InputMaybe<Array<MetadataProcessStatusWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataProcessstatusUpdateInput = {
  /** Connect existing "MetadataProcessStatus" nodes to the existing "Photo" node, through the "Photo.Metadata_ProcessStatus" relation. */
  connect?: InputMaybe<Array<MetadataProcessStatusWhereUniqueInput>>;
  /** Create new "MetadataProcessStatus" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ProcessStatus" relation. */
  create?: InputMaybe<Array<MetadataProcessStatusWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataProcessStatus" nodes from the "Photo.Metadata_ProcessStatus" relation. */
  delete?: InputMaybe<Array<MetadataProcessStatusWhereUniqueInput>>;
  /** Update existing "MetadataProcessStatus" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ProcessStatus" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataProcessstatusUpdateInput>>;
  /** Upsert existing "MetadataProcessStatus" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ProcessStatus" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataProcessstatusUpdateInput>>;
};

export type PhotoNestedMetadataProductCreateInput = {
  /** Connect existing "MetadataProduct" nodes to the new "Photo" node, through the "Photo.Metadata_Product" relation. */
  connect?: InputMaybe<Array<MetadataProductWhereUniqueInput>>;
  /** Create new "MetadataProduct" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Product" relation. */
  create?: InputMaybe<Array<MetadataProductWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataProductsCreateInput = {
  /** Connect existing "MetadataProducts" nodes to the new "Photo" node, through the "Photo.Metadata_Products" relation. */
  connect?: InputMaybe<Array<MetadataProductsWhereUniqueInput>>;
  /** Create new "MetadataProducts" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Products" relation. */
  create?: InputMaybe<Array<MetadataProductsWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataProductsUpdateInput = {
  /** Connect existing "MetadataProducts" nodes to the existing "Photo" node, through the "Photo.Metadata_Products" relation. */
  connect?: InputMaybe<Array<MetadataProductsWhereUniqueInput>>;
  /** Create new "MetadataProducts" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Products" relation. */
  create?: InputMaybe<Array<MetadataProductsWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataProducts" nodes from the "Photo.Metadata_Products" relation. */
  delete?: InputMaybe<Array<MetadataProductsWhereUniqueInput>>;
  /** Update existing "MetadataProducts" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Products" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataProductsUpdateInput>>;
  /** Upsert existing "MetadataProducts" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Products" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataProductsUpdateInput>>;
};

export type PhotoNestedMetadataProductUpdateInput = {
  /** Connect existing "MetadataProduct" nodes to the existing "Photo" node, through the "Photo.Metadata_Product" relation. */
  connect?: InputMaybe<Array<MetadataProductWhereUniqueInput>>;
  /** Create new "MetadataProduct" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Product" relation. */
  create?: InputMaybe<Array<MetadataProductWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataProduct" nodes from the "Photo.Metadata_Product" relation. */
  delete?: InputMaybe<Array<MetadataProductWhereUniqueInput>>;
  /** Update existing "MetadataProduct" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Product" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataProductUpdateInput>>;
  /** Upsert existing "MetadataProduct" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Product" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataProductUpdateInput>>;
};

export type PhotoNestedMetadataPublishingsubjectCreateInput = {
  /** Connect existing "MetadataPublishingSubject" nodes to the new "Photo" node, through the "Photo.Metadata_publishingSubject" relation. */
  connect?: InputMaybe<Array<MetadataPublishingSubjectWhereUniqueInput>>;
  /** Create new "MetadataPublishingSubject" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_publishingSubject" relation. */
  create?: InputMaybe<Array<MetadataPublishingSubjectWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataPublishingsubjectUpdateInput = {
  /** Connect existing "MetadataPublishingSubject" nodes to the existing "Photo" node, through the "Photo.Metadata_publishingSubject" relation. */
  connect?: InputMaybe<Array<MetadataPublishingSubjectWhereUniqueInput>>;
  /** Create new "MetadataPublishingSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_publishingSubject" relation. */
  create?: InputMaybe<Array<MetadataPublishingSubjectWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataPublishingSubject" nodes from the "Photo.Metadata_publishingSubject" relation. */
  delete?: InputMaybe<Array<MetadataPublishingSubjectWhereUniqueInput>>;
  /** Update existing "MetadataPublishingSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_publishingSubject" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataPublishingsubjectUpdateInput>>;
  /** Upsert existing "MetadataPublishingSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_publishingSubject" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataPublishingsubjectUpdateInput>>;
};

export type PhotoNestedMetadataResolutionkindCreateInput = {
  /** Connect existing "MetadataResolutionKind" nodes to the new "Photo" node, through the "Photo.Metadata_ResolutionKind" relation. */
  connect?: InputMaybe<Array<MetadataResolutionKindWhereUniqueInput>>;
  /** Create new "MetadataResolutionKind" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_ResolutionKind" relation. */
  create?: InputMaybe<Array<MetadataResolutionKindWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataResolutionkindUpdateInput = {
  /** Connect existing "MetadataResolutionKind" nodes to the existing "Photo" node, through the "Photo.Metadata_ResolutionKind" relation. */
  connect?: InputMaybe<Array<MetadataResolutionKindWhereUniqueInput>>;
  /** Create new "MetadataResolutionKind" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ResolutionKind" relation. */
  create?: InputMaybe<Array<MetadataResolutionKindWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataResolutionKind" nodes from the "Photo.Metadata_ResolutionKind" relation. */
  delete?: InputMaybe<Array<MetadataResolutionKindWhereUniqueInput>>;
  /** Update existing "MetadataResolutionKind" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ResolutionKind" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataResolutionkindUpdateInput>>;
  /** Upsert existing "MetadataResolutionKind" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_ResolutionKind" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataResolutionkindUpdateInput>>;
};

export type PhotoNestedMetadataRightsCreateInput = {
  /** Connect existing "MetadataRights" nodes to the new "Photo" node, through the "Photo.Metadata_rights" relation. */
  connect?: InputMaybe<Array<MetadataRightsWhereUniqueInput>>;
  /** Create new "MetadataRights" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_rights" relation. */
  create?: InputMaybe<Array<MetadataRightsWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataRightsUpdateInput = {
  /** Connect existing "MetadataRights" nodes to the existing "Photo" node, through the "Photo.Metadata_rights" relation. */
  connect?: InputMaybe<Array<MetadataRightsWhereUniqueInput>>;
  /** Create new "MetadataRights" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_rights" relation. */
  create?: InputMaybe<Array<MetadataRightsWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataRights" nodes from the "Photo.Metadata_rights" relation. */
  delete?: InputMaybe<Array<MetadataRightsWhereUniqueInput>>;
  /** Update existing "MetadataRights" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_rights" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataRightsUpdateInput>>;
  /** Upsert existing "MetadataRights" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_rights" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataRightsUpdateInput>>;
};

export type PhotoNestedMetadataSourceCreateInput = {
  /** Connect existing "MetadataSource" nodes to the new "Photo" node, through the "Photo.Metadata_Source" relation. */
  connect?: InputMaybe<Array<MetadataSourceWhereUniqueInput>>;
  /** Create new "MetadataSource" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Source" relation. */
  create?: InputMaybe<Array<MetadataSourceWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataSourceUpdateInput = {
  /** Connect existing "MetadataSource" nodes to the existing "Photo" node, through the "Photo.Metadata_Source" relation. */
  connect?: InputMaybe<Array<MetadataSourceWhereUniqueInput>>;
  /** Create new "MetadataSource" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Source" relation. */
  create?: InputMaybe<Array<MetadataSourceWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataSource" nodes from the "Photo.Metadata_Source" relation. */
  delete?: InputMaybe<Array<MetadataSourceWhereUniqueInput>>;
  /** Update existing "MetadataSource" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Source" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataSourceUpdateInput>>;
  /** Upsert existing "MetadataSource" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Source" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataSourceUpdateInput>>;
};

export type PhotoNestedMetadataSpecialinstructionsCreateInput = {
  /** Connect existing "MetadataSpecialInstructions" nodes to the new "Photo" node, through the "Photo.Metadata_SpecialInstructions" relation. */
  connect?: InputMaybe<Array<MetadataSpecialInstructionsWhereUniqueInput>>;
  /** Create new "MetadataSpecialInstructions" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_SpecialInstructions" relation. */
  create?: InputMaybe<Array<MetadataSpecialInstructionsWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataSpecialinstructionsUpdateInput = {
  /** Connect existing "MetadataSpecialInstructions" nodes to the existing "Photo" node, through the "Photo.Metadata_SpecialInstructions" relation. */
  connect?: InputMaybe<Array<MetadataSpecialInstructionsWhereUniqueInput>>;
  /** Create new "MetadataSpecialInstructions" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_SpecialInstructions" relation. */
  create?: InputMaybe<Array<MetadataSpecialInstructionsWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataSpecialInstructions" nodes from the "Photo.Metadata_SpecialInstructions" relation. */
  delete?: InputMaybe<Array<MetadataSpecialInstructionsWhereUniqueInput>>;
  /** Update existing "MetadataSpecialInstructions" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_SpecialInstructions" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataSpecialinstructionsUpdateInput>>;
  /** Upsert existing "MetadataSpecialInstructions" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_SpecialInstructions" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataSpecialinstructionsUpdateInput>>;
};

export type PhotoNestedMetadataSubjectcodeCreateInput = {
  /** Connect existing "MetadataSubjectCode" nodes to the new "Photo" node, through the "Photo.Metadata_SubjectCode" relation. */
  connect?: InputMaybe<Array<MetadataSubjectCodeWhereUniqueInput>>;
  /** Create new "MetadataSubjectCode" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_SubjectCode" relation. */
  create?: InputMaybe<Array<MetadataSubjectCodeWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataSubjectcodeUpdateInput = {
  /** Connect existing "MetadataSubjectCode" nodes to the existing "Photo" node, through the "Photo.Metadata_SubjectCode" relation. */
  connect?: InputMaybe<Array<MetadataSubjectCodeWhereUniqueInput>>;
  /** Create new "MetadataSubjectCode" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_SubjectCode" relation. */
  create?: InputMaybe<Array<MetadataSubjectCodeWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataSubjectCode" nodes from the "Photo.Metadata_SubjectCode" relation. */
  delete?: InputMaybe<Array<MetadataSubjectCodeWhereUniqueInput>>;
  /** Update existing "MetadataSubjectCode" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_SubjectCode" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataSubjectcodeUpdateInput>>;
  /** Upsert existing "MetadataSubjectCode" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_SubjectCode" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataSubjectcodeUpdateInput>>;
};

export type PhotoNestedMetadataSubjectCreateInput = {
  /** Connect existing "MetadataSubject" nodes to the new "Photo" node, through the "Photo.Metadata_subject" relation. */
  connect?: InputMaybe<Array<MetadataSubjectWhereUniqueInput>>;
  /** Create new "MetadataSubject" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_subject" relation. */
  create?: InputMaybe<Array<MetadataSubjectWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataSubjectprismaCreateInput = {
  /** Connect existing "MetadataSubjectPrisma" nodes to the new "Photo" node, through the "Photo.Metadata_SubjectPrisma" relation. */
  connect?: InputMaybe<Array<MetadataSubjectPrismaWhereUniqueInput>>;
  /** Create new "MetadataSubjectPrisma" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_SubjectPrisma" relation. */
  create?: InputMaybe<Array<MetadataSubjectPrismaWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataSubjectprismaUpdateInput = {
  /** Connect existing "MetadataSubjectPrisma" nodes to the existing "Photo" node, through the "Photo.Metadata_SubjectPrisma" relation. */
  connect?: InputMaybe<Array<MetadataSubjectPrismaWhereUniqueInput>>;
  /** Create new "MetadataSubjectPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_SubjectPrisma" relation. */
  create?: InputMaybe<Array<MetadataSubjectPrismaWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataSubjectPrisma" nodes from the "Photo.Metadata_SubjectPrisma" relation. */
  delete?: InputMaybe<Array<MetadataSubjectPrismaWhereUniqueInput>>;
  /** Update existing "MetadataSubjectPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_SubjectPrisma" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataSubjectprismaUpdateInput>>;
  /** Upsert existing "MetadataSubjectPrisma" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_SubjectPrisma" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataSubjectprismaUpdateInput>>;
};

export type PhotoNestedMetadataSubjectUpdateInput = {
  /** Connect existing "MetadataSubject" nodes to the existing "Photo" node, through the "Photo.Metadata_subject" relation. */
  connect?: InputMaybe<Array<MetadataSubjectWhereUniqueInput>>;
  /** Create new "MetadataSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_subject" relation. */
  create?: InputMaybe<Array<MetadataSubjectWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataSubject" nodes from the "Photo.Metadata_subject" relation. */
  delete?: InputMaybe<Array<MetadataSubjectWhereUniqueInput>>;
  /** Update existing "MetadataSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_subject" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataSubjectUpdateInput>>;
  /** Upsert existing "MetadataSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_subject" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataSubjectUpdateInput>>;
};

export type PhotoNestedMetadataTitleCreateInput = {
  /** Connect existing "MetadataTitle" nodes to the new "Photo" node, through the "Photo.Metadata_title" relation. */
  connect?: InputMaybe<Array<MetadataTitleWhereUniqueInput>>;
  /** Create new "MetadataTitle" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_title" relation. */
  create?: InputMaybe<Array<MetadataTitleWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataTitleUpdateInput = {
  /** Connect existing "MetadataTitle" nodes to the existing "Photo" node, through the "Photo.Metadata_title" relation. */
  connect?: InputMaybe<Array<MetadataTitleWhereUniqueInput>>;
  /** Create new "MetadataTitle" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_title" relation. */
  create?: InputMaybe<Array<MetadataTitleWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataTitle" nodes from the "Photo.Metadata_title" relation. */
  delete?: InputMaybe<Array<MetadataTitleWhereUniqueInput>>;
  /** Update existing "MetadataTitle" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_title" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataTitleUpdateInput>>;
  /** Upsert existing "MetadataTitle" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_title" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataTitleUpdateInput>>;
};

export type PhotoNestedMetadataTransferredbyCreateInput = {
  /** Connect existing "MetadataTransferredBy" nodes to the new "Photo" node, through the "Photo.Metadata_TransferredBy" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByWhereUniqueInput>>;
  /** Create new "MetadataTransferredBy" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_TransferredBy" relation. */
  create?: InputMaybe<Array<MetadataTransferredByWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataTransferredbyfullnameCreateInput = {
  /** Connect existing "MetadataTransferredByFullName" nodes to the new "Photo" node, through the "Photo.Metadata_TransferredByFullName" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByFullNameWhereUniqueInput>>;
  /** Create new "MetadataTransferredByFullName" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_TransferredByFullName" relation. */
  create?: InputMaybe<Array<MetadataTransferredByFullNameWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataTransferredbyfullnameUpdateInput = {
  /** Connect existing "MetadataTransferredByFullName" nodes to the existing "Photo" node, through the "Photo.Metadata_TransferredByFullName" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByFullNameWhereUniqueInput>>;
  /** Create new "MetadataTransferredByFullName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_TransferredByFullName" relation. */
  create?: InputMaybe<Array<MetadataTransferredByFullNameWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataTransferredByFullName" nodes from the "Photo.Metadata_TransferredByFullName" relation. */
  delete?: InputMaybe<Array<MetadataTransferredByFullNameWhereUniqueInput>>;
  /** Update existing "MetadataTransferredByFullName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_TransferredByFullName" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataTransferredbyfullnameUpdateInput>>;
  /** Upsert existing "MetadataTransferredByFullName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_TransferredByFullName" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataTransferredbyfullnameUpdateInput>>;
};

export type PhotoNestedMetadataTransferredbyUpdateInput = {
  /** Connect existing "MetadataTransferredBy" nodes to the existing "Photo" node, through the "Photo.Metadata_TransferredBy" relation. */
  connect?: InputMaybe<Array<MetadataTransferredByWhereUniqueInput>>;
  /** Create new "MetadataTransferredBy" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_TransferredBy" relation. */
  create?: InputMaybe<Array<MetadataTransferredByWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataTransferredBy" nodes from the "Photo.Metadata_TransferredBy" relation. */
  delete?: InputMaybe<Array<MetadataTransferredByWhereUniqueInput>>;
  /** Update existing "MetadataTransferredBy" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_TransferredBy" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataTransferredbyUpdateInput>>;
  /** Upsert existing "MetadataTransferredBy" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_TransferredBy" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataTransferredbyUpdateInput>>;
};

export type PhotoNestedMetadataTypeCreateInput = {
  /** Connect existing "MetadataType" nodes to the new "Photo" node, through the "Photo.Metadata_Type" relation. */
  connect?: InputMaybe<Array<MetadataTypeWhereUniqueInput>>;
  /** Create new "MetadataType" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Type" relation. */
  create?: InputMaybe<Array<MetadataTypeWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataTypeUpdateInput = {
  /** Connect existing "MetadataType" nodes to the existing "Photo" node, through the "Photo.Metadata_Type" relation. */
  connect?: InputMaybe<Array<MetadataTypeWhereUniqueInput>>;
  /** Create new "MetadataType" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Type" relation. */
  create?: InputMaybe<Array<MetadataTypeWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataType" nodes from the "Photo.Metadata_Type" relation. */
  delete?: InputMaybe<Array<MetadataTypeWhereUniqueInput>>;
  /** Update existing "MetadataType" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Type" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataTypeUpdateInput>>;
  /** Upsert existing "MetadataType" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Type" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataTypeUpdateInput>>;
};

export type PhotoNestedMetadataUndersubjectCreateInput = {
  /** Connect existing "MetadataUndersubject" nodes to the new "Photo" node, through the "Photo.Metadata_Undersubject" relation. */
  connect?: InputMaybe<Array<MetadataUndersubjectWhereUniqueInput>>;
  /** Create new "MetadataUndersubject" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Undersubject" relation. */
  create?: InputMaybe<Array<MetadataUndersubjectWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUndersubjectUpdateInput = {
  /** Connect existing "MetadataUndersubject" nodes to the existing "Photo" node, through the "Photo.Metadata_Undersubject" relation. */
  connect?: InputMaybe<Array<MetadataUndersubjectWhereUniqueInput>>;
  /** Create new "MetadataUndersubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Undersubject" relation. */
  create?: InputMaybe<Array<MetadataUndersubjectWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUndersubject" nodes from the "Photo.Metadata_Undersubject" relation. */
  delete?: InputMaybe<Array<MetadataUndersubjectWhereUniqueInput>>;
  /** Update existing "MetadataUndersubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Undersubject" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUndersubjectUpdateInput>>;
  /** Upsert existing "MetadataUndersubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Undersubject" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUndersubjectUpdateInput>>;
};

export type PhotoNestedMetadataUnderundersubjectCreateInput = {
  /** Connect existing "MetadataUnderUnderSubject" nodes to the new "Photo" node, through the "Photo.Metadata_UnderUnderSubject" relation. */
  connect?: InputMaybe<Array<MetadataUnderUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataUnderUnderSubject" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_UnderUnderSubject" relation. */
  create?: InputMaybe<Array<MetadataUnderUnderSubjectWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUnderundersubjectUpdateInput = {
  /** Connect existing "MetadataUnderUnderSubject" nodes to the existing "Photo" node, through the "Photo.Metadata_UnderUnderSubject" relation. */
  connect?: InputMaybe<Array<MetadataUnderUnderSubjectWhereUniqueInput>>;
  /** Create new "MetadataUnderUnderSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UnderUnderSubject" relation. */
  create?: InputMaybe<Array<MetadataUnderUnderSubjectWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUnderUnderSubject" nodes from the "Photo.Metadata_UnderUnderSubject" relation. */
  delete?: InputMaybe<Array<MetadataUnderUnderSubjectWhereUniqueInput>>;
  /** Update existing "MetadataUnderUnderSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UnderUnderSubject" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUnderundersubjectUpdateInput>>;
  /** Upsert existing "MetadataUnderUnderSubject" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UnderUnderSubject" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUnderundersubjectUpdateInput>>;
};

export type PhotoNestedMetadataUploadedbyCreateInput = {
  /** Connect existing "MetadataUploadedBy" nodes to the new "Photo" node, through the "Photo.Metadata_UploadedBy" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByWhereUniqueInput>>;
  /** Create new "MetadataUploadedBy" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_UploadedBy" relation. */
  create?: InputMaybe<Array<MetadataUploadedByWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUploadedbyfullnameCreateInput = {
  /** Connect existing "MetadataUploadedByFullName" nodes to the new "Photo" node, through the "Photo.Metadata_UploadedByFullName" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByFullNameWhereUniqueInput>>;
  /** Create new "MetadataUploadedByFullName" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_UploadedByFullName" relation. */
  create?: InputMaybe<Array<MetadataUploadedByFullNameWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUploadedbyfullnameUpdateInput = {
  /** Connect existing "MetadataUploadedByFullName" nodes to the existing "Photo" node, through the "Photo.Metadata_UploadedByFullName" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByFullNameWhereUniqueInput>>;
  /** Create new "MetadataUploadedByFullName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UploadedByFullName" relation. */
  create?: InputMaybe<Array<MetadataUploadedByFullNameWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUploadedByFullName" nodes from the "Photo.Metadata_UploadedByFullName" relation. */
  delete?: InputMaybe<Array<MetadataUploadedByFullNameWhereUniqueInput>>;
  /** Update existing "MetadataUploadedByFullName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UploadedByFullName" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUploadedbyfullnameUpdateInput>>;
  /** Upsert existing "MetadataUploadedByFullName" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UploadedByFullName" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUploadedbyfullnameUpdateInput>>;
};

export type PhotoNestedMetadataUploadedbyUpdateInput = {
  /** Connect existing "MetadataUploadedBy" nodes to the existing "Photo" node, through the "Photo.Metadata_UploadedBy" relation. */
  connect?: InputMaybe<Array<MetadataUploadedByWhereUniqueInput>>;
  /** Create new "MetadataUploadedBy" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UploadedBy" relation. */
  create?: InputMaybe<Array<MetadataUploadedByWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUploadedBy" nodes from the "Photo.Metadata_UploadedBy" relation. */
  delete?: InputMaybe<Array<MetadataUploadedByWhereUniqueInput>>;
  /** Update existing "MetadataUploadedBy" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UploadedBy" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUploadedbyUpdateInput>>;
  /** Upsert existing "MetadataUploadedBy" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UploadedBy" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUploadedbyUpdateInput>>;
};

export type PhotoNestedMetadataUploadtimeCreateInput = {
  /** Connect existing "MetadataUploadTime" nodes to the new "Photo" node, through the "Photo.Metadata_UploadTime" relation. */
  connect?: InputMaybe<Array<MetadataUploadTimeWhereUniqueInput>>;
  /** Create new "MetadataUploadTime" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_UploadTime" relation. */
  create?: InputMaybe<Array<MetadataUploadTimeWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUploadtimeUpdateInput = {
  /** Connect existing "MetadataUploadTime" nodes to the existing "Photo" node, through the "Photo.Metadata_UploadTime" relation. */
  connect?: InputMaybe<Array<MetadataUploadTimeWhereUniqueInput>>;
  /** Create new "MetadataUploadTime" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UploadTime" relation. */
  create?: InputMaybe<Array<MetadataUploadTimeWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUploadTime" nodes from the "Photo.Metadata_UploadTime" relation. */
  delete?: InputMaybe<Array<MetadataUploadTimeWhereUniqueInput>>;
  /** Update existing "MetadataUploadTime" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UploadTime" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUploadtimeUpdateInput>>;
  /** Upsert existing "MetadataUploadTime" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UploadTime" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUploadtimeUpdateInput>>;
};

export type PhotoNestedMetadataUrgencyCreateInput = {
  /** Connect existing "MetadataUrgency" nodes to the new "Photo" node, through the "Photo.Metadata_Urgency" relation. */
  connect?: InputMaybe<Array<MetadataUrgencyWhereUniqueInput>>;
  /** Create new "MetadataUrgency" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_Urgency" relation. */
  create?: InputMaybe<Array<MetadataUrgencyWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUrgencyUpdateInput = {
  /** Connect existing "MetadataUrgency" nodes to the existing "Photo" node, through the "Photo.Metadata_Urgency" relation. */
  connect?: InputMaybe<Array<MetadataUrgencyWhereUniqueInput>>;
  /** Create new "MetadataUrgency" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Urgency" relation. */
  create?: InputMaybe<Array<MetadataUrgencyWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUrgency" nodes from the "Photo.Metadata_Urgency" relation. */
  delete?: InputMaybe<Array<MetadataUrgencyWhereUniqueInput>>;
  /** Update existing "MetadataUrgency" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Urgency" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUrgencyUpdateInput>>;
  /** Upsert existing "MetadataUrgency" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_Urgency" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUrgencyUpdateInput>>;
};

export type PhotoNestedMetadataUserdefined195CreateInput = {
  /** Connect existing "MetadataUserDefined195" nodes to the new "Photo" node, through the "Photo.Metadata_UserDefined195" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined195WhereUniqueInput>>;
  /** Create new "MetadataUserDefined195" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_UserDefined195" relation. */
  create?: InputMaybe<Array<MetadataUserDefined195WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUserdefined195UpdateInput = {
  /** Connect existing "MetadataUserDefined195" nodes to the existing "Photo" node, through the "Photo.Metadata_UserDefined195" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined195WhereUniqueInput>>;
  /** Create new "MetadataUserDefined195" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined195" relation. */
  create?: InputMaybe<Array<MetadataUserDefined195WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUserDefined195" nodes from the "Photo.Metadata_UserDefined195" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined195WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined195" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined195" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUserdefined195UpdateInput>>;
  /** Upsert existing "MetadataUserDefined195" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined195" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUserdefined195UpdateInput>>;
};

export type PhotoNestedMetadataUserdefined237CreateInput = {
  /** Connect existing "MetadataUserDefined237" nodes to the new "Photo" node, through the "Photo.Metadata_UserDefined237" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined237WhereUniqueInput>>;
  /** Create new "MetadataUserDefined237" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_UserDefined237" relation. */
  create?: InputMaybe<Array<MetadataUserDefined237WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUserdefined237UpdateInput = {
  /** Connect existing "MetadataUserDefined237" nodes to the existing "Photo" node, through the "Photo.Metadata_UserDefined237" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined237WhereUniqueInput>>;
  /** Create new "MetadataUserDefined237" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined237" relation. */
  create?: InputMaybe<Array<MetadataUserDefined237WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUserDefined237" nodes from the "Photo.Metadata_UserDefined237" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined237WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined237" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined237" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUserdefined237UpdateInput>>;
  /** Upsert existing "MetadataUserDefined237" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined237" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUserdefined237UpdateInput>>;
};

export type PhotoNestedMetadataUserdefined238CreateInput = {
  /** Connect existing "MetadataUserDefined238" nodes to the new "Photo" node, through the "Photo.Metadata_UserDefined238" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined238WhereUniqueInput>>;
  /** Create new "MetadataUserDefined238" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_UserDefined238" relation. */
  create?: InputMaybe<Array<MetadataUserDefined238WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUserdefined238UpdateInput = {
  /** Connect existing "MetadataUserDefined238" nodes to the existing "Photo" node, through the "Photo.Metadata_UserDefined238" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined238WhereUniqueInput>>;
  /** Create new "MetadataUserDefined238" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined238" relation. */
  create?: InputMaybe<Array<MetadataUserDefined238WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUserDefined238" nodes from the "Photo.Metadata_UserDefined238" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined238WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined238" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined238" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUserdefined238UpdateInput>>;
  /** Upsert existing "MetadataUserDefined238" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined238" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUserdefined238UpdateInput>>;
};

export type PhotoNestedMetadataUserdefined239CreateInput = {
  /** Connect existing "MetadataUserDefined239" nodes to the new "Photo" node, through the "Photo.Metadata_UserDefined239" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined239WhereUniqueInput>>;
  /** Create new "MetadataUserDefined239" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_UserDefined239" relation. */
  create?: InputMaybe<Array<MetadataUserDefined239WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUserdefined239UpdateInput = {
  /** Connect existing "MetadataUserDefined239" nodes to the existing "Photo" node, through the "Photo.Metadata_UserDefined239" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined239WhereUniqueInput>>;
  /** Create new "MetadataUserDefined239" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined239" relation. */
  create?: InputMaybe<Array<MetadataUserDefined239WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUserDefined239" nodes from the "Photo.Metadata_UserDefined239" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined239WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined239" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined239" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUserdefined239UpdateInput>>;
  /** Upsert existing "MetadataUserDefined239" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined239" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUserdefined239UpdateInput>>;
};

export type PhotoNestedMetadataUserdefined242CreateInput = {
  /** Connect existing "MetadataUserDefined242" nodes to the new "Photo" node, through the "Photo.Metadata_UserDefined242" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined242WhereUniqueInput>>;
  /** Create new "MetadataUserDefined242" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_UserDefined242" relation. */
  create?: InputMaybe<Array<MetadataUserDefined242WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUserdefined242UpdateInput = {
  /** Connect existing "MetadataUserDefined242" nodes to the existing "Photo" node, through the "Photo.Metadata_UserDefined242" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined242WhereUniqueInput>>;
  /** Create new "MetadataUserDefined242" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined242" relation. */
  create?: InputMaybe<Array<MetadataUserDefined242WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUserDefined242" nodes from the "Photo.Metadata_UserDefined242" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined242WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined242" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined242" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUserdefined242UpdateInput>>;
  /** Upsert existing "MetadataUserDefined242" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined242" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUserdefined242UpdateInput>>;
};

export type PhotoNestedMetadataUserdefined62CreateInput = {
  /** Connect existing "MetadataUserDefined62" nodes to the new "Photo" node, through the "Photo.Metadata_UserDefined62" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined62WhereUniqueInput>>;
  /** Create new "MetadataUserDefined62" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_UserDefined62" relation. */
  create?: InputMaybe<Array<MetadataUserDefined62WithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataUserdefined62UpdateInput = {
  /** Connect existing "MetadataUserDefined62" nodes to the existing "Photo" node, through the "Photo.Metadata_UserDefined62" relation. */
  connect?: InputMaybe<Array<MetadataUserDefined62WhereUniqueInput>>;
  /** Create new "MetadataUserDefined62" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined62" relation. */
  create?: InputMaybe<Array<MetadataUserDefined62WithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataUserDefined62" nodes from the "Photo.Metadata_UserDefined62" relation. */
  delete?: InputMaybe<Array<MetadataUserDefined62WhereUniqueInput>>;
  /** Update existing "MetadataUserDefined62" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined62" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataUserdefined62UpdateInput>>;
  /** Upsert existing "MetadataUserDefined62" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_UserDefined62" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataUserdefined62UpdateInput>>;
};

export type PhotoNestedMetadataWorkflowkindCreateInput = {
  /** Connect existing "MetadataWorkflowKind" nodes to the new "Photo" node, through the "Photo.Metadata_WorkflowKind" relation. */
  connect?: InputMaybe<Array<MetadataWorkflowKindWhereUniqueInput>>;
  /** Create new "MetadataWorkflowKind" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_WorkflowKind" relation. */
  create?: InputMaybe<Array<MetadataWorkflowKindWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataWorkflowkindUpdateInput = {
  /** Connect existing "MetadataWorkflowKind" nodes to the existing "Photo" node, through the "Photo.Metadata_WorkflowKind" relation. */
  connect?: InputMaybe<Array<MetadataWorkflowKindWhereUniqueInput>>;
  /** Create new "MetadataWorkflowKind" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_WorkflowKind" relation. */
  create?: InputMaybe<Array<MetadataWorkflowKindWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataWorkflowKind" nodes from the "Photo.Metadata_WorkflowKind" relation. */
  delete?: InputMaybe<Array<MetadataWorkflowKindWhereUniqueInput>>;
  /** Update existing "MetadataWorkflowKind" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_WorkflowKind" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataWorkflowkindUpdateInput>>;
  /** Upsert existing "MetadataWorkflowKind" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_WorkflowKind" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataWorkflowkindUpdateInput>>;
};

export type PhotoNestedMetadataXmphistoryCreateInput = {
  /** Connect existing "MetadataXmpHistory" nodes to the new "Photo" node, through the "Photo.Metadata_XMPHistory" relation. */
  connect?: InputMaybe<Array<MetadataXmpHistoryWhereUniqueInput>>;
  /** Create new "MetadataXmpHistory" nodes and connect them to the new "Photo" node, through the "Photo.Metadata_XMPHistory" relation. */
  create?: InputMaybe<Array<MetadataXmpHistoryWithForcedPhotoCreateInput>>;
};

export type PhotoNestedMetadataXmphistoryUpdateInput = {
  /** Connect existing "MetadataXmpHistory" nodes to the existing "Photo" node, through the "Photo.Metadata_XMPHistory" relation. */
  connect?: InputMaybe<Array<MetadataXmpHistoryWhereUniqueInput>>;
  /** Create new "MetadataXmpHistory" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_XMPHistory" relation. */
  create?: InputMaybe<Array<MetadataXmpHistoryWithForcedPhotoCreateInput>>;
  /** Delete existing "MetadataXmpHistory" nodes from the "Photo.Metadata_XMPHistory" relation. */
  delete?: InputMaybe<Array<MetadataXmpHistoryWhereUniqueInput>>;
  /** Update existing "MetadataXmpHistory" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_XMPHistory" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdateMetadataXmphistoryUpdateInput>>;
  /** Upsert existing "MetadataXmpHistory" nodes and connect them to the existing "Photo" node, through the "Photo.Metadata_XMPHistory" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertMetadataXmphistoryUpdateInput>>;
};

export type PhotoNestedPhotoMetadatasCreateInput = {
  /** Create new "PhotoMetadata" nodes and connect them to the new "Photo" node, through the "Photo.photoMetadatas" relation. */
  create?: InputMaybe<Array<PhotoMetadataWithForcedPhotoCreateInput>>;
};

export type PhotoNestedPhotoMetadatasUpdateInput = {
  /** Create new "PhotoMetadata" nodes and connect them to the existing "Photo" node, through the "Photo.photoMetadatas" relation. */
  create?: InputMaybe<Array<PhotoMetadataWithForcedPhotoCreateInput>>;
  /** Delete existing "PhotoMetadata" nodes from the "Photo.photoMetadatas" relation. */
  delete?: InputMaybe<Array<PhotoMetadataWhereUniqueInput>>;
  /** Update existing "PhotoMetadata" nodes and connect them to the existing "Photo" node, through the "Photo.photoMetadatas" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdatePhotoMetadatasUpdateInput>>;
  /** Upsert existing "PhotoMetadata" nodes and connect them to the existing "Photo" node, through the "Photo.photoMetadatas" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertPhotoMetadatasUpdateInput>>;
};

export type PhotoNestedPhotoPublicationsCreateInput = {
  /** Connect existing "PhotoPublication" nodes to the new "Photo" node, through the "Photo.photoPublications" relation. */
  connect?: InputMaybe<Array<PhotoPublicationWhereUniqueInput>>;
  /** Create new "PhotoPublication" nodes and connect them to the new "Photo" node, through the "Photo.photoPublications" relation. */
  create?: InputMaybe<Array<PhotoPublicationWithForcedPhotoCreateInput>>;
};

export type PhotoNestedPhotoPublicationsUpdateInput = {
  /** Connect existing "PhotoPublication" nodes to the existing "Photo" node, through the "Photo.photoPublications" relation. */
  connect?: InputMaybe<Array<PhotoPublicationWhereUniqueInput>>;
  /** Create new "PhotoPublication" nodes and connect them to the existing "Photo" node, through the "Photo.photoPublications" relation. */
  create?: InputMaybe<Array<PhotoPublicationWithForcedPhotoCreateInput>>;
  /** Delete existing "PhotoPublication" nodes from the "Photo.photoPublications" relation. */
  delete?: InputMaybe<Array<PhotoPublicationWhereUniqueInput>>;
  /** Update existing "PhotoPublication" nodes and connect them to the existing "Photo" node, through the "Photo.photoPublications" relation. */
  update?: InputMaybe<Array<PhotoNestedUpdatePhotoPublicationsUpdateInput>>;
  /** Upsert existing "PhotoPublication" nodes and connect them to the existing "Photo" node, through the "Photo.photoPublications" relation. */
  upsert?: InputMaybe<Array<PhotoNestedUpsertPhotoPublicationsUpdateInput>>;
};

export type PhotoNestedUpdateAgencyCreateInput = {
  data: AgencyUpdateInput;
  where: AgencyWhereUniqueInput;
};

export type PhotoNestedUpdateAgencyUpdateInput = {
  data: AgencyUpdateInput;
  where: AgencyWhereUniqueInput;
};

export type PhotoNestedUpdateArchiveCreateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type PhotoNestedUpdateArchiveUpdateInput = {
  data: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type PhotoNestedUpdateCategoryCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type PhotoNestedUpdateCategoryUpdateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type PhotoNestedUpdateDeliverySubjectCreateInput = {
  data: DeliverySubjectUpdateInput;
  where: DeliverySubjectWhereUniqueInput;
};

export type PhotoNestedUpdateDeliverySubjectUpdateInput = {
  data: DeliverySubjectUpdateInput;
  where: DeliverySubjectWhereUniqueInput;
};

export type PhotoNestedUpdateImportQueueUpdateInput = {
  data: ImportQueueWithForcedPhotoUpdateInput;
  where: ImportQueueWithOptionalPhotoWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataAccessrightsUpdateInput = {
  data: MetadataAccessRightsWithForcedPhotoUpdateInput;
  where: MetadataAccessRightsWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataAssetstateUpdateInput = {
  data: MetadataAssetStateWithForcedPhotoUpdateInput;
  where: MetadataAssetStateWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataBackupnameUpdateInput = {
  data: MetadataBackupNameWithForcedPhotoUpdateInput;
  where: MetadataBackupNameWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataBrandprismaUpdateInput = {
  data: MetadataBrandPrismaWithForcedPhotoUpdateInput;
  where: MetadataBrandPrismaWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataBrandshortnameUpdateInput = {
  data: MetadataBrandShortNameWithForcedPhotoUpdateInput;
  where: MetadataBrandShortNameWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataBrandUpdateInput = {
  data: MetadataBrandWithForcedPhotoUpdateInput;
  where: MetadataBrandWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataByLineUpdateInput = {
  data: MetadataByLineWithForcedPhotoUpdateInput;
  where: MetadataByLineWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCaptionAbstractUpdateInput = {
  data: MetadataCaptionAbstractWithForcedPhotoUpdateInput;
  where: MetadataCaptionAbstractWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCaptionUpdateInput = {
  data: MetadataCaptionWithForcedPhotoUpdateInput;
  where: MetadataCaptionWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCategoryprismaUpdateInput = {
  data: MetadataCategoryPrismaWithForcedPhotoUpdateInput;
  where: MetadataCategoryPrismaWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCategoryUpdateInput = {
  data: MetadataCategoryWithForcedPhotoUpdateInput;
  where: MetadataCategoryWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCompanyshortnameUpdateInput = {
  data: MetadataCompanyShortNameWithForcedPhotoUpdateInput;
  where: MetadataCompanyShortNameWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCompanyUpdateInput = {
  data: MetadataCompanyWithForcedPhotoUpdateInput;
  where: MetadataCompanyWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCopyrightnoticeUpdateInput = {
  data: MetadataCopyrightNoticeWithForcedPhotoUpdateInput;
  where: MetadataCopyrightNoticeWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCreatorUpdateInput = {
  data: MetadataCreatorWithForcedPhotoUpdateInput;
  where: MetadataCreatorWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCreditUpdateInput = {
  data: MetadataCreditWithForcedPhotoUpdateInput;
  where: MetadataCreditWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield14UpdateInput = {
  data: MetadataCustomField14WithForcedPhotoUpdateInput;
  where: MetadataCustomField14WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield15UpdateInput = {
  data: MetadataCustomField15WithForcedPhotoUpdateInput;
  where: MetadataCustomField15WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield16UpdateInput = {
  data: MetadataCustomField16WithForcedPhotoUpdateInput;
  where: MetadataCustomField16WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield17UpdateInput = {
  data: MetadataCustomField17WithForcedPhotoUpdateInput;
  where: MetadataCustomField17WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield1UpdateInput = {
  data: MetadataCustomField1WithForcedPhotoUpdateInput;
  where: MetadataCustomField1WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield20UpdateInput = {
  data: MetadataCustomField20WithForcedPhotoUpdateInput;
  where: MetadataCustomField20WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield3UpdateInput = {
  data: MetadataCustomField3WithForcedPhotoUpdateInput;
  where: MetadataCustomField3WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield4UpdateInput = {
  data: MetadataCustomField4WithForcedPhotoUpdateInput;
  where: MetadataCustomField4WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield5UpdateInput = {
  data: MetadataCustomField5WithForcedPhotoUpdateInput;
  where: MetadataCustomField5WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield6UpdateInput = {
  data: MetadataCustomField6WithForcedPhotoUpdateInput;
  where: MetadataCustomField6WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield7UpdateInput = {
  data: MetadataCustomField7WithForcedPhotoUpdateInput;
  where: MetadataCustomField7WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataCustomfield9UpdateInput = {
  data: MetadataCustomField9WithForcedPhotoUpdateInput;
  where: MetadataCustomField9WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDatecreatedUpdateInput = {
  data: MetadataDateCreatedWithForcedPhotoUpdateInput;
  where: MetadataDateCreatedWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDatetimeoriginalUpdateInput = {
  data: MetadataDateTimeOriginalWithForcedPhotoUpdateInput;
  where: MetadataDateTimeOriginalWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliveryaccountUpdateInput = {
  data: MetadataDeliveryAccountWithForcedPhotoUpdateInput;
  where: MetadataDeliveryAccountWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliverycompanyUpdateInput = {
  data: MetadataDeliveryCompanyWithForcedPhotoUpdateInput;
  where: MetadataDeliveryCompanyWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliverycopyrightUpdateInput = {
  data: MetadataDeliveryCopyrightWithForcedPhotoUpdateInput;
  where: MetadataDeliveryCopyrightWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliverydatefolderUpdateInput = {
  data: MetadataDeliveryDateFolderWithForcedPhotoUpdateInput;
  where: MetadataDeliveryDateFolderWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliverydatetimeUpdateInput = {
  data: MetadataDeliveryDateTimeWithForcedPhotoUpdateInput;
  where: MetadataDeliveryDateTimeWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliverydccreatorUpdateInput = {
  data: MetadataDeliveryDcCreatorWithForcedPhotoUpdateInput;
  where: MetadataDeliveryDcCreatorWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliverydcrightsUpdateInput = {
  data: MetadataDeliveryDcRightsWithForcedPhotoUpdateInput;
  where: MetadataDeliveryDcRightsWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliveryfolderUpdateInput = {
  data: MetadataDeliveryFolderWithForcedPhotoUpdateInput;
  where: MetadataDeliveryFolderWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliverykindUpdateInput = {
  data: MetadataDeliveryKindWithForcedPhotoUpdateInput;
  where: MetadataDeliveryKindWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliverypathUpdateInput = {
  data: MetadataDeliveryPathWithForcedPhotoUpdateInput;
  where: MetadataDeliveryPathWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliveryphotoshopcreditUpdateInput = {
  data: MetadataDeliveryPhotoshopCreditWithForcedPhotoUpdateInput;
  where: MetadataDeliveryPhotoshopCreditWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliveryphotoshopsourceUpdateInput = {
  data: MetadataDeliveryPhotoshopSourceWithForcedPhotoUpdateInput;
  where: MetadataDeliveryPhotoshopSourceWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliveryserviceUpdateInput = {
  data: MetadataDeliveryServiceWithForcedPhotoUpdateInput;
  where: MetadataDeliveryServiceWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliverysubjectUpdateInput = {
  data: MetadataDeliverySubjectWithForcedPhotoUpdateInput;
  where: MetadataDeliverySubjectWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDeliveryundersubjectUpdateInput = {
  data: MetadataDeliveryUnderSubjectWithForcedPhotoUpdateInput;
  where: MetadataDeliveryUnderSubjectWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDepartmentUpdateInput = {
  data: MetadataDepartmentWithForcedPhotoUpdateInput;
  where: MetadataDepartmentWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataDescriptionUpdateInput = {
  data: MetadataDescriptionWithForcedPhotoUpdateInput;
  where: MetadataDescriptionWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataEditionUpdateInput = {
  data: MetadataEditionWithForcedPhotoUpdateInput;
  where: MetadataEditionWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataEditstatusUpdateInput = {
  data: MetadataEditStatusWithForcedPhotoUpdateInput;
  where: MetadataEditStatusWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataFilestatusUpdateInput = {
  data: MetadataFileStatusWithForcedPhotoUpdateInput;
  where: MetadataFileStatusWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataFormatUpdateInput = {
  data: MetadataFormatWithForcedPhotoUpdateInput;
  where: MetadataFormatWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataHeaderprismaUpdateInput = {
  data: MetadataHeaderPrismaWithForcedPhotoUpdateInput;
  where: MetadataHeaderPrismaWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataHeaderUpdateInput = {
  data: MetadataHeaderWithForcedPhotoUpdateInput;
  where: MetadataHeaderWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataHeadlineUpdateInput = {
  data: MetadataHeadlineWithForcedPhotoUpdateInput;
  where: MetadataHeadlineWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataIdassignmentUpdateInput = {
  data: MetadataIdAssignmentWithForcedPhotoUpdateInput;
  where: MetadataIdAssignmentWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataIdphotoprismaUpdateInput = {
  data: MetadataIdPhotoPrismaWithForcedPhotoUpdateInput;
  where: MetadataIdPhotoPrismaWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataIdSubjectUpdateInput = {
  data: MetadataIdSubjectWithForcedPhotoUpdateInput;
  where: MetadataIdSubjectWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataImagenotesUpdateInput = {
  data: MetadataImageNotesWithForcedPhotoUpdateInput;
  where: MetadataImageNotesWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataInstructionsUpdateInput = {
  data: MetadataInstructionsWithForcedPhotoUpdateInput;
  where: MetadataInstructionsWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataIssueUpdateInput = {
  data: MetadataIssueWithForcedPhotoUpdateInput;
  where: MetadataIssueWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataKeywordsUpdateInput = {
  data: MetadataKeywordsWithForcedPhotoUpdateInput;
  where: MetadataKeywordsWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataObjectnameUpdateInput = {
  data: MetadataObjectNameWithForcedPhotoUpdateInput;
  where: MetadataObjectNameWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataOriginalnameUpdateInput = {
  data: MetadataOriginalNameWithForcedPhotoUpdateInput;
  where: MetadataOriginalNameWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataPricelevelUpdateInput = {
  data: MetadataPriceLevelWithForcedPhotoUpdateInput;
  where: MetadataPriceLevelWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataProcesshistoryUpdateInput = {
  data: MetadataProcessHistoryWithForcedPhotoUpdateInput;
  where: MetadataProcessHistoryWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataProcessstatusUpdateInput = {
  data: MetadataProcessStatusWithForcedPhotoUpdateInput;
  where: MetadataProcessStatusWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataProductsUpdateInput = {
  data: MetadataProductsWithForcedPhotoUpdateInput;
  where: MetadataProductsWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataProductUpdateInput = {
  data: MetadataProductWithForcedPhotoUpdateInput;
  where: MetadataProductWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataPublishingsubjectUpdateInput = {
  data: MetadataPublishingSubjectWithForcedPhotoUpdateInput;
  where: MetadataPublishingSubjectWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataResolutionkindUpdateInput = {
  data: MetadataResolutionKindWithForcedPhotoUpdateInput;
  where: MetadataResolutionKindWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataRightsUpdateInput = {
  data: MetadataRightsWithForcedPhotoUpdateInput;
  where: MetadataRightsWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataSourceUpdateInput = {
  data: MetadataSourceWithForcedPhotoUpdateInput;
  where: MetadataSourceWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataSpecialinstructionsUpdateInput = {
  data: MetadataSpecialInstructionsWithForcedPhotoUpdateInput;
  where: MetadataSpecialInstructionsWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataSubjectcodeUpdateInput = {
  data: MetadataSubjectCodeWithForcedPhotoUpdateInput;
  where: MetadataSubjectCodeWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataSubjectprismaUpdateInput = {
  data: MetadataSubjectPrismaWithForcedPhotoUpdateInput;
  where: MetadataSubjectPrismaWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataSubjectUpdateInput = {
  data: MetadataSubjectWithForcedPhotoUpdateInput;
  where: MetadataSubjectWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataTitleUpdateInput = {
  data: MetadataTitleWithForcedPhotoUpdateInput;
  where: MetadataTitleWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataTransferredbyfullnameUpdateInput = {
  data: MetadataTransferredByFullNameWithForcedPhotoUpdateInput;
  where: MetadataTransferredByFullNameWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataTransferredbyUpdateInput = {
  data: MetadataTransferredByWithForcedPhotoUpdateInput;
  where: MetadataTransferredByWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataTypeUpdateInput = {
  data: MetadataTypeWithForcedPhotoUpdateInput;
  where: MetadataTypeWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUndersubjectUpdateInput = {
  data: MetadataUndersubjectWithForcedPhotoUpdateInput;
  where: MetadataUndersubjectWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUnderundersubjectUpdateInput = {
  data: MetadataUnderUnderSubjectWithForcedPhotoUpdateInput;
  where: MetadataUnderUnderSubjectWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUploadedbyfullnameUpdateInput = {
  data: MetadataUploadedByFullNameWithForcedPhotoUpdateInput;
  where: MetadataUploadedByFullNameWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUploadedbyUpdateInput = {
  data: MetadataUploadedByWithForcedPhotoUpdateInput;
  where: MetadataUploadedByWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUploadtimeUpdateInput = {
  data: MetadataUploadTimeWithForcedPhotoUpdateInput;
  where: MetadataUploadTimeWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUrgencyUpdateInput = {
  data: MetadataUrgencyWithForcedPhotoUpdateInput;
  where: MetadataUrgencyWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUserdefined195UpdateInput = {
  data: MetadataUserDefined195WithForcedPhotoUpdateInput;
  where: MetadataUserDefined195WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUserdefined237UpdateInput = {
  data: MetadataUserDefined237WithForcedPhotoUpdateInput;
  where: MetadataUserDefined237WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUserdefined238UpdateInput = {
  data: MetadataUserDefined238WithForcedPhotoUpdateInput;
  where: MetadataUserDefined238WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUserdefined239UpdateInput = {
  data: MetadataUserDefined239WithForcedPhotoUpdateInput;
  where: MetadataUserDefined239WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUserdefined242UpdateInput = {
  data: MetadataUserDefined242WithForcedPhotoUpdateInput;
  where: MetadataUserDefined242WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataUserdefined62UpdateInput = {
  data: MetadataUserDefined62WithForcedPhotoUpdateInput;
  where: MetadataUserDefined62WhereUniqueInput;
};

export type PhotoNestedUpdateMetadataWorkflowkindUpdateInput = {
  data: MetadataWorkflowKindWithForcedPhotoUpdateInput;
  where: MetadataWorkflowKindWhereUniqueInput;
};

export type PhotoNestedUpdateMetadataXmphistoryUpdateInput = {
  data: MetadataXmpHistoryWithForcedPhotoUpdateInput;
  where: MetadataXmpHistoryWhereUniqueInput;
};

export type PhotoNestedUpdatePhotoMetadatasUpdateInput = {
  data: PhotoMetadataWithForcedPhotoUpdateInput;
  where: PhotoMetadataWhereUniqueInput;
};

export type PhotoNestedUpdatePhotoPublicationsUpdateInput = {
  data: PhotoPublicationWithForcedPhotoUpdateInput;
  where: PhotoPublicationWhereUniqueInput;
};

export type PhotoNestedUpsertAgencyCreateInput = {
  create: AgencyCreateInput;
  update: AgencyUpdateInput;
  where: AgencyWhereUniqueInput;
};

export type PhotoNestedUpsertAgencyUpdateInput = {
  create: AgencyCreateInput;
  update: AgencyUpdateInput;
  where: AgencyWhereUniqueInput;
};

export type PhotoNestedUpsertArchiveCreateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type PhotoNestedUpsertArchiveUpdateInput = {
  create: ArchiveCreateInput;
  update: ArchiveUpdateInput;
  where: ArchiveWhereUniqueInput;
};

export type PhotoNestedUpsertCategoryCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type PhotoNestedUpsertCategoryUpdateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type PhotoNestedUpsertDeliverySubjectCreateInput = {
  create: DeliverySubjectCreateInput;
  update: DeliverySubjectUpdateInput;
  where: DeliverySubjectWhereUniqueInput;
};

export type PhotoNestedUpsertDeliverySubjectUpdateInput = {
  create: DeliverySubjectCreateInput;
  update: DeliverySubjectUpdateInput;
  where: DeliverySubjectWhereUniqueInput;
};

export type PhotoNestedUpsertImportQueueUpdateInput = {
  create: ImportQueueWithForcedPhotoCreateInput;
  update: ImportQueueWithForcedPhotoUpdateInput;
  where: ImportQueueWithOptionalPhotoWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataAccessrightsUpdateInput = {
  create: MetadataAccessRightsWithForcedPhotoCreateInput;
  update: MetadataAccessRightsWithForcedPhotoUpdateInput;
  where: MetadataAccessRightsWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataAssetstateUpdateInput = {
  create: MetadataAssetStateWithForcedPhotoCreateInput;
  update: MetadataAssetStateWithForcedPhotoUpdateInput;
  where: MetadataAssetStateWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataBackupnameUpdateInput = {
  create: MetadataBackupNameWithForcedPhotoCreateInput;
  update: MetadataBackupNameWithForcedPhotoUpdateInput;
  where: MetadataBackupNameWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataBrandprismaUpdateInput = {
  create: MetadataBrandPrismaWithForcedPhotoCreateInput;
  update: MetadataBrandPrismaWithForcedPhotoUpdateInput;
  where: MetadataBrandPrismaWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataBrandshortnameUpdateInput = {
  create: MetadataBrandShortNameWithForcedPhotoCreateInput;
  update: MetadataBrandShortNameWithForcedPhotoUpdateInput;
  where: MetadataBrandShortNameWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataBrandUpdateInput = {
  create: MetadataBrandWithForcedPhotoCreateInput;
  update: MetadataBrandWithForcedPhotoUpdateInput;
  where: MetadataBrandWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataByLineUpdateInput = {
  create: MetadataByLineWithForcedPhotoCreateInput;
  update: MetadataByLineWithForcedPhotoUpdateInput;
  where: MetadataByLineWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCaptionAbstractUpdateInput = {
  create: MetadataCaptionAbstractWithForcedPhotoCreateInput;
  update: MetadataCaptionAbstractWithForcedPhotoUpdateInput;
  where: MetadataCaptionAbstractWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCaptionUpdateInput = {
  create: MetadataCaptionWithForcedPhotoCreateInput;
  update: MetadataCaptionWithForcedPhotoUpdateInput;
  where: MetadataCaptionWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCategoryprismaUpdateInput = {
  create: MetadataCategoryPrismaWithForcedPhotoCreateInput;
  update: MetadataCategoryPrismaWithForcedPhotoUpdateInput;
  where: MetadataCategoryPrismaWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCategoryUpdateInput = {
  create: MetadataCategoryWithForcedPhotoCreateInput;
  update: MetadataCategoryWithForcedPhotoUpdateInput;
  where: MetadataCategoryWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCompanyshortnameUpdateInput = {
  create: MetadataCompanyShortNameWithForcedPhotoCreateInput;
  update: MetadataCompanyShortNameWithForcedPhotoUpdateInput;
  where: MetadataCompanyShortNameWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCompanyUpdateInput = {
  create: MetadataCompanyWithForcedPhotoCreateInput;
  update: MetadataCompanyWithForcedPhotoUpdateInput;
  where: MetadataCompanyWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCopyrightnoticeUpdateInput = {
  create: MetadataCopyrightNoticeWithForcedPhotoCreateInput;
  update: MetadataCopyrightNoticeWithForcedPhotoUpdateInput;
  where: MetadataCopyrightNoticeWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCreatorUpdateInput = {
  create: MetadataCreatorWithForcedPhotoCreateInput;
  update: MetadataCreatorWithForcedPhotoUpdateInput;
  where: MetadataCreatorWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCreditUpdateInput = {
  create: MetadataCreditWithForcedPhotoCreateInput;
  update: MetadataCreditWithForcedPhotoUpdateInput;
  where: MetadataCreditWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield14UpdateInput = {
  create: MetadataCustomField14WithForcedPhotoCreateInput;
  update: MetadataCustomField14WithForcedPhotoUpdateInput;
  where: MetadataCustomField14WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield15UpdateInput = {
  create: MetadataCustomField15WithForcedPhotoCreateInput;
  update: MetadataCustomField15WithForcedPhotoUpdateInput;
  where: MetadataCustomField15WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield16UpdateInput = {
  create: MetadataCustomField16WithForcedPhotoCreateInput;
  update: MetadataCustomField16WithForcedPhotoUpdateInput;
  where: MetadataCustomField16WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield17UpdateInput = {
  create: MetadataCustomField17WithForcedPhotoCreateInput;
  update: MetadataCustomField17WithForcedPhotoUpdateInput;
  where: MetadataCustomField17WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield1UpdateInput = {
  create: MetadataCustomField1WithForcedPhotoCreateInput;
  update: MetadataCustomField1WithForcedPhotoUpdateInput;
  where: MetadataCustomField1WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield20UpdateInput = {
  create: MetadataCustomField20WithForcedPhotoCreateInput;
  update: MetadataCustomField20WithForcedPhotoUpdateInput;
  where: MetadataCustomField20WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield3UpdateInput = {
  create: MetadataCustomField3WithForcedPhotoCreateInput;
  update: MetadataCustomField3WithForcedPhotoUpdateInput;
  where: MetadataCustomField3WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield4UpdateInput = {
  create: MetadataCustomField4WithForcedPhotoCreateInput;
  update: MetadataCustomField4WithForcedPhotoUpdateInput;
  where: MetadataCustomField4WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield5UpdateInput = {
  create: MetadataCustomField5WithForcedPhotoCreateInput;
  update: MetadataCustomField5WithForcedPhotoUpdateInput;
  where: MetadataCustomField5WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield6UpdateInput = {
  create: MetadataCustomField6WithForcedPhotoCreateInput;
  update: MetadataCustomField6WithForcedPhotoUpdateInput;
  where: MetadataCustomField6WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield7UpdateInput = {
  create: MetadataCustomField7WithForcedPhotoCreateInput;
  update: MetadataCustomField7WithForcedPhotoUpdateInput;
  where: MetadataCustomField7WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataCustomfield9UpdateInput = {
  create: MetadataCustomField9WithForcedPhotoCreateInput;
  update: MetadataCustomField9WithForcedPhotoUpdateInput;
  where: MetadataCustomField9WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDatecreatedUpdateInput = {
  create: MetadataDateCreatedWithForcedPhotoCreateInput;
  update: MetadataDateCreatedWithForcedPhotoUpdateInput;
  where: MetadataDateCreatedWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDatetimeoriginalUpdateInput = {
  create: MetadataDateTimeOriginalWithForcedPhotoCreateInput;
  update: MetadataDateTimeOriginalWithForcedPhotoUpdateInput;
  where: MetadataDateTimeOriginalWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliveryaccountUpdateInput = {
  create: MetadataDeliveryAccountWithForcedPhotoCreateInput;
  update: MetadataDeliveryAccountWithForcedPhotoUpdateInput;
  where: MetadataDeliveryAccountWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliverycompanyUpdateInput = {
  create: MetadataDeliveryCompanyWithForcedPhotoCreateInput;
  update: MetadataDeliveryCompanyWithForcedPhotoUpdateInput;
  where: MetadataDeliveryCompanyWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliverycopyrightUpdateInput = {
  create: MetadataDeliveryCopyrightWithForcedPhotoCreateInput;
  update: MetadataDeliveryCopyrightWithForcedPhotoUpdateInput;
  where: MetadataDeliveryCopyrightWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliverydatefolderUpdateInput = {
  create: MetadataDeliveryDateFolderWithForcedPhotoCreateInput;
  update: MetadataDeliveryDateFolderWithForcedPhotoUpdateInput;
  where: MetadataDeliveryDateFolderWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliverydatetimeUpdateInput = {
  create: MetadataDeliveryDateTimeWithForcedPhotoCreateInput;
  update: MetadataDeliveryDateTimeWithForcedPhotoUpdateInput;
  where: MetadataDeliveryDateTimeWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliverydccreatorUpdateInput = {
  create: MetadataDeliveryDcCreatorWithForcedPhotoCreateInput;
  update: MetadataDeliveryDcCreatorWithForcedPhotoUpdateInput;
  where: MetadataDeliveryDcCreatorWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliverydcrightsUpdateInput = {
  create: MetadataDeliveryDcRightsWithForcedPhotoCreateInput;
  update: MetadataDeliveryDcRightsWithForcedPhotoUpdateInput;
  where: MetadataDeliveryDcRightsWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliveryfolderUpdateInput = {
  create: MetadataDeliveryFolderWithForcedPhotoCreateInput;
  update: MetadataDeliveryFolderWithForcedPhotoUpdateInput;
  where: MetadataDeliveryFolderWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliverykindUpdateInput = {
  create: MetadataDeliveryKindWithForcedPhotoCreateInput;
  update: MetadataDeliveryKindWithForcedPhotoUpdateInput;
  where: MetadataDeliveryKindWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliverypathUpdateInput = {
  create: MetadataDeliveryPathWithForcedPhotoCreateInput;
  update: MetadataDeliveryPathWithForcedPhotoUpdateInput;
  where: MetadataDeliveryPathWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliveryphotoshopcreditUpdateInput = {
  create: MetadataDeliveryPhotoshopCreditWithForcedPhotoCreateInput;
  update: MetadataDeliveryPhotoshopCreditWithForcedPhotoUpdateInput;
  where: MetadataDeliveryPhotoshopCreditWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliveryphotoshopsourceUpdateInput = {
  create: MetadataDeliveryPhotoshopSourceWithForcedPhotoCreateInput;
  update: MetadataDeliveryPhotoshopSourceWithForcedPhotoUpdateInput;
  where: MetadataDeliveryPhotoshopSourceWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliveryserviceUpdateInput = {
  create: MetadataDeliveryServiceWithForcedPhotoCreateInput;
  update: MetadataDeliveryServiceWithForcedPhotoUpdateInput;
  where: MetadataDeliveryServiceWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliverysubjectUpdateInput = {
  create: MetadataDeliverySubjectWithForcedPhotoCreateInput;
  update: MetadataDeliverySubjectWithForcedPhotoUpdateInput;
  where: MetadataDeliverySubjectWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDeliveryundersubjectUpdateInput = {
  create: MetadataDeliveryUnderSubjectWithForcedPhotoCreateInput;
  update: MetadataDeliveryUnderSubjectWithForcedPhotoUpdateInput;
  where: MetadataDeliveryUnderSubjectWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDepartmentUpdateInput = {
  create: MetadataDepartmentWithForcedPhotoCreateInput;
  update: MetadataDepartmentWithForcedPhotoUpdateInput;
  where: MetadataDepartmentWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataDescriptionUpdateInput = {
  create: MetadataDescriptionWithForcedPhotoCreateInput;
  update: MetadataDescriptionWithForcedPhotoUpdateInput;
  where: MetadataDescriptionWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataEditionUpdateInput = {
  create: MetadataEditionWithForcedPhotoCreateInput;
  update: MetadataEditionWithForcedPhotoUpdateInput;
  where: MetadataEditionWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataEditstatusUpdateInput = {
  create: MetadataEditStatusWithForcedPhotoCreateInput;
  update: MetadataEditStatusWithForcedPhotoUpdateInput;
  where: MetadataEditStatusWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataFilestatusUpdateInput = {
  create: MetadataFileStatusWithForcedPhotoCreateInput;
  update: MetadataFileStatusWithForcedPhotoUpdateInput;
  where: MetadataFileStatusWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataFormatUpdateInput = {
  create: MetadataFormatWithForcedPhotoCreateInput;
  update: MetadataFormatWithForcedPhotoUpdateInput;
  where: MetadataFormatWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataHeaderprismaUpdateInput = {
  create: MetadataHeaderPrismaWithForcedPhotoCreateInput;
  update: MetadataHeaderPrismaWithForcedPhotoUpdateInput;
  where: MetadataHeaderPrismaWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataHeaderUpdateInput = {
  create: MetadataHeaderWithForcedPhotoCreateInput;
  update: MetadataHeaderWithForcedPhotoUpdateInput;
  where: MetadataHeaderWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataHeadlineUpdateInput = {
  create: MetadataHeadlineWithForcedPhotoCreateInput;
  update: MetadataHeadlineWithForcedPhotoUpdateInput;
  where: MetadataHeadlineWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataIdassignmentUpdateInput = {
  create: MetadataIdAssignmentWithForcedPhotoCreateInput;
  update: MetadataIdAssignmentWithForcedPhotoUpdateInput;
  where: MetadataIdAssignmentWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataIdphotoprismaUpdateInput = {
  create: MetadataIdPhotoPrismaWithForcedPhotoCreateInput;
  update: MetadataIdPhotoPrismaWithForcedPhotoUpdateInput;
  where: MetadataIdPhotoPrismaWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataIdSubjectUpdateInput = {
  create: MetadataIdSubjectWithForcedPhotoCreateInput;
  update: MetadataIdSubjectWithForcedPhotoUpdateInput;
  where: MetadataIdSubjectWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataImagenotesUpdateInput = {
  create: MetadataImageNotesWithForcedPhotoCreateInput;
  update: MetadataImageNotesWithForcedPhotoUpdateInput;
  where: MetadataImageNotesWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataInstructionsUpdateInput = {
  create: MetadataInstructionsWithForcedPhotoCreateInput;
  update: MetadataInstructionsWithForcedPhotoUpdateInput;
  where: MetadataInstructionsWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataIssueUpdateInput = {
  create: MetadataIssueWithForcedPhotoCreateInput;
  update: MetadataIssueWithForcedPhotoUpdateInput;
  where: MetadataIssueWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataKeywordsUpdateInput = {
  create: MetadataKeywordsWithForcedPhotoCreateInput;
  update: MetadataKeywordsWithForcedPhotoUpdateInput;
  where: MetadataKeywordsWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataObjectnameUpdateInput = {
  create: MetadataObjectNameWithForcedPhotoCreateInput;
  update: MetadataObjectNameWithForcedPhotoUpdateInput;
  where: MetadataObjectNameWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataOriginalnameUpdateInput = {
  create: MetadataOriginalNameWithForcedPhotoCreateInput;
  update: MetadataOriginalNameWithForcedPhotoUpdateInput;
  where: MetadataOriginalNameWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataPricelevelUpdateInput = {
  create: MetadataPriceLevelWithForcedPhotoCreateInput;
  update: MetadataPriceLevelWithForcedPhotoUpdateInput;
  where: MetadataPriceLevelWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataProcesshistoryUpdateInput = {
  create: MetadataProcessHistoryWithForcedPhotoCreateInput;
  update: MetadataProcessHistoryWithForcedPhotoUpdateInput;
  where: MetadataProcessHistoryWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataProcessstatusUpdateInput = {
  create: MetadataProcessStatusWithForcedPhotoCreateInput;
  update: MetadataProcessStatusWithForcedPhotoUpdateInput;
  where: MetadataProcessStatusWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataProductsUpdateInput = {
  create: MetadataProductsWithForcedPhotoCreateInput;
  update: MetadataProductsWithForcedPhotoUpdateInput;
  where: MetadataProductsWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataProductUpdateInput = {
  create: MetadataProductWithForcedPhotoCreateInput;
  update: MetadataProductWithForcedPhotoUpdateInput;
  where: MetadataProductWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataPublishingsubjectUpdateInput = {
  create: MetadataPublishingSubjectWithForcedPhotoCreateInput;
  update: MetadataPublishingSubjectWithForcedPhotoUpdateInput;
  where: MetadataPublishingSubjectWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataResolutionkindUpdateInput = {
  create: MetadataResolutionKindWithForcedPhotoCreateInput;
  update: MetadataResolutionKindWithForcedPhotoUpdateInput;
  where: MetadataResolutionKindWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataRightsUpdateInput = {
  create: MetadataRightsWithForcedPhotoCreateInput;
  update: MetadataRightsWithForcedPhotoUpdateInput;
  where: MetadataRightsWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataSourceUpdateInput = {
  create: MetadataSourceWithForcedPhotoCreateInput;
  update: MetadataSourceWithForcedPhotoUpdateInput;
  where: MetadataSourceWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataSpecialinstructionsUpdateInput = {
  create: MetadataSpecialInstructionsWithForcedPhotoCreateInput;
  update: MetadataSpecialInstructionsWithForcedPhotoUpdateInput;
  where: MetadataSpecialInstructionsWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataSubjectcodeUpdateInput = {
  create: MetadataSubjectCodeWithForcedPhotoCreateInput;
  update: MetadataSubjectCodeWithForcedPhotoUpdateInput;
  where: MetadataSubjectCodeWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataSubjectprismaUpdateInput = {
  create: MetadataSubjectPrismaWithForcedPhotoCreateInput;
  update: MetadataSubjectPrismaWithForcedPhotoUpdateInput;
  where: MetadataSubjectPrismaWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataSubjectUpdateInput = {
  create: MetadataSubjectWithForcedPhotoCreateInput;
  update: MetadataSubjectWithForcedPhotoUpdateInput;
  where: MetadataSubjectWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataTitleUpdateInput = {
  create: MetadataTitleWithForcedPhotoCreateInput;
  update: MetadataTitleWithForcedPhotoUpdateInput;
  where: MetadataTitleWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataTransferredbyfullnameUpdateInput = {
  create: MetadataTransferredByFullNameWithForcedPhotoCreateInput;
  update: MetadataTransferredByFullNameWithForcedPhotoUpdateInput;
  where: MetadataTransferredByFullNameWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataTransferredbyUpdateInput = {
  create: MetadataTransferredByWithForcedPhotoCreateInput;
  update: MetadataTransferredByWithForcedPhotoUpdateInput;
  where: MetadataTransferredByWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataTypeUpdateInput = {
  create: MetadataTypeWithForcedPhotoCreateInput;
  update: MetadataTypeWithForcedPhotoUpdateInput;
  where: MetadataTypeWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUndersubjectUpdateInput = {
  create: MetadataUndersubjectWithForcedPhotoCreateInput;
  update: MetadataUndersubjectWithForcedPhotoUpdateInput;
  where: MetadataUndersubjectWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUnderundersubjectUpdateInput = {
  create: MetadataUnderUnderSubjectWithForcedPhotoCreateInput;
  update: MetadataUnderUnderSubjectWithForcedPhotoUpdateInput;
  where: MetadataUnderUnderSubjectWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUploadedbyfullnameUpdateInput = {
  create: MetadataUploadedByFullNameWithForcedPhotoCreateInput;
  update: MetadataUploadedByFullNameWithForcedPhotoUpdateInput;
  where: MetadataUploadedByFullNameWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUploadedbyUpdateInput = {
  create: MetadataUploadedByWithForcedPhotoCreateInput;
  update: MetadataUploadedByWithForcedPhotoUpdateInput;
  where: MetadataUploadedByWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUploadtimeUpdateInput = {
  create: MetadataUploadTimeWithForcedPhotoCreateInput;
  update: MetadataUploadTimeWithForcedPhotoUpdateInput;
  where: MetadataUploadTimeWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUrgencyUpdateInput = {
  create: MetadataUrgencyWithForcedPhotoCreateInput;
  update: MetadataUrgencyWithForcedPhotoUpdateInput;
  where: MetadataUrgencyWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUserdefined195UpdateInput = {
  create: MetadataUserDefined195WithForcedPhotoCreateInput;
  update: MetadataUserDefined195WithForcedPhotoUpdateInput;
  where: MetadataUserDefined195WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUserdefined237UpdateInput = {
  create: MetadataUserDefined237WithForcedPhotoCreateInput;
  update: MetadataUserDefined237WithForcedPhotoUpdateInput;
  where: MetadataUserDefined237WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUserdefined238UpdateInput = {
  create: MetadataUserDefined238WithForcedPhotoCreateInput;
  update: MetadataUserDefined238WithForcedPhotoUpdateInput;
  where: MetadataUserDefined238WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUserdefined239UpdateInput = {
  create: MetadataUserDefined239WithForcedPhotoCreateInput;
  update: MetadataUserDefined239WithForcedPhotoUpdateInput;
  where: MetadataUserDefined239WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUserdefined242UpdateInput = {
  create: MetadataUserDefined242WithForcedPhotoCreateInput;
  update: MetadataUserDefined242WithForcedPhotoUpdateInput;
  where: MetadataUserDefined242WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataUserdefined62UpdateInput = {
  create: MetadataUserDefined62WithForcedPhotoCreateInput;
  update: MetadataUserDefined62WithForcedPhotoUpdateInput;
  where: MetadataUserDefined62WhereUniqueInput;
};

export type PhotoNestedUpsertMetadataWorkflowkindUpdateInput = {
  create: MetadataWorkflowKindWithForcedPhotoCreateInput;
  update: MetadataWorkflowKindWithForcedPhotoUpdateInput;
  where: MetadataWorkflowKindWhereUniqueInput;
};

export type PhotoNestedUpsertMetadataXmphistoryUpdateInput = {
  create: MetadataXmpHistoryWithForcedPhotoCreateInput;
  update: MetadataXmpHistoryWithForcedPhotoUpdateInput;
  where: MetadataXmpHistoryWhereUniqueInput;
};

export type PhotoNestedUpsertPhotoMetadatasUpdateInput = {
  create: PhotoMetadataWithForcedPhotoCreateInput;
  update: PhotoMetadataWithForcedPhotoUpdateInput;
  where: PhotoMetadataWhereUniqueInput;
};

export type PhotoNestedUpsertPhotoPublicationsUpdateInput = {
  create: PhotoPublicationWithForcedPhotoCreateInput;
  update: PhotoPublicationWithForcedPhotoUpdateInput;
  where: PhotoPublicationWhereUniqueInput;
};

export enum PhotoOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  contentType_ASC = 'contentType_ASC',
  contentType_DESC = 'contentType_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  filesize_ASC = 'filesize_ASC',
  filesize_DESC = 'filesize_DESC',
  height_ASC = 'height_ASC',
  height_DESC = 'height_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  importedAt_ASC = 'importedAt_ASC',
  importedAt_DESC = 'importedAt_DESC',
  isLegacy_ASC = 'isLegacy_ASC',
  isLegacy_DESC = 'isLegacy_DESC',
  isUploaded_ASC = 'isUploaded_ASC',
  isUploaded_DESC = 'isUploaded_DESC',
  originalName_ASC = 'originalName_ASC',
  originalName_DESC = 'originalName_DESC',
  synced_ASC = 'synced_ASC',
  synced_DESC = 'synced_DESC',
  takenAt_ASC = 'takenAt_ASC',
  takenAt_DESC = 'takenAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  width_ASC = 'width_ASC',
  width_DESC = 'width_DESC'
}

/** "PhotoPublication" resource's node */
export type PhotoPublication = {
  __typename?: 'PhotoPublication';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  assetUrl?: Maybe<Scalars['String']['output']>;
  /** get the description of the photoPublication */
  caption: Scalars['String']['output'];
  /** get the rights of the photoPublication */
  copyright: Scalars['String']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  credit?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  /** get the idPhotoPrisma of the photoPublication */
  fileName: Scalars['String']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** Proxy URL to display the Censhare preview image inline in a browser */
  imageHref?: Maybe<Scalars['String']['output']>;
  /** get the originalName of the photoPublication */
  originalName?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  page?: Maybe<Scalars['String']['output']>;
  photo: Photo;
  /** The photo internal ID */
  photoIntId?: Maybe<Scalars['Int']['output']>;
  /** get the priceLevel of the photoPublication */
  priceLevel: Scalars['String']['output'];
  printIssueTitle?: Maybe<Scalars['String']['output']>;
  printPublicationKey?: Maybe<Scalars['String']['output']>;
  /** get the source of the photoPublication */
  source: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

export type PhotoPublicationCreateInput = {
  assetUrl?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "PhotoPublication.photo" relation */
  photo: PhotoPublicationNestedPhotoCreateInput;
  /** The photo internal ID */
  photoIntId?: InputMaybe<Scalars['Int']['input']>;
  printIssueTitle?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoPublicationNestedPhotoCreateInput = {
  /** Connect an existing "Photo" node to the new "PhotoPublication" node, through the "PhotoPublication.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the new "PhotoPublication" node, through the "PhotoPublication.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the new "PhotoPublication" node, through the "PhotoPublication.photo" relation. */
  update?: InputMaybe<PhotoPublicationNestedUpdatePhotoCreateInput>;
  /** Create or update a "Photo" node and connect it to the new "PhotoPublication" node, through the "PhotoPublication.photo" relation. */
  upsert?: InputMaybe<PhotoPublicationNestedUpsertPhotoCreateInput>;
};

export type PhotoPublicationNestedPhotoUpdateInput = {
  /** Connect an existing "Photo" node to the existing "PhotoPublication" node, through the "PhotoPublication.photo" relation. */
  connect?: InputMaybe<PhotoWhereUniqueInput>;
  /** Create a new "Photo" node and connect it to the existing "PhotoPublication" node, through the "PhotoPublication.photo" relation. */
  create?: InputMaybe<PhotoCreateInput>;
  /** Update an existing "Photo" node and connect it to the existing "PhotoPublication" node, through the "PhotoPublication.photo" relation. */
  update?: InputMaybe<PhotoPublicationNestedUpdatePhotoUpdateInput>;
  /** Create or update a "Photo" node and connect it to the existing "PhotoPublication" node, through the "PhotoPublication.photo" relation. */
  upsert?: InputMaybe<PhotoPublicationNestedUpsertPhotoUpdateInput>;
};

export type PhotoPublicationNestedUpdatePhotoCreateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type PhotoPublicationNestedUpdatePhotoUpdateInput = {
  data: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type PhotoPublicationNestedUpsertPhotoCreateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export type PhotoPublicationNestedUpsertPhotoUpdateInput = {
  create: PhotoCreateInput;
  update: PhotoUpdateInput;
  where: PhotoWhereUniqueInput;
};

export enum PhotoPublicationOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  assetUrl_ASC = 'assetUrl_ASC',
  assetUrl_DESC = 'assetUrl_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  credit_ASC = 'credit_ASC',
  credit_DESC = 'credit_DESC',
  dimensions_ASC = 'dimensions_ASC',
  dimensions_DESC = 'dimensions_DESC',
  filename_ASC = 'filename_ASC',
  filename_DESC = 'filename_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  page_ASC = 'page_ASC',
  page_DESC = 'page_DESC',
  photoIntId_ASC = 'photoIntId_ASC',
  photoIntId_DESC = 'photoIntId_DESC',
  printIssueTitle_ASC = 'printIssueTitle_ASC',
  printIssueTitle_DESC = 'printIssueTitle_DESC',
  printPublicationKey_ASC = 'printPublicationKey_ASC',
  printPublicationKey_DESC = 'printPublicationKey_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PhotoPublicationUpdateInput = {
  assetUrl?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "PhotoPublication.photo" relation */
  photo?: InputMaybe<PhotoPublicationNestedPhotoUpdateInput>;
  /** The photo internal ID */
  photoIntId?: InputMaybe<Scalars['Int']['input']>;
  printIssueTitle?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey?: InputMaybe<Scalars['String']['input']>;
};

/** Filters the "PhotoPublication" nodes by specifying some conditions */
export type PhotoPublicationWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<PhotoPublicationWhereInput>>;
  assetUrl?: InputMaybe<Scalars['String']['input']>;
  assetUrl_contains?: InputMaybe<Scalars['String']['input']>;
  assetUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  assetUrl_gt?: InputMaybe<Scalars['String']['input']>;
  assetUrl_gte?: InputMaybe<Scalars['String']['input']>;
  assetUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assetUrl_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  assetUrl_lt?: InputMaybe<Scalars['String']['input']>;
  assetUrl_lte?: InputMaybe<Scalars['String']['input']>;
  assetUrl_not?: InputMaybe<Scalars['String']['input']>;
  assetUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  assetUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  assetUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assetUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  assetUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  credit?: InputMaybe<Scalars['String']['input']>;
  credit_contains?: InputMaybe<Scalars['String']['input']>;
  credit_ends_with?: InputMaybe<Scalars['String']['input']>;
  credit_gt?: InputMaybe<Scalars['String']['input']>;
  credit_gte?: InputMaybe<Scalars['String']['input']>;
  credit_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  credit_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  credit_lt?: InputMaybe<Scalars['String']['input']>;
  credit_lte?: InputMaybe<Scalars['String']['input']>;
  credit_not?: InputMaybe<Scalars['String']['input']>;
  credit_not_contains?: InputMaybe<Scalars['String']['input']>;
  credit_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  credit_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  credit_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  credit_starts_with?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  dimensions_contains?: InputMaybe<Scalars['String']['input']>;
  dimensions_ends_with?: InputMaybe<Scalars['String']['input']>;
  dimensions_gt?: InputMaybe<Scalars['String']['input']>;
  dimensions_gte?: InputMaybe<Scalars['String']['input']>;
  dimensions_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dimensions_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  dimensions_lt?: InputMaybe<Scalars['String']['input']>;
  dimensions_lte?: InputMaybe<Scalars['String']['input']>;
  dimensions_not?: InputMaybe<Scalars['String']['input']>;
  dimensions_not_contains?: InputMaybe<Scalars['String']['input']>;
  dimensions_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  dimensions_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dimensions_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  dimensions_starts_with?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  filename_contains?: InputMaybe<Scalars['String']['input']>;
  filename_ends_with?: InputMaybe<Scalars['String']['input']>;
  filename_gt?: InputMaybe<Scalars['String']['input']>;
  filename_gte?: InputMaybe<Scalars['String']['input']>;
  filename_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  filename_lt?: InputMaybe<Scalars['String']['input']>;
  filename_lte?: InputMaybe<Scalars['String']['input']>;
  filename_not?: InputMaybe<Scalars['String']['input']>;
  filename_not_contains?: InputMaybe<Scalars['String']['input']>;
  filename_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  filename_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  filename_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<PhotoPublicationWhereInput>;
  OR?: InputMaybe<Array<PhotoPublicationWhereInput>>;
  page?: InputMaybe<Scalars['String']['input']>;
  page_contains?: InputMaybe<Scalars['String']['input']>;
  page_ends_with?: InputMaybe<Scalars['String']['input']>;
  page_gt?: InputMaybe<Scalars['String']['input']>;
  page_gte?: InputMaybe<Scalars['String']['input']>;
  page_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  page_lt?: InputMaybe<Scalars['String']['input']>;
  page_lte?: InputMaybe<Scalars['String']['input']>;
  page_not?: InputMaybe<Scalars['String']['input']>;
  page_not_contains?: InputMaybe<Scalars['String']['input']>;
  page_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  page_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  page_starts_with?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<PhotoWhereInput>;
  photoIntId?: InputMaybe<Scalars['Int']['input']>;
  photoIntId_gt?: InputMaybe<Scalars['Int']['input']>;
  photoIntId_gte?: InputMaybe<Scalars['Int']['input']>;
  photoIntId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  photoIntId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  photoIntId_lt?: InputMaybe<Scalars['Int']['input']>;
  photoIntId_lte?: InputMaybe<Scalars['Int']['input']>;
  photoIntId_not?: InputMaybe<Scalars['Int']['input']>;
  photoIntId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  printIssueTitle?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_contains?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_gt?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_gte?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  printIssueTitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printIssueTitle_lt?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_lte?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_not?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  printIssueTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  printIssueTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_contains?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_ends_with?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_gt?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_gte?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  printPublicationKey_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  printPublicationKey_lt?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_lte?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_not?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  printPublicationKey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Identifies exactly one "PhotoPublication" node. */
export type PhotoPublicationWhereUniqueInput = {
  _id: Scalars['Int']['input'];
};

export type PhotoPublicationWithForcedPhotoCreateInput = {
  assetUrl?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  /** The photo internal ID */
  photoIntId?: InputMaybe<Scalars['Int']['input']>;
  printIssueTitle?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoPublicationWithForcedPhotoUpdateInput = {
  assetUrl?: InputMaybe<Scalars['String']['input']>;
  credit?: InputMaybe<Scalars['String']['input']>;
  dimensions?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['String']['input']>;
  /** The photo internal ID */
  photoIntId?: InputMaybe<Scalars['Int']['input']>;
  printIssueTitle?: InputMaybe<Scalars['String']['input']>;
  printPublicationKey?: InputMaybe<Scalars['String']['input']>;
};

export type PhotoUpdateInput = {
  /** Actions for the "Photo.agency" relation */
  agency?: InputMaybe<PhotoNestedAgencyUpdateInput>;
  /** Actions for the "Photo.archive" relation */
  archive?: InputMaybe<PhotoNestedArchiveUpdateInput>;
  /** Actions for the "Photo.category" relation */
  category?: InputMaybe<PhotoNestedCategoryUpdateInput>;
  /** asset content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.deliverySubject" relation */
  deliverySubject?: InputMaybe<PhotoNestedDeliverySubjectUpdateInput>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The date of the photo's importation */
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Photo.importQueue" relation: "ImportQueue.photo"'s inverse relation */
  importQueue?: InputMaybe<PhotoNestedImportQueueUpdateInput>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Photo.Metadata_AccessRights" relation: "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights?: InputMaybe<PhotoNestedMetadataAccessrightsUpdateInput>;
  /** Actions for the "Photo.Metadata_AssetState" relation: "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState?: InputMaybe<PhotoNestedMetadataAssetstateUpdateInput>;
  /** Actions for the "Photo.Metadata_BackupName" relation: "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName?: InputMaybe<PhotoNestedMetadataBackupnameUpdateInput>;
  /** Actions for the "Photo.Metadata_Brand" relation: "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand?: InputMaybe<PhotoNestedMetadataBrandUpdateInput>;
  /** Actions for the "Photo.Metadata_BrandPrisma" relation: "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma?: InputMaybe<PhotoNestedMetadataBrandprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_BrandShortName" relation: "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName?: InputMaybe<PhotoNestedMetadataBrandshortnameUpdateInput>;
  /** Actions for the "Photo.Metadata_By_line" relation: "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line?: InputMaybe<PhotoNestedMetadataByLineUpdateInput>;
  /** Actions for the "Photo.Metadata_Caption" relation: "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption?: InputMaybe<PhotoNestedMetadataCaptionUpdateInput>;
  /** Actions for the "Photo.Metadata_Caption_Abstract" relation: "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract?: InputMaybe<PhotoNestedMetadataCaptionAbstractUpdateInput>;
  /** Actions for the "Photo.Metadata_Category" relation: "MetadataCategory.photo"'s inverse relation */
  Metadata_Category?: InputMaybe<PhotoNestedMetadataCategoryUpdateInput>;
  /** Actions for the "Photo.Metadata_CategoryPrisma" relation: "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma?: InputMaybe<PhotoNestedMetadataCategoryprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_Company" relation: "MetadataCompany.photo"'s inverse relation */
  Metadata_Company?: InputMaybe<PhotoNestedMetadataCompanyUpdateInput>;
  /** Actions for the "Photo.Metadata_CompanyShortName" relation: "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName?: InputMaybe<PhotoNestedMetadataCompanyshortnameUpdateInput>;
  /** Actions for the "Photo.Metadata_CopyrightNotice" relation: "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice?: InputMaybe<PhotoNestedMetadataCopyrightnoticeUpdateInput>;
  /** Actions for the "Photo.Metadata_creator" relation: "MetadataCreator.photo"'s inverse relation */
  Metadata_creator?: InputMaybe<PhotoNestedMetadataCreatorUpdateInput>;
  /** Actions for the "Photo.Metadata_Credit" relation: "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit?: InputMaybe<PhotoNestedMetadataCreditUpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField1" relation: "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1?: InputMaybe<PhotoNestedMetadataCustomfield1UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField14" relation: "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14?: InputMaybe<PhotoNestedMetadataCustomfield14UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField15" relation: "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15?: InputMaybe<PhotoNestedMetadataCustomfield15UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField16" relation: "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16?: InputMaybe<PhotoNestedMetadataCustomfield16UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField17" relation: "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17?: InputMaybe<PhotoNestedMetadataCustomfield17UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField20" relation: "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20?: InputMaybe<PhotoNestedMetadataCustomfield20UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField3" relation: "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3?: InputMaybe<PhotoNestedMetadataCustomfield3UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField4" relation: "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4?: InputMaybe<PhotoNestedMetadataCustomfield4UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField5" relation: "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5?: InputMaybe<PhotoNestedMetadataCustomfield5UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField6" relation: "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6?: InputMaybe<PhotoNestedMetadataCustomfield6UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField7" relation: "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7?: InputMaybe<PhotoNestedMetadataCustomfield7UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField9" relation: "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9?: InputMaybe<PhotoNestedMetadataCustomfield9UpdateInput>;
  /** Actions for the "Photo.Metadata_DateCreated" relation: "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated?: InputMaybe<PhotoNestedMetadataDatecreatedUpdateInput>;
  /** Actions for the "Photo.Metadata_DateTimeOriginal" relation: "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal?: InputMaybe<PhotoNestedMetadataDatetimeoriginalUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryAccount" relation: "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount?: InputMaybe<PhotoNestedMetadataDeliveryaccountUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCompany" relation: "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany?: InputMaybe<PhotoNestedMetadataDeliverycompanyUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCopyright" relation: "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright?: InputMaybe<PhotoNestedMetadataDeliverycopyrightUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateFolder" relation: "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder?: InputMaybe<PhotoNestedMetadataDeliverydatefolderUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateTime" relation: "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime?: InputMaybe<PhotoNestedMetadataDeliverydatetimeUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcCreator" relation: "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator?: InputMaybe<PhotoNestedMetadataDeliverydccreatorUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcRights" relation: "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights?: InputMaybe<PhotoNestedMetadataDeliverydcrightsUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryFolder" relation: "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder?: InputMaybe<PhotoNestedMetadataDeliveryfolderUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryKind" relation: "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind?: InputMaybe<PhotoNestedMetadataDeliverykindUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPath" relation: "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath?: InputMaybe<PhotoNestedMetadataDeliverypathUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopCredit" relation: "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopcreditUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopSource" relation: "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopsourceUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryService" relation: "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService?: InputMaybe<PhotoNestedMetadataDeliveryserviceUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliverySubject" relation: "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject?: InputMaybe<PhotoNestedMetadataDeliverysubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryUnderSubject" relation: "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject?: InputMaybe<PhotoNestedMetadataDeliveryundersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_Department" relation: "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department?: InputMaybe<PhotoNestedMetadataDepartmentUpdateInput>;
  /** Actions for the "Photo.Metadata_description" relation: "MetadataDescription.photo"'s inverse relation */
  Metadata_description?: InputMaybe<PhotoNestedMetadataDescriptionUpdateInput>;
  /** Actions for the "Photo.Metadata_Edition" relation: "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition?: InputMaybe<PhotoNestedMetadataEditionUpdateInput>;
  /** Actions for the "Photo.Metadata_EditStatus" relation: "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus?: InputMaybe<PhotoNestedMetadataEditstatusUpdateInput>;
  /** Actions for the "Photo.Metadata_FileStatus" relation: "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus?: InputMaybe<PhotoNestedMetadataFilestatusUpdateInput>;
  /** Actions for the "Photo.Metadata_Format" relation: "MetadataFormat.photo"'s inverse relation */
  Metadata_Format?: InputMaybe<PhotoNestedMetadataFormatUpdateInput>;
  /** Actions for the "Photo.Metadata_Header" relation: "MetadataHeader.photo"'s inverse relation */
  Metadata_Header?: InputMaybe<PhotoNestedMetadataHeaderUpdateInput>;
  /** Actions for the "Photo.Metadata_HeaderPrisma" relation: "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma?: InputMaybe<PhotoNestedMetadataHeaderprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_Headline" relation: "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline?: InputMaybe<PhotoNestedMetadataHeadlineUpdateInput>;
  /** Actions for the "Photo.Metadata_ID_subject" relation: "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject?: InputMaybe<PhotoNestedMetadataIdSubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_IdAssignment" relation: "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment?: InputMaybe<PhotoNestedMetadataIdassignmentUpdateInput>;
  /** Actions for the "Photo.Metadata_IdPhotoPrisma" relation: "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma?: InputMaybe<PhotoNestedMetadataIdphotoprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_ImageNotes" relation: "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes?: InputMaybe<PhotoNestedMetadataImagenotesUpdateInput>;
  /** Actions for the "Photo.Metadata_Instructions" relation: "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions?: InputMaybe<PhotoNestedMetadataInstructionsUpdateInput>;
  /** Actions for the "Photo.Metadata_Issue" relation: "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue?: InputMaybe<PhotoNestedMetadataIssueUpdateInput>;
  /** Actions for the "Photo.Metadata_Keywords" relation: "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords?: InputMaybe<PhotoNestedMetadataKeywordsUpdateInput>;
  /** Actions for the "Photo.Metadata_ObjectName" relation: "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName?: InputMaybe<PhotoNestedMetadataObjectnameUpdateInput>;
  /** Actions for the "Photo.Metadata_OriginalName" relation: "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName?: InputMaybe<PhotoNestedMetadataOriginalnameUpdateInput>;
  /** Actions for the "Photo.Metadata_PriceLevel" relation: "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel?: InputMaybe<PhotoNestedMetadataPricelevelUpdateInput>;
  /** Actions for the "Photo.Metadata_ProcessHistory" relation: "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory?: InputMaybe<PhotoNestedMetadataProcesshistoryUpdateInput>;
  /** Actions for the "Photo.Metadata_ProcessStatus" relation: "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus?: InputMaybe<PhotoNestedMetadataProcessstatusUpdateInput>;
  /** Actions for the "Photo.Metadata_Product" relation: "MetadataProduct.photo"'s inverse relation */
  Metadata_Product?: InputMaybe<PhotoNestedMetadataProductUpdateInput>;
  /** Actions for the "Photo.Metadata_Products" relation: "MetadataProducts.photo"'s inverse relation */
  Metadata_Products?: InputMaybe<PhotoNestedMetadataProductsUpdateInput>;
  /** Actions for the "Photo.Metadata_publishingSubject" relation: "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject?: InputMaybe<PhotoNestedMetadataPublishingsubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_ResolutionKind" relation: "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind?: InputMaybe<PhotoNestedMetadataResolutionkindUpdateInput>;
  /** Actions for the "Photo.Metadata_rights" relation: "MetadataRights.photo"'s inverse relation */
  Metadata_rights?: InputMaybe<PhotoNestedMetadataRightsUpdateInput>;
  /** Actions for the "Photo.Metadata_Source" relation: "MetadataSource.photo"'s inverse relation */
  Metadata_Source?: InputMaybe<PhotoNestedMetadataSourceUpdateInput>;
  /** Actions for the "Photo.Metadata_SpecialInstructions" relation: "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions?: InputMaybe<PhotoNestedMetadataSpecialinstructionsUpdateInput>;
  /** Actions for the "Photo.Metadata_subject" relation: "MetadataSubject.photo"'s inverse relation */
  Metadata_subject?: InputMaybe<PhotoNestedMetadataSubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_SubjectCode" relation: "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode?: InputMaybe<PhotoNestedMetadataSubjectcodeUpdateInput>;
  /** Actions for the "Photo.Metadata_SubjectPrisma" relation: "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma?: InputMaybe<PhotoNestedMetadataSubjectprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_title" relation: "MetadataTitle.photo"'s inverse relation */
  Metadata_title?: InputMaybe<PhotoNestedMetadataTitleUpdateInput>;
  /** Actions for the "Photo.Metadata_TransferredBy" relation: "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy?: InputMaybe<PhotoNestedMetadataTransferredbyUpdateInput>;
  /** Actions for the "Photo.Metadata_TransferredByFullName" relation: "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName?: InputMaybe<PhotoNestedMetadataTransferredbyfullnameUpdateInput>;
  /** Actions for the "Photo.Metadata_Type" relation: "MetadataType.photo"'s inverse relation */
  Metadata_Type?: InputMaybe<PhotoNestedMetadataTypeUpdateInput>;
  /** Actions for the "Photo.Metadata_Undersubject" relation: "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject?: InputMaybe<PhotoNestedMetadataUndersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_UnderUnderSubject" relation: "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject?: InputMaybe<PhotoNestedMetadataUnderundersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadedBy" relation: "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy?: InputMaybe<PhotoNestedMetadataUploadedbyUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadedByFullName" relation: "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName?: InputMaybe<PhotoNestedMetadataUploadedbyfullnameUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadTime" relation: "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime?: InputMaybe<PhotoNestedMetadataUploadtimeUpdateInput>;
  /** Actions for the "Photo.Metadata_Urgency" relation: "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency?: InputMaybe<PhotoNestedMetadataUrgencyUpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined195" relation: "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195?: InputMaybe<PhotoNestedMetadataUserdefined195UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined237" relation: "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237?: InputMaybe<PhotoNestedMetadataUserdefined237UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined238" relation: "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238?: InputMaybe<PhotoNestedMetadataUserdefined238UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined239" relation: "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239?: InputMaybe<PhotoNestedMetadataUserdefined239UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined242" relation: "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242?: InputMaybe<PhotoNestedMetadataUserdefined242UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined62" relation: "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62?: InputMaybe<PhotoNestedMetadataUserdefined62UpdateInput>;
  /** Actions for the "Photo.Metadata_WorkflowKind" relation: "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind?: InputMaybe<PhotoNestedMetadataWorkflowkindUpdateInput>;
  /** Actions for the "Photo.Metadata_XMPHistory" relation: "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory?: InputMaybe<PhotoNestedMetadataXmphistoryUpdateInput>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.photoMetadatas" relation: "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas?: InputMaybe<PhotoNestedPhotoMetadatasUpdateInput>;
  /** Actions for the "Photo.photoPublications" relation: "PhotoPublication.photo"'s inverse relation */
  photoPublications?: InputMaybe<PhotoNestedPhotoPublicationsUpdateInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the photo's capture */
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Filters the "Photo" nodes by specifying some conditions */
export type PhotoWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  agency?: InputMaybe<AgencyWhereInput>;
  agency_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  AND?: InputMaybe<Array<PhotoWhereInput>>;
  archive?: InputMaybe<ArchiveWhereInput>;
  category?: InputMaybe<CategoryWhereInput>;
  category_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentType_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_ends_with?: InputMaybe<Scalars['String']['input']>;
  contentType_gt?: InputMaybe<Scalars['String']['input']>;
  contentType_gte?: InputMaybe<Scalars['String']['input']>;
  contentType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  contentType_lt?: InputMaybe<Scalars['String']['input']>;
  contentType_lte?: InputMaybe<Scalars['String']['input']>;
  contentType_not?: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains?: InputMaybe<Scalars['String']['input']>;
  contentType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  contentType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  contentType_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  deliverySubject?: InputMaybe<DeliverySubjectWhereInput>;
  deliverySubject_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  filesize_gt?: InputMaybe<Scalars['Int']['input']>;
  filesize_gte?: InputMaybe<Scalars['Int']['input']>;
  filesize_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  filesize_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  filesize_lt?: InputMaybe<Scalars['Int']['input']>;
  filesize_lte?: InputMaybe<Scalars['Int']['input']>;
  filesize_not?: InputMaybe<Scalars['Int']['input']>;
  filesize_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  height_not?: InputMaybe<Scalars['Int']['input']>;
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  importedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  importedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  importedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  importQueue?: InputMaybe<ImportQueueWhereInput>;
  importQueue_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacy_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isLegacy_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacy_not?: InputMaybe<Scalars['Boolean']['input']>;
  isLegacy_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  isUploaded_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded_not?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  Metadata_AccessRights_some?: InputMaybe<MetadataAccessRightsWhereInput>;
  Metadata_AssetState_some?: InputMaybe<MetadataAssetStateWhereInput>;
  Metadata_BackupName_some?: InputMaybe<MetadataBackupNameWhereInput>;
  Metadata_Brand_some?: InputMaybe<MetadataBrandWhereInput>;
  Metadata_BrandPrisma_some?: InputMaybe<MetadataBrandPrismaWhereInput>;
  Metadata_BrandShortName_some?: InputMaybe<MetadataBrandShortNameWhereInput>;
  Metadata_By_line_some?: InputMaybe<MetadataByLineWhereInput>;
  Metadata_Caption_Abstract_some?: InputMaybe<MetadataCaptionAbstractWhereInput>;
  Metadata_Caption_some?: InputMaybe<MetadataCaptionWhereInput>;
  Metadata_Category_some?: InputMaybe<MetadataCategoryWhereInput>;
  Metadata_CategoryPrisma_some?: InputMaybe<MetadataCategoryPrismaWhereInput>;
  Metadata_Company_some?: InputMaybe<MetadataCompanyWhereInput>;
  Metadata_CompanyShortName_some?: InputMaybe<MetadataCompanyShortNameWhereInput>;
  Metadata_CopyrightNotice_some?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
  Metadata_creator_some?: InputMaybe<MetadataCreatorWhereInput>;
  Metadata_Credit_some?: InputMaybe<MetadataCreditWhereInput>;
  Metadata_CustomField1_some?: InputMaybe<MetadataCustomField1WhereInput>;
  Metadata_CustomField14_some?: InputMaybe<MetadataCustomField14WhereInput>;
  Metadata_CustomField15_some?: InputMaybe<MetadataCustomField15WhereInput>;
  Metadata_CustomField16_some?: InputMaybe<MetadataCustomField16WhereInput>;
  Metadata_CustomField17_some?: InputMaybe<MetadataCustomField17WhereInput>;
  Metadata_CustomField20_some?: InputMaybe<MetadataCustomField20WhereInput>;
  Metadata_CustomField3_some?: InputMaybe<MetadataCustomField3WhereInput>;
  Metadata_CustomField4_some?: InputMaybe<MetadataCustomField4WhereInput>;
  Metadata_CustomField5_some?: InputMaybe<MetadataCustomField5WhereInput>;
  Metadata_CustomField6_some?: InputMaybe<MetadataCustomField6WhereInput>;
  Metadata_CustomField7_some?: InputMaybe<MetadataCustomField7WhereInput>;
  Metadata_CustomField9_some?: InputMaybe<MetadataCustomField9WhereInput>;
  Metadata_DateCreated_some?: InputMaybe<MetadataDateCreatedWhereInput>;
  Metadata_DateTimeOriginal_some?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
  Metadata_DeliveryAccount_some?: InputMaybe<MetadataDeliveryAccountWhereInput>;
  Metadata_DeliveryCompany_some?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
  Metadata_DeliveryCopyright_some?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
  Metadata_DeliveryDateFolder_some?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
  Metadata_DeliveryDateTime_some?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
  Metadata_DeliveryDcCreator_some?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
  Metadata_DeliveryDcRights_some?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
  Metadata_DeliveryFolder_some?: InputMaybe<MetadataDeliveryFolderWhereInput>;
  Metadata_DeliveryKind_some?: InputMaybe<MetadataDeliveryKindWhereInput>;
  Metadata_DeliveryPath_some?: InputMaybe<MetadataDeliveryPathWhereInput>;
  Metadata_DeliveryPhotoshopCredit_some?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
  Metadata_DeliveryPhotoshopSource_some?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
  Metadata_DeliveryService_some?: InputMaybe<MetadataDeliveryServiceWhereInput>;
  Metadata_DeliverySubject_some?: InputMaybe<MetadataDeliverySubjectWhereInput>;
  Metadata_DeliveryUnderSubject_some?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
  Metadata_Department_some?: InputMaybe<MetadataDepartmentWhereInput>;
  Metadata_description_some?: InputMaybe<MetadataDescriptionWhereInput>;
  Metadata_Edition_some?: InputMaybe<MetadataEditionWhereInput>;
  Metadata_EditStatus_some?: InputMaybe<MetadataEditStatusWhereInput>;
  Metadata_FileStatus_some?: InputMaybe<MetadataFileStatusWhereInput>;
  Metadata_Format_some?: InputMaybe<MetadataFormatWhereInput>;
  Metadata_Header_some?: InputMaybe<MetadataHeaderWhereInput>;
  Metadata_HeaderPrisma_some?: InputMaybe<MetadataHeaderPrismaWhereInput>;
  Metadata_Headline_some?: InputMaybe<MetadataHeadlineWhereInput>;
  Metadata_ID_subject_some?: InputMaybe<MetadataIdSubjectWhereInput>;
  Metadata_IdAssignment_some?: InputMaybe<MetadataIdAssignmentWhereInput>;
  Metadata_IdPhotoPrisma_some?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
  Metadata_ImageNotes_some?: InputMaybe<MetadataImageNotesWhereInput>;
  Metadata_Instructions_some?: InputMaybe<MetadataInstructionsWhereInput>;
  Metadata_Issue_some?: InputMaybe<MetadataIssueWhereInput>;
  Metadata_Keywords_some?: InputMaybe<MetadataKeywordsWhereInput>;
  Metadata_ObjectName_some?: InputMaybe<MetadataObjectNameWhereInput>;
  Metadata_OriginalName_some?: InputMaybe<MetadataOriginalNameWhereInput>;
  Metadata_PriceLevel_some?: InputMaybe<MetadataPriceLevelWhereInput>;
  Metadata_ProcessHistory_some?: InputMaybe<MetadataProcessHistoryWhereInput>;
  Metadata_ProcessStatus_some?: InputMaybe<MetadataProcessStatusWhereInput>;
  Metadata_Product_some?: InputMaybe<MetadataProductWhereInput>;
  Metadata_Products_some?: InputMaybe<MetadataProductsWhereInput>;
  Metadata_publishingSubject_some?: InputMaybe<MetadataPublishingSubjectWhereInput>;
  Metadata_ResolutionKind_some?: InputMaybe<MetadataResolutionKindWhereInput>;
  Metadata_rights_some?: InputMaybe<MetadataRightsWhereInput>;
  Metadata_Source_some?: InputMaybe<MetadataSourceWhereInput>;
  Metadata_SpecialInstructions_some?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
  Metadata_subject_some?: InputMaybe<MetadataSubjectWhereInput>;
  Metadata_SubjectCode_some?: InputMaybe<MetadataSubjectCodeWhereInput>;
  Metadata_SubjectPrisma_some?: InputMaybe<MetadataSubjectPrismaWhereInput>;
  Metadata_title_some?: InputMaybe<MetadataTitleWhereInput>;
  Metadata_TransferredBy_some?: InputMaybe<MetadataTransferredByWhereInput>;
  Metadata_TransferredByFullName_some?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
  Metadata_Type_some?: InputMaybe<MetadataTypeWhereInput>;
  Metadata_Undersubject_some?: InputMaybe<MetadataUndersubjectWhereInput>;
  Metadata_UnderUnderSubject_some?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
  Metadata_UploadedBy_some?: InputMaybe<MetadataUploadedByWhereInput>;
  Metadata_UploadedByFullName_some?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
  Metadata_UploadTime_some?: InputMaybe<MetadataUploadTimeWhereInput>;
  Metadata_Urgency_some?: InputMaybe<MetadataUrgencyWhereInput>;
  Metadata_UserDefined195_some?: InputMaybe<MetadataUserDefined195WhereInput>;
  Metadata_UserDefined237_some?: InputMaybe<MetadataUserDefined237WhereInput>;
  Metadata_UserDefined238_some?: InputMaybe<MetadataUserDefined238WhereInput>;
  Metadata_UserDefined239_some?: InputMaybe<MetadataUserDefined239WhereInput>;
  Metadata_UserDefined242_some?: InputMaybe<MetadataUserDefined242WhereInput>;
  Metadata_UserDefined62_some?: InputMaybe<MetadataUserDefined62WhereInput>;
  Metadata_WorkflowKind_some?: InputMaybe<MetadataWorkflowKindWhereInput>;
  Metadata_XMPHistory_some?: InputMaybe<MetadataXmpHistoryWhereInput>;
  NOT?: InputMaybe<PhotoWhereInput>;
  OR?: InputMaybe<Array<PhotoWhereInput>>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  originalName_contains?: InputMaybe<Scalars['String']['input']>;
  originalName_ends_with?: InputMaybe<Scalars['String']['input']>;
  originalName_gt?: InputMaybe<Scalars['String']['input']>;
  originalName_gte?: InputMaybe<Scalars['String']['input']>;
  originalName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  originalName_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  originalName_lt?: InputMaybe<Scalars['String']['input']>;
  originalName_lte?: InputMaybe<Scalars['String']['input']>;
  originalName_not?: InputMaybe<Scalars['String']['input']>;
  originalName_not_contains?: InputMaybe<Scalars['String']['input']>;
  originalName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  originalName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  originalName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  originalName_starts_with?: InputMaybe<Scalars['String']['input']>;
  photoMetadatas_some?: InputMaybe<PhotoMetadataWhereInput>;
  photoPublications_some?: InputMaybe<PhotoPublicationWhereInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  synced_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  synced_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  synced_not?: InputMaybe<Scalars['Boolean']['input']>;
  synced_not_in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  takenAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  takenAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  takenAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  takenAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  takenAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  takenAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  takenAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  takenAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  width?: InputMaybe<Scalars['Int']['input']>;
  width_gt?: InputMaybe<Scalars['Int']['input']>;
  width_gte?: InputMaybe<Scalars['Int']['input']>;
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  width_lt?: InputMaybe<Scalars['Int']['input']>;
  width_lte?: InputMaybe<Scalars['Int']['input']>;
  width_not?: InputMaybe<Scalars['Int']['input']>;
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/**
 * Identifies exactly one "Photo" node with one of these unique values:
 * - _id
 * - id
 */
export type PhotoWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PhotoWithForcedAgencyCreateInput = {
  /** Actions for the "Photo.archive" relation */
  archive: PhotoNestedArchiveCreateInput;
  /** Actions for the "Photo.category" relation */
  category?: InputMaybe<PhotoNestedCategoryCreateInput>;
  /** asset content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.deliverySubject" relation */
  deliverySubject?: InputMaybe<PhotoNestedDeliverySubjectCreateInput>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The date of the photo's importation */
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Photo.importQueue" relation: "ImportQueue.photo"'s inverse relation */
  importQueue?: InputMaybe<PhotoNestedImportQueueCreateInput>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Photo.Metadata_AccessRights" relation: "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights?: InputMaybe<PhotoNestedMetadataAccessrightsCreateInput>;
  /** Actions for the "Photo.Metadata_AssetState" relation: "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState?: InputMaybe<PhotoNestedMetadataAssetstateCreateInput>;
  /** Actions for the "Photo.Metadata_BackupName" relation: "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName?: InputMaybe<PhotoNestedMetadataBackupnameCreateInput>;
  /** Actions for the "Photo.Metadata_Brand" relation: "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand?: InputMaybe<PhotoNestedMetadataBrandCreateInput>;
  /** Actions for the "Photo.Metadata_BrandPrisma" relation: "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma?: InputMaybe<PhotoNestedMetadataBrandprismaCreateInput>;
  /** Actions for the "Photo.Metadata_BrandShortName" relation: "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName?: InputMaybe<PhotoNestedMetadataBrandshortnameCreateInput>;
  /** Actions for the "Photo.Metadata_By_line" relation: "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line?: InputMaybe<PhotoNestedMetadataByLineCreateInput>;
  /** Actions for the "Photo.Metadata_Caption" relation: "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption?: InputMaybe<PhotoNestedMetadataCaptionCreateInput>;
  /** Actions for the "Photo.Metadata_Caption_Abstract" relation: "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract?: InputMaybe<PhotoNestedMetadataCaptionAbstractCreateInput>;
  /** Actions for the "Photo.Metadata_Category" relation: "MetadataCategory.photo"'s inverse relation */
  Metadata_Category?: InputMaybe<PhotoNestedMetadataCategoryCreateInput>;
  /** Actions for the "Photo.Metadata_CategoryPrisma" relation: "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma?: InputMaybe<PhotoNestedMetadataCategoryprismaCreateInput>;
  /** Actions for the "Photo.Metadata_Company" relation: "MetadataCompany.photo"'s inverse relation */
  Metadata_Company?: InputMaybe<PhotoNestedMetadataCompanyCreateInput>;
  /** Actions for the "Photo.Metadata_CompanyShortName" relation: "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName?: InputMaybe<PhotoNestedMetadataCompanyshortnameCreateInput>;
  /** Actions for the "Photo.Metadata_CopyrightNotice" relation: "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice?: InputMaybe<PhotoNestedMetadataCopyrightnoticeCreateInput>;
  /** Actions for the "Photo.Metadata_creator" relation: "MetadataCreator.photo"'s inverse relation */
  Metadata_creator?: InputMaybe<PhotoNestedMetadataCreatorCreateInput>;
  /** Actions for the "Photo.Metadata_Credit" relation: "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit?: InputMaybe<PhotoNestedMetadataCreditCreateInput>;
  /** Actions for the "Photo.Metadata_CustomField1" relation: "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1?: InputMaybe<PhotoNestedMetadataCustomfield1CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField14" relation: "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14?: InputMaybe<PhotoNestedMetadataCustomfield14CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField15" relation: "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15?: InputMaybe<PhotoNestedMetadataCustomfield15CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField16" relation: "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16?: InputMaybe<PhotoNestedMetadataCustomfield16CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField17" relation: "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17?: InputMaybe<PhotoNestedMetadataCustomfield17CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField20" relation: "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20?: InputMaybe<PhotoNestedMetadataCustomfield20CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField3" relation: "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3?: InputMaybe<PhotoNestedMetadataCustomfield3CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField4" relation: "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4?: InputMaybe<PhotoNestedMetadataCustomfield4CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField5" relation: "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5?: InputMaybe<PhotoNestedMetadataCustomfield5CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField6" relation: "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6?: InputMaybe<PhotoNestedMetadataCustomfield6CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField7" relation: "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7?: InputMaybe<PhotoNestedMetadataCustomfield7CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField9" relation: "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9?: InputMaybe<PhotoNestedMetadataCustomfield9CreateInput>;
  /** Actions for the "Photo.Metadata_DateCreated" relation: "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated?: InputMaybe<PhotoNestedMetadataDatecreatedCreateInput>;
  /** Actions for the "Photo.Metadata_DateTimeOriginal" relation: "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal?: InputMaybe<PhotoNestedMetadataDatetimeoriginalCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryAccount" relation: "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount?: InputMaybe<PhotoNestedMetadataDeliveryaccountCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCompany" relation: "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany?: InputMaybe<PhotoNestedMetadataDeliverycompanyCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCopyright" relation: "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright?: InputMaybe<PhotoNestedMetadataDeliverycopyrightCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateFolder" relation: "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder?: InputMaybe<PhotoNestedMetadataDeliverydatefolderCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateTime" relation: "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime?: InputMaybe<PhotoNestedMetadataDeliverydatetimeCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcCreator" relation: "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator?: InputMaybe<PhotoNestedMetadataDeliverydccreatorCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcRights" relation: "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights?: InputMaybe<PhotoNestedMetadataDeliverydcrightsCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryFolder" relation: "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder?: InputMaybe<PhotoNestedMetadataDeliveryfolderCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryKind" relation: "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind?: InputMaybe<PhotoNestedMetadataDeliverykindCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPath" relation: "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath?: InputMaybe<PhotoNestedMetadataDeliverypathCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopCredit" relation: "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopcreditCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopSource" relation: "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopsourceCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryService" relation: "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService?: InputMaybe<PhotoNestedMetadataDeliveryserviceCreateInput>;
  /** Actions for the "Photo.Metadata_DeliverySubject" relation: "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject?: InputMaybe<PhotoNestedMetadataDeliverysubjectCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryUnderSubject" relation: "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject?: InputMaybe<PhotoNestedMetadataDeliveryundersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_Department" relation: "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department?: InputMaybe<PhotoNestedMetadataDepartmentCreateInput>;
  /** Actions for the "Photo.Metadata_description" relation: "MetadataDescription.photo"'s inverse relation */
  Metadata_description?: InputMaybe<PhotoNestedMetadataDescriptionCreateInput>;
  /** Actions for the "Photo.Metadata_Edition" relation: "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition?: InputMaybe<PhotoNestedMetadataEditionCreateInput>;
  /** Actions for the "Photo.Metadata_EditStatus" relation: "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus?: InputMaybe<PhotoNestedMetadataEditstatusCreateInput>;
  /** Actions for the "Photo.Metadata_FileStatus" relation: "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus?: InputMaybe<PhotoNestedMetadataFilestatusCreateInput>;
  /** Actions for the "Photo.Metadata_Format" relation: "MetadataFormat.photo"'s inverse relation */
  Metadata_Format?: InputMaybe<PhotoNestedMetadataFormatCreateInput>;
  /** Actions for the "Photo.Metadata_Header" relation: "MetadataHeader.photo"'s inverse relation */
  Metadata_Header?: InputMaybe<PhotoNestedMetadataHeaderCreateInput>;
  /** Actions for the "Photo.Metadata_HeaderPrisma" relation: "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma?: InputMaybe<PhotoNestedMetadataHeaderprismaCreateInput>;
  /** Actions for the "Photo.Metadata_Headline" relation: "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline?: InputMaybe<PhotoNestedMetadataHeadlineCreateInput>;
  /** Actions for the "Photo.Metadata_ID_subject" relation: "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject?: InputMaybe<PhotoNestedMetadataIdSubjectCreateInput>;
  /** Actions for the "Photo.Metadata_IdAssignment" relation: "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment?: InputMaybe<PhotoNestedMetadataIdassignmentCreateInput>;
  /** Actions for the "Photo.Metadata_IdPhotoPrisma" relation: "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma?: InputMaybe<PhotoNestedMetadataIdphotoprismaCreateInput>;
  /** Actions for the "Photo.Metadata_ImageNotes" relation: "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes?: InputMaybe<PhotoNestedMetadataImagenotesCreateInput>;
  /** Actions for the "Photo.Metadata_Instructions" relation: "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions?: InputMaybe<PhotoNestedMetadataInstructionsCreateInput>;
  /** Actions for the "Photo.Metadata_Issue" relation: "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue?: InputMaybe<PhotoNestedMetadataIssueCreateInput>;
  /** Actions for the "Photo.Metadata_Keywords" relation: "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords?: InputMaybe<PhotoNestedMetadataKeywordsCreateInput>;
  /** Actions for the "Photo.Metadata_ObjectName" relation: "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName?: InputMaybe<PhotoNestedMetadataObjectnameCreateInput>;
  /** Actions for the "Photo.Metadata_OriginalName" relation: "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName?: InputMaybe<PhotoNestedMetadataOriginalnameCreateInput>;
  /** Actions for the "Photo.Metadata_PriceLevel" relation: "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel?: InputMaybe<PhotoNestedMetadataPricelevelCreateInput>;
  /** Actions for the "Photo.Metadata_ProcessHistory" relation: "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory?: InputMaybe<PhotoNestedMetadataProcesshistoryCreateInput>;
  /** Actions for the "Photo.Metadata_ProcessStatus" relation: "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus?: InputMaybe<PhotoNestedMetadataProcessstatusCreateInput>;
  /** Actions for the "Photo.Metadata_Product" relation: "MetadataProduct.photo"'s inverse relation */
  Metadata_Product?: InputMaybe<PhotoNestedMetadataProductCreateInput>;
  /** Actions for the "Photo.Metadata_Products" relation: "MetadataProducts.photo"'s inverse relation */
  Metadata_Products?: InputMaybe<PhotoNestedMetadataProductsCreateInput>;
  /** Actions for the "Photo.Metadata_publishingSubject" relation: "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject?: InputMaybe<PhotoNestedMetadataPublishingsubjectCreateInput>;
  /** Actions for the "Photo.Metadata_ResolutionKind" relation: "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind?: InputMaybe<PhotoNestedMetadataResolutionkindCreateInput>;
  /** Actions for the "Photo.Metadata_rights" relation: "MetadataRights.photo"'s inverse relation */
  Metadata_rights?: InputMaybe<PhotoNestedMetadataRightsCreateInput>;
  /** Actions for the "Photo.Metadata_Source" relation: "MetadataSource.photo"'s inverse relation */
  Metadata_Source?: InputMaybe<PhotoNestedMetadataSourceCreateInput>;
  /** Actions for the "Photo.Metadata_SpecialInstructions" relation: "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions?: InputMaybe<PhotoNestedMetadataSpecialinstructionsCreateInput>;
  /** Actions for the "Photo.Metadata_subject" relation: "MetadataSubject.photo"'s inverse relation */
  Metadata_subject?: InputMaybe<PhotoNestedMetadataSubjectCreateInput>;
  /** Actions for the "Photo.Metadata_SubjectCode" relation: "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode?: InputMaybe<PhotoNestedMetadataSubjectcodeCreateInput>;
  /** Actions for the "Photo.Metadata_SubjectPrisma" relation: "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma?: InputMaybe<PhotoNestedMetadataSubjectprismaCreateInput>;
  /** Actions for the "Photo.Metadata_title" relation: "MetadataTitle.photo"'s inverse relation */
  Metadata_title?: InputMaybe<PhotoNestedMetadataTitleCreateInput>;
  /** Actions for the "Photo.Metadata_TransferredBy" relation: "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy?: InputMaybe<PhotoNestedMetadataTransferredbyCreateInput>;
  /** Actions for the "Photo.Metadata_TransferredByFullName" relation: "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName?: InputMaybe<PhotoNestedMetadataTransferredbyfullnameCreateInput>;
  /** Actions for the "Photo.Metadata_Type" relation: "MetadataType.photo"'s inverse relation */
  Metadata_Type?: InputMaybe<PhotoNestedMetadataTypeCreateInput>;
  /** Actions for the "Photo.Metadata_Undersubject" relation: "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject?: InputMaybe<PhotoNestedMetadataUndersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_UnderUnderSubject" relation: "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject?: InputMaybe<PhotoNestedMetadataUnderundersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_UploadedBy" relation: "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy?: InputMaybe<PhotoNestedMetadataUploadedbyCreateInput>;
  /** Actions for the "Photo.Metadata_UploadedByFullName" relation: "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName?: InputMaybe<PhotoNestedMetadataUploadedbyfullnameCreateInput>;
  /** Actions for the "Photo.Metadata_UploadTime" relation: "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime?: InputMaybe<PhotoNestedMetadataUploadtimeCreateInput>;
  /** Actions for the "Photo.Metadata_Urgency" relation: "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency?: InputMaybe<PhotoNestedMetadataUrgencyCreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined195" relation: "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195?: InputMaybe<PhotoNestedMetadataUserdefined195CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined237" relation: "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237?: InputMaybe<PhotoNestedMetadataUserdefined237CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined238" relation: "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238?: InputMaybe<PhotoNestedMetadataUserdefined238CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined239" relation: "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239?: InputMaybe<PhotoNestedMetadataUserdefined239CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined242" relation: "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242?: InputMaybe<PhotoNestedMetadataUserdefined242CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined62" relation: "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62?: InputMaybe<PhotoNestedMetadataUserdefined62CreateInput>;
  /** Actions for the "Photo.Metadata_WorkflowKind" relation: "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind?: InputMaybe<PhotoNestedMetadataWorkflowkindCreateInput>;
  /** Actions for the "Photo.Metadata_XMPHistory" relation: "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory?: InputMaybe<PhotoNestedMetadataXmphistoryCreateInput>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.photoMetadatas" relation: "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas?: InputMaybe<PhotoNestedPhotoMetadatasCreateInput>;
  /** Actions for the "Photo.photoPublications" relation: "PhotoPublication.photo"'s inverse relation */
  photoPublications?: InputMaybe<PhotoNestedPhotoPublicationsCreateInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the photo's capture */
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoWithForcedAgencyUpdateInput = {
  /** Actions for the "Photo.archive" relation */
  archive?: InputMaybe<PhotoNestedArchiveUpdateInput>;
  /** Actions for the "Photo.category" relation */
  category?: InputMaybe<PhotoNestedCategoryUpdateInput>;
  /** asset content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.deliverySubject" relation */
  deliverySubject?: InputMaybe<PhotoNestedDeliverySubjectUpdateInput>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The date of the photo's importation */
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Photo.importQueue" relation: "ImportQueue.photo"'s inverse relation */
  importQueue?: InputMaybe<PhotoNestedImportQueueUpdateInput>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Photo.Metadata_AccessRights" relation: "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights?: InputMaybe<PhotoNestedMetadataAccessrightsUpdateInput>;
  /** Actions for the "Photo.Metadata_AssetState" relation: "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState?: InputMaybe<PhotoNestedMetadataAssetstateUpdateInput>;
  /** Actions for the "Photo.Metadata_BackupName" relation: "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName?: InputMaybe<PhotoNestedMetadataBackupnameUpdateInput>;
  /** Actions for the "Photo.Metadata_Brand" relation: "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand?: InputMaybe<PhotoNestedMetadataBrandUpdateInput>;
  /** Actions for the "Photo.Metadata_BrandPrisma" relation: "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma?: InputMaybe<PhotoNestedMetadataBrandprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_BrandShortName" relation: "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName?: InputMaybe<PhotoNestedMetadataBrandshortnameUpdateInput>;
  /** Actions for the "Photo.Metadata_By_line" relation: "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line?: InputMaybe<PhotoNestedMetadataByLineUpdateInput>;
  /** Actions for the "Photo.Metadata_Caption" relation: "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption?: InputMaybe<PhotoNestedMetadataCaptionUpdateInput>;
  /** Actions for the "Photo.Metadata_Caption_Abstract" relation: "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract?: InputMaybe<PhotoNestedMetadataCaptionAbstractUpdateInput>;
  /** Actions for the "Photo.Metadata_Category" relation: "MetadataCategory.photo"'s inverse relation */
  Metadata_Category?: InputMaybe<PhotoNestedMetadataCategoryUpdateInput>;
  /** Actions for the "Photo.Metadata_CategoryPrisma" relation: "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma?: InputMaybe<PhotoNestedMetadataCategoryprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_Company" relation: "MetadataCompany.photo"'s inverse relation */
  Metadata_Company?: InputMaybe<PhotoNestedMetadataCompanyUpdateInput>;
  /** Actions for the "Photo.Metadata_CompanyShortName" relation: "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName?: InputMaybe<PhotoNestedMetadataCompanyshortnameUpdateInput>;
  /** Actions for the "Photo.Metadata_CopyrightNotice" relation: "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice?: InputMaybe<PhotoNestedMetadataCopyrightnoticeUpdateInput>;
  /** Actions for the "Photo.Metadata_creator" relation: "MetadataCreator.photo"'s inverse relation */
  Metadata_creator?: InputMaybe<PhotoNestedMetadataCreatorUpdateInput>;
  /** Actions for the "Photo.Metadata_Credit" relation: "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit?: InputMaybe<PhotoNestedMetadataCreditUpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField1" relation: "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1?: InputMaybe<PhotoNestedMetadataCustomfield1UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField14" relation: "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14?: InputMaybe<PhotoNestedMetadataCustomfield14UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField15" relation: "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15?: InputMaybe<PhotoNestedMetadataCustomfield15UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField16" relation: "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16?: InputMaybe<PhotoNestedMetadataCustomfield16UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField17" relation: "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17?: InputMaybe<PhotoNestedMetadataCustomfield17UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField20" relation: "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20?: InputMaybe<PhotoNestedMetadataCustomfield20UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField3" relation: "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3?: InputMaybe<PhotoNestedMetadataCustomfield3UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField4" relation: "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4?: InputMaybe<PhotoNestedMetadataCustomfield4UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField5" relation: "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5?: InputMaybe<PhotoNestedMetadataCustomfield5UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField6" relation: "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6?: InputMaybe<PhotoNestedMetadataCustomfield6UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField7" relation: "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7?: InputMaybe<PhotoNestedMetadataCustomfield7UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField9" relation: "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9?: InputMaybe<PhotoNestedMetadataCustomfield9UpdateInput>;
  /** Actions for the "Photo.Metadata_DateCreated" relation: "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated?: InputMaybe<PhotoNestedMetadataDatecreatedUpdateInput>;
  /** Actions for the "Photo.Metadata_DateTimeOriginal" relation: "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal?: InputMaybe<PhotoNestedMetadataDatetimeoriginalUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryAccount" relation: "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount?: InputMaybe<PhotoNestedMetadataDeliveryaccountUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCompany" relation: "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany?: InputMaybe<PhotoNestedMetadataDeliverycompanyUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCopyright" relation: "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright?: InputMaybe<PhotoNestedMetadataDeliverycopyrightUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateFolder" relation: "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder?: InputMaybe<PhotoNestedMetadataDeliverydatefolderUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateTime" relation: "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime?: InputMaybe<PhotoNestedMetadataDeliverydatetimeUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcCreator" relation: "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator?: InputMaybe<PhotoNestedMetadataDeliverydccreatorUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcRights" relation: "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights?: InputMaybe<PhotoNestedMetadataDeliverydcrightsUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryFolder" relation: "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder?: InputMaybe<PhotoNestedMetadataDeliveryfolderUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryKind" relation: "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind?: InputMaybe<PhotoNestedMetadataDeliverykindUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPath" relation: "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath?: InputMaybe<PhotoNestedMetadataDeliverypathUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopCredit" relation: "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopcreditUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopSource" relation: "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopsourceUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryService" relation: "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService?: InputMaybe<PhotoNestedMetadataDeliveryserviceUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliverySubject" relation: "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject?: InputMaybe<PhotoNestedMetadataDeliverysubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryUnderSubject" relation: "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject?: InputMaybe<PhotoNestedMetadataDeliveryundersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_Department" relation: "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department?: InputMaybe<PhotoNestedMetadataDepartmentUpdateInput>;
  /** Actions for the "Photo.Metadata_description" relation: "MetadataDescription.photo"'s inverse relation */
  Metadata_description?: InputMaybe<PhotoNestedMetadataDescriptionUpdateInput>;
  /** Actions for the "Photo.Metadata_Edition" relation: "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition?: InputMaybe<PhotoNestedMetadataEditionUpdateInput>;
  /** Actions for the "Photo.Metadata_EditStatus" relation: "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus?: InputMaybe<PhotoNestedMetadataEditstatusUpdateInput>;
  /** Actions for the "Photo.Metadata_FileStatus" relation: "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus?: InputMaybe<PhotoNestedMetadataFilestatusUpdateInput>;
  /** Actions for the "Photo.Metadata_Format" relation: "MetadataFormat.photo"'s inverse relation */
  Metadata_Format?: InputMaybe<PhotoNestedMetadataFormatUpdateInput>;
  /** Actions for the "Photo.Metadata_Header" relation: "MetadataHeader.photo"'s inverse relation */
  Metadata_Header?: InputMaybe<PhotoNestedMetadataHeaderUpdateInput>;
  /** Actions for the "Photo.Metadata_HeaderPrisma" relation: "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma?: InputMaybe<PhotoNestedMetadataHeaderprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_Headline" relation: "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline?: InputMaybe<PhotoNestedMetadataHeadlineUpdateInput>;
  /** Actions for the "Photo.Metadata_ID_subject" relation: "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject?: InputMaybe<PhotoNestedMetadataIdSubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_IdAssignment" relation: "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment?: InputMaybe<PhotoNestedMetadataIdassignmentUpdateInput>;
  /** Actions for the "Photo.Metadata_IdPhotoPrisma" relation: "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma?: InputMaybe<PhotoNestedMetadataIdphotoprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_ImageNotes" relation: "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes?: InputMaybe<PhotoNestedMetadataImagenotesUpdateInput>;
  /** Actions for the "Photo.Metadata_Instructions" relation: "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions?: InputMaybe<PhotoNestedMetadataInstructionsUpdateInput>;
  /** Actions for the "Photo.Metadata_Issue" relation: "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue?: InputMaybe<PhotoNestedMetadataIssueUpdateInput>;
  /** Actions for the "Photo.Metadata_Keywords" relation: "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords?: InputMaybe<PhotoNestedMetadataKeywordsUpdateInput>;
  /** Actions for the "Photo.Metadata_ObjectName" relation: "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName?: InputMaybe<PhotoNestedMetadataObjectnameUpdateInput>;
  /** Actions for the "Photo.Metadata_OriginalName" relation: "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName?: InputMaybe<PhotoNestedMetadataOriginalnameUpdateInput>;
  /** Actions for the "Photo.Metadata_PriceLevel" relation: "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel?: InputMaybe<PhotoNestedMetadataPricelevelUpdateInput>;
  /** Actions for the "Photo.Metadata_ProcessHistory" relation: "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory?: InputMaybe<PhotoNestedMetadataProcesshistoryUpdateInput>;
  /** Actions for the "Photo.Metadata_ProcessStatus" relation: "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus?: InputMaybe<PhotoNestedMetadataProcessstatusUpdateInput>;
  /** Actions for the "Photo.Metadata_Product" relation: "MetadataProduct.photo"'s inverse relation */
  Metadata_Product?: InputMaybe<PhotoNestedMetadataProductUpdateInput>;
  /** Actions for the "Photo.Metadata_Products" relation: "MetadataProducts.photo"'s inverse relation */
  Metadata_Products?: InputMaybe<PhotoNestedMetadataProductsUpdateInput>;
  /** Actions for the "Photo.Metadata_publishingSubject" relation: "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject?: InputMaybe<PhotoNestedMetadataPublishingsubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_ResolutionKind" relation: "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind?: InputMaybe<PhotoNestedMetadataResolutionkindUpdateInput>;
  /** Actions for the "Photo.Metadata_rights" relation: "MetadataRights.photo"'s inverse relation */
  Metadata_rights?: InputMaybe<PhotoNestedMetadataRightsUpdateInput>;
  /** Actions for the "Photo.Metadata_Source" relation: "MetadataSource.photo"'s inverse relation */
  Metadata_Source?: InputMaybe<PhotoNestedMetadataSourceUpdateInput>;
  /** Actions for the "Photo.Metadata_SpecialInstructions" relation: "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions?: InputMaybe<PhotoNestedMetadataSpecialinstructionsUpdateInput>;
  /** Actions for the "Photo.Metadata_subject" relation: "MetadataSubject.photo"'s inverse relation */
  Metadata_subject?: InputMaybe<PhotoNestedMetadataSubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_SubjectCode" relation: "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode?: InputMaybe<PhotoNestedMetadataSubjectcodeUpdateInput>;
  /** Actions for the "Photo.Metadata_SubjectPrisma" relation: "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma?: InputMaybe<PhotoNestedMetadataSubjectprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_title" relation: "MetadataTitle.photo"'s inverse relation */
  Metadata_title?: InputMaybe<PhotoNestedMetadataTitleUpdateInput>;
  /** Actions for the "Photo.Metadata_TransferredBy" relation: "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy?: InputMaybe<PhotoNestedMetadataTransferredbyUpdateInput>;
  /** Actions for the "Photo.Metadata_TransferredByFullName" relation: "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName?: InputMaybe<PhotoNestedMetadataTransferredbyfullnameUpdateInput>;
  /** Actions for the "Photo.Metadata_Type" relation: "MetadataType.photo"'s inverse relation */
  Metadata_Type?: InputMaybe<PhotoNestedMetadataTypeUpdateInput>;
  /** Actions for the "Photo.Metadata_Undersubject" relation: "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject?: InputMaybe<PhotoNestedMetadataUndersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_UnderUnderSubject" relation: "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject?: InputMaybe<PhotoNestedMetadataUnderundersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadedBy" relation: "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy?: InputMaybe<PhotoNestedMetadataUploadedbyUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadedByFullName" relation: "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName?: InputMaybe<PhotoNestedMetadataUploadedbyfullnameUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadTime" relation: "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime?: InputMaybe<PhotoNestedMetadataUploadtimeUpdateInput>;
  /** Actions for the "Photo.Metadata_Urgency" relation: "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency?: InputMaybe<PhotoNestedMetadataUrgencyUpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined195" relation: "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195?: InputMaybe<PhotoNestedMetadataUserdefined195UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined237" relation: "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237?: InputMaybe<PhotoNestedMetadataUserdefined237UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined238" relation: "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238?: InputMaybe<PhotoNestedMetadataUserdefined238UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined239" relation: "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239?: InputMaybe<PhotoNestedMetadataUserdefined239UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined242" relation: "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242?: InputMaybe<PhotoNestedMetadataUserdefined242UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined62" relation: "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62?: InputMaybe<PhotoNestedMetadataUserdefined62UpdateInput>;
  /** Actions for the "Photo.Metadata_WorkflowKind" relation: "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind?: InputMaybe<PhotoNestedMetadataWorkflowkindUpdateInput>;
  /** Actions for the "Photo.Metadata_XMPHistory" relation: "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory?: InputMaybe<PhotoNestedMetadataXmphistoryUpdateInput>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.photoMetadatas" relation: "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas?: InputMaybe<PhotoNestedPhotoMetadatasUpdateInput>;
  /** Actions for the "Photo.photoPublications" relation: "PhotoPublication.photo"'s inverse relation */
  photoPublications?: InputMaybe<PhotoNestedPhotoPublicationsUpdateInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the photo's capture */
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoWithForcedArchiveCreateInput = {
  /** Actions for the "Photo.agency" relation */
  agency?: InputMaybe<PhotoNestedAgencyCreateInput>;
  /** Actions for the "Photo.category" relation */
  category?: InputMaybe<PhotoNestedCategoryCreateInput>;
  /** asset content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.deliverySubject" relation */
  deliverySubject?: InputMaybe<PhotoNestedDeliverySubjectCreateInput>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The date of the photo's importation */
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Photo.importQueue" relation: "ImportQueue.photo"'s inverse relation */
  importQueue?: InputMaybe<PhotoNestedImportQueueCreateInput>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Photo.Metadata_AccessRights" relation: "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights?: InputMaybe<PhotoNestedMetadataAccessrightsCreateInput>;
  /** Actions for the "Photo.Metadata_AssetState" relation: "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState?: InputMaybe<PhotoNestedMetadataAssetstateCreateInput>;
  /** Actions for the "Photo.Metadata_BackupName" relation: "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName?: InputMaybe<PhotoNestedMetadataBackupnameCreateInput>;
  /** Actions for the "Photo.Metadata_Brand" relation: "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand?: InputMaybe<PhotoNestedMetadataBrandCreateInput>;
  /** Actions for the "Photo.Metadata_BrandPrisma" relation: "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma?: InputMaybe<PhotoNestedMetadataBrandprismaCreateInput>;
  /** Actions for the "Photo.Metadata_BrandShortName" relation: "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName?: InputMaybe<PhotoNestedMetadataBrandshortnameCreateInput>;
  /** Actions for the "Photo.Metadata_By_line" relation: "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line?: InputMaybe<PhotoNestedMetadataByLineCreateInput>;
  /** Actions for the "Photo.Metadata_Caption" relation: "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption?: InputMaybe<PhotoNestedMetadataCaptionCreateInput>;
  /** Actions for the "Photo.Metadata_Caption_Abstract" relation: "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract?: InputMaybe<PhotoNestedMetadataCaptionAbstractCreateInput>;
  /** Actions for the "Photo.Metadata_Category" relation: "MetadataCategory.photo"'s inverse relation */
  Metadata_Category?: InputMaybe<PhotoNestedMetadataCategoryCreateInput>;
  /** Actions for the "Photo.Metadata_CategoryPrisma" relation: "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma?: InputMaybe<PhotoNestedMetadataCategoryprismaCreateInput>;
  /** Actions for the "Photo.Metadata_Company" relation: "MetadataCompany.photo"'s inverse relation */
  Metadata_Company?: InputMaybe<PhotoNestedMetadataCompanyCreateInput>;
  /** Actions for the "Photo.Metadata_CompanyShortName" relation: "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName?: InputMaybe<PhotoNestedMetadataCompanyshortnameCreateInput>;
  /** Actions for the "Photo.Metadata_CopyrightNotice" relation: "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice?: InputMaybe<PhotoNestedMetadataCopyrightnoticeCreateInput>;
  /** Actions for the "Photo.Metadata_creator" relation: "MetadataCreator.photo"'s inverse relation */
  Metadata_creator?: InputMaybe<PhotoNestedMetadataCreatorCreateInput>;
  /** Actions for the "Photo.Metadata_Credit" relation: "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit?: InputMaybe<PhotoNestedMetadataCreditCreateInput>;
  /** Actions for the "Photo.Metadata_CustomField1" relation: "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1?: InputMaybe<PhotoNestedMetadataCustomfield1CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField14" relation: "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14?: InputMaybe<PhotoNestedMetadataCustomfield14CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField15" relation: "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15?: InputMaybe<PhotoNestedMetadataCustomfield15CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField16" relation: "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16?: InputMaybe<PhotoNestedMetadataCustomfield16CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField17" relation: "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17?: InputMaybe<PhotoNestedMetadataCustomfield17CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField20" relation: "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20?: InputMaybe<PhotoNestedMetadataCustomfield20CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField3" relation: "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3?: InputMaybe<PhotoNestedMetadataCustomfield3CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField4" relation: "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4?: InputMaybe<PhotoNestedMetadataCustomfield4CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField5" relation: "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5?: InputMaybe<PhotoNestedMetadataCustomfield5CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField6" relation: "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6?: InputMaybe<PhotoNestedMetadataCustomfield6CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField7" relation: "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7?: InputMaybe<PhotoNestedMetadataCustomfield7CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField9" relation: "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9?: InputMaybe<PhotoNestedMetadataCustomfield9CreateInput>;
  /** Actions for the "Photo.Metadata_DateCreated" relation: "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated?: InputMaybe<PhotoNestedMetadataDatecreatedCreateInput>;
  /** Actions for the "Photo.Metadata_DateTimeOriginal" relation: "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal?: InputMaybe<PhotoNestedMetadataDatetimeoriginalCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryAccount" relation: "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount?: InputMaybe<PhotoNestedMetadataDeliveryaccountCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCompany" relation: "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany?: InputMaybe<PhotoNestedMetadataDeliverycompanyCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCopyright" relation: "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright?: InputMaybe<PhotoNestedMetadataDeliverycopyrightCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateFolder" relation: "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder?: InputMaybe<PhotoNestedMetadataDeliverydatefolderCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateTime" relation: "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime?: InputMaybe<PhotoNestedMetadataDeliverydatetimeCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcCreator" relation: "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator?: InputMaybe<PhotoNestedMetadataDeliverydccreatorCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcRights" relation: "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights?: InputMaybe<PhotoNestedMetadataDeliverydcrightsCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryFolder" relation: "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder?: InputMaybe<PhotoNestedMetadataDeliveryfolderCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryKind" relation: "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind?: InputMaybe<PhotoNestedMetadataDeliverykindCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPath" relation: "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath?: InputMaybe<PhotoNestedMetadataDeliverypathCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopCredit" relation: "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopcreditCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopSource" relation: "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopsourceCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryService" relation: "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService?: InputMaybe<PhotoNestedMetadataDeliveryserviceCreateInput>;
  /** Actions for the "Photo.Metadata_DeliverySubject" relation: "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject?: InputMaybe<PhotoNestedMetadataDeliverysubjectCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryUnderSubject" relation: "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject?: InputMaybe<PhotoNestedMetadataDeliveryundersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_Department" relation: "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department?: InputMaybe<PhotoNestedMetadataDepartmentCreateInput>;
  /** Actions for the "Photo.Metadata_description" relation: "MetadataDescription.photo"'s inverse relation */
  Metadata_description?: InputMaybe<PhotoNestedMetadataDescriptionCreateInput>;
  /** Actions for the "Photo.Metadata_Edition" relation: "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition?: InputMaybe<PhotoNestedMetadataEditionCreateInput>;
  /** Actions for the "Photo.Metadata_EditStatus" relation: "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus?: InputMaybe<PhotoNestedMetadataEditstatusCreateInput>;
  /** Actions for the "Photo.Metadata_FileStatus" relation: "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus?: InputMaybe<PhotoNestedMetadataFilestatusCreateInput>;
  /** Actions for the "Photo.Metadata_Format" relation: "MetadataFormat.photo"'s inverse relation */
  Metadata_Format?: InputMaybe<PhotoNestedMetadataFormatCreateInput>;
  /** Actions for the "Photo.Metadata_Header" relation: "MetadataHeader.photo"'s inverse relation */
  Metadata_Header?: InputMaybe<PhotoNestedMetadataHeaderCreateInput>;
  /** Actions for the "Photo.Metadata_HeaderPrisma" relation: "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma?: InputMaybe<PhotoNestedMetadataHeaderprismaCreateInput>;
  /** Actions for the "Photo.Metadata_Headline" relation: "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline?: InputMaybe<PhotoNestedMetadataHeadlineCreateInput>;
  /** Actions for the "Photo.Metadata_ID_subject" relation: "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject?: InputMaybe<PhotoNestedMetadataIdSubjectCreateInput>;
  /** Actions for the "Photo.Metadata_IdAssignment" relation: "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment?: InputMaybe<PhotoNestedMetadataIdassignmentCreateInput>;
  /** Actions for the "Photo.Metadata_IdPhotoPrisma" relation: "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma?: InputMaybe<PhotoNestedMetadataIdphotoprismaCreateInput>;
  /** Actions for the "Photo.Metadata_ImageNotes" relation: "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes?: InputMaybe<PhotoNestedMetadataImagenotesCreateInput>;
  /** Actions for the "Photo.Metadata_Instructions" relation: "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions?: InputMaybe<PhotoNestedMetadataInstructionsCreateInput>;
  /** Actions for the "Photo.Metadata_Issue" relation: "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue?: InputMaybe<PhotoNestedMetadataIssueCreateInput>;
  /** Actions for the "Photo.Metadata_Keywords" relation: "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords?: InputMaybe<PhotoNestedMetadataKeywordsCreateInput>;
  /** Actions for the "Photo.Metadata_ObjectName" relation: "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName?: InputMaybe<PhotoNestedMetadataObjectnameCreateInput>;
  /** Actions for the "Photo.Metadata_OriginalName" relation: "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName?: InputMaybe<PhotoNestedMetadataOriginalnameCreateInput>;
  /** Actions for the "Photo.Metadata_PriceLevel" relation: "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel?: InputMaybe<PhotoNestedMetadataPricelevelCreateInput>;
  /** Actions for the "Photo.Metadata_ProcessHistory" relation: "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory?: InputMaybe<PhotoNestedMetadataProcesshistoryCreateInput>;
  /** Actions for the "Photo.Metadata_ProcessStatus" relation: "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus?: InputMaybe<PhotoNestedMetadataProcessstatusCreateInput>;
  /** Actions for the "Photo.Metadata_Product" relation: "MetadataProduct.photo"'s inverse relation */
  Metadata_Product?: InputMaybe<PhotoNestedMetadataProductCreateInput>;
  /** Actions for the "Photo.Metadata_Products" relation: "MetadataProducts.photo"'s inverse relation */
  Metadata_Products?: InputMaybe<PhotoNestedMetadataProductsCreateInput>;
  /** Actions for the "Photo.Metadata_publishingSubject" relation: "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject?: InputMaybe<PhotoNestedMetadataPublishingsubjectCreateInput>;
  /** Actions for the "Photo.Metadata_ResolutionKind" relation: "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind?: InputMaybe<PhotoNestedMetadataResolutionkindCreateInput>;
  /** Actions for the "Photo.Metadata_rights" relation: "MetadataRights.photo"'s inverse relation */
  Metadata_rights?: InputMaybe<PhotoNestedMetadataRightsCreateInput>;
  /** Actions for the "Photo.Metadata_Source" relation: "MetadataSource.photo"'s inverse relation */
  Metadata_Source?: InputMaybe<PhotoNestedMetadataSourceCreateInput>;
  /** Actions for the "Photo.Metadata_SpecialInstructions" relation: "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions?: InputMaybe<PhotoNestedMetadataSpecialinstructionsCreateInput>;
  /** Actions for the "Photo.Metadata_subject" relation: "MetadataSubject.photo"'s inverse relation */
  Metadata_subject?: InputMaybe<PhotoNestedMetadataSubjectCreateInput>;
  /** Actions for the "Photo.Metadata_SubjectCode" relation: "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode?: InputMaybe<PhotoNestedMetadataSubjectcodeCreateInput>;
  /** Actions for the "Photo.Metadata_SubjectPrisma" relation: "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma?: InputMaybe<PhotoNestedMetadataSubjectprismaCreateInput>;
  /** Actions for the "Photo.Metadata_title" relation: "MetadataTitle.photo"'s inverse relation */
  Metadata_title?: InputMaybe<PhotoNestedMetadataTitleCreateInput>;
  /** Actions for the "Photo.Metadata_TransferredBy" relation: "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy?: InputMaybe<PhotoNestedMetadataTransferredbyCreateInput>;
  /** Actions for the "Photo.Metadata_TransferredByFullName" relation: "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName?: InputMaybe<PhotoNestedMetadataTransferredbyfullnameCreateInput>;
  /** Actions for the "Photo.Metadata_Type" relation: "MetadataType.photo"'s inverse relation */
  Metadata_Type?: InputMaybe<PhotoNestedMetadataTypeCreateInput>;
  /** Actions for the "Photo.Metadata_Undersubject" relation: "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject?: InputMaybe<PhotoNestedMetadataUndersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_UnderUnderSubject" relation: "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject?: InputMaybe<PhotoNestedMetadataUnderundersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_UploadedBy" relation: "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy?: InputMaybe<PhotoNestedMetadataUploadedbyCreateInput>;
  /** Actions for the "Photo.Metadata_UploadedByFullName" relation: "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName?: InputMaybe<PhotoNestedMetadataUploadedbyfullnameCreateInput>;
  /** Actions for the "Photo.Metadata_UploadTime" relation: "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime?: InputMaybe<PhotoNestedMetadataUploadtimeCreateInput>;
  /** Actions for the "Photo.Metadata_Urgency" relation: "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency?: InputMaybe<PhotoNestedMetadataUrgencyCreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined195" relation: "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195?: InputMaybe<PhotoNestedMetadataUserdefined195CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined237" relation: "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237?: InputMaybe<PhotoNestedMetadataUserdefined237CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined238" relation: "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238?: InputMaybe<PhotoNestedMetadataUserdefined238CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined239" relation: "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239?: InputMaybe<PhotoNestedMetadataUserdefined239CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined242" relation: "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242?: InputMaybe<PhotoNestedMetadataUserdefined242CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined62" relation: "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62?: InputMaybe<PhotoNestedMetadataUserdefined62CreateInput>;
  /** Actions for the "Photo.Metadata_WorkflowKind" relation: "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind?: InputMaybe<PhotoNestedMetadataWorkflowkindCreateInput>;
  /** Actions for the "Photo.Metadata_XMPHistory" relation: "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory?: InputMaybe<PhotoNestedMetadataXmphistoryCreateInput>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.photoMetadatas" relation: "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas?: InputMaybe<PhotoNestedPhotoMetadatasCreateInput>;
  /** Actions for the "Photo.photoPublications" relation: "PhotoPublication.photo"'s inverse relation */
  photoPublications?: InputMaybe<PhotoNestedPhotoPublicationsCreateInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the photo's capture */
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoWithForcedArchiveUpdateInput = {
  /** Actions for the "Photo.agency" relation */
  agency?: InputMaybe<PhotoNestedAgencyUpdateInput>;
  /** Actions for the "Photo.category" relation */
  category?: InputMaybe<PhotoNestedCategoryUpdateInput>;
  /** asset content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.deliverySubject" relation */
  deliverySubject?: InputMaybe<PhotoNestedDeliverySubjectUpdateInput>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The date of the photo's importation */
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Photo.importQueue" relation: "ImportQueue.photo"'s inverse relation */
  importQueue?: InputMaybe<PhotoNestedImportQueueUpdateInput>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Photo.Metadata_AccessRights" relation: "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights?: InputMaybe<PhotoNestedMetadataAccessrightsUpdateInput>;
  /** Actions for the "Photo.Metadata_AssetState" relation: "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState?: InputMaybe<PhotoNestedMetadataAssetstateUpdateInput>;
  /** Actions for the "Photo.Metadata_BackupName" relation: "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName?: InputMaybe<PhotoNestedMetadataBackupnameUpdateInput>;
  /** Actions for the "Photo.Metadata_Brand" relation: "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand?: InputMaybe<PhotoNestedMetadataBrandUpdateInput>;
  /** Actions for the "Photo.Metadata_BrandPrisma" relation: "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma?: InputMaybe<PhotoNestedMetadataBrandprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_BrandShortName" relation: "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName?: InputMaybe<PhotoNestedMetadataBrandshortnameUpdateInput>;
  /** Actions for the "Photo.Metadata_By_line" relation: "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line?: InputMaybe<PhotoNestedMetadataByLineUpdateInput>;
  /** Actions for the "Photo.Metadata_Caption" relation: "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption?: InputMaybe<PhotoNestedMetadataCaptionUpdateInput>;
  /** Actions for the "Photo.Metadata_Caption_Abstract" relation: "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract?: InputMaybe<PhotoNestedMetadataCaptionAbstractUpdateInput>;
  /** Actions for the "Photo.Metadata_Category" relation: "MetadataCategory.photo"'s inverse relation */
  Metadata_Category?: InputMaybe<PhotoNestedMetadataCategoryUpdateInput>;
  /** Actions for the "Photo.Metadata_CategoryPrisma" relation: "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma?: InputMaybe<PhotoNestedMetadataCategoryprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_Company" relation: "MetadataCompany.photo"'s inverse relation */
  Metadata_Company?: InputMaybe<PhotoNestedMetadataCompanyUpdateInput>;
  /** Actions for the "Photo.Metadata_CompanyShortName" relation: "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName?: InputMaybe<PhotoNestedMetadataCompanyshortnameUpdateInput>;
  /** Actions for the "Photo.Metadata_CopyrightNotice" relation: "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice?: InputMaybe<PhotoNestedMetadataCopyrightnoticeUpdateInput>;
  /** Actions for the "Photo.Metadata_creator" relation: "MetadataCreator.photo"'s inverse relation */
  Metadata_creator?: InputMaybe<PhotoNestedMetadataCreatorUpdateInput>;
  /** Actions for the "Photo.Metadata_Credit" relation: "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit?: InputMaybe<PhotoNestedMetadataCreditUpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField1" relation: "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1?: InputMaybe<PhotoNestedMetadataCustomfield1UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField14" relation: "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14?: InputMaybe<PhotoNestedMetadataCustomfield14UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField15" relation: "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15?: InputMaybe<PhotoNestedMetadataCustomfield15UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField16" relation: "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16?: InputMaybe<PhotoNestedMetadataCustomfield16UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField17" relation: "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17?: InputMaybe<PhotoNestedMetadataCustomfield17UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField20" relation: "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20?: InputMaybe<PhotoNestedMetadataCustomfield20UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField3" relation: "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3?: InputMaybe<PhotoNestedMetadataCustomfield3UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField4" relation: "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4?: InputMaybe<PhotoNestedMetadataCustomfield4UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField5" relation: "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5?: InputMaybe<PhotoNestedMetadataCustomfield5UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField6" relation: "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6?: InputMaybe<PhotoNestedMetadataCustomfield6UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField7" relation: "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7?: InputMaybe<PhotoNestedMetadataCustomfield7UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField9" relation: "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9?: InputMaybe<PhotoNestedMetadataCustomfield9UpdateInput>;
  /** Actions for the "Photo.Metadata_DateCreated" relation: "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated?: InputMaybe<PhotoNestedMetadataDatecreatedUpdateInput>;
  /** Actions for the "Photo.Metadata_DateTimeOriginal" relation: "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal?: InputMaybe<PhotoNestedMetadataDatetimeoriginalUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryAccount" relation: "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount?: InputMaybe<PhotoNestedMetadataDeliveryaccountUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCompany" relation: "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany?: InputMaybe<PhotoNestedMetadataDeliverycompanyUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCopyright" relation: "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright?: InputMaybe<PhotoNestedMetadataDeliverycopyrightUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateFolder" relation: "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder?: InputMaybe<PhotoNestedMetadataDeliverydatefolderUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateTime" relation: "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime?: InputMaybe<PhotoNestedMetadataDeliverydatetimeUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcCreator" relation: "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator?: InputMaybe<PhotoNestedMetadataDeliverydccreatorUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcRights" relation: "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights?: InputMaybe<PhotoNestedMetadataDeliverydcrightsUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryFolder" relation: "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder?: InputMaybe<PhotoNestedMetadataDeliveryfolderUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryKind" relation: "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind?: InputMaybe<PhotoNestedMetadataDeliverykindUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPath" relation: "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath?: InputMaybe<PhotoNestedMetadataDeliverypathUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopCredit" relation: "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopcreditUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopSource" relation: "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopsourceUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryService" relation: "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService?: InputMaybe<PhotoNestedMetadataDeliveryserviceUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliverySubject" relation: "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject?: InputMaybe<PhotoNestedMetadataDeliverysubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryUnderSubject" relation: "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject?: InputMaybe<PhotoNestedMetadataDeliveryundersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_Department" relation: "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department?: InputMaybe<PhotoNestedMetadataDepartmentUpdateInput>;
  /** Actions for the "Photo.Metadata_description" relation: "MetadataDescription.photo"'s inverse relation */
  Metadata_description?: InputMaybe<PhotoNestedMetadataDescriptionUpdateInput>;
  /** Actions for the "Photo.Metadata_Edition" relation: "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition?: InputMaybe<PhotoNestedMetadataEditionUpdateInput>;
  /** Actions for the "Photo.Metadata_EditStatus" relation: "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus?: InputMaybe<PhotoNestedMetadataEditstatusUpdateInput>;
  /** Actions for the "Photo.Metadata_FileStatus" relation: "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus?: InputMaybe<PhotoNestedMetadataFilestatusUpdateInput>;
  /** Actions for the "Photo.Metadata_Format" relation: "MetadataFormat.photo"'s inverse relation */
  Metadata_Format?: InputMaybe<PhotoNestedMetadataFormatUpdateInput>;
  /** Actions for the "Photo.Metadata_Header" relation: "MetadataHeader.photo"'s inverse relation */
  Metadata_Header?: InputMaybe<PhotoNestedMetadataHeaderUpdateInput>;
  /** Actions for the "Photo.Metadata_HeaderPrisma" relation: "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma?: InputMaybe<PhotoNestedMetadataHeaderprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_Headline" relation: "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline?: InputMaybe<PhotoNestedMetadataHeadlineUpdateInput>;
  /** Actions for the "Photo.Metadata_ID_subject" relation: "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject?: InputMaybe<PhotoNestedMetadataIdSubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_IdAssignment" relation: "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment?: InputMaybe<PhotoNestedMetadataIdassignmentUpdateInput>;
  /** Actions for the "Photo.Metadata_IdPhotoPrisma" relation: "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma?: InputMaybe<PhotoNestedMetadataIdphotoprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_ImageNotes" relation: "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes?: InputMaybe<PhotoNestedMetadataImagenotesUpdateInput>;
  /** Actions for the "Photo.Metadata_Instructions" relation: "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions?: InputMaybe<PhotoNestedMetadataInstructionsUpdateInput>;
  /** Actions for the "Photo.Metadata_Issue" relation: "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue?: InputMaybe<PhotoNestedMetadataIssueUpdateInput>;
  /** Actions for the "Photo.Metadata_Keywords" relation: "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords?: InputMaybe<PhotoNestedMetadataKeywordsUpdateInput>;
  /** Actions for the "Photo.Metadata_ObjectName" relation: "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName?: InputMaybe<PhotoNestedMetadataObjectnameUpdateInput>;
  /** Actions for the "Photo.Metadata_OriginalName" relation: "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName?: InputMaybe<PhotoNestedMetadataOriginalnameUpdateInput>;
  /** Actions for the "Photo.Metadata_PriceLevel" relation: "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel?: InputMaybe<PhotoNestedMetadataPricelevelUpdateInput>;
  /** Actions for the "Photo.Metadata_ProcessHistory" relation: "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory?: InputMaybe<PhotoNestedMetadataProcesshistoryUpdateInput>;
  /** Actions for the "Photo.Metadata_ProcessStatus" relation: "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus?: InputMaybe<PhotoNestedMetadataProcessstatusUpdateInput>;
  /** Actions for the "Photo.Metadata_Product" relation: "MetadataProduct.photo"'s inverse relation */
  Metadata_Product?: InputMaybe<PhotoNestedMetadataProductUpdateInput>;
  /** Actions for the "Photo.Metadata_Products" relation: "MetadataProducts.photo"'s inverse relation */
  Metadata_Products?: InputMaybe<PhotoNestedMetadataProductsUpdateInput>;
  /** Actions for the "Photo.Metadata_publishingSubject" relation: "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject?: InputMaybe<PhotoNestedMetadataPublishingsubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_ResolutionKind" relation: "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind?: InputMaybe<PhotoNestedMetadataResolutionkindUpdateInput>;
  /** Actions for the "Photo.Metadata_rights" relation: "MetadataRights.photo"'s inverse relation */
  Metadata_rights?: InputMaybe<PhotoNestedMetadataRightsUpdateInput>;
  /** Actions for the "Photo.Metadata_Source" relation: "MetadataSource.photo"'s inverse relation */
  Metadata_Source?: InputMaybe<PhotoNestedMetadataSourceUpdateInput>;
  /** Actions for the "Photo.Metadata_SpecialInstructions" relation: "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions?: InputMaybe<PhotoNestedMetadataSpecialinstructionsUpdateInput>;
  /** Actions for the "Photo.Metadata_subject" relation: "MetadataSubject.photo"'s inverse relation */
  Metadata_subject?: InputMaybe<PhotoNestedMetadataSubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_SubjectCode" relation: "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode?: InputMaybe<PhotoNestedMetadataSubjectcodeUpdateInput>;
  /** Actions for the "Photo.Metadata_SubjectPrisma" relation: "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma?: InputMaybe<PhotoNestedMetadataSubjectprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_title" relation: "MetadataTitle.photo"'s inverse relation */
  Metadata_title?: InputMaybe<PhotoNestedMetadataTitleUpdateInput>;
  /** Actions for the "Photo.Metadata_TransferredBy" relation: "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy?: InputMaybe<PhotoNestedMetadataTransferredbyUpdateInput>;
  /** Actions for the "Photo.Metadata_TransferredByFullName" relation: "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName?: InputMaybe<PhotoNestedMetadataTransferredbyfullnameUpdateInput>;
  /** Actions for the "Photo.Metadata_Type" relation: "MetadataType.photo"'s inverse relation */
  Metadata_Type?: InputMaybe<PhotoNestedMetadataTypeUpdateInput>;
  /** Actions for the "Photo.Metadata_Undersubject" relation: "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject?: InputMaybe<PhotoNestedMetadataUndersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_UnderUnderSubject" relation: "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject?: InputMaybe<PhotoNestedMetadataUnderundersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadedBy" relation: "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy?: InputMaybe<PhotoNestedMetadataUploadedbyUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadedByFullName" relation: "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName?: InputMaybe<PhotoNestedMetadataUploadedbyfullnameUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadTime" relation: "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime?: InputMaybe<PhotoNestedMetadataUploadtimeUpdateInput>;
  /** Actions for the "Photo.Metadata_Urgency" relation: "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency?: InputMaybe<PhotoNestedMetadataUrgencyUpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined195" relation: "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195?: InputMaybe<PhotoNestedMetadataUserdefined195UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined237" relation: "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237?: InputMaybe<PhotoNestedMetadataUserdefined237UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined238" relation: "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238?: InputMaybe<PhotoNestedMetadataUserdefined238UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined239" relation: "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239?: InputMaybe<PhotoNestedMetadataUserdefined239UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined242" relation: "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242?: InputMaybe<PhotoNestedMetadataUserdefined242UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined62" relation: "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62?: InputMaybe<PhotoNestedMetadataUserdefined62UpdateInput>;
  /** Actions for the "Photo.Metadata_WorkflowKind" relation: "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind?: InputMaybe<PhotoNestedMetadataWorkflowkindUpdateInput>;
  /** Actions for the "Photo.Metadata_XMPHistory" relation: "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory?: InputMaybe<PhotoNestedMetadataXmphistoryUpdateInput>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.photoMetadatas" relation: "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas?: InputMaybe<PhotoNestedPhotoMetadatasUpdateInput>;
  /** Actions for the "Photo.photoPublications" relation: "PhotoPublication.photo"'s inverse relation */
  photoPublications?: InputMaybe<PhotoNestedPhotoPublicationsUpdateInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the photo's capture */
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoWithForcedCategoryCreateInput = {
  /** Actions for the "Photo.agency" relation */
  agency?: InputMaybe<PhotoNestedAgencyCreateInput>;
  /** Actions for the "Photo.archive" relation */
  archive: PhotoNestedArchiveCreateInput;
  /** asset content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.deliverySubject" relation */
  deliverySubject?: InputMaybe<PhotoNestedDeliverySubjectCreateInput>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The date of the photo's importation */
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Photo.importQueue" relation: "ImportQueue.photo"'s inverse relation */
  importQueue?: InputMaybe<PhotoNestedImportQueueCreateInput>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Photo.Metadata_AccessRights" relation: "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights?: InputMaybe<PhotoNestedMetadataAccessrightsCreateInput>;
  /** Actions for the "Photo.Metadata_AssetState" relation: "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState?: InputMaybe<PhotoNestedMetadataAssetstateCreateInput>;
  /** Actions for the "Photo.Metadata_BackupName" relation: "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName?: InputMaybe<PhotoNestedMetadataBackupnameCreateInput>;
  /** Actions for the "Photo.Metadata_Brand" relation: "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand?: InputMaybe<PhotoNestedMetadataBrandCreateInput>;
  /** Actions for the "Photo.Metadata_BrandPrisma" relation: "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma?: InputMaybe<PhotoNestedMetadataBrandprismaCreateInput>;
  /** Actions for the "Photo.Metadata_BrandShortName" relation: "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName?: InputMaybe<PhotoNestedMetadataBrandshortnameCreateInput>;
  /** Actions for the "Photo.Metadata_By_line" relation: "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line?: InputMaybe<PhotoNestedMetadataByLineCreateInput>;
  /** Actions for the "Photo.Metadata_Caption" relation: "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption?: InputMaybe<PhotoNestedMetadataCaptionCreateInput>;
  /** Actions for the "Photo.Metadata_Caption_Abstract" relation: "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract?: InputMaybe<PhotoNestedMetadataCaptionAbstractCreateInput>;
  /** Actions for the "Photo.Metadata_Category" relation: "MetadataCategory.photo"'s inverse relation */
  Metadata_Category?: InputMaybe<PhotoNestedMetadataCategoryCreateInput>;
  /** Actions for the "Photo.Metadata_CategoryPrisma" relation: "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma?: InputMaybe<PhotoNestedMetadataCategoryprismaCreateInput>;
  /** Actions for the "Photo.Metadata_Company" relation: "MetadataCompany.photo"'s inverse relation */
  Metadata_Company?: InputMaybe<PhotoNestedMetadataCompanyCreateInput>;
  /** Actions for the "Photo.Metadata_CompanyShortName" relation: "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName?: InputMaybe<PhotoNestedMetadataCompanyshortnameCreateInput>;
  /** Actions for the "Photo.Metadata_CopyrightNotice" relation: "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice?: InputMaybe<PhotoNestedMetadataCopyrightnoticeCreateInput>;
  /** Actions for the "Photo.Metadata_creator" relation: "MetadataCreator.photo"'s inverse relation */
  Metadata_creator?: InputMaybe<PhotoNestedMetadataCreatorCreateInput>;
  /** Actions for the "Photo.Metadata_Credit" relation: "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit?: InputMaybe<PhotoNestedMetadataCreditCreateInput>;
  /** Actions for the "Photo.Metadata_CustomField1" relation: "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1?: InputMaybe<PhotoNestedMetadataCustomfield1CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField14" relation: "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14?: InputMaybe<PhotoNestedMetadataCustomfield14CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField15" relation: "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15?: InputMaybe<PhotoNestedMetadataCustomfield15CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField16" relation: "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16?: InputMaybe<PhotoNestedMetadataCustomfield16CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField17" relation: "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17?: InputMaybe<PhotoNestedMetadataCustomfield17CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField20" relation: "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20?: InputMaybe<PhotoNestedMetadataCustomfield20CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField3" relation: "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3?: InputMaybe<PhotoNestedMetadataCustomfield3CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField4" relation: "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4?: InputMaybe<PhotoNestedMetadataCustomfield4CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField5" relation: "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5?: InputMaybe<PhotoNestedMetadataCustomfield5CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField6" relation: "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6?: InputMaybe<PhotoNestedMetadataCustomfield6CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField7" relation: "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7?: InputMaybe<PhotoNestedMetadataCustomfield7CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField9" relation: "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9?: InputMaybe<PhotoNestedMetadataCustomfield9CreateInput>;
  /** Actions for the "Photo.Metadata_DateCreated" relation: "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated?: InputMaybe<PhotoNestedMetadataDatecreatedCreateInput>;
  /** Actions for the "Photo.Metadata_DateTimeOriginal" relation: "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal?: InputMaybe<PhotoNestedMetadataDatetimeoriginalCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryAccount" relation: "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount?: InputMaybe<PhotoNestedMetadataDeliveryaccountCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCompany" relation: "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany?: InputMaybe<PhotoNestedMetadataDeliverycompanyCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCopyright" relation: "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright?: InputMaybe<PhotoNestedMetadataDeliverycopyrightCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateFolder" relation: "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder?: InputMaybe<PhotoNestedMetadataDeliverydatefolderCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateTime" relation: "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime?: InputMaybe<PhotoNestedMetadataDeliverydatetimeCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcCreator" relation: "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator?: InputMaybe<PhotoNestedMetadataDeliverydccreatorCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcRights" relation: "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights?: InputMaybe<PhotoNestedMetadataDeliverydcrightsCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryFolder" relation: "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder?: InputMaybe<PhotoNestedMetadataDeliveryfolderCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryKind" relation: "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind?: InputMaybe<PhotoNestedMetadataDeliverykindCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPath" relation: "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath?: InputMaybe<PhotoNestedMetadataDeliverypathCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopCredit" relation: "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopcreditCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopSource" relation: "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopsourceCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryService" relation: "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService?: InputMaybe<PhotoNestedMetadataDeliveryserviceCreateInput>;
  /** Actions for the "Photo.Metadata_DeliverySubject" relation: "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject?: InputMaybe<PhotoNestedMetadataDeliverysubjectCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryUnderSubject" relation: "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject?: InputMaybe<PhotoNestedMetadataDeliveryundersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_Department" relation: "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department?: InputMaybe<PhotoNestedMetadataDepartmentCreateInput>;
  /** Actions for the "Photo.Metadata_description" relation: "MetadataDescription.photo"'s inverse relation */
  Metadata_description?: InputMaybe<PhotoNestedMetadataDescriptionCreateInput>;
  /** Actions for the "Photo.Metadata_Edition" relation: "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition?: InputMaybe<PhotoNestedMetadataEditionCreateInput>;
  /** Actions for the "Photo.Metadata_EditStatus" relation: "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus?: InputMaybe<PhotoNestedMetadataEditstatusCreateInput>;
  /** Actions for the "Photo.Metadata_FileStatus" relation: "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus?: InputMaybe<PhotoNestedMetadataFilestatusCreateInput>;
  /** Actions for the "Photo.Metadata_Format" relation: "MetadataFormat.photo"'s inverse relation */
  Metadata_Format?: InputMaybe<PhotoNestedMetadataFormatCreateInput>;
  /** Actions for the "Photo.Metadata_Header" relation: "MetadataHeader.photo"'s inverse relation */
  Metadata_Header?: InputMaybe<PhotoNestedMetadataHeaderCreateInput>;
  /** Actions for the "Photo.Metadata_HeaderPrisma" relation: "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma?: InputMaybe<PhotoNestedMetadataHeaderprismaCreateInput>;
  /** Actions for the "Photo.Metadata_Headline" relation: "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline?: InputMaybe<PhotoNestedMetadataHeadlineCreateInput>;
  /** Actions for the "Photo.Metadata_ID_subject" relation: "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject?: InputMaybe<PhotoNestedMetadataIdSubjectCreateInput>;
  /** Actions for the "Photo.Metadata_IdAssignment" relation: "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment?: InputMaybe<PhotoNestedMetadataIdassignmentCreateInput>;
  /** Actions for the "Photo.Metadata_IdPhotoPrisma" relation: "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma?: InputMaybe<PhotoNestedMetadataIdphotoprismaCreateInput>;
  /** Actions for the "Photo.Metadata_ImageNotes" relation: "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes?: InputMaybe<PhotoNestedMetadataImagenotesCreateInput>;
  /** Actions for the "Photo.Metadata_Instructions" relation: "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions?: InputMaybe<PhotoNestedMetadataInstructionsCreateInput>;
  /** Actions for the "Photo.Metadata_Issue" relation: "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue?: InputMaybe<PhotoNestedMetadataIssueCreateInput>;
  /** Actions for the "Photo.Metadata_Keywords" relation: "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords?: InputMaybe<PhotoNestedMetadataKeywordsCreateInput>;
  /** Actions for the "Photo.Metadata_ObjectName" relation: "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName?: InputMaybe<PhotoNestedMetadataObjectnameCreateInput>;
  /** Actions for the "Photo.Metadata_OriginalName" relation: "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName?: InputMaybe<PhotoNestedMetadataOriginalnameCreateInput>;
  /** Actions for the "Photo.Metadata_PriceLevel" relation: "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel?: InputMaybe<PhotoNestedMetadataPricelevelCreateInput>;
  /** Actions for the "Photo.Metadata_ProcessHistory" relation: "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory?: InputMaybe<PhotoNestedMetadataProcesshistoryCreateInput>;
  /** Actions for the "Photo.Metadata_ProcessStatus" relation: "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus?: InputMaybe<PhotoNestedMetadataProcessstatusCreateInput>;
  /** Actions for the "Photo.Metadata_Product" relation: "MetadataProduct.photo"'s inverse relation */
  Metadata_Product?: InputMaybe<PhotoNestedMetadataProductCreateInput>;
  /** Actions for the "Photo.Metadata_Products" relation: "MetadataProducts.photo"'s inverse relation */
  Metadata_Products?: InputMaybe<PhotoNestedMetadataProductsCreateInput>;
  /** Actions for the "Photo.Metadata_publishingSubject" relation: "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject?: InputMaybe<PhotoNestedMetadataPublishingsubjectCreateInput>;
  /** Actions for the "Photo.Metadata_ResolutionKind" relation: "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind?: InputMaybe<PhotoNestedMetadataResolutionkindCreateInput>;
  /** Actions for the "Photo.Metadata_rights" relation: "MetadataRights.photo"'s inverse relation */
  Metadata_rights?: InputMaybe<PhotoNestedMetadataRightsCreateInput>;
  /** Actions for the "Photo.Metadata_Source" relation: "MetadataSource.photo"'s inverse relation */
  Metadata_Source?: InputMaybe<PhotoNestedMetadataSourceCreateInput>;
  /** Actions for the "Photo.Metadata_SpecialInstructions" relation: "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions?: InputMaybe<PhotoNestedMetadataSpecialinstructionsCreateInput>;
  /** Actions for the "Photo.Metadata_subject" relation: "MetadataSubject.photo"'s inverse relation */
  Metadata_subject?: InputMaybe<PhotoNestedMetadataSubjectCreateInput>;
  /** Actions for the "Photo.Metadata_SubjectCode" relation: "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode?: InputMaybe<PhotoNestedMetadataSubjectcodeCreateInput>;
  /** Actions for the "Photo.Metadata_SubjectPrisma" relation: "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma?: InputMaybe<PhotoNestedMetadataSubjectprismaCreateInput>;
  /** Actions for the "Photo.Metadata_title" relation: "MetadataTitle.photo"'s inverse relation */
  Metadata_title?: InputMaybe<PhotoNestedMetadataTitleCreateInput>;
  /** Actions for the "Photo.Metadata_TransferredBy" relation: "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy?: InputMaybe<PhotoNestedMetadataTransferredbyCreateInput>;
  /** Actions for the "Photo.Metadata_TransferredByFullName" relation: "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName?: InputMaybe<PhotoNestedMetadataTransferredbyfullnameCreateInput>;
  /** Actions for the "Photo.Metadata_Type" relation: "MetadataType.photo"'s inverse relation */
  Metadata_Type?: InputMaybe<PhotoNestedMetadataTypeCreateInput>;
  /** Actions for the "Photo.Metadata_Undersubject" relation: "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject?: InputMaybe<PhotoNestedMetadataUndersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_UnderUnderSubject" relation: "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject?: InputMaybe<PhotoNestedMetadataUnderundersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_UploadedBy" relation: "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy?: InputMaybe<PhotoNestedMetadataUploadedbyCreateInput>;
  /** Actions for the "Photo.Metadata_UploadedByFullName" relation: "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName?: InputMaybe<PhotoNestedMetadataUploadedbyfullnameCreateInput>;
  /** Actions for the "Photo.Metadata_UploadTime" relation: "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime?: InputMaybe<PhotoNestedMetadataUploadtimeCreateInput>;
  /** Actions for the "Photo.Metadata_Urgency" relation: "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency?: InputMaybe<PhotoNestedMetadataUrgencyCreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined195" relation: "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195?: InputMaybe<PhotoNestedMetadataUserdefined195CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined237" relation: "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237?: InputMaybe<PhotoNestedMetadataUserdefined237CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined238" relation: "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238?: InputMaybe<PhotoNestedMetadataUserdefined238CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined239" relation: "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239?: InputMaybe<PhotoNestedMetadataUserdefined239CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined242" relation: "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242?: InputMaybe<PhotoNestedMetadataUserdefined242CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined62" relation: "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62?: InputMaybe<PhotoNestedMetadataUserdefined62CreateInput>;
  /** Actions for the "Photo.Metadata_WorkflowKind" relation: "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind?: InputMaybe<PhotoNestedMetadataWorkflowkindCreateInput>;
  /** Actions for the "Photo.Metadata_XMPHistory" relation: "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory?: InputMaybe<PhotoNestedMetadataXmphistoryCreateInput>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.photoMetadatas" relation: "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas?: InputMaybe<PhotoNestedPhotoMetadatasCreateInput>;
  /** Actions for the "Photo.photoPublications" relation: "PhotoPublication.photo"'s inverse relation */
  photoPublications?: InputMaybe<PhotoNestedPhotoPublicationsCreateInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the photo's capture */
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoWithForcedCategoryUpdateInput = {
  /** Actions for the "Photo.agency" relation */
  agency?: InputMaybe<PhotoNestedAgencyUpdateInput>;
  /** Actions for the "Photo.archive" relation */
  archive?: InputMaybe<PhotoNestedArchiveUpdateInput>;
  /** asset content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.deliverySubject" relation */
  deliverySubject?: InputMaybe<PhotoNestedDeliverySubjectUpdateInput>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The date of the photo's importation */
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Photo.importQueue" relation: "ImportQueue.photo"'s inverse relation */
  importQueue?: InputMaybe<PhotoNestedImportQueueUpdateInput>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Photo.Metadata_AccessRights" relation: "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights?: InputMaybe<PhotoNestedMetadataAccessrightsUpdateInput>;
  /** Actions for the "Photo.Metadata_AssetState" relation: "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState?: InputMaybe<PhotoNestedMetadataAssetstateUpdateInput>;
  /** Actions for the "Photo.Metadata_BackupName" relation: "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName?: InputMaybe<PhotoNestedMetadataBackupnameUpdateInput>;
  /** Actions for the "Photo.Metadata_Brand" relation: "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand?: InputMaybe<PhotoNestedMetadataBrandUpdateInput>;
  /** Actions for the "Photo.Metadata_BrandPrisma" relation: "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma?: InputMaybe<PhotoNestedMetadataBrandprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_BrandShortName" relation: "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName?: InputMaybe<PhotoNestedMetadataBrandshortnameUpdateInput>;
  /** Actions for the "Photo.Metadata_By_line" relation: "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line?: InputMaybe<PhotoNestedMetadataByLineUpdateInput>;
  /** Actions for the "Photo.Metadata_Caption" relation: "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption?: InputMaybe<PhotoNestedMetadataCaptionUpdateInput>;
  /** Actions for the "Photo.Metadata_Caption_Abstract" relation: "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract?: InputMaybe<PhotoNestedMetadataCaptionAbstractUpdateInput>;
  /** Actions for the "Photo.Metadata_Category" relation: "MetadataCategory.photo"'s inverse relation */
  Metadata_Category?: InputMaybe<PhotoNestedMetadataCategoryUpdateInput>;
  /** Actions for the "Photo.Metadata_CategoryPrisma" relation: "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma?: InputMaybe<PhotoNestedMetadataCategoryprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_Company" relation: "MetadataCompany.photo"'s inverse relation */
  Metadata_Company?: InputMaybe<PhotoNestedMetadataCompanyUpdateInput>;
  /** Actions for the "Photo.Metadata_CompanyShortName" relation: "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName?: InputMaybe<PhotoNestedMetadataCompanyshortnameUpdateInput>;
  /** Actions for the "Photo.Metadata_CopyrightNotice" relation: "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice?: InputMaybe<PhotoNestedMetadataCopyrightnoticeUpdateInput>;
  /** Actions for the "Photo.Metadata_creator" relation: "MetadataCreator.photo"'s inverse relation */
  Metadata_creator?: InputMaybe<PhotoNestedMetadataCreatorUpdateInput>;
  /** Actions for the "Photo.Metadata_Credit" relation: "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit?: InputMaybe<PhotoNestedMetadataCreditUpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField1" relation: "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1?: InputMaybe<PhotoNestedMetadataCustomfield1UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField14" relation: "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14?: InputMaybe<PhotoNestedMetadataCustomfield14UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField15" relation: "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15?: InputMaybe<PhotoNestedMetadataCustomfield15UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField16" relation: "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16?: InputMaybe<PhotoNestedMetadataCustomfield16UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField17" relation: "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17?: InputMaybe<PhotoNestedMetadataCustomfield17UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField20" relation: "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20?: InputMaybe<PhotoNestedMetadataCustomfield20UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField3" relation: "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3?: InputMaybe<PhotoNestedMetadataCustomfield3UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField4" relation: "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4?: InputMaybe<PhotoNestedMetadataCustomfield4UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField5" relation: "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5?: InputMaybe<PhotoNestedMetadataCustomfield5UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField6" relation: "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6?: InputMaybe<PhotoNestedMetadataCustomfield6UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField7" relation: "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7?: InputMaybe<PhotoNestedMetadataCustomfield7UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField9" relation: "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9?: InputMaybe<PhotoNestedMetadataCustomfield9UpdateInput>;
  /** Actions for the "Photo.Metadata_DateCreated" relation: "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated?: InputMaybe<PhotoNestedMetadataDatecreatedUpdateInput>;
  /** Actions for the "Photo.Metadata_DateTimeOriginal" relation: "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal?: InputMaybe<PhotoNestedMetadataDatetimeoriginalUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryAccount" relation: "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount?: InputMaybe<PhotoNestedMetadataDeliveryaccountUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCompany" relation: "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany?: InputMaybe<PhotoNestedMetadataDeliverycompanyUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCopyright" relation: "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright?: InputMaybe<PhotoNestedMetadataDeliverycopyrightUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateFolder" relation: "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder?: InputMaybe<PhotoNestedMetadataDeliverydatefolderUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateTime" relation: "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime?: InputMaybe<PhotoNestedMetadataDeliverydatetimeUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcCreator" relation: "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator?: InputMaybe<PhotoNestedMetadataDeliverydccreatorUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcRights" relation: "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights?: InputMaybe<PhotoNestedMetadataDeliverydcrightsUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryFolder" relation: "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder?: InputMaybe<PhotoNestedMetadataDeliveryfolderUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryKind" relation: "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind?: InputMaybe<PhotoNestedMetadataDeliverykindUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPath" relation: "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath?: InputMaybe<PhotoNestedMetadataDeliverypathUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopCredit" relation: "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopcreditUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopSource" relation: "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopsourceUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryService" relation: "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService?: InputMaybe<PhotoNestedMetadataDeliveryserviceUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliverySubject" relation: "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject?: InputMaybe<PhotoNestedMetadataDeliverysubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryUnderSubject" relation: "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject?: InputMaybe<PhotoNestedMetadataDeliveryundersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_Department" relation: "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department?: InputMaybe<PhotoNestedMetadataDepartmentUpdateInput>;
  /** Actions for the "Photo.Metadata_description" relation: "MetadataDescription.photo"'s inverse relation */
  Metadata_description?: InputMaybe<PhotoNestedMetadataDescriptionUpdateInput>;
  /** Actions for the "Photo.Metadata_Edition" relation: "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition?: InputMaybe<PhotoNestedMetadataEditionUpdateInput>;
  /** Actions for the "Photo.Metadata_EditStatus" relation: "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus?: InputMaybe<PhotoNestedMetadataEditstatusUpdateInput>;
  /** Actions for the "Photo.Metadata_FileStatus" relation: "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus?: InputMaybe<PhotoNestedMetadataFilestatusUpdateInput>;
  /** Actions for the "Photo.Metadata_Format" relation: "MetadataFormat.photo"'s inverse relation */
  Metadata_Format?: InputMaybe<PhotoNestedMetadataFormatUpdateInput>;
  /** Actions for the "Photo.Metadata_Header" relation: "MetadataHeader.photo"'s inverse relation */
  Metadata_Header?: InputMaybe<PhotoNestedMetadataHeaderUpdateInput>;
  /** Actions for the "Photo.Metadata_HeaderPrisma" relation: "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma?: InputMaybe<PhotoNestedMetadataHeaderprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_Headline" relation: "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline?: InputMaybe<PhotoNestedMetadataHeadlineUpdateInput>;
  /** Actions for the "Photo.Metadata_ID_subject" relation: "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject?: InputMaybe<PhotoNestedMetadataIdSubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_IdAssignment" relation: "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment?: InputMaybe<PhotoNestedMetadataIdassignmentUpdateInput>;
  /** Actions for the "Photo.Metadata_IdPhotoPrisma" relation: "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma?: InputMaybe<PhotoNestedMetadataIdphotoprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_ImageNotes" relation: "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes?: InputMaybe<PhotoNestedMetadataImagenotesUpdateInput>;
  /** Actions for the "Photo.Metadata_Instructions" relation: "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions?: InputMaybe<PhotoNestedMetadataInstructionsUpdateInput>;
  /** Actions for the "Photo.Metadata_Issue" relation: "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue?: InputMaybe<PhotoNestedMetadataIssueUpdateInput>;
  /** Actions for the "Photo.Metadata_Keywords" relation: "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords?: InputMaybe<PhotoNestedMetadataKeywordsUpdateInput>;
  /** Actions for the "Photo.Metadata_ObjectName" relation: "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName?: InputMaybe<PhotoNestedMetadataObjectnameUpdateInput>;
  /** Actions for the "Photo.Metadata_OriginalName" relation: "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName?: InputMaybe<PhotoNestedMetadataOriginalnameUpdateInput>;
  /** Actions for the "Photo.Metadata_PriceLevel" relation: "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel?: InputMaybe<PhotoNestedMetadataPricelevelUpdateInput>;
  /** Actions for the "Photo.Metadata_ProcessHistory" relation: "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory?: InputMaybe<PhotoNestedMetadataProcesshistoryUpdateInput>;
  /** Actions for the "Photo.Metadata_ProcessStatus" relation: "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus?: InputMaybe<PhotoNestedMetadataProcessstatusUpdateInput>;
  /** Actions for the "Photo.Metadata_Product" relation: "MetadataProduct.photo"'s inverse relation */
  Metadata_Product?: InputMaybe<PhotoNestedMetadataProductUpdateInput>;
  /** Actions for the "Photo.Metadata_Products" relation: "MetadataProducts.photo"'s inverse relation */
  Metadata_Products?: InputMaybe<PhotoNestedMetadataProductsUpdateInput>;
  /** Actions for the "Photo.Metadata_publishingSubject" relation: "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject?: InputMaybe<PhotoNestedMetadataPublishingsubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_ResolutionKind" relation: "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind?: InputMaybe<PhotoNestedMetadataResolutionkindUpdateInput>;
  /** Actions for the "Photo.Metadata_rights" relation: "MetadataRights.photo"'s inverse relation */
  Metadata_rights?: InputMaybe<PhotoNestedMetadataRightsUpdateInput>;
  /** Actions for the "Photo.Metadata_Source" relation: "MetadataSource.photo"'s inverse relation */
  Metadata_Source?: InputMaybe<PhotoNestedMetadataSourceUpdateInput>;
  /** Actions for the "Photo.Metadata_SpecialInstructions" relation: "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions?: InputMaybe<PhotoNestedMetadataSpecialinstructionsUpdateInput>;
  /** Actions for the "Photo.Metadata_subject" relation: "MetadataSubject.photo"'s inverse relation */
  Metadata_subject?: InputMaybe<PhotoNestedMetadataSubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_SubjectCode" relation: "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode?: InputMaybe<PhotoNestedMetadataSubjectcodeUpdateInput>;
  /** Actions for the "Photo.Metadata_SubjectPrisma" relation: "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma?: InputMaybe<PhotoNestedMetadataSubjectprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_title" relation: "MetadataTitle.photo"'s inverse relation */
  Metadata_title?: InputMaybe<PhotoNestedMetadataTitleUpdateInput>;
  /** Actions for the "Photo.Metadata_TransferredBy" relation: "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy?: InputMaybe<PhotoNestedMetadataTransferredbyUpdateInput>;
  /** Actions for the "Photo.Metadata_TransferredByFullName" relation: "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName?: InputMaybe<PhotoNestedMetadataTransferredbyfullnameUpdateInput>;
  /** Actions for the "Photo.Metadata_Type" relation: "MetadataType.photo"'s inverse relation */
  Metadata_Type?: InputMaybe<PhotoNestedMetadataTypeUpdateInput>;
  /** Actions for the "Photo.Metadata_Undersubject" relation: "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject?: InputMaybe<PhotoNestedMetadataUndersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_UnderUnderSubject" relation: "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject?: InputMaybe<PhotoNestedMetadataUnderundersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadedBy" relation: "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy?: InputMaybe<PhotoNestedMetadataUploadedbyUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadedByFullName" relation: "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName?: InputMaybe<PhotoNestedMetadataUploadedbyfullnameUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadTime" relation: "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime?: InputMaybe<PhotoNestedMetadataUploadtimeUpdateInput>;
  /** Actions for the "Photo.Metadata_Urgency" relation: "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency?: InputMaybe<PhotoNestedMetadataUrgencyUpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined195" relation: "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195?: InputMaybe<PhotoNestedMetadataUserdefined195UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined237" relation: "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237?: InputMaybe<PhotoNestedMetadataUserdefined237UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined238" relation: "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238?: InputMaybe<PhotoNestedMetadataUserdefined238UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined239" relation: "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239?: InputMaybe<PhotoNestedMetadataUserdefined239UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined242" relation: "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242?: InputMaybe<PhotoNestedMetadataUserdefined242UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined62" relation: "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62?: InputMaybe<PhotoNestedMetadataUserdefined62UpdateInput>;
  /** Actions for the "Photo.Metadata_WorkflowKind" relation: "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind?: InputMaybe<PhotoNestedMetadataWorkflowkindUpdateInput>;
  /** Actions for the "Photo.Metadata_XMPHistory" relation: "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory?: InputMaybe<PhotoNestedMetadataXmphistoryUpdateInput>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.photoMetadatas" relation: "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas?: InputMaybe<PhotoNestedPhotoMetadatasUpdateInput>;
  /** Actions for the "Photo.photoPublications" relation: "PhotoPublication.photo"'s inverse relation */
  photoPublications?: InputMaybe<PhotoNestedPhotoPublicationsUpdateInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the photo's capture */
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoWithForcedDeliverySubjectCreateInput = {
  /** Actions for the "Photo.agency" relation */
  agency?: InputMaybe<PhotoNestedAgencyCreateInput>;
  /** Actions for the "Photo.archive" relation */
  archive: PhotoNestedArchiveCreateInput;
  /** Actions for the "Photo.category" relation */
  category?: InputMaybe<PhotoNestedCategoryCreateInput>;
  /** asset content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The date of the photo's importation */
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Photo.importQueue" relation: "ImportQueue.photo"'s inverse relation */
  importQueue?: InputMaybe<PhotoNestedImportQueueCreateInput>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Photo.Metadata_AccessRights" relation: "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights?: InputMaybe<PhotoNestedMetadataAccessrightsCreateInput>;
  /** Actions for the "Photo.Metadata_AssetState" relation: "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState?: InputMaybe<PhotoNestedMetadataAssetstateCreateInput>;
  /** Actions for the "Photo.Metadata_BackupName" relation: "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName?: InputMaybe<PhotoNestedMetadataBackupnameCreateInput>;
  /** Actions for the "Photo.Metadata_Brand" relation: "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand?: InputMaybe<PhotoNestedMetadataBrandCreateInput>;
  /** Actions for the "Photo.Metadata_BrandPrisma" relation: "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma?: InputMaybe<PhotoNestedMetadataBrandprismaCreateInput>;
  /** Actions for the "Photo.Metadata_BrandShortName" relation: "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName?: InputMaybe<PhotoNestedMetadataBrandshortnameCreateInput>;
  /** Actions for the "Photo.Metadata_By_line" relation: "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line?: InputMaybe<PhotoNestedMetadataByLineCreateInput>;
  /** Actions for the "Photo.Metadata_Caption" relation: "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption?: InputMaybe<PhotoNestedMetadataCaptionCreateInput>;
  /** Actions for the "Photo.Metadata_Caption_Abstract" relation: "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract?: InputMaybe<PhotoNestedMetadataCaptionAbstractCreateInput>;
  /** Actions for the "Photo.Metadata_Category" relation: "MetadataCategory.photo"'s inverse relation */
  Metadata_Category?: InputMaybe<PhotoNestedMetadataCategoryCreateInput>;
  /** Actions for the "Photo.Metadata_CategoryPrisma" relation: "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma?: InputMaybe<PhotoNestedMetadataCategoryprismaCreateInput>;
  /** Actions for the "Photo.Metadata_Company" relation: "MetadataCompany.photo"'s inverse relation */
  Metadata_Company?: InputMaybe<PhotoNestedMetadataCompanyCreateInput>;
  /** Actions for the "Photo.Metadata_CompanyShortName" relation: "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName?: InputMaybe<PhotoNestedMetadataCompanyshortnameCreateInput>;
  /** Actions for the "Photo.Metadata_CopyrightNotice" relation: "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice?: InputMaybe<PhotoNestedMetadataCopyrightnoticeCreateInput>;
  /** Actions for the "Photo.Metadata_creator" relation: "MetadataCreator.photo"'s inverse relation */
  Metadata_creator?: InputMaybe<PhotoNestedMetadataCreatorCreateInput>;
  /** Actions for the "Photo.Metadata_Credit" relation: "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit?: InputMaybe<PhotoNestedMetadataCreditCreateInput>;
  /** Actions for the "Photo.Metadata_CustomField1" relation: "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1?: InputMaybe<PhotoNestedMetadataCustomfield1CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField14" relation: "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14?: InputMaybe<PhotoNestedMetadataCustomfield14CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField15" relation: "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15?: InputMaybe<PhotoNestedMetadataCustomfield15CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField16" relation: "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16?: InputMaybe<PhotoNestedMetadataCustomfield16CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField17" relation: "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17?: InputMaybe<PhotoNestedMetadataCustomfield17CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField20" relation: "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20?: InputMaybe<PhotoNestedMetadataCustomfield20CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField3" relation: "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3?: InputMaybe<PhotoNestedMetadataCustomfield3CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField4" relation: "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4?: InputMaybe<PhotoNestedMetadataCustomfield4CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField5" relation: "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5?: InputMaybe<PhotoNestedMetadataCustomfield5CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField6" relation: "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6?: InputMaybe<PhotoNestedMetadataCustomfield6CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField7" relation: "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7?: InputMaybe<PhotoNestedMetadataCustomfield7CreateInput>;
  /** Actions for the "Photo.Metadata_CustomField9" relation: "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9?: InputMaybe<PhotoNestedMetadataCustomfield9CreateInput>;
  /** Actions for the "Photo.Metadata_DateCreated" relation: "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated?: InputMaybe<PhotoNestedMetadataDatecreatedCreateInput>;
  /** Actions for the "Photo.Metadata_DateTimeOriginal" relation: "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal?: InputMaybe<PhotoNestedMetadataDatetimeoriginalCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryAccount" relation: "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount?: InputMaybe<PhotoNestedMetadataDeliveryaccountCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCompany" relation: "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany?: InputMaybe<PhotoNestedMetadataDeliverycompanyCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCopyright" relation: "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright?: InputMaybe<PhotoNestedMetadataDeliverycopyrightCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateFolder" relation: "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder?: InputMaybe<PhotoNestedMetadataDeliverydatefolderCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateTime" relation: "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime?: InputMaybe<PhotoNestedMetadataDeliverydatetimeCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcCreator" relation: "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator?: InputMaybe<PhotoNestedMetadataDeliverydccreatorCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcRights" relation: "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights?: InputMaybe<PhotoNestedMetadataDeliverydcrightsCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryFolder" relation: "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder?: InputMaybe<PhotoNestedMetadataDeliveryfolderCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryKind" relation: "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind?: InputMaybe<PhotoNestedMetadataDeliverykindCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPath" relation: "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath?: InputMaybe<PhotoNestedMetadataDeliverypathCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopCredit" relation: "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopcreditCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopSource" relation: "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopsourceCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryService" relation: "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService?: InputMaybe<PhotoNestedMetadataDeliveryserviceCreateInput>;
  /** Actions for the "Photo.Metadata_DeliverySubject" relation: "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject?: InputMaybe<PhotoNestedMetadataDeliverysubjectCreateInput>;
  /** Actions for the "Photo.Metadata_DeliveryUnderSubject" relation: "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject?: InputMaybe<PhotoNestedMetadataDeliveryundersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_Department" relation: "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department?: InputMaybe<PhotoNestedMetadataDepartmentCreateInput>;
  /** Actions for the "Photo.Metadata_description" relation: "MetadataDescription.photo"'s inverse relation */
  Metadata_description?: InputMaybe<PhotoNestedMetadataDescriptionCreateInput>;
  /** Actions for the "Photo.Metadata_Edition" relation: "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition?: InputMaybe<PhotoNestedMetadataEditionCreateInput>;
  /** Actions for the "Photo.Metadata_EditStatus" relation: "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus?: InputMaybe<PhotoNestedMetadataEditstatusCreateInput>;
  /** Actions for the "Photo.Metadata_FileStatus" relation: "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus?: InputMaybe<PhotoNestedMetadataFilestatusCreateInput>;
  /** Actions for the "Photo.Metadata_Format" relation: "MetadataFormat.photo"'s inverse relation */
  Metadata_Format?: InputMaybe<PhotoNestedMetadataFormatCreateInput>;
  /** Actions for the "Photo.Metadata_Header" relation: "MetadataHeader.photo"'s inverse relation */
  Metadata_Header?: InputMaybe<PhotoNestedMetadataHeaderCreateInput>;
  /** Actions for the "Photo.Metadata_HeaderPrisma" relation: "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma?: InputMaybe<PhotoNestedMetadataHeaderprismaCreateInput>;
  /** Actions for the "Photo.Metadata_Headline" relation: "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline?: InputMaybe<PhotoNestedMetadataHeadlineCreateInput>;
  /** Actions for the "Photo.Metadata_ID_subject" relation: "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject?: InputMaybe<PhotoNestedMetadataIdSubjectCreateInput>;
  /** Actions for the "Photo.Metadata_IdAssignment" relation: "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment?: InputMaybe<PhotoNestedMetadataIdassignmentCreateInput>;
  /** Actions for the "Photo.Metadata_IdPhotoPrisma" relation: "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma?: InputMaybe<PhotoNestedMetadataIdphotoprismaCreateInput>;
  /** Actions for the "Photo.Metadata_ImageNotes" relation: "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes?: InputMaybe<PhotoNestedMetadataImagenotesCreateInput>;
  /** Actions for the "Photo.Metadata_Instructions" relation: "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions?: InputMaybe<PhotoNestedMetadataInstructionsCreateInput>;
  /** Actions for the "Photo.Metadata_Issue" relation: "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue?: InputMaybe<PhotoNestedMetadataIssueCreateInput>;
  /** Actions for the "Photo.Metadata_Keywords" relation: "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords?: InputMaybe<PhotoNestedMetadataKeywordsCreateInput>;
  /** Actions for the "Photo.Metadata_ObjectName" relation: "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName?: InputMaybe<PhotoNestedMetadataObjectnameCreateInput>;
  /** Actions for the "Photo.Metadata_OriginalName" relation: "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName?: InputMaybe<PhotoNestedMetadataOriginalnameCreateInput>;
  /** Actions for the "Photo.Metadata_PriceLevel" relation: "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel?: InputMaybe<PhotoNestedMetadataPricelevelCreateInput>;
  /** Actions for the "Photo.Metadata_ProcessHistory" relation: "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory?: InputMaybe<PhotoNestedMetadataProcesshistoryCreateInput>;
  /** Actions for the "Photo.Metadata_ProcessStatus" relation: "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus?: InputMaybe<PhotoNestedMetadataProcessstatusCreateInput>;
  /** Actions for the "Photo.Metadata_Product" relation: "MetadataProduct.photo"'s inverse relation */
  Metadata_Product?: InputMaybe<PhotoNestedMetadataProductCreateInput>;
  /** Actions for the "Photo.Metadata_Products" relation: "MetadataProducts.photo"'s inverse relation */
  Metadata_Products?: InputMaybe<PhotoNestedMetadataProductsCreateInput>;
  /** Actions for the "Photo.Metadata_publishingSubject" relation: "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject?: InputMaybe<PhotoNestedMetadataPublishingsubjectCreateInput>;
  /** Actions for the "Photo.Metadata_ResolutionKind" relation: "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind?: InputMaybe<PhotoNestedMetadataResolutionkindCreateInput>;
  /** Actions for the "Photo.Metadata_rights" relation: "MetadataRights.photo"'s inverse relation */
  Metadata_rights?: InputMaybe<PhotoNestedMetadataRightsCreateInput>;
  /** Actions for the "Photo.Metadata_Source" relation: "MetadataSource.photo"'s inverse relation */
  Metadata_Source?: InputMaybe<PhotoNestedMetadataSourceCreateInput>;
  /** Actions for the "Photo.Metadata_SpecialInstructions" relation: "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions?: InputMaybe<PhotoNestedMetadataSpecialinstructionsCreateInput>;
  /** Actions for the "Photo.Metadata_subject" relation: "MetadataSubject.photo"'s inverse relation */
  Metadata_subject?: InputMaybe<PhotoNestedMetadataSubjectCreateInput>;
  /** Actions for the "Photo.Metadata_SubjectCode" relation: "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode?: InputMaybe<PhotoNestedMetadataSubjectcodeCreateInput>;
  /** Actions for the "Photo.Metadata_SubjectPrisma" relation: "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma?: InputMaybe<PhotoNestedMetadataSubjectprismaCreateInput>;
  /** Actions for the "Photo.Metadata_title" relation: "MetadataTitle.photo"'s inverse relation */
  Metadata_title?: InputMaybe<PhotoNestedMetadataTitleCreateInput>;
  /** Actions for the "Photo.Metadata_TransferredBy" relation: "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy?: InputMaybe<PhotoNestedMetadataTransferredbyCreateInput>;
  /** Actions for the "Photo.Metadata_TransferredByFullName" relation: "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName?: InputMaybe<PhotoNestedMetadataTransferredbyfullnameCreateInput>;
  /** Actions for the "Photo.Metadata_Type" relation: "MetadataType.photo"'s inverse relation */
  Metadata_Type?: InputMaybe<PhotoNestedMetadataTypeCreateInput>;
  /** Actions for the "Photo.Metadata_Undersubject" relation: "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject?: InputMaybe<PhotoNestedMetadataUndersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_UnderUnderSubject" relation: "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject?: InputMaybe<PhotoNestedMetadataUnderundersubjectCreateInput>;
  /** Actions for the "Photo.Metadata_UploadedBy" relation: "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy?: InputMaybe<PhotoNestedMetadataUploadedbyCreateInput>;
  /** Actions for the "Photo.Metadata_UploadedByFullName" relation: "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName?: InputMaybe<PhotoNestedMetadataUploadedbyfullnameCreateInput>;
  /** Actions for the "Photo.Metadata_UploadTime" relation: "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime?: InputMaybe<PhotoNestedMetadataUploadtimeCreateInput>;
  /** Actions for the "Photo.Metadata_Urgency" relation: "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency?: InputMaybe<PhotoNestedMetadataUrgencyCreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined195" relation: "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195?: InputMaybe<PhotoNestedMetadataUserdefined195CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined237" relation: "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237?: InputMaybe<PhotoNestedMetadataUserdefined237CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined238" relation: "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238?: InputMaybe<PhotoNestedMetadataUserdefined238CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined239" relation: "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239?: InputMaybe<PhotoNestedMetadataUserdefined239CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined242" relation: "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242?: InputMaybe<PhotoNestedMetadataUserdefined242CreateInput>;
  /** Actions for the "Photo.Metadata_UserDefined62" relation: "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62?: InputMaybe<PhotoNestedMetadataUserdefined62CreateInput>;
  /** Actions for the "Photo.Metadata_WorkflowKind" relation: "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind?: InputMaybe<PhotoNestedMetadataWorkflowkindCreateInput>;
  /** Actions for the "Photo.Metadata_XMPHistory" relation: "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory?: InputMaybe<PhotoNestedMetadataXmphistoryCreateInput>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.photoMetadatas" relation: "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas?: InputMaybe<PhotoNestedPhotoMetadatasCreateInput>;
  /** Actions for the "Photo.photoPublications" relation: "PhotoPublication.photo"'s inverse relation */
  photoPublications?: InputMaybe<PhotoNestedPhotoPublicationsCreateInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the photo's capture */
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoWithForcedDeliverySubjectUpdateInput = {
  /** Actions for the "Photo.agency" relation */
  agency?: InputMaybe<PhotoNestedAgencyUpdateInput>;
  /** Actions for the "Photo.archive" relation */
  archive?: InputMaybe<PhotoNestedArchiveUpdateInput>;
  /** Actions for the "Photo.category" relation */
  category?: InputMaybe<PhotoNestedCategoryUpdateInput>;
  /** asset content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  filesize?: InputMaybe<Scalars['Int']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The date of the photo's importation */
  importedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Actions for the "Photo.importQueue" relation: "ImportQueue.photo"'s inverse relation */
  importQueue?: InputMaybe<PhotoNestedImportQueueUpdateInput>;
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Actions for the "Photo.Metadata_AccessRights" relation: "MetadataAccessRights.photo"'s inverse relation */
  Metadata_AccessRights?: InputMaybe<PhotoNestedMetadataAccessrightsUpdateInput>;
  /** Actions for the "Photo.Metadata_AssetState" relation: "MetadataAssetState.photo"'s inverse relation */
  Metadata_AssetState?: InputMaybe<PhotoNestedMetadataAssetstateUpdateInput>;
  /** Actions for the "Photo.Metadata_BackupName" relation: "MetadataBackupName.photo"'s inverse relation */
  Metadata_BackupName?: InputMaybe<PhotoNestedMetadataBackupnameUpdateInput>;
  /** Actions for the "Photo.Metadata_Brand" relation: "MetadataBrand.photo"'s inverse relation */
  Metadata_Brand?: InputMaybe<PhotoNestedMetadataBrandUpdateInput>;
  /** Actions for the "Photo.Metadata_BrandPrisma" relation: "MetadataBrandPrisma.photo"'s inverse relation */
  Metadata_BrandPrisma?: InputMaybe<PhotoNestedMetadataBrandprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_BrandShortName" relation: "MetadataBrandShortName.photo"'s inverse relation */
  Metadata_BrandShortName?: InputMaybe<PhotoNestedMetadataBrandshortnameUpdateInput>;
  /** Actions for the "Photo.Metadata_By_line" relation: "MetadataByLine.photo"'s inverse relation */
  Metadata_By_line?: InputMaybe<PhotoNestedMetadataByLineUpdateInput>;
  /** Actions for the "Photo.Metadata_Caption" relation: "MetadataCaption.photo"'s inverse relation */
  Metadata_Caption?: InputMaybe<PhotoNestedMetadataCaptionUpdateInput>;
  /** Actions for the "Photo.Metadata_Caption_Abstract" relation: "MetadataCaptionAbstract.photo"'s inverse relation */
  Metadata_Caption_Abstract?: InputMaybe<PhotoNestedMetadataCaptionAbstractUpdateInput>;
  /** Actions for the "Photo.Metadata_Category" relation: "MetadataCategory.photo"'s inverse relation */
  Metadata_Category?: InputMaybe<PhotoNestedMetadataCategoryUpdateInput>;
  /** Actions for the "Photo.Metadata_CategoryPrisma" relation: "MetadataCategoryPrisma.photo"'s inverse relation */
  Metadata_CategoryPrisma?: InputMaybe<PhotoNestedMetadataCategoryprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_Company" relation: "MetadataCompany.photo"'s inverse relation */
  Metadata_Company?: InputMaybe<PhotoNestedMetadataCompanyUpdateInput>;
  /** Actions for the "Photo.Metadata_CompanyShortName" relation: "MetadataCompanyShortName.photo"'s inverse relation */
  Metadata_CompanyShortName?: InputMaybe<PhotoNestedMetadataCompanyshortnameUpdateInput>;
  /** Actions for the "Photo.Metadata_CopyrightNotice" relation: "MetadataCopyrightNotice.photo"'s inverse relation */
  Metadata_CopyrightNotice?: InputMaybe<PhotoNestedMetadataCopyrightnoticeUpdateInput>;
  /** Actions for the "Photo.Metadata_creator" relation: "MetadataCreator.photo"'s inverse relation */
  Metadata_creator?: InputMaybe<PhotoNestedMetadataCreatorUpdateInput>;
  /** Actions for the "Photo.Metadata_Credit" relation: "MetadataCredit.photo"'s inverse relation */
  Metadata_Credit?: InputMaybe<PhotoNestedMetadataCreditUpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField1" relation: "MetadataCustomField1.photo"'s inverse relation */
  Metadata_CustomField1?: InputMaybe<PhotoNestedMetadataCustomfield1UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField14" relation: "MetadataCustomField14.photo"'s inverse relation */
  Metadata_CustomField14?: InputMaybe<PhotoNestedMetadataCustomfield14UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField15" relation: "MetadataCustomField15.photo"'s inverse relation */
  Metadata_CustomField15?: InputMaybe<PhotoNestedMetadataCustomfield15UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField16" relation: "MetadataCustomField16.photo"'s inverse relation */
  Metadata_CustomField16?: InputMaybe<PhotoNestedMetadataCustomfield16UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField17" relation: "MetadataCustomField17.photo"'s inverse relation */
  Metadata_CustomField17?: InputMaybe<PhotoNestedMetadataCustomfield17UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField20" relation: "MetadataCustomField20.photo"'s inverse relation */
  Metadata_CustomField20?: InputMaybe<PhotoNestedMetadataCustomfield20UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField3" relation: "MetadataCustomField3.photo"'s inverse relation */
  Metadata_CustomField3?: InputMaybe<PhotoNestedMetadataCustomfield3UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField4" relation: "MetadataCustomField4.photo"'s inverse relation */
  Metadata_CustomField4?: InputMaybe<PhotoNestedMetadataCustomfield4UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField5" relation: "MetadataCustomField5.photo"'s inverse relation */
  Metadata_CustomField5?: InputMaybe<PhotoNestedMetadataCustomfield5UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField6" relation: "MetadataCustomField6.photo"'s inverse relation */
  Metadata_CustomField6?: InputMaybe<PhotoNestedMetadataCustomfield6UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField7" relation: "MetadataCustomField7.photo"'s inverse relation */
  Metadata_CustomField7?: InputMaybe<PhotoNestedMetadataCustomfield7UpdateInput>;
  /** Actions for the "Photo.Metadata_CustomField9" relation: "MetadataCustomField9.photo"'s inverse relation */
  Metadata_CustomField9?: InputMaybe<PhotoNestedMetadataCustomfield9UpdateInput>;
  /** Actions for the "Photo.Metadata_DateCreated" relation: "MetadataDateCreated.photo"'s inverse relation */
  Metadata_DateCreated?: InputMaybe<PhotoNestedMetadataDatecreatedUpdateInput>;
  /** Actions for the "Photo.Metadata_DateTimeOriginal" relation: "MetadataDateTimeOriginal.photo"'s inverse relation */
  Metadata_DateTimeOriginal?: InputMaybe<PhotoNestedMetadataDatetimeoriginalUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryAccount" relation: "MetadataDeliveryAccount.photo"'s inverse relation */
  Metadata_DeliveryAccount?: InputMaybe<PhotoNestedMetadataDeliveryaccountUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCompany" relation: "MetadataDeliveryCompany.photo"'s inverse relation */
  Metadata_DeliveryCompany?: InputMaybe<PhotoNestedMetadataDeliverycompanyUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryCopyright" relation: "MetadataDeliveryCopyright.photo"'s inverse relation */
  Metadata_DeliveryCopyright?: InputMaybe<PhotoNestedMetadataDeliverycopyrightUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateFolder" relation: "MetadataDeliveryDateFolder.photo"'s inverse relation */
  Metadata_DeliveryDateFolder?: InputMaybe<PhotoNestedMetadataDeliverydatefolderUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDateTime" relation: "MetadataDeliveryDateTime.photo"'s inverse relation */
  Metadata_DeliveryDateTime?: InputMaybe<PhotoNestedMetadataDeliverydatetimeUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcCreator" relation: "MetadataDeliveryDcCreator.photo"'s inverse relation */
  Metadata_DeliveryDcCreator?: InputMaybe<PhotoNestedMetadataDeliverydccreatorUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryDcRights" relation: "MetadataDeliveryDcRights.photo"'s inverse relation */
  Metadata_DeliveryDcRights?: InputMaybe<PhotoNestedMetadataDeliverydcrightsUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryFolder" relation: "MetadataDeliveryFolder.photo"'s inverse relation */
  Metadata_DeliveryFolder?: InputMaybe<PhotoNestedMetadataDeliveryfolderUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryKind" relation: "MetadataDeliveryKind.photo"'s inverse relation */
  Metadata_DeliveryKind?: InputMaybe<PhotoNestedMetadataDeliverykindUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPath" relation: "MetadataDeliveryPath.photo"'s inverse relation */
  Metadata_DeliveryPath?: InputMaybe<PhotoNestedMetadataDeliverypathUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopCredit" relation: "MetadataDeliveryPhotoshopCredit.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopCredit?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopcreditUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryPhotoshopSource" relation: "MetadataDeliveryPhotoshopSource.photo"'s inverse relation */
  Metadata_DeliveryPhotoshopSource?: InputMaybe<PhotoNestedMetadataDeliveryphotoshopsourceUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryService" relation: "MetadataDeliveryService.photo"'s inverse relation */
  Metadata_DeliveryService?: InputMaybe<PhotoNestedMetadataDeliveryserviceUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliverySubject" relation: "MetadataDeliverySubject.photo"'s inverse relation */
  Metadata_DeliverySubject?: InputMaybe<PhotoNestedMetadataDeliverysubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_DeliveryUnderSubject" relation: "MetadataDeliveryUnderSubject.photo"'s inverse relation */
  Metadata_DeliveryUnderSubject?: InputMaybe<PhotoNestedMetadataDeliveryundersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_Department" relation: "MetadataDepartment.photo"'s inverse relation */
  Metadata_Department?: InputMaybe<PhotoNestedMetadataDepartmentUpdateInput>;
  /** Actions for the "Photo.Metadata_description" relation: "MetadataDescription.photo"'s inverse relation */
  Metadata_description?: InputMaybe<PhotoNestedMetadataDescriptionUpdateInput>;
  /** Actions for the "Photo.Metadata_Edition" relation: "MetadataEdition.photo"'s inverse relation */
  Metadata_Edition?: InputMaybe<PhotoNestedMetadataEditionUpdateInput>;
  /** Actions for the "Photo.Metadata_EditStatus" relation: "MetadataEditStatus.photo"'s inverse relation */
  Metadata_EditStatus?: InputMaybe<PhotoNestedMetadataEditstatusUpdateInput>;
  /** Actions for the "Photo.Metadata_FileStatus" relation: "MetadataFileStatus.photo"'s inverse relation */
  Metadata_FileStatus?: InputMaybe<PhotoNestedMetadataFilestatusUpdateInput>;
  /** Actions for the "Photo.Metadata_Format" relation: "MetadataFormat.photo"'s inverse relation */
  Metadata_Format?: InputMaybe<PhotoNestedMetadataFormatUpdateInput>;
  /** Actions for the "Photo.Metadata_Header" relation: "MetadataHeader.photo"'s inverse relation */
  Metadata_Header?: InputMaybe<PhotoNestedMetadataHeaderUpdateInput>;
  /** Actions for the "Photo.Metadata_HeaderPrisma" relation: "MetadataHeaderPrisma.photo"'s inverse relation */
  Metadata_HeaderPrisma?: InputMaybe<PhotoNestedMetadataHeaderprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_Headline" relation: "MetadataHeadline.photo"'s inverse relation */
  Metadata_Headline?: InputMaybe<PhotoNestedMetadataHeadlineUpdateInput>;
  /** Actions for the "Photo.Metadata_ID_subject" relation: "MetadataIdSubject.photo"'s inverse relation */
  Metadata_ID_subject?: InputMaybe<PhotoNestedMetadataIdSubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_IdAssignment" relation: "MetadataIdAssignment.photo"'s inverse relation */
  Metadata_IdAssignment?: InputMaybe<PhotoNestedMetadataIdassignmentUpdateInput>;
  /** Actions for the "Photo.Metadata_IdPhotoPrisma" relation: "MetadataIdPhotoPrisma.photo"'s inverse relation */
  Metadata_IdPhotoPrisma?: InputMaybe<PhotoNestedMetadataIdphotoprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_ImageNotes" relation: "MetadataImageNotes.photo"'s inverse relation */
  Metadata_ImageNotes?: InputMaybe<PhotoNestedMetadataImagenotesUpdateInput>;
  /** Actions for the "Photo.Metadata_Instructions" relation: "MetadataInstructions.photo"'s inverse relation */
  Metadata_Instructions?: InputMaybe<PhotoNestedMetadataInstructionsUpdateInput>;
  /** Actions for the "Photo.Metadata_Issue" relation: "MetadataIssue.photo"'s inverse relation */
  Metadata_Issue?: InputMaybe<PhotoNestedMetadataIssueUpdateInput>;
  /** Actions for the "Photo.Metadata_Keywords" relation: "MetadataKeywords.photo"'s inverse relation */
  Metadata_Keywords?: InputMaybe<PhotoNestedMetadataKeywordsUpdateInput>;
  /** Actions for the "Photo.Metadata_ObjectName" relation: "MetadataObjectName.photo"'s inverse relation */
  Metadata_ObjectName?: InputMaybe<PhotoNestedMetadataObjectnameUpdateInput>;
  /** Actions for the "Photo.Metadata_OriginalName" relation: "MetadataOriginalName.photo"'s inverse relation */
  Metadata_OriginalName?: InputMaybe<PhotoNestedMetadataOriginalnameUpdateInput>;
  /** Actions for the "Photo.Metadata_PriceLevel" relation: "MetadataPriceLevel.photo"'s inverse relation */
  Metadata_PriceLevel?: InputMaybe<PhotoNestedMetadataPricelevelUpdateInput>;
  /** Actions for the "Photo.Metadata_ProcessHistory" relation: "MetadataProcessHistory.photo"'s inverse relation */
  Metadata_ProcessHistory?: InputMaybe<PhotoNestedMetadataProcesshistoryUpdateInput>;
  /** Actions for the "Photo.Metadata_ProcessStatus" relation: "MetadataProcessStatus.photo"'s inverse relation */
  Metadata_ProcessStatus?: InputMaybe<PhotoNestedMetadataProcessstatusUpdateInput>;
  /** Actions for the "Photo.Metadata_Product" relation: "MetadataProduct.photo"'s inverse relation */
  Metadata_Product?: InputMaybe<PhotoNestedMetadataProductUpdateInput>;
  /** Actions for the "Photo.Metadata_Products" relation: "MetadataProducts.photo"'s inverse relation */
  Metadata_Products?: InputMaybe<PhotoNestedMetadataProductsUpdateInput>;
  /** Actions for the "Photo.Metadata_publishingSubject" relation: "MetadataPublishingSubject.photo"'s inverse relation */
  Metadata_publishingSubject?: InputMaybe<PhotoNestedMetadataPublishingsubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_ResolutionKind" relation: "MetadataResolutionKind.photo"'s inverse relation */
  Metadata_ResolutionKind?: InputMaybe<PhotoNestedMetadataResolutionkindUpdateInput>;
  /** Actions for the "Photo.Metadata_rights" relation: "MetadataRights.photo"'s inverse relation */
  Metadata_rights?: InputMaybe<PhotoNestedMetadataRightsUpdateInput>;
  /** Actions for the "Photo.Metadata_Source" relation: "MetadataSource.photo"'s inverse relation */
  Metadata_Source?: InputMaybe<PhotoNestedMetadataSourceUpdateInput>;
  /** Actions for the "Photo.Metadata_SpecialInstructions" relation: "MetadataSpecialInstructions.photo"'s inverse relation */
  Metadata_SpecialInstructions?: InputMaybe<PhotoNestedMetadataSpecialinstructionsUpdateInput>;
  /** Actions for the "Photo.Metadata_subject" relation: "MetadataSubject.photo"'s inverse relation */
  Metadata_subject?: InputMaybe<PhotoNestedMetadataSubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_SubjectCode" relation: "MetadataSubjectCode.photo"'s inverse relation */
  Metadata_SubjectCode?: InputMaybe<PhotoNestedMetadataSubjectcodeUpdateInput>;
  /** Actions for the "Photo.Metadata_SubjectPrisma" relation: "MetadataSubjectPrisma.photo"'s inverse relation */
  Metadata_SubjectPrisma?: InputMaybe<PhotoNestedMetadataSubjectprismaUpdateInput>;
  /** Actions for the "Photo.Metadata_title" relation: "MetadataTitle.photo"'s inverse relation */
  Metadata_title?: InputMaybe<PhotoNestedMetadataTitleUpdateInput>;
  /** Actions for the "Photo.Metadata_TransferredBy" relation: "MetadataTransferredBy.photo"'s inverse relation */
  Metadata_TransferredBy?: InputMaybe<PhotoNestedMetadataTransferredbyUpdateInput>;
  /** Actions for the "Photo.Metadata_TransferredByFullName" relation: "MetadataTransferredByFullName.photo"'s inverse relation */
  Metadata_TransferredByFullName?: InputMaybe<PhotoNestedMetadataTransferredbyfullnameUpdateInput>;
  /** Actions for the "Photo.Metadata_Type" relation: "MetadataType.photo"'s inverse relation */
  Metadata_Type?: InputMaybe<PhotoNestedMetadataTypeUpdateInput>;
  /** Actions for the "Photo.Metadata_Undersubject" relation: "MetadataUndersubject.photo"'s inverse relation */
  Metadata_Undersubject?: InputMaybe<PhotoNestedMetadataUndersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_UnderUnderSubject" relation: "MetadataUnderUnderSubject.photo"'s inverse relation */
  Metadata_UnderUnderSubject?: InputMaybe<PhotoNestedMetadataUnderundersubjectUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadedBy" relation: "MetadataUploadedBy.photo"'s inverse relation */
  Metadata_UploadedBy?: InputMaybe<PhotoNestedMetadataUploadedbyUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadedByFullName" relation: "MetadataUploadedByFullName.photo"'s inverse relation */
  Metadata_UploadedByFullName?: InputMaybe<PhotoNestedMetadataUploadedbyfullnameUpdateInput>;
  /** Actions for the "Photo.Metadata_UploadTime" relation: "MetadataUploadTime.photo"'s inverse relation */
  Metadata_UploadTime?: InputMaybe<PhotoNestedMetadataUploadtimeUpdateInput>;
  /** Actions for the "Photo.Metadata_Urgency" relation: "MetadataUrgency.photo"'s inverse relation */
  Metadata_Urgency?: InputMaybe<PhotoNestedMetadataUrgencyUpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined195" relation: "MetadataUserDefined195.photo"'s inverse relation */
  Metadata_UserDefined195?: InputMaybe<PhotoNestedMetadataUserdefined195UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined237" relation: "MetadataUserDefined237.photo"'s inverse relation */
  Metadata_UserDefined237?: InputMaybe<PhotoNestedMetadataUserdefined237UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined238" relation: "MetadataUserDefined238.photo"'s inverse relation */
  Metadata_UserDefined238?: InputMaybe<PhotoNestedMetadataUserdefined238UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined239" relation: "MetadataUserDefined239.photo"'s inverse relation */
  Metadata_UserDefined239?: InputMaybe<PhotoNestedMetadataUserdefined239UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined242" relation: "MetadataUserDefined242.photo"'s inverse relation */
  Metadata_UserDefined242?: InputMaybe<PhotoNestedMetadataUserdefined242UpdateInput>;
  /** Actions for the "Photo.Metadata_UserDefined62" relation: "MetadataUserDefined62.photo"'s inverse relation */
  Metadata_UserDefined62?: InputMaybe<PhotoNestedMetadataUserdefined62UpdateInput>;
  /** Actions for the "Photo.Metadata_WorkflowKind" relation: "MetadataWorkflowKind.photo"'s inverse relation */
  Metadata_WorkflowKind?: InputMaybe<PhotoNestedMetadataWorkflowkindUpdateInput>;
  /** Actions for the "Photo.Metadata_XMPHistory" relation: "MetadataXmpHistory.photo"'s inverse relation */
  Metadata_XMPHistory?: InputMaybe<PhotoNestedMetadataXmphistoryUpdateInput>;
  originalName?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Photo.photoMetadatas" relation: "PhotoMetadata.photo"'s inverse relation */
  photoMetadatas?: InputMaybe<PhotoNestedPhotoMetadatasUpdateInput>;
  /** Actions for the "Photo.photoPublications" relation: "PhotoPublication.photo"'s inverse relation */
  photoPublications?: InputMaybe<PhotoNestedPhotoPublicationsUpdateInput>;
  synced?: InputMaybe<Scalars['Boolean']['input']>;
  /** The date of the photo's capture */
  takenAt?: InputMaybe<Scalars['DateTime']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type Preview = {
  __typename?: 'Preview';
  href?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a list of "Agency" nodes. */
  agencies: Array<Agency>;
  /** Retrieve a single "Agency" node. */
  agency?: Maybe<Agency>;
  /** Retrieve the number of "Agency" nodes. */
  agencyCount: Scalars['Int']['output'];
  /** Retrieve a single "Archive" node. */
  archive?: Maybe<Archive>;
  /** Retrieve a list of "ArchiveAgency" nodes. */
  archiveAgencies: Array<ArchiveAgency>;
  /** Retrieve a single "ArchiveAgency" node. */
  archiveAgency?: Maybe<ArchiveAgency>;
  /** Retrieve the number of "ArchiveAgency" nodes. */
  archiveAgencyCount: Scalars['Int']['output'];
  /** Retrieve the number of "Archive" nodes. */
  archiveCount: Scalars['Int']['output'];
  /** Retrieve a single "ArchivePurgeSetting" node. */
  archivePurgeSetting?: Maybe<ArchivePurgeSetting>;
  /** Retrieve the number of "ArchivePurgeSetting" nodes. */
  archivePurgeSettingCount: Scalars['Int']['output'];
  /** Retrieve a list of "ArchivePurgeSetting" nodes. */
  archivePurgeSettings: Array<ArchivePurgeSetting>;
  /** Retrieve a list of "Archive" nodes. */
  archives: Array<Archive>;
  /** Retrieve a list of "Category" nodes. */
  categories: Array<Category>;
  /** Retrieve a single "Category" node. */
  category?: Maybe<Category>;
  /** Retrieve the number of "Category" nodes. */
  categoryCount: Scalars['Int']['output'];
  /** Retrieve a single "DeliverySubject" node. */
  deliverySubject?: Maybe<DeliverySubject>;
  /** Retrieve the number of "DeliverySubject" nodes. */
  deliverySubjectCount: Scalars['Int']['output'];
  /** Retrieve a list of "DeliverySubject" nodes. */
  deliverySubjects: Array<DeliverySubject>;
  /** Retrieve a single "GcImportSetting" node. */
  gcImportSetting?: Maybe<GcImportSetting>;
  /** Retrieve the number of "GcImportSetting" nodes. */
  gcImportSettingCount: Scalars['Int']['output'];
  /** Retrieve a list of "GcImportSetting" nodes. */
  gcImportSettings: Array<GcImportSetting>;
  /** search metadata by archive, return their occurrence */
  getCenshareRailroad?: Maybe<Scalars['String']['output']>;
  /** search metadata by archive, return their occurrence */
  getMetadataOccurrenceByArchive: Array<MetadataOccurrenceQlType>;
  /** Retrieve a single "ImportQueue" node. */
  importQueue?: Maybe<ImportQueue>;
  /** Retrieve the number of "ImportQueue" nodes. */
  importQueueCount: Scalars['Int']['output'];
  /** Retrieve a list of "ImportQueue" nodes. */
  importQueues: Array<ImportQueue>;
  /** Retrieve a single "Metadata" node. */
  metadata?: Maybe<Metadata>;
  /** Retrieve a single "MetadataAccessRights" node. */
  metadataAccessRights?: Maybe<MetadataAccessRights>;
  /** Retrieve the number of "MetadataAccessRights" nodes. */
  metadataAccessRightsCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataAccessRights" nodes. */
  metadataAccessRightsList: Array<MetadataAccessRights>;
  /** Retrieve a single "MetadataAssetState" node. */
  metadataAssetState?: Maybe<MetadataAssetState>;
  /** Retrieve the number of "MetadataAssetState" nodes. */
  metadataAssetStateCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataAssetState" nodes. */
  metadataAssetStateList: Array<MetadataAssetState>;
  /** Retrieve a single "MetadataBackupName" node. */
  metadataBackupName?: Maybe<MetadataBackupName>;
  /** Retrieve the number of "MetadataBackupName" nodes. */
  metadataBackupNameCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataBackupName" nodes. */
  metadataBackupNameList: Array<MetadataBackupName>;
  /** Retrieve a single "MetadataBrand" node. */
  metadataBrand?: Maybe<MetadataBrand>;
  /** Retrieve the number of "MetadataBrand" nodes. */
  metadataBrandCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataBrand" nodes. */
  metadataBrandList: Array<MetadataBrand>;
  /** Retrieve a single "MetadataBrandPrisma" node. */
  metadataBrandPrisma?: Maybe<MetadataBrandPrisma>;
  /** Retrieve the number of "MetadataBrandPrisma" nodes. */
  metadataBrandPrismaCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataBrandPrisma" nodes. */
  metadataBrandPrismaList: Array<MetadataBrandPrisma>;
  /** Retrieve a single "MetadataBrandShortName" node. */
  metadataBrandShortName?: Maybe<MetadataBrandShortName>;
  /** Retrieve the number of "MetadataBrandShortName" nodes. */
  metadataBrandShortNameCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataBrandShortName" nodes. */
  metadataBrandShortNameList: Array<MetadataBrandShortName>;
  /** Retrieve a single "MetadataByLine" node. */
  metadataByLine?: Maybe<MetadataByLine>;
  /** Retrieve the number of "MetadataByLine" nodes. */
  metadataByLineCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataByLine" nodes. */
  metadataByLineList: Array<MetadataByLine>;
  /** Retrieve a single "MetadataCaption" node. */
  metadataCaption?: Maybe<MetadataCaption>;
  /** Retrieve a single "MetadataCaptionAbstract" node. */
  metadataCaptionAbstract?: Maybe<MetadataCaptionAbstract>;
  /** Retrieve the number of "MetadataCaptionAbstract" nodes. */
  metadataCaptionAbstractCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCaptionAbstract" nodes. */
  metadataCaptionAbstractList: Array<MetadataCaptionAbstract>;
  /** Retrieve the number of "MetadataCaption" nodes. */
  metadataCaptionCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCaption" nodes. */
  metadataCaptionList: Array<MetadataCaption>;
  /** Retrieve a single "MetadataCategory" node. */
  metadataCategory?: Maybe<MetadataCategory>;
  /** Retrieve the number of "MetadataCategory" nodes. */
  metadataCategoryCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCategory" nodes. */
  metadataCategoryList: Array<MetadataCategory>;
  /** Retrieve a single "MetadataCategoryPrisma" node. */
  metadataCategoryPrisma?: Maybe<MetadataCategoryPrisma>;
  /** Retrieve the number of "MetadataCategoryPrisma" nodes. */
  metadataCategoryPrismaCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCategoryPrisma" nodes. */
  metadataCategoryPrismaList: Array<MetadataCategoryPrisma>;
  /** Retrieve a single "MetadataCompany" node. */
  metadataCompany?: Maybe<MetadataCompany>;
  /** Retrieve the number of "MetadataCompany" nodes. */
  metadataCompanyCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCompany" nodes. */
  metadataCompanyList: Array<MetadataCompany>;
  /** Retrieve a single "MetadataCompanyShortName" node. */
  metadataCompanyShortName?: Maybe<MetadataCompanyShortName>;
  /** Retrieve the number of "MetadataCompanyShortName" nodes. */
  metadataCompanyShortNameCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCompanyShortName" nodes. */
  metadataCompanyShortNameList: Array<MetadataCompanyShortName>;
  /** Retrieve a single "MetadataCopyrightNotice" node. */
  metadataCopyrightNotice?: Maybe<MetadataCopyrightNotice>;
  /** Retrieve the number of "MetadataCopyrightNotice" nodes. */
  metadataCopyrightNoticeCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCopyrightNotice" nodes. */
  metadataCopyrightNoticeList: Array<MetadataCopyrightNotice>;
  /** Retrieve the number of "Metadata" nodes. */
  metadataCount: Scalars['Int']['output'];
  /** Retrieve a single "MetadataCreator" node. */
  metadataCreator?: Maybe<MetadataCreator>;
  /** Retrieve the number of "MetadataCreator" nodes. */
  metadataCreatorCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCreator" nodes. */
  metadataCreatorList: Array<MetadataCreator>;
  /** Retrieve a single "MetadataCredit" node. */
  metadataCredit?: Maybe<MetadataCredit>;
  /** Retrieve the number of "MetadataCredit" nodes. */
  metadataCreditCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCredit" nodes. */
  metadataCreditList: Array<MetadataCredit>;
  /** Retrieve a single "MetadataCustomField1" node. */
  metadataCustomField1?: Maybe<MetadataCustomField1>;
  /** Retrieve a single "MetadataCustomField14" node. */
  metadataCustomField14?: Maybe<MetadataCustomField14>;
  /** Retrieve the number of "MetadataCustomField14" nodes. */
  metadataCustomField14Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField14" nodes. */
  metadataCustomField14List: Array<MetadataCustomField14>;
  /** Retrieve a single "MetadataCustomField15" node. */
  metadataCustomField15?: Maybe<MetadataCustomField15>;
  /** Retrieve the number of "MetadataCustomField15" nodes. */
  metadataCustomField15Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField15" nodes. */
  metadataCustomField15List: Array<MetadataCustomField15>;
  /** Retrieve a single "MetadataCustomField16" node. */
  metadataCustomField16?: Maybe<MetadataCustomField16>;
  /** Retrieve the number of "MetadataCustomField16" nodes. */
  metadataCustomField16Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField16" nodes. */
  metadataCustomField16List: Array<MetadataCustomField16>;
  /** Retrieve a single "MetadataCustomField17" node. */
  metadataCustomField17?: Maybe<MetadataCustomField17>;
  /** Retrieve the number of "MetadataCustomField17" nodes. */
  metadataCustomField17Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField17" nodes. */
  metadataCustomField17List: Array<MetadataCustomField17>;
  /** Retrieve the number of "MetadataCustomField1" nodes. */
  metadataCustomField1Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField1" nodes. */
  metadataCustomField1List: Array<MetadataCustomField1>;
  /** Retrieve a single "MetadataCustomField20" node. */
  metadataCustomField20?: Maybe<MetadataCustomField20>;
  /** Retrieve the number of "MetadataCustomField20" nodes. */
  metadataCustomField20Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField20" nodes. */
  metadataCustomField20List: Array<MetadataCustomField20>;
  /** Retrieve a single "MetadataCustomField3" node. */
  metadataCustomField3?: Maybe<MetadataCustomField3>;
  /** Retrieve the number of "MetadataCustomField3" nodes. */
  metadataCustomField3Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField3" nodes. */
  metadataCustomField3List: Array<MetadataCustomField3>;
  /** Retrieve a single "MetadataCustomField4" node. */
  metadataCustomField4?: Maybe<MetadataCustomField4>;
  /** Retrieve the number of "MetadataCustomField4" nodes. */
  metadataCustomField4Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField4" nodes. */
  metadataCustomField4List: Array<MetadataCustomField4>;
  /** Retrieve a single "MetadataCustomField5" node. */
  metadataCustomField5?: Maybe<MetadataCustomField5>;
  /** Retrieve the number of "MetadataCustomField5" nodes. */
  metadataCustomField5Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField5" nodes. */
  metadataCustomField5List: Array<MetadataCustomField5>;
  /** Retrieve a single "MetadataCustomField6" node. */
  metadataCustomField6?: Maybe<MetadataCustomField6>;
  /** Retrieve the number of "MetadataCustomField6" nodes. */
  metadataCustomField6Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField6" nodes. */
  metadataCustomField6List: Array<MetadataCustomField6>;
  /** Retrieve a single "MetadataCustomField7" node. */
  metadataCustomField7?: Maybe<MetadataCustomField7>;
  /** Retrieve the number of "MetadataCustomField7" nodes. */
  metadataCustomField7Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField7" nodes. */
  metadataCustomField7List: Array<MetadataCustomField7>;
  /** Retrieve a single "MetadataCustomField9" node. */
  metadataCustomField9?: Maybe<MetadataCustomField9>;
  /** Retrieve the number of "MetadataCustomField9" nodes. */
  metadataCustomField9Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataCustomField9" nodes. */
  metadataCustomField9List: Array<MetadataCustomField9>;
  /** Retrieve a single "MetadataDateCreated" node. */
  metadataDateCreated?: Maybe<MetadataDateCreated>;
  /** Retrieve the number of "MetadataDateCreated" nodes. */
  metadataDateCreatedCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDateCreated" nodes. */
  metadataDateCreatedList: Array<MetadataDateCreated>;
  /** Retrieve a single "MetadataDateTimeOriginal" node. */
  metadataDateTimeOriginal?: Maybe<MetadataDateTimeOriginal>;
  /** Retrieve the number of "MetadataDateTimeOriginal" nodes. */
  metadataDateTimeOriginalCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDateTimeOriginal" nodes. */
  metadataDateTimeOriginalList: Array<MetadataDateTimeOriginal>;
  /** Retrieve a single "MetadataDeliveryAccount" node. */
  metadataDeliveryAccount?: Maybe<MetadataDeliveryAccount>;
  /** Retrieve the number of "MetadataDeliveryAccount" nodes. */
  metadataDeliveryAccountCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryAccount" nodes. */
  metadataDeliveryAccountList: Array<MetadataDeliveryAccount>;
  /** Retrieve a single "MetadataDeliveryCompany" node. */
  metadataDeliveryCompany?: Maybe<MetadataDeliveryCompany>;
  /** Retrieve the number of "MetadataDeliveryCompany" nodes. */
  metadataDeliveryCompanyCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryCompany" nodes. */
  metadataDeliveryCompanyList: Array<MetadataDeliveryCompany>;
  /** Retrieve a single "MetadataDeliveryCopyright" node. */
  metadataDeliveryCopyright?: Maybe<MetadataDeliveryCopyright>;
  /** Retrieve the number of "MetadataDeliveryCopyright" nodes. */
  metadataDeliveryCopyrightCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryCopyright" nodes. */
  metadataDeliveryCopyrightList: Array<MetadataDeliveryCopyright>;
  /** Retrieve a single "MetadataDeliveryDateFolder" node. */
  metadataDeliveryDateFolder?: Maybe<MetadataDeliveryDateFolder>;
  /** Retrieve the number of "MetadataDeliveryDateFolder" nodes. */
  metadataDeliveryDateFolderCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryDateFolder" nodes. */
  metadataDeliveryDateFolderList: Array<MetadataDeliveryDateFolder>;
  /** Retrieve a single "MetadataDeliveryDateTime" node. */
  metadataDeliveryDateTime?: Maybe<MetadataDeliveryDateTime>;
  /** Retrieve the number of "MetadataDeliveryDateTime" nodes. */
  metadataDeliveryDateTimeCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryDateTime" nodes. */
  metadataDeliveryDateTimeList: Array<MetadataDeliveryDateTime>;
  /** Retrieve a single "MetadataDeliveryDcCreator" node. */
  metadataDeliveryDcCreator?: Maybe<MetadataDeliveryDcCreator>;
  /** Retrieve the number of "MetadataDeliveryDcCreator" nodes. */
  metadataDeliveryDcCreatorCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryDcCreator" nodes. */
  metadataDeliveryDcCreatorList: Array<MetadataDeliveryDcCreator>;
  /** Retrieve a single "MetadataDeliveryDcRights" node. */
  metadataDeliveryDcRights?: Maybe<MetadataDeliveryDcRights>;
  /** Retrieve the number of "MetadataDeliveryDcRights" nodes. */
  metadataDeliveryDcRightsCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryDcRights" nodes. */
  metadataDeliveryDcRightsList: Array<MetadataDeliveryDcRights>;
  /** Retrieve a single "MetadataDeliveryFolder" node. */
  metadataDeliveryFolder?: Maybe<MetadataDeliveryFolder>;
  /** Retrieve the number of "MetadataDeliveryFolder" nodes. */
  metadataDeliveryFolderCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryFolder" nodes. */
  metadataDeliveryFolderList: Array<MetadataDeliveryFolder>;
  /** Retrieve a single "MetadataDeliveryKind" node. */
  metadataDeliveryKind?: Maybe<MetadataDeliveryKind>;
  /** Retrieve the number of "MetadataDeliveryKind" nodes. */
  metadataDeliveryKindCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryKind" nodes. */
  metadataDeliveryKindList: Array<MetadataDeliveryKind>;
  /** Retrieve a single "MetadataDeliveryPath" node. */
  metadataDeliveryPath?: Maybe<MetadataDeliveryPath>;
  /** Retrieve the number of "MetadataDeliveryPath" nodes. */
  metadataDeliveryPathCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryPath" nodes. */
  metadataDeliveryPathList: Array<MetadataDeliveryPath>;
  /** Retrieve a single "MetadataDeliveryPhotoshopCredit" node. */
  metadataDeliveryPhotoshopCredit?: Maybe<MetadataDeliveryPhotoshopCredit>;
  /** Retrieve the number of "MetadataDeliveryPhotoshopCredit" nodes. */
  metadataDeliveryPhotoshopCreditCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryPhotoshopCredit" nodes. */
  metadataDeliveryPhotoshopCreditList: Array<MetadataDeliveryPhotoshopCredit>;
  /** Retrieve a single "MetadataDeliveryPhotoshopSource" node. */
  metadataDeliveryPhotoshopSource?: Maybe<MetadataDeliveryPhotoshopSource>;
  /** Retrieve the number of "MetadataDeliveryPhotoshopSource" nodes. */
  metadataDeliveryPhotoshopSourceCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryPhotoshopSource" nodes. */
  metadataDeliveryPhotoshopSourceList: Array<MetadataDeliveryPhotoshopSource>;
  /** Retrieve a single "MetadataDeliveryService" node. */
  metadataDeliveryService?: Maybe<MetadataDeliveryService>;
  /** Retrieve the number of "MetadataDeliveryService" nodes. */
  metadataDeliveryServiceCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryService" nodes. */
  metadataDeliveryServiceList: Array<MetadataDeliveryService>;
  /** Retrieve a single "MetadataDeliverySubject" node. */
  metadataDeliverySubject?: Maybe<MetadataDeliverySubject>;
  /** Retrieve the number of "MetadataDeliverySubject" nodes. */
  metadataDeliverySubjectCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliverySubject" nodes. */
  metadataDeliverySubjectList: Array<MetadataDeliverySubject>;
  /** Retrieve a single "MetadataDeliveryUnderSubject" node. */
  metadataDeliveryUnderSubject?: Maybe<MetadataDeliveryUnderSubject>;
  /** Retrieve the number of "MetadataDeliveryUnderSubject" nodes. */
  metadataDeliveryUnderSubjectCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDeliveryUnderSubject" nodes. */
  metadataDeliveryUnderSubjectList: Array<MetadataDeliveryUnderSubject>;
  /** Retrieve a single "MetadataDepartment" node. */
  metadataDepartment?: Maybe<MetadataDepartment>;
  /** Retrieve the number of "MetadataDepartment" nodes. */
  metadataDepartmentCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDepartment" nodes. */
  metadataDepartmentList: Array<MetadataDepartment>;
  /** Retrieve a single "MetadataDescription" node. */
  metadataDescription?: Maybe<MetadataDescription>;
  /** Retrieve the number of "MetadataDescription" nodes. */
  metadataDescriptionCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataDescription" nodes. */
  metadataDescriptionList: Array<MetadataDescription>;
  /** Retrieve a single "MetadataEdition" node. */
  metadataEdition?: Maybe<MetadataEdition>;
  /** Retrieve the number of "MetadataEdition" nodes. */
  metadataEditionCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataEdition" nodes. */
  metadataEditionList: Array<MetadataEdition>;
  /** Retrieve a single "MetadataEditStatus" node. */
  metadataEditStatus?: Maybe<MetadataEditStatus>;
  /** Retrieve the number of "MetadataEditStatus" nodes. */
  metadataEditStatusCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataEditStatus" nodes. */
  metadataEditStatusList: Array<MetadataEditStatus>;
  /** Retrieve a single "MetadataFileStatus" node. */
  metadataFileStatus?: Maybe<MetadataFileStatus>;
  /** Retrieve the number of "MetadataFileStatus" nodes. */
  metadataFileStatusCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataFileStatus" nodes. */
  metadataFileStatusList: Array<MetadataFileStatus>;
  /** Retrieve a single "MetadataFormat" node. */
  metadataFormat?: Maybe<MetadataFormat>;
  /** Retrieve the number of "MetadataFormat" nodes. */
  metadataFormatCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataFormat" nodes. */
  metadataFormatList: Array<MetadataFormat>;
  /** Retrieve a single "MetadataHeader" node. */
  metadataHeader?: Maybe<MetadataHeader>;
  /** Retrieve the number of "MetadataHeader" nodes. */
  metadataHeaderCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataHeader" nodes. */
  metadataHeaderList: Array<MetadataHeader>;
  /** Retrieve a single "MetadataHeaderPrisma" node. */
  metadataHeaderPrisma?: Maybe<MetadataHeaderPrisma>;
  /** Retrieve the number of "MetadataHeaderPrisma" nodes. */
  metadataHeaderPrismaCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataHeaderPrisma" nodes. */
  metadataHeaderPrismaList: Array<MetadataHeaderPrisma>;
  /** Retrieve a single "MetadataHeadline" node. */
  metadataHeadline?: Maybe<MetadataHeadline>;
  /** Retrieve the number of "MetadataHeadline" nodes. */
  metadataHeadlineCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataHeadline" nodes. */
  metadataHeadlineList: Array<MetadataHeadline>;
  /** Retrieve a single "MetadataIdAssignment" node. */
  metadataIdAssignment?: Maybe<MetadataIdAssignment>;
  /** Retrieve the number of "MetadataIdAssignment" nodes. */
  metadataIdAssignmentCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataIdAssignment" nodes. */
  metadataIdAssignmentList: Array<MetadataIdAssignment>;
  /** Retrieve a single "MetadataIdPhotoPrisma" node. */
  metadataIdPhotoPrisma?: Maybe<MetadataIdPhotoPrisma>;
  /** Retrieve the number of "MetadataIdPhotoPrisma" nodes. */
  metadataIdPhotoPrismaCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataIdPhotoPrisma" nodes. */
  metadataIdPhotoPrismaList: Array<MetadataIdPhotoPrisma>;
  /** Retrieve a single "MetadataIdSubject" node. */
  metadataIdSubject?: Maybe<MetadataIdSubject>;
  /** Retrieve the number of "MetadataIdSubject" nodes. */
  metadataIdSubjectCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataIdSubject" nodes. */
  metadataIdSubjectList: Array<MetadataIdSubject>;
  /** Retrieve a single "MetadataImageNotes" node. */
  metadataImageNotes?: Maybe<MetadataImageNotes>;
  /** Retrieve the number of "MetadataImageNotes" nodes. */
  metadataImageNotesCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataImageNotes" nodes. */
  metadataImageNotesList: Array<MetadataImageNotes>;
  /** Retrieve a single "MetadataInstructions" node. */
  metadataInstructions?: Maybe<MetadataInstructions>;
  /** Retrieve the number of "MetadataInstructions" nodes. */
  metadataInstructionsCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataInstructions" nodes. */
  metadataInstructionsList: Array<MetadataInstructions>;
  /** Retrieve a single "MetadataIssue" node. */
  metadataIssue?: Maybe<MetadataIssue>;
  /** Retrieve the number of "MetadataIssue" nodes. */
  metadataIssueCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataIssue" nodes. */
  metadataIssueList: Array<MetadataIssue>;
  /** Retrieve a single "MetadataKeywords" node. */
  metadataKeywords?: Maybe<MetadataKeywords>;
  /** Retrieve the number of "MetadataKeywords" nodes. */
  metadataKeywordsCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataKeywords" nodes. */
  metadataKeywordsList: Array<MetadataKeywords>;
  /** Retrieve a single "MetadataObjectName" node. */
  metadataObjectName?: Maybe<MetadataObjectName>;
  /** Retrieve the number of "MetadataObjectName" nodes. */
  metadataObjectNameCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataObjectName" nodes. */
  metadataObjectNameList: Array<MetadataObjectName>;
  /** Retrieve a single "MetadataOriginalName" node. */
  metadataOriginalName?: Maybe<MetadataOriginalName>;
  /** Retrieve the number of "MetadataOriginalName" nodes. */
  metadataOriginalNameCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataOriginalName" nodes. */
  metadataOriginalNameList: Array<MetadataOriginalName>;
  /** Retrieve a single "MetadataPriceLevel" node. */
  metadataPriceLevel?: Maybe<MetadataPriceLevel>;
  /** Retrieve the number of "MetadataPriceLevel" nodes. */
  metadataPriceLevelCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataPriceLevel" nodes. */
  metadataPriceLevelList: Array<MetadataPriceLevel>;
  /** Retrieve a single "MetadataProcessHistory" node. */
  metadataProcessHistory?: Maybe<MetadataProcessHistory>;
  /** Retrieve the number of "MetadataProcessHistory" nodes. */
  metadataProcessHistoryCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataProcessHistory" nodes. */
  metadataProcessHistoryList: Array<MetadataProcessHistory>;
  /** Retrieve a single "MetadataProcessStatus" node. */
  metadataProcessStatus?: Maybe<MetadataProcessStatus>;
  /** Retrieve the number of "MetadataProcessStatus" nodes. */
  metadataProcessStatusCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataProcessStatus" nodes. */
  metadataProcessStatusList: Array<MetadataProcessStatus>;
  /** Retrieve a single "MetadataProduct" node. */
  metadataProduct?: Maybe<MetadataProduct>;
  /** Retrieve the number of "MetadataProduct" nodes. */
  metadataProductCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataProduct" nodes. */
  metadataProductList: Array<MetadataProduct>;
  /** Retrieve a single "MetadataProducts" node. */
  metadataProducts?: Maybe<MetadataProducts>;
  /** Retrieve the number of "MetadataProducts" nodes. */
  metadataProductsCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataProducts" nodes. */
  metadataProductsList: Array<MetadataProducts>;
  /** Retrieve a single "MetadataPublishingSubject" node. */
  metadataPublishingSubject?: Maybe<MetadataPublishingSubject>;
  /** Retrieve the number of "MetadataPublishingSubject" nodes. */
  metadataPublishingSubjectCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataPublishingSubject" nodes. */
  metadataPublishingSubjectList: Array<MetadataPublishingSubject>;
  /** Retrieve a single "MetadataResolutionKind" node. */
  metadataResolutionKind?: Maybe<MetadataResolutionKind>;
  /** Retrieve the number of "MetadataResolutionKind" nodes. */
  metadataResolutionKindCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataResolutionKind" nodes. */
  metadataResolutionKindList: Array<MetadataResolutionKind>;
  /** Retrieve a single "MetadataRights" node. */
  metadataRights?: Maybe<MetadataRights>;
  /** Retrieve the number of "MetadataRights" nodes. */
  metadataRightsCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataRights" nodes. */
  metadataRightsList: Array<MetadataRights>;
  /** Retrieve a list of "Metadata" nodes. */
  metadatas: Array<Metadata>;
  /** Retrieve a single "MetadataSource" node. */
  metadataSource?: Maybe<MetadataSource>;
  /** Retrieve the number of "MetadataSource" nodes. */
  metadataSourceCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataSource" nodes. */
  metadataSourceList: Array<MetadataSource>;
  /** Retrieve a single "MetadataSpecialInstructions" node. */
  metadataSpecialInstructions?: Maybe<MetadataSpecialInstructions>;
  /** Retrieve the number of "MetadataSpecialInstructions" nodes. */
  metadataSpecialInstructionsCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataSpecialInstructions" nodes. */
  metadataSpecialInstructionsList: Array<MetadataSpecialInstructions>;
  /** Retrieve a single "MetadataSubject" node. */
  metadataSubject?: Maybe<MetadataSubject>;
  /** Retrieve a single "MetadataSubjectCode" node. */
  metadataSubjectCode?: Maybe<MetadataSubjectCode>;
  /** Retrieve the number of "MetadataSubjectCode" nodes. */
  metadataSubjectCodeCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataSubjectCode" nodes. */
  metadataSubjectCodeList: Array<MetadataSubjectCode>;
  /** Retrieve the number of "MetadataSubject" nodes. */
  metadataSubjectCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataSubject" nodes. */
  metadataSubjectList: Array<MetadataSubject>;
  /** Retrieve a single "MetadataSubjectPrisma" node. */
  metadataSubjectPrisma?: Maybe<MetadataSubjectPrisma>;
  /** Retrieve the number of "MetadataSubjectPrisma" nodes. */
  metadataSubjectPrismaCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataSubjectPrisma" nodes. */
  metadataSubjectPrismaList: Array<MetadataSubjectPrisma>;
  /** Retrieve a single "MetadataTitle" node. */
  metadataTitle?: Maybe<MetadataTitle>;
  /** Retrieve the number of "MetadataTitle" nodes. */
  metadataTitleCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataTitle" nodes. */
  metadataTitleList: Array<MetadataTitle>;
  /** Retrieve a single "MetadataTransferredBy" node. */
  metadataTransferredBy?: Maybe<MetadataTransferredBy>;
  /** Retrieve the number of "MetadataTransferredBy" nodes. */
  metadataTransferredByCount: Scalars['Int']['output'];
  /** Retrieve a single "MetadataTransferredByFullName" node. */
  metadataTransferredByFullName?: Maybe<MetadataTransferredByFullName>;
  /** Retrieve the number of "MetadataTransferredByFullName" nodes. */
  metadataTransferredByFullNameCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataTransferredByFullName" nodes. */
  metadataTransferredByFullNameList: Array<MetadataTransferredByFullName>;
  /** Retrieve a list of "MetadataTransferredBy" nodes. */
  metadataTransferredByList: Array<MetadataTransferredBy>;
  /** Retrieve a single "MetadataType" node. */
  metadataType?: Maybe<MetadataType>;
  /** Retrieve the number of "MetadataType" nodes. */
  metadataTypeCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataType" nodes. */
  metadataTypeList: Array<MetadataType>;
  /** Retrieve a single "MetadataUndersubject" node. */
  metadataUndersubject?: Maybe<MetadataUndersubject>;
  /** Retrieve the number of "MetadataUndersubject" nodes. */
  metadataUndersubjectCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUndersubject" nodes. */
  metadataUndersubjectList: Array<MetadataUndersubject>;
  /** Retrieve a single "MetadataUnderUnderSubject" node. */
  metadataUnderUnderSubject?: Maybe<MetadataUnderUnderSubject>;
  /** Retrieve the number of "MetadataUnderUnderSubject" nodes. */
  metadataUnderUnderSubjectCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUnderUnderSubject" nodes. */
  metadataUnderUnderSubjectList: Array<MetadataUnderUnderSubject>;
  /** Retrieve a single "MetadataUploadedBy" node. */
  metadataUploadedBy?: Maybe<MetadataUploadedBy>;
  /** Retrieve the number of "MetadataUploadedBy" nodes. */
  metadataUploadedByCount: Scalars['Int']['output'];
  /** Retrieve a single "MetadataUploadedByFullName" node. */
  metadataUploadedByFullName?: Maybe<MetadataUploadedByFullName>;
  /** Retrieve the number of "MetadataUploadedByFullName" nodes. */
  metadataUploadedByFullNameCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUploadedByFullName" nodes. */
  metadataUploadedByFullNameList: Array<MetadataUploadedByFullName>;
  /** Retrieve a list of "MetadataUploadedBy" nodes. */
  metadataUploadedByList: Array<MetadataUploadedBy>;
  /** Retrieve a single "MetadataUploadTime" node. */
  metadataUploadTime?: Maybe<MetadataUploadTime>;
  /** Retrieve the number of "MetadataUploadTime" nodes. */
  metadataUploadTimeCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUploadTime" nodes. */
  metadataUploadTimeList: Array<MetadataUploadTime>;
  /** Retrieve a single "MetadataUrgency" node. */
  metadataUrgency?: Maybe<MetadataUrgency>;
  /** Retrieve the number of "MetadataUrgency" nodes. */
  metadataUrgencyCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUrgency" nodes. */
  metadataUrgencyList: Array<MetadataUrgency>;
  /** Retrieve a single "MetadataUserDefined195" node. */
  metadataUserDefined195?: Maybe<MetadataUserDefined195>;
  /** Retrieve the number of "MetadataUserDefined195" nodes. */
  metadataUserDefined195Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUserDefined195" nodes. */
  metadataUserDefined195List: Array<MetadataUserDefined195>;
  /** Retrieve a single "MetadataUserDefined237" node. */
  metadataUserDefined237?: Maybe<MetadataUserDefined237>;
  /** Retrieve the number of "MetadataUserDefined237" nodes. */
  metadataUserDefined237Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUserDefined237" nodes. */
  metadataUserDefined237List: Array<MetadataUserDefined237>;
  /** Retrieve a single "MetadataUserDefined238" node. */
  metadataUserDefined238?: Maybe<MetadataUserDefined238>;
  /** Retrieve the number of "MetadataUserDefined238" nodes. */
  metadataUserDefined238Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUserDefined238" nodes. */
  metadataUserDefined238List: Array<MetadataUserDefined238>;
  /** Retrieve a single "MetadataUserDefined239" node. */
  metadataUserDefined239?: Maybe<MetadataUserDefined239>;
  /** Retrieve the number of "MetadataUserDefined239" nodes. */
  metadataUserDefined239Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUserDefined239" nodes. */
  metadataUserDefined239List: Array<MetadataUserDefined239>;
  /** Retrieve a single "MetadataUserDefined242" node. */
  metadataUserDefined242?: Maybe<MetadataUserDefined242>;
  /** Retrieve the number of "MetadataUserDefined242" nodes. */
  metadataUserDefined242Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUserDefined242" nodes. */
  metadataUserDefined242List: Array<MetadataUserDefined242>;
  /** Retrieve a single "MetadataUserDefined62" node. */
  metadataUserDefined62?: Maybe<MetadataUserDefined62>;
  /** Retrieve the number of "MetadataUserDefined62" nodes. */
  metadataUserDefined62Count: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataUserDefined62" nodes. */
  metadataUserDefined62List: Array<MetadataUserDefined62>;
  /** Retrieve a single "MetadataWorkflowKind" node. */
  metadataWorkflowKind?: Maybe<MetadataWorkflowKind>;
  /** Retrieve the number of "MetadataWorkflowKind" nodes. */
  metadataWorkflowKindCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataWorkflowKind" nodes. */
  metadataWorkflowKindList: Array<MetadataWorkflowKind>;
  /** Retrieve a single "MetadataXmpHistory" node. */
  metadataXmpHistory?: Maybe<MetadataXmpHistory>;
  /** Retrieve the number of "MetadataXmpHistory" nodes. */
  metadataXmpHistoryCount: Scalars['Int']['output'];
  /** Retrieve a list of "MetadataXmpHistory" nodes. */
  metadataXmpHistoryList: Array<MetadataXmpHistory>;
  /** Retrieve a single "Photo" node. */
  photo?: Maybe<Photo>;
  /** Retrieve the number of "Photo" nodes. */
  photoCount: Scalars['Int']['output'];
  /** Retrieve a single "PhotoMetadata" node. */
  photoMetadata?: Maybe<PhotoMetadata>;
  /** Retrieve the number of "PhotoMetadata" nodes. */
  photoMetadataCount: Scalars['Int']['output'];
  /** Retrieve a list of "PhotoMetadata" nodes. */
  photoMetadatas: Array<PhotoMetadata>;
  /** Retrieve a single "PhotoPublication" node. */
  photoPublication?: Maybe<PhotoPublication>;
  /** Retrieve the number of "PhotoPublication" nodes. */
  photoPublicationCount: Scalars['Int']['output'];
  /** Retrieve a list of "PhotoPublication" nodes. */
  photoPublications: Array<PhotoPublication>;
  /** Retrieve a list of "Photo" nodes. */
  photos: Array<Photo>;
  /** optimized for speed search photos query */
  searchPhotos: Array<Photo>;
  /** optimized for speed photos count query */
  searchPhotosCount: Scalars['Int']['output'];
};


export type QueryAgenciesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<AgencyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AgencyWhereInput>;
};


export type QueryAgencyArgs = {
  where: AgencyWhereUniqueInput;
};


export type QueryAgencyCountArgs = {
  where?: InputMaybe<AgencyWhereInput>;
};


export type QueryArchiveArgs = {
  where: ArchiveWhereUniqueInput;
};


export type QueryArchiveAgenciesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArchiveAgencyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArchiveAgencyWhereInput>;
};


export type QueryArchiveAgencyArgs = {
  where: ArchiveAgencyWhereUniqueInput;
};


export type QueryArchiveAgencyCountArgs = {
  where?: InputMaybe<ArchiveAgencyWhereInput>;
};


export type QueryArchiveCountArgs = {
  where?: InputMaybe<ArchiveWhereInput>;
};


export type QueryArchivePurgeSettingArgs = {
  where: ArchivePurgeSettingWhereUniqueInput;
};


export type QueryArchivePurgeSettingCountArgs = {
  where?: InputMaybe<ArchivePurgeSettingWhereInput>;
};


export type QueryArchivePurgeSettingsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArchivePurgeSettingOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArchivePurgeSettingWhereInput>;
};


export type QueryArchivesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArchiveOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ArchiveWhereInput>;
};


export type QueryCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type QueryCategoryCountArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryDeliverySubjectArgs = {
  where: DeliverySubjectWhereUniqueInput;
};


export type QueryDeliverySubjectCountArgs = {
  where?: InputMaybe<DeliverySubjectWhereInput>;
};


export type QueryDeliverySubjectsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<DeliverySubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeliverySubjectWhereInput>;
};


export type QueryGcImportSettingArgs = {
  where: GcImportSettingWhereUniqueInput;
};


export type QueryGcImportSettingCountArgs = {
  where?: InputMaybe<GcImportSettingWhereInput>;
};


export type QueryGcImportSettingsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<GcImportSettingOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GcImportSettingWhereInput>;
};


export type QueryGetCenshareRailroadArgs = {
  brandKey: Scalars['String']['input'];
  parution: Scalars['String']['input'];
};


export type QueryGetMetadataOccurrenceByArchiveArgs = {
  archiveId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
  metadata: MetadataNameEnumType;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryImportQueueArgs = {
  where: ImportQueueWhereUniqueInput;
};


export type QueryImportQueueCountArgs = {
  where?: InputMaybe<ImportQueueWhereInput>;
};


export type QueryImportQueuesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ImportQueueOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImportQueueWhereInput>;
};


export type QueryMetadataArgs = {
  where: MetadataWhereUniqueInput;
};


export type QueryMetadataAccessRightsArgs = {
  where: MetadataAccessRightsWhereUniqueInput;
};


export type QueryMetadataAccessRightsCountArgs = {
  where?: InputMaybe<MetadataAccessRightsWhereInput>;
};


export type QueryMetadataAccessRightsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataAccessRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataAccessRightsWhereInput>;
};


export type QueryMetadataAssetStateArgs = {
  where: MetadataAssetStateWhereUniqueInput;
};


export type QueryMetadataAssetStateCountArgs = {
  where?: InputMaybe<MetadataAssetStateWhereInput>;
};


export type QueryMetadataAssetStateListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataAssetStateOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataAssetStateWhereInput>;
};


export type QueryMetadataBackupNameArgs = {
  where: MetadataBackupNameWhereUniqueInput;
};


export type QueryMetadataBackupNameCountArgs = {
  where?: InputMaybe<MetadataBackupNameWhereInput>;
};


export type QueryMetadataBackupNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBackupNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBackupNameWhereInput>;
};


export type QueryMetadataBrandArgs = {
  where: MetadataBrandWhereUniqueInput;
};


export type QueryMetadataBrandCountArgs = {
  where?: InputMaybe<MetadataBrandWhereInput>;
};


export type QueryMetadataBrandListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandWhereInput>;
};


export type QueryMetadataBrandPrismaArgs = {
  where: MetadataBrandPrismaWhereUniqueInput;
};


export type QueryMetadataBrandPrismaCountArgs = {
  where?: InputMaybe<MetadataBrandPrismaWhereInput>;
};


export type QueryMetadataBrandPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandPrismaWhereInput>;
};


export type QueryMetadataBrandShortNameArgs = {
  where: MetadataBrandShortNameWhereUniqueInput;
};


export type QueryMetadataBrandShortNameCountArgs = {
  where?: InputMaybe<MetadataBrandShortNameWhereInput>;
};


export type QueryMetadataBrandShortNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataBrandShortNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataBrandShortNameWhereInput>;
};


export type QueryMetadataByLineArgs = {
  where: MetadataByLineWhereUniqueInput;
};


export type QueryMetadataByLineCountArgs = {
  where?: InputMaybe<MetadataByLineWhereInput>;
};


export type QueryMetadataByLineListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataByLineOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataByLineWhereInput>;
};


export type QueryMetadataCaptionArgs = {
  where: MetadataCaptionWhereUniqueInput;
};


export type QueryMetadataCaptionAbstractArgs = {
  where: MetadataCaptionAbstractWhereUniqueInput;
};


export type QueryMetadataCaptionAbstractCountArgs = {
  where?: InputMaybe<MetadataCaptionAbstractWhereInput>;
};


export type QueryMetadataCaptionAbstractListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCaptionAbstractOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCaptionAbstractWhereInput>;
};


export type QueryMetadataCaptionCountArgs = {
  where?: InputMaybe<MetadataCaptionWhereInput>;
};


export type QueryMetadataCaptionListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCaptionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCaptionWhereInput>;
};


export type QueryMetadataCategoryArgs = {
  where: MetadataCategoryWhereUniqueInput;
};


export type QueryMetadataCategoryCountArgs = {
  where?: InputMaybe<MetadataCategoryWhereInput>;
};


export type QueryMetadataCategoryListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCategoryWhereInput>;
};


export type QueryMetadataCategoryPrismaArgs = {
  where: MetadataCategoryPrismaWhereUniqueInput;
};


export type QueryMetadataCategoryPrismaCountArgs = {
  where?: InputMaybe<MetadataCategoryPrismaWhereInput>;
};


export type QueryMetadataCategoryPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCategoryPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCategoryPrismaWhereInput>;
};


export type QueryMetadataCompanyArgs = {
  where: MetadataCompanyWhereUniqueInput;
};


export type QueryMetadataCompanyCountArgs = {
  where?: InputMaybe<MetadataCompanyWhereInput>;
};


export type QueryMetadataCompanyListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCompanyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCompanyWhereInput>;
};


export type QueryMetadataCompanyShortNameArgs = {
  where: MetadataCompanyShortNameWhereUniqueInput;
};


export type QueryMetadataCompanyShortNameCountArgs = {
  where?: InputMaybe<MetadataCompanyShortNameWhereInput>;
};


export type QueryMetadataCompanyShortNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCompanyShortNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCompanyShortNameWhereInput>;
};


export type QueryMetadataCopyrightNoticeArgs = {
  where: MetadataCopyrightNoticeWhereUniqueInput;
};


export type QueryMetadataCopyrightNoticeCountArgs = {
  where?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
};


export type QueryMetadataCopyrightNoticeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCopyrightNoticeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCopyrightNoticeWhereInput>;
};


export type QueryMetadataCountArgs = {
  where?: InputMaybe<MetadataWhereInput>;
};


export type QueryMetadataCreatorArgs = {
  where: MetadataCreatorWhereUniqueInput;
};


export type QueryMetadataCreatorCountArgs = {
  where?: InputMaybe<MetadataCreatorWhereInput>;
};


export type QueryMetadataCreatorListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCreatorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCreatorWhereInput>;
};


export type QueryMetadataCreditArgs = {
  where: MetadataCreditWhereUniqueInput;
};


export type QueryMetadataCreditCountArgs = {
  where?: InputMaybe<MetadataCreditWhereInput>;
};


export type QueryMetadataCreditListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCreditOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCreditWhereInput>;
};


export type QueryMetadataCustomField1Args = {
  where: MetadataCustomField1WhereUniqueInput;
};


export type QueryMetadataCustomField14Args = {
  where: MetadataCustomField14WhereUniqueInput;
};


export type QueryMetadataCustomField14CountArgs = {
  where?: InputMaybe<MetadataCustomField14WhereInput>;
};


export type QueryMetadataCustomField14ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField14OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField14WhereInput>;
};


export type QueryMetadataCustomField15Args = {
  where: MetadataCustomField15WhereUniqueInput;
};


export type QueryMetadataCustomField15CountArgs = {
  where?: InputMaybe<MetadataCustomField15WhereInput>;
};


export type QueryMetadataCustomField15ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField15OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField15WhereInput>;
};


export type QueryMetadataCustomField16Args = {
  where: MetadataCustomField16WhereUniqueInput;
};


export type QueryMetadataCustomField16CountArgs = {
  where?: InputMaybe<MetadataCustomField16WhereInput>;
};


export type QueryMetadataCustomField16ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField16OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField16WhereInput>;
};


export type QueryMetadataCustomField17Args = {
  where: MetadataCustomField17WhereUniqueInput;
};


export type QueryMetadataCustomField17CountArgs = {
  where?: InputMaybe<MetadataCustomField17WhereInput>;
};


export type QueryMetadataCustomField17ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField17OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField17WhereInput>;
};


export type QueryMetadataCustomField1CountArgs = {
  where?: InputMaybe<MetadataCustomField1WhereInput>;
};


export type QueryMetadataCustomField1ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField1OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField1WhereInput>;
};


export type QueryMetadataCustomField20Args = {
  where: MetadataCustomField20WhereUniqueInput;
};


export type QueryMetadataCustomField20CountArgs = {
  where?: InputMaybe<MetadataCustomField20WhereInput>;
};


export type QueryMetadataCustomField20ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField20OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField20WhereInput>;
};


export type QueryMetadataCustomField3Args = {
  where: MetadataCustomField3WhereUniqueInput;
};


export type QueryMetadataCustomField3CountArgs = {
  where?: InputMaybe<MetadataCustomField3WhereInput>;
};


export type QueryMetadataCustomField3ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField3OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField3WhereInput>;
};


export type QueryMetadataCustomField4Args = {
  where: MetadataCustomField4WhereUniqueInput;
};


export type QueryMetadataCustomField4CountArgs = {
  where?: InputMaybe<MetadataCustomField4WhereInput>;
};


export type QueryMetadataCustomField4ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField4OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField4WhereInput>;
};


export type QueryMetadataCustomField5Args = {
  where: MetadataCustomField5WhereUniqueInput;
};


export type QueryMetadataCustomField5CountArgs = {
  where?: InputMaybe<MetadataCustomField5WhereInput>;
};


export type QueryMetadataCustomField5ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField5OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField5WhereInput>;
};


export type QueryMetadataCustomField6Args = {
  where: MetadataCustomField6WhereUniqueInput;
};


export type QueryMetadataCustomField6CountArgs = {
  where?: InputMaybe<MetadataCustomField6WhereInput>;
};


export type QueryMetadataCustomField6ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField6OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField6WhereInput>;
};


export type QueryMetadataCustomField7Args = {
  where: MetadataCustomField7WhereUniqueInput;
};


export type QueryMetadataCustomField7CountArgs = {
  where?: InputMaybe<MetadataCustomField7WhereInput>;
};


export type QueryMetadataCustomField7ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField7OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField7WhereInput>;
};


export type QueryMetadataCustomField9Args = {
  where: MetadataCustomField9WhereUniqueInput;
};


export type QueryMetadataCustomField9CountArgs = {
  where?: InputMaybe<MetadataCustomField9WhereInput>;
};


export type QueryMetadataCustomField9ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataCustomField9OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataCustomField9WhereInput>;
};


export type QueryMetadataDateCreatedArgs = {
  where: MetadataDateCreatedWhereUniqueInput;
};


export type QueryMetadataDateCreatedCountArgs = {
  where?: InputMaybe<MetadataDateCreatedWhereInput>;
};


export type QueryMetadataDateCreatedListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDateCreatedOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDateCreatedWhereInput>;
};


export type QueryMetadataDateTimeOriginalArgs = {
  where: MetadataDateTimeOriginalWhereUniqueInput;
};


export type QueryMetadataDateTimeOriginalCountArgs = {
  where?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
};


export type QueryMetadataDateTimeOriginalListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDateTimeOriginalOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDateTimeOriginalWhereInput>;
};


export type QueryMetadataDeliveryAccountArgs = {
  where: MetadataDeliveryAccountWhereUniqueInput;
};


export type QueryMetadataDeliveryAccountCountArgs = {
  where?: InputMaybe<MetadataDeliveryAccountWhereInput>;
};


export type QueryMetadataDeliveryAccountListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryAccountOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryAccountWhereInput>;
};


export type QueryMetadataDeliveryCompanyArgs = {
  where: MetadataDeliveryCompanyWhereUniqueInput;
};


export type QueryMetadataDeliveryCompanyCountArgs = {
  where?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
};


export type QueryMetadataDeliveryCompanyListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryCompanyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryCompanyWhereInput>;
};


export type QueryMetadataDeliveryCopyrightArgs = {
  where: MetadataDeliveryCopyrightWhereUniqueInput;
};


export type QueryMetadataDeliveryCopyrightCountArgs = {
  where?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
};


export type QueryMetadataDeliveryCopyrightListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryCopyrightOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryCopyrightWhereInput>;
};


export type QueryMetadataDeliveryDateFolderArgs = {
  where: MetadataDeliveryDateFolderWhereUniqueInput;
};


export type QueryMetadataDeliveryDateFolderCountArgs = {
  where?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
};


export type QueryMetadataDeliveryDateFolderListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDateFolderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDateFolderWhereInput>;
};


export type QueryMetadataDeliveryDateTimeArgs = {
  where: MetadataDeliveryDateTimeWhereUniqueInput;
};


export type QueryMetadataDeliveryDateTimeCountArgs = {
  where?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
};


export type QueryMetadataDeliveryDateTimeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDateTimeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDateTimeWhereInput>;
};


export type QueryMetadataDeliveryDcCreatorArgs = {
  where: MetadataDeliveryDcCreatorWhereUniqueInput;
};


export type QueryMetadataDeliveryDcCreatorCountArgs = {
  where?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
};


export type QueryMetadataDeliveryDcCreatorListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDcCreatorOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDcCreatorWhereInput>;
};


export type QueryMetadataDeliveryDcRightsArgs = {
  where: MetadataDeliveryDcRightsWhereUniqueInput;
};


export type QueryMetadataDeliveryDcRightsCountArgs = {
  where?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
};


export type QueryMetadataDeliveryDcRightsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryDcRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryDcRightsWhereInput>;
};


export type QueryMetadataDeliveryFolderArgs = {
  where: MetadataDeliveryFolderWhereUniqueInput;
};


export type QueryMetadataDeliveryFolderCountArgs = {
  where?: InputMaybe<MetadataDeliveryFolderWhereInput>;
};


export type QueryMetadataDeliveryFolderListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryFolderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryFolderWhereInput>;
};


export type QueryMetadataDeliveryKindArgs = {
  where: MetadataDeliveryKindWhereUniqueInput;
};


export type QueryMetadataDeliveryKindCountArgs = {
  where?: InputMaybe<MetadataDeliveryKindWhereInput>;
};


export type QueryMetadataDeliveryKindListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryKindWhereInput>;
};


export type QueryMetadataDeliveryPathArgs = {
  where: MetadataDeliveryPathWhereUniqueInput;
};


export type QueryMetadataDeliveryPathCountArgs = {
  where?: InputMaybe<MetadataDeliveryPathWhereInput>;
};


export type QueryMetadataDeliveryPathListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPathOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPathWhereInput>;
};


export type QueryMetadataDeliveryPhotoshopCreditArgs = {
  where: MetadataDeliveryPhotoshopCreditWhereUniqueInput;
};


export type QueryMetadataDeliveryPhotoshopCreditCountArgs = {
  where?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
};


export type QueryMetadataDeliveryPhotoshopCreditListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPhotoshopCreditOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPhotoshopCreditWhereInput>;
};


export type QueryMetadataDeliveryPhotoshopSourceArgs = {
  where: MetadataDeliveryPhotoshopSourceWhereUniqueInput;
};


export type QueryMetadataDeliveryPhotoshopSourceCountArgs = {
  where?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
};


export type QueryMetadataDeliveryPhotoshopSourceListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryPhotoshopSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryPhotoshopSourceWhereInput>;
};


export type QueryMetadataDeliveryServiceArgs = {
  where: MetadataDeliveryServiceWhereUniqueInput;
};


export type QueryMetadataDeliveryServiceCountArgs = {
  where?: InputMaybe<MetadataDeliveryServiceWhereInput>;
};


export type QueryMetadataDeliveryServiceListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryServiceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryServiceWhereInput>;
};


export type QueryMetadataDeliverySubjectArgs = {
  where: MetadataDeliverySubjectWhereUniqueInput;
};


export type QueryMetadataDeliverySubjectCountArgs = {
  where?: InputMaybe<MetadataDeliverySubjectWhereInput>;
};


export type QueryMetadataDeliverySubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliverySubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliverySubjectWhereInput>;
};


export type QueryMetadataDeliveryUnderSubjectArgs = {
  where: MetadataDeliveryUnderSubjectWhereUniqueInput;
};


export type QueryMetadataDeliveryUnderSubjectCountArgs = {
  where?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
};


export type QueryMetadataDeliveryUnderSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDeliveryUnderSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDeliveryUnderSubjectWhereInput>;
};


export type QueryMetadataDepartmentArgs = {
  where: MetadataDepartmentWhereUniqueInput;
};


export type QueryMetadataDepartmentCountArgs = {
  where?: InputMaybe<MetadataDepartmentWhereInput>;
};


export type QueryMetadataDepartmentListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDepartmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDepartmentWhereInput>;
};


export type QueryMetadataDescriptionArgs = {
  where: MetadataDescriptionWhereUniqueInput;
};


export type QueryMetadataDescriptionCountArgs = {
  where?: InputMaybe<MetadataDescriptionWhereInput>;
};


export type QueryMetadataDescriptionListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataDescriptionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataDescriptionWhereInput>;
};


export type QueryMetadataEditionArgs = {
  where: MetadataEditionWhereUniqueInput;
};


export type QueryMetadataEditionCountArgs = {
  where?: InputMaybe<MetadataEditionWhereInput>;
};


export type QueryMetadataEditionListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataEditionOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataEditionWhereInput>;
};


export type QueryMetadataEditStatusArgs = {
  where: MetadataEditStatusWhereUniqueInput;
};


export type QueryMetadataEditStatusCountArgs = {
  where?: InputMaybe<MetadataEditStatusWhereInput>;
};


export type QueryMetadataEditStatusListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataEditStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataEditStatusWhereInput>;
};


export type QueryMetadataFileStatusArgs = {
  where: MetadataFileStatusWhereUniqueInput;
};


export type QueryMetadataFileStatusCountArgs = {
  where?: InputMaybe<MetadataFileStatusWhereInput>;
};


export type QueryMetadataFileStatusListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataFileStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataFileStatusWhereInput>;
};


export type QueryMetadataFormatArgs = {
  where: MetadataFormatWhereUniqueInput;
};


export type QueryMetadataFormatCountArgs = {
  where?: InputMaybe<MetadataFormatWhereInput>;
};


export type QueryMetadataFormatListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataFormatOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataFormatWhereInput>;
};


export type QueryMetadataHeaderArgs = {
  where: MetadataHeaderWhereUniqueInput;
};


export type QueryMetadataHeaderCountArgs = {
  where?: InputMaybe<MetadataHeaderWhereInput>;
};


export type QueryMetadataHeaderListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeaderOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeaderWhereInput>;
};


export type QueryMetadataHeaderPrismaArgs = {
  where: MetadataHeaderPrismaWhereUniqueInput;
};


export type QueryMetadataHeaderPrismaCountArgs = {
  where?: InputMaybe<MetadataHeaderPrismaWhereInput>;
};


export type QueryMetadataHeaderPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeaderPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeaderPrismaWhereInput>;
};


export type QueryMetadataHeadlineArgs = {
  where: MetadataHeadlineWhereUniqueInput;
};


export type QueryMetadataHeadlineCountArgs = {
  where?: InputMaybe<MetadataHeadlineWhereInput>;
};


export type QueryMetadataHeadlineListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataHeadlineOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataHeadlineWhereInput>;
};


export type QueryMetadataIdAssignmentArgs = {
  where: MetadataIdAssignmentWhereUniqueInput;
};


export type QueryMetadataIdAssignmentCountArgs = {
  where?: InputMaybe<MetadataIdAssignmentWhereInput>;
};


export type QueryMetadataIdAssignmentListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdAssignmentOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdAssignmentWhereInput>;
};


export type QueryMetadataIdPhotoPrismaArgs = {
  where: MetadataIdPhotoPrismaWhereUniqueInput;
};


export type QueryMetadataIdPhotoPrismaCountArgs = {
  where?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
};


export type QueryMetadataIdPhotoPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdPhotoPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdPhotoPrismaWhereInput>;
};


export type QueryMetadataIdSubjectArgs = {
  where: MetadataIdSubjectWhereUniqueInput;
};


export type QueryMetadataIdSubjectCountArgs = {
  where?: InputMaybe<MetadataIdSubjectWhereInput>;
};


export type QueryMetadataIdSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIdSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIdSubjectWhereInput>;
};


export type QueryMetadataImageNotesArgs = {
  where: MetadataImageNotesWhereUniqueInput;
};


export type QueryMetadataImageNotesCountArgs = {
  where?: InputMaybe<MetadataImageNotesWhereInput>;
};


export type QueryMetadataImageNotesListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataImageNotesOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataImageNotesWhereInput>;
};


export type QueryMetadataInstructionsArgs = {
  where: MetadataInstructionsWhereUniqueInput;
};


export type QueryMetadataInstructionsCountArgs = {
  where?: InputMaybe<MetadataInstructionsWhereInput>;
};


export type QueryMetadataInstructionsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataInstructionsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataInstructionsWhereInput>;
};


export type QueryMetadataIssueArgs = {
  where: MetadataIssueWhereUniqueInput;
};


export type QueryMetadataIssueCountArgs = {
  where?: InputMaybe<MetadataIssueWhereInput>;
};


export type QueryMetadataIssueListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataIssueOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataIssueWhereInput>;
};


export type QueryMetadataKeywordsArgs = {
  where: MetadataKeywordsWhereUniqueInput;
};


export type QueryMetadataKeywordsCountArgs = {
  where?: InputMaybe<MetadataKeywordsWhereInput>;
};


export type QueryMetadataKeywordsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataKeywordsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataKeywordsWhereInput>;
};


export type QueryMetadataObjectNameArgs = {
  where: MetadataObjectNameWhereUniqueInput;
};


export type QueryMetadataObjectNameCountArgs = {
  where?: InputMaybe<MetadataObjectNameWhereInput>;
};


export type QueryMetadataObjectNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataObjectNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataObjectNameWhereInput>;
};


export type QueryMetadataOriginalNameArgs = {
  where: MetadataOriginalNameWhereUniqueInput;
};


export type QueryMetadataOriginalNameCountArgs = {
  where?: InputMaybe<MetadataOriginalNameWhereInput>;
};


export type QueryMetadataOriginalNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataOriginalNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataOriginalNameWhereInput>;
};


export type QueryMetadataPriceLevelArgs = {
  where: MetadataPriceLevelWhereUniqueInput;
};


export type QueryMetadataPriceLevelCountArgs = {
  where?: InputMaybe<MetadataPriceLevelWhereInput>;
};


export type QueryMetadataPriceLevelListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataPriceLevelOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataPriceLevelWhereInput>;
};


export type QueryMetadataProcessHistoryArgs = {
  where: MetadataProcessHistoryWhereUniqueInput;
};


export type QueryMetadataProcessHistoryCountArgs = {
  where?: InputMaybe<MetadataProcessHistoryWhereInput>;
};


export type QueryMetadataProcessHistoryListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProcessHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProcessHistoryWhereInput>;
};


export type QueryMetadataProcessStatusArgs = {
  where: MetadataProcessStatusWhereUniqueInput;
};


export type QueryMetadataProcessStatusCountArgs = {
  where?: InputMaybe<MetadataProcessStatusWhereInput>;
};


export type QueryMetadataProcessStatusListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProcessStatusOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProcessStatusWhereInput>;
};


export type QueryMetadataProductArgs = {
  where: MetadataProductWhereUniqueInput;
};


export type QueryMetadataProductCountArgs = {
  where?: InputMaybe<MetadataProductWhereInput>;
};


export type QueryMetadataProductListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProductOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProductWhereInput>;
};


export type QueryMetadataProductsArgs = {
  where: MetadataProductsWhereUniqueInput;
};


export type QueryMetadataProductsCountArgs = {
  where?: InputMaybe<MetadataProductsWhereInput>;
};


export type QueryMetadataProductsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataProductsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataProductsWhereInput>;
};


export type QueryMetadataPublishingSubjectArgs = {
  where: MetadataPublishingSubjectWhereUniqueInput;
};


export type QueryMetadataPublishingSubjectCountArgs = {
  where?: InputMaybe<MetadataPublishingSubjectWhereInput>;
};


export type QueryMetadataPublishingSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataPublishingSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataPublishingSubjectWhereInput>;
};


export type QueryMetadataResolutionKindArgs = {
  where: MetadataResolutionKindWhereUniqueInput;
};


export type QueryMetadataResolutionKindCountArgs = {
  where?: InputMaybe<MetadataResolutionKindWhereInput>;
};


export type QueryMetadataResolutionKindListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataResolutionKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataResolutionKindWhereInput>;
};


export type QueryMetadataRightsArgs = {
  where: MetadataRightsWhereUniqueInput;
};


export type QueryMetadataRightsCountArgs = {
  where?: InputMaybe<MetadataRightsWhereInput>;
};


export type QueryMetadataRightsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataRightsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataRightsWhereInput>;
};


export type QueryMetadatasArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataWhereInput>;
};


export type QueryMetadataSourceArgs = {
  where: MetadataSourceWhereUniqueInput;
};


export type QueryMetadataSourceCountArgs = {
  where?: InputMaybe<MetadataSourceWhereInput>;
};


export type QueryMetadataSourceListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSourceOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSourceWhereInput>;
};


export type QueryMetadataSpecialInstructionsArgs = {
  where: MetadataSpecialInstructionsWhereUniqueInput;
};


export type QueryMetadataSpecialInstructionsCountArgs = {
  where?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
};


export type QueryMetadataSpecialInstructionsListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSpecialInstructionsOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSpecialInstructionsWhereInput>;
};


export type QueryMetadataSubjectArgs = {
  where: MetadataSubjectWhereUniqueInput;
};


export type QueryMetadataSubjectCodeArgs = {
  where: MetadataSubjectCodeWhereUniqueInput;
};


export type QueryMetadataSubjectCodeCountArgs = {
  where?: InputMaybe<MetadataSubjectCodeWhereInput>;
};


export type QueryMetadataSubjectCodeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectCodeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectCodeWhereInput>;
};


export type QueryMetadataSubjectCountArgs = {
  where?: InputMaybe<MetadataSubjectWhereInput>;
};


export type QueryMetadataSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectWhereInput>;
};


export type QueryMetadataSubjectPrismaArgs = {
  where: MetadataSubjectPrismaWhereUniqueInput;
};


export type QueryMetadataSubjectPrismaCountArgs = {
  where?: InputMaybe<MetadataSubjectPrismaWhereInput>;
};


export type QueryMetadataSubjectPrismaListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataSubjectPrismaOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataSubjectPrismaWhereInput>;
};


export type QueryMetadataTitleArgs = {
  where: MetadataTitleWhereUniqueInput;
};


export type QueryMetadataTitleCountArgs = {
  where?: InputMaybe<MetadataTitleWhereInput>;
};


export type QueryMetadataTitleListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTitleOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTitleWhereInput>;
};


export type QueryMetadataTransferredByArgs = {
  where: MetadataTransferredByWhereUniqueInput;
};


export type QueryMetadataTransferredByCountArgs = {
  where?: InputMaybe<MetadataTransferredByWhereInput>;
};


export type QueryMetadataTransferredByFullNameArgs = {
  where: MetadataTransferredByFullNameWhereUniqueInput;
};


export type QueryMetadataTransferredByFullNameCountArgs = {
  where?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
};


export type QueryMetadataTransferredByFullNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTransferredByFullNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTransferredByFullNameWhereInput>;
};


export type QueryMetadataTransferredByListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTransferredByOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTransferredByWhereInput>;
};


export type QueryMetadataTypeArgs = {
  where: MetadataTypeWhereUniqueInput;
};


export type QueryMetadataTypeCountArgs = {
  where?: InputMaybe<MetadataTypeWhereInput>;
};


export type QueryMetadataTypeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataTypeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataTypeWhereInput>;
};


export type QueryMetadataUndersubjectArgs = {
  where: MetadataUndersubjectWhereUniqueInput;
};


export type QueryMetadataUndersubjectCountArgs = {
  where?: InputMaybe<MetadataUndersubjectWhereInput>;
};


export type QueryMetadataUndersubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUndersubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUndersubjectWhereInput>;
};


export type QueryMetadataUnderUnderSubjectArgs = {
  where: MetadataUnderUnderSubjectWhereUniqueInput;
};


export type QueryMetadataUnderUnderSubjectCountArgs = {
  where?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
};


export type QueryMetadataUnderUnderSubjectListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUnderUnderSubjectOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUnderUnderSubjectWhereInput>;
};


export type QueryMetadataUploadedByArgs = {
  where: MetadataUploadedByWhereUniqueInput;
};


export type QueryMetadataUploadedByCountArgs = {
  where?: InputMaybe<MetadataUploadedByWhereInput>;
};


export type QueryMetadataUploadedByFullNameArgs = {
  where: MetadataUploadedByFullNameWhereUniqueInput;
};


export type QueryMetadataUploadedByFullNameCountArgs = {
  where?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
};


export type QueryMetadataUploadedByFullNameListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadedByFullNameOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadedByFullNameWhereInput>;
};


export type QueryMetadataUploadedByListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadedByOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadedByWhereInput>;
};


export type QueryMetadataUploadTimeArgs = {
  where: MetadataUploadTimeWhereUniqueInput;
};


export type QueryMetadataUploadTimeCountArgs = {
  where?: InputMaybe<MetadataUploadTimeWhereInput>;
};


export type QueryMetadataUploadTimeListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUploadTimeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUploadTimeWhereInput>;
};


export type QueryMetadataUrgencyArgs = {
  where: MetadataUrgencyWhereUniqueInput;
};


export type QueryMetadataUrgencyCountArgs = {
  where?: InputMaybe<MetadataUrgencyWhereInput>;
};


export type QueryMetadataUrgencyListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUrgencyOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUrgencyWhereInput>;
};


export type QueryMetadataUserDefined195Args = {
  where: MetadataUserDefined195WhereUniqueInput;
};


export type QueryMetadataUserDefined195CountArgs = {
  where?: InputMaybe<MetadataUserDefined195WhereInput>;
};


export type QueryMetadataUserDefined195ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined195OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined195WhereInput>;
};


export type QueryMetadataUserDefined237Args = {
  where: MetadataUserDefined237WhereUniqueInput;
};


export type QueryMetadataUserDefined237CountArgs = {
  where?: InputMaybe<MetadataUserDefined237WhereInput>;
};


export type QueryMetadataUserDefined237ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined237OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined237WhereInput>;
};


export type QueryMetadataUserDefined238Args = {
  where: MetadataUserDefined238WhereUniqueInput;
};


export type QueryMetadataUserDefined238CountArgs = {
  where?: InputMaybe<MetadataUserDefined238WhereInput>;
};


export type QueryMetadataUserDefined238ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined238OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined238WhereInput>;
};


export type QueryMetadataUserDefined239Args = {
  where: MetadataUserDefined239WhereUniqueInput;
};


export type QueryMetadataUserDefined239CountArgs = {
  where?: InputMaybe<MetadataUserDefined239WhereInput>;
};


export type QueryMetadataUserDefined239ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined239OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined239WhereInput>;
};


export type QueryMetadataUserDefined242Args = {
  where: MetadataUserDefined242WhereUniqueInput;
};


export type QueryMetadataUserDefined242CountArgs = {
  where?: InputMaybe<MetadataUserDefined242WhereInput>;
};


export type QueryMetadataUserDefined242ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined242OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined242WhereInput>;
};


export type QueryMetadataUserDefined62Args = {
  where: MetadataUserDefined62WhereUniqueInput;
};


export type QueryMetadataUserDefined62CountArgs = {
  where?: InputMaybe<MetadataUserDefined62WhereInput>;
};


export type QueryMetadataUserDefined62ListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataUserDefined62OrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataUserDefined62WhereInput>;
};


export type QueryMetadataWorkflowKindArgs = {
  where: MetadataWorkflowKindWhereUniqueInput;
};


export type QueryMetadataWorkflowKindCountArgs = {
  where?: InputMaybe<MetadataWorkflowKindWhereInput>;
};


export type QueryMetadataWorkflowKindListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataWorkflowKindOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataWorkflowKindWhereInput>;
};


export type QueryMetadataXmpHistoryArgs = {
  where: MetadataXmpHistoryWhereUniqueInput;
};


export type QueryMetadataXmpHistoryCountArgs = {
  where?: InputMaybe<MetadataXmpHistoryWhereInput>;
};


export type QueryMetadataXmpHistoryListArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<MetadataXmpHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetadataXmpHistoryWhereInput>;
};


export type QueryPhotoArgs = {
  where: PhotoWhereUniqueInput;
};


export type QueryPhotoCountArgs = {
  where?: InputMaybe<PhotoWhereInput>;
};


export type QueryPhotoMetadataArgs = {
  where: PhotoMetadataWhereUniqueInput;
};


export type QueryPhotoMetadataCountArgs = {
  where?: InputMaybe<PhotoMetadataWhereInput>;
};


export type QueryPhotoMetadatasArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoMetadataOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoMetadataWhereInput>;
};


export type QueryPhotoPublicationArgs = {
  where: PhotoPublicationWhereUniqueInput;
};


export type QueryPhotoPublicationCountArgs = {
  where?: InputMaybe<PhotoPublicationWhereInput>;
};


export type QueryPhotoPublicationsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoPublicationOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoPublicationWhereInput>;
};


export type QueryPhotosArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoWhereInput>;
};


export type QuerySearchPhotosArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PhotoWhereInput>;
};


export type QuerySearchPhotosCountArgs = {
  where?: InputMaybe<PhotoWhereInput>;
};

export type ArchiveFragment = {
  __typename?: 'Archive',
  id: string,
  archiveId?: number | null,
  type?: ArchiveType | null,
  title?: string | null,
  key?: ArchiveKeyType | null,
  accesses?: Array<string | null> | null,
  hasCategory?: boolean | null
};

export type CategoryFragment_Category_parent_Category = {
  __typename?: 'Category',
  id: string
};

export type CategoryFragment = {
  __typename?: 'Category',
  id: string,
  label?: string | null,
  parent?: CategoryFragment_Category_parent_Category | null
};

export type PhotoFragment_Photo_archive_Archive = {
  __typename?: 'Archive',
  id: string,
  accesses?: Array<string | null> | null
};

export type PhotoFragment_Photo_previews_Preview = {
  __typename?: 'Preview',
  href?: string | null,
  size?: number | null
};

export type PhotoFragment_Photo_photoPublications_PhotoPublication = {
  __typename?: 'PhotoPublication',
  printIssueTitle?: string | null,
  printPublicationKey?: string | null,
  page?: string | null
};

export type PhotoFragment = {
  __typename?: 'Photo',
  id: string,
  createdAt: string,
  updatedAt: string,
  height?: number | null,
  width?: number | null,
  filesize?: number | null,
  originalName?: string | null,
  contentType?: string | null,
  publicUrl?: string | null,
  downloadUrl?: string | null,
  metadataByName?: { [key: string]: any } | null,
  archive: PhotoFragment_Photo_archive_Archive,
  previews?: Array<PhotoFragment_Photo_previews_Preview> | null,
  photoPublications: Array<PhotoFragment_Photo_photoPublications_PhotoPublication>
};

export type CreateCategoryMutation_createCategory_Category = {
  __typename?: 'Category',
  id: string,
  label?: string | null,
  parent?: CategoryFragment_Category_parent_Category | null
};

export type CreateCategoryMutation_Mutation = {
  __typename?: 'Mutation',
  createCategory: CreateCategoryMutation_createCategory_Category
};


export type CreateCategoryMutationVariables = Exact<{
  data: CategoryCreateInput;
}>;


export type CreateCategoryMutation = CreateCategoryMutation_Mutation;

export type CreatePhotoMutation_createPhoto_Photo = {
  __typename?: 'Photo',
  uploadUrl?: string | null,
  id: string,
  createdAt: string,
  updatedAt: string,
  height?: number | null,
  width?: number | null,
  filesize?: number | null,
  originalName?: string | null,
  contentType?: string | null,
  publicUrl?: string | null,
  downloadUrl?: string | null,
  metadataByName?: { [key: string]: any } | null,
  archive: PhotoFragment_Photo_archive_Archive,
  previews?: Array<PhotoFragment_Photo_previews_Preview> | null,
  photoPublications: Array<PhotoFragment_Photo_photoPublications_PhotoPublication>
};

export type CreatePhotoMutation_Mutation = {
  __typename?: 'Mutation',
  createPhoto: CreatePhotoMutation_createPhoto_Photo
};


export type CreatePhotoMutationVariables = Exact<{
  data: PhotoCreateInput;
}>;


export type CreatePhotoMutation = CreatePhotoMutation_Mutation;

export type UpdatePhotoMutation_updatePhoto_Photo = {
  __typename?: 'Photo',
  id: string,
  createdAt: string,
  updatedAt: string,
  height?: number | null,
  width?: number | null,
  filesize?: number | null,
  originalName?: string | null,
  contentType?: string | null,
  publicUrl?: string | null,
  downloadUrl?: string | null,
  metadataByName?: { [key: string]: any } | null,
  archive: PhotoFragment_Photo_archive_Archive,
  previews?: Array<PhotoFragment_Photo_previews_Preview> | null,
  photoPublications: Array<PhotoFragment_Photo_photoPublications_PhotoPublication>
};

export type UpdatePhotoMutation_Mutation = {
  __typename?: 'Mutation',
  updatePhoto?: UpdatePhotoMutation_updatePhoto_Photo | null
};


export type UpdatePhotoMutationVariables = Exact<{
  where: PhotoWhereUniqueInput;
  data: PhotoUpdateInput;
}>;


export type UpdatePhotoMutation = UpdatePhotoMutation_Mutation;

export type DeletePhotoMutation_deletePhoto_Photo = {
  __typename?: 'Photo',
  id: string
};

export type DeletePhotoMutation_Mutation = {
  __typename?: 'Mutation',
  deletePhoto?: DeletePhotoMutation_deletePhoto_Photo | null
};


export type DeletePhotoMutationVariables = Exact<{
  where: PhotoWhereUniqueInput;
}>;


export type DeletePhotoMutation = DeletePhotoMutation_Mutation;

export type UpdatePhotoFileMutation_updatePhotoFile_Photo = {
  __typename?: 'Photo',
  id: string,
  createdAt: string,
  updatedAt: string,
  height?: number | null,
  width?: number | null,
  filesize?: number | null,
  originalName?: string | null,
  contentType?: string | null,
  publicUrl?: string | null,
  downloadUrl?: string | null,
  metadataByName?: { [key: string]: any } | null,
  archive: PhotoFragment_Photo_archive_Archive,
  previews?: Array<PhotoFragment_Photo_previews_Preview> | null,
  photoPublications: Array<PhotoFragment_Photo_photoPublications_PhotoPublication>
};

export type UpdatePhotoFileMutation_Mutation = {
  __typename?: 'Mutation',
  updatePhotoFile?: UpdatePhotoFileMutation_updatePhotoFile_Photo | null
};


export type UpdatePhotoFileMutationVariables = Exact<{
  photoId: Scalars['String']['input'];
}>;


export type UpdatePhotoFileMutation = UpdatePhotoFileMutation_Mutation;

export type ClonePhotoMutation_clonePhoto_Photo = {
  __typename?: 'Photo',
  id: string,
  createdAt: string,
  updatedAt: string,
  height?: number | null,
  width?: number | null,
  filesize?: number | null,
  originalName?: string | null,
  contentType?: string | null,
  publicUrl?: string | null,
  downloadUrl?: string | null,
  metadataByName?: { [key: string]: any } | null,
  archive: PhotoFragment_Photo_archive_Archive,
  previews?: Array<PhotoFragment_Photo_previews_Preview> | null,
  photoPublications: Array<PhotoFragment_Photo_photoPublications_PhotoPublication>
};

export type ClonePhotoMutation_Mutation = {
  __typename?: 'Mutation',
  clonePhoto: ClonePhotoMutation_clonePhoto_Photo
};


export type ClonePhotoMutationVariables = Exact<{
  sourceId: Scalars['String']['input'];
  create: PhotoCreateInput;
}>;


export type ClonePhotoMutation = ClonePhotoMutation_Mutation;

export type GetArchivesQuery_archives_Archive = {
  __typename?: 'Archive',
  id: string,
  archiveId?: number | null,
  type?: ArchiveType | null,
  title?: string | null,
  key?: ArchiveKeyType | null,
  accesses?: Array<string | null> | null,
  hasCategory?: boolean | null
};

export type GetArchivesQuery_Query = {
  __typename?: 'Query',
  archives: Array<GetArchivesQuery_archives_Archive>
};


export type GetArchivesQueryVariables = Exact<{
  where?: InputMaybe<ArchiveWhereInput>;
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<ArchiveOrderByInput> | ArchiveOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetArchivesQuery = GetArchivesQuery_Query;

export type GetCategoriesQuery_categories_Category = {
  __typename?: 'Category',
  id: string,
  label?: string | null,
  parent?: CategoryFragment_Category_parent_Category | null
};

export type GetCategoriesQuery_Query = {
  __typename?: 'Query',
  categories: Array<GetCategoriesQuery_categories_Category>
};


export type GetCategoriesQueryVariables = Exact<{
  where?: InputMaybe<CategoryWhereInput>;
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderByInput> | CategoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCategoriesQuery = GetCategoriesQuery_Query;

export type GetUnderSubjectsQuery_searchPhotos_Photo_Metadata_Undersubject_MetadataUndersubject = {
  __typename?: 'MetadataUndersubject',
  id: number,
  value?: string | null
};

export type GetUnderSubjectsQuery_searchPhotos_Photo = {
  __typename?: 'Photo',
  id: string,
  Metadata_Undersubject: Array<GetUnderSubjectsQuery_searchPhotos_Photo_Metadata_Undersubject_MetadataUndersubject>
};

export type GetUnderSubjectsQuery_Query = {
  __typename?: 'Query',
  searchPhotos: Array<GetUnderSubjectsQuery_searchPhotos_Photo>
};


export type GetUnderSubjectsQueryVariables = Exact<{
  where: PhotoWhereInput;
  first: Scalars['Int']['input'];
}>;


export type GetUnderSubjectsQuery = GetUnderSubjectsQuery_Query;

export type SearchPhotosQuery_searchPhotos_Photo = {
  __typename?: 'Photo',
  id: string,
  createdAt: string,
  updatedAt: string,
  height?: number | null,
  width?: number | null,
  filesize?: number | null,
  originalName?: string | null,
  contentType?: string | null,
  publicUrl?: string | null,
  downloadUrl?: string | null,
  metadataByName?: { [key: string]: any } | null,
  archive: PhotoFragment_Photo_archive_Archive,
  previews?: Array<PhotoFragment_Photo_previews_Preview> | null,
  photoPublications: Array<PhotoFragment_Photo_photoPublications_PhotoPublication>
};

export type SearchPhotosQuery_Query = {
  __typename?: 'Query',
  searchPhotos: Array<SearchPhotosQuery_searchPhotos_Photo>
};


export type SearchPhotosQueryVariables = Exact<{
  where?: InputMaybe<PhotoWhereInput>;
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PhotoOrderByInput> | PhotoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchPhotosQuery = SearchPhotosQuery_Query;

export type GetPhotosCountQuery_Query = {
  __typename?: 'Query',
  photoCount: number
};


export type GetPhotosCountQueryVariables = Exact<{
  where?: InputMaybe<PhotoWhereInput>;
}>;


export type GetPhotosCountQuery = GetPhotosCountQuery_Query;

export const ArchiveFragmentDoc = gql`
    fragment Archive on Archive {
  id
  archiveId
  type
  title
  key
  accesses
  hasCategory
}
    `;
export const CategoryFragmentDoc = gql`
    fragment Category on Category {
  id
  label
  parent {
    id
  }
}
    `;
export const PhotoFragmentDoc = gql`
    fragment Photo on Photo {
  id
  archive {
    id
    accesses
  }
  createdAt
  updatedAt
  height
  width
  filesize
  originalName
  contentType
  publicUrl
  downloadUrl
  previews {
    href
    size
  }
  photoPublications(first: 100) {
    printIssueTitle
    printPublicationKey
    page
  }
  metadataByName(names: [title, subject, Instructions, creator, Headline, Credit, Source, rights, description, CustomField14, ImageNotes, UploadedBy, IdPhotoPrisma, Product, Issue, Undersubject, DeliveryCompany, OriginalName, DeliveryKind, DeliverySubject, ResolutionKind, ProcessHistory, DeliveryPhotoshopCredit, BackupName, UserDefined239, PriceLevel, AssetState, Urgency, EditStatus, UserDefined238, ProcessStatus, DateCreated])
}
    `;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($data: CategoryCreateInput!) {
  createCategory(data: $data) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const CreatePhotoDocument = gql`
    mutation CreatePhoto($data: PhotoCreateInput!) {
  createPhoto(data: $data) {
    ...Photo
    uploadUrl
  }
}
    ${PhotoFragmentDoc}`;
export type CreatePhotoMutationFn = Apollo.MutationFunction<CreatePhotoMutation, CreatePhotoMutationVariables>;

/**
 * __useCreatePhotoMutation__
 *
 * To run a mutation, you first call `useCreatePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPhotoMutation, { data, loading, error }] = useCreatePhotoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePhotoMutation(baseOptions?: Apollo.MutationHookOptions<CreatePhotoMutation, CreatePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePhotoMutation, CreatePhotoMutationVariables>(CreatePhotoDocument, options);
      }
export type CreatePhotoMutationHookResult = ReturnType<typeof useCreatePhotoMutation>;
export type CreatePhotoMutationResult = Apollo.MutationResult<CreatePhotoMutation>;
export type CreatePhotoMutationOptions = Apollo.BaseMutationOptions<CreatePhotoMutation, CreatePhotoMutationVariables>;
export const UpdatePhotoDocument = gql`
    mutation UpdatePhoto($where: PhotoWhereUniqueInput!, $data: PhotoUpdateInput!) {
  updatePhoto(where: $where, data: $data) {
    ...Photo
  }
}
    ${PhotoFragmentDoc}`;
export type UpdatePhotoMutationFn = Apollo.MutationFunction<UpdatePhotoMutation, UpdatePhotoMutationVariables>;

/**
 * __useUpdatePhotoMutation__
 *
 * To run a mutation, you first call `useUpdatePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhotoMutation, { data, loading, error }] = useUpdatePhotoMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePhotoMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhotoMutation, UpdatePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhotoMutation, UpdatePhotoMutationVariables>(UpdatePhotoDocument, options);
      }
export type UpdatePhotoMutationHookResult = ReturnType<typeof useUpdatePhotoMutation>;
export type UpdatePhotoMutationResult = Apollo.MutationResult<UpdatePhotoMutation>;
export type UpdatePhotoMutationOptions = Apollo.BaseMutationOptions<UpdatePhotoMutation, UpdatePhotoMutationVariables>;
export const DeletePhotoDocument = gql`
    mutation DeletePhoto($where: PhotoWhereUniqueInput!) {
  deletePhoto(where: $where) {
    id
  }
}
    `;
export type DeletePhotoMutationFn = Apollo.MutationFunction<DeletePhotoMutation, DeletePhotoMutationVariables>;

/**
 * __useDeletePhotoMutation__
 *
 * To run a mutation, you first call `useDeletePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePhotoMutation, { data, loading, error }] = useDeletePhotoMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeletePhotoMutation(baseOptions?: Apollo.MutationHookOptions<DeletePhotoMutation, DeletePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePhotoMutation, DeletePhotoMutationVariables>(DeletePhotoDocument, options);
      }
export type DeletePhotoMutationHookResult = ReturnType<typeof useDeletePhotoMutation>;
export type DeletePhotoMutationResult = Apollo.MutationResult<DeletePhotoMutation>;
export type DeletePhotoMutationOptions = Apollo.BaseMutationOptions<DeletePhotoMutation, DeletePhotoMutationVariables>;
export const UpdatePhotoFileDocument = gql`
    mutation UpdatePhotoFile($photoId: String!) {
  updatePhotoFile(photoId: $photoId) {
    ...Photo
  }
}
    ${PhotoFragmentDoc}`;
export type UpdatePhotoFileMutationFn = Apollo.MutationFunction<UpdatePhotoFileMutation, UpdatePhotoFileMutationVariables>;

/**
 * __useUpdatePhotoFileMutation__
 *
 * To run a mutation, you first call `useUpdatePhotoFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePhotoFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePhotoFileMutation, { data, loading, error }] = useUpdatePhotoFileMutation({
 *   variables: {
 *      photoId: // value for 'photoId'
 *   },
 * });
 */
export function useUpdatePhotoFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePhotoFileMutation, UpdatePhotoFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePhotoFileMutation, UpdatePhotoFileMutationVariables>(UpdatePhotoFileDocument, options);
      }
export type UpdatePhotoFileMutationHookResult = ReturnType<typeof useUpdatePhotoFileMutation>;
export type UpdatePhotoFileMutationResult = Apollo.MutationResult<UpdatePhotoFileMutation>;
export type UpdatePhotoFileMutationOptions = Apollo.BaseMutationOptions<UpdatePhotoFileMutation, UpdatePhotoFileMutationVariables>;
export const ClonePhotoDocument = gql`
    mutation ClonePhoto($sourceId: String!, $create: PhotoCreateInput!) {
  clonePhoto(sourceId: $sourceId, create: $create) {
    ...Photo
  }
}
    ${PhotoFragmentDoc}`;
export type ClonePhotoMutationFn = Apollo.MutationFunction<ClonePhotoMutation, ClonePhotoMutationVariables>;

/**
 * __useClonePhotoMutation__
 *
 * To run a mutation, you first call `useClonePhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClonePhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clonePhotoMutation, { data, loading, error }] = useClonePhotoMutation({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      create: // value for 'create'
 *   },
 * });
 */
export function useClonePhotoMutation(baseOptions?: Apollo.MutationHookOptions<ClonePhotoMutation, ClonePhotoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClonePhotoMutation, ClonePhotoMutationVariables>(ClonePhotoDocument, options);
      }
export type ClonePhotoMutationHookResult = ReturnType<typeof useClonePhotoMutation>;
export type ClonePhotoMutationResult = Apollo.MutationResult<ClonePhotoMutation>;
export type ClonePhotoMutationOptions = Apollo.BaseMutationOptions<ClonePhotoMutation, ClonePhotoMutationVariables>;
export const GetArchivesDocument = gql`
    query GetArchives($where: ArchiveWhereInput, $first: Int!, $orderBy: [ArchiveOrderByInput!], $skip: Int) {
  archives(where: $where, first: $first, orderBy: $orderBy, skip: $skip) {
    ...Archive
  }
}
    ${ArchiveFragmentDoc}`;

/**
 * __useGetArchivesQuery__
 *
 * To run a query within a React component, call `useGetArchivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetArchivesQuery(baseOptions: Apollo.QueryHookOptions<GetArchivesQuery, GetArchivesQueryVariables> & ({ variables: GetArchivesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArchivesQuery, GetArchivesQueryVariables>(GetArchivesDocument, options);
      }
export function useGetArchivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArchivesQuery, GetArchivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArchivesQuery, GetArchivesQueryVariables>(GetArchivesDocument, options);
        }
export function useGetArchivesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArchivesQuery, GetArchivesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArchivesQuery, GetArchivesQueryVariables>(GetArchivesDocument, options);
        }
export type GetArchivesQueryHookResult = ReturnType<typeof useGetArchivesQuery>;
export type GetArchivesLazyQueryHookResult = ReturnType<typeof useGetArchivesLazyQuery>;
export type GetArchivesSuspenseQueryHookResult = ReturnType<typeof useGetArchivesSuspenseQuery>;
export type GetArchivesQueryResult = Apollo.QueryResult<GetArchivesQuery, GetArchivesQueryVariables>;
export const GetCategoriesDocument = gql`
    query GetCategories($where: CategoryWhereInput, $first: Int!, $orderBy: [CategoryOrderByInput!], $skip: Int) {
  categories(where: $where, first: $first, orderBy: $orderBy, skip: $skip) {
    ...Category
  }
}
    ${CategoryFragmentDoc}`;

/**
 * __useGetCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables> & ({ variables: GetCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
      }
export function useGetCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export function useGetCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoriesQuery, GetCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoriesQuery, GetCategoriesQueryVariables>(GetCategoriesDocument, options);
        }
export type GetCategoriesQueryHookResult = ReturnType<typeof useGetCategoriesQuery>;
export type GetCategoriesLazyQueryHookResult = ReturnType<typeof useGetCategoriesLazyQuery>;
export type GetCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCategoriesSuspenseQuery>;
export type GetCategoriesQueryResult = Apollo.QueryResult<GetCategoriesQuery, GetCategoriesQueryVariables>;
export const GetUnderSubjectsDocument = gql`
    query GetUnderSubjects($where: PhotoWhereInput!, $first: Int!) {
  searchPhotos(where: $where, first: $first) {
    id
    Metadata_Undersubject(first: 1) {
      id
      value
    }
  }
}
    `;

/**
 * __useGetUnderSubjectsQuery__
 *
 * To run a query within a React component, call `useGetUnderSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnderSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnderSubjectsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetUnderSubjectsQuery(baseOptions: Apollo.QueryHookOptions<GetUnderSubjectsQuery, GetUnderSubjectsQueryVariables> & ({ variables: GetUnderSubjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnderSubjectsQuery, GetUnderSubjectsQueryVariables>(GetUnderSubjectsDocument, options);
      }
export function useGetUnderSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnderSubjectsQuery, GetUnderSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnderSubjectsQuery, GetUnderSubjectsQueryVariables>(GetUnderSubjectsDocument, options);
        }
export function useGetUnderSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnderSubjectsQuery, GetUnderSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnderSubjectsQuery, GetUnderSubjectsQueryVariables>(GetUnderSubjectsDocument, options);
        }
export type GetUnderSubjectsQueryHookResult = ReturnType<typeof useGetUnderSubjectsQuery>;
export type GetUnderSubjectsLazyQueryHookResult = ReturnType<typeof useGetUnderSubjectsLazyQuery>;
export type GetUnderSubjectsSuspenseQueryHookResult = ReturnType<typeof useGetUnderSubjectsSuspenseQuery>;
export type GetUnderSubjectsQueryResult = Apollo.QueryResult<GetUnderSubjectsQuery, GetUnderSubjectsQueryVariables>;
export const SearchPhotosDocument = gql`
    query SearchPhotos($where: PhotoWhereInput, $first: Int!, $orderBy: [PhotoOrderByInput!], $skip: Int) {
  searchPhotos(where: $where, first: $first, orderBy: $orderBy, skip: $skip) {
    ...Photo
  }
}
    ${PhotoFragmentDoc}`;

/**
 * __useSearchPhotosQuery__
 *
 * To run a query within a React component, call `useSearchPhotosQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPhotosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPhotosQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSearchPhotosQuery(baseOptions: Apollo.QueryHookOptions<SearchPhotosQuery, SearchPhotosQueryVariables> & ({ variables: SearchPhotosQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPhotosQuery, SearchPhotosQueryVariables>(SearchPhotosDocument, options);
      }
export function useSearchPhotosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPhotosQuery, SearchPhotosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPhotosQuery, SearchPhotosQueryVariables>(SearchPhotosDocument, options);
        }
export function useSearchPhotosSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPhotosQuery, SearchPhotosQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPhotosQuery, SearchPhotosQueryVariables>(SearchPhotosDocument, options);
        }
export type SearchPhotosQueryHookResult = ReturnType<typeof useSearchPhotosQuery>;
export type SearchPhotosLazyQueryHookResult = ReturnType<typeof useSearchPhotosLazyQuery>;
export type SearchPhotosSuspenseQueryHookResult = ReturnType<typeof useSearchPhotosSuspenseQuery>;
export type SearchPhotosQueryResult = Apollo.QueryResult<SearchPhotosQuery, SearchPhotosQueryVariables>;
export const GetPhotosCountDocument = gql`
    query GetPhotosCount($where: PhotoWhereInput) {
  photoCount: searchPhotosCount(where: $where)
}
    `;

/**
 * __useGetPhotosCountQuery__
 *
 * To run a query within a React component, call `useGetPhotosCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPhotosCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPhotosCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPhotosCountQuery(baseOptions?: Apollo.QueryHookOptions<GetPhotosCountQuery, GetPhotosCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPhotosCountQuery, GetPhotosCountQueryVariables>(GetPhotosCountDocument, options);
      }
export function useGetPhotosCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPhotosCountQuery, GetPhotosCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPhotosCountQuery, GetPhotosCountQueryVariables>(GetPhotosCountDocument, options);
        }
export function useGetPhotosCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPhotosCountQuery, GetPhotosCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPhotosCountQuery, GetPhotosCountQueryVariables>(GetPhotosCountDocument, options);
        }
export type GetPhotosCountQueryHookResult = ReturnType<typeof useGetPhotosCountQuery>;
export type GetPhotosCountLazyQueryHookResult = ReturnType<typeof useGetPhotosCountLazyQuery>;
export type GetPhotosCountSuspenseQueryHookResult = ReturnType<typeof useGetPhotosCountSuspenseQuery>;
export type GetPhotosCountQueryResult = Apollo.QueryResult<GetPhotosCountQuery, GetPhotosCountQueryVariables>;